(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb351"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb351"] = parcelRequire;
}
parcelRequire.register("b5a3Y", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8117f7ad67dd6234$export$ffb0004e005737fa; }, function (v) { return $8117f7ad67dd6234$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $8117f7ad67dd6234$export$34b9dba7ce09269b; }, function (v) { return $8117f7ad67dd6234$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $8117f7ad67dd6234$export$25062201e9e25d76; }, function (v) { return $8117f7ad67dd6234$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8117f7ad67dd6234$export$ffb0004e005737fa;
var $8117f7ad67dd6234$export$34b9dba7ce09269b;
var $8117f7ad67dd6234$export$25062201e9e25d76;
"use strict";

var $1fELX = parcelRequire("1fELX");
var $8117f7ad67dd6234$var$k = Symbol.for("react.element"), $8117f7ad67dd6234$var$l = Symbol.for("react.fragment"), $8117f7ad67dd6234$var$m = Object.prototype.hasOwnProperty, $8117f7ad67dd6234$var$n = $1fELX.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $8117f7ad67dd6234$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8117f7ad67dd6234$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$8117f7ad67dd6234$var$m.call(a, b) && !$8117f7ad67dd6234$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $8117f7ad67dd6234$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $8117f7ad67dd6234$var$n.current
    };
}
$8117f7ad67dd6234$export$ffb0004e005737fa = $8117f7ad67dd6234$var$l;
$8117f7ad67dd6234$export$34b9dba7ce09269b = $8117f7ad67dd6234$var$q;
$8117f7ad67dd6234$export$25062201e9e25d76 = $8117f7ad67dd6234$var$q;

});
parcelRequire.register("1fELX", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1CvS6"));

});
parcelRequire.register("1CvS6", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $12e210181d22c35f$export$dca3b0875bd9a954; }, function (v) { return $12e210181d22c35f$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $12e210181d22c35f$export$16fa2f45be04daa8; }, function (v) { return $12e210181d22c35f$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $12e210181d22c35f$export$ffb0004e005737fa; }, function (v) { return $12e210181d22c35f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $12e210181d22c35f$export$e2c29f18771995cb; }, function (v) { return $12e210181d22c35f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $12e210181d22c35f$export$221d75b3f55bb0bd; }, function (v) { return $12e210181d22c35f$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $12e210181d22c35f$export$5f8d39834fd61797; }, function (v) { return $12e210181d22c35f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $12e210181d22c35f$export$74bf444e3cd11ea5; }, function (v) { return $12e210181d22c35f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $12e210181d22c35f$export$ae55be85d98224ed; }, function (v) { return $12e210181d22c35f$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $12e210181d22c35f$export$e530037191fcd5d7; }, function (v) { return $12e210181d22c35f$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $12e210181d22c35f$export$fd42f52fd3ae1109; }, function (v) { return $12e210181d22c35f$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $12e210181d22c35f$export$c8a8987d4410bf2d; }, function (v) { return $12e210181d22c35f$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $12e210181d22c35f$export$d38cd72104c1f0e9; }, function (v) { return $12e210181d22c35f$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $12e210181d22c35f$export$7d1e3a5e95ceca43; }, function (v) { return $12e210181d22c35f$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $12e210181d22c35f$export$257a8862b851cb5b; }, function (v) { return $12e210181d22c35f$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $12e210181d22c35f$export$a8257692ac88316c; }, function (v) { return $12e210181d22c35f$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $12e210181d22c35f$export$488013bae63b21da; }, function (v) { return $12e210181d22c35f$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $12e210181d22c35f$export$7c73462e0d25e514; }, function (v) { return $12e210181d22c35f$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $12e210181d22c35f$export$7568632d0d33d16d; }, function (v) { return $12e210181d22c35f$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $12e210181d22c35f$export$88948ce120ea2619; }, function (v) { return $12e210181d22c35f$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $12e210181d22c35f$export$35808ee640e87ca7; }, function (v) { return $12e210181d22c35f$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $12e210181d22c35f$export$fae74005e78b1a27; }, function (v) { return $12e210181d22c35f$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $12e210181d22c35f$export$dc8fbce3eb94dc1e; }, function (v) { return $12e210181d22c35f$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $12e210181d22c35f$export$6a7bc4e911dc01cf; }, function (v) { return $12e210181d22c35f$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $12e210181d22c35f$export$6d9c69b0de29b591; }, function (v) { return $12e210181d22c35f$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $12e210181d22c35f$export$f680877a34711e37; }, function (v) { return $12e210181d22c35f$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $12e210181d22c35f$export$d5a552a76deda3c2; }, function (v) { return $12e210181d22c35f$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $12e210181d22c35f$export$aaabe4eda9ed9969; }, function (v) { return $12e210181d22c35f$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $12e210181d22c35f$export$e5c5a5f917a5871c; }, function (v) { return $12e210181d22c35f$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $12e210181d22c35f$export$1538c33de8887b59; }, function (v) { return $12e210181d22c35f$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $12e210181d22c35f$export$13e3392192263954; }, function (v) { return $12e210181d22c35f$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $12e210181d22c35f$export$b8f5890fc79d6aca; }, function (v) { return $12e210181d22c35f$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $12e210181d22c35f$export$60241385465d0a34; }, function (v) { return $12e210181d22c35f$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $12e210181d22c35f$export$306c0aa65ff9ec16; }, function (v) { return $12e210181d22c35f$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $12e210181d22c35f$export$7b286972b8d8ccbf; }, function (v) { return $12e210181d22c35f$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $12e210181d22c35f$export$83d89fbfd8236492; }, function (v) { return $12e210181d22c35f$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $12e210181d22c35f$export$dca3b0875bd9a954;
var $12e210181d22c35f$export$16fa2f45be04daa8;
var $12e210181d22c35f$export$ffb0004e005737fa;
var $12e210181d22c35f$export$e2c29f18771995cb;
var $12e210181d22c35f$export$221d75b3f55bb0bd;
var $12e210181d22c35f$export$5f8d39834fd61797;
var $12e210181d22c35f$export$74bf444e3cd11ea5;
var $12e210181d22c35f$export$ae55be85d98224ed;
var $12e210181d22c35f$export$e530037191fcd5d7;
var $12e210181d22c35f$export$fd42f52fd3ae1109;
var $12e210181d22c35f$export$c8a8987d4410bf2d;
var $12e210181d22c35f$export$d38cd72104c1f0e9;
var $12e210181d22c35f$export$7d1e3a5e95ceca43;
var $12e210181d22c35f$export$257a8862b851cb5b;
var $12e210181d22c35f$export$a8257692ac88316c;
var $12e210181d22c35f$export$488013bae63b21da;
var $12e210181d22c35f$export$7c73462e0d25e514;
var $12e210181d22c35f$export$7568632d0d33d16d;
var $12e210181d22c35f$export$88948ce120ea2619;
var $12e210181d22c35f$export$35808ee640e87ca7;
var $12e210181d22c35f$export$fae74005e78b1a27;
var $12e210181d22c35f$export$dc8fbce3eb94dc1e;
var $12e210181d22c35f$export$6a7bc4e911dc01cf;
var $12e210181d22c35f$export$6d9c69b0de29b591;
var $12e210181d22c35f$export$f680877a34711e37;
var $12e210181d22c35f$export$d5a552a76deda3c2;
var $12e210181d22c35f$export$aaabe4eda9ed9969;
var $12e210181d22c35f$export$e5c5a5f917a5871c;
var $12e210181d22c35f$export$1538c33de8887b59;
var $12e210181d22c35f$export$13e3392192263954;
var $12e210181d22c35f$export$b8f5890fc79d6aca;
var $12e210181d22c35f$export$60241385465d0a34;
var $12e210181d22c35f$export$306c0aa65ff9ec16;
var $12e210181d22c35f$export$7b286972b8d8ccbf;
var $12e210181d22c35f$export$83d89fbfd8236492;
"use strict";
var $12e210181d22c35f$var$l = Symbol.for("react.element"), $12e210181d22c35f$var$n = Symbol.for("react.portal"), $12e210181d22c35f$var$p = Symbol.for("react.fragment"), $12e210181d22c35f$var$q = Symbol.for("react.strict_mode"), $12e210181d22c35f$var$r = Symbol.for("react.profiler"), $12e210181d22c35f$var$t = Symbol.for("react.provider"), $12e210181d22c35f$var$u = Symbol.for("react.context"), $12e210181d22c35f$var$v = Symbol.for("react.forward_ref"), $12e210181d22c35f$var$w = Symbol.for("react.suspense"), $12e210181d22c35f$var$x = Symbol.for("react.memo"), $12e210181d22c35f$var$y = Symbol.for("react.lazy"), $12e210181d22c35f$var$z = Symbol.iterator;
function $12e210181d22c35f$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $12e210181d22c35f$var$z && a[$12e210181d22c35f$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $12e210181d22c35f$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $12e210181d22c35f$var$C = Object.assign, $12e210181d22c35f$var$D = {};
function $12e210181d22c35f$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $12e210181d22c35f$var$D;
    this.updater = e || $12e210181d22c35f$var$B;
}
$12e210181d22c35f$var$E.prototype.isReactComponent = {};
$12e210181d22c35f$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$12e210181d22c35f$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $12e210181d22c35f$var$F() {}
$12e210181d22c35f$var$F.prototype = $12e210181d22c35f$var$E.prototype;
function $12e210181d22c35f$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $12e210181d22c35f$var$D;
    this.updater = e || $12e210181d22c35f$var$B;
}
var $12e210181d22c35f$var$H = $12e210181d22c35f$var$G.prototype = new $12e210181d22c35f$var$F;
$12e210181d22c35f$var$H.constructor = $12e210181d22c35f$var$G;
$12e210181d22c35f$var$C($12e210181d22c35f$var$H, $12e210181d22c35f$var$E.prototype);
$12e210181d22c35f$var$H.isPureReactComponent = !0;
var $12e210181d22c35f$var$I = Array.isArray, $12e210181d22c35f$var$J = Object.prototype.hasOwnProperty, $12e210181d22c35f$var$K = {
    current: null
}, $12e210181d22c35f$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $12e210181d22c35f$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$12e210181d22c35f$var$J.call(b, d) && !$12e210181d22c35f$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $12e210181d22c35f$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $12e210181d22c35f$var$K.current
    };
}
function $12e210181d22c35f$var$N(a, b) {
    return {
        $$typeof: $12e210181d22c35f$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $12e210181d22c35f$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $12e210181d22c35f$var$l;
}
function $12e210181d22c35f$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $12e210181d22c35f$var$P = /\/+/g;
function $12e210181d22c35f$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $12e210181d22c35f$var$escape("" + a.key) : b.toString(36);
}
function $12e210181d22c35f$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $12e210181d22c35f$var$l:
                case $12e210181d22c35f$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $12e210181d22c35f$var$Q(h, 0) : d, $12e210181d22c35f$var$I(c) ? (e = "", null != a && (e = a.replace($12e210181d22c35f$var$P, "$&/") + "/"), $12e210181d22c35f$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($12e210181d22c35f$var$O(c) && (c = $12e210181d22c35f$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($12e210181d22c35f$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($12e210181d22c35f$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $12e210181d22c35f$var$Q(k, g);
        h += $12e210181d22c35f$var$R(k, b, e, f, c);
    }
    else if (f = $12e210181d22c35f$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $12e210181d22c35f$var$Q(k, g++), h += $12e210181d22c35f$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $12e210181d22c35f$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $12e210181d22c35f$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $12e210181d22c35f$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $12e210181d22c35f$var$U = {
    current: null
}, $12e210181d22c35f$var$V = {
    transition: null
}, $12e210181d22c35f$var$W = {
    ReactCurrentDispatcher: $12e210181d22c35f$var$U,
    ReactCurrentBatchConfig: $12e210181d22c35f$var$V,
    ReactCurrentOwner: $12e210181d22c35f$var$K
};
$12e210181d22c35f$export$dca3b0875bd9a954 = {
    map: $12e210181d22c35f$var$S,
    forEach: function(a, b, e) {
        $12e210181d22c35f$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $12e210181d22c35f$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $12e210181d22c35f$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$12e210181d22c35f$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$12e210181d22c35f$export$16fa2f45be04daa8 = $12e210181d22c35f$var$E;
$12e210181d22c35f$export$ffb0004e005737fa = $12e210181d22c35f$var$p;
$12e210181d22c35f$export$e2c29f18771995cb = $12e210181d22c35f$var$r;
$12e210181d22c35f$export$221d75b3f55bb0bd = $12e210181d22c35f$var$G;
$12e210181d22c35f$export$5f8d39834fd61797 = $12e210181d22c35f$var$q;
$12e210181d22c35f$export$74bf444e3cd11ea5 = $12e210181d22c35f$var$w;
$12e210181d22c35f$export$ae55be85d98224ed = $12e210181d22c35f$var$W;
$12e210181d22c35f$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $12e210181d22c35f$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $12e210181d22c35f$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$12e210181d22c35f$var$J.call(b, f) && !$12e210181d22c35f$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $12e210181d22c35f$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$12e210181d22c35f$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $12e210181d22c35f$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $12e210181d22c35f$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$12e210181d22c35f$export$c8a8987d4410bf2d = $12e210181d22c35f$var$M;
$12e210181d22c35f$export$d38cd72104c1f0e9 = function(a) {
    var b = $12e210181d22c35f$var$M.bind(null, a);
    b.type = a;
    return b;
};
$12e210181d22c35f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$12e210181d22c35f$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $12e210181d22c35f$var$v,
        render: a
    };
};
$12e210181d22c35f$export$a8257692ac88316c = $12e210181d22c35f$var$O;
$12e210181d22c35f$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $12e210181d22c35f$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $12e210181d22c35f$var$T
    };
};
$12e210181d22c35f$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $12e210181d22c35f$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$12e210181d22c35f$export$7568632d0d33d16d = function(a) {
    var b = $12e210181d22c35f$var$V.transition;
    $12e210181d22c35f$var$V.transition = {};
    try {
        a();
    } finally{
        $12e210181d22c35f$var$V.transition = b;
    }
};
$12e210181d22c35f$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$12e210181d22c35f$export$35808ee640e87ca7 = function(a, b) {
    return $12e210181d22c35f$var$U.current.useCallback(a, b);
};
$12e210181d22c35f$export$fae74005e78b1a27 = function(a) {
    return $12e210181d22c35f$var$U.current.useContext(a);
};
$12e210181d22c35f$export$dc8fbce3eb94dc1e = function() {};
$12e210181d22c35f$export$6a7bc4e911dc01cf = function(a) {
    return $12e210181d22c35f$var$U.current.useDeferredValue(a);
};
$12e210181d22c35f$export$6d9c69b0de29b591 = function(a, b) {
    return $12e210181d22c35f$var$U.current.useEffect(a, b);
};
$12e210181d22c35f$export$f680877a34711e37 = function() {
    return $12e210181d22c35f$var$U.current.useId();
};
$12e210181d22c35f$export$d5a552a76deda3c2 = function(a, b, e) {
    return $12e210181d22c35f$var$U.current.useImperativeHandle(a, b, e);
};
$12e210181d22c35f$export$aaabe4eda9ed9969 = function(a, b) {
    return $12e210181d22c35f$var$U.current.useInsertionEffect(a, b);
};
$12e210181d22c35f$export$e5c5a5f917a5871c = function(a, b) {
    return $12e210181d22c35f$var$U.current.useLayoutEffect(a, b);
};
$12e210181d22c35f$export$1538c33de8887b59 = function(a, b) {
    return $12e210181d22c35f$var$U.current.useMemo(a, b);
};
$12e210181d22c35f$export$13e3392192263954 = function(a, b, e) {
    return $12e210181d22c35f$var$U.current.useReducer(a, b, e);
};
$12e210181d22c35f$export$b8f5890fc79d6aca = function(a) {
    return $12e210181d22c35f$var$U.current.useRef(a);
};
$12e210181d22c35f$export$60241385465d0a34 = function(a) {
    return $12e210181d22c35f$var$U.current.useState(a);
};
$12e210181d22c35f$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $12e210181d22c35f$var$U.current.useSyncExternalStore(a, b, e);
};
$12e210181d22c35f$export$7b286972b8d8ccbf = function() {
    return $12e210181d22c35f$var$U.current.useTransition();
};
$12e210181d22c35f$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("1dCCy", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0e34f6a27473cf61$export$ae55be85d98224ed; }, function (v) { return $0e34f6a27473cf61$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $0e34f6a27473cf61$export$d39a5bbd09211389; }, function (v) { return $0e34f6a27473cf61$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $0e34f6a27473cf61$export$882461b6382ed46c; }, function (v) { return $0e34f6a27473cf61$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $0e34f6a27473cf61$export$466bfc07425424d5; }, function (v) { return $0e34f6a27473cf61$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $0e34f6a27473cf61$export$cd75ccfd720a3cd4; }, function (v) { return $0e34f6a27473cf61$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $0e34f6a27473cf61$export$fa8d919ba61d84db; }, function (v) { return $0e34f6a27473cf61$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $0e34f6a27473cf61$export$757ceba2d55c277e; }, function (v) { return $0e34f6a27473cf61$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $0e34f6a27473cf61$export$b3890eb0ae9dca99; }, function (v) { return $0e34f6a27473cf61$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $0e34f6a27473cf61$export$502457920280e6be; }, function (v) { return $0e34f6a27473cf61$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $0e34f6a27473cf61$export$c78a37762a8d58e1; }, function (v) { return $0e34f6a27473cf61$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $0e34f6a27473cf61$export$dc54d992c10e8a18; }, function (v) { return $0e34f6a27473cf61$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $0e34f6a27473cf61$export$83d89fbfd8236492; }, function (v) { return $0e34f6a27473cf61$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0e34f6a27473cf61$export$ae55be85d98224ed;
var $0e34f6a27473cf61$export$d39a5bbd09211389;
var $0e34f6a27473cf61$export$882461b6382ed46c;
var $0e34f6a27473cf61$export$466bfc07425424d5;
var $0e34f6a27473cf61$export$cd75ccfd720a3cd4;
var $0e34f6a27473cf61$export$fa8d919ba61d84db;
var $0e34f6a27473cf61$export$757ceba2d55c277e;
var $0e34f6a27473cf61$export$b3890eb0ae9dca99;
var $0e34f6a27473cf61$export$502457920280e6be;
var $0e34f6a27473cf61$export$c78a37762a8d58e1;
var $0e34f6a27473cf61$export$dc54d992c10e8a18;
var $0e34f6a27473cf61$export$83d89fbfd8236492;
"use strict";

var $1fELX = parcelRequire("1fELX");

var $baAzl = parcelRequire("baAzl");
function $0e34f6a27473cf61$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0e34f6a27473cf61$var$da = new Set, $0e34f6a27473cf61$var$ea = {};
function $0e34f6a27473cf61$var$fa(a, b) {
    $0e34f6a27473cf61$var$ha(a, b);
    $0e34f6a27473cf61$var$ha(a + "Capture", b);
}
function $0e34f6a27473cf61$var$ha(a, b) {
    $0e34f6a27473cf61$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0e34f6a27473cf61$var$da.add(b[a]);
}
var $0e34f6a27473cf61$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0e34f6a27473cf61$var$ja = Object.prototype.hasOwnProperty, $0e34f6a27473cf61$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0e34f6a27473cf61$var$la = {}, $0e34f6a27473cf61$var$ma = {};
function $0e34f6a27473cf61$var$oa(a) {
    if ($0e34f6a27473cf61$var$ja.call($0e34f6a27473cf61$var$ma, a)) return !0;
    if ($0e34f6a27473cf61$var$ja.call($0e34f6a27473cf61$var$la, a)) return !1;
    if ($0e34f6a27473cf61$var$ka.test(a)) return $0e34f6a27473cf61$var$ma[a] = !0;
    $0e34f6a27473cf61$var$la[a] = !0;
    return !1;
}
function $0e34f6a27473cf61$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0e34f6a27473cf61$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0e34f6a27473cf61$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0e34f6a27473cf61$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0e34f6a27473cf61$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0e34f6a27473cf61$var$z[a] = new $0e34f6a27473cf61$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0e34f6a27473cf61$var$z[b] = new $0e34f6a27473cf61$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0e34f6a27473cf61$var$z[a] = new $0e34f6a27473cf61$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0e34f6a27473cf61$var$z[a] = new $0e34f6a27473cf61$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0e34f6a27473cf61$var$z[a] = new $0e34f6a27473cf61$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0e34f6a27473cf61$var$z[a] = new $0e34f6a27473cf61$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0e34f6a27473cf61$var$z[a] = new $0e34f6a27473cf61$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0e34f6a27473cf61$var$z[a] = new $0e34f6a27473cf61$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0e34f6a27473cf61$var$z[a] = new $0e34f6a27473cf61$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0e34f6a27473cf61$var$ra = /[\-:]([a-z])/g;
function $0e34f6a27473cf61$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0e34f6a27473cf61$var$ra, $0e34f6a27473cf61$var$sa);
    $0e34f6a27473cf61$var$z[b] = new $0e34f6a27473cf61$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0e34f6a27473cf61$var$ra, $0e34f6a27473cf61$var$sa);
    $0e34f6a27473cf61$var$z[b] = new $0e34f6a27473cf61$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0e34f6a27473cf61$var$ra, $0e34f6a27473cf61$var$sa);
    $0e34f6a27473cf61$var$z[b] = new $0e34f6a27473cf61$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0e34f6a27473cf61$var$z[a] = new $0e34f6a27473cf61$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0e34f6a27473cf61$var$z.xlinkHref = new $0e34f6a27473cf61$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0e34f6a27473cf61$var$z[a] = new $0e34f6a27473cf61$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0e34f6a27473cf61$var$ta(a, b, c, d) {
    var e = $0e34f6a27473cf61$var$z.hasOwnProperty(b) ? $0e34f6a27473cf61$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0e34f6a27473cf61$var$qa(b, c, e, d) && (c = null), d || null === e ? $0e34f6a27473cf61$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0e34f6a27473cf61$var$ua = $1fELX.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0e34f6a27473cf61$var$va = Symbol.for("react.element"), $0e34f6a27473cf61$var$wa = Symbol.for("react.portal"), $0e34f6a27473cf61$var$ya = Symbol.for("react.fragment"), $0e34f6a27473cf61$var$za = Symbol.for("react.strict_mode"), $0e34f6a27473cf61$var$Aa = Symbol.for("react.profiler"), $0e34f6a27473cf61$var$Ba = Symbol.for("react.provider"), $0e34f6a27473cf61$var$Ca = Symbol.for("react.context"), $0e34f6a27473cf61$var$Da = Symbol.for("react.forward_ref"), $0e34f6a27473cf61$var$Ea = Symbol.for("react.suspense"), $0e34f6a27473cf61$var$Fa = Symbol.for("react.suspense_list"), $0e34f6a27473cf61$var$Ga = Symbol.for("react.memo"), $0e34f6a27473cf61$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0e34f6a27473cf61$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0e34f6a27473cf61$var$Ja = Symbol.iterator;
function $0e34f6a27473cf61$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0e34f6a27473cf61$var$Ja && a[$0e34f6a27473cf61$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0e34f6a27473cf61$var$A = Object.assign, $0e34f6a27473cf61$var$La;
function $0e34f6a27473cf61$var$Ma(a) {
    if (void 0 === $0e34f6a27473cf61$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0e34f6a27473cf61$var$La = b && b[1] || "";
    }
    return "\n" + $0e34f6a27473cf61$var$La + a;
}
var $0e34f6a27473cf61$var$Na = !1;
function $0e34f6a27473cf61$var$Oa(a, b) {
    if (!a || $0e34f6a27473cf61$var$Na) return "";
    $0e34f6a27473cf61$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0e34f6a27473cf61$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0e34f6a27473cf61$var$Ma(a) : "";
}
function $0e34f6a27473cf61$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0e34f6a27473cf61$var$Ma(a.type);
        case 16:
            return $0e34f6a27473cf61$var$Ma("Lazy");
        case 13:
            return $0e34f6a27473cf61$var$Ma("Suspense");
        case 19:
            return $0e34f6a27473cf61$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0e34f6a27473cf61$var$Oa(a.type, !1), a;
        case 11:
            return a = $0e34f6a27473cf61$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0e34f6a27473cf61$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0e34f6a27473cf61$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0e34f6a27473cf61$var$ya:
            return "Fragment";
        case $0e34f6a27473cf61$var$wa:
            return "Portal";
        case $0e34f6a27473cf61$var$Aa:
            return "Profiler";
        case $0e34f6a27473cf61$var$za:
            return "StrictMode";
        case $0e34f6a27473cf61$var$Ea:
            return "Suspense";
        case $0e34f6a27473cf61$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0e34f6a27473cf61$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0e34f6a27473cf61$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0e34f6a27473cf61$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0e34f6a27473cf61$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0e34f6a27473cf61$var$Qa(a.type) || "Memo";
        case $0e34f6a27473cf61$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0e34f6a27473cf61$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0e34f6a27473cf61$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0e34f6a27473cf61$var$Qa(b);
        case 8:
            return b === $0e34f6a27473cf61$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0e34f6a27473cf61$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0e34f6a27473cf61$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0e34f6a27473cf61$var$Ua(a) {
    var b = $0e34f6a27473cf61$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0e34f6a27473cf61$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0e34f6a27473cf61$var$Ua(a));
}
function $0e34f6a27473cf61$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0e34f6a27473cf61$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0e34f6a27473cf61$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0e34f6a27473cf61$var$Ya(a, b) {
    var c = b.checked;
    return $0e34f6a27473cf61$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0e34f6a27473cf61$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0e34f6a27473cf61$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0e34f6a27473cf61$var$ab(a, b) {
    b = b.checked;
    null != b && $0e34f6a27473cf61$var$ta(a, "checked", b, !1);
}
function $0e34f6a27473cf61$var$bb(a, b) {
    $0e34f6a27473cf61$var$ab(a, b);
    var c = $0e34f6a27473cf61$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0e34f6a27473cf61$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0e34f6a27473cf61$var$cb(a, b.type, $0e34f6a27473cf61$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0e34f6a27473cf61$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0e34f6a27473cf61$var$cb(a, b, c) {
    if ("number" !== b || $0e34f6a27473cf61$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0e34f6a27473cf61$var$eb = Array.isArray;
function $0e34f6a27473cf61$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0e34f6a27473cf61$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0e34f6a27473cf61$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0e34f6a27473cf61$var$p(91));
    return $0e34f6a27473cf61$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0e34f6a27473cf61$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0e34f6a27473cf61$var$p(92));
            if ($0e34f6a27473cf61$var$eb(c)) {
                if (1 < c.length) throw Error($0e34f6a27473cf61$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0e34f6a27473cf61$var$Sa(c)
    };
}
function $0e34f6a27473cf61$var$ib(a, b) {
    var c = $0e34f6a27473cf61$var$Sa(b.value), d = $0e34f6a27473cf61$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0e34f6a27473cf61$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0e34f6a27473cf61$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0e34f6a27473cf61$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0e34f6a27473cf61$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0e34f6a27473cf61$var$mb, $0e34f6a27473cf61$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0e34f6a27473cf61$var$mb = $0e34f6a27473cf61$var$mb || document.createElement("div");
        $0e34f6a27473cf61$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0e34f6a27473cf61$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0e34f6a27473cf61$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0e34f6a27473cf61$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0e34f6a27473cf61$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0e34f6a27473cf61$var$pb).forEach(function(a) {
    $0e34f6a27473cf61$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0e34f6a27473cf61$var$pb[b] = $0e34f6a27473cf61$var$pb[a];
    });
});
function $0e34f6a27473cf61$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0e34f6a27473cf61$var$pb.hasOwnProperty(a) && $0e34f6a27473cf61$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0e34f6a27473cf61$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0e34f6a27473cf61$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0e34f6a27473cf61$var$tb = $0e34f6a27473cf61$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0e34f6a27473cf61$var$ub(a, b) {
    if (b) {
        if ($0e34f6a27473cf61$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0e34f6a27473cf61$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0e34f6a27473cf61$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0e34f6a27473cf61$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0e34f6a27473cf61$var$p(62));
    }
}
function $0e34f6a27473cf61$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0e34f6a27473cf61$var$wb = null;
function $0e34f6a27473cf61$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0e34f6a27473cf61$var$yb = null, $0e34f6a27473cf61$var$zb = null, $0e34f6a27473cf61$var$Ab = null;
function $0e34f6a27473cf61$var$Bb(a) {
    if (a = $0e34f6a27473cf61$var$Cb(a)) {
        if ("function" !== typeof $0e34f6a27473cf61$var$yb) throw Error($0e34f6a27473cf61$var$p(280));
        var b = a.stateNode;
        b && (b = $0e34f6a27473cf61$var$Db(b), $0e34f6a27473cf61$var$yb(a.stateNode, a.type, b));
    }
}
function $0e34f6a27473cf61$var$Eb(a) {
    $0e34f6a27473cf61$var$zb ? $0e34f6a27473cf61$var$Ab ? $0e34f6a27473cf61$var$Ab.push(a) : $0e34f6a27473cf61$var$Ab = [
        a
    ] : $0e34f6a27473cf61$var$zb = a;
}
function $0e34f6a27473cf61$var$Fb() {
    if ($0e34f6a27473cf61$var$zb) {
        var a = $0e34f6a27473cf61$var$zb, b = $0e34f6a27473cf61$var$Ab;
        $0e34f6a27473cf61$var$Ab = $0e34f6a27473cf61$var$zb = null;
        $0e34f6a27473cf61$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0e34f6a27473cf61$var$Bb(b[a]);
    }
}
function $0e34f6a27473cf61$var$Gb(a, b) {
    return a(b);
}
function $0e34f6a27473cf61$var$Hb() {}
var $0e34f6a27473cf61$var$Ib = !1;
function $0e34f6a27473cf61$var$Jb(a, b, c) {
    if ($0e34f6a27473cf61$var$Ib) return a(b, c);
    $0e34f6a27473cf61$var$Ib = !0;
    try {
        return $0e34f6a27473cf61$var$Gb(a, b, c);
    } finally{
        if ($0e34f6a27473cf61$var$Ib = !1, null !== $0e34f6a27473cf61$var$zb || null !== $0e34f6a27473cf61$var$Ab) $0e34f6a27473cf61$var$Hb(), $0e34f6a27473cf61$var$Fb();
    }
}
function $0e34f6a27473cf61$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0e34f6a27473cf61$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0e34f6a27473cf61$var$p(231, b, typeof c));
    return c;
}
var $0e34f6a27473cf61$var$Lb = !1;
if ($0e34f6a27473cf61$var$ia) try {
    var $0e34f6a27473cf61$var$Mb = {};
    Object.defineProperty($0e34f6a27473cf61$var$Mb, "passive", {
        get: function() {
            $0e34f6a27473cf61$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0e34f6a27473cf61$var$Mb, $0e34f6a27473cf61$var$Mb);
    window.removeEventListener("test", $0e34f6a27473cf61$var$Mb, $0e34f6a27473cf61$var$Mb);
} catch (a) {
    $0e34f6a27473cf61$var$Lb = !1;
}
function $0e34f6a27473cf61$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0e34f6a27473cf61$var$Ob = !1, $0e34f6a27473cf61$var$Pb = null, $0e34f6a27473cf61$var$Qb = !1, $0e34f6a27473cf61$var$Rb = null, $0e34f6a27473cf61$var$Sb = {
    onError: function(a) {
        $0e34f6a27473cf61$var$Ob = !0;
        $0e34f6a27473cf61$var$Pb = a;
    }
};
function $0e34f6a27473cf61$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0e34f6a27473cf61$var$Ob = !1;
    $0e34f6a27473cf61$var$Pb = null;
    $0e34f6a27473cf61$var$Nb.apply($0e34f6a27473cf61$var$Sb, arguments);
}
function $0e34f6a27473cf61$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0e34f6a27473cf61$var$Tb.apply(this, arguments);
    if ($0e34f6a27473cf61$var$Ob) {
        if ($0e34f6a27473cf61$var$Ob) {
            var l = $0e34f6a27473cf61$var$Pb;
            $0e34f6a27473cf61$var$Ob = !1;
            $0e34f6a27473cf61$var$Pb = null;
        } else throw Error($0e34f6a27473cf61$var$p(198));
        $0e34f6a27473cf61$var$Qb || ($0e34f6a27473cf61$var$Qb = !0, $0e34f6a27473cf61$var$Rb = l);
    }
}
function $0e34f6a27473cf61$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0e34f6a27473cf61$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0e34f6a27473cf61$var$Xb(a) {
    if ($0e34f6a27473cf61$var$Vb(a) !== a) throw Error($0e34f6a27473cf61$var$p(188));
}
function $0e34f6a27473cf61$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0e34f6a27473cf61$var$Vb(a);
        if (null === b) throw Error($0e34f6a27473cf61$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0e34f6a27473cf61$var$Xb(e), a;
                if (f === d) return $0e34f6a27473cf61$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0e34f6a27473cf61$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0e34f6a27473cf61$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0e34f6a27473cf61$var$p(190));
    }
    if (3 !== c.tag) throw Error($0e34f6a27473cf61$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0e34f6a27473cf61$var$Zb(a) {
    a = $0e34f6a27473cf61$var$Yb(a);
    return null !== a ? $0e34f6a27473cf61$var$$b(a) : null;
}
function $0e34f6a27473cf61$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0e34f6a27473cf61$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0e34f6a27473cf61$var$ac = $baAzl.unstable_scheduleCallback, $0e34f6a27473cf61$var$bc = $baAzl.unstable_cancelCallback, $0e34f6a27473cf61$var$cc = $baAzl.unstable_shouldYield, $0e34f6a27473cf61$var$dc = $baAzl.unstable_requestPaint, $0e34f6a27473cf61$var$B = $baAzl.unstable_now, $0e34f6a27473cf61$var$ec = $baAzl.unstable_getCurrentPriorityLevel, $0e34f6a27473cf61$var$fc = $baAzl.unstable_ImmediatePriority, $0e34f6a27473cf61$var$gc = $baAzl.unstable_UserBlockingPriority, $0e34f6a27473cf61$var$hc = $baAzl.unstable_NormalPriority, $0e34f6a27473cf61$var$ic = $baAzl.unstable_LowPriority, $0e34f6a27473cf61$var$jc = $baAzl.unstable_IdlePriority, $0e34f6a27473cf61$var$kc = null, $0e34f6a27473cf61$var$lc = null;
function $0e34f6a27473cf61$var$mc(a) {
    if ($0e34f6a27473cf61$var$lc && "function" === typeof $0e34f6a27473cf61$var$lc.onCommitFiberRoot) try {
        $0e34f6a27473cf61$var$lc.onCommitFiberRoot($0e34f6a27473cf61$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0e34f6a27473cf61$var$oc = Math.clz32 ? Math.clz32 : $0e34f6a27473cf61$var$nc, $0e34f6a27473cf61$var$pc = Math.log, $0e34f6a27473cf61$var$qc = Math.LN2;
function $0e34f6a27473cf61$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0e34f6a27473cf61$var$pc(a) / $0e34f6a27473cf61$var$qc | 0) | 0;
}
var $0e34f6a27473cf61$var$rc = 64, $0e34f6a27473cf61$var$sc = 4194304;
function $0e34f6a27473cf61$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0e34f6a27473cf61$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0e34f6a27473cf61$var$tc(h) : (f &= g, 0 !== f && (d = $0e34f6a27473cf61$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0e34f6a27473cf61$var$tc(g) : 0 !== f && (d = $0e34f6a27473cf61$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0e34f6a27473cf61$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0e34f6a27473cf61$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0e34f6a27473cf61$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0e34f6a27473cf61$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0e34f6a27473cf61$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0e34f6a27473cf61$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0e34f6a27473cf61$var$yc() {
    var a = $0e34f6a27473cf61$var$rc;
    $0e34f6a27473cf61$var$rc <<= 1;
    0 === ($0e34f6a27473cf61$var$rc & 4194240) && ($0e34f6a27473cf61$var$rc = 64);
    return a;
}
function $0e34f6a27473cf61$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0e34f6a27473cf61$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0e34f6a27473cf61$var$oc(b);
    a[b] = c;
}
function $0e34f6a27473cf61$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0e34f6a27473cf61$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0e34f6a27473cf61$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0e34f6a27473cf61$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0e34f6a27473cf61$var$C = 0;
function $0e34f6a27473cf61$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0e34f6a27473cf61$var$Ec, $0e34f6a27473cf61$var$Fc, $0e34f6a27473cf61$var$Gc, $0e34f6a27473cf61$var$Hc, $0e34f6a27473cf61$var$Ic, $0e34f6a27473cf61$var$Jc = !1, $0e34f6a27473cf61$var$Kc = [], $0e34f6a27473cf61$var$Lc = null, $0e34f6a27473cf61$var$Mc = null, $0e34f6a27473cf61$var$Nc = null, $0e34f6a27473cf61$var$Oc = new Map, $0e34f6a27473cf61$var$Pc = new Map, $0e34f6a27473cf61$var$Qc = [], $0e34f6a27473cf61$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0e34f6a27473cf61$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0e34f6a27473cf61$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0e34f6a27473cf61$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0e34f6a27473cf61$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0e34f6a27473cf61$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0e34f6a27473cf61$var$Pc.delete(b.pointerId);
    }
}
function $0e34f6a27473cf61$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0e34f6a27473cf61$var$Cb(b), null !== b && $0e34f6a27473cf61$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0e34f6a27473cf61$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0e34f6a27473cf61$var$Lc = $0e34f6a27473cf61$var$Tc($0e34f6a27473cf61$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0e34f6a27473cf61$var$Mc = $0e34f6a27473cf61$var$Tc($0e34f6a27473cf61$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0e34f6a27473cf61$var$Nc = $0e34f6a27473cf61$var$Tc($0e34f6a27473cf61$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0e34f6a27473cf61$var$Oc.set(f, $0e34f6a27473cf61$var$Tc($0e34f6a27473cf61$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0e34f6a27473cf61$var$Pc.set(f, $0e34f6a27473cf61$var$Tc($0e34f6a27473cf61$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0e34f6a27473cf61$var$Vc(a) {
    var b = $0e34f6a27473cf61$var$Wc(a.target);
    if (null !== b) {
        var c = $0e34f6a27473cf61$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0e34f6a27473cf61$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0e34f6a27473cf61$var$Ic(a.priority, function() {
                        $0e34f6a27473cf61$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0e34f6a27473cf61$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0e34f6a27473cf61$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0e34f6a27473cf61$var$wb = d;
            c.target.dispatchEvent(d);
            $0e34f6a27473cf61$var$wb = null;
        } else return b = $0e34f6a27473cf61$var$Cb(c), null !== b && $0e34f6a27473cf61$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0e34f6a27473cf61$var$Zc(a, b, c) {
    $0e34f6a27473cf61$var$Xc(a) && c.delete(b);
}
function $0e34f6a27473cf61$var$$c() {
    $0e34f6a27473cf61$var$Jc = !1;
    null !== $0e34f6a27473cf61$var$Lc && $0e34f6a27473cf61$var$Xc($0e34f6a27473cf61$var$Lc) && ($0e34f6a27473cf61$var$Lc = null);
    null !== $0e34f6a27473cf61$var$Mc && $0e34f6a27473cf61$var$Xc($0e34f6a27473cf61$var$Mc) && ($0e34f6a27473cf61$var$Mc = null);
    null !== $0e34f6a27473cf61$var$Nc && $0e34f6a27473cf61$var$Xc($0e34f6a27473cf61$var$Nc) && ($0e34f6a27473cf61$var$Nc = null);
    $0e34f6a27473cf61$var$Oc.forEach($0e34f6a27473cf61$var$Zc);
    $0e34f6a27473cf61$var$Pc.forEach($0e34f6a27473cf61$var$Zc);
}
function $0e34f6a27473cf61$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0e34f6a27473cf61$var$Jc || ($0e34f6a27473cf61$var$Jc = !0, $baAzl.unstable_scheduleCallback($baAzl.unstable_NormalPriority, $0e34f6a27473cf61$var$$c)));
}
function $0e34f6a27473cf61$var$bd(a) {
    function b(b) {
        return $0e34f6a27473cf61$var$ad(b, a);
    }
    if (0 < $0e34f6a27473cf61$var$Kc.length) {
        $0e34f6a27473cf61$var$ad($0e34f6a27473cf61$var$Kc[0], a);
        for(var c = 1; c < $0e34f6a27473cf61$var$Kc.length; c++){
            var d = $0e34f6a27473cf61$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0e34f6a27473cf61$var$Lc && $0e34f6a27473cf61$var$ad($0e34f6a27473cf61$var$Lc, a);
    null !== $0e34f6a27473cf61$var$Mc && $0e34f6a27473cf61$var$ad($0e34f6a27473cf61$var$Mc, a);
    null !== $0e34f6a27473cf61$var$Nc && $0e34f6a27473cf61$var$ad($0e34f6a27473cf61$var$Nc, a);
    $0e34f6a27473cf61$var$Oc.forEach(b);
    $0e34f6a27473cf61$var$Pc.forEach(b);
    for(c = 0; c < $0e34f6a27473cf61$var$Qc.length; c++)d = $0e34f6a27473cf61$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0e34f6a27473cf61$var$Qc.length && (c = $0e34f6a27473cf61$var$Qc[0], null === c.blockedOn);)$0e34f6a27473cf61$var$Vc(c), null === c.blockedOn && $0e34f6a27473cf61$var$Qc.shift();
}
var $0e34f6a27473cf61$var$cd = $0e34f6a27473cf61$var$ua.ReactCurrentBatchConfig, $0e34f6a27473cf61$var$dd = !0;
function $0e34f6a27473cf61$var$ed(a, b, c, d) {
    var e = $0e34f6a27473cf61$var$C, f = $0e34f6a27473cf61$var$cd.transition;
    $0e34f6a27473cf61$var$cd.transition = null;
    try {
        $0e34f6a27473cf61$var$C = 1, $0e34f6a27473cf61$var$fd(a, b, c, d);
    } finally{
        $0e34f6a27473cf61$var$C = e, $0e34f6a27473cf61$var$cd.transition = f;
    }
}
function $0e34f6a27473cf61$var$gd(a, b, c, d) {
    var e = $0e34f6a27473cf61$var$C, f = $0e34f6a27473cf61$var$cd.transition;
    $0e34f6a27473cf61$var$cd.transition = null;
    try {
        $0e34f6a27473cf61$var$C = 4, $0e34f6a27473cf61$var$fd(a, b, c, d);
    } finally{
        $0e34f6a27473cf61$var$C = e, $0e34f6a27473cf61$var$cd.transition = f;
    }
}
function $0e34f6a27473cf61$var$fd(a, b, c, d) {
    if ($0e34f6a27473cf61$var$dd) {
        var e = $0e34f6a27473cf61$var$Yc(a, b, c, d);
        if (null === e) $0e34f6a27473cf61$var$hd(a, b, d, $0e34f6a27473cf61$var$id, c), $0e34f6a27473cf61$var$Sc(a, d);
        else if ($0e34f6a27473cf61$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0e34f6a27473cf61$var$Sc(a, d), b & 4 && -1 < $0e34f6a27473cf61$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0e34f6a27473cf61$var$Cb(e);
                null !== f && $0e34f6a27473cf61$var$Ec(f);
                f = $0e34f6a27473cf61$var$Yc(a, b, c, d);
                null === f && $0e34f6a27473cf61$var$hd(a, b, d, $0e34f6a27473cf61$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0e34f6a27473cf61$var$hd(a, b, d, null, c);
    }
}
var $0e34f6a27473cf61$var$id = null;
function $0e34f6a27473cf61$var$Yc(a, b, c, d) {
    $0e34f6a27473cf61$var$id = null;
    a = $0e34f6a27473cf61$var$xb(d);
    a = $0e34f6a27473cf61$var$Wc(a);
    if (null !== a) {
        if (b = $0e34f6a27473cf61$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0e34f6a27473cf61$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0e34f6a27473cf61$var$id = a;
    return null;
}
function $0e34f6a27473cf61$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0e34f6a27473cf61$var$ec()){
                case $0e34f6a27473cf61$var$fc:
                    return 1;
                case $0e34f6a27473cf61$var$gc:
                    return 4;
                case $0e34f6a27473cf61$var$hc:
                case $0e34f6a27473cf61$var$ic:
                    return 16;
                case $0e34f6a27473cf61$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0e34f6a27473cf61$var$kd = null, $0e34f6a27473cf61$var$ld = null, $0e34f6a27473cf61$var$md = null;
function $0e34f6a27473cf61$var$nd() {
    if ($0e34f6a27473cf61$var$md) return $0e34f6a27473cf61$var$md;
    var a, b = $0e34f6a27473cf61$var$ld, c = b.length, d, e = "value" in $0e34f6a27473cf61$var$kd ? $0e34f6a27473cf61$var$kd.value : $0e34f6a27473cf61$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0e34f6a27473cf61$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0e34f6a27473cf61$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0e34f6a27473cf61$var$pd() {
    return !0;
}
function $0e34f6a27473cf61$var$qd() {
    return !1;
}
function $0e34f6a27473cf61$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0e34f6a27473cf61$var$pd : $0e34f6a27473cf61$var$qd;
        this.isPropagationStopped = $0e34f6a27473cf61$var$qd;
        return this;
    }
    $0e34f6a27473cf61$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0e34f6a27473cf61$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0e34f6a27473cf61$var$pd);
        },
        persist: function() {},
        isPersistent: $0e34f6a27473cf61$var$pd
    });
    return b;
}
var $0e34f6a27473cf61$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0e34f6a27473cf61$var$td = $0e34f6a27473cf61$var$rd($0e34f6a27473cf61$var$sd), $0e34f6a27473cf61$var$ud = $0e34f6a27473cf61$var$A({}, $0e34f6a27473cf61$var$sd, {
    view: 0,
    detail: 0
}), $0e34f6a27473cf61$var$vd = $0e34f6a27473cf61$var$rd($0e34f6a27473cf61$var$ud), $0e34f6a27473cf61$var$wd, $0e34f6a27473cf61$var$xd, $0e34f6a27473cf61$var$yd, $0e34f6a27473cf61$var$Ad = $0e34f6a27473cf61$var$A({}, $0e34f6a27473cf61$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0e34f6a27473cf61$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0e34f6a27473cf61$var$yd && ($0e34f6a27473cf61$var$yd && "mousemove" === a.type ? ($0e34f6a27473cf61$var$wd = a.screenX - $0e34f6a27473cf61$var$yd.screenX, $0e34f6a27473cf61$var$xd = a.screenY - $0e34f6a27473cf61$var$yd.screenY) : $0e34f6a27473cf61$var$xd = $0e34f6a27473cf61$var$wd = 0, $0e34f6a27473cf61$var$yd = a);
        return $0e34f6a27473cf61$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0e34f6a27473cf61$var$xd;
    }
}), $0e34f6a27473cf61$var$Bd = $0e34f6a27473cf61$var$rd($0e34f6a27473cf61$var$Ad), $0e34f6a27473cf61$var$Cd = $0e34f6a27473cf61$var$A({}, $0e34f6a27473cf61$var$Ad, {
    dataTransfer: 0
}), $0e34f6a27473cf61$var$Dd = $0e34f6a27473cf61$var$rd($0e34f6a27473cf61$var$Cd), $0e34f6a27473cf61$var$Ed = $0e34f6a27473cf61$var$A({}, $0e34f6a27473cf61$var$ud, {
    relatedTarget: 0
}), $0e34f6a27473cf61$var$Fd = $0e34f6a27473cf61$var$rd($0e34f6a27473cf61$var$Ed), $0e34f6a27473cf61$var$Gd = $0e34f6a27473cf61$var$A({}, $0e34f6a27473cf61$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0e34f6a27473cf61$var$Hd = $0e34f6a27473cf61$var$rd($0e34f6a27473cf61$var$Gd), $0e34f6a27473cf61$var$Id = $0e34f6a27473cf61$var$A({}, $0e34f6a27473cf61$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0e34f6a27473cf61$var$Jd = $0e34f6a27473cf61$var$rd($0e34f6a27473cf61$var$Id), $0e34f6a27473cf61$var$Kd = $0e34f6a27473cf61$var$A({}, $0e34f6a27473cf61$var$sd, {
    data: 0
}), $0e34f6a27473cf61$var$Ld = $0e34f6a27473cf61$var$rd($0e34f6a27473cf61$var$Kd), $0e34f6a27473cf61$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0e34f6a27473cf61$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0e34f6a27473cf61$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0e34f6a27473cf61$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0e34f6a27473cf61$var$Od[a]) ? !!b[a] : !1;
}
function $0e34f6a27473cf61$var$zd() {
    return $0e34f6a27473cf61$var$Pd;
}
var $0e34f6a27473cf61$var$Qd = $0e34f6a27473cf61$var$A({}, $0e34f6a27473cf61$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0e34f6a27473cf61$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0e34f6a27473cf61$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0e34f6a27473cf61$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0e34f6a27473cf61$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0e34f6a27473cf61$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0e34f6a27473cf61$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0e34f6a27473cf61$var$Rd = $0e34f6a27473cf61$var$rd($0e34f6a27473cf61$var$Qd), $0e34f6a27473cf61$var$Sd = $0e34f6a27473cf61$var$A({}, $0e34f6a27473cf61$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0e34f6a27473cf61$var$Td = $0e34f6a27473cf61$var$rd($0e34f6a27473cf61$var$Sd), $0e34f6a27473cf61$var$Ud = $0e34f6a27473cf61$var$A({}, $0e34f6a27473cf61$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0e34f6a27473cf61$var$zd
}), $0e34f6a27473cf61$var$Vd = $0e34f6a27473cf61$var$rd($0e34f6a27473cf61$var$Ud), $0e34f6a27473cf61$var$Wd = $0e34f6a27473cf61$var$A({}, $0e34f6a27473cf61$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0e34f6a27473cf61$var$Xd = $0e34f6a27473cf61$var$rd($0e34f6a27473cf61$var$Wd), $0e34f6a27473cf61$var$Yd = $0e34f6a27473cf61$var$A({}, $0e34f6a27473cf61$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0e34f6a27473cf61$var$Zd = $0e34f6a27473cf61$var$rd($0e34f6a27473cf61$var$Yd), $0e34f6a27473cf61$var$$d = [
    9,
    13,
    27,
    32
], $0e34f6a27473cf61$var$ae = $0e34f6a27473cf61$var$ia && "CompositionEvent" in window, $0e34f6a27473cf61$var$be = null;
$0e34f6a27473cf61$var$ia && "documentMode" in document && ($0e34f6a27473cf61$var$be = document.documentMode);
var $0e34f6a27473cf61$var$ce = $0e34f6a27473cf61$var$ia && "TextEvent" in window && !$0e34f6a27473cf61$var$be, $0e34f6a27473cf61$var$de = $0e34f6a27473cf61$var$ia && (!$0e34f6a27473cf61$var$ae || $0e34f6a27473cf61$var$be && 8 < $0e34f6a27473cf61$var$be && 11 >= $0e34f6a27473cf61$var$be), $0e34f6a27473cf61$var$ee = String.fromCharCode(32), $0e34f6a27473cf61$var$fe = !1;
function $0e34f6a27473cf61$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0e34f6a27473cf61$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0e34f6a27473cf61$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0e34f6a27473cf61$var$ie = !1;
function $0e34f6a27473cf61$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0e34f6a27473cf61$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0e34f6a27473cf61$var$fe = !0;
            return $0e34f6a27473cf61$var$ee;
        case "textInput":
            return a = b.data, a === $0e34f6a27473cf61$var$ee && $0e34f6a27473cf61$var$fe ? null : a;
        default:
            return null;
    }
}
function $0e34f6a27473cf61$var$ke(a, b) {
    if ($0e34f6a27473cf61$var$ie) return "compositionend" === a || !$0e34f6a27473cf61$var$ae && $0e34f6a27473cf61$var$ge(a, b) ? (a = $0e34f6a27473cf61$var$nd(), $0e34f6a27473cf61$var$md = $0e34f6a27473cf61$var$ld = $0e34f6a27473cf61$var$kd = null, $0e34f6a27473cf61$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0e34f6a27473cf61$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0e34f6a27473cf61$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0e34f6a27473cf61$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0e34f6a27473cf61$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0e34f6a27473cf61$var$ne(a, b, c, d) {
    $0e34f6a27473cf61$var$Eb(d);
    b = $0e34f6a27473cf61$var$oe(b, "onChange");
    0 < b.length && (c = new $0e34f6a27473cf61$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0e34f6a27473cf61$var$pe = null, $0e34f6a27473cf61$var$qe = null;
function $0e34f6a27473cf61$var$re(a) {
    $0e34f6a27473cf61$var$se(a, 0);
}
function $0e34f6a27473cf61$var$te(a) {
    var b = $0e34f6a27473cf61$var$ue(a);
    if ($0e34f6a27473cf61$var$Wa(b)) return a;
}
function $0e34f6a27473cf61$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0e34f6a27473cf61$var$we = !1;
if ($0e34f6a27473cf61$var$ia) {
    var $0e34f6a27473cf61$var$xe;
    if ($0e34f6a27473cf61$var$ia) {
        var $0e34f6a27473cf61$var$ye = "oninput" in document;
        if (!$0e34f6a27473cf61$var$ye) {
            var $0e34f6a27473cf61$var$ze = document.createElement("div");
            $0e34f6a27473cf61$var$ze.setAttribute("oninput", "return;");
            $0e34f6a27473cf61$var$ye = "function" === typeof $0e34f6a27473cf61$var$ze.oninput;
        }
        $0e34f6a27473cf61$var$xe = $0e34f6a27473cf61$var$ye;
    } else $0e34f6a27473cf61$var$xe = !1;
    $0e34f6a27473cf61$var$we = $0e34f6a27473cf61$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0e34f6a27473cf61$var$Ae() {
    $0e34f6a27473cf61$var$pe && ($0e34f6a27473cf61$var$pe.detachEvent("onpropertychange", $0e34f6a27473cf61$var$Be), $0e34f6a27473cf61$var$qe = $0e34f6a27473cf61$var$pe = null);
}
function $0e34f6a27473cf61$var$Be(a) {
    if ("value" === a.propertyName && $0e34f6a27473cf61$var$te($0e34f6a27473cf61$var$qe)) {
        var b = [];
        $0e34f6a27473cf61$var$ne(b, $0e34f6a27473cf61$var$qe, a, $0e34f6a27473cf61$var$xb(a));
        $0e34f6a27473cf61$var$Jb($0e34f6a27473cf61$var$re, b);
    }
}
function $0e34f6a27473cf61$var$Ce(a, b, c) {
    "focusin" === a ? ($0e34f6a27473cf61$var$Ae(), $0e34f6a27473cf61$var$pe = b, $0e34f6a27473cf61$var$qe = c, $0e34f6a27473cf61$var$pe.attachEvent("onpropertychange", $0e34f6a27473cf61$var$Be)) : "focusout" === a && $0e34f6a27473cf61$var$Ae();
}
function $0e34f6a27473cf61$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0e34f6a27473cf61$var$te($0e34f6a27473cf61$var$qe);
}
function $0e34f6a27473cf61$var$Ee(a, b) {
    if ("click" === a) return $0e34f6a27473cf61$var$te(b);
}
function $0e34f6a27473cf61$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0e34f6a27473cf61$var$te(b);
}
function $0e34f6a27473cf61$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0e34f6a27473cf61$var$He = "function" === typeof Object.is ? Object.is : $0e34f6a27473cf61$var$Ge;
function $0e34f6a27473cf61$var$Ie(a, b) {
    if ($0e34f6a27473cf61$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0e34f6a27473cf61$var$ja.call(b, e) || !$0e34f6a27473cf61$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0e34f6a27473cf61$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0e34f6a27473cf61$var$Ke(a, b) {
    var c = $0e34f6a27473cf61$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0e34f6a27473cf61$var$Je(c);
    }
}
function $0e34f6a27473cf61$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0e34f6a27473cf61$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0e34f6a27473cf61$var$Me() {
    for(var a = window, b = $0e34f6a27473cf61$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0e34f6a27473cf61$var$Xa(a.document);
    }
    return b;
}
function $0e34f6a27473cf61$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0e34f6a27473cf61$var$Oe(a) {
    var b = $0e34f6a27473cf61$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0e34f6a27473cf61$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0e34f6a27473cf61$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0e34f6a27473cf61$var$Ke(c, f);
                var g = $0e34f6a27473cf61$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0e34f6a27473cf61$var$Pe = $0e34f6a27473cf61$var$ia && "documentMode" in document && 11 >= document.documentMode, $0e34f6a27473cf61$var$Qe = null, $0e34f6a27473cf61$var$Re = null, $0e34f6a27473cf61$var$Se = null, $0e34f6a27473cf61$var$Te = !1;
function $0e34f6a27473cf61$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0e34f6a27473cf61$var$Te || null == $0e34f6a27473cf61$var$Qe || $0e34f6a27473cf61$var$Qe !== $0e34f6a27473cf61$var$Xa(d) || (d = $0e34f6a27473cf61$var$Qe, "selectionStart" in d && $0e34f6a27473cf61$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0e34f6a27473cf61$var$Se && $0e34f6a27473cf61$var$Ie($0e34f6a27473cf61$var$Se, d) || ($0e34f6a27473cf61$var$Se = d, d = $0e34f6a27473cf61$var$oe($0e34f6a27473cf61$var$Re, "onSelect"), 0 < d.length && (b = new $0e34f6a27473cf61$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0e34f6a27473cf61$var$Qe)));
}
function $0e34f6a27473cf61$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0e34f6a27473cf61$var$We = {
    animationend: $0e34f6a27473cf61$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0e34f6a27473cf61$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0e34f6a27473cf61$var$Ve("Animation", "AnimationStart"),
    transitionend: $0e34f6a27473cf61$var$Ve("Transition", "TransitionEnd")
}, $0e34f6a27473cf61$var$Xe = {}, $0e34f6a27473cf61$var$Ye = {};
$0e34f6a27473cf61$var$ia && ($0e34f6a27473cf61$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0e34f6a27473cf61$var$We.animationend.animation, delete $0e34f6a27473cf61$var$We.animationiteration.animation, delete $0e34f6a27473cf61$var$We.animationstart.animation), "TransitionEvent" in window || delete $0e34f6a27473cf61$var$We.transitionend.transition);
function $0e34f6a27473cf61$var$Ze(a) {
    if ($0e34f6a27473cf61$var$Xe[a]) return $0e34f6a27473cf61$var$Xe[a];
    if (!$0e34f6a27473cf61$var$We[a]) return a;
    var b = $0e34f6a27473cf61$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0e34f6a27473cf61$var$Ye) return $0e34f6a27473cf61$var$Xe[a] = b[c];
    return a;
}
var $0e34f6a27473cf61$var$$e = $0e34f6a27473cf61$var$Ze("animationend"), $0e34f6a27473cf61$var$af = $0e34f6a27473cf61$var$Ze("animationiteration"), $0e34f6a27473cf61$var$bf = $0e34f6a27473cf61$var$Ze("animationstart"), $0e34f6a27473cf61$var$cf = $0e34f6a27473cf61$var$Ze("transitionend"), $0e34f6a27473cf61$var$df = new Map, $0e34f6a27473cf61$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0e34f6a27473cf61$var$ff(a, b) {
    $0e34f6a27473cf61$var$df.set(a, b);
    $0e34f6a27473cf61$var$fa(b, [
        a
    ]);
}
for(var $0e34f6a27473cf61$var$gf = 0; $0e34f6a27473cf61$var$gf < $0e34f6a27473cf61$var$ef.length; $0e34f6a27473cf61$var$gf++){
    var $0e34f6a27473cf61$var$hf = $0e34f6a27473cf61$var$ef[$0e34f6a27473cf61$var$gf], $0e34f6a27473cf61$var$jf = $0e34f6a27473cf61$var$hf.toLowerCase(), $0e34f6a27473cf61$var$kf = $0e34f6a27473cf61$var$hf[0].toUpperCase() + $0e34f6a27473cf61$var$hf.slice(1);
    $0e34f6a27473cf61$var$ff($0e34f6a27473cf61$var$jf, "on" + $0e34f6a27473cf61$var$kf);
}
$0e34f6a27473cf61$var$ff($0e34f6a27473cf61$var$$e, "onAnimationEnd");
$0e34f6a27473cf61$var$ff($0e34f6a27473cf61$var$af, "onAnimationIteration");
$0e34f6a27473cf61$var$ff($0e34f6a27473cf61$var$bf, "onAnimationStart");
$0e34f6a27473cf61$var$ff("dblclick", "onDoubleClick");
$0e34f6a27473cf61$var$ff("focusin", "onFocus");
$0e34f6a27473cf61$var$ff("focusout", "onBlur");
$0e34f6a27473cf61$var$ff($0e34f6a27473cf61$var$cf, "onTransitionEnd");
$0e34f6a27473cf61$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0e34f6a27473cf61$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0e34f6a27473cf61$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0e34f6a27473cf61$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0e34f6a27473cf61$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0e34f6a27473cf61$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0e34f6a27473cf61$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0e34f6a27473cf61$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0e34f6a27473cf61$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0e34f6a27473cf61$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0e34f6a27473cf61$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0e34f6a27473cf61$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0e34f6a27473cf61$var$lf));
function $0e34f6a27473cf61$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0e34f6a27473cf61$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0e34f6a27473cf61$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0e34f6a27473cf61$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0e34f6a27473cf61$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0e34f6a27473cf61$var$Qb) throw a = $0e34f6a27473cf61$var$Rb, $0e34f6a27473cf61$var$Qb = !1, $0e34f6a27473cf61$var$Rb = null, a;
}
function $0e34f6a27473cf61$var$D(a, b) {
    var c = b[$0e34f6a27473cf61$var$of];
    void 0 === c && (c = b[$0e34f6a27473cf61$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0e34f6a27473cf61$var$pf(b, a, 2, !1), c.add(d));
}
function $0e34f6a27473cf61$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0e34f6a27473cf61$var$pf(c, a, d, b);
}
var $0e34f6a27473cf61$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0e34f6a27473cf61$var$sf(a) {
    if (!a[$0e34f6a27473cf61$var$rf]) {
        a[$0e34f6a27473cf61$var$rf] = !0;
        $0e34f6a27473cf61$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0e34f6a27473cf61$var$mf.has(b) || $0e34f6a27473cf61$var$qf(b, !1, a), $0e34f6a27473cf61$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0e34f6a27473cf61$var$rf] || (b[$0e34f6a27473cf61$var$rf] = !0, $0e34f6a27473cf61$var$qf("selectionchange", !1, b));
    }
}
function $0e34f6a27473cf61$var$pf(a, b, c, d) {
    switch($0e34f6a27473cf61$var$jd(b)){
        case 1:
            var e = $0e34f6a27473cf61$var$ed;
            break;
        case 4:
            e = $0e34f6a27473cf61$var$gd;
            break;
        default:
            e = $0e34f6a27473cf61$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0e34f6a27473cf61$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0e34f6a27473cf61$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0e34f6a27473cf61$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0e34f6a27473cf61$var$Jb(function() {
        var d = f, e = $0e34f6a27473cf61$var$xb(c), g = [];
        a: {
            var h = $0e34f6a27473cf61$var$df.get(a);
            if (void 0 !== h) {
                var k = $0e34f6a27473cf61$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0e34f6a27473cf61$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0e34f6a27473cf61$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0e34f6a27473cf61$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0e34f6a27473cf61$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0e34f6a27473cf61$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0e34f6a27473cf61$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0e34f6a27473cf61$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0e34f6a27473cf61$var$Vd;
                        break;
                    case $0e34f6a27473cf61$var$$e:
                    case $0e34f6a27473cf61$var$af:
                    case $0e34f6a27473cf61$var$bf:
                        k = $0e34f6a27473cf61$var$Hd;
                        break;
                    case $0e34f6a27473cf61$var$cf:
                        k = $0e34f6a27473cf61$var$Xd;
                        break;
                    case "scroll":
                        k = $0e34f6a27473cf61$var$vd;
                        break;
                    case "wheel":
                        k = $0e34f6a27473cf61$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0e34f6a27473cf61$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0e34f6a27473cf61$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0e34f6a27473cf61$var$Kb(w, x), null != F && t.push($0e34f6a27473cf61$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0e34f6a27473cf61$var$wb && (n = c.relatedTarget || c.fromElement) && ($0e34f6a27473cf61$var$Wc(n) || n[$0e34f6a27473cf61$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0e34f6a27473cf61$var$Wc(n) : null, null !== n && (J = $0e34f6a27473cf61$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0e34f6a27473cf61$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0e34f6a27473cf61$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0e34f6a27473cf61$var$ue(k);
                        u = null == n ? h : $0e34f6a27473cf61$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0e34f6a27473cf61$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0e34f6a27473cf61$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0e34f6a27473cf61$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0e34f6a27473cf61$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0e34f6a27473cf61$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0e34f6a27473cf61$var$vf(t);
                                x = $0e34f6a27473cf61$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0e34f6a27473cf61$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0e34f6a27473cf61$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0e34f6a27473cf61$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0e34f6a27473cf61$var$ve;
                else if ($0e34f6a27473cf61$var$me(h)) {
                    if ($0e34f6a27473cf61$var$we) na = $0e34f6a27473cf61$var$Fe;
                    else {
                        na = $0e34f6a27473cf61$var$De;
                        var xa = $0e34f6a27473cf61$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0e34f6a27473cf61$var$Ee);
                if (na && (na = na(a, d))) {
                    $0e34f6a27473cf61$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0e34f6a27473cf61$var$cb(h, "number", h.value);
            }
            xa = d ? $0e34f6a27473cf61$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0e34f6a27473cf61$var$me(xa) || "true" === xa.contentEditable) $0e34f6a27473cf61$var$Qe = xa, $0e34f6a27473cf61$var$Re = d, $0e34f6a27473cf61$var$Se = null;
                    break;
                case "focusout":
                    $0e34f6a27473cf61$var$Se = $0e34f6a27473cf61$var$Re = $0e34f6a27473cf61$var$Qe = null;
                    break;
                case "mousedown":
                    $0e34f6a27473cf61$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0e34f6a27473cf61$var$Te = !1;
                    $0e34f6a27473cf61$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0e34f6a27473cf61$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0e34f6a27473cf61$var$Ue(g, c, e);
            }
            var $a;
            if ($0e34f6a27473cf61$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0e34f6a27473cf61$var$ie ? $0e34f6a27473cf61$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0e34f6a27473cf61$var$de && "ko" !== c.locale && ($0e34f6a27473cf61$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0e34f6a27473cf61$var$ie && ($a = $0e34f6a27473cf61$var$nd()) : ($0e34f6a27473cf61$var$kd = e, $0e34f6a27473cf61$var$ld = "value" in $0e34f6a27473cf61$var$kd ? $0e34f6a27473cf61$var$kd.value : $0e34f6a27473cf61$var$kd.textContent, $0e34f6a27473cf61$var$ie = !0)), xa = $0e34f6a27473cf61$var$oe(d, ba), 0 < xa.length && (ba = new $0e34f6a27473cf61$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0e34f6a27473cf61$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0e34f6a27473cf61$var$ce ? $0e34f6a27473cf61$var$je(a, c) : $0e34f6a27473cf61$var$ke(a, c)) d = $0e34f6a27473cf61$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0e34f6a27473cf61$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0e34f6a27473cf61$var$se(g, b);
    });
}
function $0e34f6a27473cf61$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0e34f6a27473cf61$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0e34f6a27473cf61$var$Kb(a, c), null != f && d.unshift($0e34f6a27473cf61$var$tf(a, f, e)), f = $0e34f6a27473cf61$var$Kb(a, b), null != f && d.push($0e34f6a27473cf61$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0e34f6a27473cf61$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0e34f6a27473cf61$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0e34f6a27473cf61$var$Kb(c, f), null != k && g.unshift($0e34f6a27473cf61$var$tf(c, k, h))) : e || (k = $0e34f6a27473cf61$var$Kb(c, f), null != k && g.push($0e34f6a27473cf61$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0e34f6a27473cf61$var$xf = /\r\n?/g, $0e34f6a27473cf61$var$yf = /\u0000|\uFFFD/g;
function $0e34f6a27473cf61$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0e34f6a27473cf61$var$xf, "\n").replace($0e34f6a27473cf61$var$yf, "");
}
function $0e34f6a27473cf61$var$Af(a, b, c) {
    b = $0e34f6a27473cf61$var$zf(b);
    if ($0e34f6a27473cf61$var$zf(a) !== b && c) throw Error($0e34f6a27473cf61$var$p(425));
}
function $0e34f6a27473cf61$var$Bf() {}
var $0e34f6a27473cf61$var$Cf = null, $0e34f6a27473cf61$var$Df = null;
function $0e34f6a27473cf61$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0e34f6a27473cf61$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0e34f6a27473cf61$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0e34f6a27473cf61$var$Hf = "function" === typeof Promise ? Promise : void 0, $0e34f6a27473cf61$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0e34f6a27473cf61$var$Hf ? function(a) {
    return $0e34f6a27473cf61$var$Hf.resolve(null).then(a).catch($0e34f6a27473cf61$var$If);
} : $0e34f6a27473cf61$var$Ff;
function $0e34f6a27473cf61$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0e34f6a27473cf61$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0e34f6a27473cf61$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0e34f6a27473cf61$var$bd(b);
}
function $0e34f6a27473cf61$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0e34f6a27473cf61$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0e34f6a27473cf61$var$Nf = Math.random().toString(36).slice(2), $0e34f6a27473cf61$var$Of = "__reactFiber$" + $0e34f6a27473cf61$var$Nf, $0e34f6a27473cf61$var$Pf = "__reactProps$" + $0e34f6a27473cf61$var$Nf, $0e34f6a27473cf61$var$uf = "__reactContainer$" + $0e34f6a27473cf61$var$Nf, $0e34f6a27473cf61$var$of = "__reactEvents$" + $0e34f6a27473cf61$var$Nf, $0e34f6a27473cf61$var$Qf = "__reactListeners$" + $0e34f6a27473cf61$var$Nf, $0e34f6a27473cf61$var$Rf = "__reactHandles$" + $0e34f6a27473cf61$var$Nf;
function $0e34f6a27473cf61$var$Wc(a) {
    var b = a[$0e34f6a27473cf61$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0e34f6a27473cf61$var$uf] || c[$0e34f6a27473cf61$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0e34f6a27473cf61$var$Mf(a); null !== a;){
                if (c = a[$0e34f6a27473cf61$var$Of]) return c;
                a = $0e34f6a27473cf61$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0e34f6a27473cf61$var$Cb(a) {
    a = a[$0e34f6a27473cf61$var$Of] || a[$0e34f6a27473cf61$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0e34f6a27473cf61$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0e34f6a27473cf61$var$p(33));
}
function $0e34f6a27473cf61$var$Db(a) {
    return a[$0e34f6a27473cf61$var$Pf] || null;
}
var $0e34f6a27473cf61$var$Sf = [], $0e34f6a27473cf61$var$Tf = -1;
function $0e34f6a27473cf61$var$Uf(a) {
    return {
        current: a
    };
}
function $0e34f6a27473cf61$var$E(a) {
    0 > $0e34f6a27473cf61$var$Tf || (a.current = $0e34f6a27473cf61$var$Sf[$0e34f6a27473cf61$var$Tf], $0e34f6a27473cf61$var$Sf[$0e34f6a27473cf61$var$Tf] = null, $0e34f6a27473cf61$var$Tf--);
}
function $0e34f6a27473cf61$var$G(a, b) {
    $0e34f6a27473cf61$var$Tf++;
    $0e34f6a27473cf61$var$Sf[$0e34f6a27473cf61$var$Tf] = a.current;
    a.current = b;
}
var $0e34f6a27473cf61$var$Vf = {}, $0e34f6a27473cf61$var$H = $0e34f6a27473cf61$var$Uf($0e34f6a27473cf61$var$Vf), $0e34f6a27473cf61$var$Wf = $0e34f6a27473cf61$var$Uf(!1), $0e34f6a27473cf61$var$Xf = $0e34f6a27473cf61$var$Vf;
function $0e34f6a27473cf61$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0e34f6a27473cf61$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0e34f6a27473cf61$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0e34f6a27473cf61$var$$f() {
    $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$Wf);
    $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$H);
}
function $0e34f6a27473cf61$var$ag(a, b, c) {
    if ($0e34f6a27473cf61$var$H.current !== $0e34f6a27473cf61$var$Vf) throw Error($0e34f6a27473cf61$var$p(168));
    $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$H, b);
    $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$Wf, c);
}
function $0e34f6a27473cf61$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0e34f6a27473cf61$var$p(108, $0e34f6a27473cf61$var$Ra(a) || "Unknown", e));
    return $0e34f6a27473cf61$var$A({}, c, d);
}
function $0e34f6a27473cf61$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0e34f6a27473cf61$var$Vf;
    $0e34f6a27473cf61$var$Xf = $0e34f6a27473cf61$var$H.current;
    $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$H, a);
    $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$Wf, $0e34f6a27473cf61$var$Wf.current);
    return !0;
}
function $0e34f6a27473cf61$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0e34f6a27473cf61$var$p(169));
    c ? (a = $0e34f6a27473cf61$var$bg(a, b, $0e34f6a27473cf61$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$Wf), $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$H), $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$H, a)) : $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$Wf);
    $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$Wf, c);
}
var $0e34f6a27473cf61$var$eg = null, $0e34f6a27473cf61$var$fg = !1, $0e34f6a27473cf61$var$gg = !1;
function $0e34f6a27473cf61$var$hg(a) {
    null === $0e34f6a27473cf61$var$eg ? $0e34f6a27473cf61$var$eg = [
        a
    ] : $0e34f6a27473cf61$var$eg.push(a);
}
function $0e34f6a27473cf61$var$ig(a) {
    $0e34f6a27473cf61$var$fg = !0;
    $0e34f6a27473cf61$var$hg(a);
}
function $0e34f6a27473cf61$var$jg() {
    if (!$0e34f6a27473cf61$var$gg && null !== $0e34f6a27473cf61$var$eg) {
        $0e34f6a27473cf61$var$gg = !0;
        var a = 0, b = $0e34f6a27473cf61$var$C;
        try {
            var c = $0e34f6a27473cf61$var$eg;
            for($0e34f6a27473cf61$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0e34f6a27473cf61$var$eg = null;
            $0e34f6a27473cf61$var$fg = !1;
        } catch (e) {
            throw null !== $0e34f6a27473cf61$var$eg && ($0e34f6a27473cf61$var$eg = $0e34f6a27473cf61$var$eg.slice(a + 1)), $0e34f6a27473cf61$var$ac($0e34f6a27473cf61$var$fc, $0e34f6a27473cf61$var$jg), e;
        } finally{
            $0e34f6a27473cf61$var$C = b, $0e34f6a27473cf61$var$gg = !1;
        }
    }
    return null;
}
var $0e34f6a27473cf61$var$kg = [], $0e34f6a27473cf61$var$lg = 0, $0e34f6a27473cf61$var$mg = null, $0e34f6a27473cf61$var$ng = 0, $0e34f6a27473cf61$var$og = [], $0e34f6a27473cf61$var$pg = 0, $0e34f6a27473cf61$var$qg = null, $0e34f6a27473cf61$var$rg = 1, $0e34f6a27473cf61$var$sg = "";
function $0e34f6a27473cf61$var$tg(a, b) {
    $0e34f6a27473cf61$var$kg[$0e34f6a27473cf61$var$lg++] = $0e34f6a27473cf61$var$ng;
    $0e34f6a27473cf61$var$kg[$0e34f6a27473cf61$var$lg++] = $0e34f6a27473cf61$var$mg;
    $0e34f6a27473cf61$var$mg = a;
    $0e34f6a27473cf61$var$ng = b;
}
function $0e34f6a27473cf61$var$ug(a, b, c) {
    $0e34f6a27473cf61$var$og[$0e34f6a27473cf61$var$pg++] = $0e34f6a27473cf61$var$rg;
    $0e34f6a27473cf61$var$og[$0e34f6a27473cf61$var$pg++] = $0e34f6a27473cf61$var$sg;
    $0e34f6a27473cf61$var$og[$0e34f6a27473cf61$var$pg++] = $0e34f6a27473cf61$var$qg;
    $0e34f6a27473cf61$var$qg = a;
    var d = $0e34f6a27473cf61$var$rg;
    a = $0e34f6a27473cf61$var$sg;
    var e = 32 - $0e34f6a27473cf61$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0e34f6a27473cf61$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0e34f6a27473cf61$var$rg = 1 << 32 - $0e34f6a27473cf61$var$oc(b) + e | c << e | d;
        $0e34f6a27473cf61$var$sg = f + a;
    } else $0e34f6a27473cf61$var$rg = 1 << f | c << e | d, $0e34f6a27473cf61$var$sg = a;
}
function $0e34f6a27473cf61$var$vg(a) {
    null !== a.return && ($0e34f6a27473cf61$var$tg(a, 1), $0e34f6a27473cf61$var$ug(a, 1, 0));
}
function $0e34f6a27473cf61$var$wg(a) {
    for(; a === $0e34f6a27473cf61$var$mg;)$0e34f6a27473cf61$var$mg = $0e34f6a27473cf61$var$kg[--$0e34f6a27473cf61$var$lg], $0e34f6a27473cf61$var$kg[$0e34f6a27473cf61$var$lg] = null, $0e34f6a27473cf61$var$ng = $0e34f6a27473cf61$var$kg[--$0e34f6a27473cf61$var$lg], $0e34f6a27473cf61$var$kg[$0e34f6a27473cf61$var$lg] = null;
    for(; a === $0e34f6a27473cf61$var$qg;)$0e34f6a27473cf61$var$qg = $0e34f6a27473cf61$var$og[--$0e34f6a27473cf61$var$pg], $0e34f6a27473cf61$var$og[$0e34f6a27473cf61$var$pg] = null, $0e34f6a27473cf61$var$sg = $0e34f6a27473cf61$var$og[--$0e34f6a27473cf61$var$pg], $0e34f6a27473cf61$var$og[$0e34f6a27473cf61$var$pg] = null, $0e34f6a27473cf61$var$rg = $0e34f6a27473cf61$var$og[--$0e34f6a27473cf61$var$pg], $0e34f6a27473cf61$var$og[$0e34f6a27473cf61$var$pg] = null;
}
var $0e34f6a27473cf61$var$xg = null, $0e34f6a27473cf61$var$yg = null, $0e34f6a27473cf61$var$I = !1, $0e34f6a27473cf61$var$zg = null;
function $0e34f6a27473cf61$var$Ag(a, b) {
    var c = $0e34f6a27473cf61$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0e34f6a27473cf61$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0e34f6a27473cf61$var$xg = a, $0e34f6a27473cf61$var$yg = $0e34f6a27473cf61$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0e34f6a27473cf61$var$xg = a, $0e34f6a27473cf61$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0e34f6a27473cf61$var$qg ? {
                id: $0e34f6a27473cf61$var$rg,
                overflow: $0e34f6a27473cf61$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0e34f6a27473cf61$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0e34f6a27473cf61$var$xg = a, $0e34f6a27473cf61$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0e34f6a27473cf61$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0e34f6a27473cf61$var$Eg(a) {
    if ($0e34f6a27473cf61$var$I) {
        var b = $0e34f6a27473cf61$var$yg;
        if (b) {
            var c = b;
            if (!$0e34f6a27473cf61$var$Cg(a, b)) {
                if ($0e34f6a27473cf61$var$Dg(a)) throw Error($0e34f6a27473cf61$var$p(418));
                b = $0e34f6a27473cf61$var$Lf(c.nextSibling);
                var d = $0e34f6a27473cf61$var$xg;
                b && $0e34f6a27473cf61$var$Cg(a, b) ? $0e34f6a27473cf61$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0e34f6a27473cf61$var$I = !1, $0e34f6a27473cf61$var$xg = a);
            }
        } else {
            if ($0e34f6a27473cf61$var$Dg(a)) throw Error($0e34f6a27473cf61$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0e34f6a27473cf61$var$I = !1;
            $0e34f6a27473cf61$var$xg = a;
        }
    }
}
function $0e34f6a27473cf61$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0e34f6a27473cf61$var$xg = a;
}
function $0e34f6a27473cf61$var$Gg(a) {
    if (a !== $0e34f6a27473cf61$var$xg) return !1;
    if (!$0e34f6a27473cf61$var$I) return $0e34f6a27473cf61$var$Fg(a), $0e34f6a27473cf61$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0e34f6a27473cf61$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0e34f6a27473cf61$var$yg)) {
        if ($0e34f6a27473cf61$var$Dg(a)) throw $0e34f6a27473cf61$var$Hg(), Error($0e34f6a27473cf61$var$p(418));
        for(; b;)$0e34f6a27473cf61$var$Ag(a, b), b = $0e34f6a27473cf61$var$Lf(b.nextSibling);
    }
    $0e34f6a27473cf61$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0e34f6a27473cf61$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0e34f6a27473cf61$var$yg = $0e34f6a27473cf61$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0e34f6a27473cf61$var$yg = null;
        }
    } else $0e34f6a27473cf61$var$yg = $0e34f6a27473cf61$var$xg ? $0e34f6a27473cf61$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0e34f6a27473cf61$var$Hg() {
    for(var a = $0e34f6a27473cf61$var$yg; a;)a = $0e34f6a27473cf61$var$Lf(a.nextSibling);
}
function $0e34f6a27473cf61$var$Ig() {
    $0e34f6a27473cf61$var$yg = $0e34f6a27473cf61$var$xg = null;
    $0e34f6a27473cf61$var$I = !1;
}
function $0e34f6a27473cf61$var$Jg(a) {
    null === $0e34f6a27473cf61$var$zg ? $0e34f6a27473cf61$var$zg = [
        a
    ] : $0e34f6a27473cf61$var$zg.push(a);
}
var $0e34f6a27473cf61$var$Kg = $0e34f6a27473cf61$var$ua.ReactCurrentBatchConfig;
function $0e34f6a27473cf61$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0e34f6a27473cf61$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0e34f6a27473cf61$var$Mg = $0e34f6a27473cf61$var$Uf(null), $0e34f6a27473cf61$var$Ng = null, $0e34f6a27473cf61$var$Og = null, $0e34f6a27473cf61$var$Pg = null;
function $0e34f6a27473cf61$var$Qg() {
    $0e34f6a27473cf61$var$Pg = $0e34f6a27473cf61$var$Og = $0e34f6a27473cf61$var$Ng = null;
}
function $0e34f6a27473cf61$var$Rg(a) {
    var b = $0e34f6a27473cf61$var$Mg.current;
    $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$Mg);
    a._currentValue = b;
}
function $0e34f6a27473cf61$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0e34f6a27473cf61$var$Tg(a, b) {
    $0e34f6a27473cf61$var$Ng = a;
    $0e34f6a27473cf61$var$Pg = $0e34f6a27473cf61$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0e34f6a27473cf61$var$Ug = !0), a.firstContext = null);
}
function $0e34f6a27473cf61$var$Vg(a) {
    var b = a._currentValue;
    if ($0e34f6a27473cf61$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0e34f6a27473cf61$var$Og) {
            if (null === $0e34f6a27473cf61$var$Ng) throw Error($0e34f6a27473cf61$var$p(308));
            $0e34f6a27473cf61$var$Og = a;
            $0e34f6a27473cf61$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0e34f6a27473cf61$var$Og = $0e34f6a27473cf61$var$Og.next = a;
    }
    return b;
}
var $0e34f6a27473cf61$var$Wg = null;
function $0e34f6a27473cf61$var$Xg(a) {
    null === $0e34f6a27473cf61$var$Wg ? $0e34f6a27473cf61$var$Wg = [
        a
    ] : $0e34f6a27473cf61$var$Wg.push(a);
}
function $0e34f6a27473cf61$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0e34f6a27473cf61$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0e34f6a27473cf61$var$Zg(a, d);
}
function $0e34f6a27473cf61$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0e34f6a27473cf61$var$$g = !1;
function $0e34f6a27473cf61$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0e34f6a27473cf61$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0e34f6a27473cf61$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0e34f6a27473cf61$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0e34f6a27473cf61$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0e34f6a27473cf61$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0e34f6a27473cf61$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0e34f6a27473cf61$var$Zg(a, c);
}
function $0e34f6a27473cf61$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0e34f6a27473cf61$var$Cc(a, c);
    }
}
function $0e34f6a27473cf61$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0e34f6a27473cf61$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0e34f6a27473cf61$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0e34f6a27473cf61$var$A({}, q, r);
                            break a;
                        case 2:
                            $0e34f6a27473cf61$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0e34f6a27473cf61$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0e34f6a27473cf61$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0e34f6a27473cf61$var$p(191, e));
            e.call(d);
        }
    }
}
var $0e34f6a27473cf61$var$jh = (new $1fELX.Component).refs;
function $0e34f6a27473cf61$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0e34f6a27473cf61$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0e34f6a27473cf61$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0e34f6a27473cf61$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0e34f6a27473cf61$var$L(), e = $0e34f6a27473cf61$var$lh(a), f = $0e34f6a27473cf61$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0e34f6a27473cf61$var$dh(a, f, e);
        null !== b && ($0e34f6a27473cf61$var$mh(b, a, e, d), $0e34f6a27473cf61$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0e34f6a27473cf61$var$L(), e = $0e34f6a27473cf61$var$lh(a), f = $0e34f6a27473cf61$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0e34f6a27473cf61$var$dh(a, f, e);
        null !== b && ($0e34f6a27473cf61$var$mh(b, a, e, d), $0e34f6a27473cf61$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0e34f6a27473cf61$var$L(), d = $0e34f6a27473cf61$var$lh(a), e = $0e34f6a27473cf61$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0e34f6a27473cf61$var$dh(a, e, d);
        null !== b && ($0e34f6a27473cf61$var$mh(b, a, d, c), $0e34f6a27473cf61$var$eh(b, a, d));
    }
};
function $0e34f6a27473cf61$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0e34f6a27473cf61$var$Ie(c, d) || !$0e34f6a27473cf61$var$Ie(e, f) : !0;
}
function $0e34f6a27473cf61$var$ph(a, b, c) {
    var d = !1, e = $0e34f6a27473cf61$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0e34f6a27473cf61$var$Vg(f) : (e = $0e34f6a27473cf61$var$Zf(b) ? $0e34f6a27473cf61$var$Xf : $0e34f6a27473cf61$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0e34f6a27473cf61$var$Yf(a, e) : $0e34f6a27473cf61$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0e34f6a27473cf61$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0e34f6a27473cf61$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0e34f6a27473cf61$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0e34f6a27473cf61$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0e34f6a27473cf61$var$jh;
    $0e34f6a27473cf61$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0e34f6a27473cf61$var$Vg(f) : (f = $0e34f6a27473cf61$var$Zf(b) ? $0e34f6a27473cf61$var$Xf : $0e34f6a27473cf61$var$H.current, e.context = $0e34f6a27473cf61$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0e34f6a27473cf61$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0e34f6a27473cf61$var$nh.enqueueReplaceState(e, e.state, null), $0e34f6a27473cf61$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0e34f6a27473cf61$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0e34f6a27473cf61$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0e34f6a27473cf61$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0e34f6a27473cf61$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0e34f6a27473cf61$var$p(284));
        if (!c._owner) throw Error($0e34f6a27473cf61$var$p(290, a));
    }
    return a;
}
function $0e34f6a27473cf61$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0e34f6a27473cf61$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0e34f6a27473cf61$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0e34f6a27473cf61$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0e34f6a27473cf61$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0e34f6a27473cf61$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0e34f6a27473cf61$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0e34f6a27473cf61$var$Ha && $0e34f6a27473cf61$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0e34f6a27473cf61$var$sh(a, b, c), d.return = a, d;
        d = $0e34f6a27473cf61$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0e34f6a27473cf61$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0e34f6a27473cf61$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0e34f6a27473cf61$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0e34f6a27473cf61$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0e34f6a27473cf61$var$va:
                    return c = $0e34f6a27473cf61$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0e34f6a27473cf61$var$sh(a, null, b), c.return = a, c;
                case $0e34f6a27473cf61$var$wa:
                    return b = $0e34f6a27473cf61$var$zh(b, a.mode, c), b.return = a, b;
                case $0e34f6a27473cf61$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0e34f6a27473cf61$var$eb(b) || $0e34f6a27473cf61$var$Ka(b)) return b = $0e34f6a27473cf61$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0e34f6a27473cf61$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0e34f6a27473cf61$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0e34f6a27473cf61$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0e34f6a27473cf61$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0e34f6a27473cf61$var$eb(c) || $0e34f6a27473cf61$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0e34f6a27473cf61$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0e34f6a27473cf61$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0e34f6a27473cf61$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0e34f6a27473cf61$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0e34f6a27473cf61$var$eb(d) || $0e34f6a27473cf61$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0e34f6a27473cf61$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0e34f6a27473cf61$var$I && $0e34f6a27473cf61$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0e34f6a27473cf61$var$I && $0e34f6a27473cf61$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0e34f6a27473cf61$var$I && $0e34f6a27473cf61$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0e34f6a27473cf61$var$Ka(h);
        if ("function" !== typeof l) throw Error($0e34f6a27473cf61$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0e34f6a27473cf61$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0e34f6a27473cf61$var$I && $0e34f6a27473cf61$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0e34f6a27473cf61$var$I && $0e34f6a27473cf61$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0e34f6a27473cf61$var$I && $0e34f6a27473cf61$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0e34f6a27473cf61$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0e34f6a27473cf61$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0e34f6a27473cf61$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0e34f6a27473cf61$var$Ha && $0e34f6a27473cf61$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0e34f6a27473cf61$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0e34f6a27473cf61$var$ya ? (d = $0e34f6a27473cf61$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0e34f6a27473cf61$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0e34f6a27473cf61$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0e34f6a27473cf61$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0e34f6a27473cf61$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0e34f6a27473cf61$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0e34f6a27473cf61$var$eb(f)) return n(a, d, f, h);
            if ($0e34f6a27473cf61$var$Ka(f)) return t(a, d, f, h);
            $0e34f6a27473cf61$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0e34f6a27473cf61$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0e34f6a27473cf61$var$Bh = $0e34f6a27473cf61$var$vh(!0), $0e34f6a27473cf61$var$Ch = $0e34f6a27473cf61$var$vh(!1), $0e34f6a27473cf61$var$Dh = {}, $0e34f6a27473cf61$var$Eh = $0e34f6a27473cf61$var$Uf($0e34f6a27473cf61$var$Dh), $0e34f6a27473cf61$var$Fh = $0e34f6a27473cf61$var$Uf($0e34f6a27473cf61$var$Dh), $0e34f6a27473cf61$var$Gh = $0e34f6a27473cf61$var$Uf($0e34f6a27473cf61$var$Dh);
function $0e34f6a27473cf61$var$Hh(a) {
    if (a === $0e34f6a27473cf61$var$Dh) throw Error($0e34f6a27473cf61$var$p(174));
    return a;
}
function $0e34f6a27473cf61$var$Ih(a, b) {
    $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$Gh, b);
    $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$Fh, a);
    $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$Eh, $0e34f6a27473cf61$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0e34f6a27473cf61$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0e34f6a27473cf61$var$lb(b, a);
    }
    $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$Eh);
    $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$Eh, b);
}
function $0e34f6a27473cf61$var$Jh() {
    $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$Eh);
    $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$Fh);
    $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$Gh);
}
function $0e34f6a27473cf61$var$Kh(a) {
    $0e34f6a27473cf61$var$Hh($0e34f6a27473cf61$var$Gh.current);
    var b = $0e34f6a27473cf61$var$Hh($0e34f6a27473cf61$var$Eh.current);
    var c = $0e34f6a27473cf61$var$lb(b, a.type);
    b !== c && ($0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$Fh, a), $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$Eh, c));
}
function $0e34f6a27473cf61$var$Lh(a) {
    $0e34f6a27473cf61$var$Fh.current === a && ($0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$Eh), $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$Fh));
}
var $0e34f6a27473cf61$var$M = $0e34f6a27473cf61$var$Uf(0);
function $0e34f6a27473cf61$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0e34f6a27473cf61$var$Nh = [];
function $0e34f6a27473cf61$var$Oh() {
    for(var a = 0; a < $0e34f6a27473cf61$var$Nh.length; a++)$0e34f6a27473cf61$var$Nh[a]._workInProgressVersionPrimary = null;
    $0e34f6a27473cf61$var$Nh.length = 0;
}
var $0e34f6a27473cf61$var$Ph = $0e34f6a27473cf61$var$ua.ReactCurrentDispatcher, $0e34f6a27473cf61$var$Qh = $0e34f6a27473cf61$var$ua.ReactCurrentBatchConfig, $0e34f6a27473cf61$var$Rh = 0, $0e34f6a27473cf61$var$N = null, $0e34f6a27473cf61$var$O = null, $0e34f6a27473cf61$var$P = null, $0e34f6a27473cf61$var$Sh = !1, $0e34f6a27473cf61$var$Th = !1, $0e34f6a27473cf61$var$Uh = 0, $0e34f6a27473cf61$var$Vh = 0;
function $0e34f6a27473cf61$var$Q() {
    throw Error($0e34f6a27473cf61$var$p(321));
}
function $0e34f6a27473cf61$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0e34f6a27473cf61$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0e34f6a27473cf61$var$Xh(a, b, c, d, e, f) {
    $0e34f6a27473cf61$var$Rh = f;
    $0e34f6a27473cf61$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0e34f6a27473cf61$var$Ph.current = null === a || null === a.memoizedState ? $0e34f6a27473cf61$var$Yh : $0e34f6a27473cf61$var$Zh;
    a = c(d, e);
    if ($0e34f6a27473cf61$var$Th) {
        f = 0;
        do {
            $0e34f6a27473cf61$var$Th = !1;
            $0e34f6a27473cf61$var$Uh = 0;
            if (25 <= f) throw Error($0e34f6a27473cf61$var$p(301));
            f += 1;
            $0e34f6a27473cf61$var$P = $0e34f6a27473cf61$var$O = null;
            b.updateQueue = null;
            $0e34f6a27473cf61$var$Ph.current = $0e34f6a27473cf61$var$$h;
            a = c(d, e);
        }while ($0e34f6a27473cf61$var$Th);
    }
    $0e34f6a27473cf61$var$Ph.current = $0e34f6a27473cf61$var$ai;
    b = null !== $0e34f6a27473cf61$var$O && null !== $0e34f6a27473cf61$var$O.next;
    $0e34f6a27473cf61$var$Rh = 0;
    $0e34f6a27473cf61$var$P = $0e34f6a27473cf61$var$O = $0e34f6a27473cf61$var$N = null;
    $0e34f6a27473cf61$var$Sh = !1;
    if (b) throw Error($0e34f6a27473cf61$var$p(300));
    return a;
}
function $0e34f6a27473cf61$var$bi() {
    var a = 0 !== $0e34f6a27473cf61$var$Uh;
    $0e34f6a27473cf61$var$Uh = 0;
    return a;
}
function $0e34f6a27473cf61$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0e34f6a27473cf61$var$P ? $0e34f6a27473cf61$var$N.memoizedState = $0e34f6a27473cf61$var$P = a : $0e34f6a27473cf61$var$P = $0e34f6a27473cf61$var$P.next = a;
    return $0e34f6a27473cf61$var$P;
}
function $0e34f6a27473cf61$var$di() {
    if (null === $0e34f6a27473cf61$var$O) {
        var a = $0e34f6a27473cf61$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0e34f6a27473cf61$var$O.next;
    var b = null === $0e34f6a27473cf61$var$P ? $0e34f6a27473cf61$var$N.memoizedState : $0e34f6a27473cf61$var$P.next;
    if (null !== b) $0e34f6a27473cf61$var$P = b, $0e34f6a27473cf61$var$O = a;
    else {
        if (null === a) throw Error($0e34f6a27473cf61$var$p(310));
        $0e34f6a27473cf61$var$O = a;
        a = {
            memoizedState: $0e34f6a27473cf61$var$O.memoizedState,
            baseState: $0e34f6a27473cf61$var$O.baseState,
            baseQueue: $0e34f6a27473cf61$var$O.baseQueue,
            queue: $0e34f6a27473cf61$var$O.queue,
            next: null
        };
        null === $0e34f6a27473cf61$var$P ? $0e34f6a27473cf61$var$N.memoizedState = $0e34f6a27473cf61$var$P = a : $0e34f6a27473cf61$var$P = $0e34f6a27473cf61$var$P.next = a;
    }
    return $0e34f6a27473cf61$var$P;
}
function $0e34f6a27473cf61$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0e34f6a27473cf61$var$fi(a) {
    var b = $0e34f6a27473cf61$var$di(), c = b.queue;
    if (null === c) throw Error($0e34f6a27473cf61$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0e34f6a27473cf61$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0e34f6a27473cf61$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0e34f6a27473cf61$var$N.lanes |= m;
                $0e34f6a27473cf61$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0e34f6a27473cf61$var$He(d, b.memoizedState) || ($0e34f6a27473cf61$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0e34f6a27473cf61$var$N.lanes |= f, $0e34f6a27473cf61$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0e34f6a27473cf61$var$gi(a) {
    var b = $0e34f6a27473cf61$var$di(), c = b.queue;
    if (null === c) throw Error($0e34f6a27473cf61$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0e34f6a27473cf61$var$He(f, b.memoizedState) || ($0e34f6a27473cf61$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0e34f6a27473cf61$var$hi() {}
function $0e34f6a27473cf61$var$ii(a, b) {
    var c = $0e34f6a27473cf61$var$N, d = $0e34f6a27473cf61$var$di(), e = b(), f = !$0e34f6a27473cf61$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0e34f6a27473cf61$var$Ug = !0);
    d = d.queue;
    $0e34f6a27473cf61$var$ji($0e34f6a27473cf61$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0e34f6a27473cf61$var$P && $0e34f6a27473cf61$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0e34f6a27473cf61$var$li(9, $0e34f6a27473cf61$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0e34f6a27473cf61$var$R) throw Error($0e34f6a27473cf61$var$p(349));
        0 !== ($0e34f6a27473cf61$var$Rh & 30) || $0e34f6a27473cf61$var$ni(c, b, e);
    }
    return e;
}
function $0e34f6a27473cf61$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0e34f6a27473cf61$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0e34f6a27473cf61$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0e34f6a27473cf61$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0e34f6a27473cf61$var$oi(b) && $0e34f6a27473cf61$var$pi(a);
}
function $0e34f6a27473cf61$var$ki(a, b, c) {
    return c(function() {
        $0e34f6a27473cf61$var$oi(b) && $0e34f6a27473cf61$var$pi(a);
    });
}
function $0e34f6a27473cf61$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0e34f6a27473cf61$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0e34f6a27473cf61$var$pi(a) {
    var b = $0e34f6a27473cf61$var$Zg(a, 1);
    null !== b && $0e34f6a27473cf61$var$mh(b, a, 1, -1);
}
function $0e34f6a27473cf61$var$qi(a) {
    var b = $0e34f6a27473cf61$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0e34f6a27473cf61$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0e34f6a27473cf61$var$ri.bind(null, $0e34f6a27473cf61$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0e34f6a27473cf61$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0e34f6a27473cf61$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0e34f6a27473cf61$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0e34f6a27473cf61$var$si() {
    return $0e34f6a27473cf61$var$di().memoizedState;
}
function $0e34f6a27473cf61$var$ti(a, b, c, d) {
    var e = $0e34f6a27473cf61$var$ci();
    $0e34f6a27473cf61$var$N.flags |= a;
    e.memoizedState = $0e34f6a27473cf61$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0e34f6a27473cf61$var$ui(a, b, c, d) {
    var e = $0e34f6a27473cf61$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0e34f6a27473cf61$var$O) {
        var g = $0e34f6a27473cf61$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0e34f6a27473cf61$var$Wh(d, g.deps)) {
            e.memoizedState = $0e34f6a27473cf61$var$li(b, c, f, d);
            return;
        }
    }
    $0e34f6a27473cf61$var$N.flags |= a;
    e.memoizedState = $0e34f6a27473cf61$var$li(1 | b, c, f, d);
}
function $0e34f6a27473cf61$var$vi(a, b) {
    return $0e34f6a27473cf61$var$ti(8390656, 8, a, b);
}
function $0e34f6a27473cf61$var$ji(a, b) {
    return $0e34f6a27473cf61$var$ui(2048, 8, a, b);
}
function $0e34f6a27473cf61$var$wi(a, b) {
    return $0e34f6a27473cf61$var$ui(4, 2, a, b);
}
function $0e34f6a27473cf61$var$xi(a, b) {
    return $0e34f6a27473cf61$var$ui(4, 4, a, b);
}
function $0e34f6a27473cf61$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0e34f6a27473cf61$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0e34f6a27473cf61$var$ui(4, 4, $0e34f6a27473cf61$var$yi.bind(null, b, a), c);
}
function $0e34f6a27473cf61$var$Ai() {}
function $0e34f6a27473cf61$var$Bi(a, b) {
    var c = $0e34f6a27473cf61$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0e34f6a27473cf61$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0e34f6a27473cf61$var$Ci(a, b) {
    var c = $0e34f6a27473cf61$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0e34f6a27473cf61$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0e34f6a27473cf61$var$Di(a, b, c) {
    if (0 === ($0e34f6a27473cf61$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0e34f6a27473cf61$var$Ug = !0), a.memoizedState = c;
    $0e34f6a27473cf61$var$He(c, b) || (c = $0e34f6a27473cf61$var$yc(), $0e34f6a27473cf61$var$N.lanes |= c, $0e34f6a27473cf61$var$hh |= c, a.baseState = !0);
    return b;
}
function $0e34f6a27473cf61$var$Ei(a, b) {
    var c = $0e34f6a27473cf61$var$C;
    $0e34f6a27473cf61$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0e34f6a27473cf61$var$Qh.transition;
    $0e34f6a27473cf61$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0e34f6a27473cf61$var$C = c, $0e34f6a27473cf61$var$Qh.transition = d;
    }
}
function $0e34f6a27473cf61$var$Fi() {
    return $0e34f6a27473cf61$var$di().memoizedState;
}
function $0e34f6a27473cf61$var$Gi(a, b, c) {
    var d = $0e34f6a27473cf61$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0e34f6a27473cf61$var$Hi(a)) $0e34f6a27473cf61$var$Ii(b, c);
    else if (c = $0e34f6a27473cf61$var$Yg(a, b, c, d), null !== c) {
        var e = $0e34f6a27473cf61$var$L();
        $0e34f6a27473cf61$var$mh(c, a, d, e);
        $0e34f6a27473cf61$var$Ji(c, b, d);
    }
}
function $0e34f6a27473cf61$var$ri(a, b, c) {
    var d = $0e34f6a27473cf61$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0e34f6a27473cf61$var$Hi(a)) $0e34f6a27473cf61$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0e34f6a27473cf61$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0e34f6a27473cf61$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0e34f6a27473cf61$var$Yg(a, b, e, d);
        null !== c && (e = $0e34f6a27473cf61$var$L(), $0e34f6a27473cf61$var$mh(c, a, d, e), $0e34f6a27473cf61$var$Ji(c, b, d));
    }
}
function $0e34f6a27473cf61$var$Hi(a) {
    var b = a.alternate;
    return a === $0e34f6a27473cf61$var$N || null !== b && b === $0e34f6a27473cf61$var$N;
}
function $0e34f6a27473cf61$var$Ii(a, b) {
    $0e34f6a27473cf61$var$Th = $0e34f6a27473cf61$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0e34f6a27473cf61$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0e34f6a27473cf61$var$Cc(a, c);
    }
}
var $0e34f6a27473cf61$var$ai = {
    readContext: $0e34f6a27473cf61$var$Vg,
    useCallback: $0e34f6a27473cf61$var$Q,
    useContext: $0e34f6a27473cf61$var$Q,
    useEffect: $0e34f6a27473cf61$var$Q,
    useImperativeHandle: $0e34f6a27473cf61$var$Q,
    useInsertionEffect: $0e34f6a27473cf61$var$Q,
    useLayoutEffect: $0e34f6a27473cf61$var$Q,
    useMemo: $0e34f6a27473cf61$var$Q,
    useReducer: $0e34f6a27473cf61$var$Q,
    useRef: $0e34f6a27473cf61$var$Q,
    useState: $0e34f6a27473cf61$var$Q,
    useDebugValue: $0e34f6a27473cf61$var$Q,
    useDeferredValue: $0e34f6a27473cf61$var$Q,
    useTransition: $0e34f6a27473cf61$var$Q,
    useMutableSource: $0e34f6a27473cf61$var$Q,
    useSyncExternalStore: $0e34f6a27473cf61$var$Q,
    useId: $0e34f6a27473cf61$var$Q,
    unstable_isNewReconciler: !1
}, $0e34f6a27473cf61$var$Yh = {
    readContext: $0e34f6a27473cf61$var$Vg,
    useCallback: function(a, b) {
        $0e34f6a27473cf61$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0e34f6a27473cf61$var$Vg,
    useEffect: $0e34f6a27473cf61$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0e34f6a27473cf61$var$ti(4194308, 4, $0e34f6a27473cf61$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0e34f6a27473cf61$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0e34f6a27473cf61$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0e34f6a27473cf61$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0e34f6a27473cf61$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0e34f6a27473cf61$var$Gi.bind(null, $0e34f6a27473cf61$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0e34f6a27473cf61$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0e34f6a27473cf61$var$qi,
    useDebugValue: $0e34f6a27473cf61$var$Ai,
    useDeferredValue: function(a) {
        return $0e34f6a27473cf61$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0e34f6a27473cf61$var$qi(!1), b = a[0];
        a = $0e34f6a27473cf61$var$Ei.bind(null, a[1]);
        $0e34f6a27473cf61$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0e34f6a27473cf61$var$N, e = $0e34f6a27473cf61$var$ci();
        if ($0e34f6a27473cf61$var$I) {
            if (void 0 === c) throw Error($0e34f6a27473cf61$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0e34f6a27473cf61$var$R) throw Error($0e34f6a27473cf61$var$p(349));
            0 !== ($0e34f6a27473cf61$var$Rh & 30) || $0e34f6a27473cf61$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0e34f6a27473cf61$var$vi($0e34f6a27473cf61$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0e34f6a27473cf61$var$li(9, $0e34f6a27473cf61$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0e34f6a27473cf61$var$ci(), b = $0e34f6a27473cf61$var$R.identifierPrefix;
        if ($0e34f6a27473cf61$var$I) {
            var c = $0e34f6a27473cf61$var$sg;
            var d = $0e34f6a27473cf61$var$rg;
            c = (d & ~(1 << 32 - $0e34f6a27473cf61$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0e34f6a27473cf61$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0e34f6a27473cf61$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0e34f6a27473cf61$var$Zh = {
    readContext: $0e34f6a27473cf61$var$Vg,
    useCallback: $0e34f6a27473cf61$var$Bi,
    useContext: $0e34f6a27473cf61$var$Vg,
    useEffect: $0e34f6a27473cf61$var$ji,
    useImperativeHandle: $0e34f6a27473cf61$var$zi,
    useInsertionEffect: $0e34f6a27473cf61$var$wi,
    useLayoutEffect: $0e34f6a27473cf61$var$xi,
    useMemo: $0e34f6a27473cf61$var$Ci,
    useReducer: $0e34f6a27473cf61$var$fi,
    useRef: $0e34f6a27473cf61$var$si,
    useState: function() {
        return $0e34f6a27473cf61$var$fi($0e34f6a27473cf61$var$ei);
    },
    useDebugValue: $0e34f6a27473cf61$var$Ai,
    useDeferredValue: function(a) {
        var b = $0e34f6a27473cf61$var$di();
        return $0e34f6a27473cf61$var$Di(b, $0e34f6a27473cf61$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0e34f6a27473cf61$var$fi($0e34f6a27473cf61$var$ei)[0], b = $0e34f6a27473cf61$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0e34f6a27473cf61$var$hi,
    useSyncExternalStore: $0e34f6a27473cf61$var$ii,
    useId: $0e34f6a27473cf61$var$Fi,
    unstable_isNewReconciler: !1
}, $0e34f6a27473cf61$var$$h = {
    readContext: $0e34f6a27473cf61$var$Vg,
    useCallback: $0e34f6a27473cf61$var$Bi,
    useContext: $0e34f6a27473cf61$var$Vg,
    useEffect: $0e34f6a27473cf61$var$ji,
    useImperativeHandle: $0e34f6a27473cf61$var$zi,
    useInsertionEffect: $0e34f6a27473cf61$var$wi,
    useLayoutEffect: $0e34f6a27473cf61$var$xi,
    useMemo: $0e34f6a27473cf61$var$Ci,
    useReducer: $0e34f6a27473cf61$var$gi,
    useRef: $0e34f6a27473cf61$var$si,
    useState: function() {
        return $0e34f6a27473cf61$var$gi($0e34f6a27473cf61$var$ei);
    },
    useDebugValue: $0e34f6a27473cf61$var$Ai,
    useDeferredValue: function(a) {
        var b = $0e34f6a27473cf61$var$di();
        return null === $0e34f6a27473cf61$var$O ? b.memoizedState = a : $0e34f6a27473cf61$var$Di(b, $0e34f6a27473cf61$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0e34f6a27473cf61$var$gi($0e34f6a27473cf61$var$ei)[0], b = $0e34f6a27473cf61$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0e34f6a27473cf61$var$hi,
    useSyncExternalStore: $0e34f6a27473cf61$var$ii,
    useId: $0e34f6a27473cf61$var$Fi,
    unstable_isNewReconciler: !1
};
function $0e34f6a27473cf61$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0e34f6a27473cf61$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0e34f6a27473cf61$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0e34f6a27473cf61$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0e34f6a27473cf61$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0e34f6a27473cf61$var$Oi(a, b, c) {
    c = $0e34f6a27473cf61$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0e34f6a27473cf61$var$Pi || ($0e34f6a27473cf61$var$Pi = !0, $0e34f6a27473cf61$var$Qi = d);
        $0e34f6a27473cf61$var$Mi(a, b);
    };
    return c;
}
function $0e34f6a27473cf61$var$Ri(a, b, c) {
    c = $0e34f6a27473cf61$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0e34f6a27473cf61$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0e34f6a27473cf61$var$Mi(a, b);
        "function" !== typeof d && (null === $0e34f6a27473cf61$var$Si ? $0e34f6a27473cf61$var$Si = new Set([
            this
        ]) : $0e34f6a27473cf61$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0e34f6a27473cf61$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0e34f6a27473cf61$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0e34f6a27473cf61$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0e34f6a27473cf61$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0e34f6a27473cf61$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0e34f6a27473cf61$var$ch(-1, 1), b.tag = 2, $0e34f6a27473cf61$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0e34f6a27473cf61$var$Xi = $0e34f6a27473cf61$var$ua.ReactCurrentOwner, $0e34f6a27473cf61$var$Ug = !1;
function $0e34f6a27473cf61$var$Yi(a, b, c, d) {
    b.child = null === a ? $0e34f6a27473cf61$var$Ch(b, null, c, d) : $0e34f6a27473cf61$var$Bh(b, a.child, c, d);
}
function $0e34f6a27473cf61$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0e34f6a27473cf61$var$Tg(b, e);
    d = $0e34f6a27473cf61$var$Xh(a, b, c, d, f, e);
    c = $0e34f6a27473cf61$var$bi();
    if (null !== a && !$0e34f6a27473cf61$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0e34f6a27473cf61$var$$i(a, b, e);
    $0e34f6a27473cf61$var$I && c && $0e34f6a27473cf61$var$vg(b);
    b.flags |= 1;
    $0e34f6a27473cf61$var$Yi(a, b, d, e);
    return b.child;
}
function $0e34f6a27473cf61$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0e34f6a27473cf61$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0e34f6a27473cf61$var$cj(a, b, f, d, e);
        a = $0e34f6a27473cf61$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0e34f6a27473cf61$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0e34f6a27473cf61$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0e34f6a27473cf61$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0e34f6a27473cf61$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0e34f6a27473cf61$var$Ie(f, d) && a.ref === b.ref) {
            if ($0e34f6a27473cf61$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0e34f6a27473cf61$var$Ug = !0);
            else return b.lanes = a.lanes, $0e34f6a27473cf61$var$$i(a, b, e);
        }
    }
    return $0e34f6a27473cf61$var$dj(a, b, c, d, e);
}
function $0e34f6a27473cf61$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$fj, $0e34f6a27473cf61$var$gj), $0e34f6a27473cf61$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$fj, $0e34f6a27473cf61$var$gj), $0e34f6a27473cf61$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$fj, $0e34f6a27473cf61$var$gj);
            $0e34f6a27473cf61$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$fj, $0e34f6a27473cf61$var$gj), $0e34f6a27473cf61$var$gj |= d;
    $0e34f6a27473cf61$var$Yi(a, b, e, c);
    return b.child;
}
function $0e34f6a27473cf61$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0e34f6a27473cf61$var$dj(a, b, c, d, e) {
    var f = $0e34f6a27473cf61$var$Zf(c) ? $0e34f6a27473cf61$var$Xf : $0e34f6a27473cf61$var$H.current;
    f = $0e34f6a27473cf61$var$Yf(b, f);
    $0e34f6a27473cf61$var$Tg(b, e);
    c = $0e34f6a27473cf61$var$Xh(a, b, c, d, f, e);
    d = $0e34f6a27473cf61$var$bi();
    if (null !== a && !$0e34f6a27473cf61$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0e34f6a27473cf61$var$$i(a, b, e);
    $0e34f6a27473cf61$var$I && d && $0e34f6a27473cf61$var$vg(b);
    b.flags |= 1;
    $0e34f6a27473cf61$var$Yi(a, b, c, e);
    return b.child;
}
function $0e34f6a27473cf61$var$ij(a, b, c, d, e) {
    if ($0e34f6a27473cf61$var$Zf(c)) {
        var f = !0;
        $0e34f6a27473cf61$var$cg(b);
    } else f = !1;
    $0e34f6a27473cf61$var$Tg(b, e);
    if (null === b.stateNode) $0e34f6a27473cf61$var$jj(a, b), $0e34f6a27473cf61$var$ph(b, c, d), $0e34f6a27473cf61$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0e34f6a27473cf61$var$Vg(l) : (l = $0e34f6a27473cf61$var$Zf(c) ? $0e34f6a27473cf61$var$Xf : $0e34f6a27473cf61$var$H.current, l = $0e34f6a27473cf61$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0e34f6a27473cf61$var$qh(b, g, d, l);
        $0e34f6a27473cf61$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0e34f6a27473cf61$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0e34f6a27473cf61$var$Wf.current || $0e34f6a27473cf61$var$$g ? ("function" === typeof m && ($0e34f6a27473cf61$var$kh(b, c, m, d), k = b.memoizedState), (h = $0e34f6a27473cf61$var$$g || $0e34f6a27473cf61$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0e34f6a27473cf61$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0e34f6a27473cf61$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0e34f6a27473cf61$var$Vg(k) : (k = $0e34f6a27473cf61$var$Zf(c) ? $0e34f6a27473cf61$var$Xf : $0e34f6a27473cf61$var$H.current, k = $0e34f6a27473cf61$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0e34f6a27473cf61$var$qh(b, g, d, k);
        $0e34f6a27473cf61$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0e34f6a27473cf61$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0e34f6a27473cf61$var$Wf.current || $0e34f6a27473cf61$var$$g ? ("function" === typeof y && ($0e34f6a27473cf61$var$kh(b, c, y, d), n = b.memoizedState), (l = $0e34f6a27473cf61$var$$g || $0e34f6a27473cf61$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0e34f6a27473cf61$var$kj(a, b, c, d, f, e);
}
function $0e34f6a27473cf61$var$kj(a, b, c, d, e, f) {
    $0e34f6a27473cf61$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0e34f6a27473cf61$var$dg(b, c, !1), $0e34f6a27473cf61$var$$i(a, b, f);
    d = b.stateNode;
    $0e34f6a27473cf61$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0e34f6a27473cf61$var$Bh(b, a.child, null, f), b.child = $0e34f6a27473cf61$var$Bh(b, null, h, f)) : $0e34f6a27473cf61$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0e34f6a27473cf61$var$dg(b, c, !0);
    return b.child;
}
function $0e34f6a27473cf61$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0e34f6a27473cf61$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0e34f6a27473cf61$var$ag(a, b.context, !1);
    $0e34f6a27473cf61$var$Ih(a, b.containerInfo);
}
function $0e34f6a27473cf61$var$mj(a, b, c, d, e) {
    $0e34f6a27473cf61$var$Ig();
    $0e34f6a27473cf61$var$Jg(e);
    b.flags |= 256;
    $0e34f6a27473cf61$var$Yi(a, b, c, d);
    return b.child;
}
var $0e34f6a27473cf61$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0e34f6a27473cf61$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0e34f6a27473cf61$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0e34f6a27473cf61$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$M, e & 1);
    if (null === a) {
        $0e34f6a27473cf61$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0e34f6a27473cf61$var$qj(g, d, 0, null), a = $0e34f6a27473cf61$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0e34f6a27473cf61$var$oj(c), b.memoizedState = $0e34f6a27473cf61$var$nj, a) : $0e34f6a27473cf61$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0e34f6a27473cf61$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0e34f6a27473cf61$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0e34f6a27473cf61$var$wh(h, f) : (f = $0e34f6a27473cf61$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0e34f6a27473cf61$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0e34f6a27473cf61$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0e34f6a27473cf61$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0e34f6a27473cf61$var$rj(a, b) {
    b = $0e34f6a27473cf61$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0e34f6a27473cf61$var$tj(a, b, c, d) {
    null !== d && $0e34f6a27473cf61$var$Jg(d);
    $0e34f6a27473cf61$var$Bh(b, a.child, null, c);
    a = $0e34f6a27473cf61$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0e34f6a27473cf61$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0e34f6a27473cf61$var$Li(Error($0e34f6a27473cf61$var$p(422))), $0e34f6a27473cf61$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0e34f6a27473cf61$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0e34f6a27473cf61$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0e34f6a27473cf61$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0e34f6a27473cf61$var$oj(g);
        b.memoizedState = $0e34f6a27473cf61$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0e34f6a27473cf61$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0e34f6a27473cf61$var$p(419));
        d = $0e34f6a27473cf61$var$Li(f, d, void 0);
        return $0e34f6a27473cf61$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0e34f6a27473cf61$var$Ug || h) {
        d = $0e34f6a27473cf61$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0e34f6a27473cf61$var$Zg(a, e), $0e34f6a27473cf61$var$mh(d, a, e, -1));
        }
        $0e34f6a27473cf61$var$uj();
        d = $0e34f6a27473cf61$var$Li(Error($0e34f6a27473cf61$var$p(421)));
        return $0e34f6a27473cf61$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0e34f6a27473cf61$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0e34f6a27473cf61$var$yg = $0e34f6a27473cf61$var$Lf(e.nextSibling);
    $0e34f6a27473cf61$var$xg = b;
    $0e34f6a27473cf61$var$I = !0;
    $0e34f6a27473cf61$var$zg = null;
    null !== a && ($0e34f6a27473cf61$var$og[$0e34f6a27473cf61$var$pg++] = $0e34f6a27473cf61$var$rg, $0e34f6a27473cf61$var$og[$0e34f6a27473cf61$var$pg++] = $0e34f6a27473cf61$var$sg, $0e34f6a27473cf61$var$og[$0e34f6a27473cf61$var$pg++] = $0e34f6a27473cf61$var$qg, $0e34f6a27473cf61$var$rg = a.id, $0e34f6a27473cf61$var$sg = a.overflow, $0e34f6a27473cf61$var$qg = b);
    b = $0e34f6a27473cf61$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0e34f6a27473cf61$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0e34f6a27473cf61$var$Sg(a.return, b, c);
}
function $0e34f6a27473cf61$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0e34f6a27473cf61$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0e34f6a27473cf61$var$Yi(a, b, d.children, c);
    d = $0e34f6a27473cf61$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0e34f6a27473cf61$var$wj(a, c, b);
            else if (19 === a.tag) $0e34f6a27473cf61$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0e34f6a27473cf61$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0e34f6a27473cf61$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0e34f6a27473cf61$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0e34f6a27473cf61$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0e34f6a27473cf61$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0e34f6a27473cf61$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0e34f6a27473cf61$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0e34f6a27473cf61$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0e34f6a27473cf61$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0e34f6a27473cf61$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0e34f6a27473cf61$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0e34f6a27473cf61$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0e34f6a27473cf61$var$lj(b);
            $0e34f6a27473cf61$var$Ig();
            break;
        case 5:
            $0e34f6a27473cf61$var$Kh(b);
            break;
        case 1:
            $0e34f6a27473cf61$var$Zf(b.type) && $0e34f6a27473cf61$var$cg(b);
            break;
        case 4:
            $0e34f6a27473cf61$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$M, $0e34f6a27473cf61$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0e34f6a27473cf61$var$pj(a, b, c);
                $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$M, $0e34f6a27473cf61$var$M.current & 1);
                a = $0e34f6a27473cf61$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$M, $0e34f6a27473cf61$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0e34f6a27473cf61$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$M, $0e34f6a27473cf61$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0e34f6a27473cf61$var$ej(a, b, c);
    }
    return $0e34f6a27473cf61$var$$i(a, b, c);
}
var $0e34f6a27473cf61$var$Aj, $0e34f6a27473cf61$var$Bj, $0e34f6a27473cf61$var$Cj, $0e34f6a27473cf61$var$Dj;
$0e34f6a27473cf61$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0e34f6a27473cf61$var$Bj = function() {};
$0e34f6a27473cf61$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0e34f6a27473cf61$var$Hh($0e34f6a27473cf61$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0e34f6a27473cf61$var$Ya(a, e);
                d = $0e34f6a27473cf61$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0e34f6a27473cf61$var$A({}, e, {
                    value: void 0
                });
                d = $0e34f6a27473cf61$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0e34f6a27473cf61$var$gb(a, e);
                d = $0e34f6a27473cf61$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0e34f6a27473cf61$var$Bf);
        }
        $0e34f6a27473cf61$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0e34f6a27473cf61$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0e34f6a27473cf61$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0e34f6a27473cf61$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0e34f6a27473cf61$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0e34f6a27473cf61$var$Ej(a, b) {
    if (!$0e34f6a27473cf61$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0e34f6a27473cf61$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0e34f6a27473cf61$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0e34f6a27473cf61$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0e34f6a27473cf61$var$S(b), null;
        case 1:
            return $0e34f6a27473cf61$var$Zf(b.type) && $0e34f6a27473cf61$var$$f(), $0e34f6a27473cf61$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0e34f6a27473cf61$var$Jh();
            $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$Wf);
            $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$H);
            $0e34f6a27473cf61$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0e34f6a27473cf61$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0e34f6a27473cf61$var$zg && ($0e34f6a27473cf61$var$Gj($0e34f6a27473cf61$var$zg), $0e34f6a27473cf61$var$zg = null));
            $0e34f6a27473cf61$var$Bj(a, b);
            $0e34f6a27473cf61$var$S(b);
            return null;
        case 5:
            $0e34f6a27473cf61$var$Lh(b);
            var e = $0e34f6a27473cf61$var$Hh($0e34f6a27473cf61$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0e34f6a27473cf61$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0e34f6a27473cf61$var$p(166));
                    $0e34f6a27473cf61$var$S(b);
                    return null;
                }
                a = $0e34f6a27473cf61$var$Hh($0e34f6a27473cf61$var$Eh.current);
                if ($0e34f6a27473cf61$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0e34f6a27473cf61$var$Of] = b;
                    d[$0e34f6a27473cf61$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0e34f6a27473cf61$var$D("cancel", d);
                            $0e34f6a27473cf61$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0e34f6a27473cf61$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0e34f6a27473cf61$var$lf.length; e++)$0e34f6a27473cf61$var$D($0e34f6a27473cf61$var$lf[e], d);
                            break;
                        case "source":
                            $0e34f6a27473cf61$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0e34f6a27473cf61$var$D("error", d);
                            $0e34f6a27473cf61$var$D("load", d);
                            break;
                        case "details":
                            $0e34f6a27473cf61$var$D("toggle", d);
                            break;
                        case "input":
                            $0e34f6a27473cf61$var$Za(d, f);
                            $0e34f6a27473cf61$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0e34f6a27473cf61$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0e34f6a27473cf61$var$hb(d, f), $0e34f6a27473cf61$var$D("invalid", d);
                    }
                    $0e34f6a27473cf61$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0e34f6a27473cf61$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0e34f6a27473cf61$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0e34f6a27473cf61$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0e34f6a27473cf61$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0e34f6a27473cf61$var$Va(d);
                            $0e34f6a27473cf61$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0e34f6a27473cf61$var$Va(d);
                            $0e34f6a27473cf61$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0e34f6a27473cf61$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0e34f6a27473cf61$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0e34f6a27473cf61$var$Of] = b;
                    a[$0e34f6a27473cf61$var$Pf] = d;
                    $0e34f6a27473cf61$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0e34f6a27473cf61$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0e34f6a27473cf61$var$D("cancel", a);
                                $0e34f6a27473cf61$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0e34f6a27473cf61$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0e34f6a27473cf61$var$lf.length; e++)$0e34f6a27473cf61$var$D($0e34f6a27473cf61$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0e34f6a27473cf61$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0e34f6a27473cf61$var$D("error", a);
                                $0e34f6a27473cf61$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0e34f6a27473cf61$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0e34f6a27473cf61$var$Za(a, d);
                                e = $0e34f6a27473cf61$var$Ya(a, d);
                                $0e34f6a27473cf61$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0e34f6a27473cf61$var$A({}, d, {
                                    value: void 0
                                });
                                $0e34f6a27473cf61$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0e34f6a27473cf61$var$hb(a, d);
                                e = $0e34f6a27473cf61$var$gb(a, d);
                                $0e34f6a27473cf61$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0e34f6a27473cf61$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0e34f6a27473cf61$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0e34f6a27473cf61$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0e34f6a27473cf61$var$ob(a, k) : "number" === typeof k && $0e34f6a27473cf61$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0e34f6a27473cf61$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0e34f6a27473cf61$var$D("scroll", a) : null != k && $0e34f6a27473cf61$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0e34f6a27473cf61$var$Va(a);
                                $0e34f6a27473cf61$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0e34f6a27473cf61$var$Va(a);
                                $0e34f6a27473cf61$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0e34f6a27473cf61$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0e34f6a27473cf61$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0e34f6a27473cf61$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0e34f6a27473cf61$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0e34f6a27473cf61$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0e34f6a27473cf61$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0e34f6a27473cf61$var$p(166));
                c = $0e34f6a27473cf61$var$Hh($0e34f6a27473cf61$var$Gh.current);
                $0e34f6a27473cf61$var$Hh($0e34f6a27473cf61$var$Eh.current);
                if ($0e34f6a27473cf61$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0e34f6a27473cf61$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0e34f6a27473cf61$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0e34f6a27473cf61$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0e34f6a27473cf61$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0e34f6a27473cf61$var$Of] = b, b.stateNode = d;
            }
            $0e34f6a27473cf61$var$S(b);
            return null;
        case 13:
            $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0e34f6a27473cf61$var$I && null !== $0e34f6a27473cf61$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0e34f6a27473cf61$var$Hg(), $0e34f6a27473cf61$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0e34f6a27473cf61$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0e34f6a27473cf61$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0e34f6a27473cf61$var$p(317));
                        f[$0e34f6a27473cf61$var$Of] = b;
                    } else $0e34f6a27473cf61$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0e34f6a27473cf61$var$S(b);
                    f = !1;
                } else null !== $0e34f6a27473cf61$var$zg && ($0e34f6a27473cf61$var$Gj($0e34f6a27473cf61$var$zg), $0e34f6a27473cf61$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0e34f6a27473cf61$var$M.current & 1) ? 0 === $0e34f6a27473cf61$var$T && ($0e34f6a27473cf61$var$T = 3) : $0e34f6a27473cf61$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0e34f6a27473cf61$var$S(b);
            return null;
        case 4:
            return $0e34f6a27473cf61$var$Jh(), $0e34f6a27473cf61$var$Bj(a, b), null === a && $0e34f6a27473cf61$var$sf(b.stateNode.containerInfo), $0e34f6a27473cf61$var$S(b), null;
        case 10:
            return $0e34f6a27473cf61$var$Rg(b.type._context), $0e34f6a27473cf61$var$S(b), null;
        case 17:
            return $0e34f6a27473cf61$var$Zf(b.type) && $0e34f6a27473cf61$var$$f(), $0e34f6a27473cf61$var$S(b), null;
        case 19:
            $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$M);
            f = b.memoizedState;
            if (null === f) return $0e34f6a27473cf61$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0e34f6a27473cf61$var$Ej(f, !1);
                else {
                    if (0 !== $0e34f6a27473cf61$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0e34f6a27473cf61$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0e34f6a27473cf61$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$M, $0e34f6a27473cf61$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0e34f6a27473cf61$var$B() > $0e34f6a27473cf61$var$Hj && (b.flags |= 128, d = !0, $0e34f6a27473cf61$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0e34f6a27473cf61$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0e34f6a27473cf61$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0e34f6a27473cf61$var$I) return $0e34f6a27473cf61$var$S(b), null;
                    } else 2 * $0e34f6a27473cf61$var$B() - f.renderingStartTime > $0e34f6a27473cf61$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0e34f6a27473cf61$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0e34f6a27473cf61$var$B(), b.sibling = null, c = $0e34f6a27473cf61$var$M.current, $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$M, d ? c & 1 | 2 : c & 1), b;
            $0e34f6a27473cf61$var$S(b);
            return null;
        case 22:
        case 23:
            return $0e34f6a27473cf61$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0e34f6a27473cf61$var$gj & 1073741824) && ($0e34f6a27473cf61$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0e34f6a27473cf61$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0e34f6a27473cf61$var$p(156, b.tag));
}
function $0e34f6a27473cf61$var$Jj(a, b) {
    $0e34f6a27473cf61$var$wg(b);
    switch(b.tag){
        case 1:
            return $0e34f6a27473cf61$var$Zf(b.type) && $0e34f6a27473cf61$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0e34f6a27473cf61$var$Jh(), $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$Wf), $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$H), $0e34f6a27473cf61$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0e34f6a27473cf61$var$Lh(b), null;
        case 13:
            $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0e34f6a27473cf61$var$p(340));
                $0e34f6a27473cf61$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$M), null;
        case 4:
            return $0e34f6a27473cf61$var$Jh(), null;
        case 10:
            return $0e34f6a27473cf61$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0e34f6a27473cf61$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0e34f6a27473cf61$var$Kj = !1, $0e34f6a27473cf61$var$U = !1, $0e34f6a27473cf61$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0e34f6a27473cf61$var$V = null;
function $0e34f6a27473cf61$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0e34f6a27473cf61$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0e34f6a27473cf61$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0e34f6a27473cf61$var$W(a, b, d);
    }
}
var $0e34f6a27473cf61$var$Oj = !1;
function $0e34f6a27473cf61$var$Pj(a, b) {
    $0e34f6a27473cf61$var$Cf = $0e34f6a27473cf61$var$dd;
    a = $0e34f6a27473cf61$var$Me();
    if ($0e34f6a27473cf61$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0e34f6a27473cf61$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0e34f6a27473cf61$var$dd = !1;
    for($0e34f6a27473cf61$var$V = b; null !== $0e34f6a27473cf61$var$V;)if (b = $0e34f6a27473cf61$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0e34f6a27473cf61$var$V = a;
    else for(; null !== $0e34f6a27473cf61$var$V;){
        b = $0e34f6a27473cf61$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0e34f6a27473cf61$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0e34f6a27473cf61$var$p(163));
            }
        } catch (F) {
            $0e34f6a27473cf61$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0e34f6a27473cf61$var$V = a;
            break;
        }
        $0e34f6a27473cf61$var$V = b.return;
    }
    n = $0e34f6a27473cf61$var$Oj;
    $0e34f6a27473cf61$var$Oj = !1;
    return n;
}
function $0e34f6a27473cf61$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0e34f6a27473cf61$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0e34f6a27473cf61$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0e34f6a27473cf61$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0e34f6a27473cf61$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0e34f6a27473cf61$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0e34f6a27473cf61$var$Of], delete b[$0e34f6a27473cf61$var$Pf], delete b[$0e34f6a27473cf61$var$of], delete b[$0e34f6a27473cf61$var$Qf], delete b[$0e34f6a27473cf61$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0e34f6a27473cf61$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0e34f6a27473cf61$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0e34f6a27473cf61$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0e34f6a27473cf61$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0e34f6a27473cf61$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0e34f6a27473cf61$var$Wj(a, b, c), a = a.sibling; null !== a;)$0e34f6a27473cf61$var$Wj(a, b, c), a = a.sibling;
}
function $0e34f6a27473cf61$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0e34f6a27473cf61$var$Xj(a, b, c), a = a.sibling; null !== a;)$0e34f6a27473cf61$var$Xj(a, b, c), a = a.sibling;
}
var $0e34f6a27473cf61$var$X = null, $0e34f6a27473cf61$var$Yj = !1;
function $0e34f6a27473cf61$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0e34f6a27473cf61$var$ak(a, b, c), c = c.sibling;
}
function $0e34f6a27473cf61$var$ak(a, b, c) {
    if ($0e34f6a27473cf61$var$lc && "function" === typeof $0e34f6a27473cf61$var$lc.onCommitFiberUnmount) try {
        $0e34f6a27473cf61$var$lc.onCommitFiberUnmount($0e34f6a27473cf61$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0e34f6a27473cf61$var$U || $0e34f6a27473cf61$var$Mj(c, b);
        case 6:
            var d = $0e34f6a27473cf61$var$X, e = $0e34f6a27473cf61$var$Yj;
            $0e34f6a27473cf61$var$X = null;
            $0e34f6a27473cf61$var$Zj(a, b, c);
            $0e34f6a27473cf61$var$X = d;
            $0e34f6a27473cf61$var$Yj = e;
            null !== $0e34f6a27473cf61$var$X && ($0e34f6a27473cf61$var$Yj ? (a = $0e34f6a27473cf61$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0e34f6a27473cf61$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0e34f6a27473cf61$var$X && ($0e34f6a27473cf61$var$Yj ? (a = $0e34f6a27473cf61$var$X, c = c.stateNode, 8 === a.nodeType ? $0e34f6a27473cf61$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0e34f6a27473cf61$var$Kf(a, c), $0e34f6a27473cf61$var$bd(a)) : $0e34f6a27473cf61$var$Kf($0e34f6a27473cf61$var$X, c.stateNode));
            break;
        case 4:
            d = $0e34f6a27473cf61$var$X;
            e = $0e34f6a27473cf61$var$Yj;
            $0e34f6a27473cf61$var$X = c.stateNode.containerInfo;
            $0e34f6a27473cf61$var$Yj = !0;
            $0e34f6a27473cf61$var$Zj(a, b, c);
            $0e34f6a27473cf61$var$X = d;
            $0e34f6a27473cf61$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0e34f6a27473cf61$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0e34f6a27473cf61$var$Nj(c, b, g) : 0 !== (f & 4) && $0e34f6a27473cf61$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0e34f6a27473cf61$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0e34f6a27473cf61$var$U && ($0e34f6a27473cf61$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0e34f6a27473cf61$var$W(c, b, h);
            }
            $0e34f6a27473cf61$var$Zj(a, b, c);
            break;
        case 21:
            $0e34f6a27473cf61$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0e34f6a27473cf61$var$U = (d = $0e34f6a27473cf61$var$U) || null !== c.memoizedState, $0e34f6a27473cf61$var$Zj(a, b, c), $0e34f6a27473cf61$var$U = d) : $0e34f6a27473cf61$var$Zj(a, b, c);
            break;
        default:
            $0e34f6a27473cf61$var$Zj(a, b, c);
    }
}
function $0e34f6a27473cf61$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0e34f6a27473cf61$var$Lj);
        b.forEach(function(b) {
            var d = $0e34f6a27473cf61$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0e34f6a27473cf61$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0e34f6a27473cf61$var$X = h.stateNode;
                        $0e34f6a27473cf61$var$Yj = !1;
                        break a;
                    case 3:
                        $0e34f6a27473cf61$var$X = h.stateNode.containerInfo;
                        $0e34f6a27473cf61$var$Yj = !0;
                        break a;
                    case 4:
                        $0e34f6a27473cf61$var$X = h.stateNode.containerInfo;
                        $0e34f6a27473cf61$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0e34f6a27473cf61$var$X) throw Error($0e34f6a27473cf61$var$p(160));
            $0e34f6a27473cf61$var$ak(f, g, e);
            $0e34f6a27473cf61$var$X = null;
            $0e34f6a27473cf61$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0e34f6a27473cf61$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0e34f6a27473cf61$var$ek(b, a), b = b.sibling;
}
function $0e34f6a27473cf61$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0e34f6a27473cf61$var$dk(b, a);
            $0e34f6a27473cf61$var$fk(a);
            if (d & 4) {
                try {
                    $0e34f6a27473cf61$var$Qj(3, a, a.return), $0e34f6a27473cf61$var$Rj(3, a);
                } catch (t) {
                    $0e34f6a27473cf61$var$W(a, a.return, t);
                }
                try {
                    $0e34f6a27473cf61$var$Qj(5, a, a.return);
                } catch (t) {
                    $0e34f6a27473cf61$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0e34f6a27473cf61$var$dk(b, a);
            $0e34f6a27473cf61$var$fk(a);
            d & 512 && null !== c && $0e34f6a27473cf61$var$Mj(c, c.return);
            break;
        case 5:
            $0e34f6a27473cf61$var$dk(b, a);
            $0e34f6a27473cf61$var$fk(a);
            d & 512 && null !== c && $0e34f6a27473cf61$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0e34f6a27473cf61$var$ob(e, "");
                } catch (t) {
                    $0e34f6a27473cf61$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0e34f6a27473cf61$var$ab(e, f);
                    $0e34f6a27473cf61$var$vb(h, g);
                    var l = $0e34f6a27473cf61$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0e34f6a27473cf61$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0e34f6a27473cf61$var$nb(e, q) : "children" === m ? $0e34f6a27473cf61$var$ob(e, q) : $0e34f6a27473cf61$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0e34f6a27473cf61$var$bb(e, f);
                            break;
                        case "textarea":
                            $0e34f6a27473cf61$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0e34f6a27473cf61$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0e34f6a27473cf61$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0e34f6a27473cf61$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0e34f6a27473cf61$var$Pf] = f;
                } catch (t) {
                    $0e34f6a27473cf61$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0e34f6a27473cf61$var$dk(b, a);
            $0e34f6a27473cf61$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0e34f6a27473cf61$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0e34f6a27473cf61$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0e34f6a27473cf61$var$dk(b, a);
            $0e34f6a27473cf61$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0e34f6a27473cf61$var$bd(b.containerInfo);
            } catch (t) {
                $0e34f6a27473cf61$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0e34f6a27473cf61$var$dk(b, a);
            $0e34f6a27473cf61$var$fk(a);
            break;
        case 13:
            $0e34f6a27473cf61$var$dk(b, a);
            $0e34f6a27473cf61$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0e34f6a27473cf61$var$gk = $0e34f6a27473cf61$var$B()));
            d & 4 && $0e34f6a27473cf61$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0e34f6a27473cf61$var$U = (l = $0e34f6a27473cf61$var$U) || m, $0e34f6a27473cf61$var$dk(b, a), $0e34f6a27473cf61$var$U = l) : $0e34f6a27473cf61$var$dk(b, a);
            $0e34f6a27473cf61$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0e34f6a27473cf61$var$V = a, m = a.child; null !== m;){
                    for(q = $0e34f6a27473cf61$var$V = m; null !== $0e34f6a27473cf61$var$V;){
                        r = $0e34f6a27473cf61$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0e34f6a27473cf61$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0e34f6a27473cf61$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0e34f6a27473cf61$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0e34f6a27473cf61$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0e34f6a27473cf61$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0e34f6a27473cf61$var$V = y) : $0e34f6a27473cf61$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0e34f6a27473cf61$var$rb("display", g));
                            } catch (t) {
                                $0e34f6a27473cf61$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0e34f6a27473cf61$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0e34f6a27473cf61$var$dk(b, a);
            $0e34f6a27473cf61$var$fk(a);
            d & 4 && $0e34f6a27473cf61$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0e34f6a27473cf61$var$dk(b, a), $0e34f6a27473cf61$var$fk(a);
    }
}
function $0e34f6a27473cf61$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0e34f6a27473cf61$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0e34f6a27473cf61$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0e34f6a27473cf61$var$ob(e, ""), d.flags &= -33);
                    var f = $0e34f6a27473cf61$var$Vj(a);
                    $0e34f6a27473cf61$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0e34f6a27473cf61$var$Vj(a);
                    $0e34f6a27473cf61$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0e34f6a27473cf61$var$p(161));
            }
        } catch (k) {
            $0e34f6a27473cf61$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0e34f6a27473cf61$var$ik(a, b, c) {
    $0e34f6a27473cf61$var$V = a;
    $0e34f6a27473cf61$var$jk(a, b, c);
}
function $0e34f6a27473cf61$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0e34f6a27473cf61$var$V;){
        var e = $0e34f6a27473cf61$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0e34f6a27473cf61$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0e34f6a27473cf61$var$U;
                h = $0e34f6a27473cf61$var$Kj;
                var l = $0e34f6a27473cf61$var$U;
                $0e34f6a27473cf61$var$Kj = g;
                if (($0e34f6a27473cf61$var$U = k) && !l) for($0e34f6a27473cf61$var$V = e; null !== $0e34f6a27473cf61$var$V;)g = $0e34f6a27473cf61$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0e34f6a27473cf61$var$kk(e) : null !== k ? (k.return = g, $0e34f6a27473cf61$var$V = k) : $0e34f6a27473cf61$var$kk(e);
                for(; null !== f;)$0e34f6a27473cf61$var$V = f, $0e34f6a27473cf61$var$jk(f, b, c), f = f.sibling;
                $0e34f6a27473cf61$var$V = e;
                $0e34f6a27473cf61$var$Kj = h;
                $0e34f6a27473cf61$var$U = l;
            }
            $0e34f6a27473cf61$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0e34f6a27473cf61$var$V = f) : $0e34f6a27473cf61$var$lk(a, b, c);
    }
}
function $0e34f6a27473cf61$var$lk(a) {
    for(; null !== $0e34f6a27473cf61$var$V;){
        var b = $0e34f6a27473cf61$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0e34f6a27473cf61$var$U || $0e34f6a27473cf61$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0e34f6a27473cf61$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0e34f6a27473cf61$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0e34f6a27473cf61$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0e34f6a27473cf61$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0e34f6a27473cf61$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0e34f6a27473cf61$var$p(163));
                }
                $0e34f6a27473cf61$var$U || b.flags & 512 && $0e34f6a27473cf61$var$Sj(b);
            } catch (r) {
                $0e34f6a27473cf61$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0e34f6a27473cf61$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0e34f6a27473cf61$var$V = c;
            break;
        }
        $0e34f6a27473cf61$var$V = b.return;
    }
}
function $0e34f6a27473cf61$var$hk(a) {
    for(; null !== $0e34f6a27473cf61$var$V;){
        var b = $0e34f6a27473cf61$var$V;
        if (b === a) {
            $0e34f6a27473cf61$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0e34f6a27473cf61$var$V = c;
            break;
        }
        $0e34f6a27473cf61$var$V = b.return;
    }
}
function $0e34f6a27473cf61$var$kk(a) {
    for(; null !== $0e34f6a27473cf61$var$V;){
        var b = $0e34f6a27473cf61$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0e34f6a27473cf61$var$Rj(4, b);
                    } catch (k) {
                        $0e34f6a27473cf61$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0e34f6a27473cf61$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0e34f6a27473cf61$var$Sj(b);
                    } catch (k) {
                        $0e34f6a27473cf61$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0e34f6a27473cf61$var$Sj(b);
                    } catch (k) {
                        $0e34f6a27473cf61$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0e34f6a27473cf61$var$W(b, b.return, k);
        }
        if (b === a) {
            $0e34f6a27473cf61$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0e34f6a27473cf61$var$V = h;
            break;
        }
        $0e34f6a27473cf61$var$V = b.return;
    }
}
var $0e34f6a27473cf61$var$mk = Math.ceil, $0e34f6a27473cf61$var$nk = $0e34f6a27473cf61$var$ua.ReactCurrentDispatcher, $0e34f6a27473cf61$var$ok = $0e34f6a27473cf61$var$ua.ReactCurrentOwner, $0e34f6a27473cf61$var$pk = $0e34f6a27473cf61$var$ua.ReactCurrentBatchConfig, $0e34f6a27473cf61$var$K = 0, $0e34f6a27473cf61$var$R = null, $0e34f6a27473cf61$var$Y = null, $0e34f6a27473cf61$var$Z = 0, $0e34f6a27473cf61$var$gj = 0, $0e34f6a27473cf61$var$fj = $0e34f6a27473cf61$var$Uf(0), $0e34f6a27473cf61$var$T = 0, $0e34f6a27473cf61$var$qk = null, $0e34f6a27473cf61$var$hh = 0, $0e34f6a27473cf61$var$rk = 0, $0e34f6a27473cf61$var$sk = 0, $0e34f6a27473cf61$var$tk = null, $0e34f6a27473cf61$var$uk = null, $0e34f6a27473cf61$var$gk = 0, $0e34f6a27473cf61$var$Hj = Infinity, $0e34f6a27473cf61$var$vk = null, $0e34f6a27473cf61$var$Pi = !1, $0e34f6a27473cf61$var$Qi = null, $0e34f6a27473cf61$var$Si = null, $0e34f6a27473cf61$var$wk = !1, $0e34f6a27473cf61$var$xk = null, $0e34f6a27473cf61$var$yk = 0, $0e34f6a27473cf61$var$zk = 0, $0e34f6a27473cf61$var$Ak = null, $0e34f6a27473cf61$var$Bk = -1, $0e34f6a27473cf61$var$Ck = 0;
function $0e34f6a27473cf61$var$L() {
    return 0 !== ($0e34f6a27473cf61$var$K & 6) ? $0e34f6a27473cf61$var$B() : -1 !== $0e34f6a27473cf61$var$Bk ? $0e34f6a27473cf61$var$Bk : $0e34f6a27473cf61$var$Bk = $0e34f6a27473cf61$var$B();
}
function $0e34f6a27473cf61$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0e34f6a27473cf61$var$K & 2) && 0 !== $0e34f6a27473cf61$var$Z) return $0e34f6a27473cf61$var$Z & -$0e34f6a27473cf61$var$Z;
    if (null !== $0e34f6a27473cf61$var$Kg.transition) return 0 === $0e34f6a27473cf61$var$Ck && ($0e34f6a27473cf61$var$Ck = $0e34f6a27473cf61$var$yc()), $0e34f6a27473cf61$var$Ck;
    a = $0e34f6a27473cf61$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0e34f6a27473cf61$var$jd(a.type);
    return a;
}
function $0e34f6a27473cf61$var$mh(a, b, c, d) {
    if (50 < $0e34f6a27473cf61$var$zk) throw $0e34f6a27473cf61$var$zk = 0, $0e34f6a27473cf61$var$Ak = null, Error($0e34f6a27473cf61$var$p(185));
    $0e34f6a27473cf61$var$Ac(a, c, d);
    if (0 === ($0e34f6a27473cf61$var$K & 2) || a !== $0e34f6a27473cf61$var$R) a === $0e34f6a27473cf61$var$R && (0 === ($0e34f6a27473cf61$var$K & 2) && ($0e34f6a27473cf61$var$rk |= c), 4 === $0e34f6a27473cf61$var$T && $0e34f6a27473cf61$var$Dk(a, $0e34f6a27473cf61$var$Z)), $0e34f6a27473cf61$var$Ek(a, d), 1 === c && 0 === $0e34f6a27473cf61$var$K && 0 === (b.mode & 1) && ($0e34f6a27473cf61$var$Hj = $0e34f6a27473cf61$var$B() + 500, $0e34f6a27473cf61$var$fg && $0e34f6a27473cf61$var$jg());
}
function $0e34f6a27473cf61$var$Ek(a, b) {
    var c = a.callbackNode;
    $0e34f6a27473cf61$var$wc(a, b);
    var d = $0e34f6a27473cf61$var$uc(a, a === $0e34f6a27473cf61$var$R ? $0e34f6a27473cf61$var$Z : 0);
    if (0 === d) null !== c && $0e34f6a27473cf61$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0e34f6a27473cf61$var$bc(c);
        if (1 === b) 0 === a.tag ? $0e34f6a27473cf61$var$ig($0e34f6a27473cf61$var$Fk.bind(null, a)) : $0e34f6a27473cf61$var$hg($0e34f6a27473cf61$var$Fk.bind(null, a)), $0e34f6a27473cf61$var$Jf(function() {
            0 === ($0e34f6a27473cf61$var$K & 6) && $0e34f6a27473cf61$var$jg();
        }), c = null;
        else {
            switch($0e34f6a27473cf61$var$Dc(d)){
                case 1:
                    c = $0e34f6a27473cf61$var$fc;
                    break;
                case 4:
                    c = $0e34f6a27473cf61$var$gc;
                    break;
                case 16:
                    c = $0e34f6a27473cf61$var$hc;
                    break;
                case 536870912:
                    c = $0e34f6a27473cf61$var$jc;
                    break;
                default:
                    c = $0e34f6a27473cf61$var$hc;
            }
            c = $0e34f6a27473cf61$var$Gk(c, $0e34f6a27473cf61$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0e34f6a27473cf61$var$Hk(a, b) {
    $0e34f6a27473cf61$var$Bk = -1;
    $0e34f6a27473cf61$var$Ck = 0;
    if (0 !== ($0e34f6a27473cf61$var$K & 6)) throw Error($0e34f6a27473cf61$var$p(327));
    var c = a.callbackNode;
    if ($0e34f6a27473cf61$var$Ik() && a.callbackNode !== c) return null;
    var d = $0e34f6a27473cf61$var$uc(a, a === $0e34f6a27473cf61$var$R ? $0e34f6a27473cf61$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0e34f6a27473cf61$var$Jk(a, d);
    else {
        b = d;
        var e = $0e34f6a27473cf61$var$K;
        $0e34f6a27473cf61$var$K |= 2;
        var f = $0e34f6a27473cf61$var$Kk();
        if ($0e34f6a27473cf61$var$R !== a || $0e34f6a27473cf61$var$Z !== b) $0e34f6a27473cf61$var$vk = null, $0e34f6a27473cf61$var$Hj = $0e34f6a27473cf61$var$B() + 500, $0e34f6a27473cf61$var$Lk(a, b);
        for(;;)try {
            $0e34f6a27473cf61$var$Mk();
            break;
        } catch (h) {
            $0e34f6a27473cf61$var$Nk(a, h);
        }
        $0e34f6a27473cf61$var$Qg();
        $0e34f6a27473cf61$var$nk.current = f;
        $0e34f6a27473cf61$var$K = e;
        null !== $0e34f6a27473cf61$var$Y ? b = 0 : ($0e34f6a27473cf61$var$R = null, $0e34f6a27473cf61$var$Z = 0, b = $0e34f6a27473cf61$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0e34f6a27473cf61$var$xc(a), 0 !== e && (d = e, b = $0e34f6a27473cf61$var$Ok(a, e)));
        if (1 === b) throw c = $0e34f6a27473cf61$var$qk, $0e34f6a27473cf61$var$Lk(a, 0), $0e34f6a27473cf61$var$Dk(a, d), $0e34f6a27473cf61$var$Ek(a, $0e34f6a27473cf61$var$B()), c;
        if (6 === b) $0e34f6a27473cf61$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0e34f6a27473cf61$var$Pk(e) && (b = $0e34f6a27473cf61$var$Jk(a, d), 2 === b && (f = $0e34f6a27473cf61$var$xc(a), 0 !== f && (d = f, b = $0e34f6a27473cf61$var$Ok(a, f))), 1 === b)) throw c = $0e34f6a27473cf61$var$qk, $0e34f6a27473cf61$var$Lk(a, 0), $0e34f6a27473cf61$var$Dk(a, d), $0e34f6a27473cf61$var$Ek(a, $0e34f6a27473cf61$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0e34f6a27473cf61$var$p(345));
                case 2:
                    $0e34f6a27473cf61$var$Qk(a, $0e34f6a27473cf61$var$uk, $0e34f6a27473cf61$var$vk);
                    break;
                case 3:
                    $0e34f6a27473cf61$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0e34f6a27473cf61$var$gk + 500 - $0e34f6a27473cf61$var$B(), 10 < b)) {
                        if (0 !== $0e34f6a27473cf61$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0e34f6a27473cf61$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0e34f6a27473cf61$var$Ff($0e34f6a27473cf61$var$Qk.bind(null, a, $0e34f6a27473cf61$var$uk, $0e34f6a27473cf61$var$vk), b);
                        break;
                    }
                    $0e34f6a27473cf61$var$Qk(a, $0e34f6a27473cf61$var$uk, $0e34f6a27473cf61$var$vk);
                    break;
                case 4:
                    $0e34f6a27473cf61$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0e34f6a27473cf61$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0e34f6a27473cf61$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0e34f6a27473cf61$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0e34f6a27473cf61$var$Ff($0e34f6a27473cf61$var$Qk.bind(null, a, $0e34f6a27473cf61$var$uk, $0e34f6a27473cf61$var$vk), d);
                        break;
                    }
                    $0e34f6a27473cf61$var$Qk(a, $0e34f6a27473cf61$var$uk, $0e34f6a27473cf61$var$vk);
                    break;
                case 5:
                    $0e34f6a27473cf61$var$Qk(a, $0e34f6a27473cf61$var$uk, $0e34f6a27473cf61$var$vk);
                    break;
                default:
                    throw Error($0e34f6a27473cf61$var$p(329));
            }
        }
    }
    $0e34f6a27473cf61$var$Ek(a, $0e34f6a27473cf61$var$B());
    return a.callbackNode === c ? $0e34f6a27473cf61$var$Hk.bind(null, a) : null;
}
function $0e34f6a27473cf61$var$Ok(a, b) {
    var c = $0e34f6a27473cf61$var$tk;
    a.current.memoizedState.isDehydrated && ($0e34f6a27473cf61$var$Lk(a, b).flags |= 256);
    a = $0e34f6a27473cf61$var$Jk(a, b);
    2 !== a && (b = $0e34f6a27473cf61$var$uk, $0e34f6a27473cf61$var$uk = c, null !== b && $0e34f6a27473cf61$var$Gj(b));
    return a;
}
function $0e34f6a27473cf61$var$Gj(a) {
    null === $0e34f6a27473cf61$var$uk ? $0e34f6a27473cf61$var$uk = a : $0e34f6a27473cf61$var$uk.push.apply($0e34f6a27473cf61$var$uk, a);
}
function $0e34f6a27473cf61$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0e34f6a27473cf61$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0e34f6a27473cf61$var$Dk(a, b) {
    b &= ~$0e34f6a27473cf61$var$sk;
    b &= ~$0e34f6a27473cf61$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0e34f6a27473cf61$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0e34f6a27473cf61$var$Fk(a) {
    if (0 !== ($0e34f6a27473cf61$var$K & 6)) throw Error($0e34f6a27473cf61$var$p(327));
    $0e34f6a27473cf61$var$Ik();
    var b = $0e34f6a27473cf61$var$uc(a, 0);
    if (0 === (b & 1)) return $0e34f6a27473cf61$var$Ek(a, $0e34f6a27473cf61$var$B()), null;
    var c = $0e34f6a27473cf61$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0e34f6a27473cf61$var$xc(a);
        0 !== d && (b = d, c = $0e34f6a27473cf61$var$Ok(a, d));
    }
    if (1 === c) throw c = $0e34f6a27473cf61$var$qk, $0e34f6a27473cf61$var$Lk(a, 0), $0e34f6a27473cf61$var$Dk(a, b), $0e34f6a27473cf61$var$Ek(a, $0e34f6a27473cf61$var$B()), c;
    if (6 === c) throw Error($0e34f6a27473cf61$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0e34f6a27473cf61$var$Qk(a, $0e34f6a27473cf61$var$uk, $0e34f6a27473cf61$var$vk);
    $0e34f6a27473cf61$var$Ek(a, $0e34f6a27473cf61$var$B());
    return null;
}
function $0e34f6a27473cf61$var$Rk(a, b) {
    var c = $0e34f6a27473cf61$var$K;
    $0e34f6a27473cf61$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0e34f6a27473cf61$var$K = c, 0 === $0e34f6a27473cf61$var$K && ($0e34f6a27473cf61$var$Hj = $0e34f6a27473cf61$var$B() + 500, $0e34f6a27473cf61$var$fg && $0e34f6a27473cf61$var$jg());
    }
}
function $0e34f6a27473cf61$var$Sk(a) {
    null !== $0e34f6a27473cf61$var$xk && 0 === $0e34f6a27473cf61$var$xk.tag && 0 === ($0e34f6a27473cf61$var$K & 6) && $0e34f6a27473cf61$var$Ik();
    var b = $0e34f6a27473cf61$var$K;
    $0e34f6a27473cf61$var$K |= 1;
    var c = $0e34f6a27473cf61$var$pk.transition, d = $0e34f6a27473cf61$var$C;
    try {
        if ($0e34f6a27473cf61$var$pk.transition = null, $0e34f6a27473cf61$var$C = 1, a) return a();
    } finally{
        $0e34f6a27473cf61$var$C = d, $0e34f6a27473cf61$var$pk.transition = c, $0e34f6a27473cf61$var$K = b, 0 === ($0e34f6a27473cf61$var$K & 6) && $0e34f6a27473cf61$var$jg();
    }
}
function $0e34f6a27473cf61$var$Ij() {
    $0e34f6a27473cf61$var$gj = $0e34f6a27473cf61$var$fj.current;
    $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$fj);
}
function $0e34f6a27473cf61$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0e34f6a27473cf61$var$Gf(c));
    if (null !== $0e34f6a27473cf61$var$Y) for(c = $0e34f6a27473cf61$var$Y.return; null !== c;){
        var d = c;
        $0e34f6a27473cf61$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0e34f6a27473cf61$var$$f();
                break;
            case 3:
                $0e34f6a27473cf61$var$Jh();
                $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$Wf);
                $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$H);
                $0e34f6a27473cf61$var$Oh();
                break;
            case 5:
                $0e34f6a27473cf61$var$Lh(d);
                break;
            case 4:
                $0e34f6a27473cf61$var$Jh();
                break;
            case 13:
                $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$M);
                break;
            case 19:
                $0e34f6a27473cf61$var$E($0e34f6a27473cf61$var$M);
                break;
            case 10:
                $0e34f6a27473cf61$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0e34f6a27473cf61$var$Ij();
        }
        c = c.return;
    }
    $0e34f6a27473cf61$var$R = a;
    $0e34f6a27473cf61$var$Y = a = $0e34f6a27473cf61$var$wh(a.current, null);
    $0e34f6a27473cf61$var$Z = $0e34f6a27473cf61$var$gj = b;
    $0e34f6a27473cf61$var$T = 0;
    $0e34f6a27473cf61$var$qk = null;
    $0e34f6a27473cf61$var$sk = $0e34f6a27473cf61$var$rk = $0e34f6a27473cf61$var$hh = 0;
    $0e34f6a27473cf61$var$uk = $0e34f6a27473cf61$var$tk = null;
    if (null !== $0e34f6a27473cf61$var$Wg) {
        for(b = 0; b < $0e34f6a27473cf61$var$Wg.length; b++)if (c = $0e34f6a27473cf61$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0e34f6a27473cf61$var$Wg = null;
    }
    return a;
}
function $0e34f6a27473cf61$var$Nk(a, b) {
    do {
        var c = $0e34f6a27473cf61$var$Y;
        try {
            $0e34f6a27473cf61$var$Qg();
            $0e34f6a27473cf61$var$Ph.current = $0e34f6a27473cf61$var$ai;
            if ($0e34f6a27473cf61$var$Sh) {
                for(var d = $0e34f6a27473cf61$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0e34f6a27473cf61$var$Sh = !1;
            }
            $0e34f6a27473cf61$var$Rh = 0;
            $0e34f6a27473cf61$var$P = $0e34f6a27473cf61$var$O = $0e34f6a27473cf61$var$N = null;
            $0e34f6a27473cf61$var$Th = !1;
            $0e34f6a27473cf61$var$Uh = 0;
            $0e34f6a27473cf61$var$ok.current = null;
            if (null === c || null === c.return) {
                $0e34f6a27473cf61$var$T = 1;
                $0e34f6a27473cf61$var$qk = b;
                $0e34f6a27473cf61$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0e34f6a27473cf61$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0e34f6a27473cf61$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0e34f6a27473cf61$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0e34f6a27473cf61$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0e34f6a27473cf61$var$Ti(f, l, b);
                            $0e34f6a27473cf61$var$uj();
                            break a;
                        }
                        k = Error($0e34f6a27473cf61$var$p(426));
                    }
                } else if ($0e34f6a27473cf61$var$I && h.mode & 1) {
                    var J = $0e34f6a27473cf61$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0e34f6a27473cf61$var$Wi(J, g, h, f, b);
                        $0e34f6a27473cf61$var$Jg($0e34f6a27473cf61$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0e34f6a27473cf61$var$Ki(k, h);
                4 !== $0e34f6a27473cf61$var$T && ($0e34f6a27473cf61$var$T = 2);
                null === $0e34f6a27473cf61$var$tk ? $0e34f6a27473cf61$var$tk = [
                    f
                ] : $0e34f6a27473cf61$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0e34f6a27473cf61$var$Oi(f, k, b);
                            $0e34f6a27473cf61$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0e34f6a27473cf61$var$Si || !$0e34f6a27473cf61$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0e34f6a27473cf61$var$Ri(f, h, b);
                                $0e34f6a27473cf61$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0e34f6a27473cf61$var$Tk(c);
        } catch (na) {
            b = na;
            $0e34f6a27473cf61$var$Y === c && null !== c && ($0e34f6a27473cf61$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0e34f6a27473cf61$var$Kk() {
    var a = $0e34f6a27473cf61$var$nk.current;
    $0e34f6a27473cf61$var$nk.current = $0e34f6a27473cf61$var$ai;
    return null === a ? $0e34f6a27473cf61$var$ai : a;
}
function $0e34f6a27473cf61$var$uj() {
    if (0 === $0e34f6a27473cf61$var$T || 3 === $0e34f6a27473cf61$var$T || 2 === $0e34f6a27473cf61$var$T) $0e34f6a27473cf61$var$T = 4;
    null === $0e34f6a27473cf61$var$R || 0 === ($0e34f6a27473cf61$var$hh & 268435455) && 0 === ($0e34f6a27473cf61$var$rk & 268435455) || $0e34f6a27473cf61$var$Dk($0e34f6a27473cf61$var$R, $0e34f6a27473cf61$var$Z);
}
function $0e34f6a27473cf61$var$Jk(a, b) {
    var c = $0e34f6a27473cf61$var$K;
    $0e34f6a27473cf61$var$K |= 2;
    var d = $0e34f6a27473cf61$var$Kk();
    if ($0e34f6a27473cf61$var$R !== a || $0e34f6a27473cf61$var$Z !== b) $0e34f6a27473cf61$var$vk = null, $0e34f6a27473cf61$var$Lk(a, b);
    for(;;)try {
        $0e34f6a27473cf61$var$Uk();
        break;
    } catch (e) {
        $0e34f6a27473cf61$var$Nk(a, e);
    }
    $0e34f6a27473cf61$var$Qg();
    $0e34f6a27473cf61$var$K = c;
    $0e34f6a27473cf61$var$nk.current = d;
    if (null !== $0e34f6a27473cf61$var$Y) throw Error($0e34f6a27473cf61$var$p(261));
    $0e34f6a27473cf61$var$R = null;
    $0e34f6a27473cf61$var$Z = 0;
    return $0e34f6a27473cf61$var$T;
}
function $0e34f6a27473cf61$var$Uk() {
    for(; null !== $0e34f6a27473cf61$var$Y;)$0e34f6a27473cf61$var$Vk($0e34f6a27473cf61$var$Y);
}
function $0e34f6a27473cf61$var$Mk() {
    for(; null !== $0e34f6a27473cf61$var$Y && !$0e34f6a27473cf61$var$cc();)$0e34f6a27473cf61$var$Vk($0e34f6a27473cf61$var$Y);
}
function $0e34f6a27473cf61$var$Vk(a) {
    var b = $0e34f6a27473cf61$var$Wk(a.alternate, a, $0e34f6a27473cf61$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0e34f6a27473cf61$var$Tk(a) : $0e34f6a27473cf61$var$Y = b;
    $0e34f6a27473cf61$var$ok.current = null;
}
function $0e34f6a27473cf61$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0e34f6a27473cf61$var$Fj(c, b, $0e34f6a27473cf61$var$gj), null !== c) {
                $0e34f6a27473cf61$var$Y = c;
                return;
            }
        } else {
            c = $0e34f6a27473cf61$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0e34f6a27473cf61$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0e34f6a27473cf61$var$T = 6;
                $0e34f6a27473cf61$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0e34f6a27473cf61$var$Y = b;
            return;
        }
        $0e34f6a27473cf61$var$Y = b = a;
    }while (null !== b);
    0 === $0e34f6a27473cf61$var$T && ($0e34f6a27473cf61$var$T = 5);
}
function $0e34f6a27473cf61$var$Qk(a, b, c) {
    var d = $0e34f6a27473cf61$var$C, e = $0e34f6a27473cf61$var$pk.transition;
    try {
        $0e34f6a27473cf61$var$pk.transition = null, $0e34f6a27473cf61$var$C = 1, $0e34f6a27473cf61$var$Xk(a, b, c, d);
    } finally{
        $0e34f6a27473cf61$var$pk.transition = e, $0e34f6a27473cf61$var$C = d;
    }
    return null;
}
function $0e34f6a27473cf61$var$Xk(a, b, c, d) {
    do $0e34f6a27473cf61$var$Ik();
    while (null !== $0e34f6a27473cf61$var$xk);
    if (0 !== ($0e34f6a27473cf61$var$K & 6)) throw Error($0e34f6a27473cf61$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0e34f6a27473cf61$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0e34f6a27473cf61$var$Bc(a, f);
    a === $0e34f6a27473cf61$var$R && ($0e34f6a27473cf61$var$Y = $0e34f6a27473cf61$var$R = null, $0e34f6a27473cf61$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0e34f6a27473cf61$var$wk || ($0e34f6a27473cf61$var$wk = !0, $0e34f6a27473cf61$var$Gk($0e34f6a27473cf61$var$hc, function() {
        $0e34f6a27473cf61$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0e34f6a27473cf61$var$pk.transition;
        $0e34f6a27473cf61$var$pk.transition = null;
        var g = $0e34f6a27473cf61$var$C;
        $0e34f6a27473cf61$var$C = 1;
        var h = $0e34f6a27473cf61$var$K;
        $0e34f6a27473cf61$var$K |= 4;
        $0e34f6a27473cf61$var$ok.current = null;
        $0e34f6a27473cf61$var$Pj(a, c);
        $0e34f6a27473cf61$var$ek(c, a);
        $0e34f6a27473cf61$var$Oe($0e34f6a27473cf61$var$Df);
        $0e34f6a27473cf61$var$dd = !!$0e34f6a27473cf61$var$Cf;
        $0e34f6a27473cf61$var$Df = $0e34f6a27473cf61$var$Cf = null;
        a.current = c;
        $0e34f6a27473cf61$var$ik(c, a, e);
        $0e34f6a27473cf61$var$dc();
        $0e34f6a27473cf61$var$K = h;
        $0e34f6a27473cf61$var$C = g;
        $0e34f6a27473cf61$var$pk.transition = f;
    } else a.current = c;
    $0e34f6a27473cf61$var$wk && ($0e34f6a27473cf61$var$wk = !1, $0e34f6a27473cf61$var$xk = a, $0e34f6a27473cf61$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0e34f6a27473cf61$var$Si = null);
    $0e34f6a27473cf61$var$mc(c.stateNode, d);
    $0e34f6a27473cf61$var$Ek(a, $0e34f6a27473cf61$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0e34f6a27473cf61$var$Pi) throw $0e34f6a27473cf61$var$Pi = !1, a = $0e34f6a27473cf61$var$Qi, $0e34f6a27473cf61$var$Qi = null, a;
    0 !== ($0e34f6a27473cf61$var$yk & 1) && 0 !== a.tag && $0e34f6a27473cf61$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0e34f6a27473cf61$var$Ak ? $0e34f6a27473cf61$var$zk++ : ($0e34f6a27473cf61$var$zk = 0, $0e34f6a27473cf61$var$Ak = a) : $0e34f6a27473cf61$var$zk = 0;
    $0e34f6a27473cf61$var$jg();
    return null;
}
function $0e34f6a27473cf61$var$Ik() {
    if (null !== $0e34f6a27473cf61$var$xk) {
        var a = $0e34f6a27473cf61$var$Dc($0e34f6a27473cf61$var$yk), b = $0e34f6a27473cf61$var$pk.transition, c = $0e34f6a27473cf61$var$C;
        try {
            $0e34f6a27473cf61$var$pk.transition = null;
            $0e34f6a27473cf61$var$C = 16 > a ? 16 : a;
            if (null === $0e34f6a27473cf61$var$xk) var d = !1;
            else {
                a = $0e34f6a27473cf61$var$xk;
                $0e34f6a27473cf61$var$xk = null;
                $0e34f6a27473cf61$var$yk = 0;
                if (0 !== ($0e34f6a27473cf61$var$K & 6)) throw Error($0e34f6a27473cf61$var$p(331));
                var e = $0e34f6a27473cf61$var$K;
                $0e34f6a27473cf61$var$K |= 4;
                for($0e34f6a27473cf61$var$V = a.current; null !== $0e34f6a27473cf61$var$V;){
                    var f = $0e34f6a27473cf61$var$V, g = f.child;
                    if (0 !== ($0e34f6a27473cf61$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0e34f6a27473cf61$var$V = l; null !== $0e34f6a27473cf61$var$V;){
                                    var m = $0e34f6a27473cf61$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0e34f6a27473cf61$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0e34f6a27473cf61$var$V = q;
                                    else for(; null !== $0e34f6a27473cf61$var$V;){
                                        m = $0e34f6a27473cf61$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0e34f6a27473cf61$var$Tj(m);
                                        if (m === l) {
                                            $0e34f6a27473cf61$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0e34f6a27473cf61$var$V = r;
                                            break;
                                        }
                                        $0e34f6a27473cf61$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0e34f6a27473cf61$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0e34f6a27473cf61$var$V = g;
                    else b: for(; null !== $0e34f6a27473cf61$var$V;){
                        f = $0e34f6a27473cf61$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0e34f6a27473cf61$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0e34f6a27473cf61$var$V = x;
                            break b;
                        }
                        $0e34f6a27473cf61$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0e34f6a27473cf61$var$V = w; null !== $0e34f6a27473cf61$var$V;){
                    g = $0e34f6a27473cf61$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0e34f6a27473cf61$var$V = u;
                    else b: for(g = w; null !== $0e34f6a27473cf61$var$V;){
                        h = $0e34f6a27473cf61$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0e34f6a27473cf61$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0e34f6a27473cf61$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0e34f6a27473cf61$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0e34f6a27473cf61$var$V = F;
                            break b;
                        }
                        $0e34f6a27473cf61$var$V = h.return;
                    }
                }
                $0e34f6a27473cf61$var$K = e;
                $0e34f6a27473cf61$var$jg();
                if ($0e34f6a27473cf61$var$lc && "function" === typeof $0e34f6a27473cf61$var$lc.onPostCommitFiberRoot) try {
                    $0e34f6a27473cf61$var$lc.onPostCommitFiberRoot($0e34f6a27473cf61$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0e34f6a27473cf61$var$C = c, $0e34f6a27473cf61$var$pk.transition = b;
        }
    }
    return !1;
}
function $0e34f6a27473cf61$var$Yk(a, b, c) {
    b = $0e34f6a27473cf61$var$Ki(c, b);
    b = $0e34f6a27473cf61$var$Oi(a, b, 1);
    a = $0e34f6a27473cf61$var$dh(a, b, 1);
    b = $0e34f6a27473cf61$var$L();
    null !== a && ($0e34f6a27473cf61$var$Ac(a, 1, b), $0e34f6a27473cf61$var$Ek(a, b));
}
function $0e34f6a27473cf61$var$W(a, b, c) {
    if (3 === a.tag) $0e34f6a27473cf61$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0e34f6a27473cf61$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0e34f6a27473cf61$var$Si || !$0e34f6a27473cf61$var$Si.has(d))) {
                a = $0e34f6a27473cf61$var$Ki(c, a);
                a = $0e34f6a27473cf61$var$Ri(b, a, 1);
                b = $0e34f6a27473cf61$var$dh(b, a, 1);
                a = $0e34f6a27473cf61$var$L();
                null !== b && ($0e34f6a27473cf61$var$Ac(b, 1, a), $0e34f6a27473cf61$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0e34f6a27473cf61$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0e34f6a27473cf61$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0e34f6a27473cf61$var$R === a && ($0e34f6a27473cf61$var$Z & c) === c && (4 === $0e34f6a27473cf61$var$T || 3 === $0e34f6a27473cf61$var$T && ($0e34f6a27473cf61$var$Z & 130023424) === $0e34f6a27473cf61$var$Z && 500 > $0e34f6a27473cf61$var$B() - $0e34f6a27473cf61$var$gk ? $0e34f6a27473cf61$var$Lk(a, 0) : $0e34f6a27473cf61$var$sk |= c);
    $0e34f6a27473cf61$var$Ek(a, b);
}
function $0e34f6a27473cf61$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0e34f6a27473cf61$var$sc, $0e34f6a27473cf61$var$sc <<= 1, 0 === ($0e34f6a27473cf61$var$sc & 130023424) && ($0e34f6a27473cf61$var$sc = 4194304)));
    var c = $0e34f6a27473cf61$var$L();
    a = $0e34f6a27473cf61$var$Zg(a, b);
    null !== a && ($0e34f6a27473cf61$var$Ac(a, b, c), $0e34f6a27473cf61$var$Ek(a, c));
}
function $0e34f6a27473cf61$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0e34f6a27473cf61$var$Zk(a, c);
}
function $0e34f6a27473cf61$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0e34f6a27473cf61$var$p(314));
    }
    null !== d && d.delete(b);
    $0e34f6a27473cf61$var$Zk(a, c);
}
var $0e34f6a27473cf61$var$Wk;
$0e34f6a27473cf61$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0e34f6a27473cf61$var$Wf.current) $0e34f6a27473cf61$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0e34f6a27473cf61$var$Ug = !1, $0e34f6a27473cf61$var$zj(a, b, c);
            $0e34f6a27473cf61$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0e34f6a27473cf61$var$Ug = !1, $0e34f6a27473cf61$var$I && 0 !== (b.flags & 1048576) && $0e34f6a27473cf61$var$ug(b, $0e34f6a27473cf61$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0e34f6a27473cf61$var$jj(a, b);
            a = b.pendingProps;
            var e = $0e34f6a27473cf61$var$Yf(b, $0e34f6a27473cf61$var$H.current);
            $0e34f6a27473cf61$var$Tg(b, c);
            e = $0e34f6a27473cf61$var$Xh(null, b, d, a, e, c);
            var f = $0e34f6a27473cf61$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0e34f6a27473cf61$var$Zf(d) ? (f = !0, $0e34f6a27473cf61$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0e34f6a27473cf61$var$ah(b), e.updater = $0e34f6a27473cf61$var$nh, b.stateNode = e, e._reactInternals = b, $0e34f6a27473cf61$var$rh(b, d, a, c), b = $0e34f6a27473cf61$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0e34f6a27473cf61$var$I && f && $0e34f6a27473cf61$var$vg(b), $0e34f6a27473cf61$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0e34f6a27473cf61$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0e34f6a27473cf61$var$$k(d);
                a = $0e34f6a27473cf61$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0e34f6a27473cf61$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0e34f6a27473cf61$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0e34f6a27473cf61$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0e34f6a27473cf61$var$aj(null, b, d, $0e34f6a27473cf61$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0e34f6a27473cf61$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0e34f6a27473cf61$var$Lg(d, e), $0e34f6a27473cf61$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0e34f6a27473cf61$var$Lg(d, e), $0e34f6a27473cf61$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0e34f6a27473cf61$var$lj(b);
                if (null === a) throw Error($0e34f6a27473cf61$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0e34f6a27473cf61$var$bh(a, b);
                $0e34f6a27473cf61$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0e34f6a27473cf61$var$Ki(Error($0e34f6a27473cf61$var$p(423)), b);
                        b = $0e34f6a27473cf61$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0e34f6a27473cf61$var$Ki(Error($0e34f6a27473cf61$var$p(424)), b);
                        b = $0e34f6a27473cf61$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0e34f6a27473cf61$var$yg = $0e34f6a27473cf61$var$Lf(b.stateNode.containerInfo.firstChild), $0e34f6a27473cf61$var$xg = b, $0e34f6a27473cf61$var$I = !0, $0e34f6a27473cf61$var$zg = null, c = $0e34f6a27473cf61$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0e34f6a27473cf61$var$Ig();
                    if (d === e) {
                        b = $0e34f6a27473cf61$var$$i(a, b, c);
                        break a;
                    }
                    $0e34f6a27473cf61$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0e34f6a27473cf61$var$Kh(b), null === a && $0e34f6a27473cf61$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0e34f6a27473cf61$var$Ef(d, e) ? g = null : null !== f && $0e34f6a27473cf61$var$Ef(d, f) && (b.flags |= 32), $0e34f6a27473cf61$var$hj(a, b), $0e34f6a27473cf61$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0e34f6a27473cf61$var$Eg(b), null;
        case 13:
            return $0e34f6a27473cf61$var$pj(a, b, c);
        case 4:
            return $0e34f6a27473cf61$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0e34f6a27473cf61$var$Bh(b, null, d, c) : $0e34f6a27473cf61$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0e34f6a27473cf61$var$Lg(d, e), $0e34f6a27473cf61$var$Zi(a, b, d, e, c);
        case 7:
            return $0e34f6a27473cf61$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0e34f6a27473cf61$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0e34f6a27473cf61$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0e34f6a27473cf61$var$G($0e34f6a27473cf61$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0e34f6a27473cf61$var$He(f.value, g)) {
                        if (f.children === e.children && !$0e34f6a27473cf61$var$Wf.current) {
                            b = $0e34f6a27473cf61$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0e34f6a27473cf61$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0e34f6a27473cf61$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0e34f6a27473cf61$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0e34f6a27473cf61$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0e34f6a27473cf61$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0e34f6a27473cf61$var$Tg(b, c), e = $0e34f6a27473cf61$var$Vg(e), d = d(e), b.flags |= 1, $0e34f6a27473cf61$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0e34f6a27473cf61$var$Lg(d, b.pendingProps), e = $0e34f6a27473cf61$var$Lg(d.type, e), $0e34f6a27473cf61$var$aj(a, b, d, e, c);
        case 15:
            return $0e34f6a27473cf61$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0e34f6a27473cf61$var$Lg(d, e), $0e34f6a27473cf61$var$jj(a, b), b.tag = 1, $0e34f6a27473cf61$var$Zf(d) ? (a = !0, $0e34f6a27473cf61$var$cg(b)) : a = !1, $0e34f6a27473cf61$var$Tg(b, c), $0e34f6a27473cf61$var$ph(b, d, e), $0e34f6a27473cf61$var$rh(b, d, e, c), $0e34f6a27473cf61$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0e34f6a27473cf61$var$yj(a, b, c);
        case 22:
            return $0e34f6a27473cf61$var$ej(a, b, c);
    }
    throw Error($0e34f6a27473cf61$var$p(156, b.tag));
};
function $0e34f6a27473cf61$var$Gk(a, b) {
    return $0e34f6a27473cf61$var$ac(a, b);
}
function $0e34f6a27473cf61$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0e34f6a27473cf61$var$Bg(a, b, c, d) {
    return new $0e34f6a27473cf61$var$al(a, b, c, d);
}
function $0e34f6a27473cf61$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0e34f6a27473cf61$var$$k(a) {
    if ("function" === typeof a) return $0e34f6a27473cf61$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0e34f6a27473cf61$var$Da) return 11;
        if (a === $0e34f6a27473cf61$var$Ga) return 14;
    }
    return 2;
}
function $0e34f6a27473cf61$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0e34f6a27473cf61$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0e34f6a27473cf61$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0e34f6a27473cf61$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0e34f6a27473cf61$var$ya:
            return $0e34f6a27473cf61$var$Ah(c.children, e, f, b);
        case $0e34f6a27473cf61$var$za:
            g = 8;
            e |= 8;
            break;
        case $0e34f6a27473cf61$var$Aa:
            return a = $0e34f6a27473cf61$var$Bg(12, c, b, e | 2), a.elementType = $0e34f6a27473cf61$var$Aa, a.lanes = f, a;
        case $0e34f6a27473cf61$var$Ea:
            return a = $0e34f6a27473cf61$var$Bg(13, c, b, e), a.elementType = $0e34f6a27473cf61$var$Ea, a.lanes = f, a;
        case $0e34f6a27473cf61$var$Fa:
            return a = $0e34f6a27473cf61$var$Bg(19, c, b, e), a.elementType = $0e34f6a27473cf61$var$Fa, a.lanes = f, a;
        case $0e34f6a27473cf61$var$Ia:
            return $0e34f6a27473cf61$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0e34f6a27473cf61$var$Ba:
                    g = 10;
                    break a;
                case $0e34f6a27473cf61$var$Ca:
                    g = 9;
                    break a;
                case $0e34f6a27473cf61$var$Da:
                    g = 11;
                    break a;
                case $0e34f6a27473cf61$var$Ga:
                    g = 14;
                    break a;
                case $0e34f6a27473cf61$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0e34f6a27473cf61$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0e34f6a27473cf61$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0e34f6a27473cf61$var$Ah(a, b, c, d) {
    a = $0e34f6a27473cf61$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0e34f6a27473cf61$var$qj(a, b, c, d) {
    a = $0e34f6a27473cf61$var$Bg(22, a, d, b);
    a.elementType = $0e34f6a27473cf61$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0e34f6a27473cf61$var$xh(a, b, c) {
    a = $0e34f6a27473cf61$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0e34f6a27473cf61$var$zh(a, b, c) {
    b = $0e34f6a27473cf61$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0e34f6a27473cf61$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0e34f6a27473cf61$var$zc(0);
    this.expirationTimes = $0e34f6a27473cf61$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0e34f6a27473cf61$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0e34f6a27473cf61$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0e34f6a27473cf61$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0e34f6a27473cf61$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0e34f6a27473cf61$var$ah(f);
    return a;
}
function $0e34f6a27473cf61$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0e34f6a27473cf61$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0e34f6a27473cf61$var$el(a) {
    if (!a) return $0e34f6a27473cf61$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0e34f6a27473cf61$var$Vb(a) !== a || 1 !== a.tag) throw Error($0e34f6a27473cf61$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0e34f6a27473cf61$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0e34f6a27473cf61$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0e34f6a27473cf61$var$Zf(c)) return $0e34f6a27473cf61$var$bg(a, c, b);
    }
    return b;
}
function $0e34f6a27473cf61$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0e34f6a27473cf61$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0e34f6a27473cf61$var$el(null);
    c = a.current;
    d = $0e34f6a27473cf61$var$L();
    e = $0e34f6a27473cf61$var$lh(c);
    f = $0e34f6a27473cf61$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0e34f6a27473cf61$var$dh(c, f, e);
    a.current.lanes = e;
    $0e34f6a27473cf61$var$Ac(a, e, d);
    $0e34f6a27473cf61$var$Ek(a, d);
    return a;
}
function $0e34f6a27473cf61$var$gl(a, b, c, d) {
    var e = b.current, f = $0e34f6a27473cf61$var$L(), g = $0e34f6a27473cf61$var$lh(e);
    c = $0e34f6a27473cf61$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0e34f6a27473cf61$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0e34f6a27473cf61$var$dh(e, b, g);
    null !== a && ($0e34f6a27473cf61$var$mh(a, e, g, f), $0e34f6a27473cf61$var$eh(a, e, g));
    return g;
}
function $0e34f6a27473cf61$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0e34f6a27473cf61$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0e34f6a27473cf61$var$jl(a, b) {
    $0e34f6a27473cf61$var$il(a, b);
    (a = a.alternate) && $0e34f6a27473cf61$var$il(a, b);
}
function $0e34f6a27473cf61$var$kl() {
    return null;
}
var $0e34f6a27473cf61$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0e34f6a27473cf61$var$ml(a) {
    this._internalRoot = a;
}
$0e34f6a27473cf61$var$nl.prototype.render = $0e34f6a27473cf61$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0e34f6a27473cf61$var$p(409));
    $0e34f6a27473cf61$var$gl(a, b, null, null);
};
$0e34f6a27473cf61$var$nl.prototype.unmount = $0e34f6a27473cf61$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0e34f6a27473cf61$var$Sk(function() {
            $0e34f6a27473cf61$var$gl(null, a, null, null);
        });
        b[$0e34f6a27473cf61$var$uf] = null;
    }
};
function $0e34f6a27473cf61$var$nl(a) {
    this._internalRoot = a;
}
$0e34f6a27473cf61$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0e34f6a27473cf61$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0e34f6a27473cf61$var$Qc.length && 0 !== b && b < $0e34f6a27473cf61$var$Qc[c].priority; c++);
        $0e34f6a27473cf61$var$Qc.splice(c, 0, a);
        0 === c && $0e34f6a27473cf61$var$Vc(a);
    }
};
function $0e34f6a27473cf61$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0e34f6a27473cf61$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0e34f6a27473cf61$var$ql() {}
function $0e34f6a27473cf61$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0e34f6a27473cf61$var$hl(g);
                f.call(a);
            };
        }
        var g = $0e34f6a27473cf61$var$fl(b, d, a, 0, null, !1, !1, "", $0e34f6a27473cf61$var$ql);
        a._reactRootContainer = g;
        a[$0e34f6a27473cf61$var$uf] = g.current;
        $0e34f6a27473cf61$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0e34f6a27473cf61$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0e34f6a27473cf61$var$hl(k);
            h.call(a);
        };
    }
    var k = $0e34f6a27473cf61$var$cl(a, 0, !1, null, null, !1, !1, "", $0e34f6a27473cf61$var$ql);
    a._reactRootContainer = k;
    a[$0e34f6a27473cf61$var$uf] = k.current;
    $0e34f6a27473cf61$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0e34f6a27473cf61$var$Sk(function() {
        $0e34f6a27473cf61$var$gl(b, k, c, d);
    });
    return k;
}
function $0e34f6a27473cf61$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0e34f6a27473cf61$var$hl(g);
                h.call(a);
            };
        }
        $0e34f6a27473cf61$var$gl(b, g, a, e);
    } else g = $0e34f6a27473cf61$var$rl(c, b, a, e, d);
    return $0e34f6a27473cf61$var$hl(g);
}
$0e34f6a27473cf61$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0e34f6a27473cf61$var$tc(b.pendingLanes);
                0 !== c && ($0e34f6a27473cf61$var$Cc(b, c | 1), $0e34f6a27473cf61$var$Ek(b, $0e34f6a27473cf61$var$B()), 0 === ($0e34f6a27473cf61$var$K & 6) && ($0e34f6a27473cf61$var$Hj = $0e34f6a27473cf61$var$B() + 500, $0e34f6a27473cf61$var$jg()));
            }
            break;
        case 13:
            $0e34f6a27473cf61$var$Sk(function() {
                var b = $0e34f6a27473cf61$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0e34f6a27473cf61$var$L();
                    $0e34f6a27473cf61$var$mh(b, a, 1, c);
                }
            }), $0e34f6a27473cf61$var$jl(a, 1);
    }
};
$0e34f6a27473cf61$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0e34f6a27473cf61$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0e34f6a27473cf61$var$L();
            $0e34f6a27473cf61$var$mh(b, a, 134217728, c);
        }
        $0e34f6a27473cf61$var$jl(a, 134217728);
    }
};
$0e34f6a27473cf61$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0e34f6a27473cf61$var$lh(a), c = $0e34f6a27473cf61$var$Zg(a, b);
        if (null !== c) {
            var d = $0e34f6a27473cf61$var$L();
            $0e34f6a27473cf61$var$mh(c, a, b, d);
        }
        $0e34f6a27473cf61$var$jl(a, b);
    }
};
$0e34f6a27473cf61$var$Hc = function() {
    return $0e34f6a27473cf61$var$C;
};
$0e34f6a27473cf61$var$Ic = function(a, b) {
    var c = $0e34f6a27473cf61$var$C;
    try {
        return $0e34f6a27473cf61$var$C = a, b();
    } finally{
        $0e34f6a27473cf61$var$C = c;
    }
};
$0e34f6a27473cf61$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0e34f6a27473cf61$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0e34f6a27473cf61$var$Db(d);
                        if (!e) throw Error($0e34f6a27473cf61$var$p(90));
                        $0e34f6a27473cf61$var$Wa(d);
                        $0e34f6a27473cf61$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0e34f6a27473cf61$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0e34f6a27473cf61$var$fb(a, !!c.multiple, b, !1);
    }
};
$0e34f6a27473cf61$var$Gb = $0e34f6a27473cf61$var$Rk;
$0e34f6a27473cf61$var$Hb = $0e34f6a27473cf61$var$Sk;
var $0e34f6a27473cf61$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0e34f6a27473cf61$var$Cb,
        $0e34f6a27473cf61$var$ue,
        $0e34f6a27473cf61$var$Db,
        $0e34f6a27473cf61$var$Eb,
        $0e34f6a27473cf61$var$Fb,
        $0e34f6a27473cf61$var$Rk
    ]
}, $0e34f6a27473cf61$var$ul = {
    findFiberByHostInstance: $0e34f6a27473cf61$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0e34f6a27473cf61$var$vl = {
    bundleType: $0e34f6a27473cf61$var$ul.bundleType,
    version: $0e34f6a27473cf61$var$ul.version,
    rendererPackageName: $0e34f6a27473cf61$var$ul.rendererPackageName,
    rendererConfig: $0e34f6a27473cf61$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0e34f6a27473cf61$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0e34f6a27473cf61$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0e34f6a27473cf61$var$ul.findFiberByHostInstance || $0e34f6a27473cf61$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0e34f6a27473cf61$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0e34f6a27473cf61$var$wl.isDisabled && $0e34f6a27473cf61$var$wl.supportsFiber) try {
        $0e34f6a27473cf61$var$kc = $0e34f6a27473cf61$var$wl.inject($0e34f6a27473cf61$var$vl), $0e34f6a27473cf61$var$lc = $0e34f6a27473cf61$var$wl;
    } catch (a) {}
}
$0e34f6a27473cf61$export$ae55be85d98224ed = $0e34f6a27473cf61$var$tl;
$0e34f6a27473cf61$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0e34f6a27473cf61$var$ol(b)) throw Error($0e34f6a27473cf61$var$p(200));
    return $0e34f6a27473cf61$var$dl(a, b, null, c);
};
$0e34f6a27473cf61$export$882461b6382ed46c = function(a, b) {
    if (!$0e34f6a27473cf61$var$ol(a)) throw Error($0e34f6a27473cf61$var$p(299));
    var c = !1, d = "", e = $0e34f6a27473cf61$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0e34f6a27473cf61$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0e34f6a27473cf61$var$uf] = b.current;
    $0e34f6a27473cf61$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0e34f6a27473cf61$var$ml(b);
};
$0e34f6a27473cf61$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0e34f6a27473cf61$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0e34f6a27473cf61$var$p(268, a));
    }
    a = $0e34f6a27473cf61$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0e34f6a27473cf61$export$cd75ccfd720a3cd4 = function(a) {
    return $0e34f6a27473cf61$var$Sk(a);
};
$0e34f6a27473cf61$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0e34f6a27473cf61$var$pl(b)) throw Error($0e34f6a27473cf61$var$p(200));
    return $0e34f6a27473cf61$var$sl(null, a, b, !0, c);
};
$0e34f6a27473cf61$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0e34f6a27473cf61$var$ol(a)) throw Error($0e34f6a27473cf61$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0e34f6a27473cf61$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0e34f6a27473cf61$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0e34f6a27473cf61$var$uf] = b.current;
    $0e34f6a27473cf61$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0e34f6a27473cf61$var$nl(b);
};
$0e34f6a27473cf61$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0e34f6a27473cf61$var$pl(b)) throw Error($0e34f6a27473cf61$var$p(200));
    return $0e34f6a27473cf61$var$sl(null, a, b, !1, c);
};
$0e34f6a27473cf61$export$502457920280e6be = function(a) {
    if (!$0e34f6a27473cf61$var$pl(a)) throw Error($0e34f6a27473cf61$var$p(40));
    return a._reactRootContainer ? ($0e34f6a27473cf61$var$Sk(function() {
        $0e34f6a27473cf61$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0e34f6a27473cf61$var$uf] = null;
        });
    }), !0) : !1;
};
$0e34f6a27473cf61$export$c78a37762a8d58e1 = $0e34f6a27473cf61$var$Rk;
$0e34f6a27473cf61$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0e34f6a27473cf61$var$pl(c)) throw Error($0e34f6a27473cf61$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0e34f6a27473cf61$var$p(38));
    return $0e34f6a27473cf61$var$sl(a, b, c, !1, d);
};
$0e34f6a27473cf61$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("baAzl", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4QROG"));

});
parcelRequire.register("4QROG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $3885c39a7ff6d9ce$export$c4744153514ff05d; }, function (v) { return $3885c39a7ff6d9ce$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $3885c39a7ff6d9ce$export$3e506c1ccc9cc1a7; }, function (v) { return $3885c39a7ff6d9ce$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $3885c39a7ff6d9ce$export$e26fe2ed2fa76875; }, function (v) { return $3885c39a7ff6d9ce$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $3885c39a7ff6d9ce$export$502329bbf4b505b1; }, function (v) { return $3885c39a7ff6d9ce$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $3885c39a7ff6d9ce$export$6e3807111c4874c4; }, function (v) { return $3885c39a7ff6d9ce$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $3885c39a7ff6d9ce$export$c27134553091fb3a; }, function (v) { return $3885c39a7ff6d9ce$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $3885c39a7ff6d9ce$export$33ee1acdc04fd2a2; }, function (v) { return $3885c39a7ff6d9ce$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $3885c39a7ff6d9ce$export$b00a404bbd5edef2; }, function (v) { return $3885c39a7ff6d9ce$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $3885c39a7ff6d9ce$export$8352ce38b91d0c62; }, function (v) { return $3885c39a7ff6d9ce$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $3885c39a7ff6d9ce$export$d66a1c1c77bd778b; }, function (v) { return $3885c39a7ff6d9ce$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $3885c39a7ff6d9ce$export$d3dfb8e4810cb555; }, function (v) { return $3885c39a7ff6d9ce$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $3885c39a7ff6d9ce$export$839f9183b0465a69; }, function (v) { return $3885c39a7ff6d9ce$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $3885c39a7ff6d9ce$export$72fdf0e06517287b; }, function (v) { return $3885c39a7ff6d9ce$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $3885c39a7ff6d9ce$export$4b844e58a3e414b4; }, function (v) { return $3885c39a7ff6d9ce$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $3885c39a7ff6d9ce$export$816d2913ae6b83b1; }, function (v) { return $3885c39a7ff6d9ce$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $3885c39a7ff6d9ce$export$61bcfe829111a1d0; }, function (v) { return $3885c39a7ff6d9ce$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $3885c39a7ff6d9ce$export$7ee8c9beb337bc3f; }, function (v) { return $3885c39a7ff6d9ce$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $3885c39a7ff6d9ce$export$b5836b71941fa3ed; }, function (v) { return $3885c39a7ff6d9ce$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $3885c39a7ff6d9ce$export$cf845f2c119da08a; }, function (v) { return $3885c39a7ff6d9ce$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3885c39a7ff6d9ce$export$c4744153514ff05d;
var $3885c39a7ff6d9ce$export$3e506c1ccc9cc1a7;
var $3885c39a7ff6d9ce$export$e26fe2ed2fa76875;
var $3885c39a7ff6d9ce$export$502329bbf4b505b1;
var $3885c39a7ff6d9ce$export$6e3807111c4874c4;
var $3885c39a7ff6d9ce$export$c27134553091fb3a;
var $3885c39a7ff6d9ce$export$33ee1acdc04fd2a2;
var $3885c39a7ff6d9ce$export$b00a404bbd5edef2;
var $3885c39a7ff6d9ce$export$8352ce38b91d0c62;
var $3885c39a7ff6d9ce$export$d66a1c1c77bd778b;
var $3885c39a7ff6d9ce$export$d3dfb8e4810cb555;
var $3885c39a7ff6d9ce$export$839f9183b0465a69;
var $3885c39a7ff6d9ce$export$72fdf0e06517287b;
var $3885c39a7ff6d9ce$export$4b844e58a3e414b4;
var $3885c39a7ff6d9ce$export$816d2913ae6b83b1;
var $3885c39a7ff6d9ce$export$61bcfe829111a1d0;
var $3885c39a7ff6d9ce$export$7ee8c9beb337bc3f;
var $3885c39a7ff6d9ce$export$b5836b71941fa3ed;
var $3885c39a7ff6d9ce$export$cf845f2c119da08a;
"use strict";
function $3885c39a7ff6d9ce$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3885c39a7ff6d9ce$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3885c39a7ff6d9ce$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3885c39a7ff6d9ce$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3885c39a7ff6d9ce$var$g(C, c)) n < e && 0 > $3885c39a7ff6d9ce$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3885c39a7ff6d9ce$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3885c39a7ff6d9ce$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3885c39a7ff6d9ce$var$l = performance;
    $3885c39a7ff6d9ce$export$c4744153514ff05d = function() {
        return $3885c39a7ff6d9ce$var$l.now();
    };
} else {
    var $3885c39a7ff6d9ce$var$p = Date, $3885c39a7ff6d9ce$var$q = $3885c39a7ff6d9ce$var$p.now();
    $3885c39a7ff6d9ce$export$c4744153514ff05d = function() {
        return $3885c39a7ff6d9ce$var$p.now() - $3885c39a7ff6d9ce$var$q;
    };
}
var $3885c39a7ff6d9ce$var$r = [], $3885c39a7ff6d9ce$var$t = [], $3885c39a7ff6d9ce$var$u = 1, $3885c39a7ff6d9ce$var$v = null, $3885c39a7ff6d9ce$var$y = 3, $3885c39a7ff6d9ce$var$z = !1, $3885c39a7ff6d9ce$var$A = !1, $3885c39a7ff6d9ce$var$B = !1, $3885c39a7ff6d9ce$var$D = "function" === typeof setTimeout ? setTimeout : null, $3885c39a7ff6d9ce$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3885c39a7ff6d9ce$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3885c39a7ff6d9ce$var$G(a) {
    for(var b = $3885c39a7ff6d9ce$var$h($3885c39a7ff6d9ce$var$t); null !== b;){
        if (null === b.callback) $3885c39a7ff6d9ce$var$k($3885c39a7ff6d9ce$var$t);
        else if (b.startTime <= a) $3885c39a7ff6d9ce$var$k($3885c39a7ff6d9ce$var$t), b.sortIndex = b.expirationTime, $3885c39a7ff6d9ce$var$f($3885c39a7ff6d9ce$var$r, b);
        else break;
        b = $3885c39a7ff6d9ce$var$h($3885c39a7ff6d9ce$var$t);
    }
}
function $3885c39a7ff6d9ce$var$H(a) {
    $3885c39a7ff6d9ce$var$B = !1;
    $3885c39a7ff6d9ce$var$G(a);
    if (!$3885c39a7ff6d9ce$var$A) {
        if (null !== $3885c39a7ff6d9ce$var$h($3885c39a7ff6d9ce$var$r)) $3885c39a7ff6d9ce$var$A = !0, $3885c39a7ff6d9ce$var$I($3885c39a7ff6d9ce$var$J);
        else {
            var b = $3885c39a7ff6d9ce$var$h($3885c39a7ff6d9ce$var$t);
            null !== b && $3885c39a7ff6d9ce$var$K($3885c39a7ff6d9ce$var$H, b.startTime - a);
        }
    }
}
function $3885c39a7ff6d9ce$var$J(a, b) {
    $3885c39a7ff6d9ce$var$A = !1;
    $3885c39a7ff6d9ce$var$B && ($3885c39a7ff6d9ce$var$B = !1, $3885c39a7ff6d9ce$var$E($3885c39a7ff6d9ce$var$L), $3885c39a7ff6d9ce$var$L = -1);
    $3885c39a7ff6d9ce$var$z = !0;
    var c = $3885c39a7ff6d9ce$var$y;
    try {
        $3885c39a7ff6d9ce$var$G(b);
        for($3885c39a7ff6d9ce$var$v = $3885c39a7ff6d9ce$var$h($3885c39a7ff6d9ce$var$r); null !== $3885c39a7ff6d9ce$var$v && (!($3885c39a7ff6d9ce$var$v.expirationTime > b) || a && !$3885c39a7ff6d9ce$var$M());){
            var d = $3885c39a7ff6d9ce$var$v.callback;
            if ("function" === typeof d) {
                $3885c39a7ff6d9ce$var$v.callback = null;
                $3885c39a7ff6d9ce$var$y = $3885c39a7ff6d9ce$var$v.priorityLevel;
                var e = d($3885c39a7ff6d9ce$var$v.expirationTime <= b);
                b = $3885c39a7ff6d9ce$export$c4744153514ff05d();
                "function" === typeof e ? $3885c39a7ff6d9ce$var$v.callback = e : $3885c39a7ff6d9ce$var$v === $3885c39a7ff6d9ce$var$h($3885c39a7ff6d9ce$var$r) && $3885c39a7ff6d9ce$var$k($3885c39a7ff6d9ce$var$r);
                $3885c39a7ff6d9ce$var$G(b);
            } else $3885c39a7ff6d9ce$var$k($3885c39a7ff6d9ce$var$r);
            $3885c39a7ff6d9ce$var$v = $3885c39a7ff6d9ce$var$h($3885c39a7ff6d9ce$var$r);
        }
        if (null !== $3885c39a7ff6d9ce$var$v) var w = !0;
        else {
            var m = $3885c39a7ff6d9ce$var$h($3885c39a7ff6d9ce$var$t);
            null !== m && $3885c39a7ff6d9ce$var$K($3885c39a7ff6d9ce$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3885c39a7ff6d9ce$var$v = null, $3885c39a7ff6d9ce$var$y = c, $3885c39a7ff6d9ce$var$z = !1;
    }
}
var $3885c39a7ff6d9ce$var$N = !1, $3885c39a7ff6d9ce$var$O = null, $3885c39a7ff6d9ce$var$L = -1, $3885c39a7ff6d9ce$var$P = 5, $3885c39a7ff6d9ce$var$Q = -1;
function $3885c39a7ff6d9ce$var$M() {
    return $3885c39a7ff6d9ce$export$c4744153514ff05d() - $3885c39a7ff6d9ce$var$Q < $3885c39a7ff6d9ce$var$P ? !1 : !0;
}
function $3885c39a7ff6d9ce$var$R() {
    if (null !== $3885c39a7ff6d9ce$var$O) {
        var a = $3885c39a7ff6d9ce$export$c4744153514ff05d();
        $3885c39a7ff6d9ce$var$Q = a;
        var b = !0;
        try {
            b = $3885c39a7ff6d9ce$var$O(!0, a);
        } finally{
            b ? $3885c39a7ff6d9ce$var$S() : ($3885c39a7ff6d9ce$var$N = !1, $3885c39a7ff6d9ce$var$O = null);
        }
    } else $3885c39a7ff6d9ce$var$N = !1;
}
var $3885c39a7ff6d9ce$var$S;
if ("function" === typeof $3885c39a7ff6d9ce$var$F) $3885c39a7ff6d9ce$var$S = function() {
    $3885c39a7ff6d9ce$var$F($3885c39a7ff6d9ce$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3885c39a7ff6d9ce$var$T = new MessageChannel, $3885c39a7ff6d9ce$var$U = $3885c39a7ff6d9ce$var$T.port2;
    $3885c39a7ff6d9ce$var$T.port1.onmessage = $3885c39a7ff6d9ce$var$R;
    $3885c39a7ff6d9ce$var$S = function() {
        $3885c39a7ff6d9ce$var$U.postMessage(null);
    };
} else $3885c39a7ff6d9ce$var$S = function() {
    $3885c39a7ff6d9ce$var$D($3885c39a7ff6d9ce$var$R, 0);
};
function $3885c39a7ff6d9ce$var$I(a) {
    $3885c39a7ff6d9ce$var$O = a;
    $3885c39a7ff6d9ce$var$N || ($3885c39a7ff6d9ce$var$N = !0, $3885c39a7ff6d9ce$var$S());
}
function $3885c39a7ff6d9ce$var$K(a, b) {
    $3885c39a7ff6d9ce$var$L = $3885c39a7ff6d9ce$var$D(function() {
        a($3885c39a7ff6d9ce$export$c4744153514ff05d());
    }, b);
}
$3885c39a7ff6d9ce$export$3e506c1ccc9cc1a7 = 5;
$3885c39a7ff6d9ce$export$e26fe2ed2fa76875 = 1;
$3885c39a7ff6d9ce$export$502329bbf4b505b1 = 4;
$3885c39a7ff6d9ce$export$6e3807111c4874c4 = 3;
$3885c39a7ff6d9ce$export$c27134553091fb3a = null;
$3885c39a7ff6d9ce$export$33ee1acdc04fd2a2 = 2;
$3885c39a7ff6d9ce$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3885c39a7ff6d9ce$export$8352ce38b91d0c62 = function() {
    $3885c39a7ff6d9ce$var$A || $3885c39a7ff6d9ce$var$z || ($3885c39a7ff6d9ce$var$A = !0, $3885c39a7ff6d9ce$var$I($3885c39a7ff6d9ce$var$J));
};
$3885c39a7ff6d9ce$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3885c39a7ff6d9ce$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3885c39a7ff6d9ce$export$d3dfb8e4810cb555 = function() {
    return $3885c39a7ff6d9ce$var$y;
};
$3885c39a7ff6d9ce$export$839f9183b0465a69 = function() {
    return $3885c39a7ff6d9ce$var$h($3885c39a7ff6d9ce$var$r);
};
$3885c39a7ff6d9ce$export$72fdf0e06517287b = function(a) {
    switch($3885c39a7ff6d9ce$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3885c39a7ff6d9ce$var$y;
    }
    var c = $3885c39a7ff6d9ce$var$y;
    $3885c39a7ff6d9ce$var$y = b;
    try {
        return a();
    } finally{
        $3885c39a7ff6d9ce$var$y = c;
    }
};
$3885c39a7ff6d9ce$export$4b844e58a3e414b4 = function() {};
$3885c39a7ff6d9ce$export$816d2913ae6b83b1 = function() {};
$3885c39a7ff6d9ce$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3885c39a7ff6d9ce$var$y;
    $3885c39a7ff6d9ce$var$y = a;
    try {
        return b();
    } finally{
        $3885c39a7ff6d9ce$var$y = c;
    }
};
$3885c39a7ff6d9ce$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3885c39a7ff6d9ce$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3885c39a7ff6d9ce$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3885c39a7ff6d9ce$var$f($3885c39a7ff6d9ce$var$t, a), null === $3885c39a7ff6d9ce$var$h($3885c39a7ff6d9ce$var$r) && a === $3885c39a7ff6d9ce$var$h($3885c39a7ff6d9ce$var$t) && ($3885c39a7ff6d9ce$var$B ? ($3885c39a7ff6d9ce$var$E($3885c39a7ff6d9ce$var$L), $3885c39a7ff6d9ce$var$L = -1) : $3885c39a7ff6d9ce$var$B = !0, $3885c39a7ff6d9ce$var$K($3885c39a7ff6d9ce$var$H, c - d))) : (a.sortIndex = e, $3885c39a7ff6d9ce$var$f($3885c39a7ff6d9ce$var$r, a), $3885c39a7ff6d9ce$var$A || $3885c39a7ff6d9ce$var$z || ($3885c39a7ff6d9ce$var$A = !0, $3885c39a7ff6d9ce$var$I($3885c39a7ff6d9ce$var$J)));
    return a;
};
$3885c39a7ff6d9ce$export$b5836b71941fa3ed = $3885c39a7ff6d9ce$var$M;
$3885c39a7ff6d9ce$export$cf845f2c119da08a = function(a) {
    var b = $3885c39a7ff6d9ce$var$y;
    return function() {
        var c = $3885c39a7ff6d9ce$var$y;
        $3885c39a7ff6d9ce$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3885c39a7ff6d9ce$var$y = c;
        }
    };
};

});



parcelRequire.register("3j58s", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $2687213e7bcb246c$export$bdfd709ae4826697; }, function (v) { return $2687213e7bcb246c$export$bdfd709ae4826697 = v; });
var $2687213e7bcb246c$export$bdfd709ae4826697;
var $2687213e7bcb246c$export$c9e73fbda7da57b6;
var $2687213e7bcb246c$export$5a759dc7a1cfb72a;
"use strict";
var $2687213e7bcb246c$var$bundleURL = {};
function $2687213e7bcb246c$var$getBundleURLCached(id) {
    var value = $2687213e7bcb246c$var$bundleURL[id];
    if (!value) {
        value = $2687213e7bcb246c$var$getBundleURL();
        $2687213e7bcb246c$var$bundleURL[id] = value;
    }
    return value;
}
function $2687213e7bcb246c$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $2687213e7bcb246c$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $2687213e7bcb246c$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $2687213e7bcb246c$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$2687213e7bcb246c$export$bdfd709ae4826697 = $2687213e7bcb246c$var$getBundleURLCached;
$2687213e7bcb246c$export$c9e73fbda7da57b6 = $2687213e7bcb246c$var$getBaseURL;
$2687213e7bcb246c$export$5a759dc7a1cfb72a = $2687213e7bcb246c$var$getOrigin;

});

parcelRequire.register("8qcWM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $621acb6f5c80b076$export$2e2bcd8739ae039; });

var $cHWp9 = parcelRequire("cHWp9");
var $621acb6f5c80b076$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $621acb6f5c80b076$var$index = (0, $cHWp9.default)(function(prop) {
    return $621acb6f5c80b076$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $621acb6f5c80b076$export$2e2bcd8739ae039 = $621acb6f5c80b076$var$index;

});
parcelRequire.register("cHWp9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9406ce24fefdcaac$export$2e2bcd8739ae039; });
function $9406ce24fefdcaac$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $9406ce24fefdcaac$export$2e2bcd8739ae039 = $9406ce24fefdcaac$var$memoize;

});


parcelRequire.register("a7rUz", function(module, exports) {

$parcel$export(module.exports, "Howler", function () { return $75e03579e62b4980$export$c9d39ca3bcd93abb; }, function (v) { return $75e03579e62b4980$export$c9d39ca3bcd93abb = v; });
$parcel$export(module.exports, "Howl", function () { return $75e03579e62b4980$export$b791fe48eec8032a; }, function (v) { return $75e03579e62b4980$export$b791fe48eec8032a = v; });
/*! howler.js v2.2.4 | (c) 2013-2020, James Simpson of GoldFire Studios | MIT License | howlerjs.com */ var $75e03579e62b4980$export$c9d39ca3bcd93abb;
var $75e03579e62b4980$export$b791fe48eec8032a;
!function() {
    "use strict";
    var e = function() {
        this.init();
    };
    e.prototype = {
        init: function() {
            var e = this || n;
            return e._counter = 1e3, e._html5AudioPool = [], e.html5PoolSize = 10, e._codecs = {}, e._howls = [], e._muted = !1, e._volume = 1, e._canPlayEvent = "canplaythrough", e._navigator = "undefined" != typeof window && window.navigator ? window.navigator : null, e.masterGain = null, e.noAudio = !1, e.usingWebAudio = !0, e.autoSuspend = !0, e.ctx = null, e.autoUnlock = !0, e._setup(), e;
        },
        volume: function(e) {
            var o = this || n;
            if (e = parseFloat(e), o.ctx || _(), void 0 !== e && e >= 0 && e <= 1) {
                if (o._volume = e, o._muted) return o;
                o.usingWebAudio && o.masterGain.gain.setValueAtTime(e, n.ctx.currentTime);
                for(var t = 0; t < o._howls.length; t++)if (!o._howls[t]._webAudio) for(var r = o._howls[t]._getSoundIds(), a = 0; a < r.length; a++){
                    var u = o._howls[t]._soundById(r[a]);
                    u && u._node && (u._node.volume = u._volume * e);
                }
                return o;
            }
            return o._volume;
        },
        mute: function(e) {
            var o = this || n;
            o.ctx || _(), o._muted = e, o.usingWebAudio && o.masterGain.gain.setValueAtTime(e ? 0 : o._volume, n.ctx.currentTime);
            for(var t = 0; t < o._howls.length; t++)if (!o._howls[t]._webAudio) for(var r = o._howls[t]._getSoundIds(), a = 0; a < r.length; a++){
                var u = o._howls[t]._soundById(r[a]);
                u && u._node && (u._node.muted = !!e || u._muted);
            }
            return o;
        },
        stop: function() {
            for(var e = this || n, o = 0; o < e._howls.length; o++)e._howls[o].stop();
            return e;
        },
        unload: function() {
            for(var e = this || n, o = e._howls.length - 1; o >= 0; o--)e._howls[o].unload();
            return e.usingWebAudio && e.ctx && void 0 !== e.ctx.close && (e.ctx.close(), e.ctx = null, _()), e;
        },
        codecs: function(e) {
            return (this || n)._codecs[e.replace(/^x-/, "")];
        },
        _setup: function() {
            var e = this || n;
            if (e.state = e.ctx ? e.ctx.state || "suspended" : "suspended", e._autoSuspend(), !e.usingWebAudio) {
                if ("undefined" != typeof Audio) try {
                    var o = new Audio;
                    void 0 === o.oncanplaythrough && (e._canPlayEvent = "canplay");
                } catch (n) {
                    e.noAudio = !0;
                }
                else e.noAudio = !0;
            }
            try {
                var o = new Audio;
                o.muted && (e.noAudio = !0);
            } catch (e) {}
            return e.noAudio || e._setupCodecs(), e;
        },
        _setupCodecs: function() {
            var e = this || n, o = null;
            try {
                o = "undefined" != typeof Audio ? new Audio : null;
            } catch (n) {
                return e;
            }
            if (!o || "function" != typeof o.canPlayType) return e;
            var t = o.canPlayType("audio/mpeg;").replace(/^no$/, ""), r = e._navigator ? e._navigator.userAgent : "", a = r.match(/OPR\/(\d+)/g), u = a && parseInt(a[0].split("/")[1], 10) < 33, d = -1 !== r.indexOf("Safari") && -1 === r.indexOf("Chrome"), i = r.match(/Version\/(.*?) /), _ = d && i && parseInt(i[1], 10) < 15;
            return e._codecs = {
                mp3: !(u || !t && !o.canPlayType("audio/mp3;").replace(/^no$/, "")),
                mpeg: !!t,
                opus: !!o.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ""),
                ogg: !!o.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                oga: !!o.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                wav: !!(o.canPlayType('audio/wav; codecs="1"') || o.canPlayType("audio/wav")).replace(/^no$/, ""),
                aac: !!o.canPlayType("audio/aac;").replace(/^no$/, ""),
                caf: !!o.canPlayType("audio/x-caf;").replace(/^no$/, ""),
                m4a: !!(o.canPlayType("audio/x-m4a;") || o.canPlayType("audio/m4a;") || o.canPlayType("audio/aac;")).replace(/^no$/, ""),
                m4b: !!(o.canPlayType("audio/x-m4b;") || o.canPlayType("audio/m4b;") || o.canPlayType("audio/aac;")).replace(/^no$/, ""),
                mp4: !!(o.canPlayType("audio/x-mp4;") || o.canPlayType("audio/mp4;") || o.canPlayType("audio/aac;")).replace(/^no$/, ""),
                weba: !(_ || !o.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                webm: !(_ || !o.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                dolby: !!o.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ""),
                flac: !!(o.canPlayType("audio/x-flac;") || o.canPlayType("audio/flac;")).replace(/^no$/, "")
            }, e;
        },
        _unlockAudio: function() {
            var e = this || n;
            if (!e._audioUnlocked && e.ctx) {
                e._audioUnlocked = !1, e.autoUnlock = !1, e._mobileUnloaded || 44100 === e.ctx.sampleRate || (e._mobileUnloaded = !0, e.unload()), e._scratchBuffer = e.ctx.createBuffer(1, 1, 22050);
                var o = function(n) {
                    for(; e._html5AudioPool.length < e.html5PoolSize;)try {
                        var t = new Audio;
                        t._unlocked = !0, e._releaseHtml5Audio(t);
                    } catch (n) {
                        e.noAudio = !0;
                        break;
                    }
                    for(var r = 0; r < e._howls.length; r++)if (!e._howls[r]._webAudio) for(var a = e._howls[r]._getSoundIds(), u = 0; u < a.length; u++){
                        var d = e._howls[r]._soundById(a[u]);
                        d && d._node && !d._node._unlocked && (d._node._unlocked = !0, d._node.load());
                    }
                    e._autoResume();
                    var i = e.ctx.createBufferSource();
                    i.buffer = e._scratchBuffer, i.connect(e.ctx.destination), void 0 === i.start ? i.noteOn(0) : i.start(0), "function" == typeof e.ctx.resume && e.ctx.resume(), i.onended = function() {
                        i.disconnect(0), e._audioUnlocked = !0, document.removeEventListener("touchstart", o, !0), document.removeEventListener("touchend", o, !0), document.removeEventListener("click", o, !0), document.removeEventListener("keydown", o, !0);
                        for(var n = 0; n < e._howls.length; n++)e._howls[n]._emit("unlock");
                    };
                };
                return document.addEventListener("touchstart", o, !0), document.addEventListener("touchend", o, !0), document.addEventListener("click", o, !0), document.addEventListener("keydown", o, !0), e;
            }
        },
        _obtainHtml5Audio: function() {
            var e = this || n;
            if (e._html5AudioPool.length) return e._html5AudioPool.pop();
            var o = (new Audio).play();
            return o && "undefined" != typeof Promise && (o instanceof Promise || "function" == typeof o.then) && o.catch(function() {
                console.warn("HTML5 Audio pool exhausted, returning potentially locked audio object.");
            }), new Audio;
        },
        _releaseHtml5Audio: function(e) {
            var o = this || n;
            return e._unlocked && o._html5AudioPool.push(e), o;
        },
        _autoSuspend: function() {
            var e = this;
            if (e.autoSuspend && e.ctx && void 0 !== e.ctx.suspend && n.usingWebAudio) {
                for(var o = 0; o < e._howls.length; o++)if (e._howls[o]._webAudio) {
                    for(var t = 0; t < e._howls[o]._sounds.length; t++)if (!e._howls[o]._sounds[t]._paused) return e;
                }
                return e._suspendTimer && clearTimeout(e._suspendTimer), e._suspendTimer = setTimeout(function() {
                    if (e.autoSuspend) {
                        e._suspendTimer = null, e.state = "suspending";
                        var n = function() {
                            e.state = "suspended", e._resumeAfterSuspend && (delete e._resumeAfterSuspend, e._autoResume());
                        };
                        e.ctx.suspend().then(n, n);
                    }
                }, 3e4), e;
            }
        },
        _autoResume: function() {
            var e = this;
            if (e.ctx && void 0 !== e.ctx.resume && n.usingWebAudio) return "running" === e.state && "interrupted" !== e.ctx.state && e._suspendTimer ? (clearTimeout(e._suspendTimer), e._suspendTimer = null) : "suspended" === e.state || "running" === e.state && "interrupted" === e.ctx.state ? (e.ctx.resume().then(function() {
                e.state = "running";
                for(var n = 0; n < e._howls.length; n++)e._howls[n]._emit("resume");
            }), e._suspendTimer && (clearTimeout(e._suspendTimer), e._suspendTimer = null)) : "suspending" === e.state && (e._resumeAfterSuspend = !0), e;
        }
    };
    var n = new e, o = function(e) {
        var n = this;
        if (!e.src || 0 === e.src.length) return void console.error("An array of source files must be passed with any new Howl.");
        n.init(e);
    };
    o.prototype = {
        init: function(e) {
            var o = this;
            return n.ctx || _(), o._autoplay = e.autoplay || !1, o._format = "string" != typeof e.format ? e.format : [
                e.format
            ], o._html5 = e.html5 || !1, o._muted = e.mute || !1, o._loop = e.loop || !1, o._pool = e.pool || 5, o._preload = "boolean" != typeof e.preload && "metadata" !== e.preload || e.preload, o._rate = e.rate || 1, o._sprite = e.sprite || {}, o._src = "string" != typeof e.src ? e.src : [
                e.src
            ], o._volume = void 0 !== e.volume ? e.volume : 1, o._xhr = {
                method: e.xhr && e.xhr.method ? e.xhr.method : "GET",
                headers: e.xhr && e.xhr.headers ? e.xhr.headers : null,
                withCredentials: !(!e.xhr || !e.xhr.withCredentials) && e.xhr.withCredentials
            }, o._duration = 0, o._state = "unloaded", o._sounds = [], o._endTimers = {}, o._queue = [], o._playLock = !1, o._onend = e.onend ? [
                {
                    fn: e.onend
                }
            ] : [], o._onfade = e.onfade ? [
                {
                    fn: e.onfade
                }
            ] : [], o._onload = e.onload ? [
                {
                    fn: e.onload
                }
            ] : [], o._onloaderror = e.onloaderror ? [
                {
                    fn: e.onloaderror
                }
            ] : [], o._onplayerror = e.onplayerror ? [
                {
                    fn: e.onplayerror
                }
            ] : [], o._onpause = e.onpause ? [
                {
                    fn: e.onpause
                }
            ] : [], o._onplay = e.onplay ? [
                {
                    fn: e.onplay
                }
            ] : [], o._onstop = e.onstop ? [
                {
                    fn: e.onstop
                }
            ] : [], o._onmute = e.onmute ? [
                {
                    fn: e.onmute
                }
            ] : [], o._onvolume = e.onvolume ? [
                {
                    fn: e.onvolume
                }
            ] : [], o._onrate = e.onrate ? [
                {
                    fn: e.onrate
                }
            ] : [], o._onseek = e.onseek ? [
                {
                    fn: e.onseek
                }
            ] : [], o._onunlock = e.onunlock ? [
                {
                    fn: e.onunlock
                }
            ] : [], o._onresume = [], o._webAudio = n.usingWebAudio && !o._html5, void 0 !== n.ctx && n.ctx && n.autoUnlock && n._unlockAudio(), n._howls.push(o), o._autoplay && o._queue.push({
                event: "play",
                action: function() {
                    o.play();
                }
            }), o._preload && "none" !== o._preload && o.load(), o;
        },
        load: function() {
            var e = this, o = null;
            if (n.noAudio) return void e._emit("loaderror", null, "No audio support.");
            "string" == typeof e._src && (e._src = [
                e._src
            ]);
            for(var r = 0; r < e._src.length; r++){
                var u, d;
                if (e._format && e._format[r]) u = e._format[r];
                else {
                    if ("string" != typeof (d = e._src[r])) {
                        e._emit("loaderror", null, "Non-string found in selected audio sources - ignoring.");
                        continue;
                    }
                    u = /^data:audio\/([^;,]+);/i.exec(d), u || (u = /\.([^.]+)$/.exec(d.split("?", 1)[0])), u && (u = u[1].toLowerCase());
                }
                if (u || console.warn('No file extension was found. Consider using the "format" property or specify an extension.'), u && n.codecs(u)) {
                    o = e._src[r];
                    break;
                }
            }
            return o ? (e._src = o, e._state = "loading", "https:" === window.location.protocol && "http:" === o.slice(0, 5) && (e._html5 = !0, e._webAudio = !1), new t(e), e._webAudio && a(e), e) : void e._emit("loaderror", null, "No codec support for selected audio sources.");
        },
        play: function(e, o) {
            var t = this, r = null;
            if ("number" == typeof e) r = e, e = null;
            else {
                if ("string" == typeof e && "loaded" === t._state && !t._sprite[e]) return null;
                if (void 0 === e && (e = "__default", !t._playLock)) {
                    for(var a = 0, u = 0; u < t._sounds.length; u++)t._sounds[u]._paused && !t._sounds[u]._ended && (a++, r = t._sounds[u]._id);
                    1 === a ? e = null : r = null;
                }
            }
            var d = r ? t._soundById(r) : t._inactiveSound();
            if (!d) return null;
            if (r && !e && (e = d._sprite || "__default"), "loaded" !== t._state) {
                d._sprite = e, d._ended = !1;
                var i = d._id;
                return t._queue.push({
                    event: "play",
                    action: function() {
                        t.play(i);
                    }
                }), i;
            }
            if (r && !d._paused) return o || t._loadQueue("play"), d._id;
            t._webAudio && n._autoResume();
            var _ = Math.max(0, d._seek > 0 ? d._seek : t._sprite[e][0] / 1e3), s = Math.max(0, (t._sprite[e][0] + t._sprite[e][1]) / 1e3 - _), l = 1e3 * s / Math.abs(d._rate), c = t._sprite[e][0] / 1e3, f = (t._sprite[e][0] + t._sprite[e][1]) / 1e3;
            d._sprite = e, d._ended = !1;
            var p = function() {
                d._paused = !1, d._seek = _, d._start = c, d._stop = f, d._loop = !(!d._loop && !t._sprite[e][2]);
            };
            if (_ >= f) return void t._ended(d);
            var m = d._node;
            if (t._webAudio) {
                var v = function() {
                    t._playLock = !1, p(), t._refreshBuffer(d);
                    var e = d._muted || t._muted ? 0 : d._volume;
                    m.gain.setValueAtTime(e, n.ctx.currentTime), d._playStart = n.ctx.currentTime, void 0 === m.bufferSource.start ? d._loop ? m.bufferSource.noteGrainOn(0, _, 86400) : m.bufferSource.noteGrainOn(0, _, s) : d._loop ? m.bufferSource.start(0, _, 86400) : m.bufferSource.start(0, _, s), l !== 1 / 0 && (t._endTimers[d._id] = setTimeout(t._ended.bind(t, d), l)), o || setTimeout(function() {
                        t._emit("play", d._id), t._loadQueue();
                    }, 0);
                };
                "running" === n.state && "interrupted" !== n.ctx.state ? v() : (t._playLock = !0, t.once("resume", v), t._clearTimer(d._id));
            } else {
                var h = function() {
                    m.currentTime = _, m.muted = d._muted || t._muted || n._muted || m.muted, m.volume = d._volume * n.volume(), m.playbackRate = d._rate;
                    try {
                        var r = m.play();
                        if (r && "undefined" != typeof Promise && (r instanceof Promise || "function" == typeof r.then) ? (t._playLock = !0, p(), r.then(function() {
                            t._playLock = !1, m._unlocked = !0, o ? t._loadQueue() : t._emit("play", d._id);
                        }).catch(function() {
                            t._playLock = !1, t._emit("playerror", d._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction."), d._ended = !0, d._paused = !0;
                        })) : o || (t._playLock = !1, p(), t._emit("play", d._id)), m.playbackRate = d._rate, m.paused) return void t._emit("playerror", d._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                        "__default" !== e || d._loop ? t._endTimers[d._id] = setTimeout(t._ended.bind(t, d), l) : (t._endTimers[d._id] = function() {
                            t._ended(d), m.removeEventListener("ended", t._endTimers[d._id], !1);
                        }, m.addEventListener("ended", t._endTimers[d._id], !1));
                    } catch (e) {
                        t._emit("playerror", d._id, e);
                    }
                };
                "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA" === m.src && (m.src = t._src, m.load());
                var y = window && window.ejecta || !m.readyState && n._navigator.isCocoonJS;
                if (m.readyState >= 3 || y) h();
                else {
                    t._playLock = !0, t._state = "loading";
                    var g = function() {
                        t._state = "loaded", h(), m.removeEventListener(n._canPlayEvent, g, !1);
                    };
                    m.addEventListener(n._canPlayEvent, g, !1), t._clearTimer(d._id);
                }
            }
            return d._id;
        },
        pause: function(e) {
            var n = this;
            if ("loaded" !== n._state || n._playLock) return n._queue.push({
                event: "pause",
                action: function() {
                    n.pause(e);
                }
            }), n;
            for(var o = n._getSoundIds(e), t = 0; t < o.length; t++){
                n._clearTimer(o[t]);
                var r = n._soundById(o[t]);
                if (r && !r._paused && (r._seek = n.seek(o[t]), r._rateSeek = 0, r._paused = !0, n._stopFade(o[t]), r._node)) {
                    if (n._webAudio) {
                        if (!r._node.bufferSource) continue;
                        void 0 === r._node.bufferSource.stop ? r._node.bufferSource.noteOff(0) : r._node.bufferSource.stop(0), n._cleanBuffer(r._node);
                    } else isNaN(r._node.duration) && r._node.duration !== 1 / 0 || r._node.pause();
                }
                arguments[1] || n._emit("pause", r ? r._id : null);
            }
            return n;
        },
        stop: function(e, n) {
            var o = this;
            if ("loaded" !== o._state || o._playLock) return o._queue.push({
                event: "stop",
                action: function() {
                    o.stop(e);
                }
            }), o;
            for(var t = o._getSoundIds(e), r = 0; r < t.length; r++){
                o._clearTimer(t[r]);
                var a = o._soundById(t[r]);
                a && (a._seek = a._start || 0, a._rateSeek = 0, a._paused = !0, a._ended = !0, o._stopFade(t[r]), a._node && (o._webAudio ? a._node.bufferSource && (void 0 === a._node.bufferSource.stop ? a._node.bufferSource.noteOff(0) : a._node.bufferSource.stop(0), o._cleanBuffer(a._node)) : isNaN(a._node.duration) && a._node.duration !== 1 / 0 || (a._node.currentTime = a._start || 0, a._node.pause(), a._node.duration === 1 / 0 && o._clearSound(a._node))), n || o._emit("stop", a._id));
            }
            return o;
        },
        mute: function(e, o) {
            var t = this;
            if ("loaded" !== t._state || t._playLock) return t._queue.push({
                event: "mute",
                action: function() {
                    t.mute(e, o);
                }
            }), t;
            if (void 0 === o) {
                if ("boolean" != typeof e) return t._muted;
                t._muted = e;
            }
            for(var r = t._getSoundIds(o), a = 0; a < r.length; a++){
                var u = t._soundById(r[a]);
                u && (u._muted = e, u._interval && t._stopFade(u._id), t._webAudio && u._node ? u._node.gain.setValueAtTime(e ? 0 : u._volume, n.ctx.currentTime) : u._node && (u._node.muted = !!n._muted || e), t._emit("mute", u._id));
            }
            return t;
        },
        volume: function() {
            var e, o, t = this, r = arguments;
            if (0 === r.length) return t._volume;
            if (1 === r.length || 2 === r.length && void 0 === r[1]) t._getSoundIds().indexOf(r[0]) >= 0 ? o = parseInt(r[0], 10) : e = parseFloat(r[0]);
            else r.length >= 2 && (e = parseFloat(r[0]), o = parseInt(r[1], 10));
            var a;
            if (!(void 0 !== e && e >= 0 && e <= 1)) return a = o ? t._soundById(o) : t._sounds[0], a ? a._volume : 0;
            if ("loaded" !== t._state || t._playLock) return t._queue.push({
                event: "volume",
                action: function() {
                    t.volume.apply(t, r);
                }
            }), t;
            void 0 === o && (t._volume = e), o = t._getSoundIds(o);
            for(var u = 0; u < o.length; u++)(a = t._soundById(o[u])) && (a._volume = e, r[2] || t._stopFade(o[u]), t._webAudio && a._node && !a._muted ? a._node.gain.setValueAtTime(e, n.ctx.currentTime) : a._node && !a._muted && (a._node.volume = e * n.volume()), t._emit("volume", a._id));
            return t;
        },
        fade: function(e, o, t, r) {
            var a = this;
            if ("loaded" !== a._state || a._playLock) return a._queue.push({
                event: "fade",
                action: function() {
                    a.fade(e, o, t, r);
                }
            }), a;
            e = Math.min(Math.max(0, parseFloat(e)), 1), o = Math.min(Math.max(0, parseFloat(o)), 1), t = parseFloat(t), a.volume(e, r);
            for(var u = a._getSoundIds(r), d = 0; d < u.length; d++){
                var i = a._soundById(u[d]);
                if (i) {
                    if (r || a._stopFade(u[d]), a._webAudio && !i._muted) {
                        var _ = n.ctx.currentTime, s = _ + t / 1e3;
                        i._volume = e, i._node.gain.setValueAtTime(e, _), i._node.gain.linearRampToValueAtTime(o, s);
                    }
                    a._startFadeInterval(i, e, o, t, u[d], void 0 === r);
                }
            }
            return a;
        },
        _startFadeInterval: function(e, n, o, t, r, a) {
            var u = this, d = n, i = o - n, _ = Math.abs(i / .01), s = Math.max(4, _ > 0 ? t / _ : t), l = Date.now();
            e._fadeTo = o, e._interval = setInterval(function() {
                var r = (Date.now() - l) / t;
                l = Date.now(), d += i * r, d = Math.round(100 * d) / 100, d = i < 0 ? Math.max(o, d) : Math.min(o, d), u._webAudio ? e._volume = d : u.volume(d, e._id, !0), a && (u._volume = d), (o < n && d <= o || o > n && d >= o) && (clearInterval(e._interval), e._interval = null, e._fadeTo = null, u.volume(o, e._id), u._emit("fade", e._id));
            }, s);
        },
        _stopFade: function(e) {
            var o = this, t = o._soundById(e);
            return t && t._interval && (o._webAudio && t._node.gain.cancelScheduledValues(n.ctx.currentTime), clearInterval(t._interval), t._interval = null, o.volume(t._fadeTo, e), t._fadeTo = null, o._emit("fade", e)), o;
        },
        loop: function() {
            var e, n, o, t = this, r = arguments;
            if (0 === r.length) return t._loop;
            if (1 === r.length) {
                if ("boolean" != typeof r[0]) return !!(o = t._soundById(parseInt(r[0], 10))) && o._loop;
                e = r[0], t._loop = e;
            } else 2 === r.length && (e = r[0], n = parseInt(r[1], 10));
            for(var a = t._getSoundIds(n), u = 0; u < a.length; u++)(o = t._soundById(a[u])) && (o._loop = e, t._webAudio && o._node && o._node.bufferSource && (o._node.bufferSource.loop = e, e && (o._node.bufferSource.loopStart = o._start || 0, o._node.bufferSource.loopEnd = o._stop, t.playing(a[u]) && (t.pause(a[u], !0), t.play(a[u], !0)))));
            return t;
        },
        rate: function() {
            var e, o, t = this, r = arguments;
            if (0 === r.length) o = t._sounds[0]._id;
            else if (1 === r.length) {
                var a = t._getSoundIds(), u = a.indexOf(r[0]);
                u >= 0 ? o = parseInt(r[0], 10) : e = parseFloat(r[0]);
            } else 2 === r.length && (e = parseFloat(r[0]), o = parseInt(r[1], 10));
            var d;
            if ("number" != typeof e) return d = t._soundById(o), d ? d._rate : t._rate;
            if ("loaded" !== t._state || t._playLock) return t._queue.push({
                event: "rate",
                action: function() {
                    t.rate.apply(t, r);
                }
            }), t;
            void 0 === o && (t._rate = e), o = t._getSoundIds(o);
            for(var i = 0; i < o.length; i++)if (d = t._soundById(o[i])) {
                t.playing(o[i]) && (d._rateSeek = t.seek(o[i]), d._playStart = t._webAudio ? n.ctx.currentTime : d._playStart), d._rate = e, t._webAudio && d._node && d._node.bufferSource ? d._node.bufferSource.playbackRate.setValueAtTime(e, n.ctx.currentTime) : d._node && (d._node.playbackRate = e);
                var _ = t.seek(o[i]), s = (t._sprite[d._sprite][0] + t._sprite[d._sprite][1]) / 1e3 - _, l = 1e3 * s / Math.abs(d._rate);
                !t._endTimers[o[i]] && d._paused || (t._clearTimer(o[i]), t._endTimers[o[i]] = setTimeout(t._ended.bind(t, d), l)), t._emit("rate", d._id);
            }
            return t;
        },
        seek: function() {
            var e, o, t = this, r = arguments;
            if (0 === r.length) t._sounds.length && (o = t._sounds[0]._id);
            else if (1 === r.length) {
                var a = t._getSoundIds(), u = a.indexOf(r[0]);
                u >= 0 ? o = parseInt(r[0], 10) : t._sounds.length && (o = t._sounds[0]._id, e = parseFloat(r[0]));
            } else 2 === r.length && (e = parseFloat(r[0]), o = parseInt(r[1], 10));
            if (void 0 === o) return 0;
            if ("number" == typeof e && ("loaded" !== t._state || t._playLock)) return t._queue.push({
                event: "seek",
                action: function() {
                    t.seek.apply(t, r);
                }
            }), t;
            var d = t._soundById(o);
            if (d) {
                if (!("number" == typeof e && e >= 0)) {
                    if (t._webAudio) {
                        var i = t.playing(o) ? n.ctx.currentTime - d._playStart : 0, _ = d._rateSeek ? d._rateSeek - d._seek : 0;
                        return d._seek + (_ + i * Math.abs(d._rate));
                    }
                    return d._node.currentTime;
                }
                var s = t.playing(o);
                s && t.pause(o, !0), d._seek = e, d._ended = !1, t._clearTimer(o), t._webAudio || !d._node || isNaN(d._node.duration) || (d._node.currentTime = e);
                var l = function() {
                    s && t.play(o, !0), t._emit("seek", o);
                };
                if (s && !t._webAudio) {
                    var c = function() {
                        t._playLock ? setTimeout(c, 0) : l();
                    };
                    setTimeout(c, 0);
                } else l();
            }
            return t;
        },
        playing: function(e) {
            var n = this;
            if ("number" == typeof e) {
                var o = n._soundById(e);
                return !!o && !o._paused;
            }
            for(var t = 0; t < n._sounds.length; t++)if (!n._sounds[t]._paused) return !0;
            return !1;
        },
        duration: function(e) {
            var n = this, o = n._duration, t = n._soundById(e);
            return t && (o = n._sprite[t._sprite][1] / 1e3), o;
        },
        state: function() {
            return this._state;
        },
        unload: function() {
            for(var e = this, o = e._sounds, t = 0; t < o.length; t++)o[t]._paused || e.stop(o[t]._id), e._webAudio || (e._clearSound(o[t]._node), o[t]._node.removeEventListener("error", o[t]._errorFn, !1), o[t]._node.removeEventListener(n._canPlayEvent, o[t]._loadFn, !1), o[t]._node.removeEventListener("ended", o[t]._endFn, !1), n._releaseHtml5Audio(o[t]._node)), delete o[t]._node, e._clearTimer(o[t]._id);
            var a = n._howls.indexOf(e);
            a >= 0 && n._howls.splice(a, 1);
            var u = !0;
            for(t = 0; t < n._howls.length; t++)if (n._howls[t]._src === e._src || e._src.indexOf(n._howls[t]._src) >= 0) {
                u = !1;
                break;
            }
            return r && u && delete r[e._src], n.noAudio = !1, e._state = "unloaded", e._sounds = [], e = null, null;
        },
        on: function(e, n, o, t) {
            var r = this, a = r["_on" + e];
            return "function" == typeof n && a.push(t ? {
                id: o,
                fn: n,
                once: t
            } : {
                id: o,
                fn: n
            }), r;
        },
        off: function(e, n, o) {
            var t = this, r = t["_on" + e], a = 0;
            if ("number" == typeof n && (o = n, n = null), n || o) for(a = 0; a < r.length; a++){
                var u = o === r[a].id;
                if (n === r[a].fn && u || !n && u) {
                    r.splice(a, 1);
                    break;
                }
            }
            else if (e) t["_on" + e] = [];
            else {
                var d = Object.keys(t);
                for(a = 0; a < d.length; a++)0 === d[a].indexOf("_on") && Array.isArray(t[d[a]]) && (t[d[a]] = []);
            }
            return t;
        },
        once: function(e, n, o) {
            var t = this;
            return t.on(e, n, o, 1), t;
        },
        _emit: function(e, n, o) {
            for(var t = this, r = t["_on" + e], a = r.length - 1; a >= 0; a--)r[a].id && r[a].id !== n && "load" !== e || (setTimeout((function(e) {
                e.call(this, n, o);
            }).bind(t, r[a].fn), 0), r[a].once && t.off(e, r[a].fn, r[a].id));
            return t._loadQueue(e), t;
        },
        _loadQueue: function(e) {
            var n = this;
            if (n._queue.length > 0) {
                var o = n._queue[0];
                o.event === e && (n._queue.shift(), n._loadQueue()), e || o.action();
            }
            return n;
        },
        _ended: function(e) {
            var o = this, t = e._sprite;
            if (!o._webAudio && e._node && !e._node.paused && !e._node.ended && e._node.currentTime < e._stop) return setTimeout(o._ended.bind(o, e), 100), o;
            var r = !(!e._loop && !o._sprite[t][2]);
            if (o._emit("end", e._id), !o._webAudio && r && o.stop(e._id, !0).play(e._id), o._webAudio && r) {
                o._emit("play", e._id), e._seek = e._start || 0, e._rateSeek = 0, e._playStart = n.ctx.currentTime;
                var a = 1e3 * (e._stop - e._start) / Math.abs(e._rate);
                o._endTimers[e._id] = setTimeout(o._ended.bind(o, e), a);
            }
            return o._webAudio && !r && (e._paused = !0, e._ended = !0, e._seek = e._start || 0, e._rateSeek = 0, o._clearTimer(e._id), o._cleanBuffer(e._node), n._autoSuspend()), o._webAudio || r || o.stop(e._id, !0), o;
        },
        _clearTimer: function(e) {
            var n = this;
            if (n._endTimers[e]) {
                if ("function" != typeof n._endTimers[e]) clearTimeout(n._endTimers[e]);
                else {
                    var o = n._soundById(e);
                    o && o._node && o._node.removeEventListener("ended", n._endTimers[e], !1);
                }
                delete n._endTimers[e];
            }
            return n;
        },
        _soundById: function(e) {
            for(var n = this, o = 0; o < n._sounds.length; o++)if (e === n._sounds[o]._id) return n._sounds[o];
            return null;
        },
        _inactiveSound: function() {
            var e = this;
            e._drain();
            for(var n = 0; n < e._sounds.length; n++)if (e._sounds[n]._ended) return e._sounds[n].reset();
            return new t(e);
        },
        _drain: function() {
            var e = this, n = e._pool, o = 0, t = 0;
            if (!(e._sounds.length < n)) {
                for(t = 0; t < e._sounds.length; t++)e._sounds[t]._ended && o++;
                for(t = e._sounds.length - 1; t >= 0; t--){
                    if (o <= n) return;
                    e._sounds[t]._ended && (e._webAudio && e._sounds[t]._node && e._sounds[t]._node.disconnect(0), e._sounds.splice(t, 1), o--);
                }
            }
        },
        _getSoundIds: function(e) {
            var n = this;
            if (void 0 === e) {
                for(var o = [], t = 0; t < n._sounds.length; t++)o.push(n._sounds[t]._id);
                return o;
            }
            return [
                e
            ];
        },
        _refreshBuffer: function(e) {
            var o = this;
            return e._node.bufferSource = n.ctx.createBufferSource(), e._node.bufferSource.buffer = r[o._src], e._panner ? e._node.bufferSource.connect(e._panner) : e._node.bufferSource.connect(e._node), e._node.bufferSource.loop = e._loop, e._loop && (e._node.bufferSource.loopStart = e._start || 0, e._node.bufferSource.loopEnd = e._stop || 0), e._node.bufferSource.playbackRate.setValueAtTime(e._rate, n.ctx.currentTime), o;
        },
        _cleanBuffer: function(e) {
            var o = this, t = n._navigator && n._navigator.vendor.indexOf("Apple") >= 0;
            if (!e.bufferSource) return o;
            if (n._scratchBuffer && e.bufferSource && (e.bufferSource.onended = null, e.bufferSource.disconnect(0), t)) try {
                e.bufferSource.buffer = n._scratchBuffer;
            } catch (e) {}
            return e.bufferSource = null, o;
        },
        _clearSound: function(e) {
            /MSIE |Trident\//.test(n._navigator && n._navigator.userAgent) || (e.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA");
        }
    };
    var t = function(e) {
        this._parent = e, this.init();
    };
    t.prototype = {
        init: function() {
            var e = this, o = e._parent;
            return e._muted = o._muted, e._loop = o._loop, e._volume = o._volume, e._rate = o._rate, e._seek = 0, e._paused = !0, e._ended = !0, e._sprite = "__default", e._id = ++n._counter, o._sounds.push(e), e.create(), e;
        },
        create: function() {
            var e = this, o = e._parent, t = n._muted || e._muted || e._parent._muted ? 0 : e._volume;
            return o._webAudio ? (e._node = void 0 === n.ctx.createGain ? n.ctx.createGainNode() : n.ctx.createGain(), e._node.gain.setValueAtTime(t, n.ctx.currentTime), e._node.paused = !0, e._node.connect(n.masterGain)) : n.noAudio || (e._node = n._obtainHtml5Audio(), e._errorFn = e._errorListener.bind(e), e._node.addEventListener("error", e._errorFn, !1), e._loadFn = e._loadListener.bind(e), e._node.addEventListener(n._canPlayEvent, e._loadFn, !1), e._endFn = e._endListener.bind(e), e._node.addEventListener("ended", e._endFn, !1), e._node.src = o._src, e._node.preload = !0 === o._preload ? "auto" : o._preload, e._node.volume = t * n.volume(), e._node.load()), e;
        },
        reset: function() {
            var e = this, o = e._parent;
            return e._muted = o._muted, e._loop = o._loop, e._volume = o._volume, e._rate = o._rate, e._seek = 0, e._rateSeek = 0, e._paused = !0, e._ended = !0, e._sprite = "__default", e._id = ++n._counter, e;
        },
        _errorListener: function() {
            var e = this;
            e._parent._emit("loaderror", e._id, e._node.error ? e._node.error.code : 0), e._node.removeEventListener("error", e._errorFn, !1);
        },
        _loadListener: function() {
            var e = this, o = e._parent;
            o._duration = Math.ceil(10 * e._node.duration) / 10, 0 === Object.keys(o._sprite).length && (o._sprite = {
                __default: [
                    0,
                    1e3 * o._duration
                ]
            }), "loaded" !== o._state && (o._state = "loaded", o._emit("load"), o._loadQueue()), e._node.removeEventListener(n._canPlayEvent, e._loadFn, !1);
        },
        _endListener: function() {
            var e = this, n = e._parent;
            n._duration === 1 / 0 && (n._duration = Math.ceil(10 * e._node.duration) / 10, n._sprite.__default[1] === 1 / 0 && (n._sprite.__default[1] = 1e3 * n._duration), n._ended(e)), e._node.removeEventListener("ended", e._endFn, !1);
        }
    };
    var r = {}, a = function(e) {
        var n = e._src;
        if (r[n]) return e._duration = r[n].duration, void i(e);
        if (/^data:[^;]+;base64,/.test(n)) {
            for(var o = atob(n.split(",")[1]), t = new Uint8Array(o.length), a = 0; a < o.length; ++a)t[a] = o.charCodeAt(a);
            d(t.buffer, e);
        } else {
            var _ = new XMLHttpRequest;
            _.open(e._xhr.method, n, !0), _.withCredentials = e._xhr.withCredentials, _.responseType = "arraybuffer", e._xhr.headers && Object.keys(e._xhr.headers).forEach(function(n) {
                _.setRequestHeader(n, e._xhr.headers[n]);
            }), _.onload = function() {
                var n = (_.status + "")[0];
                if ("0" !== n && "2" !== n && "3" !== n) return void e._emit("loaderror", null, "Failed loading audio file with status: " + _.status + ".");
                d(_.response, e);
            }, _.onerror = function() {
                e._webAudio && (e._html5 = !0, e._webAudio = !1, e._sounds = [], delete r[n], e.load());
            }, u(_);
        }
    }, u = function(e) {
        try {
            e.send();
        } catch (n) {
            e.onerror();
        }
    }, d = function(e, o) {
        var t = function() {
            o._emit("loaderror", null, "Decoding audio data failed.");
        }, a = function(e) {
            e && o._sounds.length > 0 ? (r[o._src] = e, i(o, e)) : t();
        };
        "undefined" != typeof Promise && 1 === n.ctx.decodeAudioData.length ? n.ctx.decodeAudioData(e).then(a).catch(t) : n.ctx.decodeAudioData(e, a, t);
    }, i = function(e, n) {
        n && !e._duration && (e._duration = n.duration), 0 === Object.keys(e._sprite).length && (e._sprite = {
            __default: [
                0,
                1e3 * e._duration
            ]
        }), "loaded" !== e._state && (e._state = "loaded", e._emit("load"), e._loadQueue());
    }, _ = function() {
        if (n.usingWebAudio) {
            try {
                "undefined" != typeof AudioContext ? n.ctx = new AudioContext : "undefined" != typeof webkitAudioContext ? n.ctx = new webkitAudioContext : n.usingWebAudio = !1;
            } catch (e) {
                n.usingWebAudio = !1;
            }
            n.ctx || (n.usingWebAudio = !1);
            var e = /iP(hone|od|ad)/.test(n._navigator && n._navigator.platform), o = n._navigator && n._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/), t = o ? parseInt(o[1], 10) : null;
            if (e && t && t < 9) {
                var r = /safari/.test(n._navigator && n._navigator.userAgent.toLowerCase());
                n._navigator && !r && (n.usingWebAudio = !1);
            }
            n.usingWebAudio && (n.masterGain = void 0 === n.ctx.createGain ? n.ctx.createGainNode() : n.ctx.createGain(), n.masterGain.gain.setValueAtTime(n._muted ? 0 : n._volume, n.ctx.currentTime), n.masterGain.connect(n.ctx.destination)), n._setup();
        }
    };
    "function" == typeof define && define.amd && define([], function() {
        return {
            Howler: n,
            Howl: o
        };
    }), $75e03579e62b4980$export$c9d39ca3bcd93abb = n, $75e03579e62b4980$export$b791fe48eec8032a = o, "undefined" != typeof $parcel$global ? ($parcel$global.HowlerGlobal = e, $parcel$global.Howler = n, $parcel$global.Howl = o, $parcel$global.Sound = t) : "undefined" != typeof window && (window.HowlerGlobal = e, window.Howler = n, window.Howl = o, window.Sound = t);
}();

});

var $01494118b1e6559d$exports = {};
"use strict";

$01494118b1e6559d$exports = (parcelRequire("b5a3Y"));


parcelRequire("1fELX");
var $62253b9dcd75e122$export$882461b6382ed46c;
var $62253b9dcd75e122$export$757ceba2d55c277e;
"use strict";
var $1d18ee8fb4ef5a7f$exports = {};
"use strict";
function $1d18ee8fb4ef5a7f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1d18ee8fb4ef5a7f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1d18ee8fb4ef5a7f$var$checkDCE();

$1d18ee8fb4ef5a7f$exports = (parcelRequire("1dCCy"));


var $62253b9dcd75e122$var$i;
$62253b9dcd75e122$export$882461b6382ed46c = $1d18ee8fb4ef5a7f$exports.createRoot;
$62253b9dcd75e122$export$757ceba2d55c277e = $1d18ee8fb4ef5a7f$exports.hydrateRoot;



parcelRequire("1fELX");


var $1fELX = parcelRequire("1fELX");


var $1fELX = parcelRequire("1fELX");
var $fe11df8941c5cc1d$export$23c7328964450bd2;
(function(GameStatus) {
    GameStatus["Title"] = "game_status--title";
    GameStatus["Started"] = "game_status--started";
    GameStatus["Paused"] = "game_status--paused";
    GameStatus["Ready"] = "game_status--ready";
    GameStatus["Finished"] = "game_status--finished";
    GameStatus["Leaderboard"] = "game_status--leaderboard";
    GameStatus["PlayerDetails"] = "game_status--player_details";
})($fe11df8941c5cc1d$export$23c7328964450bd2 || ($fe11df8941c5cc1d$export$23c7328964450bd2 = {}));




const $5b61aaedfb6d7f4f$export$ff90cd3c8a8f97de = "sm_playerInfo";
const $5b61aaedfb6d7f4f$export$73542a68f45c89c2 = ()=>{
    const playerInfoStr = localStorage.getItem($5b61aaedfb6d7f4f$export$ff90cd3c8a8f97de);
    if (!playerInfoStr) return [];
    const parsedPlayerInfo = JSON.parse(playerInfoStr);
    if (!Array.isArray(parsedPlayerInfo)) throw new Error("Invalid player info in local storage");
    return parsedPlayerInfo;
};
const $5b61aaedfb6d7f4f$export$4c6503a9ef13db27 = async (newPlayerInfo)=>{
    const playerInfo = $5b61aaedfb6d7f4f$export$73542a68f45c89c2();
    playerInfo.push(newPlayerInfo);
    localStorage.setItem($5b61aaedfb6d7f4f$export$ff90cd3c8a8f97de, JSON.stringify(playerInfo));
};



parcelRequire("1fELX");

var $1fELX = parcelRequire("1fELX");
function $d4d68b59540df7f6$var$_extends() {
    $d4d68b59540df7f6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d4d68b59540df7f6$var$_extends.apply(this, arguments);
}
function $d4d68b59540df7f6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d4d68b59540df7f6$var$useOnMount(callback) {
    (0, $1fELX.useEffect)(callback, []);
}

function $d4d68b59540df7f6$export$a34349420ba3cec8(src, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$volume = _ref2.volume, volume = _ref2$volume === void 0 ? 1 : _ref2$volume, _ref2$playbackRate = _ref2.playbackRate, playbackRate = _ref2$playbackRate === void 0 ? 1 : _ref2$playbackRate, _ref2$soundEnabled = _ref2.soundEnabled, soundEnabled = _ref2$soundEnabled === void 0 ? true : _ref2$soundEnabled, _ref2$interrupt = _ref2.interrupt, interrupt = _ref2$interrupt === void 0 ? false : _ref2$interrupt, onload = _ref2.onload, delegated = $d4d68b59540df7f6$var$_objectWithoutPropertiesLoose(_ref2, [
        "id",
        "volume",
        "playbackRate",
        "soundEnabled",
        "interrupt",
        "onload"
    ]);
    var HowlConstructor = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef(null);
    var isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useState(null), duration = _React$useState[0], setDuration = _React$useState[1];
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useState(null), sound = _React$useState2[0], setSound = _React$useState2[1];
    var handleLoad = function handleLoad() {
        if (typeof onload === "function") // @ts-ignore
        onload.call(this);
        if (isMounted.current) // @ts-ignore
        setDuration(this.duration() * 1000);
         // @ts-ignore
        setSound(this);
    }; // We want to lazy-load Howler, since sounds can't play on load anyway.
    $d4d68b59540df7f6$var$useOnMount(function() {
        Promise.resolve((parcelRequire("a7rUz"))).then(function(mod) {
            if (!isMounted.current) {
                var _mod$Howl;
                // Depending on the module system used, `mod` might hold
                // the export directly, or it might be under `default`.
                HowlConstructor.current = (_mod$Howl = mod.Howl) !== null && _mod$Howl !== void 0 ? _mod$Howl : mod["default"].Howl;
                isMounted.current = true;
                new HowlConstructor.current($d4d68b59540df7f6$var$_extends({
                    src: Array.isArray(src) ? src : [
                        src
                    ],
                    volume: volume,
                    rate: playbackRate,
                    onload: handleLoad
                }, delegated));
            }
        });
        return function() {
            isMounted.current = false;
        };
    }); // When the `src` changes, we have to do a whole thing where we recreate
    // the Howl instance. This is because Howler doesn't expose a way to
    // tweak the sound
    (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useEffect(function() {
        if (HowlConstructor.current && sound) setSound(new HowlConstructor.current($d4d68b59540df7f6$var$_extends({
            src: Array.isArray(src) ? src : [
                src
            ],
            volume: volume,
            onload: handleLoad
        }, delegated)));
         // The linter wants to run this effect whenever ANYTHING changes,
    // but very specifically I only want to recreate the Howl instance
    // when the `src` changes. Other changes should have no effect.
    // Passing array to the useEffect dependencies list will result in
    // ifinite loop so we need to stringify it, for more details check
    // https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(src)
    ]); // Whenever volume/playbackRate are changed, change those properties
    // on the sound instance.
    (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useEffect(function() {
        if (sound) {
            sound.volume(volume);
            sound.rate(playbackRate);
        } // A weird bug means that including the `sound` here can trigger an
    // error on unmount, where the state loses track of the sprites??
    // No idea, but anyway I don't need to re-run this if only the `sound`
    // changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        volume,
        playbackRate
    ]);
    var play = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback(function(options) {
        if (typeof options === "undefined") options = {};
        if (!sound || !soundEnabled && !options.forceSoundEnabled) return;
        if (interrupt) sound.stop();
        if (options.playbackRate) sound.rate(options.playbackRate);
        sound.play(options.id);
    }, [
        sound,
        soundEnabled,
        interrupt
    ]);
    var stop = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback(function(id) {
        if (!sound) return;
        sound.stop(id);
    }, [
        sound
    ]);
    var pause = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback(function(id) {
        if (!sound) return;
        sound.pause(id);
    }, [
        sound
    ]);
    var returnedValue = [
        play,
        {
            sound: sound,
            stop: stop,
            pause: pause,
            duration: duration
        }
    ];
    return returnedValue;
}
var $d4d68b59540df7f6$export$2e2bcd8739ae039 = $d4d68b59540df7f6$export$a34349420ba3cec8;


var $850715ba787e56c1$exports = {};


$850715ba787e56c1$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("15bra");


var $c4ef87ec98a2975b$exports = {};


$c4ef87ec98a2975b$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("hB2Ze");


const $b280a35ff744d18b$export$b89a827e9254211a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
        className: "fixed top-[5%] bottom-[5%] left-1/2 -translate-x-1/2 flex justify-stretch items-stretch bg-opacity-70 aspect-[4/3] pt-[9vh] pb-[8vh] px-[12vh]",
        style: {
            backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($850715ba787e56c1$exports)))})`
        },
        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
            className: "flex-grow flex flex-col gap-4",
            children: children
        })
    });
};
const $b280a35ff744d18b$export$8868dba5c6237081 = ({ children: children, variant: variant = "neutral" })=>{
    const variantClassName = variant === "primary" ? "bg-primary text-neutral-900" : "bg-neutral-400 text-white";
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("header", {
        className: `flex items-center justify-center rounded-2xl text-center mb-8 ${variantClassName}`,
        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("h2", {
            className: "text-display1 font-semibold tracking-wide flex items-center p-2",
            children: children
        })
    });
};
const $b280a35ff744d18b$export$a2a14dc5e9bae153 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("main", {
        className: " max-h-[60vh]",
        children: children
    });
};
const $b280a35ff744d18b$export$f1011c2ab959143d = ({ children: children })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("footer", {
        className: "flex justify-center gap-10 mt-auto",
        children: children
    });
};
const $b280a35ff744d18b$export$59ad24bf1c8e19d9 = ({ children: children, variant: variant = "neutral", type: type = "button", onClick: onClick, ...rest })=>{
    const [play] = (0, $d4d68b59540df7f6$export$a34349420ba3cec8)((0, (/*@__PURE__*/$parcel$interopDefault($c4ef87ec98a2975b$exports))), {
        interrupt: true
    });
    const variantClassName = variant === "primary" ? "bg-primary text-neutral-900" : "bg-neutral-400 text-neutral-100";
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("button", {
        className: `inline-flex rounded-xl py-4 px-5 font-bold ease-out hover:brightness-110 gap-2 ${variantClassName}`,
        type: type,
        onClick: (event)=>{
            play();
            onClick?.(event);
        },
        ...rest,
        children: children
    });
};




var $1fELX = parcelRequire("1fELX");
const $a1f1afff6039ad8b$export$5a5464e2c335e3ae = [
    "arrow-left",
    "clock",
    "check",
    "cross-hair",
    "consensus",
    "controller",
    "star",
    "trophy",
    "trophy-wire-frame",
    "mute",
    "sound"
];
const $a1f1afff6039ad8b$export$f04a61298a47a40f = ({ className: className, name: name })=>{
    const classNames = "inline-block " + className;
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $01494118b1e6559d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $1fELX.cloneElement)($a1f1afff6039ad8b$var$getIconForName(name), {
            className: classNames
        })
    });
};
const $a1f1afff6039ad8b$var$getIconForName = (name)=>{
    switch(name){
        case "arrow-left":
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12.7071 4.29289C13.0976 4.68342 13.0976 5.31658 12.7071 5.70711L6.41421 12L12.7071 18.2929C13.0976 18.6834 13.0976 19.3166 12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929L11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289Z",
                        fill: "currentColor"
                    })
                ]
            });
        case "clock":
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("svg", {
                width: "32",
                height: "32",
                viewBox: "0 0 32 32",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("g", {
                        clipPath: "url(#clip0_342_21364)",
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M12.0605 2.66677C12.0605 1.96386 12.6304 1.39404 13.3333 1.39404H18.6666C19.3695 1.39404 19.9393 1.96386 19.9393 2.66677C19.9393 3.36968 19.3695 3.9395 18.6666 3.9395H13.3333C12.6304 3.9395 12.0605 3.36968 12.0605 2.66677Z",
                                fill: "currentColor"
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M20.8997 13.7668C21.3968 14.2638 21.3968 15.0697 20.8997 15.5667L16.8997 19.5667C16.4027 20.0638 15.5969 20.0638 15.0998 19.5667C14.6028 19.0697 14.6028 18.2638 15.0998 17.7668L19.0998 13.7668C19.5969 13.2698 20.4027 13.2698 20.8997 13.7668Z",
                                fill: "currentColor"
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M15.9999 9.27275C10.8118 9.27275 6.606 13.4786 6.606 18.6667C6.606 23.8548 10.8118 28.0606 15.9999 28.0606C21.1881 28.0606 25.3939 23.8548 25.3939 18.6667C25.3939 13.4786 21.1881 9.27275 15.9999 9.27275ZM4.06055 18.6667C4.06055 12.0727 9.406 6.72729 15.9999 6.72729C22.5939 6.72729 27.9393 12.0727 27.9393 18.6667C27.9393 25.2606 22.5939 30.6061 15.9999 30.6061C9.406 30.6061 4.06055 25.2606 4.06055 18.6667Z",
                                fill: "currentColor"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("clipPath", {
                            id: "clip0_342_21364",
                            children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("rect", {
                                width: "32",
                                height: "32",
                                fill: "white"
                            })
                        })
                    })
                ]
            });
        case "check":
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("svg", {
                width: "25",
                height: "25",
                viewBox: "0 0 25 25",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20.9571 5.79289C21.3476 6.18342 21.3476 6.81658 20.9571 7.20711L9.95711 18.2071C9.56658 18.5976 8.93342 18.5976 8.54289 18.2071L3.54289 13.2071C3.15237 12.8166 3.15237 12.1834 3.54289 11.7929C3.93342 11.4024 4.56658 11.4024 4.95711 11.7929L9.25 16.0858L19.5429 5.79289C19.9334 5.40237 20.5666 5.40237 20.9571 5.79289Z",
                    fill: "currentColor"
                })
            });
        case "cross-hair":
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("svg", {
                width: "24",
                height: "25",
                viewBox: "0 0 24 25",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M22 12.5H18",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M6 12.5H2",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M12 6.5V2.5",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M12 22.5V18.5",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            });
        case "consensus":
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M9 14L11 16L15 12",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            });
        case "controller":
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("svg", {
                width: "25",
                height: "24",
                viewBox: "0 0 25 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M6.5 11H10.5",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M8.5 9V13",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M15.5 12H15.51",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M18.5 10H18.51",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M17.82 5H7.18C6.19028 5.00023 5.23579 5.36738 4.50103 6.03046C3.76628 6.69355 3.30345 7.60549 3.202 8.59C3.196 8.642 3.192 8.691 3.185 8.742C3.104 9.416 2.5 14.456 2.5 16C2.5 16.7956 2.81607 17.5587 3.37868 18.1213C3.94129 18.6839 4.70435 19 5.5 19C6.5 19 7 18.5 7.5 18L8.914 16.586C9.28899 16.2109 9.79761 16.0001 10.328 16H14.672C15.2024 16.0001 15.711 16.2109 16.086 16.586L17.5 18C18 18.5 18.5 19 19.5 19C20.2956 19 21.0587 18.6839 21.6213 18.1213C22.1839 17.5587 22.5 16.7956 22.5 16C22.5 14.455 21.896 9.416 21.815 8.742C21.808 8.692 21.804 8.642 21.798 8.591C21.6968 7.60631 21.2341 6.69413 20.4993 6.03083C19.7645 5.36754 18.8099 5.00026 17.82 5Z",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            });
        case "star":
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("svg", {
                width: "25",
                height: "24",
                viewBox: "0 0 25 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("g", {
                    id: "Frame",
                    children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        id: "Vector",
                        d: "M12.3569 2L15.4469 8.26L22.3569 9.27L17.3569 14.14L18.5369 21.02L12.3569 17.77L6.17693 21.02L7.35693 14.14L2.35693 9.27L9.26693 8.26L12.3569 2Z",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            });
        case "trophy":
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("svg", {
                width: "35",
                height: "36",
                viewBox: "0 0 35 36",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M5.99993 7.71443C5.35583 7.71443 4.73812 7.97029 4.28267 8.42574C3.82723 8.88118 3.57136 9.4989 3.57136 10.143C3.57136 10.7871 3.82723 11.4048 4.28267 11.8603C4.58173 12.1593 4.95076 12.3724 5.35142 12.4834C5.56783 12.5434 5.78616 12.5875 6.05015 12.6408C6.10231 12.6513 6.15625 12.6622 6.21232 12.6737C6.53081 12.7388 6.90781 12.8202 7.28722 12.9522L9.6611 13.7779C10.2572 13.9852 10.5724 14.6366 10.3651 15.2327C10.1577 15.8289 9.50634 16.1441 8.91019 15.9367L6.53632 15.111C6.31211 15.033 6.06426 14.9764 5.75485 14.9132C5.71083 14.9042 5.66493 14.8949 5.61747 14.8854C5.35426 14.8324 5.04319 14.7698 4.74097 14.6861C3.9635 14.4706 3.24704 14.0571 2.66643 13.4765C1.78233 12.5924 1.28564 11.3933 1.28564 10.143C1.28564 8.89269 1.78233 7.69359 2.66643 6.80949C3.55053 5.92539 4.74962 5.42871 5.99993 5.42871H8.14279C8.77397 5.42871 9.28564 5.94039 9.28564 6.57157C9.28564 7.20275 8.77397 7.71443 8.14279 7.71443H5.99993Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M26.4286 6.57157C26.4286 5.94039 26.9403 5.42871 27.5715 5.42871H29.7143C30.9646 5.42871 32.1637 5.92539 33.0478 6.80949C33.9319 7.69359 34.4286 8.89269 34.4286 10.143C34.4286 11.3933 33.9319 12.5924 33.0478 13.4765C32.7293 13.795 32.3699 14.0633 31.9819 14.2761C31.4678 14.5581 30.912 14.7702 30.4433 14.949C30.3682 14.9777 30.2954 15.0055 30.2253 15.0325C29.6797 15.2435 29.2521 15.4282 28.8958 15.676L27.0812 16.9383C26.5631 17.2988 25.8509 17.1709 25.4904 16.6528C25.13 16.1346 25.2578 15.4224 25.776 15.062L27.5905 13.7996C28.192 13.3812 28.8475 13.1146 29.4012 12.9006C29.4859 12.8678 29.5681 12.8363 29.6478 12.8058C30.1248 12.623 30.517 12.4727 30.8825 12.2722C31.0823 12.1625 31.2674 12.0244 31.4316 11.8603C31.887 11.4048 32.1429 10.7871 32.1429 10.143C32.1429 9.4989 31.887 8.88118 31.4316 8.42574C30.9761 7.97029 30.3584 7.71443 29.7143 7.71443H27.5715C26.9403 7.71443 26.4286 7.20275 26.4286 6.57157Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M7.57129 32.2859H28.1427",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M15.5712 21.4287C16.2024 21.4287 16.7141 21.9404 16.7141 22.5716V25.4863C16.7141 26.8046 15.7128 27.6452 14.9749 28.0152L14.9727 28.0162C14.4339 28.285 13.6921 28.8217 13.0972 29.5233C12.4984 30.2293 12.1426 30.9878 12.1426 31.7144C12.1426 32.3456 11.631 32.8573 10.9998 32.8573C10.3686 32.8573 9.85693 32.3456 9.85693 31.7144C9.85693 30.2488 10.5583 28.9831 11.3539 28.0449C12.1528 27.1028 13.1418 26.3755 13.9513 25.9715C14.1193 25.8871 14.2568 25.7772 14.3412 25.6724C14.4205 25.574 14.4284 25.5143 14.4284 25.4863V22.5716C14.4284 21.9404 14.94 21.4287 15.5712 21.4287Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.4576 20.9016C20.9477 21.0421 21.2854 21.4903 21.2854 22.0001V25.4863C21.2854 25.5143 21.2933 25.574 21.3726 25.6724C21.4569 25.7772 21.5945 25.8871 21.7625 25.9714C22.572 26.3755 23.561 27.1028 24.3599 28.0449C25.1555 28.9831 25.8569 30.2488 25.8569 31.7144C25.8569 32.103 25.6594 32.4649 25.3327 32.6753C25.006 32.8857 24.5948 32.9156 24.2411 32.7548L17.9554 29.8977C17.7171 29.7894 17.5232 29.6025 17.4061 29.3684L16.2632 27.0827C16.0852 26.7266 16.1053 26.3035 16.3163 25.9658L19.1734 21.3944C19.4437 20.9621 19.9676 20.761 20.4576 20.9016ZM18.5943 26.6337L19.2696 27.9843L22.5922 29.4946C22.0015 28.8071 21.2725 28.2813 20.7411 28.0162L20.7389 28.0152C20.0862 27.6879 19.2275 26.9925 19.0379 25.924L18.5943 26.6337Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M26.4285 3.71436H9.28564V13.7144C9.28564 15.9876 10.1887 18.1678 11.7962 19.7753C13.4036 21.3827 15.5838 22.2858 17.8571 22.2858C20.1304 22.2858 22.3105 21.3827 23.918 19.7753C25.5254 18.1678 26.4285 15.9876 26.4285 13.7144V3.71436Z",
                        fill: "currentColor",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M15.1504 25.2179V22.06L16.0527 21.6089H20.564L19.7692 25.2179L20.1429 27.0224L23.2707 27.9247L24.6241 30.6314L25.0752 32.436H11.9925L10.6392 31.9848L11.5414 29.7292L12.4437 27.9247L14.2482 27.0224L15.1504 25.2179Z",
                        fill: "currentColor"
                    })
                ]
            });
        case "trophy-wire-frame":
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M6 9H4.5C3.83696 9 3.20107 8.73661 2.73223 8.26777C2.26339 7.79893 2 7.16304 2 6.5C2 5.83696 2.26339 5.20107 2.73223 4.73223C3.20107 4.26339 3.83696 4 4.5 4H6",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M18 9H19.5C20.163 9 20.7989 8.73661 21.2678 8.26777C21.7366 7.79893 22 7.16304 22 6.5C22 5.83696 21.7366 5.20107 21.2678 4.73223C20.7989 4.26339 20.163 4 19.5 4H18",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M4 22H20",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M10 14.6599V16.9999C10 17.5499 9.53 17.9799 9.03 18.2099C7.85 18.7499 7 20.2399 7 21.9999",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M14 14.6599V16.9999C14 17.5499 14.47 17.9799 14.97 18.2099C16.15 18.7499 17 20.2399 17 21.9999",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M18 2H6V9C6 10.5913 6.63214 12.1174 7.75736 13.2426C8.88258 14.3679 10.4087 15 12 15C13.5913 15 15.1174 14.3679 16.2426 13.2426C17.3679 12.1174 18 10.5913 18 9V2Z",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            });
        case "mute":
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M11 5L6 9H2V15H6L11 19V5Z",
                        stroke: "#F2F7FA",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M22 9L16 15",
                        stroke: "#F2F7FA",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M16 9L22 15",
                        stroke: "#F2F7FA",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            });
        case "sound":
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M11 5L6 9H2V15H6L11 19V5Z",
                        stroke: "#F2F7FA",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M15.54 8.45996C16.4774 9.3976 17.004 10.6691 17.004 11.995C17.004 13.3208 16.4774 14.5923 15.54 15.53",
                        stroke: "#F2F7FA",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: "M19.0701 4.92993C20.9448 6.80521 21.9979 9.34829 21.9979 11.9999C21.9979 14.6516 20.9448 17.1947 19.0701 19.0699",
                        stroke: "#F2F7FA",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $01494118b1e6559d$exports.Fragment), {});
    }
};


var $e0694f4e7923cdf6$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $e0694f4e7923cdf6$export$18a094aefa070634 = (obj, member, getter)=>{
    $e0694f4e7923cdf6$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $e0694f4e7923cdf6$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $e0694f4e7923cdf6$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $e0694f4e7923cdf6$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $e0694f4e7923cdf6$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $e0694f4e7923cdf6$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $e0694f4e7923cdf6$export$18a094aefa070634(obj, member, getter);
        }
    });
var $e0694f4e7923cdf6$export$fa92d15b718fce20 = (obj, member, method)=>{
    $e0694f4e7923cdf6$var$__accessCheck(obj, member, "access private method");
    return method;
};



// src/utils.ts
var $f57a82afd5852ebf$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $f57a82afd5852ebf$export$8793edee2d425525() {
    return void 0;
}
function $f57a82afd5852ebf$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $f57a82afd5852ebf$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $f57a82afd5852ebf$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $f57a82afd5852ebf$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $f57a82afd5852ebf$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$f57a82afd5852ebf$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $f57a82afd5852ebf$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($f57a82afd5852ebf$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $f57a82afd5852ebf$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$f57a82afd5852ebf$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $f57a82afd5852ebf$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $f57a82afd5852ebf$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $f57a82afd5852ebf$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$f57a82afd5852ebf$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $f57a82afd5852ebf$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$f57a82afd5852ebf$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $f57a82afd5852ebf$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $f57a82afd5852ebf$export$7a8558113332b71e(a) && $f57a82afd5852ebf$export$7a8558113332b71e(b);
    if (array || $f57a82afd5852ebf$export$53b83ca8eaab0383(a) && $f57a82afd5852ebf$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $f57a82afd5852ebf$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $f57a82afd5852ebf$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $f57a82afd5852ebf$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $f57a82afd5852ebf$export$53b83ca8eaab0383(o) {
    if (!$f57a82afd5852ebf$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
    const prot = ctor.prototype;
    if (!$f57a82afd5852ebf$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function $f57a82afd5852ebf$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $f57a82afd5852ebf$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $f57a82afd5852ebf$export$4304cb76768ca134(callback) {
    $f57a82afd5852ebf$export$e772c8ff12451969(0).then(callback);
}
function $f57a82afd5852ebf$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) return $f57a82afd5852ebf$export$77a71fc411098696(prevData, data);
    return data;
}
function $f57a82afd5852ebf$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $f57a82afd5852ebf$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $f57a82afd5852ebf$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}




function $d2c8ece77381cd5b$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $f57a82afd5852ebf$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $f57a82afd5852ebf$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
}
var $d2c8ece77381cd5b$export$520687f44db6e1ab = $d2c8ece77381cd5b$export$316a8efd03cd1458();




// src/subscribable.ts
var $afef6c1c30b4cd1f$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $e144ef068697cf99$var$_focused, $e144ef068697cf99$var$_cleanup, $e144ef068697cf99$var$_setup;
var $e144ef068697cf99$export$86f1af424b2ca4de = class extends (0, $afef6c1c30b4cd1f$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $e144ef068697cf99$var$_focused, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $e144ef068697cf99$var$_cleanup, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $e144ef068697cf99$var$_setup, void 0);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $e144ef068697cf99$var$_setup, (onFocus)=>{
            if (!(0, $f57a82afd5852ebf$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $e144ef068697cf99$var$_cleanup)) this.setEventListener((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $e144ef068697cf99$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $e144ef068697cf99$var$_cleanup)) == null || _a.call(this);
            (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $e144ef068697cf99$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $e144ef068697cf99$var$_setup, setup);
        (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $e144ef068697cf99$var$_cleanup)) == null || _a.call(this);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $e144ef068697cf99$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $e144ef068697cf99$var$_focused) !== focused;
        if (changed) {
            (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $e144ef068697cf99$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach((listener)=>{
            listener();
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $e144ef068697cf99$var$_focused) === "boolean") return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $e144ef068697cf99$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$e144ef068697cf99$var$_focused = new WeakMap();
$e144ef068697cf99$var$_cleanup = new WeakMap();
$e144ef068697cf99$var$_setup = new WeakMap();
var $e144ef068697cf99$export$6bf54661be5b02cf = new $e144ef068697cf99$export$86f1af424b2ca4de();








var $7f3a5e4614e6f9f6$var$_online, $7f3a5e4614e6f9f6$var$_cleanup, $7f3a5e4614e6f9f6$var$_setup;
var $7f3a5e4614e6f9f6$export$58774fb55d5ff7fc = class extends (0, $afef6c1c30b4cd1f$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $7f3a5e4614e6f9f6$var$_online, true);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $7f3a5e4614e6f9f6$var$_cleanup, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $7f3a5e4614e6f9f6$var$_setup, void 0);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $7f3a5e4614e6f9f6$var$_setup, (onOnline)=>{
            if (!(0, $f57a82afd5852ebf$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $7f3a5e4614e6f9f6$var$_cleanup)) this.setEventListener((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $7f3a5e4614e6f9f6$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $7f3a5e4614e6f9f6$var$_cleanup)) == null || _a.call(this);
            (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $7f3a5e4614e6f9f6$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $7f3a5e4614e6f9f6$var$_setup, setup);
        (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $7f3a5e4614e6f9f6$var$_cleanup)) == null || _a.call(this);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $7f3a5e4614e6f9f6$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $7f3a5e4614e6f9f6$var$_online) !== online;
        if (changed) {
            (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $7f3a5e4614e6f9f6$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $7f3a5e4614e6f9f6$var$_online);
    }
};
$7f3a5e4614e6f9f6$var$_online = new WeakMap();
$7f3a5e4614e6f9f6$var$_cleanup = new WeakMap();
$7f3a5e4614e6f9f6$var$_setup = new WeakMap();
var $7f3a5e4614e6f9f6$export$b113e788b2dd3fdc = new $7f3a5e4614e6f9f6$export$58774fb55d5ff7fc();



function $d448c6ba1da5350d$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $d448c6ba1da5350d$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $7f3a5e4614e6f9f6$export$b113e788b2dd3fdc).isOnline() : true;
}
var $d448c6ba1da5350d$export$a8430ed4188f35a9 = class {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $d448c6ba1da5350d$export$986cc6445c1d323(value) {
    return value instanceof $d448c6ba1da5350d$export$a8430ed4188f35a9;
}
function $d448c6ba1da5350d$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $d448c6ba1da5350d$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $e144ef068697cf99$export$6bf54661be5b02cf).isFocused() || config.networkMode !== "always" && !(0, $7f3a5e4614e6f9f6$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $f57a82afd5852ebf$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $d448c6ba1da5350d$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $f57a82afd5852ebf$export$e772c8ff12451969)(delay).then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    if ($d448c6ba1da5350d$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}


var $2c29221e5186587b$var$_client, $2c29221e5186587b$var$_currentQuery, $2c29221e5186587b$var$_currentQueryInitialState, $2c29221e5186587b$var$_currentResult, $2c29221e5186587b$var$_currentResultState, $2c29221e5186587b$var$_currentResultOptions, $2c29221e5186587b$var$_selectError, $2c29221e5186587b$var$_selectFn, $2c29221e5186587b$var$_selectResult, $2c29221e5186587b$var$_lastQueryWithDefinedData, $2c29221e5186587b$var$_staleTimeoutId, $2c29221e5186587b$var$_refetchIntervalId, $2c29221e5186587b$var$_currentRefetchInterval, $2c29221e5186587b$var$_trackedProps, $2c29221e5186587b$var$_executeFetch, $2c29221e5186587b$var$executeFetch_fn, $2c29221e5186587b$var$_updateStaleTimeout, $2c29221e5186587b$var$updateStaleTimeout_fn, $2c29221e5186587b$var$_computeRefetchInterval, $2c29221e5186587b$var$computeRefetchInterval_fn, $2c29221e5186587b$var$_updateRefetchInterval, $2c29221e5186587b$var$updateRefetchInterval_fn, $2c29221e5186587b$var$_updateTimers, $2c29221e5186587b$var$updateTimers_fn, $2c29221e5186587b$var$_clearStaleTimeout, $2c29221e5186587b$var$clearStaleTimeout_fn, $2c29221e5186587b$var$_clearRefetchInterval, $2c29221e5186587b$var$clearRefetchInterval_fn, $2c29221e5186587b$var$_updateQuery, $2c29221e5186587b$var$updateQuery_fn, $2c29221e5186587b$var$_notify, $2c29221e5186587b$var$notify_fn;
var $2c29221e5186587b$export$a06cf8c0066f0d4c = class extends (0, $afef6c1c30b4cd1f$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_executeFetch);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_updateStaleTimeout);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_computeRefetchInterval);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_updateRefetchInterval);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_updateTimers);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_clearStaleTimeout);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_clearRefetchInterval);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_updateQuery);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_notify);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_client, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_currentQuery, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_currentQueryInitialState, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_currentResult, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_currentResultState, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_currentResultOptions, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_selectError, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_selectFn, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_lastQueryWithDefinedData, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_staleTimeoutId, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_refetchIntervalId, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_currentRefetchInterval, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $2c29221e5186587b$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_client, client);
        this.options = options;
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_selectError, null);
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery).addObserver(this);
            if ($2c29221e5186587b$var$shouldFetchOnMount((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery), this.options)) (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_executeFetch, $2c29221e5186587b$var$executeFetch_fn).call(this);
            (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_updateTimers, $2c29221e5186587b$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $2c29221e5186587b$var$shouldFetchOn((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $2c29221e5186587b$var$shouldFetchOn((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_clearStaleTimeout, $2c29221e5186587b$var$clearStaleTimeout_fn).call(this);
        (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_clearRefetchInterval, $2c29221e5186587b$var$clearRefetchInterval_fn).call(this);
        (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery);
        this.options = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_client).defaultQueryOptions(options);
        if (!(0, $f57a82afd5852ebf$export$3e67810a3f0e9f1c)(prevOptions, this.options)) (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery),
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_updateQuery, $2c29221e5186587b$var$updateQuery_fn).call(this);
        const mounted = this.hasListeners();
        if (mounted && $2c29221e5186587b$var$shouldFetchOptionally((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_executeFetch, $2c29221e5186587b$var$executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_updateStaleTimeout, $2c29221e5186587b$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_computeRefetchInterval, $2c29221e5186587b$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentRefetchInterval))) (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_updateRefetchInterval, $2c29221e5186587b$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_client).getQueryCache().build((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_client), options);
        const result = this.createResult(query, options);
        if ($2c29221e5186587b$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_currentResult, result);
            (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_currentResultOptions, this.options);
            (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_currentResultState, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentResult);
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_trackedProps).add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_client).defaultQueryOptions(options);
        const query = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_client).getQueryCache().build((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_client), defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_executeFetch, $2c29221e5186587b$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentResult);
        const prevResultState = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentResultState);
        const prevResultOptions = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQueryInitialState);
        const { state: state } = query;
        let { error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $2c29221e5186587b$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $2c29221e5186587b$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $d448c6ba1da5350d$export$61b92f63f30245cf)(query.options.networkMode) ? "fetching" : "paused";
                if (!state.dataUpdatedAt) status = "pending";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        }
        if (options.select && typeof state.data !== "undefined") {
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_selectFn)) data = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_selectResult);
            else try {
                (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_selectFn, options.select);
                data = options.select(state.data);
                data = (0, $f57a82afd5852ebf$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_selectResult, data);
                (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_selectError, null);
            } catch (selectError) {
                (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_selectError, selectError);
            }
        } else data = state.data;
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_selectError, null);
                } catch (selectError) {
                    (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_selectError, selectError);
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $f57a82afd5852ebf$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_selectError)) {
            error = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_selectError);
            data = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: state.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $2c29221e5186587b$var$isStale(query, options),
            refetch: this.refetch
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentResult);
        const nextResult = this.createResult((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery), this.options);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_currentResultState, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery).state);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_currentResultOptions, this.options);
        if ((0, $f57a82afd5852ebf$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        if ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentResultState).data !== void 0) (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_lastQueryWithDefinedData, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery));
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_notify, $2c29221e5186587b$var$notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_updateTimers, $2c29221e5186587b$var$updateTimers_fn).call(this);
    }
};
$2c29221e5186587b$var$_client = new WeakMap();
$2c29221e5186587b$var$_currentQuery = new WeakMap();
$2c29221e5186587b$var$_currentQueryInitialState = new WeakMap();
$2c29221e5186587b$var$_currentResult = new WeakMap();
$2c29221e5186587b$var$_currentResultState = new WeakMap();
$2c29221e5186587b$var$_currentResultOptions = new WeakMap();
$2c29221e5186587b$var$_selectError = new WeakMap();
$2c29221e5186587b$var$_selectFn = new WeakMap();
$2c29221e5186587b$var$_selectResult = new WeakMap();
$2c29221e5186587b$var$_lastQueryWithDefinedData = new WeakMap();
$2c29221e5186587b$var$_staleTimeoutId = new WeakMap();
$2c29221e5186587b$var$_refetchIntervalId = new WeakMap();
$2c29221e5186587b$var$_currentRefetchInterval = new WeakMap();
$2c29221e5186587b$var$_trackedProps = new WeakMap();
$2c29221e5186587b$var$_executeFetch = new WeakSet();
$2c29221e5186587b$var$executeFetch_fn = function(fetchOptions) {
    (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_updateQuery, $2c29221e5186587b$var$updateQuery_fn).call(this);
    let promise = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $f57a82afd5852ebf$export$8793edee2d425525));
    return promise;
};
$2c29221e5186587b$var$_updateStaleTimeout = new WeakSet();
$2c29221e5186587b$var$updateStaleTimeout_fn = function() {
    (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_clearStaleTimeout, $2c29221e5186587b$var$clearStaleTimeout_fn).call(this);
    if ((0, $f57a82afd5852ebf$export$6acf61af03e62db) || (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentResult).isStale || !(0, $f57a82afd5852ebf$export$e539f754e934e270)(this.options.staleTime)) return;
    const time = (0, $f57a82afd5852ebf$export$811b83d62bcf47f0)((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentResult).dataUpdatedAt, this.options.staleTime);
    const timeout = time + 1;
    (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$2c29221e5186587b$var$_computeRefetchInterval = new WeakSet();
$2c29221e5186587b$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$2c29221e5186587b$var$_updateRefetchInterval = new WeakSet();
$2c29221e5186587b$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_clearRefetchInterval, $2c29221e5186587b$var$clearRefetchInterval_fn).call(this);
    (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_currentRefetchInterval, nextInterval);
    if ((0, $f57a82afd5852ebf$export$6acf61af03e62db) || this.options.enabled === false || !(0, $f57a82afd5852ebf$export$e539f754e934e270)((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentRefetchInterval)) || (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentRefetchInterval) === 0) return;
    (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $e144ef068697cf99$export$6bf54661be5b02cf).isFocused()) (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_executeFetch, $2c29221e5186587b$var$executeFetch_fn).call(this);
    }, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentRefetchInterval)));
};
$2c29221e5186587b$var$_updateTimers = new WeakSet();
$2c29221e5186587b$var$updateTimers_fn = function() {
    (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_updateStaleTimeout, $2c29221e5186587b$var$updateStaleTimeout_fn).call(this);
    (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_updateRefetchInterval, $2c29221e5186587b$var$updateRefetchInterval_fn).call(this, (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $2c29221e5186587b$var$_computeRefetchInterval, $2c29221e5186587b$var$computeRefetchInterval_fn).call(this));
};
$2c29221e5186587b$var$_clearStaleTimeout = new WeakSet();
$2c29221e5186587b$var$clearStaleTimeout_fn = function() {
    if ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_staleTimeoutId)) {
        clearTimeout((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_staleTimeoutId));
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_staleTimeoutId, void 0);
    }
};
$2c29221e5186587b$var$_clearRefetchInterval = new WeakSet();
$2c29221e5186587b$var$clearRefetchInterval_fn = function() {
    if ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_refetchIntervalId)) {
        clearInterval((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_refetchIntervalId));
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_refetchIntervalId, void 0);
    }
};
$2c29221e5186587b$var$_updateQuery = new WeakSet();
$2c29221e5186587b$var$updateQuery_fn = function() {
    const query = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_client).getQueryCache().build((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_client), this.options);
    if (query === (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery)) return;
    const prevQuery = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery);
    (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_currentQuery, query);
    (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $2c29221e5186587b$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$2c29221e5186587b$var$_notify = new WeakSet();
$2c29221e5186587b$var$notify_fn = function(notifyOptions) {
    (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentResult));
        });
        (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_client).getQueryCache().notify({
            query: (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $2c29221e5186587b$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $2c29221e5186587b$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $2c29221e5186587b$var$shouldFetchOnMount(query, options) {
    return $2c29221e5186587b$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $2c29221e5186587b$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $2c29221e5186587b$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $2c29221e5186587b$var$isStale(query, options);
    }
    return false;
}
function $2c29221e5186587b$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $2c29221e5186587b$var$isStale(query, options);
}
function $2c29221e5186587b$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}
function $2c29221e5186587b$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $f57a82afd5852ebf$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $1fELX = parcelRequire("1fELX");


var $1fELX = parcelRequire("1fELX");
"use client";
function $38b3cb76ba61cafc$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $38b3cb76ba61cafc$var$QueryErrorResetBoundaryContext = $1fELX.createContext($38b3cb76ba61cafc$var$createValue());
var $38b3cb76ba61cafc$export$50dfac555130cafd = ()=>$1fELX.useContext($38b3cb76ba61cafc$var$QueryErrorResetBoundaryContext);
var $38b3cb76ba61cafc$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $1fELX.useState(()=>$38b3cb76ba61cafc$var$createValue());
    return /* @__PURE__ */ $1fELX.createElement($38b3cb76ba61cafc$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};



var $1fELX = parcelRequire("1fELX");
"use client";
var $b41875c28b512fff$export$da112d31b0149f31 = $1fELX.createContext(void 0);
var $b41875c28b512fff$export$22e77b9572c4fded = (queryClient)=>{
    const client = $1fELX.useContext($b41875c28b512fff$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $b41875c28b512fff$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $1fELX.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ $1fELX.createElement($b41875c28b512fff$export$da112d31b0149f31.Provider, {
        value: client
    }, children);
};



var $1fELX = parcelRequire("1fELX");
"use client";
var $115f0698cf5ea6f2$var$IsRestoringContext = $1fELX.createContext(false);
var $115f0698cf5ea6f2$export$4da0178d6b5f553 = ()=>$1fELX.useContext($115f0698cf5ea6f2$var$IsRestoringContext);
var $115f0698cf5ea6f2$export$593807d4e94f9621 = $115f0698cf5ea6f2$var$IsRestoringContext.Provider;



var $1fELX = parcelRequire("1fELX");
// src/utils.ts
function $fd2dd5d99e5425e7$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}


"use client";
var $4856e91c1ee05d24$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $4856e91c1ee05d24$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $1fELX.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $4856e91c1ee05d24$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $fd2dd5d99e5425e7$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]);
};


// src/suspense.ts
var $93c084e292a8c152$export$8bed2f8d02206063 = (_error, query)=>typeof query.state.data === "undefined";
var $93c084e292a8c152$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1e3;
    }
};
var $93c084e292a8c152$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $93c084e292a8c152$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $93c084e292a8c152$export$e0a3f29513afe430(result, isRestoring);
var $93c084e292a8c152$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $5c535bfa89d40df8$export$fff0865807e996c5(options, Observer, queryClient) {
    const client = (0, $b41875c28b512fff$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $115f0698cf5ea6f2$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $38b3cb76ba61cafc$export$50dfac555130cafd)();
    const defaultedOptions = client.defaultQueryOptions(options);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $93c084e292a8c152$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $4856e91c1ee05d24$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $4856e91c1ee05d24$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $1fELX.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $1fELX.useSyncExternalStore($1fELX.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>void 0 : observer.subscribe((0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $1fELX.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $93c084e292a8c152$export$88d3586dfed64df9)(defaultedOptions, result, isRestoring)) throw (0, $93c084e292a8c152$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $4856e91c1ee05d24$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: observer.getCurrentQuery()
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $6da3eb65dfb1e8de$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $5c535bfa89d40df8$export$fff0865807e996c5)(options, (0, $2c29221e5186587b$export$a06cf8c0066f0d4c), queryClient);
}


function $a15d49ed6e92009e$export$5daf09ba04077ce8(ms) {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor(ms % 60000 / 1000);
    const fraction = Math.round(ms % 1000 / 100);
    const minutesStr = String(minutes).padStart(2, "0");
    const secondsStr = String(seconds).padStart(2, "0");
    return `${minutesStr}:${secondsStr}.${fraction}`;
}


function $4d6ebddf7daae0bd$export$225e940b58276ad(playerInfo) {
    return [
        ...playerInfo
    ].sort((a, b)=>{
        const scoreComparison = b.score - a.score;
        // If scores are equal, secondary comparison on totalTime
        if (scoreComparison === 0) return a.totalTime - b.totalTime;
        return scoreComparison;
    });
}
function $4d6ebddf7daae0bd$export$fe1fe805a87328d({ score: score, totalTime: totalTime }, playerInfo) {
    const newPlayerInfo = {
        score: score,
        totalTime: totalTime,
        id: "",
        firstName: "",
        lastName: "",
        institution: "",
        email: "",
        selectionHistory: []
    };
    const newLeaderboard = [
        ...playerInfo,
        newPlayerInfo
    ];
    const sortedNewLeaderboard = $4d6ebddf7daae0bd$export$225e940b58276ad(newLeaderboard);
    return sortedNewLeaderboard.indexOf(newPlayerInfo) + 1;
}


var $46d036be69149635$exports = {};


$46d036be69149635$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("ksDbD");


var $85779f215aa1929a$exports = {};


$85779f215aa1929a$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("7L5aG");


var $ef4ace29f626c2c9$exports = {};


$ef4ace29f626c2c9$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("9J5ZF");


const $f53e2e66ab870a62$export$176c9ac0984acede = {
    numberOfImages: 10,
    imageTimeLimitInSeconds: 30,
    maxScorePerImage: 300,
    imageAnimationTime: 2
};
const $f53e2e66ab870a62$export$e51102fedf2f55a8 = {
    1: {
        label: "1st",
        color: "#F8D73A",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($46d036be69149635$exports)))
    },
    2: {
        label: "2nd",
        color: "#C2B9B7",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($85779f215aa1929a$exports)))
    },
    3: {
        label: "3rd",
        color: "#C96A2C",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ef4ace29f626c2c9$exports)))
    }
};


var $78301b06f4fb5e5f$exports = {};


$78301b06f4fb5e5f$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("5RrR6");



function $fdcb63b800e1e1ab$export$a1cae00e116c957c(players) {
    // Define CSV headers
    const headers = [
        "ID",
        "First Name",
        "Last Name",
        "Institution",
        "Email",
        "Score",
        "Total Time",
        "Selection History"
    ].join(",");
    // Format player data
    const rows = players.map((player)=>{
        const selectionHistoryJSON = JSON.stringify(player.selectionHistory);
        return [
            player.id,
            player.firstName,
            player.lastName,
            player.institution,
            player.email,
            player.score,
            (0, $a15d49ed6e92009e$export$5daf09ba04077ce8)(player.totalTime),
            selectionHistoryJSON
        ].map($fdcb63b800e1e1ab$var$escapeCSVField).join(",");
    });
    // Join headers and rows to form the CSV
    return [
        headers,
        ...rows
    ].join("\n");
}
function $fdcb63b800e1e1ab$var$escapeCSVField(field) {
    if (typeof field === "undefined" || field === null) return "";
    const str = field.toString();
    if (str.includes(",") || str.includes("\n") || str.includes('"')) return `"${str.replace(/"/g, '""')}"`;
    return str;
}


const $76aa6350eb86bafa$export$e439bffd17c92e84 = ({ setGameStatus: setGameStatus })=>{
    const [downloadMode, setDownloadMode] = (0, $1fELX.useState)(false);
    const { data: playerInfo = [] } = (0, $6da3eb65dfb1e8de$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $5b61aaedfb6d7f4f$export$ff90cd3c8a8f97de)
        ],
        queryFn: (0, $5b61aaedfb6d7f4f$export$73542a68f45c89c2)
    });
    const sortedPlayerInfo = (0, $4d6ebddf7daae0bd$export$225e940b58276ad)(playerInfo);
    (0, $1fELX.useEffect)(()=>{
        const handleKeyPress = (e)=>{
            if ((e.key === "d" || e.key === "D") && e.ctrlKey && e.shiftKey) setDownloadMode((downloadMode)=>!downloadMode);
        };
        document.addEventListener("keypress", handleKeyPress);
        return ()=>{
            document.removeEventListener("keypress", handleKeyPress);
        };
    }, []);
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$b89a827e9254211a), {
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$8868dba5c6237081), {
                variant: "primary",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                        name: "trophy"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                        className: "mx-10",
                        children: "Leaderboard"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                        name: "trophy"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b280a35ff744d18b$export$a2a14dc5e9bae153), {
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                    className: "flex justify-between flex-col h-full overflow-y-auto overflow-x-hidden",
                    children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                        className: "flex flex-col",
                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                            className: "sm:-mx-2 lg:-mx-4",
                            children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                className: "inline-block min-w-full py-2 sm:px-6 lg:px-4",
                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                    className: "overflow-hidden w-full",
                                    children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("ol", {
                                        className: "text-left w-full",
                                        children: sortedPlayerInfo.map((player, i)=>{
                                            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("li", {
                                                className: "rounded-full text-display4 hover:bg-neutral-400 hover:text-primary flex items-center w-full h-24",
                                                children: [
                                                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                                        className: "w-1/12 px-6 py-4 font-medium",
                                                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                                                            className: "inline-block ml-2",
                                                            style: {
                                                                color: (0, $f53e2e66ab870a62$export$e51102fedf2f55a8)[i + 1]?.color ?? "#C9D4DA"
                                                            },
                                                            children: (i + 1).toString().padStart(2, "0")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                                        className: "w-4/12 px-6 py-4 font-semibold hover:text-primary",
                                                        children: [
                                                            player.firstName,
                                                            " ",
                                                            player.lastName
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                                        className: "w-3/12 px-6 py-4 font-medium",
                                                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                                            className: "flex gap-1 items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                                                    name: "clock",
                                                                    className: "h-11"
                                                                }),
                                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                                                                    className: "text-neutral-300",
                                                                    children: (0, $a15d49ed6e92009e$export$5daf09ba04077ce8)(player.totalTime)
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                                        className: "w-3/12 px-6 py-4 font-medium",
                                                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                                            className: "flex gap-2 items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                                                    name: "star"
                                                                }),
                                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("span", {
                                                                    className: "text-neutral-300",
                                                                    children: [
                                                                        player.score,
                                                                        " Points"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                                        className: "w-1/12",
                                                        children: $76aa6350eb86bafa$var$renderTrophy(i + 1)
                                                    })
                                                ]
                                            }, player.id);
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$f1011c2ab959143d), {
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                        onClick: ()=>setGameStatus((0, $fe11df8941c5cc1d$export$23c7328964450bd2).Title),
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                name: "arrow-left"
                            }),
                            "Back"
                        ]
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                        variant: "primary",
                        onClick: ()=>setGameStatus((0, $fe11df8941c5cc1d$export$23c7328964450bd2).Ready),
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                name: "controller"
                            }),
                            "Start"
                        ]
                    }),
                    downloadMode && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($76aa6350eb86bafa$var$PlayerInfoDownload, {
                        playerInfo: playerInfo
                    })
                ]
            })
        ]
    });
};
function $76aa6350eb86bafa$var$renderTrophy(rank) {
    const image = rank <= 3 ? (0, $f53e2e66ab870a62$export$e51102fedf2f55a8)[rank].image : (0, (/*@__PURE__*/$parcel$interopDefault($78301b06f4fb5e5f$exports)));
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
        src: image,
        alt: "trophy",
        className: "max-h-20"
    });
}
const $76aa6350eb86bafa$var$PlayerInfoDownload = ({ playerInfo: playerInfo })=>{
    const blobURL = (0, $1fELX.useMemo)(()=>{
        const csv = (0, $fdcb63b800e1e1ab$export$a1cae00e116c957c)(playerInfo);
        const blob = new Blob([
            csv
        ], {
            type: "text/csv"
        });
        return URL.createObjectURL(blob);
    }, [
        playerInfo
    ]);
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("a", {
        href: blobURL,
        download: "playerInfo.csv",
        className: "rounded-xl py-4 px-5 font-bold ease-out hover:bg-neutral-300 text-neutral-50 hover:text-neutral-900",
        children: "Download CSV"
    });
};





var $1fELX = parcelRequire("1fELX");

var $718c28c0b6f98086$exports = {};


$718c28c0b6f98086$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("ldfbI");




parcelRequire("1fELX");
var $cc00f4b137e2dc0c$export$80d18f138b02e097;
(function(TiRadsGrading) {
    TiRadsGrading["TR1"] = "ti_rads_grading--tr1";
    TiRadsGrading["TR2"] = "ti_rads_grading--tr2";
    TiRadsGrading["TR3"] = "ti_rads_grading--tr3";
    TiRadsGrading["TR4"] = "ti_rads_grading--tr4";
    TiRadsGrading["TR5"] = "ti_rads_grading--tr5";
})($cc00f4b137e2dc0c$export$80d18f138b02e097 || ($cc00f4b137e2dc0c$export$80d18f138b02e097 = {}));
const $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca = {
    [$cc00f4b137e2dc0c$export$80d18f138b02e097.TR1]: {
        label: "TR 1",
        color: "#c9d4da",
        className: "bg-noduleSeverity-100",
        keyBinding: "1"
    },
    [$cc00f4b137e2dc0c$export$80d18f138b02e097.TR2]: {
        label: "TR 2",
        color: "#ffd990",
        className: "bg-noduleSeverity-300",
        keyBinding: "2"
    },
    [$cc00f4b137e2dc0c$export$80d18f138b02e097.TR3]: {
        label: "TR 3",
        color: "#ffa048",
        className: "bg-noduleSeverity-500",
        keyBinding: "3"
    },
    [$cc00f4b137e2dc0c$export$80d18f138b02e097.TR4]: {
        label: "TR 4",
        color: "#f85e1d",
        className: "bg-noduleSeverity-700",
        keyBinding: "4"
    },
    [$cc00f4b137e2dc0c$export$80d18f138b02e097.TR5]: {
        label: "TR 5",
        color: "#e62c4c",
        className: "bg-noduleSeverity-900",
        keyBinding: "5"
    }
};
const $cc00f4b137e2dc0c$export$897da0bbced5e834 = Object.keys($cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca);
function $cc00f4b137e2dc0c$export$da5a638e0e69c83(keyBinding) {
    for (const [key, value] of Object.entries($cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)){
        if (value.keyBinding === keyBinding) return key;
    }
    return null;
}






const $1471987380e9ac3d$export$d20f921b8f89dc37 = (num)=>{
    return String(num).padStart(2, "0");
};
const $1471987380e9ac3d$export$b21e1b8d67919b37 = (arrayA, arrayB)=>{
    if (!arrayA && !arrayB) return true;
    if (!arrayA || !arrayB) return false;
    if (arrayA.length != arrayB.length) return false;
    arrayA.sort();
    arrayB.sort();
    return JSON.stringify(arrayA) == JSON.stringify(arrayB);
};


const $ac40294a8e4334e3$export$a1d3af27dd9ed829 = ({ index: index, image: image, selectionHistory: selectionHistory, setImageId: setImageId })=>{
    const modelResultGrading = image.modelResult?.findings[0].grading;
    const consensusGrading = image.groundTruth?.grading;
    const userSelection = selectionHistory.find((history)=>history.dicomId == image.id);
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
        className: "grid-cols-result grid gap-4 border-t-small border-neutral-400",
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                        className: "text-neutral-300 text-display4 pr-4",
                        children: (0, $1471987380e9ac3d$export$d20f921b8f89dc37)(index)
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                        src: image.imageSrc,
                        className: " inline rounded-md max-h-[55px] my-2",
                        onClick: ()=>setImageId(image.id)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                className: "bg-neutral-400/20 grid justify-items-center items-center grid-cols-[2fr_1fr_1fr] gap-3",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                        className: "justify-self-start pl-8",
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                name: "clock",
                                className: "text-neutral-300 w-[24px] h-[24px]"
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                                children: (0, $a15d49ed6e92009e$export$5daf09ba04077ce8)(image.modelResult?.usedTime || 0)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                        className: "font-bold",
                        children: (0, $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)[modelResultGrading].label
                    }),
                    modelResultGrading === consensusGrading ? /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                        name: "check",
                        className: "text-neutral-50 w-[24px] h-[24px]"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                className: "bg-primary/10 grid justify-items-center items-center",
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                    className: "text-primary font-bold",
                    children: (0, $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)[consensusGrading].label
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                className: "bg-neutral-400/20 grid justify-items-center items-center grid-cols-[1fr_1fr_2fr] gap-3",
                children: [
                    userSelection?.grading === consensusGrading ? /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                        name: "check",
                        className: "text-neutral-50 w-[24px] h-[24px]"
                    }) : /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                        className: "font-bold",
                        children: userSelection?.grading ? (0, $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)[userSelection?.grading].label : "-"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                        className: "justify-self-start pl-6",
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                name: "clock",
                                className: "text-neutral-300 w-[24px] h-[24px]"
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                                children: (0, $a15d49ed6e92009e$export$5daf09ba04077ce8)(userSelection?.usedTime || 0)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                className: "grid justify-items-center items-center",
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("button", {
                    className: "rounded-3xl bg-neutral-400 min-h-[32px] px-5",
                    onClick: ()=>setImageId(image.id),
                    children: [
                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                            name: "cross-hair",
                            className: "text-neutral-50 w-[24px] h-[24px] pr-3"
                        }),
                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                            className: "text-display6",
                            children: "inspect"
                        })
                    ]
                })
            })
        ]
    }, image.id);
};




parcelRequire("1fELX");





parcelRequire("1fELX");
const $8bffb1d2969323f1$export$d2cf3038149dd1b5 = ({ text: text, className: className })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
        className: `flex rounded-[99px] text-neutral-900 text-caption ${className} py-1 px-5 w-fit `,
        children: text
    });
};





var $1fELX = parcelRequire("1fELX");

var $1fELX = parcelRequire("1fELX");
/**
 * @public
 */ const $e7597edd82d01988$export$22a697fb29aac98d = (0, $1fELX.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $1fELX = parcelRequire("1fELX");
const $69db8e953f103d3b$export$2285bbca2c666415 = (0, $1fELX.createContext)({});



var $1fELX = parcelRequire("1fELX");

var $1fELX = parcelRequire("1fELX");
/**
 * @public
 */ const $101046bede865000$export$f224e4635b6f8ce2 = (0, $1fELX.createContext)(null);




var $1fELX = parcelRequire("1fELX");
const $44af367f2f852964$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $e977dcf06c49c0b9$export$700979bc83e7db82 = (0, $44af367f2f852964$export$4e09c449d6c407f7) ? (0, $1fELX.useLayoutEffect) : (0, $1fELX.useEffect);



var $1fELX = parcelRequire("1fELX");
const $55b4994d00ec9d4c$export$40f10139ecf1f171 = (0, $1fELX.createContext)({
    strict: false
});



function $4e39d715562b8a73$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $1fELX.useContext)((0, $69db8e953f103d3b$export$2285bbca2c666415));
    const lazyContext = (0, $1fELX.useContext)((0, $55b4994d00ec9d4c$export$40f10139ecf1f171));
    const presenceContext = (0, $1fELX.useContext)((0, $101046bede865000$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $1fELX.useContext)((0, $e7597edd82d01988$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $1fELX.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $1fELX.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const canHandoff = (0, $1fELX.useRef)(Boolean(window.HandoffAppearAnimations));
    (0, $e977dcf06c49c0b9$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.render();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (canHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $1fELX.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!canHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        /**
         * Once we've handed off animations we can delete HandoffAppearAnimations
         * so components added after the initial render can animate changes
         * in useEffect vs useLayoutEffect.
         */ window.HandoffAppearAnimations = undefined;
        canHandoff.current = false;
    });
    return visualElement;
}



var $1fELX = parcelRequire("1fELX");
function $7a738a3c9374e55e$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $dbe950f85336fe2a$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $1fELX.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $7a738a3c9374e55e$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $1fELX = parcelRequire("1fELX");

/**
 * Decides if the supplied variable is variant label
 */ function $3190f36b71321c09$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $952367654bef91ce$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}



const $e4fa23f226618644$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $e4fa23f226618644$export$1405a65085f40b9 = [
    "initial",
    ...$e4fa23f226618644$export$16e45afcc206d3a8
];


function $7b52befeb14e6684$export$4b3c3bd8d910d78d(props) {
    return (0, $952367654bef91ce$export$aa71198ceeaf53ce)(props.animate) || (0, $e4fa23f226618644$export$1405a65085f40b9).some((name)=>(0, $3190f36b71321c09$export$720b90e312cea233)(props[name]));
}
function $7b52befeb14e6684$export$ce46fa4165cdec40(props) {
    return Boolean($7b52befeb14e6684$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $f1101bce53074b12$export$12fc32fc096a04a3(props, context) {
    if ((0, $7b52befeb14e6684$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $3190f36b71321c09$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $3190f36b71321c09$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $d15202a7b0ea92b8$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $f1101bce53074b12$export$12fc32fc096a04a3)(props, (0, $1fELX.useContext)((0, $69db8e953f103d3b$export$2285bbca2c666415)));
    return (0, $1fELX.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $d15202a7b0ea92b8$var$variantLabelsAsDependency(initial),
        $d15202a7b0ea92b8$var$variantLabelsAsDependency(animate)
    ]);
}
function $d15202a7b0ea92b8$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $61fff2decb061cdc$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $61fff2decb061cdc$export$65570e08d843624d = {};
for(const key in $61fff2decb061cdc$var$featureProps)$61fff2decb061cdc$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$61fff2decb061cdc$var$featureProps[key].some((name)=>!!props[name])
};


function $0a608c995339cfa8$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $61fff2decb061cdc$export$65570e08d843624d)[key] = {
        ...(0, $61fff2decb061cdc$export$65570e08d843624d)[key],
        ...features[key]
    };
}




var $1fELX = parcelRequire("1fELX");
const $fd2e4331a0c11561$export$a3579ca508007a95 = (0, $1fELX.createContext)({});




var $1fELX = parcelRequire("1fELX");
/**
 * Internal, exported only for usage in Framer
 */ const $cea396ecc8fbc8b2$export$da5f7b802957459a = (0, $1fELX.createContext)({});


const $ac3f8874710809bd$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $91946d356494d93e$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $0a608c995339cfa8$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $1fELX.useContext)((0, $e7597edd82d01988$export$22a697fb29aac98d)),
            ...props,
            layoutId: $91946d356494d93e$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $d15202a7b0ea92b8$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $44af367f2f852964$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $4e39d715562b8a73$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $1fELX.useContext)((0, $cea396ecc8fbc8b2$export$da5f7b802957459a));
            const isStrict = (0, $1fELX.useContext)((0, $55b4994d00ec9d4c$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $1fELX.createElement((0, $69db8e953f103d3b$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $1fELX.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, $dbe950f85336fe2a$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $1fELX.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $ac3f8874710809bd$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $91946d356494d93e$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $1fELX.useContext)((0, $fd2e4331a0c11561$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $0fbc3d1fdb918876$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $91946d356494d93e$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $8174d01bdddc20da$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $a1d0fd0b7b9867ca$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $8174d01bdddc20da$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $1fELX = parcelRequire("1fELX");

var $1fELX = parcelRequire("1fELX");
const $ed12628c6ba7107f$export$91ddd985b97788d1 = {};
function $ed12628c6ba7107f$export$de9e7791c71225fd(correctors) {
    Object.assign($ed12628c6ba7107f$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $65a4d8bb723a9720$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $65a4d8bb723a9720$export$7b42a0094fb00b6e = new Set($65a4d8bb723a9720$export$280dc01950909d86);


function $7088115ea04d39b4$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $65a4d8bb723a9720$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $ed12628c6ba7107f$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $7e7233c78c258da3$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $6d842c0bf92cb530$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $6d842c0bf92cb530$var$numTransforms = (0, $65a4d8bb723a9720$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $6d842c0bf92cb530$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $6d842c0bf92cb530$var$numTransforms; i++){
        const key = (0, $65a4d8bb723a9720$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $6d842c0bf92cb530$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $c38983fabc3ecd20$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $c38983fabc3ecd20$export$9de1236619d9e756 = $c38983fabc3ecd20$var$checkStringStartsWith("--");
const $c38983fabc3ecd20$export$31f9caa2600b5723 = $c38983fabc3ecd20$var$checkStringStartsWith("var(--");
const $c38983fabc3ecd20$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $03bd3975bc921908$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $87b952b96899abe3$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $8b66f3157093c0fd$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $8b66f3157093c0fd$export$58f0f39f63f3cf42 = {
    ...$8b66f3157093c0fd$export$98e628dec113755e,
    transform: (v)=>(0, $87b952b96899abe3$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $8b66f3157093c0fd$export$dcdf75081b88279d = {
    ...$8b66f3157093c0fd$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $2b4e39238a2c8249$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $2b4e39238a2c8249$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $2b4e39238a2c8249$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $2b4e39238a2c8249$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $2b4e39238a2c8249$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $0a597012195f13fa$var$createUnitType = (unit)=>({
        test: (v)=>(0, $2b4e39238a2c8249$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $0a597012195f13fa$export$41fc368e1a942b97 = $0a597012195f13fa$var$createUnitType("deg");
const $0a597012195f13fa$export$626336c2cd4b14de = $0a597012195f13fa$var$createUnitType("%");
const $0a597012195f13fa$export$91c0eda1d06bf008 = $0a597012195f13fa$var$createUnitType("px");
const $0a597012195f13fa$export$f91e8c45a95a32f2 = $0a597012195f13fa$var$createUnitType("vh");
const $0a597012195f13fa$export$aed3d7b7d206c196 = $0a597012195f13fa$var$createUnitType("vw");
const $0a597012195f13fa$export$44e2e1705876d7ed = {
    ...$0a597012195f13fa$export$626336c2cd4b14de,
    parse: (v)=>$0a597012195f13fa$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$0a597012195f13fa$export$626336c2cd4b14de.transform(v * 100)
};



const $53fe55048bd926f7$export$7d260a2a5f8bc19e = {
    ...(0, $8b66f3157093c0fd$export$98e628dec113755e),
    transform: Math.round
};


const $509abf73285149ff$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    borderTopWidth: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    borderRightWidth: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    borderRadius: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    radius: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    maxWidth: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    height: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    maxHeight: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    size: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    top: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    right: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    bottom: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    left: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    paddingTop: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    paddingRight: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    paddingBottom: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    paddingLeft: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    margin: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    marginTop: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    marginRight: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    marginBottom: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    marginLeft: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $0a597012195f13fa$export$41fc368e1a942b97),
    rotateX: (0, $0a597012195f13fa$export$41fc368e1a942b97),
    rotateY: (0, $0a597012195f13fa$export$41fc368e1a942b97),
    rotateZ: (0, $0a597012195f13fa$export$41fc368e1a942b97),
    scale: $8b66f3157093c0fd$export$dcdf75081b88279d,
    scaleX: (0, $8b66f3157093c0fd$export$dcdf75081b88279d),
    scaleY: (0, $8b66f3157093c0fd$export$dcdf75081b88279d),
    scaleZ: (0, $8b66f3157093c0fd$export$dcdf75081b88279d),
    skew: (0, $0a597012195f13fa$export$41fc368e1a942b97),
    skewX: (0, $0a597012195f13fa$export$41fc368e1a942b97),
    skewY: (0, $0a597012195f13fa$export$41fc368e1a942b97),
    distance: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    translateX: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    translateY: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    translateZ: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    x: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    y: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    z: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    perspective: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    transformPerspective: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    opacity: (0, $8b66f3157093c0fd$export$58f0f39f63f3cf42),
    originX: (0, $0a597012195f13fa$export$44e2e1705876d7ed),
    originY: (0, $0a597012195f13fa$export$44e2e1705876d7ed),
    originZ: (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $53fe55048bd926f7$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $8b66f3157093c0fd$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $8b66f3157093c0fd$export$58f0f39f63f3cf42),
    numOctaves: (0, $53fe55048bd926f7$export$7d260a2a5f8bc19e)
};


function $c2704297486be9bf$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $c38983fabc3ecd20$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $509abf73285149ff$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $03bd3975bc921908$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $65a4d8bb723a9720$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $6d842c0bf92cb530$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $b9a64ee988e6dec4$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $96b4522f749def49$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $7e7233c78c258da3$export$605d60a2578142d3)(source[key]) && !(0, $7088115ea04d39b4$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $96b4522f749def49$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $1fELX.useMemo)(()=>{
        const state = (0, $b9a64ee988e6dec4$export$8940b483cf52eeda)();
        (0, $c2704297486be9bf$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $96b4522f749def49$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $96b4522f749def49$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $96b4522f749def49$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $96b4522f749def49$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $96b4522f749def49$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $b73b17b5bd7d80ef$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $b73b17b5bd7d80ef$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || $b73b17b5bd7d80ef$var$validMotionProps.has(key);
}


let $c232530c30ffea99$var$shouldForward = (key)=>!(0, $b73b17b5bd7d80ef$export$2f9c46555243bf04)(key);
function $c232530c30ffea99$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $c232530c30ffea99$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $b73b17b5bd7d80ef$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $c232530c30ffea99$export$59d6962c470509a5((parcelRequire("8qcWM")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $c232530c30ffea99$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($c232530c30ffea99$var$shouldForward(key) || forwardMotionProps === true && (0, $b73b17b5bd7d80ef$export$2f9c46555243bf04)(key) || !isDom && !(0, $b73b17b5bd7d80ef$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $1fELX = parcelRequire("1fELX");



function $ce07e623bf51a225$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $0a597012195f13fa$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $ce07e623bf51a225$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $ce07e623bf51a225$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $ce07e623bf51a225$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $1e78622d038e230f$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $1e78622d038e230f$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $1e78622d038e230f$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $1e78622d038e230f$var$dashKeys : $1e78622d038e230f$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $0a597012195f13fa$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $0a597012195f13fa$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $0a597012195f13fa$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $70bb1f4d5de4f5b5$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $c2704297486be9bf$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $ce07e623bf51a225$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $1e78622d038e230f$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $b29e8fa2da3e5f54$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $b9a64ee988e6dec4$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $d49d8e9d1197304d$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $15cf761999647109$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $1fELX.useMemo)(()=>{
        const state = (0, $b29e8fa2da3e5f54$export$41be8b43e1c4d4f9)();
        (0, $70bb1f4d5de4f5b5$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $d49d8e9d1197304d$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $96b4522f749def49$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $cbf8d363ae008b4c$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $a1d0fd0b7b9867ca$export$88f3fc2fd3766989)(Component) ? (0, $15cf761999647109$export$84309c4f53cb1bd5) : (0, $96b4522f749def49$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $c232530c30ffea99$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $1fELX.useMemo)(()=>(0, $7e7233c78c258da3$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $1fELX.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


/**
 * Convert camelCase to dash-case properties.
 */ const $92d636a7e44e6950$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


function $29b89cae4ff1c3ba$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $7cf13c19abf36556$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $80c9925ca43d5135$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $29b89cae4ff1c3ba$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $7cf13c19abf36556$export$28931db5d57958e5).has(key) ? (0, $92d636a7e44e6950$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $bfd10de960536988$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $7e7233c78c258da3$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $7e7233c78c258da3$export$605d60a2578142d3)(prevProps.style[key]) || (0, $7088115ea04d39b4$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $5d13043f52b61163$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $bfd10de960536988$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $7e7233c78c258da3$export$605d60a2578142d3)(props[key]) || (0, $7e7233c78c258da3$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $65a4d8bb723a9720$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $1fELX = parcelRequire("1fELX");


function $c46b2aeac8f69ef1$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



var $1fELX = parcelRequire("1fELX");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $6d4d3a80aee48cda$export$fe4300aa8eebea86(init) {
    const ref = (0, $1fELX.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


const $cfb9b78a47dd237b$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $1d20cd5973f4901d$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $1d20cd5973f4901d$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $cfb9b78a47dd237b$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $825f34e50c18523b$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $7e7233c78c258da3$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $1d20cd5973f4901d$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $ed3469f6e5c3a196$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $ed3469f6e5c3a196$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $ed3469f6e5c3a196$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $1fELX.useContext)((0, $69db8e953f103d3b$export$2285bbca2c666415));
        const presenceContext = (0, $1fELX.useContext)((0, $101046bede865000$export$f224e4635b6f8ce2));
        const make = ()=>$ed3469f6e5c3a196$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $6d4d3a80aee48cda$export$fe4300aa8eebea86)(make);
    };
function $ed3469f6e5c3a196$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $825f34e50c18523b$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $7b52befeb14e6684$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $7b52befeb14e6684$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $952367654bef91ce$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $c46b2aeac8f69ef1$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}





const $a3a6277fc71707ca$export$8793edee2d425525 = (any)=>any;


class $770dbe54e934f496$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $770dbe54e934f496$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $770dbe54e934f496$var$Queue();
    let nextFrame = new $770dbe54e934f496$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $d70b7f53ce9adb20$export$71ecace0a033b35a = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $d70b7f53ce9adb20$var$maxElapsed = 40;
function $d70b7f53ce9adb20$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $d70b7f53ce9adb20$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $770dbe54e934f496$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = ()=>{
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $d70b7f53ce9adb20$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $d70b7f53ce9adb20$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $d70b7f53ce9adb20$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$d70b7f53ce9adb20$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $3d23425702b2eefa$export$2cef06c20297c17d, cancel: $3d23425702b2eefa$export$ec99c0ef4978dccb, state: $3d23425702b2eefa$export$fff89137e9e818ce, steps: $3d23425702b2eefa$export$be3f796aed065412 } = (0, $d70b7f53ce9adb20$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $a3a6277fc71707ca$export$8793edee2d425525), true);


const $141d9a25a54b4d9d$export$44dabd3fae512e85 = {
    useVisualState: (0, $ed3469f6e5c3a196$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $5d13043f52b61163$export$16da615486abaa45),
        createRenderState: (0, $b29e8fa2da3e5f54$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $3d23425702b2eefa$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $3d23425702b2eefa$export$2cef06c20297c17d).render(()=>{
                (0, $70bb1f4d5de4f5b5$export$5475d24f125d7053)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $d49d8e9d1197304d$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $80c9925ca43d5135$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $5d58f33c86d1c75a$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $ed3469f6e5c3a196$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $bfd10de960536988$export$16da615486abaa45,
        createRenderState: (0, $b9a64ee988e6dec4$export$8940b483cf52eeda)
    })
};


function $451276071798d45e$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $a1d0fd0b7b9867ca$export$88f3fc2fd3766989)(Component) ? (0, $141d9a25a54b4d9d$export$44dabd3fae512e85) : (0, $5d58f33c86d1c75a$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $cbf8d363ae008b4c$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $aacb07df10ff3166$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $a594a2d99b92fb4d$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $cc1367fcc4bd4074$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $cc1367fcc4bd4074$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $a594a2d99b92fb4d$export$a4cf9c8a4b063a6e)(event) && handler(event, $cc1367fcc4bd4074$export$12f84bb882d06e1a(event));
};


function $29924e8d44f9ed73$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $aacb07df10ff3166$export$b1d829ddf82884aa)(target, eventName, (0, $cc1367fcc4bd4074$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $4e2fe17bd76ea70c$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $4e2fe17bd76ea70c$export$a4627e546088548d = (...transformers)=>transformers.reduce($4e2fe17bd76ea70c$var$combineFunctions);


function $0c22fe48547aab28$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $0c22fe48547aab28$var$globalHorizontalLock = $0c22fe48547aab28$export$518c5fc2dcb7974b("dragHorizontal");
const $0c22fe48547aab28$var$globalVerticalLock = $0c22fe48547aab28$export$518c5fc2dcb7974b("dragVertical");
function $0c22fe48547aab28$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $0c22fe48547aab28$var$globalVerticalLock();
    else if (drag === "x") lock = $0c22fe48547aab28$var$globalHorizontalLock();
    else {
        const openHorizontal = $0c22fe48547aab28$var$globalHorizontalLock();
        const openVertical = $0c22fe48547aab28$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $0c22fe48547aab28$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $0c22fe48547aab28$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $f2b79f7005177a9e$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}



function $f270b2db3df4d235$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.type === "touch" || (0, $0c22fe48547aab28$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(()=>props[callbackName](event, info));
    };
    return (0, $29924e8d44f9ed73$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $f270b2db3df4d235$export$93a81ea037eac456 extends (0, $f2b79f7005177a9e$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $4e2fe17bd76ea70c$export$a4627e546088548d)($f270b2db3df4d235$var$addHoverEvent(this.node, true), $f270b2db3df4d235$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $0acf01c7d16e054b$export$d4826db40d47595b extends (0, $f2b79f7005177a9e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $4e2fe17bd76ea70c$export$a4627e546088548d)((0, $aacb07df10ff3166$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $aacb07df10ff3166$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $21f733ea4bfddef8$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $21f733ea4bfddef8$export$e841ada32ff745b(parent, child.parentElement);
};




function $d5fe012d1b59f002$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $cc1367fcc4bd4074$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $d5fe012d1b59f002$export$f026abdbba7f0c9e extends (0, $f2b79f7005177a9e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $a3a6277fc71707ca$export$8793edee2d425525);
        this.removeEndListeners = (0, $a3a6277fc71707ca$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $a3a6277fc71707ca$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            this.removeEndListeners();
            if (this.isPressing) return;
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel } = this.node.getProps();
                (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !(0, $21f733ea4bfddef8$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, $29924e8d44f9ed73$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $29924e8d44f9ed73$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $4e2fe17bd76ea70c$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $d5fe012d1b59f002$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $aacb07df10ff3166$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $d5fe012d1b59f002$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $aacb07df10ff3166$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $d5fe012d1b59f002$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $aacb07df10ff3166$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $4e2fe17bd76ea70c$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $0c22fe48547aab28$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $29924e8d44f9ed73$export$fcff2e64e6676b81)(this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $aacb07df10ff3166$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $4e2fe17bd76ea70c$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $0f073e355878aceb$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $0f073e355878aceb$var$observers = new WeakMap();
const $0f073e355878aceb$var$fireObserverCallback = (entry)=>{
    const callback = $0f073e355878aceb$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $0f073e355878aceb$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($0f073e355878aceb$var$fireObserverCallback);
};
function $0f073e355878aceb$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$0f073e355878aceb$var$observers.has(lookupRoot)) $0f073e355878aceb$var$observers.set(lookupRoot, {});
    const rootObservers = $0f073e355878aceb$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($0f073e355878aceb$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $0f073e355878aceb$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $0f073e355878aceb$var$initIntersectionObserver(options);
    $0f073e355878aceb$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $0f073e355878aceb$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $cc28740cbef34385$var$thresholdNames = {
    some: 0,
    all: 1
};
class $cc28740cbef34385$export$150851c8cc2f0c72 extends (0, $f2b79f7005177a9e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $cc28740cbef34385$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $0f073e355878aceb$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($cc28740cbef34385$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $cc28740cbef34385$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $4b1532b9d8f6f66a$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $cc28740cbef34385$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $d5fe012d1b59f002$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $0acf01c7d16e054b$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $f270b2db3df4d235$export$93a81ea037eac456)
    }
};





function $d7d3d153a17cfdd4$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $5bbf104a237c23bf$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $5bbf104a237c23bf$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $5bbf104a237c23bf$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $c46b2aeac8f69ef1$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $5bbf104a237c23bf$var$getCurrent(visualElement), $5bbf104a237c23bf$var$getVelocity(visualElement));
}






const $5c3b5c04aedd6c53$export$ed7b8fa9dbf0105d = "framerAppearId";
const $5c3b5c04aedd6c53$export$8592e1c077c890a6 = "data-" + (0, $92d636a7e44e6950$export$9fd24a634729c672)($5c3b5c04aedd6c53$export$ed7b8fa9dbf0105d);



let $37fdec4f220cd02e$export$491112666e282270 = (0, $a3a6277fc71707ca$export$8793edee2d425525);
let $37fdec4f220cd02e$export$f5708dca728d7177 = (0, $a3a6277fc71707ca$export$8793edee2d425525);
var $37fdec4f220cd02e$var$check, $37fdec4f220cd02e$var$message, $37fdec4f220cd02e$var$check1, $37fdec4f220cd02e$var$message1;


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $9a4f2f7d51aaab5f$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $9a4f2f7d51aaab5f$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $2f568df52897e7a6$export$888a3d84909f9e3d = {
    current: false
};


const $f8ae5d36eddf47d1$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $b9048956309ebc31$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $b9048956309ebc31$export$2cf569f5e2221176[easing] || (0, $f8ae5d36eddf47d1$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($b9048956309ebc31$export$fcdd8f3f2160beda));
}
const $b9048956309ebc31$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $b9048956309ebc31$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $b9048956309ebc31$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $b9048956309ebc31$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $b9048956309ebc31$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $b9048956309ebc31$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $b9048956309ebc31$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $f8ae5d36eddf47d1$export$ff43f99925d7366b)(easing) ? $b9048956309ebc31$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($b9048956309ebc31$export$916ea73bcd3a6030) : $b9048956309ebc31$export$2cf569f5e2221176[easing];
}


function $65beb567f94ac9eb$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $b9048956309ebc31$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $8c55b21b74797cfb$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $fa57b16f958d1b3b$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $fa57b16f958d1b3b$var$subdivisionPrecision = 0.0000001;
const $fa57b16f958d1b3b$var$subdivisionMaxIterations = 12;
function $fa57b16f958d1b3b$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $fa57b16f958d1b3b$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $fa57b16f958d1b3b$var$subdivisionPrecision && ++i < $fa57b16f958d1b3b$var$subdivisionMaxIterations);
    return currentT;
}
function $fa57b16f958d1b3b$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $a3a6277fc71707ca$export$8793edee2d425525;
    const getTForX = (aX)=>$fa57b16f958d1b3b$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $fa57b16f958d1b3b$var$calcBezier(getTForX(t), mY1, mY2);
}


const $bbd849c35d9884af$export$929e5a82286172a6 = (0, $fa57b16f958d1b3b$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $bbd849c35d9884af$export$57636bb43b1ccbb0 = (0, $fa57b16f958d1b3b$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $bbd849c35d9884af$export$c07234257a03d5e9 = (0, $fa57b16f958d1b3b$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $fc00816700da3e5d$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $3366c1170289a416$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $a9682e76f0424b65$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $279430e8e3e021cc$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $279430e8e3e021cc$export$c8d67a19199d1a50 = (0, $a9682e76f0424b65$export$2c07eeff45156d4d)($279430e8e3e021cc$export$e444123e42d03385);
const $279430e8e3e021cc$export$30d3455eee55bed5 = (0, $3366c1170289a416$export$f946554fb8aeaf0d)($279430e8e3e021cc$export$c8d67a19199d1a50);





const $9959eb1200d89486$export$77edfce482316a60 = (0, $fa57b16f958d1b3b$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $9959eb1200d89486$export$b01116c84cdfe1a2 = (0, $a9682e76f0424b65$export$2c07eeff45156d4d)($9959eb1200d89486$export$77edfce482316a60);
const $9959eb1200d89486$export$ddc5fd596f6c71b2 = (0, $3366c1170289a416$export$f946554fb8aeaf0d)($9959eb1200d89486$export$b01116c84cdfe1a2);



const $23089a5a33c372ec$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $9959eb1200d89486$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $2b77e1b1b61fc22a$var$easingLookup = {
    linear: (0, $a3a6277fc71707ca$export$8793edee2d425525),
    easeIn: $bbd849c35d9884af$export$929e5a82286172a6,
    easeInOut: $bbd849c35d9884af$export$c07234257a03d5e9,
    easeOut: $bbd849c35d9884af$export$57636bb43b1ccbb0,
    circIn: $279430e8e3e021cc$export$e444123e42d03385,
    circInOut: $279430e8e3e021cc$export$30d3455eee55bed5,
    circOut: $279430e8e3e021cc$export$c8d67a19199d1a50,
    backIn: $9959eb1200d89486$export$b01116c84cdfe1a2,
    backInOut: $9959eb1200d89486$export$ddc5fd596f6c71b2,
    backOut: $9959eb1200d89486$export$77edfce482316a60,
    anticipate: $23089a5a33c372ec$export$6b0af63b873d419e
};
const $2b77e1b1b61fc22a$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $37fdec4f220cd02e$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $fa57b16f958d1b3b$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $37fdec4f220cd02e$export$f5708dca728d7177)($2b77e1b1b61fc22a$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $2b77e1b1b61fc22a$var$easingLookup[definition];
    }
    return definition;
};








/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $d44124aeba3f91d1$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $2b4e39238a2c8249$export$844ec244b1367d54)(v) && (0, $2b4e39238a2c8249$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $d44124aeba3f91d1$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $2b4e39238a2c8249$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $2b4e39238a2c8249$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $d70f393ade1faf62$var$clampRgbUnit = (v)=>(0, $87b952b96899abe3$export$7d15b64cf5a3a4c4)(0, 255, v);
const $d70f393ade1faf62$export$7a99c86b5b1f4c9e = {
    ...(0, $8b66f3157093c0fd$export$98e628dec113755e),
    transform: (v)=>Math.round($d70f393ade1faf62$var$clampRgbUnit(v))
};
const $d70f393ade1faf62$export$4e46ac54fc82cf3b = {
    test: (0, $d44124aeba3f91d1$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $d44124aeba3f91d1$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $d70f393ade1faf62$export$7a99c86b5b1f4c9e.transform(red) + ", " + $d70f393ade1faf62$export$7a99c86b5b1f4c9e.transform(green) + ", " + $d70f393ade1faf62$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $2b4e39238a2c8249$export$83d2e9e3e4ee39ed)((0, $8b66f3157093c0fd$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $8993d05f56823d23$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $8993d05f56823d23$export$834dfc94dde4b3d8 = {
    test: (0, $d44124aeba3f91d1$export$2c8400d58aca05e)("#"),
    parse: $8993d05f56823d23$var$parseHex,
    transform: (0, $d70f393ade1faf62$export$4e46ac54fc82cf3b).transform
};






const $95a3818045c366b5$export$810b04175080204c = {
    test: (0, $d44124aeba3f91d1$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $d44124aeba3f91d1$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $0a597012195f13fa$export$626336c2cd4b14de).transform((0, $2b4e39238a2c8249$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $0a597012195f13fa$export$626336c2cd4b14de).transform((0, $2b4e39238a2c8249$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $2b4e39238a2c8249$export$83d2e9e3e4ee39ed)((0, $8b66f3157093c0fd$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $5fe79bcb2da5e981$export$35e9368ef982300f = {
    test: (v)=>(0, $d70f393ade1faf62$export$4e46ac54fc82cf3b).test(v) || (0, $8993d05f56823d23$export$834dfc94dde4b3d8).test(v) || (0, $95a3818045c366b5$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $d70f393ade1faf62$export$4e46ac54fc82cf3b).test(v)) return (0, $d70f393ade1faf62$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $95a3818045c366b5$export$810b04175080204c).test(v)) return (0, $95a3818045c366b5$export$810b04175080204c).parse(v);
        else return (0, $8993d05f56823d23$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $2b4e39238a2c8249$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $d70f393ade1faf62$export$4e46ac54fc82cf3b).transform(v) : (0, $95a3818045c366b5$export$810b04175080204c).transform(v);
    }
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $35f0b2a35e81bfa8$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $ad2c8fdeb0e443dc$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $ad2c8fdeb0e443dc$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $ad2c8fdeb0e443dc$var$hueToRgb(p, q, hue + 1 / 3);
        green = $ad2c8fdeb0e443dc$var$hueToRgb(p, q, hue);
        blue = $ad2c8fdeb0e443dc$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $d1fadca5e77c67c7$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $d1fadca5e77c67c7$var$colorTypes = [
    (0, $8993d05f56823d23$export$834dfc94dde4b3d8),
    (0, $d70f393ade1faf62$export$4e46ac54fc82cf3b),
    (0, $95a3818045c366b5$export$810b04175080204c)
];
const $d1fadca5e77c67c7$var$getColorType = (v)=>$d1fadca5e77c67c7$var$colorTypes.find((type)=>type.test(v));
function $d1fadca5e77c67c7$var$asRGBA(color) {
    const type = $d1fadca5e77c67c7$var$getColorType(color);
    (0, $37fdec4f220cd02e$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $95a3818045c366b5$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $ad2c8fdeb0e443dc$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $d1fadca5e77c67c7$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $d1fadca5e77c67c7$var$asRGBA(from);
    const toRGBA = $d1fadca5e77c67c7$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $d1fadca5e77c67c7$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $d1fadca5e77c67c7$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $d1fadca5e77c67c7$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $d70f393ade1faf62$export$4e46ac54fc82cf3b).transform(blended);
    };
};












function $b847becac8de69da$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $2b4e39238a2c8249$export$844ec244b1367d54)(v) && (((_a = v.match((0, $2b4e39238a2c8249$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $2b4e39238a2c8249$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $b847becac8de69da$var$cssVarTokeniser = {
    regex: (0, $c38983fabc3ecd20$export$f7c0a352d8ef6313),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $a3a6277fc71707ca$export$8793edee2d425525)
};
const $b847becac8de69da$var$colorTokeniser = {
    regex: (0, $2b4e39238a2c8249$export$740b69c5fad25dba),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $5fe79bcb2da5e981$export$35e9368ef982300f).parse
};
const $b847becac8de69da$var$numberTokeniser = {
    regex: (0, $2b4e39238a2c8249$export$2444ca58c08448e4),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $8b66f3157093c0fd$export$98e628dec113755e).parse
};
function $b847becac8de69da$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $b847becac8de69da$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $b847becac8de69da$var$tokenise(info, $b847becac8de69da$var$cssVarTokeniser);
    $b847becac8de69da$var$tokenise(info, $b847becac8de69da$var$colorTokeniser);
    $b847becac8de69da$var$tokenise(info, $b847becac8de69da$var$numberTokeniser);
    return info;
}
function $b847becac8de69da$var$parseComplexValue(v) {
    return $b847becac8de69da$export$b61fc7c44bf646d5(v).values;
}
function $b847becac8de69da$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $b847becac8de69da$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($b847becac8de69da$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($b847becac8de69da$var$colorTokeniser.token, (0, $5fe79bcb2da5e981$export$35e9368ef982300f).transform(v[i]));
            else output = output.replace($b847becac8de69da$var$numberTokeniser.token, (0, $2b4e39238a2c8249$export$83d2e9e3e4ee39ed)(v[i]));
        }
        return output;
    };
}
const $b847becac8de69da$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $b847becac8de69da$var$getAnimatableNone(v) {
    const parsed = $b847becac8de69da$var$parseComplexValue(v);
    const transformer = $b847becac8de69da$var$createTransformer(v);
    return transformer(parsed.map($b847becac8de69da$var$convertNumbersToZero));
}
const $b847becac8de69da$export$83a0e34f1302825b = {
    test: $b847becac8de69da$var$test,
    parse: $b847becac8de69da$var$parseComplexValue,
    createTransformer: $b847becac8de69da$var$createTransformer,
    getAnimatableNone: $b847becac8de69da$var$getAnimatableNone
};


const $e2ad40f89d78a275$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $e2ad40f89d78a275$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $5fe79bcb2da5e981$export$35e9368ef982300f).test(origin)) return (0, $d1fadca5e77c67c7$export$51e568cf5c039bac)(origin, target);
    else return origin.startsWith("var(") ? $e2ad40f89d78a275$var$mixImmediate(origin, target) : $e2ad40f89d78a275$export$65516310a87d8205(origin, target);
}
const $e2ad40f89d78a275$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$e2ad40f89d78a275$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $e2ad40f89d78a275$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $e2ad40f89d78a275$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $e2ad40f89d78a275$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $b847becac8de69da$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $b847becac8de69da$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $b847becac8de69da$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $4e2fe17bd76ea70c$export$a4627e546088548d)($e2ad40f89d78a275$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $37fdec4f220cd02e$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $e2ad40f89d78a275$var$mixImmediate(origin, target);
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $e6d054f6bd4b2f86$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



const $a17488c831406b4e$var$mixNumber = (from, to)=>(p)=>(0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(from, to, p);
function $a17488c831406b4e$var$detectMixerFactory(v) {
    if (typeof v === "number") return $a17488c831406b4e$var$mixNumber;
    else if (typeof v === "string") return (0, $5fe79bcb2da5e981$export$35e9368ef982300f).test(v) ? (0, $d1fadca5e77c67c7$export$51e568cf5c039bac) : (0, $e2ad40f89d78a275$export$65516310a87d8205);
    else if (Array.isArray(v)) return 0, $e2ad40f89d78a275$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $e2ad40f89d78a275$export$ebc23b6840c51ba1;
    return $a17488c831406b4e$var$mixNumber;
}
function $a17488c831406b4e$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $a17488c831406b4e$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $a3a6277fc71707ca$export$8793edee2d425525) : ease;
            mixer = (0, $4e2fe17bd76ea70c$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $a17488c831406b4e$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $37fdec4f220cd02e$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $a17488c831406b4e$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $e6d054f6bd4b2f86$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $87b952b96899abe3$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $33b4af1f8159e014$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $e6d054f6bd4b2f86$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $6f6480343b49518e$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $33b4af1f8159e014$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $d2b065ada351a2e5$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $5d402b6acbc3c859$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $bbd849c35d9884af$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $5d402b6acbc3c859$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $fc00816700da3e5d$export$216948827bbdc797)(ease) ? ease.map((0, $2b77e1b1b61fc22a$export$ef97fe084f156ca4)) : (0, $2b77e1b1b61fc22a$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $d2b065ada351a2e5$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $6f6480343b49518e$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $a17488c831406b4e$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $5d402b6acbc3c859$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $56894999351ffe32$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $edbfa5949b20acea$var$velocitySampleDuration = 5; // ms
function $edbfa5949b20acea$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $edbfa5949b20acea$var$velocitySampleDuration, 0);
    return (0, $56894999351ffe32$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $1ee919ac9c84a102$var$safeMin = 0.001;
const $1ee919ac9c84a102$export$a3cdb76e84ee608e = 0.01;
const $1ee919ac9c84a102$export$1824b851fad8862b = 10.0;
const $1ee919ac9c84a102$export$ff08f2d53484465 = 0.05;
const $1ee919ac9c84a102$export$201ca48e54038115 = 1;
function $1ee919ac9c84a102$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $37fdec4f220cd02e$export$491112666e282270)(duration <= (0, $9a4f2f7d51aaab5f$export$fc3e7e8557f8c8c7)($1ee919ac9c84a102$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $87b952b96899abe3$export$7d15b64cf5a3a4c4)($1ee919ac9c84a102$export$ff08f2d53484465, $1ee919ac9c84a102$export$201ca48e54038115, dampingRatio);
    duration = (0, $87b952b96899abe3$export$7d15b64cf5a3a4c4)($1ee919ac9c84a102$export$a3cdb76e84ee608e, $1ee919ac9c84a102$export$1824b851fad8862b, (0, $9a4f2f7d51aaab5f$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $1ee919ac9c84a102$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $1ee919ac9c84a102$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $1ee919ac9c84a102$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $1ee919ac9c84a102$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$1ee919ac9c84a102$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $1ee919ac9c84a102$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $9a4f2f7d51aaab5f$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $1ee919ac9c84a102$var$rootIterations = 12;
function $1ee919ac9c84a102$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $1ee919ac9c84a102$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $1ee919ac9c84a102$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $d6229f16bf9e8a9a$var$durationKeys = [
    "duration",
    "bounce"
];
const $d6229f16bf9e8a9a$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $d6229f16bf9e8a9a$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $d6229f16bf9e8a9a$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$d6229f16bf9e8a9a$var$isSpringType(options, $d6229f16bf9e8a9a$var$physicsKeys) && $d6229f16bf9e8a9a$var$isSpringType(options, $d6229f16bf9e8a9a$var$durationKeys)) {
        const derived = (0, $1ee919ac9c84a102$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $d6229f16bf9e8a9a$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $d6229f16bf9e8a9a$var$getSpringOptions(options);
    const initialVelocity = velocity ? -(0, $9a4f2f7d51aaab5f$export$f64c3bfbc58eec0f)(velocity) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $9a4f2f7d51aaab5f$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $1ee919ac9c84a102$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $edbfa5949b20acea$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $6d0bd5665507e77e$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $d6229f16bf9e8a9a$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $edbfa5949b20acea$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $193d7b74b053e639$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $3d23425702b2eefa$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $3d23425702b2eefa$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $3d23425702b2eefa$export$fff89137e9e818ce).isProcessing ? (0, $3d23425702b2eefa$export$fff89137e9e818ce).timestamp : performance.now()
    };
};





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $4da5054b446d292d$export$f4ff70a5b4808fd8 = 20000;
function $4da5054b446d292d$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $4da5054b446d292d$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $4da5054b446d292d$export$f4ff70a5b4808fd8 ? Infinity : duration;
}


const $a425eca464687d9a$var$types = {
    decay: (0, $6d0bd5665507e77e$export$ee3ff3a17106998),
    inertia: $6d0bd5665507e77e$export$ee3ff3a17106998,
    tween: (0, $5d402b6acbc3c859$export$d25ddfdf17c3ad3e),
    keyframes: (0, $5d402b6acbc3c859$export$d25ddfdf17c3ad3e),
    spring: $d6229f16bf9e8a9a$export$b36281d89752ae66
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $a425eca464687d9a$export$ee9b76de7353d815({ autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $193d7b74b053e639$export$c1033964b5ad7fef), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $a425eca464687d9a$var$types[type] || (0, $5d402b6acbc3c859$export$d25ddfdf17c3ad3e);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     * TODO: Support velocity for units and complex value types/
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $5d402b6acbc3c859$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $a17488c831406b4e$export$89e29e4ab65e70a9)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $4da5054b446d292d$export$cbdd6b3d40ea54e2)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = currentTime / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = Boolean(currentIteration % 2);
            if (iterationIsOdd) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            let p = (0, $87b952b96899abe3$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress);
            if (currentTime > totalDuration) p = repeatType === "reverse" && iterationIsOdd ? 1 : 0;
            elapsed = p * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $9a4f2f7d51aaab5f$export$f64c3bfbc58eec0f)(currentTime);
        },
        set time (newTime){
            newTime = (0, $9a4f2f7d51aaab5f$export$fc3e7e8557f8c8c7)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $4da5054b446d292d$export$cbdd6b3d40ea54e2)(generator) : generator.calculatedDuration;
            return (0, $9a4f2f7d51aaab5f$export$f64c3bfbc58eec0f)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $9a4f2f7d51aaab5f$export$f64c3bfbc58eec0f)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}



function $94adbf009ae9c630$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}




const $a28cf8aaeaaa25ed$var$supportsWaapi = (0, $94adbf009ae9c630$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $a28cf8aaeaaa25ed$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $a28cf8aaeaaa25ed$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $a28cf8aaeaaa25ed$var$maxDuration = 20000;
const $a28cf8aaeaaa25ed$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $b9048956309ebc31$export$fcdd8f3f2160beda)(options.ease);
function $a28cf8aaeaaa25ed$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = $a28cf8aaeaaa25ed$var$supportsWaapi() && $a28cf8aaeaaa25ed$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($a28cf8aaeaaa25ed$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $a425eca464687d9a$export$ee9b76de7353d815)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $a28cf8aaeaaa25ed$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $a28cf8aaeaaa25ed$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $a28cf8aaeaaa25ed$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $65beb567f94ac9eb$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    });
    /**
     * WAAPI animations don't resolve startTime synchronously. But a blocked
     * thread could delay the startTime resolution by a noticeable amount.
     * For synching handoff animations with the new Motion animation we want
     * to ensure startTime is synchronously set.
     */ if (options.syncStart) animation.startTime = (0, $3d23425702b2eefa$export$fff89137e9e818ce).isProcessing ? (0, $3d23425702b2eefa$export$fff89137e9e818ce).timestamp : document.timeline ? document.timeline.currentTime : performance.now();
    const cancelAnimation = ()=>animation.cancel();
    const safeCancel = ()=>{
        (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        value.set((0, $8c55b21b74797cfb$export$14de59408fad90b)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, $a3a6277fc71707ca$export$8793edee2d425525;
        },
        get time () {
            return (0, $9a4f2f7d51aaab5f$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $9a4f2f7d51aaab5f$export$fc3e7e8557f8c8c7)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $9a4f2f7d51aaab5f$export$f64c3bfbc58eec0f)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $3d23425702b2eefa$export$ec99c0ef4978dccb)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $a425eca464687d9a$export$ee9b76de7353d815)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $a28cf8aaeaaa25ed$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $a28cf8aaeaaa25ed$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>animation.finish(),
        cancel: safeCancel
    };
    return controls;
}




function $77a847e09bc5d802$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $a3a6277fc71707ca$export$8793edee2d425525),
            pause: (0, $a3a6277fc71707ca$export$8793edee2d425525),
            stop: (0, $a3a6277fc71707ca$export$8793edee2d425525),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $a3a6277fc71707ca$export$8793edee2d425525),
            complete: (0, $a3a6277fc71707ca$export$8793edee2d425525)
        };
    };
    return delay ? (0, $a425eca464687d9a$export$ee9b76de7353d815)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}



const $e6ae005f78e798b1$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $e6ae005f78e798b1$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $e6ae005f78e798b1$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $e6ae005f78e798b1$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $e6ae005f78e798b1$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $e6ae005f78e798b1$var$keyframesTransition;
    else if ((0, $65a4d8bb723a9720$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $e6ae005f78e798b1$var$criticallyDampedSpring(keyframes[1]) : $e6ae005f78e798b1$var$underDampedSpring;
    return $e6ae005f78e798b1$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $96d5ebd67874dc3d$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $b847becac8de69da$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Properties that should default to 1 or 100%
 */ const $9713230b46fc0ee8$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $9713230b46fc0ee8$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $2b4e39238a2c8249$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $9713230b46fc0ee8$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $9713230b46fc0ee8$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $9713230b46fc0ee8$export$3dea766d36a8935f = {
    ...(0, $b847becac8de69da$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($9713230b46fc0ee8$var$functionRegex);
        return functions ? functions.map($9713230b46fc0ee8$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $974e21b30ad0137b$export$98cd7c72c5a731fb = {
    ...(0, $509abf73285149ff$export$eec14432cd1cb67b),
    color: // Color props
    $5fe79bcb2da5e981$export$35e9368ef982300f,
    backgroundColor: (0, $5fe79bcb2da5e981$export$35e9368ef982300f),
    outlineColor: (0, $5fe79bcb2da5e981$export$35e9368ef982300f),
    fill: (0, $5fe79bcb2da5e981$export$35e9368ef982300f),
    stroke: (0, $5fe79bcb2da5e981$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $5fe79bcb2da5e981$export$35e9368ef982300f),
    borderTopColor: (0, $5fe79bcb2da5e981$export$35e9368ef982300f),
    borderRightColor: (0, $5fe79bcb2da5e981$export$35e9368ef982300f),
    borderBottomColor: (0, $5fe79bcb2da5e981$export$35e9368ef982300f),
    borderLeftColor: (0, $5fe79bcb2da5e981$export$35e9368ef982300f),
    filter: $9713230b46fc0ee8$export$3dea766d36a8935f,
    WebkitFilter: (0, $9713230b46fc0ee8$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $974e21b30ad0137b$export$67d1babe0338d23b = (key)=>$974e21b30ad0137b$export$98cd7c72c5a731fb[key];


function $473b65fb07c9cfbd$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $974e21b30ad0137b$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $9713230b46fc0ee8$export$3dea766d36a8935f)) defaultValueType = (0, $b847becac8de69da$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $bac641dcc66ab2d3$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);


function $741ec71db2ea0e4f$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $bac641dcc66ab2d3$export$ade84c85e44a6cb1)(value);
}


function $5246cd21fcd7e854$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $96d5ebd67874dc3d$export$65676b58b122bc38)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $741ec71db2ea0e4f$export$e56af863d5645d5f)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $473b65fb07c9cfbd$export$cea0cedcb94873b5)(valueName, animatableTemplateValue);
    }
    return keyframes;
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ab5f5e7ca2db4aaa$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $ab5f5e7ca2db4aaa$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $b716785b0165e90e$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $ab5f5e7ca2db4aaa$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $9a4f2f7d51aaab5f$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $5246cd21fcd7e854$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $96d5ebd67874dc3d$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $96d5ebd67874dc3d$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $37fdec4f220cd02e$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $ab5f5e7ca2db4aaa$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $e6ae005f78e798b1$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $9a4f2f7d51aaab5f$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $9a4f2f7d51aaab5f$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $2f568df52897e7a6$export$888a3d84909f9e3d).current || valueTransition.type === false) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $77a847e09bc5d802$export$6f34fc8ef6c42b70)((0, $2f568df52897e7a6$export$888a3d84909f9e3d).current ? {
            ...options,
            delay: 0
        } : options);
        /**
         * Animate via WAAPI if possible.
         */ if (value.owner && value.owner.current instanceof HTMLElement && !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $a28cf8aaeaaa25ed$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $a425eca464687d9a$export$ee9b76de7353d815)(options);
    };
};



function $727fcacc9713ec9e$export$98397f3adbf6259f(value) {
    return Boolean((0, $7e7233c78c258da3$export$605d60a2578142d3)(value) && value.add);
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $5ecb7658c7ddf76c$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);




function $c84ab96179a9f581$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $c84ab96179a9f581$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $c84ab96179a9f581$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $058749f336e77913$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $c84ab96179a9f581$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $c84ab96179a9f581$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}





const $c2ffb6e63d68ba98$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $c2ffb6e63d68ba98$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $c2ffb6e63d68ba98$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.16.4";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $3d23425702b2eefa$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $3d23425702b2eefa$export$2cef06c20297c17d).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $3d23425702b2eefa$export$2cef06c20297c17d).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $c2ffb6e63d68ba98$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $058749f336e77913$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $3d23425702b2eefa$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($c2ffb6e63d68ba98$export$67fcd818a264039d.current) $c2ffb6e63d68ba98$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $56894999351ffe32$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $c2ffb6e63d68ba98$export$ce8bdc721e76545f(init, options) {
    return new $c2ffb6e63d68ba98$export$8cea36d14ee64562(init, options);
}








/**
 * Tests a provided value against a ValueType
 */ const $dd817317ae7b32d7$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $dcc144a9359a327b$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $25ef98165f31c32a$export$d176691c1998a1f5 = [
    (0, $8b66f3157093c0fd$export$98e628dec113755e),
    (0, $0a597012195f13fa$export$91c0eda1d06bf008),
    (0, $0a597012195f13fa$export$626336c2cd4b14de),
    (0, $0a597012195f13fa$export$41fc368e1a942b97),
    (0, $0a597012195f13fa$export$aed3d7b7d206c196),
    (0, $0a597012195f13fa$export$f91e8c45a95a32f2),
    (0, $dcc144a9359a327b$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $25ef98165f31c32a$export$eefdd52e3ccae428 = (v)=>$25ef98165f31c32a$export$d176691c1998a1f5.find((0, $dd817317ae7b32d7$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $4c6306385ad9a78c$var$valueTypes = [
    ...(0, $25ef98165f31c32a$export$d176691c1998a1f5),
    (0, $5fe79bcb2da5e981$export$35e9368ef982300f),
    (0, $b847becac8de69da$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $4c6306385ad9a78c$export$950e7e59ea1ffed7 = (v)=>$4c6306385ad9a78c$var$valueTypes.find((0, $dd817317ae7b32d7$export$6eae4d0a6a7ca7cd)(v));



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $6ba193dea068d486$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $c2ffb6e63d68ba98$export$ce8bdc721e76545f)(value));
}
function $6ba193dea068d486$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $5bbf104a237c23bf$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $1d20cd5973f4901d$export$5485128c47bd48bb)(target[key]);
        $6ba193dea068d486$var$setMotionValue(visualElement, key, value);
    }
}
function $6ba193dea068d486$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $6ba193dea068d486$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $6ba193dea068d486$var$setVariants(child, variantLabels);
        });
    });
}
function $6ba193dea068d486$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $6ba193dea068d486$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $6ba193dea068d486$var$setVariants(visualElement, [
        definition
    ]);
    else $6ba193dea068d486$export$1f61c53461aff4a5(visualElement, definition);
}
function $6ba193dea068d486$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $5ecb7658c7ddf76c$export$65583ed5a868f2d9)(value) || (0, $bac641dcc66ab2d3$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $4c6306385ad9a78c$export$950e7e59ea1ffed7)(value) && (0, $b847becac8de69da$export$83a0e34f1302825b).test(targetValue)) value = (0, $473b65fb07c9cfbd$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $c2ffb6e63d68ba98$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $6ba193dea068d486$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $6ba193dea068d486$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $6ba193dea068d486$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $b053fab66331cc3f$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $b053fab66331cc3f$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $b053fab66331cc3f$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...transition
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations && !value.hasAnimated) {
            const appearId = visualElement.getProps()[0, $5c3b5c04aedd6c53$export$8592e1c077c890a6];
            if (appearId) {
                valueTransition.elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $3d23425702b2eefa$export$2cef06c20297c17d));
                valueTransition.syncStart = true;
            }
        }
        value.start((0, $b716785b0165e90e$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $65a4d8bb723a9720$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $727fcacc9713ec9e$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $6ba193dea068d486$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
    return animations;
}




function $f7a8431bc1a0d03a$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $5bbf104a237c23bf$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $b053fab66331cc3f$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $f7a8431bc1a0d03a$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $f7a8431bc1a0d03a$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($f7a8431bc1a0d03a$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($f7a8431bc1a0d03a$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $f7a8431bc1a0d03a$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $0d0521403ddffced$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $f7a8431bc1a0d03a$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $f7a8431bc1a0d03a$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $5bbf104a237c23bf$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $b053fab66331cc3f$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}


const $d386e121ffacad7f$var$reversePriorityOrder = [
    ...(0, $e4fa23f226618644$export$16e45afcc206d3a8)
].reverse();
const $d386e121ffacad7f$var$numAnimationTypes = (0, $e4fa23f226618644$export$16e45afcc206d3a8).length;
function $d386e121ffacad7f$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $0d0521403ddffced$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $d386e121ffacad7f$export$bb53502b7a672aa8(visualElement) {
    let animate = $d386e121ffacad7f$var$animateList(visualElement);
    const state = $d386e121ffacad7f$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $5bbf104a237c23bf$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $d386e121ffacad7f$var$numAnimationTypes; i++){
            const type = $d386e121ffacad7f$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $3190f36b71321c09$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $952367654bef91ce$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $d386e121ffacad7f$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $cfb9b78a47dd237b$export$9153ad4c4999f4a0)(next) && (0, $cfb9b78a47dd237b$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $d7d3d153a17cfdd4$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $d386e121ffacad7f$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $d7d3d153a17cfdd4$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $d386e121ffacad7f$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $d386e121ffacad7f$var$createState() {
    return {
        animate: $d386e121ffacad7f$var$createTypeState(true),
        whileInView: $d386e121ffacad7f$var$createTypeState(),
        whileHover: $d386e121ffacad7f$var$createTypeState(),
        whileTap: $d386e121ffacad7f$var$createTypeState(),
        whileDrag: $d386e121ffacad7f$var$createTypeState(),
        whileFocus: $d386e121ffacad7f$var$createTypeState(),
        exit: $d386e121ffacad7f$var$createTypeState()
    };
}



class $81bb3a912f13e9e4$export$b45b3fe5caabdca extends (0, $f2b79f7005177a9e$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $d386e121ffacad7f$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $952367654bef91ce$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}



let $a3adca6836192633$var$id = 0;
class $a3adca6836192633$export$4989d1eb6104cc6c extends (0, $f2b79f7005177a9e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $a3adca6836192633$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $bac2628a29d5bd03$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $81bb3a912f13e9e4$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $a3adca6836192633$export$4989d1eb6104cc6c)
    }
};









const $6f97bd9de1799ceb$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $6f97bd9de1799ceb$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $6f97bd9de1799ceb$export$9f17032d917177de(a.x, b.x);
    const yDelta = $6f97bd9de1799ceb$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $a8ab69c0bc78e8d6$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $a8ab69c0bc78e8d6$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $6f97bd9de1799ceb$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $3d23425702b2eefa$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $a8ab69c0bc78e8d6$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            const panInfo = $a8ab69c0bc78e8d6$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $a8ab69c0bc78e8d6$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $a594a2d99b92fb4d$export$a4cf9c8a4b063a6e)(event)) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = (0, $cc1367fcc4bd4074$export$12f84bb882d06e1a)(event);
        const initialInfo = $a8ab69c0bc78e8d6$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $3d23425702b2eefa$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $a8ab69c0bc78e8d6$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $4e2fe17bd76ea70c$export$a4627e546088548d)((0, $29924e8d44f9ed73$export$fcff2e64e6676b81)(window, "pointermove", this.handlePointerMove), (0, $29924e8d44f9ed73$export$fcff2e64e6676b81)(window, "pointerup", this.handlePointerUp), (0, $29924e8d44f9ed73$export$fcff2e64e6676b81)(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $3d23425702b2eefa$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $a8ab69c0bc78e8d6$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $a8ab69c0bc78e8d6$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $a8ab69c0bc78e8d6$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $a8ab69c0bc78e8d6$var$subtractPoint(point, $a8ab69c0bc78e8d6$var$lastDevicePoint(history)),
        offset: $a8ab69c0bc78e8d6$var$subtractPoint(point, $a8ab69c0bc78e8d6$var$startDevicePoint(history)),
        velocity: $a8ab69c0bc78e8d6$var$getVelocity(history, 0.1)
    };
}
function $a8ab69c0bc78e8d6$var$startDevicePoint(history) {
    return history[0];
}
function $a8ab69c0bc78e8d6$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $a8ab69c0bc78e8d6$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $a8ab69c0bc78e8d6$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $9a4f2f7d51aaab5f$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $9a4f2f7d51aaab5f$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $06428341cf17e73a$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $06428341cf17e73a$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $06428341cf17e73a$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $06428341cf17e73a$export$c1c127004b72a37(target) / $06428341cf17e73a$export$c1c127004b72a37(source);
    if ($06428341cf17e73a$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($06428341cf17e73a$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $06428341cf17e73a$export$c0d25e96fc67d310(delta, source, target, origin) {
    $06428341cf17e73a$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $06428341cf17e73a$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $06428341cf17e73a$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $06428341cf17e73a$export$c1c127004b72a37(relative);
}
function $06428341cf17e73a$export$426154f9d100f99(target, relative, parent) {
    $06428341cf17e73a$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $06428341cf17e73a$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $06428341cf17e73a$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $06428341cf17e73a$export$c1c127004b72a37(layout);
}
function $06428341cf17e73a$export$2785bfcc929c5650(target, layout, parent) {
    $06428341cf17e73a$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $06428341cf17e73a$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $72be0b6c6e9df432$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $72be0b6c6e9df432$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $72be0b6c6e9df432$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $72be0b6c6e9df432$export$690c180aa5775042(layoutBox.x, left, right),
        y: $72be0b6c6e9df432$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $72be0b6c6e9df432$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $72be0b6c6e9df432$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $72be0b6c6e9df432$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $72be0b6c6e9df432$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $72be0b6c6e9df432$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $06428341cf17e73a$export$c1c127004b72a37)(source);
    const targetLength = (0, $06428341cf17e73a$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $e6d054f6bd4b2f86$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $e6d054f6bd4b2f86$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $87b952b96899abe3$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $72be0b6c6e9df432$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $72be0b6c6e9df432$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $72be0b6c6e9df432$export$7c5eaef8f4723d22(dragElastic = $72be0b6c6e9df432$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $72be0b6c6e9df432$export$a3366d3bac43a742;
    return {
        x: $72be0b6c6e9df432$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $72be0b6c6e9df432$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $72be0b6c6e9df432$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $72be0b6c6e9df432$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $72be0b6c6e9df432$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $72be0b6c6e9df432$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $9a77768ae7b08538$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $9a77768ae7b08538$export$3d227df54007d73a = ()=>({
        x: $9a77768ae7b08538$export$ff25708b37f72782(),
        y: $9a77768ae7b08538$export$ff25708b37f72782()
    });
const $9a77768ae7b08538$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $9a77768ae7b08538$export$6459fc9e86be362e = ()=>({
        x: $9a77768ae7b08538$export$6db76765312617ac(),
        y: $9a77768ae7b08538$export$6db76765312617ac()
    });


function $58995a33ecde7fbe$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $38f8a79a52c46c69$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $38f8a79a52c46c69$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $38f8a79a52c46c69$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $9e2e47e81ea2aed0$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $9e2e47e81ea2aed0$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$9e2e47e81ea2aed0$var$isIdentityScale(scale) || !$9e2e47e81ea2aed0$var$isIdentityScale(scaleX) || !$9e2e47e81ea2aed0$var$isIdentityScale(scaleY);
}
function $9e2e47e81ea2aed0$export$a545127cf1fbb600(values) {
    return $9e2e47e81ea2aed0$export$bdf30dca883ea463(values) || $9e2e47e81ea2aed0$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $9e2e47e81ea2aed0$export$bf80f5f8f4dc327f(values) {
    return $9e2e47e81ea2aed0$var$is2DTranslate(values.x) || $9e2e47e81ea2aed0$var$is2DTranslate(values.y);
}
function $9e2e47e81ea2aed0$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $9ef09740eca346a4$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $9ef09740eca346a4$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $9ef09740eca346a4$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $9ef09740eca346a4$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $9ef09740eca346a4$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $9ef09740eca346a4$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $9ef09740eca346a4$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $9ef09740eca346a4$export$d80074982803af5c(box, { x: x, y: y }) {
    $9ef09740eca346a4$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $9ef09740eca346a4$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $9ef09740eca346a4$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $9ef09740eca346a4$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $9ef09740eca346a4$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $9e2e47e81ea2aed0$export$a545127cf1fbb600)(node.latestValues)) $9ef09740eca346a4$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $9ef09740eca346a4$var$snapToDefault(treeScale.x);
    treeScale.y = $9ef09740eca346a4$var$snapToDefault(treeScale.y);
}
function $9ef09740eca346a4$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $9ef09740eca346a4$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $9ef09740eca346a4$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $9ef09740eca346a4$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $9ef09740eca346a4$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $9ef09740eca346a4$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $9ef09740eca346a4$export$58b16271041fbfb(box, transform) {
    $9ef09740eca346a4$export$625f1dd140a2f5e7(box.x, transform, $9ef09740eca346a4$var$xKeys);
    $9ef09740eca346a4$export$625f1dd140a2f5e7(box.y, transform, $9ef09740eca346a4$var$yKeys);
}


function $6d5ed500f2b0c6db$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $38f8a79a52c46c69$export$d3955c6a8f65a36b)((0, $38f8a79a52c46c69$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $6d5ed500f2b0c6db$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $6d5ed500f2b0c6db$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $9ef09740eca346a4$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $9ef09740eca346a4$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}










const $cce85039f3ac0af1$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $cce85039f3ac0af1$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $cc1367fcc4bd4074$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $0c22fe48547aab28$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $58995a33ecde7fbe$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $0a597012195f13fa$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $06428341cf17e73a$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $cce85039f3ac0af1$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        this.panSession = new (0, $a8ab69c0bc78e8d6$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$cce85039f3ac0af1$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $72be0b6c6e9df432$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const { layout: layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $7a738a3c9374e55e$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $72be0b6c6e9df432$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $72be0b6c6e9df432$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $58995a33ecde7fbe$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $72be0b6c6e9df432$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $7a738a3c9374e55e$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $37fdec4f220cd02e$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $6d5ed500f2b0c6db$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $72be0b6c6e9df432$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $38f8a79a52c46c69$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $38f8a79a52c46c69$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $58995a33ecde7fbe$export$b789de563eb43b1)((axis)=>{
            if (!$cce85039f3ac0af1$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $b716785b0165e90e$export$90b3dfc33ff3548)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $58995a33ecde7fbe$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $58995a33ecde7fbe$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$cce85039f3ac0af1$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $7a738a3c9374e55e$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $58995a33ecde7fbe$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $72be0b6c6e9df432$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $58995a33ecde7fbe$export$b789de563eb43b1)((axis)=>{
            if (!$cce85039f3ac0af1$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $cce85039f3ac0af1$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $29924e8d44f9ed73$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $7a738a3c9374e55e$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $aacb07df10ff3166$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $58995a33ecde7fbe$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $72be0b6c6e9df432$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $cce85039f3ac0af1$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $cce85039f3ac0af1$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $801240383dad4f99$export$5d97dc2872682820 extends (0, $f2b79f7005177a9e$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $a3a6277fc71707ca$export$8793edee2d425525);
        this.removeListeners = (0, $a3a6277fc71707ca$export$8793edee2d425525);
        this.controls = new (0, $cce85039f3ac0af1$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $a3a6277fc71707ca$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}







const $fce1937051434d75$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(()=>handler(event, info));
    };
class $fce1937051434d75$export$b4f8f1ee75ce5859 extends (0, $f2b79f7005177a9e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $a3a6277fc71707ca$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $a8ab69c0bc78e8d6$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint()
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $fce1937051434d75$var$asyncHandler(onPanSessionStart),
            onStart: $fce1937051434d75$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $29924e8d44f9ed73$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $1fELX = parcelRequire("1fELX");

var $1fELX = parcelRequire("1fELX");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $46fd02bc651ff2ca$export$2a8c16d82a0a0e26() {
    const context = (0, $1fELX.useContext)((0, $101046bede865000$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $1fELX.useId)();
    (0, $1fELX.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $46fd02bc651ff2ca$export$8249053f690ea39a() {
    return $46fd02bc651ff2ca$export$ee27c052bca048fb((0, $1fELX.useContext)((0, $101046bede865000$export$f224e4635b6f8ce2)));
}
function $46fd02bc651ff2ca$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $30f2714c2475edca$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $0ef14d787487003f$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $0ef14d787487003f$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $0a597012195f13fa$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $0ef14d787487003f$export$fafff692be55225d(latest, node.target.x);
        const y = $0ef14d787487003f$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $db0fdcf1805dad95$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $b847becac8de69da$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $b847becac8de69da$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};




class $3147ae5a0ba38208$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $ed12628c6ba7107f$export$de9e7791c71225fd)($3147ae5a0ba38208$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $30f2714c2475edca$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $3d23425702b2eefa$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $3147ae5a0ba38208$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $46fd02bc651ff2ca$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $1fELX.useContext)((0, $fd2e4331a0c11561$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).createElement($3147ae5a0ba38208$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $1fELX.useContext)((0, $cea396ecc8fbc8b2$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $3147ae5a0ba38208$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $0ef14d787487003f$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $0ef14d787487003f$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $0ef14d787487003f$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $0ef14d787487003f$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $0ef14d787487003f$export$5eafb6257a5844c),
    boxShadow: (0, $db0fdcf1805dad95$export$eb0bc629e74dcf8)
};








const $6dd08eab309d2b7e$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $6dd08eab309d2b7e$var$numBorders = $6dd08eab309d2b7e$var$borders.length;
const $6dd08eab309d2b7e$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $6dd08eab309d2b7e$var$isPx = (value)=>typeof value === "number" || (0, $0a597012195f13fa$export$91c0eda1d06bf008).test(value);
function $6dd08eab309d2b7e$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $6dd08eab309d2b7e$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $6dd08eab309d2b7e$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $6dd08eab309d2b7e$var$numBorders; i++){
        const borderLabel = `border${$6dd08eab309d2b7e$var$borders[i]}Radius`;
        let followRadius = $6dd08eab309d2b7e$var$getRadius(follow, borderLabel);
        let leadRadius = $6dd08eab309d2b7e$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $6dd08eab309d2b7e$var$isPx(followRadius) === $6dd08eab309d2b7e$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)($6dd08eab309d2b7e$var$asNumber(followRadius), $6dd08eab309d2b7e$var$asNumber(leadRadius), progress), 0);
            if ((0, $0a597012195f13fa$export$626336c2cd4b14de).test(leadRadius) || (0, $0a597012195f13fa$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $6dd08eab309d2b7e$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $6dd08eab309d2b7e$var$easeCrossfadeIn = $6dd08eab309d2b7e$var$compress(0, 0.5, (0, $279430e8e3e021cc$export$c8d67a19199d1a50));
const $6dd08eab309d2b7e$var$easeCrossfadeOut = $6dd08eab309d2b7e$var$compress(0.5, 0.95, (0, $a3a6277fc71707ca$export$8793edee2d425525));
function $6dd08eab309d2b7e$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $e6d054f6bd4b2f86$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $cd0a228e4a19ec2b$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $cd0a228e4a19ec2b$export$c53fd88f45d77e4b(box, originBox) {
    $cd0a228e4a19ec2b$export$a0230ae482601ae8(box.x, originBox.x);
    $cd0a228e4a19ec2b$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $de2717ebee93c6cc$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $9ef09740eca346a4$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $9ef09740eca346a4$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $de2717ebee93c6cc$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $0a597012195f13fa$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $de2717ebee93c6cc$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $de2717ebee93c6cc$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $de2717ebee93c6cc$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $de2717ebee93c6cc$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $de2717ebee93c6cc$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $de2717ebee93c6cc$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $de2717ebee93c6cc$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $de2717ebee93c6cc$export$42b76f1d0d16d5b(box.x, transforms, $de2717ebee93c6cc$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $de2717ebee93c6cc$export$42b76f1d0d16d5b(box.y, transforms, $de2717ebee93c6cc$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $c736f87f7c922157$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $c736f87f7c922157$export$a7ec7642fe550fb6(delta) {
    return $c736f87f7c922157$var$isAxisDeltaZero(delta.x) && $c736f87f7c922157$var$isAxisDeltaZero(delta.y);
}
function $c736f87f7c922157$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $c736f87f7c922157$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $c736f87f7c922157$export$c5706146bc63213(box) {
    return (0, $06428341cf17e73a$export$c1c127004b72a37)(box.x) / (0, $06428341cf17e73a$export$c1c127004b72a37)(box.y);
}



class $332d5169acb33f55$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $c84ab96179a9f581$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $c84ab96179a9f581$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $532f8cffd7ae35eb$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $4558a4e5f4281463$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $a23daefbd4d713be$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $c84ab96179a9f581$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $c84ab96179a9f581$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $4558a4e5f4281463$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





/**
 * Timeout defined in ms
 */ function $bb9c4b5e897e6c6a$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $3d23425702b2eefa$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $3d23425702b2eefa$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $3d23425702b2eefa$export$ec99c0ef4978dccb)(checkElapsed);
}



function $78ddd89ae9ce874a$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $d454ef50c615e5da$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $9334f9bb9dabbd7e$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $7e7233c78c258da3$export$605d60a2578142d3)(value) ? value : (0, $c2ffb6e63d68ba98$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $b716785b0165e90e$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}





const $1fafe5dbe28586be$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $1fafe5dbe28586be$var$animationTarget = 1000;
let $1fafe5dbe28586be$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $1fafe5dbe28586be$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $1fafe5dbe28586be$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $1fafe5dbe28586be$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $1fafe5dbe28586be$var$projectionFrameData.totalNodes = $1fafe5dbe28586be$var$projectionFrameData.resolvedTargetDeltas = $1fafe5dbe28586be$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($1fafe5dbe28586be$export$131f2f0cc5fe9609);
                this.nodes.forEach($1fafe5dbe28586be$var$resolveTargetDelta);
                this.nodes.forEach($1fafe5dbe28586be$var$calcProjection);
                this.nodes.forEach($1fafe5dbe28586be$export$c2664f37bc951031);
                (0, $78ddd89ae9ce874a$export$e5185e241753e543)($1fafe5dbe28586be$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $a23daefbd4d713be$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $058749f336e77913$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $d454ef50c615e5da$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $bb9c4b5e897e6c6a$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $30f2714c2475edca$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $30f2714c2475edca$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($1fafe5dbe28586be$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $1fafe5dbe28586be$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $c736f87f7c922157$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $ab5f5e7ca2db4aaa$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $1fafe5dbe28586be$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $3d23425702b2eefa$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($1fafe5dbe28586be$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($1fafe5dbe28586be$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($1fafe5dbe28586be$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($1fafe5dbe28586be$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($1fafe5dbe28586be$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($1fafe5dbe28586be$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = performance.now();
            (0, $3d23425702b2eefa$export$fff89137e9e818ce).delta = (0, $87b952b96899abe3$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $3d23425702b2eefa$export$fff89137e9e818ce).timestamp);
            (0, $3d23425702b2eefa$export$fff89137e9e818ce).timestamp = now;
            (0, $3d23425702b2eefa$export$fff89137e9e818ce).isProcessing = true;
            (0, $3d23425702b2eefa$export$be3f796aed065412).update.process((0, $3d23425702b2eefa$export$fff89137e9e818ce));
            (0, $3d23425702b2eefa$export$be3f796aed065412).preRender.process((0, $3d23425702b2eefa$export$fff89137e9e818ce));
            (0, $3d23425702b2eefa$export$be3f796aed065412).render.process((0, $3d23425702b2eefa$export$fff89137e9e818ce));
            (0, $3d23425702b2eefa$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($1fafe5dbe28586be$var$clearSnapshot);
            this.sharedNodes.forEach($1fafe5dbe28586be$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            (0, $3d23425702b2eefa$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $3d23425702b2eefa$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $c736f87f7c922157$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $9e2e47e81ea2aed0$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $1fafe5dbe28586be$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $9ef09740eca346a4$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $9ef09740eca346a4$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
            (0, $cd0a228e4a19ec2b$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $cd0a228e4a19ec2b$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $9ef09740eca346a4$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $9ef09740eca346a4$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $9ef09740eca346a4$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $9ef09740eca346a4$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
            (0, $cd0a228e4a19ec2b$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $9ef09740eca346a4$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $9e2e47e81ea2aed0$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $9ef09740eca346a4$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $9e2e47e81ea2aed0$export$a545127cf1fbb600)(this.latestValues)) (0, $9ef09740eca346a4$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
            (0, $cd0a228e4a19ec2b$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $9e2e47e81ea2aed0$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $9e2e47e81ea2aed0$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $cd0a228e4a19ec2b$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $de2717ebee93c6cc$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $9e2e47e81ea2aed0$export$a545127cf1fbb600)(this.latestValues)) (0, $de2717ebee93c6cc$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $3d23425702b2eefa$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $3d23425702b2eefa$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
                    (0, $06428341cf17e73a$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $cd0a228e4a19ec2b$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $06428341cf17e73a$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $cd0a228e4a19ec2b$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $9ef09740eca346a4$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $cd0a228e4a19ec2b$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
                    (0, $06428341cf17e73a$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $cd0a228e4a19ec2b$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $1fafe5dbe28586be$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $9e2e47e81ea2aed0$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $9e2e47e81ea2aed0$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $3d23425702b2eefa$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $cd0a228e4a19ec2b$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $9ef09740eca346a4$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) lead.target = lead.layout.layoutBox;
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $9a77768ae7b08538$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $9a77768ae7b08538$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $9a77768ae7b08538$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $06428341cf17e73a$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $532f8cffd7ae35eb$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $1fafe5dbe28586be$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $9a77768ae7b08538$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($1fafe5dbe28586be$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $1fafe5dbe28586be$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $1fafe5dbe28586be$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $06428341cf17e73a$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $1fafe5dbe28586be$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $c736f87f7c922157$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
                    (0, $cd0a228e4a19ec2b$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $6dd08eab309d2b7e$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $3d23425702b2eefa$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(()=>{
                (0, $30f2714c2475edca$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $9334f9bb9dabbd7e$export$335a17c977067b99)(0, $1fafe5dbe28586be$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($1fafe5dbe28586be$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $1fafe5dbe28586be$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
                const xLength = (0, $06428341cf17e73a$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $06428341cf17e73a$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $cd0a228e4a19ec2b$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $9ef09740eca346a4$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $06428341cf17e73a$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $332d5169acb33f55$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $1fafe5dbe28586be$var$transformAxes.length; i++){
                const key = "rotate" + $1fafe5dbe28586be$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $825f34e50c18523b$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $825f34e50c18523b$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $9e2e47e81ea2aed0$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $532f8cffd7ae35eb$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $ed12628c6ba7107f$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $ed12628c6ba7107f$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $825f34e50c18523b$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($1fafe5dbe28586be$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $1fafe5dbe28586be$var$updateLayout(node) {
    node.updateLayout();
}
function $1fafe5dbe28586be$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $58995a33ecde7fbe$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $06428341cf17e73a$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($1fafe5dbe28586be$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $58995a33ecde7fbe$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $06428341cf17e73a$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $9a77768ae7b08538$export$3d227df54007d73a)();
        (0, $06428341cf17e73a$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $9a77768ae7b08538$export$3d227df54007d73a)();
        if (isShared) (0, $06428341cf17e73a$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $06428341cf17e73a$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $c736f87f7c922157$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
                    (0, $06428341cf17e73a$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
                    (0, $06428341cf17e73a$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $c736f87f7c922157$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $1fafe5dbe28586be$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $1fafe5dbe28586be$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $1fafe5dbe28586be$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $1fafe5dbe28586be$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $1fafe5dbe28586be$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $1fafe5dbe28586be$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $1fafe5dbe28586be$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $1fafe5dbe28586be$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $1fafe5dbe28586be$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $1fafe5dbe28586be$var$calcProjection(node) {
    node.calcProjection();
}
function $1fafe5dbe28586be$var$resetRotation(node) {
    node.resetRotation();
}
function $1fafe5dbe28586be$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $1fafe5dbe28586be$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $1fafe5dbe28586be$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $1fafe5dbe28586be$export$6ffd3e6ae339a132(output, from, to, p) {
    $1fafe5dbe28586be$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $1fafe5dbe28586be$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $1fafe5dbe28586be$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $1fafe5dbe28586be$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $1fafe5dbe28586be$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $1fafe5dbe28586be$var$roundPoint = $1fafe5dbe28586be$var$userAgentContains("applewebkit/") && !$1fafe5dbe28586be$var$userAgentContains("chrome/") ? Math.round : (0, $a3a6277fc71707ca$export$8793edee2d425525);
function $1fafe5dbe28586be$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $1fafe5dbe28586be$var$roundPoint(axis.min);
    axis.max = $1fafe5dbe28586be$var$roundPoint(axis.max);
}
function $1fafe5dbe28586be$var$roundBox(box) {
    $1fafe5dbe28586be$var$roundAxis(box.x);
    $1fafe5dbe28586be$var$roundAxis(box.y);
}
function $1fafe5dbe28586be$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $06428341cf17e73a$export$28d0384c4b79bde2)((0, $c736f87f7c922157$export$c5706146bc63213)(snapshot), (0, $c736f87f7c922157$export$c5706146bc63213)(layout), 0.2);
}




const $d63f3be20054c62b$export$2d029a49a09b6177 = (0, $1fafe5dbe28586be$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $aacb07df10ff3166$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $b7cb4da3cf4a187b$export$b91509fcf893b648 = {
    current: undefined
};
const $b7cb4da3cf4a187b$export$b61a9eb3dbde8858 = (0, $1fafe5dbe28586be$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$b7cb4da3cf4a187b$export$b91509fcf893b648.current) {
            const documentNode = new (0, $d63f3be20054c62b$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $b7cb4da3cf4a187b$export$b91509fcf893b648.current = documentNode;
        }
        return $b7cb4da3cf4a187b$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $7992692cd7606f5e$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $fce1937051434d75$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $801240383dad4f99$export$5d97dc2872682820),
        ProjectionNode: (0, $b7cb4da3cf4a187b$export$b61a9eb3dbde8858),
        MeasureLayout: $3147ae5a0ba38208$export$779f5fb01ad751cd
    }
};













/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $60fa31193063f18a$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $60fa31193063f18a$export$b9f0c1f373aee2b0(current) {
    const match = $60fa31193063f18a$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $60fa31193063f18a$var$maxDepth = 4;
function $60fa31193063f18a$var$getVariableValue(current, element, depth = 1) {
    (0, $37fdec4f220cd02e$export$f5708dca728d7177)(depth <= $60fa31193063f18a$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $60fa31193063f18a$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $5ecb7658c7ddf76c$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    } else if ((0, $c38983fabc3ecd20$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $60fa31193063f18a$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $60fa31193063f18a$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $c38983fabc3ecd20$export$31f9caa2600b5723)(current)) return;
        const resolved = $60fa31193063f18a$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $c38983fabc3ecd20$export$31f9caa2600b5723)(current)) continue;
        const resolved = $60fa31193063f18a$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}









const $099f5c4057eb8646$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $099f5c4057eb8646$var$isPositionalKey = (key)=>$099f5c4057eb8646$var$positionalKeys.has(key);
const $099f5c4057eb8646$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($099f5c4057eb8646$var$isPositionalKey);
};
const $099f5c4057eb8646$var$isNumOrPxType = (v)=>v === (0, $8b66f3157093c0fd$export$98e628dec113755e) || v === (0, $0a597012195f13fa$export$91c0eda1d06bf008);
const $099f5c4057eb8646$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $099f5c4057eb8646$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $099f5c4057eb8646$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $099f5c4057eb8646$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $099f5c4057eb8646$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $099f5c4057eb8646$var$nonTranslationalTransformKeys = (0, $65a4d8bb723a9720$export$280dc01950909d86).filter((key)=>!$099f5c4057eb8646$var$transformKeys.has(key));
function $099f5c4057eb8646$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $099f5c4057eb8646$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $099f5c4057eb8646$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $099f5c4057eb8646$var$getTranslateFromMatrix(4, 13),
    y: $099f5c4057eb8646$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$099f5c4057eb8646$export$781d46a8aa670d52.translateX = $099f5c4057eb8646$export$781d46a8aa670d52.x;
$099f5c4057eb8646$export$781d46a8aa670d52.translateY = $099f5c4057eb8646$export$781d46a8aa670d52.y;
const $099f5c4057eb8646$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $099f5c4057eb8646$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $099f5c4057eb8646$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $099f5c4057eb8646$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($099f5c4057eb8646$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $25ef98165f31c32a$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $cfb9b78a47dd237b$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $25ef98165f31c32a$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $25ef98165f31c32a$export$eefdd52e3ccae428)(to[i]);
                    (0, $37fdec4f220cd02e$export$f5708dca728d7177)(toType === fromType || $099f5c4057eb8646$var$isNumOrPxType(fromType) && $099f5c4057eb8646$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $37fdec4f220cd02e$export$f5708dca728d7177)((0, $25ef98165f31c32a$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $25ef98165f31c32a$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($099f5c4057eb8646$var$isNumOrPxType(fromType) && $099f5c4057eb8646$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $0a597012195f13fa$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $099f5c4057eb8646$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $099f5c4057eb8646$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $44af367f2f852964$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $099f5c4057eb8646$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $099f5c4057eb8646$var$hasPositionalKey(target) ? $099f5c4057eb8646$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $5f415a5bf93166e8$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $60fa31193063f18a$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $099f5c4057eb8646$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};






// Does this device prefer reduced motion? Returns `null` server-side.
const $c4bb4b7af2611afa$export$ff7706047246b98b = {
    current: null
};
const $c4bb4b7af2611afa$export$6476d16e2fd2d0db = {
    current: false
};


function $8a8966635d11e3b8$export$ca9f41fb23dded3d() {
    (0, $c4bb4b7af2611afa$export$6476d16e2fd2d0db).current = true;
    if (!(0, $44af367f2f852964$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $c4bb4b7af2611afa$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $c4bb4b7af2611afa$export$ff7706047246b98b).current = false;
}














function $d70fe24e707dc80a$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $7e7233c78c258da3$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $727fcacc9713ec9e$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $7e7233c78c258da3$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $c2ffb6e63d68ba98$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $727fcacc9713ec9e$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $c2ffb6e63d68ba98$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $12d1160d63b9dcbd$export$bc2a978a17abfdde = new WeakMap();



const $3b5844702f6f21f7$var$featureNames = Object.keys((0, $61fff2decb061cdc$export$65570e08d843624d));
const $3b5844702f6f21f7$var$numFeatures = $3b5844702f6f21f7$var$featureNames.length;
const $3b5844702f6f21f7$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $3b5844702f6f21f7$var$numVariantProps = (0, $e4fa23f226618644$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $3b5844702f6f21f7$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $3d23425702b2eefa$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $7b52befeb14e6684$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $7b52befeb14e6684$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $7e7233c78c258da3$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $727fcacc9713ec9e$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $12d1160d63b9dcbd$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $c4bb4b7af2611afa$export$6476d16e2fd2d0db).current) (0, $8a8966635d11e3b8$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $c4bb4b7af2611afa$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $12d1160d63b9dcbd$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $3d23425702b2eefa$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $3d23425702b2eefa$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $65a4d8bb723a9720$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $3b5844702f6f21f7$var$numFeatures; i++){
            const name = $3b5844702f6f21f7$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $61fff2decb061cdc$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $7a738a3c9374e55e$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $3b5844702f6f21f7$var$propEventHandlers.length; i++){
            const key = $3b5844702f6f21f7$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $d70fe24e707dc80a$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $3b5844702f6f21f7$var$numVariantProps; i++){
            const name = (0, $e4fa23f226618644$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $3190f36b71321c09$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $c2ffb6e63d68ba98$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $c46b2aeac8f69ef1$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $7e7233c78c258da3$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $058749f336e77913$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}


class $78c2f9fe5956289d$export$e49735c2a366bdc7 extends (0, $3b5844702f6f21f7$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $6ba193dea068d486$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $6ba193dea068d486$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $5f415a5bf93166e8$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}



function $4dc3827667a6bf2c$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $4dc3827667a6bf2c$export$23fea75b03ac16b3 extends (0, $78c2f9fe5956289d$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $65a4d8bb723a9720$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $974e21b30ad0137b$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $4dc3827667a6bf2c$export$3735103072e4a80(instance);
            const value = ((0, $c38983fabc3ecd20$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $6d5ed500f2b0c6db$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $c2704297486be9bf$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $bfd10de960536988$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $7e7233c78c258da3$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $29b89cae4ff1c3ba$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $d9313b7cad8364a5$export$86bcdffbaf733d84 extends (0, $78c2f9fe5956289d$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $65a4d8bb723a9720$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $974e21b30ad0137b$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $7cf13c19abf36556$export$28931db5d57958e5).has(key) ? (0, $92d636a7e44e6950$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $9a77768ae7b08538$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $5d13043f52b61163$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $70bb1f4d5de4f5b5$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $80c9925ca43d5135$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $d49d8e9d1197304d$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $2ae2617a8af1d504$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $a1d0fd0b7b9867ca$export$88f3fc2fd3766989)(Component) ? new (0, $d9313b7cad8364a5$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $4dc3827667a6bf2c$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $c49f181985880691$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $b7cb4da3cf4a187b$export$b61a9eb3dbde8858),
        MeasureLayout: $3147ae5a0ba38208$export$779f5fb01ad751cd
    }
};


const $b769f11e629ddf15$var$preloadedFeatures = {
    ...(0, $bac2628a29d5bd03$export$7f9953c70dacfd7f),
    ...(0, $4b1532b9d8f6f66a$export$e5b72898e5a201f1),
    ...(0, $7992692cd7606f5e$export$d7d5d435647ed5a0),
    ...(0, $c49f181985880691$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $b769f11e629ddf15$export$e25e478948902b8b = /*@__PURE__*/ (0, $0fbc3d1fdb918876$export$a28d6df673050e18)((Component, config)=>(0, $451276071798d45e$export$732916c0e88175fb)(Component, config, $b769f11e629ddf15$var$preloadedFeatures, (0, $2ae2617a8af1d504$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $b769f11e629ddf15$export$546614c4a05701f9(key) {
    return (0, $91946d356494d93e$export$46b7e4b9dc6110c3)((0, $451276071798d45e$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $b769f11e629ddf15$var$preloadedFeatures, (0, $2ae2617a8af1d504$export$56ba0183203348f5)));
}







class $34ef2847a1b462ae$export$3fe5fa490af65f85 extends (0, $c2ffb6e63d68ba98$export$8cea36d14ee64562) {
    constructor(){
        super(...arguments);
        this.members = [];
        this.transforms = new Set();
    }
    add(name) {
        let memberName;
        if ((0, $65a4d8bb723a9720$export$7b42a0094fb00b6e).has(name)) {
            this.transforms.add(name);
            memberName = "transform";
        } else if (!name.startsWith("origin") && !(0, $c38983fabc3ecd20$export$9de1236619d9e756)(name) && name !== "willChange") memberName = (0, $92d636a7e44e6950$export$9fd24a634729c672)(name);
        if (memberName) {
            (0, $c84ab96179a9f581$export$20e507e47fae79fd)(this.members, memberName);
            this.update();
        }
    }
    remove(name) {
        if ((0, $65a4d8bb723a9720$export$7b42a0094fb00b6e).has(name)) {
            this.transforms.delete(name);
            if (!this.transforms.size) (0, $c84ab96179a9f581$export$fe2d9b4e03920b4c)(this.members, "transform");
        } else (0, $c84ab96179a9f581$export$fe2d9b4e03920b4c)(this.members, (0, $92d636a7e44e6950$export$9fd24a634729c672)(name));
        this.update();
    }
    update() {
        this.set(this.members.length ? this.members.join(", ") : "auto");
    }
}
function $34ef2847a1b462ae$export$384afe146fc0c056() {
    return (0, $6d4d3a80aee48cda$export$fe4300aa8eebea86)(()=>new $34ef2847a1b462ae$export$3fe5fa490af65f85("auto"));
}



var $1fELX = parcelRequire("1fELX");
const $0861364603d97aac$export$48cccd7fbde04223 = ({ image: image, delayBoundingBox: delayBoundingBox = false })=>{
    const imgRef = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef(null);
    const [boxStyle, setBoxStyle] = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useState(null);
    const willChange = (0, $34ef2847a1b462ae$export$384afe146fc0c056)();
    const { boundingBox: boundingBox } = image;
    const handleLoad = ()=>{
        if (imgRef.current && boundingBox) {
            const widthPercentage = (value)=>value / imgRef.current.naturalWidth * 100 + "%";
            const heightPercentage = (value)=>value / imgRef.current.naturalHeight * 100 + "%";
            setBoxStyle({
                top: heightPercentage(boundingBox.yMin),
                left: widthPercentage(boundingBox.xMin),
                width: widthPercentage(boundingBox.xMax - boundingBox.xMin),
                height: heightPercentage(boundingBox.yMax - boundingBox.yMin)
            });
        }
    };
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
        className: "relative h-full",
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                ref: imgRef,
                src: image.imageSrc,
                className: "h-full",
                onLoad: handleLoad
            }),
            boxStyle && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b769f11e629ddf15$export$e25e478948902b8b).svg, {
                style: {
                    willChange: willChange
                },
                viewBox: "0 0 40 40",
                preserveAspectRatio: "none",
                className: "absolute",
                initial: {
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    opacity: 0
                },
                animate: {
                    top: boxStyle.top,
                    left: boxStyle.left,
                    width: boxStyle.width,
                    height: boxStyle.height,
                    opacity: 1,
                    transition: {
                        duration: 1.2,
                        delay: delayBoundingBox ? 0.8 : 0,
                        ease: "easeIn"
                    }
                },
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("rect", {
                    width: "40",
                    height: "40",
                    className: "marching-rect"
                })
            })
        ]
    });
};


const $88c177f3e0191424$export$b695f824f00c1cb0 = ({ setImageId: setImageId, gameSession: gameSession, imageId: imageId })=>{
    const image = gameSession.shownImages.find((image)=>image.id == imageId);
    if (!image) return;
    const imageIndex = gameSession.shownImages.map((image)=>image.id).indexOf(image.id);
    const consensusFeatures = image.groundTruth?.characteristics;
    const consensusGrading = image.groundTruth?.grading;
    const finding = image.modelResult?.findings[0];
    const modelGrading = finding?.grading;
    const userSelection = gameSession.selectionHistory.find((selection)=>selection.dicomId === image.id);
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $01494118b1e6559d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                className: "flex text-left mb-8 py-3",
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("h2", {
                    className: "text-display1 text-white py-2",
                    children: [
                        "Image ",
                        (0, $1471987380e9ac3d$export$d20f921b8f89dc37)(imageIndex + 1),
                        userSelection?.grading && ` - You selected ${(0, $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)[userSelection.grading].label}`,
                        userSelection?.grading && userSelection?.grading == consensusGrading && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                            name: "check",
                            className: "text-neutral-50 w-[42px] h-[42px] pl-4"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                className: "grid gap-4 grid-cols-resultDetail grid-rows-[minmax(57px,_auto)]",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                        className: "row-span-2",
                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $0861364603d97aac$export$48cccd7fbde04223), {
                            image: image
                        })
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                        className: "bg-neutral-400 rounded-t-lg h-[57px] grid justify-center items-center",
                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($718c28c0b6f98086$exports))),
                            className: "inline"
                        })
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                        className: "bg-primary rounded-t-lg text-neutral-900 text-center font-bold text-display3 py-[12px] h-[57px]",
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                name: "consensus",
                                className: "text-black w-[32px] h-[32px] pr-2"
                            }),
                            "Consensus"
                        ]
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                        className: "detail-table grid col-span-2 grid-cols-[minmax(auto,_200px)_minmax(auto,_175px)] gap-x-4 grid-rows-[repeat(5,_max-content)_auto]",
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                className: "bg-neutral-400/20 grid justify-end grid-cols-[auto_30px] pt-4 px-4",
                                children: [
                                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                        className: "flex items-center justify-center bg-neutral-200/40 rounded-lg w-[80px] h-[36px] text-neutral-50 text-display6",
                                        children: modelGrading && (0, $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)[modelGrading].label
                                    }),
                                    modelGrading === consensusGrading && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                        name: "check",
                                        className: "text-neutral-50 w-[24px] h-[24px] self-center justify-self-end"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                className: "bg-primary/10 pt-4 px-4",
                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                    className: "flex items-center justify-center bg-primary/10 rounded-lg  w-[80px] h-[36px] text-primary text-display6",
                                    children: consensusGrading && (0, $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)[consensusGrading].label
                                })
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($88c177f3e0191424$var$DetailTableCell, {
                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                    className: "border-t border-neutral-50 grid justify-end grid-cols-[auto_30px] gap-y-3 pt-4",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $8bffb1d2969323f1$export$d2cf3038149dd1b5), {
                                            text: finding?.characteristics.composition,
                                            className: "bg-neutral-200 justify-self-end"
                                        }),
                                        finding?.characteristics.composition == consensusFeatures?.composition ? /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                            name: "check",
                                            className: "text-neutral-50 w-[24px] h-[24px] self-center justify-self-end"
                                        }) : /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($88c177f3e0191424$var$DetailTableCell, {
                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                    className: "border-t border-primary grid justify-end grid-cols-1 pt-4",
                                    children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $8bffb1d2969323f1$export$d2cf3038149dd1b5), {
                                        text: consensusFeatures?.composition,
                                        className: "bg-primary"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($88c177f3e0191424$var$DetailTableCell, {
                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                    className: "grid justify-end grid-cols-[auto_30px] pb-[0px]",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $8bffb1d2969323f1$export$d2cf3038149dd1b5), {
                                            text: finding?.characteristics.echogenicity,
                                            className: "bg-neutral-200 justify-self-end"
                                        }),
                                        finding?.characteristics.echogenicity == consensusFeatures?.echogenicity ? /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                            name: "check",
                                            className: "text-neutral-50 w-[24px] h-[24px] self-center justify-self-end"
                                        }) : /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($88c177f3e0191424$var$DetailTableCell, {
                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $8bffb1d2969323f1$export$d2cf3038149dd1b5), {
                                    text: consensusFeatures?.echogenicity,
                                    className: "bg-primary"
                                })
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($88c177f3e0191424$var$DetailTableCell, {
                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                    className: "grid justify-end grid-cols-[auto_30px]",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $8bffb1d2969323f1$export$d2cf3038149dd1b5), {
                                            text: finding?.characteristics.shape,
                                            className: "bg-neutral-200 justify-self-end"
                                        }),
                                        finding?.characteristics.shape == consensusFeatures?.shape ? /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                            name: "check",
                                            className: "text-neutral-50 w-[24px] h-[24px] self-center justify-self-end"
                                        }) : /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($88c177f3e0191424$var$DetailTableCell, {
                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $8bffb1d2969323f1$export$d2cf3038149dd1b5), {
                                    text: consensusFeatures?.shape,
                                    className: "bg-primary"
                                })
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($88c177f3e0191424$var$DetailTableCell, {
                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                    className: "grid justify-end grid-cols-[auto_30px]",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $8bffb1d2969323f1$export$d2cf3038149dd1b5), {
                                            text: finding?.characteristics.margin,
                                            className: "bg-neutral-200 justify-self-end"
                                        }),
                                        finding?.characteristics.margin == consensusFeatures?.margin ? /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                            name: "check",
                                            className: "text-neutral-50 w-[24px] h-[24px] self-center justify-self-end"
                                        }) : /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($88c177f3e0191424$var$DetailTableCell, {
                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $8bffb1d2969323f1$export$d2cf3038149dd1b5), {
                                    text: consensusFeatures?.margin,
                                    className: "bg-primary"
                                })
                            }),
                            finding?.characteristics.echogenicFoci.map((value, index)=>{
                                if (!value) return null;
                                return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $01494118b1e6559d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($88c177f3e0191424$var$DetailTableCell, {
                                            children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                                className: "grid justify-end grid-cols-[auto_30px] pb-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $8bffb1d2969323f1$export$d2cf3038149dd1b5), {
                                                        text: value,
                                                        className: "bg-neutral-200 justify-self-end"
                                                    }),
                                                    (0, $1471987380e9ac3d$export$b21e1b8d67919b37)(finding?.characteristics.echogenicFoci, consensusFeatures?.echogenicFoci) && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                                        name: "check",
                                                        className: "text-neutral-50 w-[24px] h-[24px] self-center justify-self-end"
                                                    })
                                                ]
                                            })
                                        }, index),
                                        consensusFeatures?.echogenicFoci.map((value, index)=>{
                                            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($88c177f3e0191424$var$DetailTableCell, {
                                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                                    className: "pb-4",
                                                    children: value && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $8bffb1d2969323f1$export$d2cf3038149dd1b5), {
                                                        text: value,
                                                        className: "bg-primary"
                                                    })
                                                })
                                            }, index);
                                        })
                                    ]
                                });
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b280a35ff744d18b$export$f1011c2ab959143d), {
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                    variant: "neutral",
                    onClick: ()=>setImageId(undefined),
                    children: [
                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                            name: "arrow-left",
                            className: "text-neutral-50 w-[24px] h-[24px]"
                        }),
                        "Back"
                    ]
                })
            })
        ]
    });
};
const $88c177f3e0191424$var$DetailTableCell = ({ children: children })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
        className: "pl-2 pr-2 pt-2 odd:bg-neutral-400/20 even:bg-primary/10 auto-rows-max",
        children: children
    });
};



const $d92e9fb9044b3545$export$8fdcabde73f49165 = ({ setGameStatus: setGameStatus, gameSession: gameSession })=>{
    const [imageId, setImageId] = (0, $1fELX.useState)(undefined);
    const numOfCorrectSelection = gameSession.shownImages.filter((image)=>{
        const userSelection = gameSession.selectionHistory.find((history)=>history.dicomId == image.id);
        return userSelection?.grading === image.groundTruth?.grading;
    }).length;
    const numOfCorrectModelSelection = gameSession.shownImages.filter((image)=>image.modelResult?.findings[0].grading === image.groundTruth?.grading).length;
    const totalUsedTimeModel = gameSession.shownImages.reduce((sum, image)=>{
        return sum + (image.modelResult?.usedTime || 0);
    }, 0);
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b280a35ff744d18b$export$b89a827e9254211a), {
        children: imageId ? /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $88c177f3e0191424$export$b695f824f00c1cb0), {
            gameSession: gameSession,
            setImageId: setImageId,
            imageId: imageId
        }) : /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $01494118b1e6559d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$8868dba5c6237081), {
                    children: [
                        "WOW! You collected",
                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                            name: "star",
                            className: "text-primary w-[44px] h-[44px] mr-3 ml-7"
                        }),
                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("span", {
                            className: "text-primary",
                            children: [
                                gameSession.score,
                                " Points"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$a2a14dc5e9bae153), {
                    children: [
                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                            className: "grid gap-4 grid-cols-result",
                            children: [
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {}),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                    className: "bg-neutral-400 rounded-t-lg text-center flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($718c28c0b6f98086$exports))),
                                        className: "inline"
                                    })
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                    className: "bg-primary rounded-t-lg text-neutral-900 font-bold text-display6 flex items-center justify-center flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                            name: "consensus",
                                            className: "text-black w-[24px] h-[24px] mt-2"
                                        }),
                                        "Consensus"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                    className: "bg-neutral-400 rounded-t-lg  text-primary font-bold text-display2 flex items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                            name: "star",
                                            className: "text-primary w-[32px] h-[32px]"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                                            className: "mx-5",
                                            children: "You"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                            name: "star",
                                            className: "text-primary w-[32px] h-[32px]"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                            className: "overflow-y-auto max-h-[40vh] mt-4 2xl:max-h-[40vh]",
                            children: gameSession.shownImages.map((image, index)=>{
                                return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $ac40294a8e4334e3$export$a1d3af27dd9ed829), {
                                    image: image,
                                    index: index + 1,
                                    selectionHistory: gameSession.selectionHistory,
                                    setImageId: setImageId
                                }, image.id);
                            })
                        }),
                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                            className: "grid gap-4 mt-4 grid-cols-result ",
                            children: [
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {}),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                    className: "bg-neutral-500 border-neutral-400 border-2 grid grid-cols-[2fr_1fr] gap-3 justify-items-center align-middle h-[48px]",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                            className: "flex items-center justify-self-start pl-8 gap-x-[4px]",
                                            children: [
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                                    name: "clock",
                                                    className: "text-neutral-300 w-[32px] h-[32px]"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                                                    className: "text-display2",
                                                    children: (0, $a15d49ed6e92009e$export$5daf09ba04077ce8)(totalUsedTimeModel)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                            className: "flex items-center gap-x-[8px]",
                                            children: [
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                                                    className: "text-display2",
                                                    children: numOfCorrectModelSelection
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                                    name: "check",
                                                    className: "text-neutral-50 w-[32px] h-[32px]"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {}),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                    className: "row-span-2",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                            className: "bg-neutral-500 border-neutral-400 border-2 grid grid-cols-[1fr_2fr] gap-3 justify-items-center align-middle h-[48px]",
                                            children: [
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                                    className: "flex items-center gap-x-[8px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                                                            className: "text-display2",
                                                            children: numOfCorrectSelection
                                                        }),
                                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                                            name: "check",
                                                            className: "text-neutral-50 w-[32px] h-[32px]"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                                    className: "flex items-center justify-self-end pr-8 gap-x-[4px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                                            name: "clock",
                                                            className: "text-neutral-300 w-[32px] h-[32px]"
                                                        }),
                                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                                                            className: "text-primary text-display2",
                                                            children: (0, $a15d49ed6e92009e$export$5daf09ba04077ce8)(gameSession.totalTime)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                            className: "flex items-center flex-row-reverse mr-8 mt-4",
                                            children: [
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                                                    className: "text-display2 text-primary pl-3",
                                                    children: gameSession.score
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                                    name: "star",
                                                    className: "text-primary w-[32px] h-[32px]"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b280a35ff744d18b$export$f1011c2ab959143d), {
                    children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                        variant: "primary",
                        onClick: ()=>setGameStatus((0, $fe11df8941c5cc1d$export$23c7328964450bd2).PlayerDetails),
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                name: "trophy-wire-frame",
                                className: "text-neutral-900 w-[24px] h-[24px]"
                            }),
                            "View Ranking"
                        ]
                    })
                })
            ]
        })
    });
};


const $505cc0e1cc0a03bf$export$b018b9e416692c43 = (composition)=>{
    switch(composition){
        case "solid_or_almost_completely_solid":
            return "Solid or almost completely solid";
        case "mixed_cystic_&_solid":
            return "Mixed cystic and solid";
        case "cystic/almost_completely_cystic":
            return "Cystic or almost completely cystic";
        case "spongiform":
            return "Spongiform";
        default:
            return composition || "";
    }
};
const $505cc0e1cc0a03bf$export$d5cd69ed0f64d080 = (echogenicity)=>{
    switch(echogenicity){
        case "anechoic":
            return "Anechoic";
        case "hyperechoic_or_isoechoic":
            return "Hyperechoic or isoechoic";
        case "hypoechoic":
            return "Hypoechoic";
        case "very_hypoechoic":
            return "Very hypoechoic";
        default:
            return echogenicity || "";
    }
};
const $505cc0e1cc0a03bf$export$bc50eaca7eabc91f = (shape)=>{
    switch(shape){
        case "wider_than_tall":
            return "Wider than tall";
        case "taller_than_wide":
            return "Taller than wide";
        default:
            return shape || "";
    }
};
const $505cc0e1cc0a03bf$export$5ee42cabcc813479 = (margin)=>{
    switch(margin){
        case "smooth":
            return "Smooth";
        case "ill-defined":
        case "ill defined":
            return "Ill defined";
        case "lobulated_or_irregular":
            return "Lobulated or irregular";
        case "extra_thyroidal_extension":
            return "Extra thyroidal extension";
        default:
            return margin || "";
    }
};
const $505cc0e1cc0a03bf$export$d85a97fafa17208b = (echogenicFoci)=>{
    return echogenicFoci?.map((value)=>{
        switch(value){
            case "macrocalcifications":
                return "Macrocalcifications";
            case "peripheral_(rim)_calcification":
                return "Peripheral (rim) calcifications";
            case "punctate_echogenic_foci":
                return "Punctate echogenic foci";
            case "none_or_large_comet_tail_artefacts":
            case "none_or_large_comet-tail_artefacts":
            default:
                return "None or large comet-tail artefacts";
        }
    }) || [
        "None or large comet-tail artefacts"
    ];
};



var $c5376fdb434288c4$exports = {};
$c5376fdb434288c4$exports = JSON.parse('{"P2000245-b":{"ground_truth":{"grading":3,"characteristics":{"composition":"solid_or_almost_completely_solid","echogenicity":"hyperechoic_or_isoechoic","margin":"smooth","echogenic_foci":["none_or_large_comet-tail_artefacts"],"shape":"wider_than_tall"}},"images_names":["IM000001","IM000002"],"model_result":{"findings":{"grading":3,"characteristics":{"composition":"solid_or_almost_completely_solid","margin":"smooth","echogenicity":"hyperechoic_or_isoechoic","echogenic_foci":"none_or_large_comet_tail_artefacts","shape":"wider_than_tall"}}},"bounding_boxes":[315,169,511,431],"image_src":"P2000245-b/IM000001.png","id":"P2000245-b_IM000001"},"PA000026-b":{"ground_truth":{"grading":1,"characteristics":{"composition":"cystic/almost_completely_cystic","echogenicity":"anechoic","margin":"smooth","echogenic_foci":["none_or_large_comet-tail_artefacts"],"shape":"wider_than_tall"}},"images_names":["IM000001","IM000002"],"model_result":{"findings":{"grading":1,"characteristics":{"composition":"cystic/almost_completely_cystic","margin":"smooth","echogenicity":"hyperechoic_or_isoechoic","echogenic_foci":"none_or_large_comet_tail_artefacts","shape":"wider_than_tall"}}},"bounding_boxes":[248,162,568,372],"image_src":"PA000026-b/IM000001.png","id":"PA000026-b_IM000001"},"5000431421-m":{"ground_truth":{"grading":5,"characteristics":{"composition":"solid_or_almost_completely_solid","echogenicity":"very_hypoechoic","margin":"lobulated_or_irregular","echogenic_foci":null,"shape":"wider_than_tall"}},"images_names":["1.2.826.0.1.3680043.8.498.44636551017316469804588618221657215898.dcm","1.2.826.0.1.3680043.8.498.58344224246455850211648464268304318997.dcm"],"model_result":{"findings":{"grading":5,"characteristics":{"composition":"solid_or_almost_completely_solid","margin":"lobulated_or_irregular","echogenicity":"very_hypoechoic","echogenic_foci":"none_or_large_comet_tail_artefacts","shape":"wider_than_tall"}}},"bounding_boxes":[349,281,164,132],"image_src":"5000431421-m/1.2.826.0.1.3680043.8.498.44636551017316469804588618221657215898.dcm.png","id":"5000431421-m_1.2.826.0.1.3680043.8.498.44636551017316469804588618221657215898.dcm"},"5000820574-b":{"ground_truth":{"grading":2,"characteristics":{"composition":"mixed_cystic_&_solid","echogenicity":"hyperechoic_or_isoechoic","margin":"smooth","echogenic_foci":null,"shape":"wider_than_tall"}},"images_names":["1.2.826.0.1.3680043.8.498.13068505253431065240764062365236107106.dcm","1.2.826.0.1.3680043.8.498.84369049204068245717733308269820910259.dcm"],"model_result":{"findings":{"grading":2,"characteristics":{"composition":"mixed_cystic_&_solid","margin":"smooth","echogenicity":"hyperechoic_or_isoechoic","echogenic_foci":"none_or_large_comet_tail_artefacts","shape":"wider_than_tall"}}},"bounding_boxes":[196,267,580,325],"image_src":"5000820574-b/1.2.826.0.1.3680043.8.498.13068505253431065240764062365236107106.dcm.png","id":"5000820574-b_1.2.826.0.1.3680043.8.498.13068505253431065240764062365236107106.dcm"},"5001404450-m":{"ground_truth":{"grading":3,"characteristics":{"composition":"solid_or_almost_completely_solid","echogenicity":"hyperechoic_or_isoechoic","margin":"smooth","echogenic_foci":null,"shape":"wider_than_tall"}},"images_names":["1.2.826.0.1.3680043.8.498.11373352633426108031523672857818122188.dcm","1.2.826.0.1.3680043.8.498.11846894989284081733200855633689097336.dcm"],"model_result":{"findings":{"grading":3,"characteristics":{"composition":"solid_or_almost_completely_solid","margin":"smooth","echogenicity":"hyperechoic_or_isoechoic","echogenic_foci":"none_or_large_comet_tail_artefacts","shape":"wider_than_tall"}}},"bounding_boxes":[244,227,353,286],"image_src":"5001404450-m/1.2.826.0.1.3680043.8.498.11373352633426108031523672857818122188.dcm.png","id":"5001404450-m_1.2.826.0.1.3680043.8.498.11373352633426108031523672857818122188.dcm"},"5001568820-m":{"ground_truth":{"grading":4,"characteristics":{"composition":"solid_or_almost_completely_solid","echogenicity":"hypoechoic","margin":"smooth","echogenic_foci":null,"shape":"wider_than_tall"}},"images_names":["IMG-0006-00001.dcm","IMG-0007-00001.dcm"],"model_result":{"findings":{"grading":4,"characteristics":{"composition":"solid_or_almost_completely_solid","margin":"smooth","echogenicity":"hypoechoic","echogenic_foci":"none_or_large_comet_tail_artefacts","shape":"wider_than_tall"}}},"bounding_boxes":[213,214,405,336],"image_src":"5001568820-m/IMG-0006-00001.dcm.png","id":"5001568820-m_IMG-0006-00001.dcm"},"P2000132-b":{"ground_truth":{"grading":1,"characteristics":{"composition":"cystic/almost_completely_cystic","echogenicity":"anechoic","margin":"smooth","echogenic_foci":["none_or_large_comet-tail_artefacts"],"shape":"wider_than_tall"}},"images_names":["IM000001","IM000006"],"model_result":{"findings":{"grading":2,"characteristics":{"composition":"cystic/almost_completely_cystic","margin":"smooth","echogenicity":"hyperechoic_or_isoechoic","echogenic_foci":"macrocalcifications","shape":"wider_than_tall"}}},"bounding_boxes":[421,230,256,264],"image_src":"P2000132-b/IM000001.png","id":"P2000132-b_IM000001"},"P2000019-b":{"ground_truth":{"grading":4,"characteristics":{"composition":"solid_or_almost_completely_solid","echogenicity":"hypoechoic","margin":"smooth","echogenic_foci":null,"shape":"wider_than_tall"}},"images_names":["IM000001","IM000013"],"model_result":{"findings":{"grading":3,"characteristics":{"composition":"solid_or_almost_completely_solid","margin":"smooth","echogenicity":"hyperechoic_or_isoechoic","echogenic_foci":"none_or_large_comet_tail_artefacts","shape":"wider_than_tall"}}},"bounding_boxes":[408,250,312,244],"image_src":"P2000019-b/IM000001.png","id":"P2000019-b_IM000001"},"P2000023-b":{"ground_truth":{"grading":2,"characteristics":{"composition":"mixed_cystic_&_solid","echogenicity":"hyperechoic_or_isoechoic","margin":"smooth","echogenic_foci":null,"shape":"wider_than_tall"}},"images_names":["IM000001","IM000004"],"model_result":{"findings":{"grading":2,"characteristics":{"composition":"mixed_cystic_&_solid","margin":"smooth","echogenicity":"hyperechoic_or_isoechoic","echogenic_foci":"none_or_large_comet_tail_artefacts","shape":"wider_than_tall"}}},"bounding_boxes":[346,158,381,339],"image_src":"P2000023-b/IM000001.png","id":"P2000023-b_IM000001"},"5002647812-m":{"ground_truth":{"grading":5,"characteristics":{"composition":"solid_or_almost_completely_solid","echogenicity":"very_hypoechoic","margin":"lobulated_or_irregular","echogenic_foci":null,"shape":"taller_than_wide"}},"images_names":["1.2.826.0.1.3680043.8.498.11373256303656691750883487612469561501.dcm","1.2.826.0.1.3680043.8.498.65936577258639847130706552679454687702.dcm"],"model_result":{"findings":{"grading":5,"characteristics":{"composition":"solid_or_almost_completely_solid","margin":"lobulated_or_irregular","echogenicity":"very_hypoechoic","echogenic_foci":"none_or_large_comet_tail_artefacts","shape":"taller_than_wide"}}},"bounding_boxes":[385,349,189,214],"image_src":"5002647812-m/1.2.826.0.1.3680043.8.498.11373256303656691750883487612469561501.dcm.png","id":"5002647812-m_1.2.826.0.1.3680043.8.498.11373256303656691750883487612469561501.dcm"}}');


const $7608f61690e7ec76$export$325b3be5de81a33b = ()=>{
    const decodedImageData = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($c5376fdb434288c4$exports)))).map((key)=>{
        return $7608f61690e7ec76$export$3c17c3d89b3e617e((0, (/*@__PURE__*/$parcel$interopDefault($c5376fdb434288c4$exports)))[key]);
    });
    return $7608f61690e7ec76$var$shuffle(decodedImageData);
};
const $7608f61690e7ec76$export$3c17c3d89b3e617e = (data)=>{
    const characteristics = data.ground_truth.characteristics;
    const usedTime = $7608f61690e7ec76$var$generateModelResultUsedTime();
    return {
        id: data.id,
        imageSrc: "/rsna_data_output/" + data.image_src,
        boundingBox: $7608f61690e7ec76$var$decodeBoundingBoxes(data.bounding_boxes),
        modelResult: {
            findings: $7608f61690e7ec76$var$decodeModelResult(data.model_result),
            usedTime: usedTime
        },
        groundTruth: {
            characteristics: $7608f61690e7ec76$var$decodeCharacteristics(characteristics),
            grading: $7608f61690e7ec76$var$decodeGrading(data.ground_truth.grading)
        }
    };
};
const $7608f61690e7ec76$var$decodeCharacteristics = (characteristics)=>{
    return {
        composition: (0, $505cc0e1cc0a03bf$export$b018b9e416692c43)(characteristics.composition),
        echogenicity: (0, $505cc0e1cc0a03bf$export$d5cd69ed0f64d080)(characteristics.echogenicity),
        shape: (0, $505cc0e1cc0a03bf$export$bc50eaca7eabc91f)(characteristics.shape),
        margin: (0, $505cc0e1cc0a03bf$export$5ee42cabcc813479)(characteristics.margin),
        echogenicFoci: Array.isArray(characteristics.echogenic_foci) ? (0, $505cc0e1cc0a03bf$export$d85a97fafa17208b)(characteristics.echogenic_foci) : (0, $505cc0e1cc0a03bf$export$d85a97fafa17208b)([
            characteristics.echogenic_foci
        ])
    };
};
const $7608f61690e7ec76$var$decodeGrading = (grading)=>{
    switch(grading){
        case 1:
            return (0, $cc00f4b137e2dc0c$export$80d18f138b02e097).TR1;
        case 2:
            return (0, $cc00f4b137e2dc0c$export$80d18f138b02e097).TR2;
        case 3:
            return (0, $cc00f4b137e2dc0c$export$80d18f138b02e097).TR3;
        case 4:
            return (0, $cc00f4b137e2dc0c$export$80d18f138b02e097).TR4;
        case 5:
            return (0, $cc00f4b137e2dc0c$export$80d18f138b02e097).TR5;
        default:
            console.error(`Cannot decode grading ${grading}`);
            return (0, $cc00f4b137e2dc0c$export$80d18f138b02e097).TR1;
    }
};
const $7608f61690e7ec76$var$decodeBoundingBoxes = (boundingBoxes)=>{
    return {
        xMin: boundingBoxes[0],
        xMax: boundingBoxes[0] + boundingBoxes[2],
        yMin: boundingBoxes[1],
        yMax: boundingBoxes[1] + boundingBoxes[3]
    };
};
const $7608f61690e7ec76$var$decodeModelResult = (result)=>{
    const findings = result.findings;
    if (Array.isArray(findings)) return findings.map((finding)=>{
        return {
            characteristics: $7608f61690e7ec76$var$decodeCharacteristics(finding.characteristics),
            grading: $7608f61690e7ec76$var$decodeGrading(finding.grading)
        };
    });
    else return [
        {
            characteristics: $7608f61690e7ec76$var$decodeCharacteristics(findings.characteristics),
            grading: $7608f61690e7ec76$var$decodeGrading(findings.grading)
        }
    ];
};
const $7608f61690e7ec76$var$generateModelResultUsedTime = ()=>{
    // generate model result used time between 200 to 300 milliseconds
    return 200 + Math.floor(Math.random() * 10) * 10 + Math.floor(Math.random() * 10);
};
const $7608f61690e7ec76$var$shuffle = (array)=>{
    return array.sort(()=>Math.random() - 0.5);
};


const $042a7e9d97463528$export$321dbc493110171c = (0, $7608f61690e7ec76$export$325b3be5de81a33b)();
// Preload the images for seamless rendering
$042a7e9d97463528$export$321dbc493110171c.forEach((imageData)=>{
    const img = new Image();
    img.src = imageData.imageSrc;
});




var $1fELX = parcelRequire("1fELX");



var $1fELX = parcelRequire("1fELX");

var $1fELX = parcelRequire("1fELX");

var $1fELX = parcelRequire("1fELX");

function $a56596ec9efafa16$export$80c2a3957bcb42ea() {
    const isMounted = (0, $1fELX.useRef)(false);
    (0, $e977dcf06c49c0b9$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}



function $70f3c0d3fcca6f28$export$91db9bc4f8ac944a() {
    const isMounted = (0, $a56596ec9efafa16$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $1fELX.useState)(0);
    const forceRender = (0, $1fELX.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $1fELX.useCallback)(()=>(0, $3d23425702b2eefa$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $1fELX = parcelRequire("1fELX");



var $1fELX = parcelRequire("1fELX");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $79ad1c355fe6a9a5$var$PopChildMeasure extends $1fELX.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $79ad1c355fe6a9a5$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $1fELX.useId)();
    const ref = (0, $1fELX.useRef)(null);
    const size = (0, $1fELX.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $1fELX.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $1fELX.createElement($79ad1c355fe6a9a5$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $1fELX.cloneElement(children, {
        ref: ref
    }));
}


const $e57f7d914f957003$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $6d4d3a80aee48cda$export$fe4300aa8eebea86)($e57f7d914f957003$var$newChildrenMap);
    const id = (0, $1fELX.useId)();
    const context = (0, $1fELX.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $1fELX.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $1fELX.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $1fELX.createElement((0, $79ad1c355fe6a9a5$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $1fELX.createElement((0, $101046bede865000$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $e57f7d914f957003$var$newChildrenMap() {
    return new Map();
}





var $1fELX = parcelRequire("1fELX");
function $85f5fc6732f01f15$export$f3a192d0cbd30b96(callback) {
    return (0, $1fELX.useEffect)(()=>()=>callback(), []);
}



const $b19d52cfe90140b0$var$getChildKey = (child)=>child.key || "";
function $b19d52cfe90140b0$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $b19d52cfe90140b0$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $b19d52cfe90140b0$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $1fELX.Children).forEach(children, (child)=>{
        if ((0, $1fELX.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $b19d52cfe90140b0$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $37fdec4f220cd02e$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $1fELX.useContext)((0, $fd2e4331a0c11561$export$a3579ca508007a95)).forceRender || (0, $70f3c0d3fcca6f28$export$91db9bc4f8ac944a)()[0];
    const isMounted = (0, $a56596ec9efafa16$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $b19d52cfe90140b0$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $1fELX.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $1fELX.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $1fELX.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $1fELX.useRef)(true);
    (0, $e977dcf06c49c0b9$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $b19d52cfe90140b0$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $85f5fc6732f01f15$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return $1fELX.createElement($1fELX.Fragment, null, childrenToRender.map((child)=>$1fELX.createElement((0, $e57f7d914f957003$export$979daf65881a382a), {
            key: $b19d52cfe90140b0$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($b19d52cfe90140b0$var$getChildKey);
    const targetKeys = filteredChildren.map($b19d52cfe90140b0$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                allChildren.delete(key);
                exitingChildren.delete(key);
                // Remove this child from the present children
                const removeIndex = presentChildren.current.findIndex((presentChild)=>presentChild.key === key);
                presentChildren.current.splice(removeIndex, 1);
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    presentChildren.current = filteredChildren;
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = $1fELX.createElement((0, $e57f7d914f957003$export$979daf65881a382a), {
                key: $b19d52cfe90140b0$var$getChildKey(child),
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode
            }, child);
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : $1fELX.createElement((0, $e57f7d914f957003$export$979daf65881a382a), {
            key: $b19d52cfe90140b0$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $1fELX.createElement($1fELX.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $1fELX.cloneElement)(child)));
};




function $99175d26ddbc976d$export$90ceba2564a894f8(elements, scope, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        let root = document;
        if (scope) {
            (0, $37fdec4f220cd02e$export$f5708dca728d7177)(Boolean(scope.current), "Scope provided, but no element detected.");
            root = scope.current;
        }
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = root.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = root.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}





function $87eb2dbb266d19d1$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $3d23425702b2eefa$export$2cef06c20297c17d).update(onFrame, true);
    return ()=>(0, $3d23425702b2eefa$export$ec99c0ef4978dccb)(onFrame);
}



const $37f2fab7a367e124$export$20d68f04f30763a5 = (0, $94adbf009ae9c630$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $38d41246f165ffa5$export$c1e41718f71efe41 {
    constructor(animations){
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const cancelAll = this.animations.map((animation)=>{
            if ((0, $37f2fab7a367e124$export$20d68f04f30763a5)() && animation.attachTimeline) animation.attachTimeline(timeline);
            else {
                animation.pause();
                return (0, $87eb2dbb266d19d1$export$b4f1bbab0c442a76)((progress)=>{
                    animation.time = animation.duration * progress;
                }, timeline);
            }
        });
        return ()=>{
            cancelAll.forEach((cancelTimeline, i)=>{
                if (cancelTimeline) cancelTimeline();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    stop() {
        this.runAll("stop");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


function $1f5f9bc90dc78971$export$d276bfce3b1077ca(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}







function $5da79153148a8eab$export$f2911d8192f464a8(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    const node = (0, $d454ef50c615e5da$export$17eda790a720ec57)(element) ? new (0, $d9313b7cad8364a5$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $4dc3827667a6bf2c$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
    node.mount(element);
    (0, $12d1160d63b9dcbd$export$bc2a978a17abfdde).set(element, node);
}






/**
 * Create a progress => progress easing function from a generator.
 */ function $8bf8d6f6e9b27ee6$export$7f1511d09ee75a99(options, scale = 100) {
    const generator = (0, $d6229f16bf9e8a9a$export$b36281d89752ae66)({
        keyframes: [
            0,
            scale
        ],
        ...options
    });
    const duration = Math.min((0, $4da5054b446d292d$export$cbdd6b3d40ea54e2)(generator), (0, $4da5054b446d292d$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>generator.next(duration * progress).value / scale,
        duration: (0, $9a4f2f7d51aaab5f$export$f64c3bfbc58eec0f)(duration)
    };
}








/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ function $4dd125344154b64a$export$83ccd85155ba9791(current, next, prev, labels) {
    var _a;
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
}


const $d4d1f2e09e46eccf$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};



function $dc9fa0e01715dc43$export$41c5e731255a462(easing, i) {
    return (0, $fc00816700da3e5d$export$216948827bbdc797)(easing) ? easing[(0, $d4d1f2e09e46eccf$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}




function $b988c49378850a19$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $c84ab96179a9f581$export$fe2d9b4e03920b4c)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $b988c49378850a19$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $b988c49378850a19$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $35f0b2a35e81bfa8$export$2c9e8a9632a706b2)(startTime, endTime, offset[i]),
        easing: (0, $dc9fa0e01715dc43$export$41c5e731255a462)(easing, i)
    });
}


function $5b52ace599e62bae$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}


const $7853a70c39673f73$var$defaultSegmentEasing = "easeInOut";
function $7853a70c39673f73$export$1f0f44b51a4b2f73(sequence, { defaultTransition: defaultTransition = {}, ...sequenceTransition } = {}, scope) {
    const defaultDuration = defaultTransition.duration || 0.3;
    const animationDefinitions = new Map();
    const sequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < sequence.length; i++){
        const segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $4dd125344154b64a$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        let [subject, keyframes, transition = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, $4dd125344154b64a$export$83ccd85155ba9791)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numElements = 0)=>{
            const valueKeyframesAsList = $7853a70c39673f73$var$keyframesAsList(valueKeyframes);
            const { delay: delay = 0, times: times = (0, $6f6480343b49518e$export$24dbcec0b26e6d9d)(valueKeyframesAsList), type: type = "keyframes", ...remainingTransition } = valueTransition;
            let { ease: ease = defaultTransition.ease || "easeOut", duration: duration } = valueTransition;
            /**
             * Resolve stagger() if defined.
             */ const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numElements) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ const numKeyframes = valueKeyframesAsList.length;
            if (numKeyframes <= 2 && type === "spring") {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ let absoluteDelta = 100;
                if (numKeyframes === 2 && $7853a70c39673f73$var$isNumberKeyframesArray(valueKeyframesAsList)) {
                    const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                const springTransition = {
                    ...remainingTransition
                };
                if (duration !== undefined) springTransition.duration = (0, $9a4f2f7d51aaab5f$export$fc3e7e8557f8c8c7)(duration);
                const springEasing = (0, $8bf8d6f6e9b27ee6$export$7f1511d09ee75a99)(springTransition, absoluteDelta);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
            const startTime = currentTime + calculatedDelay;
            const targetTime = startTime + duration;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, $33b4af1f8159e014$export$dafee61230cf05c6)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, $b988c49378850a19$export$89dfa6760a9f76e7)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, $7e7233c78c258da3$export$605d60a2578142d3)(subject)) {
            const subjectSequence = $7853a70c39673f73$var$getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, $7853a70c39673f73$var$getValueSequence("default", subjectSequence));
        } else {
            /**
             * Find all the elements specified in the definition and parse value
             * keyframes from their timeline definitions.
             */ const elements = (0, $99175d26ddbc976d$export$90ceba2564a894f8)(subject, scope, elementCache);
            const numElements = elements.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(let elementIndex = 0; elementIndex < numElements; elementIndex++){
                keyframes;
                transition;
                const element = elements[elementIndex];
                const subjectSequence = $7853a70c39673f73$var$getSubjectSequence(element, sequences);
                for(const key in keyframes)resolveValueSequence(keyframes[key], $7853a70c39673f73$export$7c1391340308742e(transition, key), $7853a70c39673f73$var$getValueSequence(key, subjectSequence), elementIndex, numElements);
            }
            prevTime = currentTime;
            currentTime += maxDuration;
        }
    }
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $5b52ace599e62bae$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $e6d054f6bd4b2f86$export$504d7abb21fa8c9)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift($7853a70c39673f73$var$defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            definition.transition[key] = {
                ...defaultTransition,
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset,
                ...sequenceTransition
            };
        }
    });
    return animationDefinitions;
}
function $7853a70c39673f73$var$getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function $7853a70c39673f73$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function $7853a70c39673f73$var$keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function $7853a70c39673f73$export$7c1391340308742e(transition, key) {
    return transition[key] ? {
        ...transition,
        ...transition[key]
    } : {
        ...transition
    };
}
const $7853a70c39673f73$var$isNumber = (keyframe)=>typeof keyframe === "number";
const $7853a70c39673f73$var$isNumberKeyframesArray = (keyframes)=>keyframes.every($7853a70c39673f73$var$isNumber);



function $9b535b9e39873fad$var$animateElements(elementOrSelector, keyframes, options, scope) {
    const elements = (0, $99175d26ddbc976d$export$90ceba2564a894f8)(elementOrSelector, scope);
    const numElements = elements.length;
    (0, $37fdec4f220cd02e$export$f5708dca728d7177)(Boolean(numElements), "No valid element provided.");
    const animations = [];
    for(let i = 0; i < numElements; i++){
        const element = elements[i];
        /**
         * Check each element for an associated VisualElement. If none exists,
         * we need to create one.
         */ if (!(0, $12d1160d63b9dcbd$export$bc2a978a17abfdde).has(element)) /**
             * TODO: We only need render-specific parts of the VisualElement.
             * With some additional work the size of the animate() function
             * could be reduced significantly.
             */ (0, $5da79153148a8eab$export$f2911d8192f464a8)(element);
        const visualElement = (0, $12d1160d63b9dcbd$export$bc2a978a17abfdde).get(element);
        const transition = {
            ...options
        };
        /**
         * Resolve stagger function if provided.
         */ if (typeof transition.delay === "function") transition.delay = transition.delay(i, numElements);
        animations.push(...(0, $b053fab66331cc3f$export$68cacfeee78d98d2)(visualElement, {
            ...keyframes,
            transition: transition
        }, {}));
    }
    return new (0, $38d41246f165ffa5$export$c1e41718f71efe41)(animations);
}
const $9b535b9e39873fad$var$isSequence = (value)=>Array.isArray(value) && Array.isArray(value[0]);
function $9b535b9e39873fad$var$animateSequence(sequence, options, scope) {
    const animations = [];
    const animationDefinitions = (0, $7853a70c39673f73$export$1f0f44b51a4b2f73)(sequence, options, scope);
    animationDefinitions.forEach(({ keyframes: keyframes, transition: transition }, subject)=>{
        let animation;
        if ((0, $7e7233c78c258da3$export$605d60a2578142d3)(subject)) animation = (0, $9334f9bb9dabbd7e$export$335a17c977067b99)(subject, keyframes.default, transition.default);
        else animation = $9b535b9e39873fad$var$animateElements(subject, keyframes, transition);
        animations.push(animation);
    });
    return new (0, $38d41246f165ffa5$export$c1e41718f71efe41)(animations);
}
const $9b535b9e39873fad$export$c17e592002be9b90 = (scope)=>{
    /**
     * Implementation
     */ function scopedAnimate(valueOrElementOrSequence, keyframes, options) {
        let animation;
        if ($9b535b9e39873fad$var$isSequence(valueOrElementOrSequence)) animation = $9b535b9e39873fad$var$animateSequence(valueOrElementOrSequence, keyframes, scope);
        else if ((0, $1f5f9bc90dc78971$export$d276bfce3b1077ca)(keyframes)) animation = $9b535b9e39873fad$var$animateElements(valueOrElementOrSequence, keyframes, options, scope);
        else animation = (0, $9334f9bb9dabbd7e$export$335a17c977067b99)(valueOrElementOrSequence, keyframes, options);
        if (scope) scope.animations.push(animation);
        return animation;
    }
    return scopedAnimate;
};
const $9b535b9e39873fad$export$e3607ec2d7a891c4 = $9b535b9e39873fad$export$c17e592002be9b90();


function $bdd83a68c8e5ccfc$export$9f387b98a73b1511() {
    const scope = (0, $6d4d3a80aee48cda$export$fe4300aa8eebea86)(()=>({
            current: null,
            animations: []
        }));
    const animate = (0, $6d4d3a80aee48cda$export$fe4300aa8eebea86)(()=>(0, $9b535b9e39873fad$export$c17e592002be9b90)(scope));
    (0, $85f5fc6732f01f15$export$f3a192d0cbd30b96)(()=>{
        scope.animations.forEach((animation)=>animation.stop());
    });
    return [
        scope,
        animate
    ];
}



var $1fELX = parcelRequire("1fELX");
var $831f2c713fb8fdbd$exports = {};


$831f2c713fb8fdbd$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("bQ9c2");




const $3b721212c7786b45$export$94026ee33dbabc26 = ({ image: image, lastSelected: lastSelected })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
        className: "fixed top-0 w-full h-full flex flex-col items-center gap-xxxxl z-20",
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b19d52cfe90140b0$export$3ae376d12526dd6f), {
                children: !!image && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($3b721212c7786b45$export$3e431a229df88919, {
                    image: image,
                    lastSelected: lastSelected
                }, image.id)
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($831f2c713fb8fdbd$exports))),
                className: "fixed top-0 h-[90%] max-w-none"
            })
        ]
    });
};
const $3b721212c7786b45$export$3e431a229df88919 = ({ image: image, lastSelected: lastSelected })=>{
    const willChange = (0, $34ef2847a1b462ae$export$384afe146fc0c056)();
    const [scope, animate] = (0, $bdd83a68c8e5ccfc$export$9f387b98a73b1511)();
    const exitBorderColor = lastSelected ? (0, $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)[lastSelected].color : "blueviolet";
    (0, $1fELX.useEffect)(()=>{
        (async ()=>{
            await animate(scope.current, {
                opacity: 1,
                y: "20%",
                scale: 0.8
            }, {
                opacity: {
                    duration: 0.8,
                    ease: "easeOut"
                },
                y: {
                    duration: 2,
                    ease: "easeOut"
                },
                scale: {
                    duration: 2,
                    ease: "easeIn"
                }
            });
            if (scope.current) await animate(scope.current, {
                scale: 1
            }, {
                duration: (0, $f53e2e66ab870a62$export$176c9ac0984acede).imageTimeLimitInSeconds - 2,
                ease: "easeOut"
            });
        })();
    }, [
        scope,
        animate
    ]);
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b769f11e629ddf15$export$e25e478948902b8b).div, {
        ref: scope,
        style: {
            willChange: willChange
        },
        className: "absolute z-10 w-auto h-[55%]",
        initial: {
            opacity: 0,
            y: "-75%",
            scale: 0.5
        },
        exit: {
            opacity: 0,
            scale: 1.5,
            y: "150%",
            transition: {
                duration: 0.5,
                ease: "easeOut"
            }
        },
        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b769f11e629ddf15$export$e25e478948902b8b).div, {
            className: "border-large border-primary h-full rounded-s overflow-hidden",
            exit: {
                borderColor: exitBorderColor,
                transition: {
                    duration: 0.1
                }
            },
            children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $0861364603d97aac$export$48cccd7fbde04223), {
                image: image,
                delayBoundingBox: true
            })
        })
    });
};






var $1fELX = parcelRequire("1fELX");
var $29f9650599ae269c$exports = {};


$29f9650599ae269c$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("aS8OV");





var $2eec3e2560079eb1$exports = {};


$2eec3e2560079eb1$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("9Uo39");


const $176c0debacf7111a$export$4f932205b2d915ac = ({ onSelect: onSelect, totalScore: totalScore, startTime: startTime, isActive: isActive, correctAnswer: correctAnswer })=>{
    const [showCorrect, setShowCorrect] = (0, $1fELX.useState)(false);
    (0, $1fELX.useEffect)(()=>{
        const handleKeyPress = (event)=>{
            const keySelected = (0, $cc00f4b137e2dc0c$export$da5a638e0e69c83)(event.key);
            if (keySelected) onSelect(keySelected);
            else if (event.key === "x" || event.key === "X") setShowCorrect(true);
        };
        window.addEventListener("keypress", handleKeyPress);
        return ()=>window.removeEventListener("keypress", handleKeyPress);
    }, [
        onSelect
    ]);
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
        className: "fixed z-50 bottom-[-.5vh] h-[15.5vh] aspect-[10/1] left-1/2 -translate-x-1/2 bg-top bg-cover bg-no-repeat",
        style: {
            backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($29f9650599ae269c$exports)))})`
        },
        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
            className: "relative h-full w-[calc(100%-8rem)] max-w-[100vw] left-1/2 -translate-x-1/2",
            children: [
                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                    className: "absolute z-40 top-0 py-8 left-1/2 -translate-x-1/2 flex gap-12",
                    children: (0, $cc00f4b137e2dc0c$export$897da0bbced5e834).map((grading)=>/*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($176c0debacf7111a$export$353f5b6fc5456de1, {
                            label: (0, $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)[grading].label,
                            className: (0, $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)[grading].className,
                            onSelect: ()=>onSelect(grading),
                            highlighted: showCorrect && grading === correctAnswer
                        }, grading))
                }),
                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($176c0debacf7111a$var$GlobalTimer, {
                    startTime: startTime,
                    isActive: isActive
                }),
                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($176c0debacf7111a$var$Score, {
                    totalScore: totalScore
                })
            ]
        })
    });
};
const $176c0debacf7111a$export$353f5b6fc5456de1 = ({ label: label, className: className, onSelect: onSelect, highlighted: highlighted })=>{
    const [play] = (0, $d4d68b59540df7f6$export$a34349420ba3cec8)((0, (/*@__PURE__*/$parcel$interopDefault($2eec3e2560079eb1$exports))), {
        interrupt: true
    });
    const highlightedClass = highlighted ? "outline-primary outline-1 outline-double" : "";
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("button", {
        className: `rounded-lg text-black font-bold p-xs ${className} ${highlightedClass}`,
        onClick: (e)=>{
            onSelect();
            play();
            e.currentTarget.blur();
        },
        tabIndex: -1,
        children: label
    });
};
const $176c0debacf7111a$var$GlobalTimer = ({ startTime: startTime, isActive: isActive })=>{
    const [time, setTime] = (0, $1fELX.useState)(0);
    (0, $1fELX.useEffect)(()=>{
        const interval = setInterval(()=>{
            if (isActive) setTime(new Date().getTime() - startTime.getTime());
        }, 100);
        return ()=>clearInterval(interval);
    }, [
        startTime,
        isActive
    ]);
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
        className: "absolute bottom-[1%] z-50 left-0 px-8 py-[2vh] flex items-center",
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                name: "clock",
                className: "h-14 m-4 text-neutral-300"
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                className: "text-neutral-50 text-display2 font-medium",
                children: (0, $a15d49ed6e92009e$export$5daf09ba04077ce8)(time)
            })
        ]
    });
};
const $176c0debacf7111a$var$Score = ({ totalScore: totalScore })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
        className: "absolute bottom-[1%] z-50 right-0 px-8 py-[2vh] flex items-center w-64",
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                name: "star",
                className: "h-14 w-14 m-4 text-primary"
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                className: "text-neutral-50 text-display2 font-medium",
                children: totalScore
            })
        ]
    });
};





var $1fELX = parcelRequire("1fELX");



const $aed330b7874a8ed8$export$3e8d0cb7ceb1642a = ({ selectionHistory: selectionHistory, currentIndex: currentIndex, startTime: startTime })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
        className: "fixed w-[300px] pt-xxxl pl-xxl flex flex-col",
        children: [
            selectionHistory.map((selection, i)=>/*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($aed330b7874a8ed8$export$3c90523bf1a73c39, {
                    index: i,
                    selection: selection,
                    startTime: startTime
                }, i)),
            new Array((0, $f53e2e66ab870a62$export$176c9ac0984acede).numberOfImages - currentIndex).fill(null).map((_, i)=>/*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($aed330b7874a8ed8$export$3c90523bf1a73c39, {
                    index: i + currentIndex,
                    selection: null,
                    isCurrent: i === 0,
                    startTime: startTime
                }, i + currentIndex))
        ]
    });
};
const $aed330b7874a8ed8$export$3c90523bf1a73c39 = ({ index: index, selection: selection, isCurrent: isCurrent, startTime: startTime })=>{
    const [time, setTime] = (0, $1fELX.useState)(selection?.usedTime ?? 0);
    (0, $1fELX.useEffect)(()=>{
        if (isCurrent) {
            const interval = setInterval(()=>{
                const elapsed = new Date().getTime() - startTime.getTime();
                setTime(elapsed);
            }, 100);
            return ()=>clearInterval(interval);
        }
    }, [
        startTime,
        isCurrent
    ]);
    const borderClassName = isCurrent ? "outline outline-primary" : "";
    const textClassName = selection ? "text-neutral-300" : isCurrent ? "text-neutral-50" : "text-neutral-400";
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
        className: `flex items-start font-light py-1 px-6 rounded-full ${borderClassName} ${textClassName}`,
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                className: "w-[38%]",
                children: $aed330b7874a8ed8$var$getImageLabel(index)
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                className: "w-[45%]",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                        name: "clock",
                        className: "h-9"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
                        children: (0, $a15d49ed6e92009e$export$5daf09ba04077ce8)(time)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                className: "w-[17%] font-bold",
                style: $aed330b7874a8ed8$var$getGradingStyle(selection),
                children: $aed330b7874a8ed8$var$getGrading(selection)
            })
        ]
    });
};
function $aed330b7874a8ed8$var$getImageLabel(index) {
    const numberAsText = (index + 1).toString().padStart(2, "0");
    return `DICOM ${numberAsText}`;
}
function $aed330b7874a8ed8$var$getGrading(selection) {
    return selection?.grading ? (0, $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)[selection.grading].label : "TR -";
}
function $aed330b7874a8ed8$var$getGradingStyle(selection) {
    if (selection?.grading) return {
        color: (0, $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)[selection.grading].color
    };
    return {};
}




var $1fELX = parcelRequire("1fELX");

var $f7644409ae5e9a13$exports = {};


$f7644409ae5e9a13$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("6b6cc");



const $0a33ef90d6a0bed0$export$c57e9b2d8b9e4de = (props)=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b769f11e629ddf15$export$e25e478948902b8b).div, {
        className: "fixed top-[40%] left-[80%] -translate-x-1/2 -translate-y-1/2 z-50 flex items-center justify-center w-[12vh] h-[12vh]",
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1,
            transition: {
                duration: 1,
                ease: "easeOut"
            }
        },
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($0a33ef90d6a0bed0$var$TimerCircle, {
                ...props
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                className: "absolute h-[37.5%]",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($f7644409ae5e9a13$exports)))
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($0a33ef90d6a0bed0$var$TimerText, {
                ...props
            })
        ]
    });
};
const $0a33ef90d6a0bed0$var$TimerText = ({ startTime: startTime, onLimitReached: onLimitReached })=>{
    const [remainingTimeS, setRemainingTimeS] = (0, $1fELX.useState)((0, $f53e2e66ab870a62$export$176c9ac0984acede).imageTimeLimitInSeconds);
    (0, $1fELX.useEffect)(()=>{
        const interval = setInterval(()=>{
            const time = (0, $f53e2e66ab870a62$export$176c9ac0984acede).imageTimeLimitInSeconds - (new Date().getTime() - startTime.getTime()) / 1000;
            if (time <= 0) onLimitReached();
            else setRemainingTimeS(time);
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        startTime,
        onLimitReached
    ]);
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("span", {
        className: "block absolute bottom-[22%] translate-y-1/2 text-black font-semibold",
        children: [
            remainingTimeS.toFixed(0),
            "\xa0s"
        ]
    });
};
const $0a33ef90d6a0bed0$var$TimerCircle = ({ startTime: startTime })=>{
    const [elapsedTimeMs, setElapsedTimeMs] = (0, $1fELX.useState)(0);
    const percentage = elapsedTimeMs / ((0, $f53e2e66ab870a62$export$176c9ac0984acede).imageTimeLimitInSeconds * 10);
    const progressStyle = {
        background: `conic-gradient(#00FFBA8C 0% 0%, #00FFBA66 ${percentage - 0.2}% ${percentage}%, #00FFBA ${percentage + 0.1}% 100%)`
    };
    (0, $1fELX.useEffect)(()=>{
        const interval = setInterval(()=>{
            setElapsedTimeMs(new Date().getTime() - startTime.getTime());
        }, 50);
        return ()=>clearInterval(interval);
    }, [
        startTime
    ]);
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
        className: "w-full h-full rounded-full",
        style: progressStyle
    });
};




parcelRequire("1fELX");
const $a3e7ef04d345b07d$export$13921ac0cc260818 = ({ lastSelected: lastSelected, currentIndex: currentIndex })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
        className: "h-full flex gap-8",
        children: (0, $cc00f4b137e2dc0c$export$897da0bbced5e834).map((grading)=>/*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                className: "overflow-visible aspect-[64/847] relative",
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($a3e7ef04d345b07d$var$TrackLine, {
                    grading: grading,
                    selected: lastSelected === grading,
                    currentIndex: currentIndex
                })
            }, grading))
    });
};
const $a3e7ef04d345b07d$var$TrackLine = ({ grading: grading, selected: selected, currentIndex: currentIndex })=>{
    switch(grading){
        case (0, $cc00f4b137e2dc0c$export$80d18f138b02e097).TR1:
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($a3e7ef04d345b07d$var$TrackLineSVG, {
                id: "line-1",
                viewBox: "0 0 84 847",
                path: "M84.0001 0H61.2699V345.514C61.2699 514.543 40.6953 682.943 6.10352e-05 847H62.5694L84.0001 600V0Z",
                animationDelay: 4,
                selectedColor: "#c9d4da",
                selected: selected,
                currentIndex: currentIndex
            });
        case (0, $cc00f4b137e2dc0c$export$80d18f138b02e097).TR2:
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($a3e7ef04d345b07d$var$TrackLineSVG, {
                id: "line-2",
                viewBox: "0 0 64 847",
                path: "M64 0H40.5636V437.977C40.5636 575.322 26.9762 712.33 0 847H62.5394L64 394.55V0Z",
                animationDelay: 1,
                selectedColor: "#ffd990",
                selected: selected,
                currentIndex: currentIndex
            });
        case (0, $cc00f4b137e2dc0c$export$80d18f138b02e097).TR3:
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($a3e7ef04d345b07d$var$TrackLineSVG, {
                id: "line-3",
                viewBox: "0 0 64 847",
                path: "M20.296 0H43.6373L44.1364 590L64 847H0L20.296 590V0Z",
                animationDelay: 3,
                className: "left-1/2 -translate-x-1/2",
                selectedColor: "#ffa048",
                selected: selected,
                currentIndex: currentIndex
            });
        case (0, $cc00f4b137e2dc0c$export$80d18f138b02e097).TR4:
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($a3e7ef04d345b07d$var$TrackLineSVG, {
                id: "line-4",
                viewBox: "0 0 64 847",
                path: "M0 0H23.4364V437.977C23.4364 575.322 37.0238 712.33 64 847H1.46064L0 394.55V0Z",
                animationDelay: 0,
                className: "right-0",
                selectedColor: "#f85e1d",
                selected: selected,
                currentIndex: currentIndex
            });
        case (0, $cc00f4b137e2dc0c$export$80d18f138b02e097).TR5:
            return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($a3e7ef04d345b07d$var$TrackLineSVG, {
                id: "line-5",
                viewBox: "0 0 84 847",
                path: "M-6.10352e-05 0H22.7301V345.514C22.7301 514.543 43.3047 682.943 83.9999 847H21.4306L-6.10352e-05 600V0Z",
                animationDelay: 2,
                className: "right-0",
                selectedColor: "#e62c4c",
                selected: selected,
                currentIndex: currentIndex
            });
    }
};
const $a3e7ef04d345b07d$var$TrackLineSVG = ({ path: path, viewBox: viewBox, id: id, animationDelay: animationDelay, className: className = "", selected: selected, selectedColor: selectedColor, currentIndex: currentIndex })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $01494118b1e6559d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("svg", {
                viewBox: viewBox,
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: `h-full absolute ${className}`,
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($a3e7ef04d345b07d$var$TrackLineGradient, {
                            id: id,
                            begin: `${animationDelay}s`
                        })
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: path,
                        fill: `url(#${id})`
                    })
                ]
            }),
            selected && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("svg", {
                viewBox: viewBox,
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: `h-full absolute ${className}`,
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($a3e7ef04d345b07d$var$SelectedGradient, {
                            id: id,
                            selectedColor: selectedColor
                        })
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                        d: path,
                        fill: `url(#${id + "-selected"})`
                    })
                ]
            }, currentIndex)
        ]
    });
};
const $a3e7ef04d345b07d$var$TrackLineGradient = ({ id: id, begin: begin })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
        id: id,
        x1: "0%",
        y1: "0%",
        x2: "0%",
        y2: "100%",
        spreadMethod: "repeat",
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                offset: "0%",
                stopColor: "#3A4E5A"
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                offset: "30%",
                stopColor: "#3A4E5A"
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                offset: "45%",
                stopColor: "#61717A",
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("animate", {
                    attributeName: "stop-color",
                    values: "#3A4E5A;#61717A;",
                    dur: "2s",
                    repeatCount: "1"
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                offset: "49%",
                stopColor: "#75838B",
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("animate", {
                    attributeName: "stop-color",
                    values: "#3A4E5A;#75838B;",
                    dur: "2s",
                    repeatCount: "1"
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                offset: "51%",
                stopColor: "#75838B",
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("animate", {
                    attributeName: "stop-color",
                    values: "#3A4E5A;#75838B;",
                    dur: "2s",
                    repeatCount: "1"
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                offset: "55%",
                stopColor: "#61717A",
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("animate", {
                    attributeName: "stop-color",
                    values: "#3A4E5A;#61717A;",
                    dur: "2s",
                    repeatCount: "1"
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                offset: "70%",
                stopColor: "#3A4E5A"
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                offset: "100%",
                stopColor: "#3A4E5A"
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("animate", {
                attributeName: "y1",
                values: "0;1;",
                dur: "5s",
                begin: begin,
                repeatCount: "indefinite"
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("animate", {
                attributeName: "y2",
                values: "1;2;",
                dur: "5s",
                begin: begin,
                repeatCount: "indefinite"
            })
        ]
    });
};
const $a3e7ef04d345b07d$var$SelectedGradient = ({ id: id, selectedColor: selectedColor })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
        id: id + "-selected",
        x1: "0%",
        y1: "0%",
        x2: "0%",
        y2: "100%",
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                offset: "0%",
                stopColor: selectedColor,
                stopOpacity: 0
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                offset: "50%",
                stopColor: selectedColor,
                stopOpacity: 0,
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("animate", {
                    attributeName: "stop-opacity",
                    values: ".5;1;.5;0;",
                    dur: ".9s",
                    repeatCount: "1"
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                offset: "100%",
                stopColor: selectedColor,
                stopOpacity: 0,
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("animate", {
                    attributeName: "stop-opacity",
                    values: ".5;1;.5;0;",
                    dur: ".9s",
                    repeatCount: "1"
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("animate", {
                attributeName: "y1",
                values: "1;0;",
                dur: ".3s",
                repeatCount: "1"
            })
        ]
    });
};




var $1fELX = parcelRequire("1fELX");
const $46adf260b14651d6$var$StarsBackgroundLayers = ({ prewarm: prewarm })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
        id: "layers",
        children: [
            0,
            1,
            2,
            3,
            4
        ].map((num)=>/*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($46adf260b14651d6$var$Layer, {
                limit: 30,
                layerIndex: num,
                prewarm: prewarm
            }, num))
    });
};
const $46adf260b14651d6$export$5f95e975d3adc575 = /*#__PURE__*/ (0, $1fELX.memo)($46adf260b14651d6$var$StarsBackgroundLayers);
const $46adf260b14651d6$var$Star = ({ left: left, top: top, scale: scale, opacity: opacity })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("span", {
        className: "star",
        style: {
            left: left,
            top: top,
            transform: `scale(${scale})`,
            opacity: opacity
        },
        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("svg", {
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                d: "M10.744,5.372C7.777,5.372,5.372,2.967,5.372,0c0,2.967-2.405,5.372-5.372,5.372c2.967,0,5.372,2.405,5.372,5.372 C5.372,7.777,7.777,5.372,10.744,5.372z"
            })
        })
    });
};
const $46adf260b14651d6$var$Layer = ({ limit: limit, layerIndex: layerIndex, prewarm: prewarm })=>{
    const stars = Array.from({
        length: limit
    }, (_)=>({
            left: $46adf260b14651d6$var$randomInt(1, 100) + "%",
            top: $46adf260b14651d6$var$randomInt(1, 100) + "%",
            scale: "scale(" + $46adf260b14651d6$var$randomNum(0, 1) + ")",
            opacity: $46adf260b14651d6$var$randomNum(0.6, 1)
        }));
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
        className: `layer`,
        style: {
            animationDelay: `${layerIndex * (prewarm ? -1 : 1)}s`
        },
        children: stars.map((star, index)=>/*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($46adf260b14651d6$var$Star, {
                ...star
            }, index))
    });
};
function $46adf260b14651d6$var$randomInt(min, max) {
    return Math.floor(Math.random() * max + min);
}
function $46adf260b14651d6$var$randomNum(min, max) {
    return Math.max(Math.random() * max, min).toFixed(1);
}



function $9fa5f9e20cc9995d$export$947363cddeff0a3d(elapsedTimeMs, grading, image) {
    const isCorrect = !!grading && grading === image.groundTruth?.grading;
    if (isCorrect) return (0, $f53e2e66ab870a62$export$176c9ac0984acede).maxScorePerImage - Math.floor(elapsedTimeMs / 100);
    else return 0;
}




parcelRequire("1fELX");

var $1fELX = parcelRequire("1fELX");
const $9f7790cd505e6a79$export$4a278486528d5cfb = "generated";
const $9f7790cd505e6a79$export$9ffd73c9a0e32c34 = "pointerdown";
const $9f7790cd505e6a79$export$9fb0268ce1bdbca0 = "pointerup";
const $9f7790cd505e6a79$export$f4b184a85a586f8a = "pointerleave";
const $9f7790cd505e6a79$export$55cc1d6a692feb2b = "pointerout";
const $9f7790cd505e6a79$export$1ffe551d7d33cd33 = "pointermove";
const $9f7790cd505e6a79$export$d5353b6c79bbcc70 = "touchstart";
const $9f7790cd505e6a79$export$11164630b85c192d = "touchend";
const $9f7790cd505e6a79$export$d28a82874c0e6212 = "touchmove";
const $9f7790cd505e6a79$export$65db1c69591947a7 = "touchcancel";
const $9f7790cd505e6a79$export$8b3d73c91cd7cc65 = "resize";
const $9f7790cd505e6a79$export$73536144dc68dd0f = "visibilitychange";
const $9f7790cd505e6a79$export$adea4917e02d93dc = "tsParticles - Error";





class $4f7724755777c76d$export$ece015703618ce3d {
    constructor(xOrCoords, y, z){
        this._updateFromAngle = (angle, length)=>{
            this.x = Math.cos(angle) * length;
            this.y = Math.sin(angle) * length;
        };
        if (!(0, $ab7d474d755ab51b$export$7e4aa119212bc614)(xOrCoords) && xOrCoords) {
            this.x = xOrCoords.x;
            this.y = xOrCoords.y;
            const coords3d = xOrCoords;
            this.z = coords3d.z ? coords3d.z : 0;
        } else if (xOrCoords !== undefined && y !== undefined) {
            this.x = xOrCoords;
            this.y = y;
            this.z = z ?? 0;
        } else throw new Error(`${(0, $9f7790cd505e6a79$export$adea4917e02d93dc)} Vector3d not initialized correctly`);
    }
    static get origin() {
        return $4f7724755777c76d$export$ece015703618ce3d.create(0, 0, 0);
    }
    get angle() {
        return Math.atan2(this.y, this.x);
    }
    set angle(angle) {
        this._updateFromAngle(angle, this.length);
    }
    get length() {
        return Math.sqrt(this.getLengthSq());
    }
    set length(length) {
        this._updateFromAngle(this.angle, length);
    }
    static clone(source) {
        return $4f7724755777c76d$export$ece015703618ce3d.create(source.x, source.y, source.z);
    }
    static create(x, y, z) {
        return new $4f7724755777c76d$export$ece015703618ce3d(x, y, z);
    }
    add(v) {
        return $4f7724755777c76d$export$ece015703618ce3d.create(this.x + v.x, this.y + v.y, this.z + v.z);
    }
    addTo(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
    }
    copy() {
        return $4f7724755777c76d$export$ece015703618ce3d.clone(this);
    }
    distanceTo(v) {
        return this.sub(v).length;
    }
    distanceToSq(v) {
        return this.sub(v).getLengthSq();
    }
    div(n) {
        return $4f7724755777c76d$export$ece015703618ce3d.create(this.x / n, this.y / n, this.z / n);
    }
    divTo(n) {
        this.x /= n;
        this.y /= n;
        this.z /= n;
    }
    getLengthSq() {
        return this.x ** 2 + this.y ** 2;
    }
    mult(n) {
        return $4f7724755777c76d$export$ece015703618ce3d.create(this.x * n, this.y * n, this.z * n);
    }
    multTo(n) {
        this.x *= n;
        this.y *= n;
        this.z *= n;
    }
    normalize() {
        const length = this.length;
        if (length != 0) this.multTo(1.0 / length);
    }
    rotate(angle) {
        return $4f7724755777c76d$export$ece015703618ce3d.create(this.x * Math.cos(angle) - this.y * Math.sin(angle), this.x * Math.sin(angle) + this.y * Math.cos(angle), 0);
    }
    setTo(c) {
        this.x = c.x;
        this.y = c.y;
        const v3d = c;
        this.z = v3d.z ? v3d.z : 0;
    }
    sub(v) {
        return $4f7724755777c76d$export$ece015703618ce3d.create(this.x - v.x, this.y - v.y, this.z - v.z);
    }
    subFrom(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
    }
}


class $f2e8cb9a78120c28$export$9b781de7bf37bf48 extends (0, $4f7724755777c76d$export$ece015703618ce3d) {
    constructor(xOrCoords, y){
        super(xOrCoords, y, 0);
    }
    static get origin() {
        return $f2e8cb9a78120c28$export$9b781de7bf37bf48.create(0, 0);
    }
    static clone(source) {
        return $f2e8cb9a78120c28$export$9b781de7bf37bf48.create(source.x, source.y);
    }
    static create(x, y) {
        return new $f2e8cb9a78120c28$export$9b781de7bf37bf48(x, y);
    }
}


let $a17cb6ec9e2ec6c9$var$_random = Math.random;
const $a17cb6ec9e2ec6c9$var$easings = new Map();
function $a17cb6ec9e2ec6c9$export$e2251c95822ce867(name, easing) {
    if ($a17cb6ec9e2ec6c9$var$easings.get(name)) return;
    $a17cb6ec9e2ec6c9$var$easings.set(name, easing);
}
function $a17cb6ec9e2ec6c9$export$2bbf531f74195405(name) {
    return $a17cb6ec9e2ec6c9$var$easings.get(name) || ((value)=>value);
}
function $a17cb6ec9e2ec6c9$export$3ba5cb2c014ef7d5(rnd = Math.random) {
    $a17cb6ec9e2ec6c9$var$_random = rnd;
}
function $a17cb6ec9e2ec6c9$export$1a76347094524b3b() {
    return $a17cb6ec9e2ec6c9$export$7d15b64cf5a3a4c4($a17cb6ec9e2ec6c9$var$_random(), 0, 1 - 1e-16);
}
function $a17cb6ec9e2ec6c9$export$7d15b64cf5a3a4c4(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function $a17cb6ec9e2ec6c9$export$2c9e8a9632a706b2(comp1, comp2, weight1, weight2) {
    return Math.floor((comp1 * weight1 + comp2 * weight2) / (weight1 + weight2));
}
function $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804(r) {
    const max = $a17cb6ec9e2ec6c9$export$27d2c76f835d583d(r);
    let min = $a17cb6ec9e2ec6c9$export$71c94d28c0fa4bfe(r);
    if (max === min) min = 0;
    return $a17cb6ec9e2ec6c9$export$1a76347094524b3b() * (max - min) + min;
}
function $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e(value) {
    return (0, $ab7d474d755ab51b$export$7e4aa119212bc614)(value) ? value : $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804(value);
}
function $a17cb6ec9e2ec6c9$export$71c94d28c0fa4bfe(value) {
    return (0, $ab7d474d755ab51b$export$7e4aa119212bc614)(value) ? value : value.min;
}
function $a17cb6ec9e2ec6c9$export$27d2c76f835d583d(value) {
    return (0, $ab7d474d755ab51b$export$7e4aa119212bc614)(value) ? value : value.max;
}
function $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7(source, value) {
    if (source === value || value === undefined && (0, $ab7d474d755ab51b$export$7e4aa119212bc614)(source)) return source;
    const min = $a17cb6ec9e2ec6c9$export$71c94d28c0fa4bfe(source), max = $a17cb6ec9e2ec6c9$export$27d2c76f835d583d(source);
    return value !== undefined ? {
        min: Math.min(min, value),
        max: Math.max(max, value)
    } : $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7(min, max);
}
function $a17cb6ec9e2ec6c9$export$bf7199a9ebcb84a9(options) {
    const random = options.random, { enable: enable, minimumValue: minimumValue } = (0, $ab7d474d755ab51b$export$f9ce7b637dfbe238)(random) ? {
        enable: random,
        minimumValue: 0
    } : random;
    return enable ? $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e($a17cb6ec9e2ec6c9$export$6dcd5a07b989db7(options.value, minimumValue)) : $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e(options.value);
}
function $a17cb6ec9e2ec6c9$export$c76b58cfe053f228(pointA, pointB) {
    const dx = pointA.x - pointB.x, dy = pointA.y - pointB.y;
    return {
        dx: dx,
        dy: dy,
        distance: Math.sqrt(dx ** 2 + dy ** 2)
    };
}
function $a17cb6ec9e2ec6c9$export$79376507b09a66f(pointA, pointB) {
    return $a17cb6ec9e2ec6c9$export$c76b58cfe053f228(pointA, pointB).distance;
}
function $a17cb6ec9e2ec6c9$export$2045f76df51d18c4(direction, position, center) {
    if ((0, $ab7d474d755ab51b$export$7e4aa119212bc614)(direction)) return direction * Math.PI / 180;
    switch(direction){
        case "top":
            return -Math.PI / 2;
        case "top-right":
            return -Math.PI / 4;
        case "right":
            return 0;
        case "bottom-right":
            return Math.PI / 4;
        case "bottom":
            return Math.PI / 2;
        case "bottom-left":
            return 3 * Math.PI / 4;
        case "left":
            return Math.PI;
        case "top-left":
            return -3 * Math.PI / 4;
        case "inside":
            return Math.atan2(center.y - position.y, center.x - position.x);
        case "outside":
            return Math.atan2(position.y - center.y, position.x - center.x);
        default:
            return $a17cb6ec9e2ec6c9$export$1a76347094524b3b() * Math.PI * 2;
    }
}
function $a17cb6ec9e2ec6c9$export$cce6f12debc4024a(direction) {
    const baseVelocity = (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).origin;
    baseVelocity.length = 1;
    baseVelocity.angle = direction;
    return baseVelocity;
}
function $a17cb6ec9e2ec6c9$export$ee2fb97c67882d88(v1, v2, m1, m2) {
    return (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).create(v1.x * (m1 - m2) / (m1 + m2) + v2.x * 2 * m2 / (m1 + m2), v1.y);
}
function $a17cb6ec9e2ec6c9$export$3cb8a699840fed18(data) {
    return data.position && data.position.x !== undefined && data.position.y !== undefined ? {
        x: data.position.x * data.size.width / 100,
        y: data.position.y * data.size.height / 100
    } : undefined;
}
function $a17cb6ec9e2ec6c9$export$b19bedb83d642783(data) {
    return {
        x: (data.position?.x ?? $a17cb6ec9e2ec6c9$export$1a76347094524b3b() * 100) * data.size.width / 100,
        y: (data.position?.y ?? $a17cb6ec9e2ec6c9$export$1a76347094524b3b() * 100) * data.size.height / 100
    };
}
function $a17cb6ec9e2ec6c9$export$b6e437e0d75e3d2c(data) {
    const position = {
        x: data.position?.x !== undefined ? $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e(data.position.x) : undefined,
        y: data.position?.y !== undefined ? $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e(data.position.y) : undefined
    };
    return $a17cb6ec9e2ec6c9$export$b19bedb83d642783({
        size: data.size,
        position: position
    });
}
function $a17cb6ec9e2ec6c9$export$a3c87c98a736c457(data) {
    return {
        x: data.position?.x ?? $a17cb6ec9e2ec6c9$export$1a76347094524b3b() * data.size.width,
        y: data.position?.y ?? $a17cb6ec9e2ec6c9$export$1a76347094524b3b() * data.size.height
    };
}
function $a17cb6ec9e2ec6c9$export$30970e96ab2e23ee(data) {
    const position = {
        x: data.position?.x !== undefined ? $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e(data.position.x) : undefined,
        y: data.position?.y !== undefined ? $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e(data.position.y) : undefined
    };
    return $a17cb6ec9e2ec6c9$export$a3c87c98a736c457({
        size: data.size,
        position: position
    });
}
function $a17cb6ec9e2ec6c9$export$988633967de92230(input) {
    return input ? input.endsWith("%") ? parseFloat(input) / 100 : parseFloat(input) : 1;
}



const $ab7d474d755ab51b$var$_logger = {
    debug: console.debug,
    error: console.error,
    info: console.info,
    log: console.log,
    verbose: console.log,
    warning: console.warn
};
function $ab7d474d755ab51b$export$3abbd92f765bee58(logger) {
    $ab7d474d755ab51b$var$_logger.debug = logger.debug || $ab7d474d755ab51b$var$_logger.debug;
    $ab7d474d755ab51b$var$_logger.error = logger.error || $ab7d474d755ab51b$var$_logger.error;
    $ab7d474d755ab51b$var$_logger.info = logger.info || $ab7d474d755ab51b$var$_logger.info;
    $ab7d474d755ab51b$var$_logger.log = logger.log || $ab7d474d755ab51b$var$_logger.log;
    $ab7d474d755ab51b$var$_logger.verbose = logger.verbose || $ab7d474d755ab51b$var$_logger.verbose;
    $ab7d474d755ab51b$var$_logger.warning = logger.warning || $ab7d474d755ab51b$var$_logger.warning;
}
function $ab7d474d755ab51b$export$2b1d391cd05230fd() {
    return $ab7d474d755ab51b$var$_logger;
}
function $ab7d474d755ab51b$var$rectSideBounce(data) {
    const res = {
        bounced: false
    }, { pSide: pSide, pOtherSide: pOtherSide, rectSide: rectSide, rectOtherSide: rectOtherSide, velocity: velocity, factor: factor } = data;
    if (pOtherSide.min < rectOtherSide.min || pOtherSide.min > rectOtherSide.max || pOtherSide.max < rectOtherSide.min || pOtherSide.max > rectOtherSide.max) return res;
    if (pSide.max >= rectSide.min && pSide.max <= (rectSide.max + rectSide.min) / 2 && velocity > 0 || pSide.min <= rectSide.max && pSide.min > (rectSide.max + rectSide.min) / 2 && velocity < 0) {
        res.velocity = velocity * -factor;
        res.bounced = true;
    }
    return res;
}
function $ab7d474d755ab51b$var$checkSelector(element, selectors) {
    const res = $ab7d474d755ab51b$export$8e5dc47097396754(selectors, (selector)=>{
        return element.matches(selector);
    });
    return $ab7d474d755ab51b$export$43bee75e5e14138e(res) ? res.some((t)=>t) : res;
}
function $ab7d474d755ab51b$export$460b6777813d3d86() {
    return typeof window === "undefined" || !window || typeof window.document === "undefined" || !window.document;
}
function $ab7d474d755ab51b$export$c242851ed0beda6c() {
    return !$ab7d474d755ab51b$export$460b6777813d3d86() && typeof matchMedia !== "undefined";
}
function $ab7d474d755ab51b$export$db32b9574e21e00f(query) {
    if (!$ab7d474d755ab51b$export$c242851ed0beda6c()) return;
    return matchMedia(query);
}
function $ab7d474d755ab51b$export$c2f9084a48da0641(callback) {
    if ($ab7d474d755ab51b$export$460b6777813d3d86() || typeof MutationObserver === "undefined") return;
    return new MutationObserver(callback);
}
function $ab7d474d755ab51b$export$5e9bb4359042e24b(value, array) {
    return value === array || $ab7d474d755ab51b$export$43bee75e5e14138e(array) && array.indexOf(value) > -1;
}
async function $ab7d474d755ab51b$export$672089c3debc1182(font, weight) {
    try {
        await document.fonts.load(`${weight ?? "400"} 36px '${font ?? "Verdana"}'`);
    } catch  {}
}
function $ab7d474d755ab51b$export$aab6d48e027939d7(array) {
    return Math.floor((0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() * array.length);
}
function $ab7d474d755ab51b$export$3a5d12ca7137122f(array, index, useIndex = true) {
    return array[index !== undefined && useIndex ? index % array.length : $ab7d474d755ab51b$export$aab6d48e027939d7(array)];
}
function $ab7d474d755ab51b$export$2ea42ef493c7076c(point, size, offset, radius, direction) {
    return $ab7d474d755ab51b$export$bb47d4799bdb9a4d($ab7d474d755ab51b$export$b0a2169b5f9d18d8(point, radius ?? 0), size, offset, direction);
}
function $ab7d474d755ab51b$export$bb47d4799bdb9a4d(bounds, size, offset, direction) {
    let inside = true;
    if (!direction || direction === "bottom") inside = bounds.top < size.height + offset.x;
    if (inside && (!direction || direction === "left")) inside = bounds.right > offset.x;
    if (inside && (!direction || direction === "right")) inside = bounds.left < size.width + offset.y;
    if (inside && (!direction || direction === "top")) inside = bounds.bottom > offset.y;
    return inside;
}
function $ab7d474d755ab51b$export$b0a2169b5f9d18d8(point, radius) {
    return {
        bottom: point.y + radius,
        left: point.x - radius,
        right: point.x + radius,
        top: point.y - radius
    };
}
function $ab7d474d755ab51b$export$54e9fb29908872fa(destination, ...sources) {
    for (const source of sources){
        if (source === undefined || source === null) continue;
        if (!$ab7d474d755ab51b$export$a6cdc56e425d0d0a(source)) {
            destination = source;
            continue;
        }
        const sourceIsArray = Array.isArray(source);
        if (sourceIsArray && ($ab7d474d755ab51b$export$a6cdc56e425d0d0a(destination) || !destination || !Array.isArray(destination))) destination = [];
        else if (!sourceIsArray && ($ab7d474d755ab51b$export$a6cdc56e425d0d0a(destination) || !destination || Array.isArray(destination))) destination = {};
        for(const key in source){
            if (key === "__proto__") continue;
            const sourceDict = source, value = sourceDict[key], destDict = destination;
            destDict[key] = $ab7d474d755ab51b$export$a6cdc56e425d0d0a(value) && Array.isArray(value) ? value.map((v)=>$ab7d474d755ab51b$export$54e9fb29908872fa(destDict[key], v)) : $ab7d474d755ab51b$export$54e9fb29908872fa(destDict[key], value);
        }
    }
    return destination;
}
function $ab7d474d755ab51b$export$5d1f020956707f4(mode, divs) {
    return !!$ab7d474d755ab51b$export$bfd133b0f67a5a3a(divs, (t)=>t.enable && $ab7d474d755ab51b$export$5e9bb4359042e24b(mode, t.mode));
}
function $ab7d474d755ab51b$export$194f9554360903fd(mode, divs, callback) {
    $ab7d474d755ab51b$export$8e5dc47097396754(divs, (div)=>{
        const divMode = div.mode, divEnabled = div.enable;
        if (divEnabled && $ab7d474d755ab51b$export$5e9bb4359042e24b(mode, divMode)) $ab7d474d755ab51b$export$921eaa53ee8b79db(div, callback);
    });
}
function $ab7d474d755ab51b$export$921eaa53ee8b79db(div, callback) {
    const selectors = div.selectors;
    $ab7d474d755ab51b$export$8e5dc47097396754(selectors, (selector)=>{
        callback(selector, div);
    });
}
function $ab7d474d755ab51b$export$f7c2b83aad443adb(divs, element) {
    if (!element || !divs) return;
    return $ab7d474d755ab51b$export$bfd133b0f67a5a3a(divs, (div)=>{
        return $ab7d474d755ab51b$var$checkSelector(element, div.selectors);
    });
}
function $ab7d474d755ab51b$export$11ae16f2acc5c3ba(p) {
    return {
        position: p.getPosition(),
        radius: p.getRadius(),
        mass: p.getMass(),
        velocity: p.velocity,
        factor: (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).create((0, $a17cb6ec9e2ec6c9$export$bf7199a9ebcb84a9)(p.options.bounce.horizontal), (0, $a17cb6ec9e2ec6c9$export$bf7199a9ebcb84a9)(p.options.bounce.vertical))
    };
}
function $ab7d474d755ab51b$export$c6e9f28fb57ea828(p1, p2) {
    const { x: xVelocityDiff, y: yVelocityDiff } = p1.velocity.sub(p2.velocity), [pos1, pos2] = [
        p1.position,
        p2.position
    ], { dx: xDist, dy: yDist } = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(pos2, pos1);
    if (xVelocityDiff * xDist + yVelocityDiff * yDist < 0) return;
    const angle = -Math.atan2(yDist, xDist), m1 = p1.mass, m2 = p2.mass, u1 = p1.velocity.rotate(angle), u2 = p2.velocity.rotate(angle), v1 = (0, $a17cb6ec9e2ec6c9$export$ee2fb97c67882d88)(u1, u2, m1, m2), v2 = (0, $a17cb6ec9e2ec6c9$export$ee2fb97c67882d88)(u2, u1, m1, m2), vFinal1 = v1.rotate(-angle), vFinal2 = v2.rotate(-angle);
    p1.velocity.x = vFinal1.x * p1.factor.x;
    p1.velocity.y = vFinal1.y * p1.factor.y;
    p2.velocity.x = vFinal2.x * p2.factor.x;
    p2.velocity.y = vFinal2.y * p2.factor.y;
}
function $ab7d474d755ab51b$export$e83851ba31840182(particle, divBounds) {
    const pPos = particle.getPosition(), size = particle.getRadius(), bounds = $ab7d474d755ab51b$export$b0a2169b5f9d18d8(pPos, size), resH = $ab7d474d755ab51b$var$rectSideBounce({
        pSide: {
            min: bounds.left,
            max: bounds.right
        },
        pOtherSide: {
            min: bounds.top,
            max: bounds.bottom
        },
        rectSide: {
            min: divBounds.left,
            max: divBounds.right
        },
        rectOtherSide: {
            min: divBounds.top,
            max: divBounds.bottom
        },
        velocity: particle.velocity.x,
        factor: (0, $a17cb6ec9e2ec6c9$export$bf7199a9ebcb84a9)(particle.options.bounce.horizontal)
    });
    if (resH.bounced) {
        if (resH.velocity !== undefined) particle.velocity.x = resH.velocity;
        if (resH.position !== undefined) particle.position.x = resH.position;
    }
    const resV = $ab7d474d755ab51b$var$rectSideBounce({
        pSide: {
            min: bounds.top,
            max: bounds.bottom
        },
        pOtherSide: {
            min: bounds.left,
            max: bounds.right
        },
        rectSide: {
            min: divBounds.top,
            max: divBounds.bottom
        },
        rectOtherSide: {
            min: divBounds.left,
            max: divBounds.right
        },
        velocity: particle.velocity.y,
        factor: (0, $a17cb6ec9e2ec6c9$export$bf7199a9ebcb84a9)(particle.options.bounce.vertical)
    });
    if (resV.bounced) {
        if (resV.velocity !== undefined) particle.velocity.y = resV.velocity;
        if (resV.position !== undefined) particle.position.y = resV.position;
    }
}
function $ab7d474d755ab51b$export$8e5dc47097396754(obj, callback) {
    return $ab7d474d755ab51b$export$43bee75e5e14138e(obj) ? obj.map((item, index)=>callback(item, index)) : callback(obj, 0);
}
function $ab7d474d755ab51b$export$3fbf39566d3ee62e(obj, index, useIndex) {
    return $ab7d474d755ab51b$export$43bee75e5e14138e(obj) ? $ab7d474d755ab51b$export$3a5d12ca7137122f(obj, index, useIndex) : obj;
}
function $ab7d474d755ab51b$export$bfd133b0f67a5a3a(obj, callback) {
    return $ab7d474d755ab51b$export$43bee75e5e14138e(obj) ? obj.find((t, index)=>callback(t, index)) : callback(obj, 0) ? obj : undefined;
}
function $ab7d474d755ab51b$export$bebd78259cce4fd(options, pxRatio) {
    const valueRange = options.value, animationOptions = options.animation, res = {
        delayTime: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(animationOptions.delay) * 1000,
        enable: animationOptions.enable,
        value: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(options.value) * pxRatio,
        max: (0, $a17cb6ec9e2ec6c9$export$27d2c76f835d583d)(valueRange) * pxRatio,
        min: (0, $a17cb6ec9e2ec6c9$export$71c94d28c0fa4bfe)(valueRange) * pxRatio,
        loops: 0,
        maxLoops: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(animationOptions.count),
        time: 0
    };
    if (animationOptions.enable) {
        res.decay = 1 - (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(animationOptions.decay);
        switch(animationOptions.mode){
            case "increase":
                res.status = "increasing";
                break;
            case "decrease":
                res.status = "decreasing";
                break;
            case "random":
                res.status = (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() >= 0.5 ? "increasing" : "decreasing";
                break;
        }
        const autoStatus = animationOptions.mode === "auto";
        switch(animationOptions.startValue){
            case "min":
                res.value = res.min;
                if (autoStatus) res.status = "increasing";
                break;
            case "max":
                res.value = res.max;
                if (autoStatus) res.status = "decreasing";
                break;
            case "random":
            default:
                res.value = (0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)(res);
                if (autoStatus) res.status = (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() >= 0.5 ? "increasing" : "decreasing";
                break;
        }
    }
    res.initialValue = res.value;
    return res;
}
function $ab7d474d755ab51b$var$getPositionOrSize(positionOrSize, canvasSize) {
    const isPercent = positionOrSize.mode === "percent";
    if (!isPercent) {
        const { mode: _, ...rest } = positionOrSize;
        return rest;
    }
    const isPosition = "x" in positionOrSize;
    if (isPosition) return {
        x: positionOrSize.x / 100 * canvasSize.width,
        y: positionOrSize.y / 100 * canvasSize.height
    };
    else return {
        width: positionOrSize.width / 100 * canvasSize.width,
        height: positionOrSize.height / 100 * canvasSize.height
    };
}
function $ab7d474d755ab51b$export$1690e12b840569b9(position, canvasSize) {
    return $ab7d474d755ab51b$var$getPositionOrSize(position, canvasSize);
}
function $ab7d474d755ab51b$export$31b21d0167753bb4(size, canvasSize) {
    return $ab7d474d755ab51b$var$getPositionOrSize(size, canvasSize);
}
function $ab7d474d755ab51b$export$f9ce7b637dfbe238(arg) {
    return typeof arg === "boolean";
}
function $ab7d474d755ab51b$export$844ec244b1367d54(arg) {
    return typeof arg === "string";
}
function $ab7d474d755ab51b$export$7e4aa119212bc614(arg) {
    return typeof arg === "number";
}
function $ab7d474d755ab51b$export$f6e2535fb5126e54(arg) {
    return typeof arg === "function";
}
function $ab7d474d755ab51b$export$a6cdc56e425d0d0a(arg) {
    return typeof arg === "object" && arg !== null;
}
function $ab7d474d755ab51b$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}





const $3b20cd3c058d307c$var$randomColorValue = "random", $3b20cd3c058d307c$var$midColorValue = "mid", $3b20cd3c058d307c$var$colorManagers = new Map();
function $3b20cd3c058d307c$export$fac4919b23cbaf23(manager) {
    $3b20cd3c058d307c$var$colorManagers.set(manager.key, manager);
}
function $3b20cd3c058d307c$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $3b20cd3c058d307c$var$stringToRgba(input) {
    for (const [, manager] of $3b20cd3c058d307c$var$colorManagers){
        if (input.startsWith(manager.stringPrefix)) return manager.parseString(input);
    }
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, hexFixed = input.replace(shorthandRegex, (_, r, g, b, a)=>{
        return r + r + g + g + b + b + (a !== undefined ? a + a : "");
    }), regex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, result = regex.exec(hexFixed);
    return result ? {
        a: result[4] !== undefined ? parseInt(result[4], 16) / 0xff : 1,
        b: parseInt(result[3], 16),
        g: parseInt(result[2], 16),
        r: parseInt(result[1], 16)
    } : undefined;
}
function $3b20cd3c058d307c$export$fbf0bf3cc1fc0cc4(input, index, useIndex = true) {
    if (!input) return;
    const color = (0, $ab7d474d755ab51b$export$844ec244b1367d54)(input) ? {
        value: input
    } : input;
    if ((0, $ab7d474d755ab51b$export$844ec244b1367d54)(color.value)) return $3b20cd3c058d307c$export$170d64abcc52d97a(color.value, index, useIndex);
    if ((0, $ab7d474d755ab51b$export$43bee75e5e14138e)(color.value)) return $3b20cd3c058d307c$export$fbf0bf3cc1fc0cc4({
        value: (0, $ab7d474d755ab51b$export$3a5d12ca7137122f)(color.value, index, useIndex)
    });
    for (const [, manager] of $3b20cd3c058d307c$var$colorManagers){
        const res = manager.handleRangeColor(color);
        if (res) return res;
    }
}
function $3b20cd3c058d307c$export$170d64abcc52d97a(input, index, useIndex = true) {
    if (!input) return;
    const color = (0, $ab7d474d755ab51b$export$844ec244b1367d54)(input) ? {
        value: input
    } : input;
    if ((0, $ab7d474d755ab51b$export$844ec244b1367d54)(color.value)) return color.value === $3b20cd3c058d307c$var$randomColorValue ? $3b20cd3c058d307c$export$ac4fc8e9144a1018() : $3b20cd3c058d307c$export$d2c5ec93815c4391(color.value);
    if ((0, $ab7d474d755ab51b$export$43bee75e5e14138e)(color.value)) return $3b20cd3c058d307c$export$170d64abcc52d97a({
        value: (0, $ab7d474d755ab51b$export$3a5d12ca7137122f)(color.value, index, useIndex)
    });
    for (const [, manager] of $3b20cd3c058d307c$var$colorManagers){
        const res = manager.handleColor(color);
        if (res) return res;
    }
}
function $3b20cd3c058d307c$export$5e49d166a305dfce(color, index, useIndex = true) {
    const rgb = $3b20cd3c058d307c$export$170d64abcc52d97a(color, index, useIndex);
    return rgb ? $3b20cd3c058d307c$export$c85ca4f4753af384(rgb) : undefined;
}
function $3b20cd3c058d307c$export$79a89086521c0f12(color, index, useIndex = true) {
    const rgb = $3b20cd3c058d307c$export$fbf0bf3cc1fc0cc4(color, index, useIndex);
    return rgb ? $3b20cd3c058d307c$export$c85ca4f4753af384(rgb) : undefined;
}
function $3b20cd3c058d307c$export$c85ca4f4753af384(color) {
    const r1 = color.r / 255, g1 = color.g / 255, b1 = color.b / 255, max = Math.max(r1, g1, b1), min = Math.min(r1, g1, b1), res = {
        h: 0,
        l: (max + min) / 2,
        s: 0
    };
    if (max !== min) {
        res.s = res.l < 0.5 ? (max - min) / (max + min) : (max - min) / (2.0 - max - min);
        res.h = r1 === max ? (g1 - b1) / (max - min) : res.h = g1 === max ? 2.0 + (b1 - r1) / (max - min) : 4.0 + (r1 - g1) / (max - min);
    }
    res.l *= 100;
    res.s *= 100;
    res.h *= 60;
    if (res.h < 0) res.h += 360;
    if (res.h >= 360) res.h -= 360;
    return res;
}
function $3b20cd3c058d307c$export$143dda7722fd213d(input) {
    return $3b20cd3c058d307c$var$stringToRgba(input)?.a;
}
function $3b20cd3c058d307c$export$d2c5ec93815c4391(input) {
    return $3b20cd3c058d307c$var$stringToRgba(input);
}
function $3b20cd3c058d307c$export$29fb7152bd3f781a(hsl) {
    const result = {
        b: 0,
        g: 0,
        r: 0
    }, hslPercent = {
        h: hsl.h / 360,
        l: hsl.l / 100,
        s: hsl.s / 100
    };
    if (!hslPercent.s) result.r = result.g = result.b = hslPercent.l;
    else {
        const q = hslPercent.l < 0.5 ? hslPercent.l * (1 + hslPercent.s) : hslPercent.l + hslPercent.s - hslPercent.l * hslPercent.s, p = 2 * hslPercent.l - q;
        result.r = $3b20cd3c058d307c$var$hue2rgb(p, q, hslPercent.h + 1 / 3);
        result.g = $3b20cd3c058d307c$var$hue2rgb(p, q, hslPercent.h);
        result.b = $3b20cd3c058d307c$var$hue2rgb(p, q, hslPercent.h - 1 / 3);
    }
    result.r = Math.floor(result.r * 255);
    result.g = Math.floor(result.g * 255);
    result.b = Math.floor(result.b * 255);
    return result;
}
function $3b20cd3c058d307c$export$6ae64dbcd6bfc33e(hsla) {
    const rgbResult = $3b20cd3c058d307c$export$29fb7152bd3f781a(hsla);
    return {
        a: hsla.a,
        b: rgbResult.b,
        g: rgbResult.g,
        r: rgbResult.r
    };
}
function $3b20cd3c058d307c$export$ac4fc8e9144a1018(min) {
    const fixedMin = min ?? 0;
    return {
        b: Math.floor((0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)((0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(fixedMin, 256))),
        g: Math.floor((0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)((0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(fixedMin, 256))),
        r: Math.floor((0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)((0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(fixedMin, 256)))
    };
}
function $3b20cd3c058d307c$export$2476af37e47fcae2(color, opacity) {
    return `rgba(${color.r}, ${color.g}, ${color.b}, ${opacity ?? 1})`;
}
function $3b20cd3c058d307c$export$9d057e59c7b0a82d(color, opacity) {
    return `hsla(${color.h}, ${color.s}%, ${color.l}%, ${opacity ?? 1})`;
}
function $3b20cd3c058d307c$export$9b476054b78b89cd(color1, color2, size1, size2) {
    let rgb1 = color1, rgb2 = color2;
    if (rgb1.r === undefined) rgb1 = $3b20cd3c058d307c$export$29fb7152bd3f781a(color1);
    if (rgb2.r === undefined) rgb2 = $3b20cd3c058d307c$export$29fb7152bd3f781a(color2);
    return {
        b: (0, $a17cb6ec9e2ec6c9$export$2c9e8a9632a706b2)(rgb1.b, rgb2.b, size1, size2),
        g: (0, $a17cb6ec9e2ec6c9$export$2c9e8a9632a706b2)(rgb1.g, rgb2.g, size1, size2),
        r: (0, $a17cb6ec9e2ec6c9$export$2c9e8a9632a706b2)(rgb1.r, rgb2.r, size1, size2)
    };
}
function $3b20cd3c058d307c$export$b676eb46c472d7df(p1, p2, linkColor) {
    if (linkColor === $3b20cd3c058d307c$var$randomColorValue) return $3b20cd3c058d307c$export$ac4fc8e9144a1018();
    else if (linkColor === $3b20cd3c058d307c$var$midColorValue) {
        const sourceColor = p1.getFillColor() ?? p1.getStrokeColor(), destColor = p2?.getFillColor() ?? p2?.getStrokeColor();
        if (sourceColor && destColor && p2) return $3b20cd3c058d307c$export$9b476054b78b89cd(sourceColor, destColor, p1.getRadius(), p2.getRadius());
        else {
            const hslColor = sourceColor ?? destColor;
            if (hslColor) return $3b20cd3c058d307c$export$29fb7152bd3f781a(hslColor);
        }
    } else return linkColor;
}
function $3b20cd3c058d307c$export$cf0e5a4ae26bdcdc(optColor, blink, consent) {
    const color = (0, $ab7d474d755ab51b$export$844ec244b1367d54)(optColor) ? optColor : optColor.value;
    if (color === $3b20cd3c058d307c$var$randomColorValue) {
        if (consent) return $3b20cd3c058d307c$export$fbf0bf3cc1fc0cc4({
            value: color
        });
        if (blink) return $3b20cd3c058d307c$var$randomColorValue;
        return $3b20cd3c058d307c$var$midColorValue;
    } else if (color === $3b20cd3c058d307c$var$midColorValue) return $3b20cd3c058d307c$var$midColorValue;
    else return $3b20cd3c058d307c$export$fbf0bf3cc1fc0cc4({
        value: color
    });
}
function $3b20cd3c058d307c$export$c90768c73bc1d7ab(animation) {
    return animation !== undefined ? {
        h: animation.h.value,
        s: animation.s.value,
        l: animation.l.value
    } : undefined;
}
function $3b20cd3c058d307c$export$6e8a573710bea117(hsl, animationOptions, reduceFactor) {
    const resColor = {
        h: {
            enable: false,
            value: hsl.h
        },
        s: {
            enable: false,
            value: hsl.s
        },
        l: {
            enable: false,
            value: hsl.l
        }
    };
    if (animationOptions) {
        $3b20cd3c058d307c$var$setColorAnimation(resColor.h, animationOptions.h, reduceFactor);
        $3b20cd3c058d307c$var$setColorAnimation(resColor.s, animationOptions.s, reduceFactor);
        $3b20cd3c058d307c$var$setColorAnimation(resColor.l, animationOptions.l, reduceFactor);
    }
    return resColor;
}
function $3b20cd3c058d307c$var$setColorAnimation(colorValue, colorAnimation, reduceFactor) {
    colorValue.enable = colorAnimation.enable;
    if (colorValue.enable) {
        colorValue.velocity = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(colorAnimation.speed) / 100 * reduceFactor;
        colorValue.decay = 1 - (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(colorAnimation.decay);
        colorValue.status = "increasing";
        colorValue.loops = 0;
        colorValue.maxLoops = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(colorAnimation.count);
        colorValue.time = 0;
        colorValue.delayTime = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(colorAnimation.delay) * 1000;
        if (!colorAnimation.sync) {
            colorValue.velocity *= (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)();
            colorValue.value *= (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)();
        }
        colorValue.initialValue = colorValue.value;
    } else colorValue.velocity = 0;
}


function $b69b7cfe4b0de35f$export$819db45aec5fcbe5(context, begin, end) {
    context.beginPath();
    context.moveTo(begin.x, begin.y);
    context.lineTo(end.x, end.y);
    context.closePath();
}
function $b69b7cfe4b0de35f$export$e6b70c7883316010(context, p1, p2, p3) {
    context.beginPath();
    context.moveTo(p1.x, p1.y);
    context.lineTo(p2.x, p2.y);
    context.lineTo(p3.x, p3.y);
    context.closePath();
}
function $b69b7cfe4b0de35f$export$2837cdf5427f767e(context, dimension, baseColor) {
    context.fillStyle = baseColor ?? "rgba(0,0,0,0)";
    context.fillRect(0, 0, dimension.width, dimension.height);
}
function $b69b7cfe4b0de35f$export$a17334b9431a8cb2(context, dimension, image, opacity) {
    if (!image) return;
    context.globalAlpha = opacity;
    context.drawImage(image, 0, 0, dimension.width, dimension.height);
    context.globalAlpha = 1;
}
function $b69b7cfe4b0de35f$export$42ffd38884aecdac(context, dimension) {
    context.clearRect(0, 0, dimension.width, dimension.height);
}
function $b69b7cfe4b0de35f$export$fca8f175741ef351(data) {
    const { container: container, context: context, particle: particle, delta: delta, colorStyles: colorStyles, backgroundMask: backgroundMask, composite: composite, radius: radius, opacity: opacity, shadow: shadow, transform: transform } = data;
    const pos = particle.getPosition(), angle = particle.rotation + (particle.pathRotation ? particle.velocity.angle : 0), rotateData = {
        sin: Math.sin(angle),
        cos: Math.cos(angle)
    }, transformData = {
        a: rotateData.cos * (transform.a ?? 1),
        b: rotateData.sin * (transform.b ?? 1),
        c: -rotateData.sin * (transform.c ?? 1),
        d: rotateData.cos * (transform.d ?? 1)
    };
    context.setTransform(transformData.a, transformData.b, transformData.c, transformData.d, pos.x, pos.y);
    context.beginPath();
    if (backgroundMask) context.globalCompositeOperation = composite;
    const shadowColor = particle.shadowColor;
    if (shadow.enable && shadowColor) {
        context.shadowBlur = shadow.blur;
        context.shadowColor = (0, $3b20cd3c058d307c$export$2476af37e47fcae2)(shadowColor);
        context.shadowOffsetX = shadow.offset.x;
        context.shadowOffsetY = shadow.offset.y;
    }
    if (colorStyles.fill) context.fillStyle = colorStyles.fill;
    const strokeWidth = particle.strokeWidth ?? 0;
    context.lineWidth = strokeWidth;
    if (colorStyles.stroke) context.strokeStyle = colorStyles.stroke;
    $b69b7cfe4b0de35f$export$71b514a25c47df50(container, context, particle, radius, opacity, delta);
    if (strokeWidth > 0) context.stroke();
    if (particle.close) context.closePath();
    if (particle.fill) context.fill();
    $b69b7cfe4b0de35f$export$eeffaa3298a32e85(container, context, particle, radius, opacity, delta);
    context.globalCompositeOperation = "source-over";
    context.setTransform(1, 0, 0, 1, 0, 0);
}
function $b69b7cfe4b0de35f$export$71b514a25c47df50(container, context, particle, radius, opacity, delta) {
    if (!particle.shape) return;
    const drawer = container.drawers.get(particle.shape);
    if (!drawer) return;
    drawer.draw(context, particle, radius, opacity, delta, container.retina.pixelRatio);
}
function $b69b7cfe4b0de35f$export$eeffaa3298a32e85(container, context, particle, radius, opacity, delta) {
    if (!particle.shape) return;
    const drawer = container.drawers.get(particle.shape);
    if (!drawer || !drawer.afterEffect) return;
    drawer.afterEffect(context, particle, radius, opacity, delta, container.retina.pixelRatio);
}
function $b69b7cfe4b0de35f$export$ee9933e1bf4ba142(context, plugin, delta) {
    if (!plugin.draw) return;
    plugin.draw(context, delta);
}
function $b69b7cfe4b0de35f$export$3493f6d6277d918a(context, plugin, particle, delta) {
    if (!plugin.drawParticle) return;
    plugin.drawParticle(context, particle, delta);
}
function $b69b7cfe4b0de35f$export$fe1d034b0e82666(color, type, value) {
    return {
        h: color.h,
        s: color.s,
        l: color.l + (type === "darken" ? -1 : 1) * value
    };
}





function $e6bf9c7b5e45d6d5$var$setTransformValue(factor, newFactor, key) {
    const newValue = newFactor[key];
    if (newValue !== undefined) factor[key] = (factor[key] ?? 1) * newValue;
}
class $e6bf9c7b5e45d6d5$export$8d01c972ee8b14a9 {
    constructor(container){
        this.container = container;
        this._applyPostDrawUpdaters = (particle)=>{
            for (const updater of this._postDrawUpdaters)updater.afterDraw && updater.afterDraw(particle);
        };
        this._applyPreDrawUpdaters = (ctx, particle, radius, zOpacity, colorStyles, transform)=>{
            for (const updater of this._preDrawUpdaters){
                if (updater.getColorStyles) {
                    const { fill: fill, stroke: stroke } = updater.getColorStyles(particle, ctx, radius, zOpacity);
                    if (fill) colorStyles.fill = fill;
                    if (stroke) colorStyles.stroke = stroke;
                }
                if (updater.getTransformValues) {
                    const updaterTransform = updater.getTransformValues(particle);
                    for(const key in updaterTransform)$e6bf9c7b5e45d6d5$var$setTransformValue(transform, updaterTransform, key);
                }
                updater.beforeDraw && updater.beforeDraw(particle);
            }
        };
        this._applyResizePlugins = ()=>{
            for (const plugin of this._resizePlugins)plugin.resize && plugin.resize();
        };
        this._getPluginParticleColors = (particle)=>{
            let fColor, sColor;
            for (const plugin of this._colorPlugins){
                if (!fColor && plugin.particleFillColor) fColor = (0, $3b20cd3c058d307c$export$79a89086521c0f12)(plugin.particleFillColor(particle));
                if (!sColor && plugin.particleStrokeColor) sColor = (0, $3b20cd3c058d307c$export$79a89086521c0f12)(plugin.particleStrokeColor(particle));
                if (fColor && sColor) break;
            }
            return [
                fColor,
                sColor
            ];
        };
        this._initCover = ()=>{
            const options = this.container.actualOptions, cover = options.backgroundMask.cover, color = cover.color, coverRgb = (0, $3b20cd3c058d307c$export$fbf0bf3cc1fc0cc4)(color);
            if (coverRgb) {
                const coverColor = {
                    ...coverRgb,
                    a: cover.opacity
                };
                this._coverColorStyle = (0, $3b20cd3c058d307c$export$2476af37e47fcae2)(coverColor, coverColor.a);
            }
        };
        this._initStyle = ()=>{
            const element = this.element, options = this.container.actualOptions;
            if (!element) return;
            if (this._fullScreen) {
                this._originalStyle = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)({}, element.style);
                this._setFullScreenStyle();
            } else this._resetOriginalStyle();
            for(const key in options.style){
                if (!key || !options.style) continue;
                const value = options.style[key];
                if (!value) continue;
                element.style.setProperty(key, value, "important");
            }
        };
        this._initTrail = async ()=>{
            const options = this.container.actualOptions, trail = options.particles.move.trail, trailFill = trail.fill;
            if (!trail.enable) return;
            if (trailFill.color) {
                const fillColor = (0, $3b20cd3c058d307c$export$fbf0bf3cc1fc0cc4)(trailFill.color);
                if (!fillColor) return;
                const trail = options.particles.move.trail;
                this._trailFill = {
                    color: {
                        ...fillColor
                    },
                    opacity: 1 / trail.length
                };
            } else await new Promise((resolve, reject)=>{
                if (!trailFill.image) return;
                const img = document.createElement("img");
                img.addEventListener("load", ()=>{
                    this._trailFill = {
                        image: img,
                        opacity: 1 / trail.length
                    };
                    resolve();
                });
                img.addEventListener("error", (evt)=>{
                    reject(evt.error);
                });
                img.src = trailFill.image;
            });
        };
        this._paintBase = (baseColor)=>{
            this.draw((ctx)=>(0, $b69b7cfe4b0de35f$export$2837cdf5427f767e)(ctx, this.size, baseColor));
        };
        this._paintImage = (image, opacity)=>{
            this.draw((ctx)=>(0, $b69b7cfe4b0de35f$export$a17334b9431a8cb2)(ctx, this.size, image, opacity));
        };
        this._repairStyle = ()=>{
            const element = this.element;
            if (!element) return;
            this._safeMutationObserver((observer)=>observer.disconnect());
            this._initStyle();
            this.initBackground();
            this._safeMutationObserver((observer)=>observer.observe(element, {
                    attributes: true
                }));
        };
        this._resetOriginalStyle = ()=>{
            const element = this.element, originalStyle = this._originalStyle;
            if (!(element && originalStyle)) return;
            const style = element.style;
            style.position = originalStyle.position;
            style.zIndex = originalStyle.zIndex;
            style.top = originalStyle.top;
            style.left = originalStyle.left;
            style.width = originalStyle.width;
            style.height = originalStyle.height;
        };
        this._safeMutationObserver = (callback)=>{
            if (!this._mutationObserver) return;
            callback(this._mutationObserver);
        };
        this._setFullScreenStyle = ()=>{
            const element = this.element;
            if (!element) return;
            const priority = "important", style = element.style;
            style.setProperty("position", "fixed", priority);
            style.setProperty("z-index", this.container.actualOptions.fullScreen.zIndex.toString(10), priority);
            style.setProperty("top", "0", priority);
            style.setProperty("left", "0", priority);
            style.setProperty("width", "100%", priority);
            style.setProperty("height", "100%", priority);
        };
        this.size = {
            height: 0,
            width: 0
        };
        this._context = null;
        this._generated = false;
        this._preDrawUpdaters = [];
        this._postDrawUpdaters = [];
        this._resizePlugins = [];
        this._colorPlugins = [];
    }
    get _fullScreen() {
        return this.container.actualOptions.fullScreen.enable;
    }
    clear() {
        const options = this.container.actualOptions, trail = options.particles.move.trail, trailFill = this._trailFill;
        if (options.backgroundMask.enable) this.paint();
        else if (trail.enable && trail.length > 0 && trailFill) {
            if (trailFill.color) this._paintBase((0, $3b20cd3c058d307c$export$2476af37e47fcae2)(trailFill.color, trailFill.opacity));
            else if (trailFill.image) this._paintImage(trailFill.image, trailFill.opacity);
        } else this.draw((ctx)=>{
            (0, $b69b7cfe4b0de35f$export$42ffd38884aecdac)(ctx, this.size);
        });
    }
    destroy() {
        this.stop();
        if (this._generated) {
            const element = this.element;
            element && element.remove();
        } else this._resetOriginalStyle();
        this._preDrawUpdaters = [];
        this._postDrawUpdaters = [];
        this._resizePlugins = [];
        this._colorPlugins = [];
    }
    draw(cb) {
        const ctx = this._context;
        if (!ctx) return;
        return cb(ctx);
    }
    drawParticle(particle, delta) {
        if (particle.spawning || particle.destroyed) return;
        const radius = particle.getRadius();
        if (radius <= 0) return;
        const pfColor = particle.getFillColor(), psColor = particle.getStrokeColor() ?? pfColor;
        let [fColor, sColor] = this._getPluginParticleColors(particle);
        if (!fColor) fColor = pfColor;
        if (!sColor) sColor = psColor;
        if (!fColor && !sColor) return;
        this.draw((ctx)=>{
            const container = this.container, options = container.actualOptions, zIndexOptions = particle.options.zIndex, zOpacityFactor = (1 - particle.zIndexFactor) ** zIndexOptions.opacityRate, opacity = particle.bubble.opacity ?? particle.opacity?.value ?? 1, strokeOpacity = particle.strokeOpacity ?? opacity, zOpacity = opacity * zOpacityFactor, zStrokeOpacity = strokeOpacity * zOpacityFactor, transform = {}, colorStyles = {
                fill: fColor ? (0, $3b20cd3c058d307c$export$9d057e59c7b0a82d)(fColor, zOpacity) : undefined
            };
            colorStyles.stroke = sColor ? (0, $3b20cd3c058d307c$export$9d057e59c7b0a82d)(sColor, zStrokeOpacity) : colorStyles.fill;
            this._applyPreDrawUpdaters(ctx, particle, radius, zOpacity, colorStyles, transform);
            (0, $b69b7cfe4b0de35f$export$fca8f175741ef351)({
                container: container,
                context: ctx,
                particle: particle,
                delta: delta,
                colorStyles: colorStyles,
                backgroundMask: options.backgroundMask.enable,
                composite: options.backgroundMask.composite,
                radius: radius * (1 - particle.zIndexFactor) ** zIndexOptions.sizeRate,
                opacity: zOpacity,
                shadow: particle.options.shadow,
                transform: transform
            });
            this._applyPostDrawUpdaters(particle);
        });
    }
    drawParticlePlugin(plugin, particle, delta) {
        this.draw((ctx)=>(0, $b69b7cfe4b0de35f$export$3493f6d6277d918a)(ctx, plugin, particle, delta));
    }
    drawPlugin(plugin, delta) {
        this.draw((ctx)=>(0, $b69b7cfe4b0de35f$export$ee9933e1bf4ba142)(ctx, plugin, delta));
    }
    async init() {
        this._safeMutationObserver((obs)=>obs.disconnect());
        this._mutationObserver = (0, $ab7d474d755ab51b$export$c2f9084a48da0641)((records)=>{
            for (const record of records)if (record.type === "attributes" && record.attributeName === "style") this._repairStyle();
        });
        this.resize();
        this._initStyle();
        this._initCover();
        try {
            await this._initTrail();
        } catch (e) {
            (0, $ab7d474d755ab51b$export$2b1d391cd05230fd)().error(e);
        }
        this.initBackground();
        this._safeMutationObserver((obs)=>{
            if (!this.element) return;
            obs.observe(this.element, {
                attributes: true
            });
        });
        this.initUpdaters();
        this.initPlugins();
        this.paint();
    }
    initBackground() {
        const options = this.container.actualOptions, background = options.background, element = this.element;
        if (!element) return;
        const elementStyle = element.style;
        if (!elementStyle) return;
        if (background.color) {
            const color = (0, $3b20cd3c058d307c$export$fbf0bf3cc1fc0cc4)(background.color);
            elementStyle.backgroundColor = color ? (0, $3b20cd3c058d307c$export$2476af37e47fcae2)(color, background.opacity) : "";
        } else elementStyle.backgroundColor = "";
        elementStyle.backgroundImage = background.image || "";
        elementStyle.backgroundPosition = background.position || "";
        elementStyle.backgroundRepeat = background.repeat || "";
        elementStyle.backgroundSize = background.size || "";
    }
    initPlugins() {
        this._resizePlugins = [];
        for (const [, plugin] of this.container.plugins){
            if (plugin.resize) this._resizePlugins.push(plugin);
            if (plugin.particleFillColor || plugin.particleStrokeColor) this._colorPlugins.push(plugin);
        }
    }
    initUpdaters() {
        this._preDrawUpdaters = [];
        this._postDrawUpdaters = [];
        for (const updater of this.container.particles.updaters){
            if (updater.afterDraw) this._postDrawUpdaters.push(updater);
            if (updater.getColorStyles || updater.getTransformValues || updater.beforeDraw) this._preDrawUpdaters.push(updater);
        }
    }
    loadCanvas(canvas) {
        if (this._generated && this.element) this.element.remove();
        this._generated = canvas.dataset && (0, $9f7790cd505e6a79$export$4a278486528d5cfb) in canvas.dataset ? canvas.dataset[0, $9f7790cd505e6a79$export$4a278486528d5cfb] === "true" : this._generated;
        this.element = canvas;
        this.element.ariaHidden = "true";
        this._originalStyle = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)({}, this.element.style);
        this.size.height = canvas.offsetHeight;
        this.size.width = canvas.offsetWidth;
        this._context = this.element.getContext("2d");
        this._safeMutationObserver((obs)=>{
            if (!this.element) return;
            obs.observe(this.element, {
                attributes: true
            });
        });
        this.container.retina.init();
        this.initBackground();
    }
    paint() {
        const options = this.container.actualOptions;
        this.draw((ctx)=>{
            if (options.backgroundMask.enable && options.backgroundMask.cover) {
                (0, $b69b7cfe4b0de35f$export$42ffd38884aecdac)(ctx, this.size);
                this._paintBase(this._coverColorStyle);
            } else this._paintBase();
        });
    }
    resize() {
        if (!this.element) return false;
        const container = this.container, pxRatio = container.retina.pixelRatio, size = container.canvas.size, newSize = {
            width: this.element.offsetWidth * pxRatio,
            height: this.element.offsetHeight * pxRatio
        };
        if (newSize.height === size.height && newSize.width === size.width && newSize.height === this.element.height && newSize.width === this.element.width) return false;
        const oldSize = {
            ...size
        };
        this.element.width = size.width = this.element.offsetWidth * pxRatio;
        this.element.height = size.height = this.element.offsetHeight * pxRatio;
        if (this.container.started) this.resizeFactor = {
            width: size.width / oldSize.width,
            height: size.height / oldSize.height
        };
        return true;
    }
    stop() {
        this._safeMutationObserver((obs)=>obs.disconnect());
        this._mutationObserver = undefined;
        this.draw((ctx)=>(0, $b69b7cfe4b0de35f$export$42ffd38884aecdac)(ctx, this.size));
    }
    async windowResize() {
        if (!this.element || !this.resize()) return;
        const container = this.container, needsRefresh = container.updateActualOptions();
        container.particles.setDensity();
        this._applyResizePlugins();
        if (needsRefresh) await container.refresh();
    }
}




function $c949071402dcefec$var$manageListener(element, event, handler, add, options) {
    if (add) {
        let addOptions = {
            passive: true
        };
        if ((0, $ab7d474d755ab51b$export$f9ce7b637dfbe238)(options)) addOptions.capture = options;
        else if (options !== undefined) addOptions = options;
        element.addEventListener(event, handler, addOptions);
    } else {
        const removeOptions = options;
        element.removeEventListener(event, handler, removeOptions);
    }
}
class $c949071402dcefec$export$b20b719ec758a20f {
    constructor(container){
        this.container = container;
        this._doMouseTouchClick = (e)=>{
            const container = this.container, options = container.actualOptions;
            if (this._canPush) {
                const mouseInteractivity = container.interactivity.mouse, mousePos = mouseInteractivity.position;
                if (!mousePos) return;
                mouseInteractivity.clickPosition = {
                    ...mousePos
                };
                mouseInteractivity.clickTime = new Date().getTime();
                const onClick = options.interactivity.events.onClick;
                (0, $ab7d474d755ab51b$export$8e5dc47097396754)(onClick.mode, (mode)=>this.container.handleClickMode(mode));
            }
            if (e.type === "touchend") setTimeout(()=>this._mouseTouchFinish(), 500);
        };
        this._handleThemeChange = (e)=>{
            const mediaEvent = e, container = this.container, options = container.options, defaultThemes = options.defaultThemes, themeName = mediaEvent.matches ? defaultThemes.dark : defaultThemes.light, theme = options.themes.find((theme)=>theme.name === themeName);
            if (theme && theme.default.auto) container.loadTheme(themeName);
        };
        this._handleVisibilityChange = ()=>{
            const container = this.container, options = container.actualOptions;
            this._mouseTouchFinish();
            if (!options.pauseOnBlur) return;
            if (document && document.hidden) {
                container.pageHidden = true;
                container.pause();
            } else {
                container.pageHidden = false;
                if (container.getAnimationStatus()) container.play(true);
                else container.draw(true);
            }
        };
        this._handleWindowResize = async ()=>{
            if (this._resizeTimeout) {
                clearTimeout(this._resizeTimeout);
                delete this._resizeTimeout;
            }
            this._resizeTimeout = setTimeout(async ()=>{
                const canvas = this.container.canvas;
                canvas && await canvas.windowResize();
            }, this.container.actualOptions.interactivity.events.resize.delay * 1000);
        };
        this._manageInteractivityListeners = (mouseLeaveTmpEvent, add)=>{
            const handlers = this._handlers, container = this.container, options = container.actualOptions;
            const interactivityEl = container.interactivity.element;
            if (!interactivityEl) return;
            const html = interactivityEl, canvasEl = container.canvas.element;
            if (canvasEl) canvasEl.style.pointerEvents = html === canvasEl ? "initial" : "none";
            if (!(options.interactivity.events.onHover.enable || options.interactivity.events.onClick.enable)) return;
            $c949071402dcefec$var$manageListener(interactivityEl, (0, $9f7790cd505e6a79$export$1ffe551d7d33cd33), handlers.mouseMove, add);
            $c949071402dcefec$var$manageListener(interactivityEl, (0, $9f7790cd505e6a79$export$d5353b6c79bbcc70), handlers.touchStart, add);
            $c949071402dcefec$var$manageListener(interactivityEl, (0, $9f7790cd505e6a79$export$d28a82874c0e6212), handlers.touchMove, add);
            if (!options.interactivity.events.onClick.enable) $c949071402dcefec$var$manageListener(interactivityEl, (0, $9f7790cd505e6a79$export$11164630b85c192d), handlers.touchEnd, add);
            else {
                $c949071402dcefec$var$manageListener(interactivityEl, (0, $9f7790cd505e6a79$export$11164630b85c192d), handlers.touchEndClick, add);
                $c949071402dcefec$var$manageListener(interactivityEl, (0, $9f7790cd505e6a79$export$9fb0268ce1bdbca0), handlers.mouseUp, add);
                $c949071402dcefec$var$manageListener(interactivityEl, (0, $9f7790cd505e6a79$export$9ffd73c9a0e32c34), handlers.mouseDown, add);
            }
            $c949071402dcefec$var$manageListener(interactivityEl, mouseLeaveTmpEvent, handlers.mouseLeave, add);
            $c949071402dcefec$var$manageListener(interactivityEl, (0, $9f7790cd505e6a79$export$65db1c69591947a7), handlers.touchCancel, add);
        };
        this._manageListeners = (add)=>{
            const handlers = this._handlers, container = this.container, options = container.actualOptions, detectType = options.interactivity.detectsOn, canvasEl = container.canvas.element;
            let mouseLeaveTmpEvent = (0, $9f7790cd505e6a79$export$f4b184a85a586f8a);
            if (detectType === "window") {
                container.interactivity.element = window;
                mouseLeaveTmpEvent = (0, $9f7790cd505e6a79$export$55cc1d6a692feb2b);
            } else if (detectType === "parent" && canvasEl) container.interactivity.element = canvasEl.parentElement ?? canvasEl.parentNode;
            else container.interactivity.element = canvasEl;
            this._manageMediaMatch(add);
            this._manageResize(add);
            this._manageInteractivityListeners(mouseLeaveTmpEvent, add);
            if (document) $c949071402dcefec$var$manageListener(document, (0, $9f7790cd505e6a79$export$73536144dc68dd0f), handlers.visibilityChange, add, false);
        };
        this._manageMediaMatch = (add)=>{
            const handlers = this._handlers, mediaMatch = (0, $ab7d474d755ab51b$export$db32b9574e21e00f)("(prefers-color-scheme: dark)");
            if (!mediaMatch) return;
            if (mediaMatch.addEventListener !== undefined) {
                $c949071402dcefec$var$manageListener(mediaMatch, "change", handlers.themeChange, add);
                return;
            }
            if (mediaMatch.addListener === undefined) return;
            if (add) mediaMatch.addListener(handlers.oldThemeChange);
            else mediaMatch.removeListener(handlers.oldThemeChange);
        };
        this._manageResize = (add)=>{
            const handlers = this._handlers, container = this.container, options = container.actualOptions;
            if (!options.interactivity.events.resize) return;
            if (typeof ResizeObserver === "undefined") {
                $c949071402dcefec$var$manageListener(window, (0, $9f7790cd505e6a79$export$8b3d73c91cd7cc65), handlers.resize, add);
                return;
            }
            const canvasEl = container.canvas.element;
            if (this._resizeObserver && !add) {
                if (canvasEl) this._resizeObserver.unobserve(canvasEl);
                this._resizeObserver.disconnect();
                delete this._resizeObserver;
            } else if (!this._resizeObserver && add && canvasEl) {
                this._resizeObserver = new ResizeObserver(async (entries)=>{
                    const entry = entries.find((e)=>e.target === canvasEl);
                    if (!entry) return;
                    await this._handleWindowResize();
                });
                this._resizeObserver.observe(canvasEl);
            }
        };
        this._mouseDown = ()=>{
            const { interactivity: interactivity } = this.container;
            if (!interactivity) return;
            const { mouse: mouse } = interactivity;
            mouse.clicking = true;
            mouse.downPosition = mouse.position;
        };
        this._mouseTouchClick = (e)=>{
            const container = this.container, options = container.actualOptions, { mouse: mouse } = container.interactivity;
            mouse.inside = true;
            let handled = false;
            const mousePosition = mouse.position;
            if (!mousePosition || !options.interactivity.events.onClick.enable) return;
            for (const [, plugin] of container.plugins){
                if (!plugin.clickPositionValid) continue;
                handled = plugin.clickPositionValid(mousePosition);
                if (handled) break;
            }
            if (!handled) this._doMouseTouchClick(e);
            mouse.clicking = false;
        };
        this._mouseTouchFinish = ()=>{
            const interactivity = this.container.interactivity;
            if (!interactivity) return;
            const mouse = interactivity.mouse;
            delete mouse.position;
            delete mouse.clickPosition;
            delete mouse.downPosition;
            interactivity.status = (0, $9f7790cd505e6a79$export$f4b184a85a586f8a);
            mouse.inside = false;
            mouse.clicking = false;
        };
        this._mouseTouchMove = (e)=>{
            const container = this.container, options = container.actualOptions, interactivity = container.interactivity, canvasEl = container.canvas.element;
            if (!interactivity || !interactivity.element) return;
            interactivity.mouse.inside = true;
            let pos;
            if (e.type.startsWith("pointer")) {
                this._canPush = true;
                const mouseEvent = e;
                if (interactivity.element === window) {
                    if (canvasEl) {
                        const clientRect = canvasEl.getBoundingClientRect();
                        pos = {
                            x: mouseEvent.clientX - clientRect.left,
                            y: mouseEvent.clientY - clientRect.top
                        };
                    }
                } else if (options.interactivity.detectsOn === "parent") {
                    const source = mouseEvent.target, target = mouseEvent.currentTarget;
                    if (source && target && canvasEl) {
                        const sourceRect = source.getBoundingClientRect(), targetRect = target.getBoundingClientRect(), canvasRect = canvasEl.getBoundingClientRect();
                        pos = {
                            x: mouseEvent.offsetX + 2 * sourceRect.left - (targetRect.left + canvasRect.left),
                            y: mouseEvent.offsetY + 2 * sourceRect.top - (targetRect.top + canvasRect.top)
                        };
                    } else pos = {
                        x: mouseEvent.offsetX ?? mouseEvent.clientX,
                        y: mouseEvent.offsetY ?? mouseEvent.clientY
                    };
                } else if (mouseEvent.target === canvasEl) pos = {
                    x: mouseEvent.offsetX ?? mouseEvent.clientX,
                    y: mouseEvent.offsetY ?? mouseEvent.clientY
                };
            } else {
                this._canPush = e.type !== "touchmove";
                if (canvasEl) {
                    const touchEvent = e, lastTouch = touchEvent.touches[touchEvent.touches.length - 1], canvasRect = canvasEl.getBoundingClientRect();
                    pos = {
                        x: lastTouch.clientX - (canvasRect.left ?? 0),
                        y: lastTouch.clientY - (canvasRect.top ?? 0)
                    };
                }
            }
            const pxRatio = container.retina.pixelRatio;
            if (pos) {
                pos.x *= pxRatio;
                pos.y *= pxRatio;
            }
            interactivity.mouse.position = pos;
            interactivity.status = (0, $9f7790cd505e6a79$export$1ffe551d7d33cd33);
        };
        this._touchEnd = (e)=>{
            const evt = e, touches = Array.from(evt.changedTouches);
            for (const touch of touches)this._touches.delete(touch.identifier);
            this._mouseTouchFinish();
        };
        this._touchEndClick = (e)=>{
            const evt = e, touches = Array.from(evt.changedTouches);
            for (const touch of touches)this._touches.delete(touch.identifier);
            this._mouseTouchClick(e);
        };
        this._touchStart = (e)=>{
            const evt = e, touches = Array.from(evt.changedTouches);
            for (const touch of touches)this._touches.set(touch.identifier, performance.now());
            this._mouseTouchMove(e);
        };
        this._canPush = true;
        this._touches = new Map();
        this._handlers = {
            mouseDown: ()=>this._mouseDown(),
            mouseLeave: ()=>this._mouseTouchFinish(),
            mouseMove: (e)=>this._mouseTouchMove(e),
            mouseUp: (e)=>this._mouseTouchClick(e),
            touchStart: (e)=>this._touchStart(e),
            touchMove: (e)=>this._mouseTouchMove(e),
            touchEnd: (e)=>this._touchEnd(e),
            touchCancel: (e)=>this._touchEnd(e),
            touchEndClick: (e)=>this._touchEndClick(e),
            visibilityChange: ()=>this._handleVisibilityChange(),
            themeChange: (e)=>this._handleThemeChange(e),
            oldThemeChange: (e)=>this._handleThemeChange(e),
            resize: ()=>{
                this._handleWindowResize();
            }
        };
    }
    addListeners() {
        this._manageListeners(true);
    }
    removeListeners() {
        this._manageListeners(false);
    }
}




class $67b0362ed7572c6e$export$c2b08aa25660fcaa {
    constructor(){
        this.value = "";
    }
    static create(source, data) {
        const color = new $67b0362ed7572c6e$export$c2b08aa25660fcaa();
        color.load(source);
        if (data !== undefined) {
            if ((0, $ab7d474d755ab51b$export$844ec244b1367d54)(data) || (0, $ab7d474d755ab51b$export$43bee75e5e14138e)(data)) color.load({
                value: data
            });
            else color.load(data);
        }
        return color;
    }
    load(data) {
        if (data?.value === undefined) return;
        this.value = data.value;
    }
}


class $7f8db8c4da47be31$export$668799e4797757a8 {
    constructor(){
        this.color = new (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa)();
        this.color.value = "";
        this.image = "";
        this.position = "";
        this.repeat = "";
        this.size = "";
        this.opacity = 1;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.image !== undefined) this.image = data.image;
        if (data.position !== undefined) this.position = data.position;
        if (data.repeat !== undefined) this.repeat = data.repeat;
        if (data.size !== undefined) this.size = data.size;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}



class $7d911c293f05f260$export$83d45d4584162ec0 {
    constructor(){
        this.color = new (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa)();
        this.color.value = "#fff";
        this.opacity = 1;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}



class $deef64c6aa823051$export$36a2fa1e47ffeebc {
    constructor(){
        this.composite = "destination-out";
        this.cover = new (0, $7d911c293f05f260$export$83d45d4584162ec0)();
        this.enable = false;
    }
    load(data) {
        if (!data) return;
        if (data.composite !== undefined) this.composite = data.composite;
        if (data.cover !== undefined) {
            const cover = data.cover;
            const color = (0, $ab7d474d755ab51b$export$844ec244b1367d54)(data.cover) ? {
                color: data.cover
            } : data.cover;
            this.cover.load(cover.color !== undefined ? cover : {
                color: color
            });
        }
        if (data.enable !== undefined) this.enable = data.enable;
    }
}


class $d80e6a0da33a09c1$export$f885b95b3f0be76d {
    constructor(){
        this.enable = true;
        this.zIndex = 0;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.zIndex !== undefined) this.zIndex = data.zIndex;
    }
}



class $09c5e13e42f489f5$export$8d82f6df2d02cd91 {
    constructor(){
        this.enable = false;
        this.mode = [];
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.mode !== undefined) this.mode = data.mode;
    }
}



class $56f9fabd95198e5a$export$54136f11f358067a {
    constructor(){
        this.selectors = [];
        this.enable = false;
        this.mode = [];
        this.type = "circle";
    }
    get el() {
        return this.elementId;
    }
    set el(value) {
        this.elementId = value;
    }
    get elementId() {
        return this.ids;
    }
    set elementId(value) {
        this.ids = value;
    }
    get ids() {
        return (0, $ab7d474d755ab51b$export$8e5dc47097396754)(this.selectors, (t)=>t.replace("#", ""));
    }
    set ids(value) {
        this.selectors = (0, $ab7d474d755ab51b$export$8e5dc47097396754)(value, (t)=>`#${t}`);
    }
    load(data) {
        if (!data) return;
        const ids = data.ids ?? data.elementId ?? data.el;
        if (ids !== undefined) this.ids = ids;
        if (data.selectors !== undefined) this.selectors = data.selectors;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.type !== undefined) this.type = data.type;
    }
}


class $9045ad35bd30ad9e$export$1bc430945f060dd1 {
    constructor(){
        this.enable = false;
        this.force = 2;
        this.smooth = 10;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.force !== undefined) this.force = data.force;
        if (data.smooth !== undefined) this.smooth = data.smooth;
    }
}


class $b88bc1e4424ffa06$export$2f13ede603111372 {
    constructor(){
        this.enable = false;
        this.mode = [];
        this.parallax = new (0, $9045ad35bd30ad9e$export$1bc430945f060dd1)();
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.mode !== undefined) this.mode = data.mode;
        this.parallax.load(data.parallax);
    }
}


class $3aafade3ab49bdfc$export$4a407cdeed472cd5 {
    constructor(){
        this.delay = 0.5;
        this.enable = true;
    }
    load(data) {
        if (data === undefined) return;
        if (data.delay !== undefined) this.delay = data.delay;
        if (data.enable !== undefined) this.enable = data.enable;
    }
}


class $94c2d6b78ab2304e$export$ada873a34909da65 {
    constructor(){
        this.onClick = new (0, $09c5e13e42f489f5$export$8d82f6df2d02cd91)();
        this.onDiv = new (0, $56f9fabd95198e5a$export$54136f11f358067a)();
        this.onHover = new (0, $b88bc1e4424ffa06$export$2f13ede603111372)();
        this.resize = new (0, $3aafade3ab49bdfc$export$4a407cdeed472cd5)();
    }
    get onclick() {
        return this.onClick;
    }
    set onclick(value) {
        this.onClick = value;
    }
    get ondiv() {
        return this.onDiv;
    }
    set ondiv(value) {
        this.onDiv = value;
    }
    get onhover() {
        return this.onHover;
    }
    set onhover(value) {
        this.onHover = value;
    }
    load(data) {
        if (!data) return;
        this.onClick.load(data.onClick ?? data.onclick);
        const onDiv = data.onDiv ?? data.ondiv;
        if (onDiv !== undefined) this.onDiv = (0, $ab7d474d755ab51b$export$8e5dc47097396754)(onDiv, (t)=>{
            const tmp = new (0, $56f9fabd95198e5a$export$54136f11f358067a)();
            tmp.load(t);
            return tmp;
        });
        this.onHover.load(data.onHover ?? data.onhover);
        if ((0, $ab7d474d755ab51b$export$f9ce7b637dfbe238)(data.resize)) this.resize.enable = data.resize;
        else this.resize.load(data.resize);
    }
}


class $03b54a1f48340609$export$43660d87cb080eb {
    constructor(engine, container){
        this._engine = engine;
        this._container = container;
    }
    load(data) {
        if (!data) return;
        if (!this._container) return;
        const interactors = this._engine.plugins.interactors.get(this._container);
        if (!interactors) return;
        for (const interactor of interactors){
            if (!interactor.loadModeOptions) continue;
            interactor.loadModeOptions(this, data);
        }
    }
}


class $357167fe6330c9ea$export$865458a3ba269c4a {
    constructor(engine, container){
        this.detectsOn = "window";
        this.events = new (0, $94c2d6b78ab2304e$export$ada873a34909da65)();
        this.modes = new (0, $03b54a1f48340609$export$43660d87cb080eb)(engine, container);
    }
    get detect_on() {
        return this.detectsOn;
    }
    set detect_on(value) {
        this.detectsOn = value;
    }
    load(data) {
        if (!data) return;
        const detectsOn = data.detectsOn ?? data.detect_on;
        if (detectsOn !== undefined) this.detectsOn = detectsOn;
        this.events.load(data.events);
        this.modes.load(data.modes);
    }
}



class $4d994646826b3c71$export$4f41a3ab9fa8cdf {
    load(data) {
        if (!data) return;
        if (data.position) this.position = {
            x: data.position.x ?? 50,
            y: data.position.y ?? 50,
            mode: data.position.mode ?? "percent"
        };
        if (data.options) this.options = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)({}, data.options);
    }
}



class $351496b1f97dd6f8$export$49b67f1c7ac91d9b {
    constructor(){
        this.maxWidth = Infinity;
        this.options = {};
        this.mode = "canvas";
    }
    load(data) {
        if (!data) return;
        if (data.maxWidth !== undefined) this.maxWidth = data.maxWidth;
        if (data.mode !== undefined) {
            if (data.mode === "screen") this.mode = "screen";
            else this.mode = "canvas";
        }
        if (data.options !== undefined) this.options = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)({}, data.options);
    }
}


class $c8502e8c8e73685c$export$4bc81bcab6354024 {
    constructor(){
        this.auto = false;
        this.mode = "any";
        this.value = false;
    }
    load(data) {
        if (!data) return;
        if (data.auto !== undefined) this.auto = data.auto;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.value !== undefined) this.value = data.value;
    }
}



class $f970ed02f948f8d9$export$14faa19a0f3bbeb2 {
    constructor(){
        this.name = "";
        this.default = new (0, $c8502e8c8e73685c$export$4bc81bcab6354024)();
    }
    load(data) {
        if (!data) return;
        if (data.name !== undefined) this.name = data.name;
        this.default.load(data.default);
        if (data.options !== undefined) this.options = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)({}, data.options);
    }
}





class $e3d6a23860df79e1$export$3cc8aa7a0c621de0 {
    constructor(){
        this.count = 0;
        this.enable = false;
        this.offset = 0;
        this.speed = 1;
        this.delay = 0;
        this.decay = 0;
        this.sync = true;
    }
    load(data) {
        if (!data) return;
        if (data.count !== undefined) this.count = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.count);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.offset !== undefined) this.offset = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.offset);
        if (data.speed !== undefined) this.speed = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.speed);
        if (data.decay !== undefined) this.decay = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.decay);
        if (data.delay !== undefined) this.delay = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.delay);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}


class $fd581362e639ce75$export$b4c56f18acc5f2f4 {
    constructor(){
        this.h = new (0, $e3d6a23860df79e1$export$3cc8aa7a0c621de0)();
        this.s = new (0, $e3d6a23860df79e1$export$3cc8aa7a0c621de0)();
        this.l = new (0, $e3d6a23860df79e1$export$3cc8aa7a0c621de0)();
    }
    load(data) {
        if (!data) return;
        this.h.load(data.h);
        this.s.load(data.s);
        this.l.load(data.l);
    }
}



class $8bb543fb93ff69a6$export$6f79b6ff75533155 extends (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa) {
    constructor(){
        super();
        this.animation = new (0, $fd581362e639ce75$export$b4c56f18acc5f2f4)();
    }
    static create(source, data) {
        const color = new $8bb543fb93ff69a6$export$6f79b6ff75533155();
        color.load(source);
        if (data !== undefined) {
            if ((0, $ab7d474d755ab51b$export$844ec244b1367d54)(data) || (0, $ab7d474d755ab51b$export$43bee75e5e14138e)(data)) color.load({
                value: data
            });
            else color.load(data);
        }
        return color;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        const colorAnimation = data.animation;
        if (colorAnimation !== undefined) {
            if (colorAnimation.enable !== undefined) this.animation.h.load(colorAnimation);
            else this.animation.load(data.animation);
        }
    }
}


class $297c9e9dba74152a$export$dbafb70800ee3f9b {
    constructor(){
        this.speed = 2;
    }
    load(data) {
        if (!data) return;
        if (data.speed !== undefined) this.speed = data.speed;
    }
}


class $5345678dec3e0281$export$7dac291125fc16da {
    constructor(){
        this.enable = true;
        this.retries = 0;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.retries !== undefined) this.retries = data.retries;
    }
}



class $79e06715390c5229$export$e293c31e7176ae39 {
    constructor(){
        this.count = 0;
        this.enable = false;
        this.speed = 1;
        this.decay = 0;
        this.delay = 0;
        this.sync = false;
    }
    load(data) {
        if (!data) return;
        if (data.count !== undefined) this.count = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.count);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) this.speed = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.speed);
        if (data.decay !== undefined) this.decay = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.decay);
        if (data.delay !== undefined) this.delay = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.delay);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}
class $79e06715390c5229$export$664e182a9c83d6f5 extends $79e06715390c5229$export$e293c31e7176ae39 {
    constructor(){
        super();
        this.mode = "auto";
        this.startValue = "random";
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.minimumValue !== undefined) this.minimumValue = data.minimumValue;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.startValue !== undefined) this.startValue = data.startValue;
    }
}


class $2e459965b04e8869$export$a92776769f460054 {
    constructor(){
        this.enable = false;
        this.minimumValue = 0;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.minimumValue !== undefined) this.minimumValue = data.minimumValue;
    }
}




class $7502aa7b9e2abdb4$export$2f74c042fca0b66d {
    constructor(){
        this.random = new (0, $2e459965b04e8869$export$a92776769f460054)();
        this.value = 0;
    }
    load(data) {
        if (!data) return;
        if ((0, $ab7d474d755ab51b$export$f9ce7b637dfbe238)(data.random)) this.random.enable = data.random;
        else this.random.load(data.random);
        if (data.value !== undefined) this.value = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.value, this.random.enable ? this.random.minimumValue : undefined);
    }
}
class $7502aa7b9e2abdb4$export$a0fda83b6e14e586 extends $7502aa7b9e2abdb4$export$2f74c042fca0b66d {
    constructor(){
        super();
        this.animation = new (0, $79e06715390c5229$export$e293c31e7176ae39)();
    }
    get anim() {
        return this.animation;
    }
    set anim(value) {
        this.animation = value;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        const animation = data.animation ?? data.anim;
        if (animation !== undefined) this.animation.load(animation);
    }
}
class $7502aa7b9e2abdb4$export$8d0da1142c209427 extends $7502aa7b9e2abdb4$export$a0fda83b6e14e586 {
    constructor(){
        super();
        this.animation = new (0, $79e06715390c5229$export$664e182a9c83d6f5)();
    }
    load(data) {
        super.load(data);
        if (!data) return;
        const animation = data.animation ?? data.anim;
        if (animation !== undefined) this.value = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(this.value, this.animation.enable ? this.animation.minimumValue : undefined);
    }
}


class $80dee0a76cce12c6$export$855823db9a0085c extends (0, $7502aa7b9e2abdb4$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.random.minimumValue = 0.1;
        this.value = 1;
    }
}


class $072464e1d12c3ca8$export$e6dd54c89cd6ac88 {
    constructor(){
        this.horizontal = new (0, $80dee0a76cce12c6$export$855823db9a0085c)();
        this.vertical = new (0, $80dee0a76cce12c6$export$855823db9a0085c)();
    }
    load(data) {
        if (!data) return;
        this.horizontal.load(data.horizontal);
        this.vertical.load(data.vertical);
    }
}



class $4c9dc7c1c2929a87$export$97ff58b0eb9a5ed0 {
    constructor(){
        this.absorb = new (0, $297c9e9dba74152a$export$dbafb70800ee3f9b)();
        this.bounce = new (0, $072464e1d12c3ca8$export$e6dd54c89cd6ac88)();
        this.enable = false;
        this.maxSpeed = 50;
        this.mode = "bounce";
        this.overlap = new (0, $5345678dec3e0281$export$7dac291125fc16da)();
    }
    load(data) {
        if (!data) return;
        this.absorb.load(data.absorb);
        this.bounce.load(data.bounce);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.maxSpeed !== undefined) this.maxSpeed = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.maxSpeed);
        if (data.mode !== undefined) this.mode = data.mode;
        this.overlap.load(data.overlap);
    }
}




class $7c25223e3eded3e0$export$128f6c8d329dc399 {
    constructor(){
        this.offset = 0;
        this.value = 90;
    }
    load(data) {
        if (!data) return;
        if (data.offset !== undefined) this.offset = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.offset);
        if (data.value !== undefined) this.value = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.value);
    }
}



class $35c5f580057daa41$export$6c54633883102b4b {
    constructor(){
        this.distance = 200;
        this.enable = false;
        this.rotate = {
            x: 3000,
            y: 3000
        };
    }
    get rotateX() {
        return this.rotate.x;
    }
    set rotateX(value) {
        this.rotate.x = value;
    }
    get rotateY() {
        return this.rotate.y;
    }
    set rotateY(value) {
        this.rotate.y = value;
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.distance);
        if (data.enable !== undefined) this.enable = data.enable;
        const rotateX = data.rotate?.x ?? data.rotateX;
        if (rotateX !== undefined) this.rotate.x = rotateX;
        const rotateY = data.rotate?.y ?? data.rotateY;
        if (rotateY !== undefined) this.rotate.y = rotateY;
    }
}


class $37e3b07013502279$export$7b60622f06eeec06 {
    constructor(){
        this.x = 50;
        this.y = 50;
        this.mode = "percent";
        this.radius = 0;
    }
    load(data) {
        if (!data) return;
        if (data.x !== undefined) this.x = data.x;
        if (data.y !== undefined) this.y = data.y;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.radius !== undefined) this.radius = data.radius;
    }
}



class $759d11b3bdea45bc$export$c6d1f1b3593b164c {
    constructor(){
        this.acceleration = 9.81;
        this.enable = false;
        this.inverse = false;
        this.maxSpeed = 50;
    }
    load(data) {
        if (!data) return;
        if (data.acceleration !== undefined) this.acceleration = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.acceleration);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.inverse !== undefined) this.inverse = data.inverse;
        if (data.maxSpeed !== undefined) this.maxSpeed = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.maxSpeed);
    }
}




class $b772b85ca507c311$export$bcc70636a6a97e73 {
    constructor(){
        this.clamp = true;
        this.delay = new (0, $7502aa7b9e2abdb4$export$2f74c042fca0b66d)();
        this.enable = false;
        this.options = {};
    }
    load(data) {
        if (!data) return;
        if (data.clamp !== undefined) this.clamp = data.clamp;
        this.delay.load(data.delay);
        if (data.enable !== undefined) this.enable = data.enable;
        this.generator = data.generator;
        if (data.options) this.options = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)(this.options, data.options);
    }
}



class $843d4cc52b82fef6$export$7518c5bd39f0f31a {
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.image !== undefined) this.image = data.image;
    }
}


class $0c93200c47c4fa63$export$e428bb3fcf53809d {
    constructor(){
        this.enable = false;
        this.length = 10;
        this.fill = new (0, $843d4cc52b82fef6$export$7518c5bd39f0f31a)();
    }
    get fillColor() {
        return this.fill.color;
    }
    set fillColor(value) {
        this.fill.load({
            color: value
        });
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.fill !== undefined || data.fillColor !== undefined) this.fill.load(data.fill || {
            color: data.fillColor
        });
        if (data.length !== undefined) this.length = data.length;
    }
}


class $00d557b4c994fa41$export$647cf31ffff2d3 {
    constructor(){
        this.default = "out";
    }
    load(data) {
        if (!data) return;
        if (data.default !== undefined) this.default = data.default;
        this.bottom = data.bottom ?? data.default;
        this.left = data.left ?? data.default;
        this.right = data.right ?? data.default;
        this.top = data.top ?? data.default;
    }
}




class $15ac73e67e1256b0$export$fcd783eeafc305c0 {
    constructor(){
        this.acceleration = 0;
        this.enable = false;
    }
    load(data) {
        if (!data) return;
        if (data.acceleration !== undefined) this.acceleration = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.acceleration);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.position) this.position = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)({}, data.position);
    }
}



class $d2856c74717219ba$export$e49a5ad3dd6df925 {
    constructor(){
        this.angle = new (0, $7c25223e3eded3e0$export$128f6c8d329dc399)();
        this.attract = new (0, $35c5f580057daa41$export$6c54633883102b4b)();
        this.center = new (0, $37e3b07013502279$export$7b60622f06eeec06)();
        this.decay = 0;
        this.distance = {};
        this.direction = "none";
        this.drift = 0;
        this.enable = false;
        this.gravity = new (0, $759d11b3bdea45bc$export$c6d1f1b3593b164c)();
        this.path = new (0, $b772b85ca507c311$export$bcc70636a6a97e73)();
        this.outModes = new (0, $00d557b4c994fa41$export$647cf31ffff2d3)();
        this.random = false;
        this.size = false;
        this.speed = 2;
        this.spin = new (0, $15ac73e67e1256b0$export$fcd783eeafc305c0)();
        this.straight = false;
        this.trail = new (0, $0c93200c47c4fa63$export$e428bb3fcf53809d)();
        this.vibrate = false;
        this.warp = false;
    }
    get bounce() {
        return this.collisions;
    }
    set bounce(value) {
        this.collisions = value;
    }
    get collisions() {
        return false;
    }
    set collisions(_) {}
    get noise() {
        return this.path;
    }
    set noise(value) {
        this.path = value;
    }
    get outMode() {
        return this.outModes.default;
    }
    set outMode(value) {
        this.outModes.default = value;
    }
    get out_mode() {
        return this.outMode;
    }
    set out_mode(value) {
        this.outMode = value;
    }
    load(data) {
        if (!data) return;
        this.angle.load((0, $ab7d474d755ab51b$export$7e4aa119212bc614)(data.angle) ? {
            value: data.angle
        } : data.angle);
        this.attract.load(data.attract);
        this.center.load(data.center);
        if (data.decay !== undefined) this.decay = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.decay);
        if (data.direction !== undefined) this.direction = data.direction;
        if (data.distance !== undefined) this.distance = (0, $ab7d474d755ab51b$export$7e4aa119212bc614)(data.distance) ? {
            horizontal: data.distance,
            vertical: data.distance
        } : {
            ...data.distance
        };
        if (data.drift !== undefined) this.drift = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.drift);
        if (data.enable !== undefined) this.enable = data.enable;
        this.gravity.load(data.gravity);
        const outModes = data.outModes ?? data.outMode ?? data.out_mode;
        if (outModes !== undefined) {
            if ((0, $ab7d474d755ab51b$export$a6cdc56e425d0d0a)(outModes)) this.outModes.load(outModes);
            else this.outModes.load({
                default: outModes
            });
        }
        this.path.load(data.path ?? data.noise);
        if (data.random !== undefined) this.random = data.random;
        if (data.size !== undefined) this.size = data.size;
        if (data.speed !== undefined) this.speed = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.speed);
        this.spin.load(data.spin);
        if (data.straight !== undefined) this.straight = data.straight;
        this.trail.load(data.trail);
        if (data.vibrate !== undefined) this.vibrate = data.vibrate;
        if (data.warp !== undefined) this.warp = data.warp;
    }
}



class $bad9e65fb4c7eb73$export$3e55dc49e2356209 extends (0, $79e06715390c5229$export$664e182a9c83d6f5) {
    constructor(){
        super();
        this.destroy = "none";
        this.speed = 2;
    }
    get opacity_min() {
        return this.minimumValue;
    }
    set opacity_min(value) {
        this.minimumValue = value;
    }
    load(data) {
        if (data?.opacity_min !== undefined && data.minimumValue === undefined) data.minimumValue = data.opacity_min;
        super.load(data);
        if (!data) return;
        if (data.destroy !== undefined) this.destroy = data.destroy;
    }
}




class $598c48e3ab76b06d$export$588760baa0f6108e extends (0, $7502aa7b9e2abdb4$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.animation = new (0, $bad9e65fb4c7eb73$export$3e55dc49e2356209)();
        this.random.minimumValue = 0.1;
        this.value = 1;
    }
    get anim() {
        return this.animation;
    }
    set anim(value) {
        this.animation = value;
    }
    load(data) {
        if (!data) return;
        super.load(data);
        const animation = data.animation ?? data.anim;
        if (animation !== undefined) {
            this.animation.load(animation);
            this.value = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(this.value, this.animation.enable ? this.animation.minimumValue : undefined);
        }
    }
}



class $3649684ad93eb6fd$export$c11b1f56b7022ac8 {
    constructor(){
        this.enable = false;
        this.width = 1920;
        this.height = 1080;
    }
    get area() {
        return this.width;
    }
    set area(value) {
        this.width = value;
    }
    get factor() {
        return this.height;
    }
    set factor(value) {
        this.height = value;
    }
    get value_area() {
        return this.area;
    }
    set value_area(value) {
        this.area = value;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        const width = data.width ?? data.area ?? data.value_area;
        if (width !== undefined) this.width = width;
        const height = data.height ?? data.factor;
        if (height !== undefined) this.height = height;
    }
}


class $cff128ab056d19fb$export$2335cf7e85f36cfd {
    constructor(){
        this.density = new (0, $3649684ad93eb6fd$export$c11b1f56b7022ac8)();
        this.limit = 0;
        this.value = 0;
    }
    get max() {
        return this.limit;
    }
    set max(value) {
        this.limit = value;
    }
    load(data) {
        if (!data) return;
        this.density.load(data.density);
        const limit = data.limit ?? data.max;
        if (limit !== undefined) this.limit = limit;
        if (data.value !== undefined) this.value = data.value;
    }
}



class $6153b9a337f78104$export$a24c14443968327c {
    constructor(){
        this.blur = 0;
        this.color = new (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa)();
        this.enable = false;
        this.offset = {
            x: 0,
            y: 0
        };
        this.color.value = "#000";
    }
    load(data) {
        if (!data) return;
        if (data.blur !== undefined) this.blur = data.blur;
        this.color = (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.offset === undefined) return;
        if (data.offset.x !== undefined) this.offset.x = data.offset.x;
        if (data.offset.y !== undefined) this.offset.y = data.offset.y;
    }
}



const $2dca2bf5db12842f$var$charKey = "character", $2dca2bf5db12842f$var$charAltKey = "char", $2dca2bf5db12842f$var$imageKey = "image", $2dca2bf5db12842f$var$imageAltKey = "images", $2dca2bf5db12842f$var$polygonKey = "polygon", $2dca2bf5db12842f$var$polygonAltKey = "star";
class $2dca2bf5db12842f$export$6428a7f2611ef1fa {
    constructor(){
        this.loadShape = (item, mainKey, altKey, altOverride)=>{
            if (!item) return;
            const itemIsArray = (0, $ab7d474d755ab51b$export$43bee75e5e14138e)(item), emptyValue = itemIsArray ? [] : {}, mainDifferentValues = itemIsArray !== (0, $ab7d474d755ab51b$export$43bee75e5e14138e)(this.options[mainKey]), altDifferentValues = itemIsArray !== (0, $ab7d474d755ab51b$export$43bee75e5e14138e)(this.options[altKey]);
            if (mainDifferentValues) this.options[mainKey] = emptyValue;
            if (altDifferentValues && altOverride) this.options[altKey] = emptyValue;
            this.options[mainKey] = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)(this.options[mainKey] ?? emptyValue, item);
            if (!this.options[altKey] || altOverride) this.options[altKey] = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)(this.options[altKey] ?? emptyValue, item);
        };
        this.close = true;
        this.fill = true;
        this.options = {};
        this.type = "circle";
    }
    get character() {
        return this.options[$2dca2bf5db12842f$var$charKey] ?? this.options[$2dca2bf5db12842f$var$charAltKey];
    }
    set character(value) {
        this.options[$2dca2bf5db12842f$var$charAltKey] = this.options[$2dca2bf5db12842f$var$charKey] = value;
    }
    get custom() {
        return this.options;
    }
    set custom(value) {
        this.options = value;
    }
    get image() {
        return this.options[$2dca2bf5db12842f$var$imageKey] ?? this.options[$2dca2bf5db12842f$var$imageAltKey];
    }
    set image(value) {
        this.options[$2dca2bf5db12842f$var$imageAltKey] = this.options[$2dca2bf5db12842f$var$imageKey] = value;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
    get polygon() {
        return this.options[$2dca2bf5db12842f$var$polygonKey] ?? this.options[$2dca2bf5db12842f$var$polygonAltKey];
    }
    set polygon(value) {
        this.options[$2dca2bf5db12842f$var$polygonAltKey] = this.options[$2dca2bf5db12842f$var$polygonKey] = value;
    }
    get stroke() {
        return [];
    }
    set stroke(_value) {}
    load(data) {
        if (!data) return;
        const options = data.options ?? data.custom;
        if (options !== undefined) for(const shape in options){
            const item = options[shape];
            if (item) this.options[shape] = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)(this.options[shape] ?? {}, item);
        }
        this.loadShape(data.character, $2dca2bf5db12842f$var$charKey, $2dca2bf5db12842f$var$charAltKey, true);
        this.loadShape(data.polygon, $2dca2bf5db12842f$var$polygonKey, $2dca2bf5db12842f$var$polygonAltKey, false);
        this.loadShape(data.image ?? data.images, $2dca2bf5db12842f$var$imageKey, $2dca2bf5db12842f$var$imageAltKey, true);
        if (data.close !== undefined) this.close = data.close;
        if (data.fill !== undefined) this.fill = data.fill;
        if (data.type !== undefined) this.type = data.type;
    }
}



class $8e56455185b43bab$export$231e08f1693c0669 extends (0, $79e06715390c5229$export$664e182a9c83d6f5) {
    constructor(){
        super();
        this.destroy = "none";
        this.speed = 5;
    }
    get size_min() {
        return this.minimumValue;
    }
    set size_min(value) {
        this.minimumValue = value;
    }
    load(data) {
        if (data?.size_min !== undefined && data.minimumValue === undefined) data.minimumValue = data.size_min;
        super.load(data);
        if (!data) return;
        if (data.destroy !== undefined) this.destroy = data.destroy;
    }
}




class $ff2d523548a49b8c$export$cb6da89c6af1a8ec extends (0, $7502aa7b9e2abdb4$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.animation = new (0, $8e56455185b43bab$export$231e08f1693c0669)();
        this.random.minimumValue = 1;
        this.value = 3;
    }
    get anim() {
        return this.animation;
    }
    set anim(value) {
        this.animation = value;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        const animation = data.animation ?? data.anim;
        if (animation !== undefined) {
            this.animation.load(animation);
            this.value = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(this.value, this.animation.enable ? this.animation.minimumValue : undefined);
        }
    }
}




class $83d59d88d8951fba$export$18d19c7a3aa33064 {
    constructor(){
        this.width = 0;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $8bb543fb93ff69a6$export$6f79b6ff75533155).create(this.color, data.color);
        if (data.width !== undefined) this.width = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.width);
        if (data.opacity !== undefined) this.opacity = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.opacity);
    }
}



class $174094d16b5b0873$export$ccb31788083e2069 extends (0, $7502aa7b9e2abdb4$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.opacityRate = 1;
        this.sizeRate = 1;
        this.velocityRate = 1;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.opacityRate !== undefined) this.opacityRate = data.opacityRate;
        if (data.sizeRate !== undefined) this.sizeRate = data.sizeRate;
        if (data.velocityRate !== undefined) this.velocityRate = data.velocityRate;
    }
}


class $ea1a83241c5b3c26$export$b4f1619131f0bce9 {
    constructor(engine, container){
        this._engine = engine;
        this._container = container;
        this.bounce = new (0, $072464e1d12c3ca8$export$e6dd54c89cd6ac88)();
        this.collisions = new (0, $4c9dc7c1c2929a87$export$97ff58b0eb9a5ed0)();
        this.color = new (0, $8bb543fb93ff69a6$export$6f79b6ff75533155)();
        this.color.value = "#fff";
        this.groups = {};
        this.move = new (0, $d2856c74717219ba$export$e49a5ad3dd6df925)();
        this.number = new (0, $cff128ab056d19fb$export$2335cf7e85f36cfd)();
        this.opacity = new (0, $598c48e3ab76b06d$export$588760baa0f6108e)();
        this.reduceDuplicates = false;
        this.shadow = new (0, $6153b9a337f78104$export$a24c14443968327c)();
        this.shape = new (0, $2dca2bf5db12842f$export$6428a7f2611ef1fa)();
        this.size = new (0, $ff2d523548a49b8c$export$cb6da89c6af1a8ec)();
        this.stroke = new (0, $83d59d88d8951fba$export$18d19c7a3aa33064)();
        this.zIndex = new (0, $174094d16b5b0873$export$ccb31788083e2069)();
    }
    load(data) {
        if (!data) return;
        this.bounce.load(data.bounce);
        this.color.load((0, $8bb543fb93ff69a6$export$6f79b6ff75533155).create(this.color, data.color));
        if (data.groups !== undefined) for(const group in data.groups){
            const item = data.groups[group];
            if (item !== undefined) this.groups[group] = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)(this.groups[group] ?? {}, item);
        }
        this.move.load(data.move);
        this.number.load(data.number);
        this.opacity.load(data.opacity);
        if (data.reduceDuplicates !== undefined) this.reduceDuplicates = data.reduceDuplicates;
        this.shape.load(data.shape);
        this.size.load(data.size);
        this.shadow.load(data.shadow);
        this.zIndex.load(data.zIndex);
        const collisions = data.move?.collisions ?? data.move?.bounce;
        if (collisions !== undefined) this.collisions.enable = collisions;
        this.collisions.load(data.collisions);
        if (data.interactivity !== undefined) this.interactivity = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)({}, data.interactivity);
        const strokeToLoad = data.stroke ?? data.shape?.stroke;
        if (strokeToLoad) this.stroke = (0, $ab7d474d755ab51b$export$8e5dc47097396754)(strokeToLoad, (t)=>{
            const tmp = new (0, $83d59d88d8951fba$export$18d19c7a3aa33064)();
            tmp.load(t);
            return tmp;
        });
        if (this._container) {
            const updaters = this._engine.plugins.updaters.get(this._container);
            if (updaters) {
                for (const updater of updaters)if (updater.loadOptions) updater.loadOptions(this, data);
            }
            const interactors = this._engine.plugins.interactors.get(this._container);
            if (interactors) {
                for (const interactor of interactors)if (interactor.loadParticlesOptions) interactor.loadParticlesOptions(this, data);
            }
        }
    }
}


function $5364e7fd152e0675$export$cad72087bded938(options, ...sourceOptionsArr) {
    for (const sourceOptions of sourceOptionsArr)options.load(sourceOptions);
}
function $5364e7fd152e0675$export$3e14721506027822(engine, container, ...sourceOptionsArr) {
    const options = new (0, $ea1a83241c5b3c26$export$b4f1619131f0bce9)(engine, container);
    $5364e7fd152e0675$export$cad72087bded938(options, ...sourceOptionsArr);
    return options;
}



class $a879bdf3c5a56bcb$export$c019608e5b5bb4cb {
    constructor(engine, container){
        this._findDefaultTheme = (mode)=>{
            return this.themes.find((theme)=>theme.default.value && theme.default.mode === mode) ?? this.themes.find((theme)=>theme.default.value && theme.default.mode === "any");
        };
        this._importPreset = (preset)=>{
            this.load(this._engine.plugins.getPreset(preset));
        };
        this._engine = engine;
        this._container = container;
        this.autoPlay = true;
        this.background = new (0, $7f8db8c4da47be31$export$668799e4797757a8)();
        this.backgroundMask = new (0, $deef64c6aa823051$export$36a2fa1e47ffeebc)();
        this.defaultThemes = {};
        this.delay = 0;
        this.fullScreen = new (0, $d80e6a0da33a09c1$export$f885b95b3f0be76d)();
        this.detectRetina = true;
        this.duration = 0;
        this.fpsLimit = 120;
        this.interactivity = new (0, $357167fe6330c9ea$export$865458a3ba269c4a)(engine, container);
        this.manualParticles = [];
        this.particles = (0, $5364e7fd152e0675$export$3e14721506027822)(this._engine, this._container);
        this.pauseOnBlur = true;
        this.pauseOnOutsideViewport = true;
        this.responsive = [];
        this.smooth = false;
        this.style = {};
        this.themes = [];
        this.zLayers = 100;
    }
    get backgroundMode() {
        return this.fullScreen;
    }
    set backgroundMode(value) {
        this.fullScreen.load(value);
    }
    get fps_limit() {
        return this.fpsLimit;
    }
    set fps_limit(value) {
        this.fpsLimit = value;
    }
    get retina_detect() {
        return this.detectRetina;
    }
    set retina_detect(value) {
        this.detectRetina = value;
    }
    load(data) {
        if (!data) return;
        if (data.preset !== undefined) (0, $ab7d474d755ab51b$export$8e5dc47097396754)(data.preset, (preset)=>this._importPreset(preset));
        if (data.autoPlay !== undefined) this.autoPlay = data.autoPlay;
        if (data.delay !== undefined) this.delay = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.delay);
        const detectRetina = data.detectRetina ?? data.retina_detect;
        if (detectRetina !== undefined) this.detectRetina = detectRetina;
        if (data.duration !== undefined) this.duration = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.duration);
        const fpsLimit = data.fpsLimit ?? data.fps_limit;
        if (fpsLimit !== undefined) this.fpsLimit = fpsLimit;
        if (data.pauseOnBlur !== undefined) this.pauseOnBlur = data.pauseOnBlur;
        if (data.pauseOnOutsideViewport !== undefined) this.pauseOnOutsideViewport = data.pauseOnOutsideViewport;
        if (data.zLayers !== undefined) this.zLayers = data.zLayers;
        this.background.load(data.background);
        const fullScreen = data.fullScreen ?? data.backgroundMode;
        if ((0, $ab7d474d755ab51b$export$f9ce7b637dfbe238)(fullScreen)) this.fullScreen.enable = fullScreen;
        else this.fullScreen.load(fullScreen);
        this.backgroundMask.load(data.backgroundMask);
        this.interactivity.load(data.interactivity);
        if (data.manualParticles) this.manualParticles = data.manualParticles.map((t)=>{
            const tmp = new (0, $4d994646826b3c71$export$4f41a3ab9fa8cdf)();
            tmp.load(t);
            return tmp;
        });
        this.particles.load(data.particles);
        this.style = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)(this.style, data.style);
        this._engine.plugins.loadOptions(this, data);
        if (data.smooth !== undefined) this.smooth = data.smooth;
        const interactors = this._engine.plugins.interactors.get(this._container);
        if (interactors) {
            for (const interactor of interactors)if (interactor.loadOptions) interactor.loadOptions(this, data);
        }
        if (data.responsive !== undefined) for (const responsive of data.responsive){
            const optResponsive = new (0, $351496b1f97dd6f8$export$49b67f1c7ac91d9b)();
            optResponsive.load(responsive);
            this.responsive.push(optResponsive);
        }
        this.responsive.sort((a, b)=>a.maxWidth - b.maxWidth);
        if (data.themes !== undefined) for (const theme of data.themes){
            const existingTheme = this.themes.find((t)=>t.name === theme.name);
            if (!existingTheme) {
                const optTheme = new (0, $f970ed02f948f8d9$export$14faa19a0f3bbeb2)();
                optTheme.load(theme);
                this.themes.push(optTheme);
            } else existingTheme.load(theme);
        }
        this.defaultThemes.dark = this._findDefaultTheme("dark")?.name;
        this.defaultThemes.light = this._findDefaultTheme("light")?.name;
    }
    setResponsive(width, pxRatio, defaultOptions) {
        this.load(defaultOptions);
        const responsiveOptions = this.responsive.find((t)=>t.mode === "screen" && screen ? t.maxWidth > screen.availWidth : t.maxWidth * pxRatio > width);
        this.load(responsiveOptions?.options);
        return responsiveOptions?.maxWidth;
    }
    setTheme(name) {
        if (name) {
            const chosenTheme = this.themes.find((theme)=>theme.name === name);
            if (chosenTheme) this.load(chosenTheme.options);
        } else {
            const mediaMatch = (0, $ab7d474d755ab51b$export$db32b9574e21e00f)("(prefers-color-scheme: dark)"), clientDarkMode = mediaMatch && mediaMatch.matches, defaultTheme = this._findDefaultTheme(clientDarkMode ? "dark" : "light");
            if (defaultTheme) this.load(defaultTheme.options);
        }
    }
}



class $9447ca068c953476$export$aaa80641d584351c {
    constructor(engine, container){
        this.container = container;
        this._engine = engine;
        this._interactors = engine.plugins.getInteractors(this.container, true);
        this._externalInteractors = [];
        this._particleInteractors = [];
    }
    async externalInteract(delta) {
        for (const interactor of this._externalInteractors)interactor.isEnabled() && await interactor.interact(delta);
    }
    handleClickMode(mode) {
        for (const interactor of this._externalInteractors)interactor.handleClickMode && interactor.handleClickMode(mode);
    }
    init() {
        this._externalInteractors = [];
        this._particleInteractors = [];
        for (const interactor of this._interactors){
            switch(interactor.type){
                case "external":
                    this._externalInteractors.push(interactor);
                    break;
                case "particles":
                    this._particleInteractors.push(interactor);
                    break;
            }
            interactor.init();
        }
    }
    async particlesInteract(particle, delta) {
        for (const interactor of this._externalInteractors)interactor.clear(particle, delta);
        for (const interactor of this._particleInteractors)interactor.isEnabled(particle) && await interactor.interact(particle, delta);
    }
    async reset(particle) {
        for (const interactor of this._externalInteractors)interactor.isEnabled() && interactor.reset(particle);
        for (const interactor of this._particleInteractors)interactor.isEnabled(particle) && interactor.reset(particle);
    }
}











const $14d3d48c1296b161$var$fixOutMode = (data)=>{
    if (!(0, $ab7d474d755ab51b$export$5e9bb4359042e24b)(data.outMode, data.checkModes)) return;
    const diameter = data.radius * 2;
    if (data.coord > data.maxCoord - diameter) data.setCb(-data.radius);
    else if (data.coord < diameter) data.setCb(data.radius);
};
class $14d3d48c1296b161$export$c36c68baa13912a5 {
    constructor(engine, id, container, position, overrideOptions, group){
        this.container = container;
        this._calcPosition = (container, position, zIndex, tryCount = 0)=>{
            for (const [, plugin] of container.plugins){
                const pluginPos = plugin.particlePosition !== undefined ? plugin.particlePosition(position, this) : undefined;
                if (pluginPos) return (0, $4f7724755777c76d$export$ece015703618ce3d).create(pluginPos.x, pluginPos.y, zIndex);
            }
            const canvasSize = container.canvas.size, exactPosition = (0, $a17cb6ec9e2ec6c9$export$a3c87c98a736c457)({
                size: canvasSize,
                position: position
            }), pos = (0, $4f7724755777c76d$export$ece015703618ce3d).create(exactPosition.x, exactPosition.y, zIndex), radius = this.getRadius(), outModes = this.options.move.outModes, fixHorizontal = (outMode)=>{
                $14d3d48c1296b161$var$fixOutMode({
                    outMode: outMode,
                    checkModes: [
                        "bounce",
                        "bounce-horizontal"
                    ],
                    coord: pos.x,
                    maxCoord: container.canvas.size.width,
                    setCb: (value)=>pos.x += value,
                    radius: radius
                });
            }, fixVertical = (outMode)=>{
                $14d3d48c1296b161$var$fixOutMode({
                    outMode: outMode,
                    checkModes: [
                        "bounce",
                        "bounce-vertical"
                    ],
                    coord: pos.y,
                    maxCoord: container.canvas.size.height,
                    setCb: (value)=>pos.y += value,
                    radius: radius
                });
            };
            fixHorizontal(outModes.left ?? outModes.default);
            fixHorizontal(outModes.right ?? outModes.default);
            fixVertical(outModes.top ?? outModes.default);
            fixVertical(outModes.bottom ?? outModes.default);
            if (this._checkOverlap(pos, tryCount)) return this._calcPosition(container, undefined, zIndex, tryCount + 1);
            return pos;
        };
        this._calculateVelocity = ()=>{
            const baseVelocity = (0, $a17cb6ec9e2ec6c9$export$cce6f12debc4024a)(this.direction), res = baseVelocity.copy(), moveOptions = this.options.move;
            if (moveOptions.direction === "inside" || moveOptions.direction === "outside") return res;
            const rad = Math.PI / 180 * (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(moveOptions.angle.value), radOffset = Math.PI / 180 * (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(moveOptions.angle.offset), range = {
                left: radOffset - rad / 2,
                right: radOffset + rad / 2
            };
            if (!moveOptions.straight) res.angle += (0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)((0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(range.left, range.right));
            if (moveOptions.random && typeof moveOptions.speed === "number") res.length *= (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)();
            return res;
        };
        this._checkOverlap = (pos, tryCount = 0)=>{
            const collisionsOptions = this.options.collisions, radius = this.getRadius();
            if (!collisionsOptions.enable) return false;
            const overlapOptions = collisionsOptions.overlap;
            if (overlapOptions.enable) return false;
            const retries = overlapOptions.retries;
            if (retries >= 0 && tryCount > retries) throw new Error(`${(0, $9f7790cd505e6a79$export$adea4917e02d93dc)} particle is overlapping and can't be placed`);
            return !!this.container.particles.find((particle)=>(0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(pos, particle.position) < radius + particle.getRadius());
        };
        this._getRollColor = (color)=>{
            if (!color || !this.roll || !this.backColor && !this.roll.alter) return color;
            const backFactor = this.roll.horizontal && this.roll.vertical ? 2 : 1, backSum = this.roll.horizontal ? Math.PI / 2 : 0, rolled = Math.floor(((this.roll.angle ?? 0) + backSum) / (Math.PI / backFactor)) % 2;
            if (!rolled) return color;
            if (this.backColor) return this.backColor;
            if (this.roll.alter) return (0, $b69b7cfe4b0de35f$export$fe1d034b0e82666)(color, this.roll.alter.type, this.roll.alter.value);
            return color;
        };
        this._initPosition = (position)=>{
            const container = this.container, zIndexValue = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(this.options.zIndex.value);
            this.position = this._calcPosition(container, position, (0, $a17cb6ec9e2ec6c9$export$7d15b64cf5a3a4c4)(zIndexValue, 0, container.zLayers));
            this.initialPosition = this.position.copy();
            const canvasSize = container.canvas.size;
            this.moveCenter = {
                ...(0, $ab7d474d755ab51b$export$1690e12b840569b9)(this.options.move.center, canvasSize),
                radius: this.options.move.center.radius ?? 0,
                mode: this.options.move.center.mode ?? "percent"
            };
            this.direction = (0, $a17cb6ec9e2ec6c9$export$2045f76df51d18c4)(this.options.move.direction, this.position, this.moveCenter);
            switch(this.options.move.direction){
                case "inside":
                    this.outType = "inside";
                    break;
                case "outside":
                    this.outType = "outside";
                    break;
            }
            this.offset = (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).origin;
        };
        this._loadShapeData = (shapeOptions, reduceDuplicates)=>{
            const shapeData = shapeOptions.options[this.shape];
            if (!shapeData) return;
            return (0, $ab7d474d755ab51b$export$54e9fb29908872fa)({
                close: shapeOptions.close,
                fill: shapeOptions.fill
            }, (0, $ab7d474d755ab51b$export$3fbf39566d3ee62e)(shapeData, this.id, reduceDuplicates));
        };
        this._engine = engine;
        this.init(id, position, overrideOptions, group);
    }
    destroy(override) {
        if (this.unbreakable || this.destroyed) return;
        this.destroyed = true;
        this.bubble.inRange = false;
        this.slow.inRange = false;
        const container = this.container, pathGenerator = this.pathGenerator;
        for (const [, plugin] of container.plugins)if (plugin.particleDestroyed) plugin.particleDestroyed(this, override);
        for (const updater of container.particles.updaters)if (updater.particleDestroyed) updater.particleDestroyed(this, override);
        if (pathGenerator) pathGenerator.reset(this);
    }
    draw(delta) {
        const container = this.container;
        for (const [, plugin] of container.plugins)container.canvas.drawParticlePlugin(plugin, this, delta);
        container.canvas.drawParticle(this, delta);
    }
    getFillColor() {
        return this._getRollColor(this.bubble.color ?? (0, $3b20cd3c058d307c$export$c90768c73bc1d7ab)(this.color));
    }
    getMass() {
        return this.getRadius() ** 2 * Math.PI / 2;
    }
    getPosition() {
        return {
            x: this.position.x + this.offset.x,
            y: this.position.y + this.offset.y,
            z: this.position.z
        };
    }
    getRadius() {
        return this.bubble.radius ?? this.size.value;
    }
    getStrokeColor() {
        return this._getRollColor(this.bubble.color ?? (0, $3b20cd3c058d307c$export$c90768c73bc1d7ab)(this.strokeColor));
    }
    init(id, position, overrideOptions, group) {
        const container = this.container, engine = this._engine;
        this.id = id;
        this.group = group;
        this.fill = true;
        this.pathRotation = false;
        this.close = true;
        this.lastPathTime = 0;
        this.destroyed = false;
        this.unbreakable = false;
        this.rotation = 0;
        this.misplaced = false;
        this.retina = {
            maxDistance: {}
        };
        this.outType = "normal";
        this.ignoresResizeRatio = true;
        const pxRatio = container.retina.pixelRatio, mainOptions = container.actualOptions, particlesOptions = (0, $5364e7fd152e0675$export$3e14721506027822)(this._engine, container, mainOptions.particles), shapeType = particlesOptions.shape.type, { reduceDuplicates: reduceDuplicates } = particlesOptions;
        this.shape = (0, $ab7d474d755ab51b$export$3fbf39566d3ee62e)(shapeType, this.id, reduceDuplicates);
        const shapeOptions = particlesOptions.shape;
        if (overrideOptions && overrideOptions.shape && overrideOptions.shape.type) {
            const overrideShapeType = overrideOptions.shape.type, shape = (0, $ab7d474d755ab51b$export$3fbf39566d3ee62e)(overrideShapeType, this.id, reduceDuplicates);
            if (shape) {
                this.shape = shape;
                shapeOptions.load(overrideOptions.shape);
            }
        }
        this.shapeData = this._loadShapeData(shapeOptions, reduceDuplicates);
        particlesOptions.load(overrideOptions);
        const shapeData = this.shapeData;
        if (shapeData) particlesOptions.load(shapeData.particles);
        const interactivity = new (0, $357167fe6330c9ea$export$865458a3ba269c4a)(engine, container);
        interactivity.load(container.actualOptions.interactivity);
        interactivity.load(particlesOptions.interactivity);
        this.interactivity = interactivity;
        this.fill = shapeData?.fill ?? particlesOptions.shape.fill;
        this.close = shapeData?.close ?? particlesOptions.shape.close;
        this.options = particlesOptions;
        const pathOptions = this.options.move.path;
        this.pathDelay = (0, $a17cb6ec9e2ec6c9$export$bf7199a9ebcb84a9)(pathOptions.delay) * 1000;
        if (pathOptions.generator) {
            this.pathGenerator = this._engine.plugins.getPathGenerator(pathOptions.generator);
            if (this.pathGenerator && container.addPath(pathOptions.generator, this.pathGenerator)) this.pathGenerator.init(container);
        }
        container.retina.initParticle(this);
        this.size = (0, $ab7d474d755ab51b$export$bebd78259cce4fd)(this.options.size, pxRatio);
        this.bubble = {
            inRange: false
        };
        this.slow = {
            inRange: false,
            factor: 1
        };
        this._initPosition(position);
        this.initialVelocity = this._calculateVelocity();
        this.velocity = this.initialVelocity.copy();
        this.moveDecay = 1 - (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(this.options.move.decay);
        const particles = container.particles;
        particles.needsSort = particles.needsSort || particles.lastZIndex < this.position.z;
        particles.lastZIndex = this.position.z;
        this.zIndexFactor = this.position.z / container.zLayers;
        this.sides = 24;
        let drawer = container.drawers.get(this.shape);
        if (!drawer) {
            drawer = this._engine.plugins.getShapeDrawer(this.shape);
            if (drawer) container.drawers.set(this.shape, drawer);
        }
        if (drawer && drawer.loadShape) drawer.loadShape(this);
        const sideCountFunc = drawer?.getSidesCount;
        if (sideCountFunc) this.sides = sideCountFunc(this);
        this.spawning = false;
        this.shadowColor = (0, $3b20cd3c058d307c$export$fbf0bf3cc1fc0cc4)(this.options.shadow.color);
        for (const updater of container.particles.updaters)updater.init(this);
        for (const mover of container.particles.movers)mover.init && mover.init(this);
        if (drawer && drawer.particleInit) drawer.particleInit(container, this);
        for (const [, plugin] of container.plugins)plugin.particleCreated && plugin.particleCreated(this);
    }
    isInsideCanvas() {
        const radius = this.getRadius(), canvasSize = this.container.canvas.size, position = this.position;
        return position.x >= -radius && position.y >= -radius && position.y <= canvasSize.height + radius && position.x <= canvasSize.width + radius;
    }
    isVisible() {
        return !this.destroyed && !this.spawning && this.isInsideCanvas();
    }
    reset() {
        for (const updater of this.container.particles.updaters)updater.reset && updater.reset(this);
    }
}


class $b3a743448af77b04$export$baf26146a414f24a {
    constructor(position, particle){
        this.position = position;
        this.particle = particle;
    }
}


class $7cc5ddf8d7cf0480$export$9a58ef0d7ad3278c {
    constructor(x, y){
        this.position = {
            x: x,
            y: y
        };
    }
}




class $fbaf108f02b30a19$export$4617fb02663045ef extends (0, $7cc5ddf8d7cf0480$export$9a58ef0d7ad3278c) {
    constructor(x, y, width, height){
        super(x, y);
        this.size = {
            height: height,
            width: width
        };
    }
    contains(point) {
        const w = this.size.width, h = this.size.height, pos = this.position;
        return point.x >= pos.x && point.x <= pos.x + w && point.y >= pos.y && point.y <= pos.y + h;
    }
    intersects(range) {
        if (range instanceof (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa)) range.intersects(this);
        const w = this.size.width, h = this.size.height, pos1 = this.position, pos2 = range.position, size2 = range instanceof $fbaf108f02b30a19$export$4617fb02663045ef ? range.size : {
            width: 0,
            height: 0
        }, w2 = size2.width, h2 = size2.height;
        return pos2.x < pos1.x + w && pos2.x + w2 > pos1.x && pos2.y < pos1.y + h && pos2.y + h2 > pos1.y;
    }
}



class $a41a3c6540989ea7$export$c89a927ffc67e6fa extends (0, $7cc5ddf8d7cf0480$export$9a58ef0d7ad3278c) {
    constructor(x, y, radius){
        super(x, y);
        this.radius = radius;
    }
    contains(point) {
        return (0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(point, this.position) <= this.radius;
    }
    intersects(range) {
        const pos1 = this.position, pos2 = range.position, distPos = {
            x: Math.abs(pos2.x - pos1.x),
            y: Math.abs(pos2.y - pos1.y)
        }, r = this.radius;
        if (range instanceof $a41a3c6540989ea7$export$c89a927ffc67e6fa) {
            const rSum = r + range.radius, dist = Math.sqrt(distPos.x ** 2 + distPos.y ** 2);
            return rSum > dist;
        } else if (range instanceof (0, $fbaf108f02b30a19$export$4617fb02663045ef)) {
            const { width: width, height: height } = range.size, edges = Math.pow(distPos.x - width, 2) + Math.pow(distPos.y - height, 2);
            return edges <= r ** 2 || distPos.x <= r + width && distPos.y <= r + height || distPos.x <= width || distPos.y <= height;
        }
        return false;
    }
}




class $0635ffab4879f69f$export$b82688eb02220411 {
    constructor(rectangle, capacity){
        this.rectangle = rectangle;
        this.capacity = capacity;
        this._subdivide = ()=>{
            const { x: x, y: y } = this.rectangle.position, { width: width, height: height } = this.rectangle.size, { capacity: capacity } = this;
            for(let i = 0; i < 4; i++)this._subs.push(new $0635ffab4879f69f$export$b82688eb02220411(new (0, $fbaf108f02b30a19$export$4617fb02663045ef)(x + width / 2 * (i % 2), y + height / 2 * (Math.round(i / 2) - i % 2), width / 2, height / 2), capacity));
            this._divided = true;
        };
        this._points = [];
        this._divided = false;
        this._subs = [];
    }
    insert(point) {
        if (!this.rectangle.contains(point.position)) return false;
        if (this._points.length < this.capacity) {
            this._points.push(point);
            return true;
        }
        if (!this._divided) this._subdivide();
        return this._subs.some((sub)=>sub.insert(point));
    }
    query(range, check, found) {
        const res = found || [];
        if (!range.intersects(this.rectangle)) return [];
        for (const p of this._points){
            if (!range.contains(p.position) && (0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(range.position, p.position) > p.particle.getRadius() && (!check || check(p.particle))) continue;
            res.push(p.particle);
        }
        if (this._divided) for (const sub of this._subs)sub.query(range, check, res);
        return res;
    }
    queryCircle(position, radius, check) {
        return this.query(new (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa)(position.x, position.y, radius), check);
    }
    queryRectangle(position, size, check) {
        return this.query(new (0, $fbaf108f02b30a19$export$4617fb02663045ef)(position.x, position.y, size.width, size.height), check);
    }
}




const $02eaad4ed5e105cc$var$qTreeCapacity = 4;
const $02eaad4ed5e105cc$var$qTreeRectangle = (canvasSize)=>{
    return new (0, $fbaf108f02b30a19$export$4617fb02663045ef)(-canvasSize.width / 4, -canvasSize.height / 4, canvasSize.width * 3 / 2, canvasSize.height * 3 / 2);
};
class $02eaad4ed5e105cc$export$ec4bceef241d2e36 {
    constructor(engine, container){
        this._applyDensity = (options, manualCount, group)=>{
            if (!options.number.density?.enable) return;
            const numberOptions = options.number, densityFactor = this._initDensityFactor(numberOptions.density), optParticlesNumber = numberOptions.value, optParticlesLimit = numberOptions.limit > 0 ? numberOptions.limit : optParticlesNumber, particlesNumber = Math.min(optParticlesNumber, optParticlesLimit) * densityFactor + manualCount, particlesCount = Math.min(this.count, this.filter((t)=>t.group === group).length);
            this.limit = numberOptions.limit * densityFactor;
            if (particlesCount < particlesNumber) this.push(Math.abs(particlesNumber - particlesCount), undefined, options, group);
            else if (particlesCount > particlesNumber) this.removeQuantity(particlesCount - particlesNumber, group);
        };
        this._initDensityFactor = (densityOptions)=>{
            const container = this._container;
            if (!container.canvas.element || !densityOptions.enable) return 1;
            const canvas = container.canvas.element, pxRatio = container.retina.pixelRatio;
            return canvas.width * canvas.height / (densityOptions.factor * pxRatio ** 2 * densityOptions.area);
        };
        this._pushParticle = (position, overrideOptions, group, initializer)=>{
            try {
                let particle = this.pool.pop();
                if (particle) particle.init(this._nextId, position, overrideOptions, group);
                else particle = new (0, $14d3d48c1296b161$export$c36c68baa13912a5)(this._engine, this._nextId, this._container, position, overrideOptions, group);
                let canAdd = true;
                if (initializer) canAdd = initializer(particle);
                if (!canAdd) return;
                this._array.push(particle);
                this._zArray.push(particle);
                this._nextId++;
                this._engine.dispatchEvent("particleAdded", {
                    container: this._container,
                    data: {
                        particle: particle
                    }
                });
                return particle;
            } catch (e) {
                (0, $ab7d474d755ab51b$export$2b1d391cd05230fd)().warning(`${(0, $9f7790cd505e6a79$export$adea4917e02d93dc)} adding particle: ${e}`);
                return;
            }
        };
        this._removeParticle = (index, group, override)=>{
            const particle = this._array[index];
            if (!particle || particle.group !== group) return false;
            particle.destroy(override);
            const zIdx = this._zArray.indexOf(particle);
            this._array.splice(index, 1);
            this._zArray.splice(zIdx, 1);
            this.pool.push(particle);
            this._engine.dispatchEvent("particleRemoved", {
                container: this._container,
                data: {
                    particle: particle
                }
            });
            return true;
        };
        this._engine = engine;
        this._container = container;
        this._nextId = 0;
        this._array = [];
        this._zArray = [];
        this.pool = [];
        this.limit = 0;
        this.needsSort = false;
        this.lastZIndex = 0;
        this._interactionManager = new (0, $9447ca068c953476$export$aaa80641d584351c)(engine, container);
        const canvasSize = container.canvas.size;
        this.quadTree = new (0, $0635ffab4879f69f$export$b82688eb02220411)($02eaad4ed5e105cc$var$qTreeRectangle(canvasSize), $02eaad4ed5e105cc$var$qTreeCapacity);
        this.movers = this._engine.plugins.getMovers(container, true);
        this.updaters = this._engine.plugins.getUpdaters(container, true);
    }
    get count() {
        return this._array.length;
    }
    addManualParticles() {
        const container = this._container, options = container.actualOptions;
        for (const particle of options.manualParticles)this.addParticle(particle.position ? (0, $ab7d474d755ab51b$export$1690e12b840569b9)(particle.position, container.canvas.size) : undefined, particle.options);
    }
    addParticle(position, overrideOptions, group, initializer) {
        const container = this._container, options = container.actualOptions, limit = options.particles.number.limit;
        if (limit > 0) {
            const countToRemove = this.count + 1 - limit;
            if (countToRemove > 0) this.removeQuantity(countToRemove);
        }
        return this._pushParticle(position, overrideOptions, group, initializer);
    }
    clear() {
        this._array = [];
        this._zArray = [];
    }
    destroy() {
        this._array = [];
        this._zArray = [];
        this.movers = [];
        this.updaters = [];
    }
    async draw(delta) {
        const container = this._container;
        container.canvas.clear();
        await this.update(delta);
        for (const [, plugin] of container.plugins)container.canvas.drawPlugin(plugin, delta);
        for (const p of this._zArray)p.draw(delta);
    }
    filter(condition) {
        return this._array.filter(condition);
    }
    find(condition) {
        return this._array.find(condition);
    }
    handleClickMode(mode) {
        this._interactionManager.handleClickMode(mode);
    }
    init() {
        const container = this._container, options = container.actualOptions;
        this.lastZIndex = 0;
        this.needsSort = false;
        let handled = false;
        this.updaters = this._engine.plugins.getUpdaters(container, true);
        this._interactionManager.init();
        for (const [, plugin] of container.plugins){
            if (plugin.particlesInitialization !== undefined) handled = plugin.particlesInitialization();
            if (handled) break;
        }
        this._interactionManager.init();
        for (const [, pathGenerator] of container.pathGenerators)pathGenerator.init(container);
        this.addManualParticles();
        if (!handled) {
            for(const group in options.particles.groups){
                const groupOptions = options.particles.groups[group];
                for(let i = this.count, j = 0; j < groupOptions.number?.value && i < options.particles.number.value; i++, j++)this.addParticle(undefined, groupOptions, group);
            }
            for(let i = this.count; i < options.particles.number.value; i++)this.addParticle();
        }
    }
    push(nb, mouse, overrideOptions, group) {
        this.pushing = true;
        for(let i = 0; i < nb; i++)this.addParticle(mouse?.position, overrideOptions, group);
        this.pushing = false;
    }
    async redraw() {
        this.clear();
        this.init();
        await this.draw({
            value: 0,
            factor: 0
        });
    }
    remove(particle, group, override) {
        this.removeAt(this._array.indexOf(particle), undefined, group, override);
    }
    removeAt(index, quantity = 1, group, override) {
        if (index < 0 || index > this.count) return;
        let deleted = 0;
        for(let i = index; deleted < quantity && i < this.count; i++)this._removeParticle(i--, group, override) && deleted++;
    }
    removeQuantity(quantity, group) {
        this.removeAt(0, quantity, group);
    }
    setDensity() {
        const options = this._container.actualOptions, groups = options.particles.groups;
        for(const group in groups)this._applyDensity(groups[group], 0, group);
        this._applyDensity(options.particles, options.manualParticles.length);
    }
    async update(delta) {
        const container = this._container, particlesToDelete = new Set();
        this.quadTree = new (0, $0635ffab4879f69f$export$b82688eb02220411)($02eaad4ed5e105cc$var$qTreeRectangle(container.canvas.size), $02eaad4ed5e105cc$var$qTreeCapacity);
        for (const [, pathGenerator] of container.pathGenerators)pathGenerator.update();
        for (const [, plugin] of container.plugins)plugin.update && plugin.update(delta);
        for (const particle of this._array){
            const resizeFactor = container.canvas.resizeFactor;
            if (resizeFactor && !particle.ignoresResizeRatio) {
                particle.position.x *= resizeFactor.width;
                particle.position.y *= resizeFactor.height;
                particle.initialPosition.x *= resizeFactor.width;
                particle.initialPosition.y *= resizeFactor.height;
            }
            particle.ignoresResizeRatio = false;
            await this._interactionManager.reset(particle);
            for (const [, plugin] of this._container.plugins){
                if (particle.destroyed) break;
                if (plugin.particleUpdate) plugin.particleUpdate(particle, delta);
            }
            for (const mover of this.movers)mover.isEnabled(particle) && mover.move(particle, delta);
            if (particle.destroyed) {
                particlesToDelete.add(particle);
                continue;
            }
            this.quadTree.insert(new (0, $b3a743448af77b04$export$baf26146a414f24a)(particle.getPosition(), particle));
        }
        if (particlesToDelete.size) {
            const checkDelete = (p)=>!particlesToDelete.has(p);
            this._array = this.filter(checkDelete);
            this._zArray = this._zArray.filter(checkDelete);
            this.pool.push(...particlesToDelete);
        }
        await this._interactionManager.externalInteract(delta);
        for (const particle of this._array){
            for (const updater of this.updaters)updater.update(particle, delta);
            if (!particle.destroyed && !particle.spawning) await this._interactionManager.particlesInteract(particle, delta);
        }
        delete container.canvas.resizeFactor;
        if (this.needsSort) {
            const zArray = this._zArray;
            zArray.sort((a, b)=>b.position.z - a.position.z || a.id - b.id);
            this.lastZIndex = zArray[zArray.length - 1].position.z;
            this.needsSort = false;
        }
    }
}




class $f74f3cd0e37f1474$export$b7a992a6d33e9eff {
    constructor(container){
        this.container = container;
        this.pixelRatio = 1;
        this.reduceFactor = 1;
    }
    init() {
        const container = this.container, options = container.actualOptions;
        this.pixelRatio = !options.detectRetina || (0, $ab7d474d755ab51b$export$460b6777813d3d86)() ? 1 : window.devicePixelRatio;
        this.reduceFactor = 1;
        const ratio = this.pixelRatio;
        if (container.canvas.element) {
            const element = container.canvas.element;
            container.canvas.size.width = element.offsetWidth * ratio;
            container.canvas.size.height = element.offsetHeight * ratio;
        }
        const particles = options.particles, moveOptions = particles.move;
        this.attractDistance = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(moveOptions.attract.distance) * ratio;
        this.maxSpeed = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(moveOptions.gravity.maxSpeed) * ratio;
        this.sizeAnimationSpeed = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(particles.size.animation.speed) * ratio;
    }
    initParticle(particle) {
        const options = particle.options, ratio = this.pixelRatio, moveOptions = options.move, moveDistance = moveOptions.distance, props = particle.retina;
        props.attractDistance = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(moveOptions.attract.distance) * ratio;
        props.moveDrift = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(moveOptions.drift) * ratio;
        props.moveSpeed = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(moveOptions.speed) * ratio;
        props.sizeAnimationSpeed = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(options.size.animation.speed) * ratio;
        const maxDistance = props.maxDistance;
        maxDistance.horizontal = moveDistance.horizontal !== undefined ? moveDistance.horizontal * ratio : undefined;
        maxDistance.vertical = moveDistance.vertical !== undefined ? moveDistance.vertical * ratio : undefined;
        props.maxSpeed = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(moveOptions.gravity.maxSpeed) * ratio;
    }
}





function $911f0faba23726a5$var$guardCheck(container) {
    return container && !container.destroyed;
}
function $911f0faba23726a5$var$initDelta(value, fpsLimit = 60, smooth = false) {
    return {
        value: value,
        factor: smooth ? 60 / fpsLimit : 60 * value / 1000
    };
}
function $911f0faba23726a5$var$loadContainerOptions(engine, container, ...sourceOptionsArr) {
    const options = new (0, $a879bdf3c5a56bcb$export$c019608e5b5bb4cb)(engine, container);
    (0, $5364e7fd152e0675$export$cad72087bded938)(options, ...sourceOptionsArr);
    return options;
}
const $911f0faba23726a5$var$defaultPathGeneratorKey = "default", $911f0faba23726a5$var$defaultPathGenerator = {
    generate: (p)=>p.velocity,
    init: ()=>{},
    update: ()=>{},
    reset: ()=>{}
};
class $911f0faba23726a5$export$42a852a2b6b56249 {
    constructor(engine, id, sourceOptions){
        this.id = id;
        this._intersectionManager = (entries)=>{
            if (!$911f0faba23726a5$var$guardCheck(this) || !this.actualOptions.pauseOnOutsideViewport) return;
            for (const entry of entries){
                if (entry.target !== this.interactivity.element) continue;
                (entry.isIntersecting ? this.play : this.pause)();
            }
        };
        this._nextFrame = async (timestamp)=>{
            try {
                if (!this.smooth && this.lastFrameTime !== undefined && timestamp < this.lastFrameTime + 1000 / this.fpsLimit) {
                    this.draw(false);
                    return;
                }
                this.lastFrameTime ??= timestamp;
                const delta = $911f0faba23726a5$var$initDelta(timestamp - this.lastFrameTime, this.fpsLimit, this.smooth);
                this.addLifeTime(delta.value);
                this.lastFrameTime = timestamp;
                if (delta.value > 1000) {
                    this.draw(false);
                    return;
                }
                await this.particles.draw(delta);
                if (!this.alive()) {
                    this.destroy();
                    return;
                }
                if (this.getAnimationStatus()) this.draw(false);
            } catch (e) {
                (0, $ab7d474d755ab51b$export$2b1d391cd05230fd)().error(`${(0, $9f7790cd505e6a79$export$adea4917e02d93dc)} in animation loop`, e);
            }
        };
        this._engine = engine;
        this.fpsLimit = 120;
        this.smooth = false;
        this._delay = 0;
        this._duration = 0;
        this._lifeTime = 0;
        this._firstStart = true;
        this.started = false;
        this.destroyed = false;
        this._paused = true;
        this.lastFrameTime = 0;
        this.zLayers = 100;
        this.pageHidden = false;
        this._sourceOptions = sourceOptions;
        this._initialSourceOptions = sourceOptions;
        this.retina = new (0, $f74f3cd0e37f1474$export$b7a992a6d33e9eff)(this);
        this.canvas = new (0, $e6bf9c7b5e45d6d5$export$8d01c972ee8b14a9)(this);
        this.particles = new (0, $02eaad4ed5e105cc$export$ec4bceef241d2e36)(this._engine, this);
        this.pathGenerators = new Map();
        this.interactivity = {
            mouse: {
                clicking: false,
                inside: false
            }
        };
        this.plugins = new Map();
        this.drawers = new Map();
        this._options = $911f0faba23726a5$var$loadContainerOptions(this._engine, this);
        this.actualOptions = $911f0faba23726a5$var$loadContainerOptions(this._engine, this);
        this._eventListeners = new (0, $c949071402dcefec$export$b20b719ec758a20f)(this);
        if (typeof IntersectionObserver !== "undefined" && IntersectionObserver) this._intersectionObserver = new IntersectionObserver((entries)=>this._intersectionManager(entries));
        this._engine.dispatchEvent("containerBuilt", {
            container: this
        });
    }
    get options() {
        return this._options;
    }
    get sourceOptions() {
        return this._sourceOptions;
    }
    addClickHandler(callback) {
        if (!$911f0faba23726a5$var$guardCheck(this)) return;
        const el = this.interactivity.element;
        if (!el) return;
        const clickOrTouchHandler = (e, pos, radius)=>{
            if (!$911f0faba23726a5$var$guardCheck(this)) return;
            const pxRatio = this.retina.pixelRatio, posRetina = {
                x: pos.x * pxRatio,
                y: pos.y * pxRatio
            }, particles = this.particles.quadTree.queryCircle(posRetina, radius * pxRatio);
            callback(e, particles);
        };
        const clickHandler = (e)=>{
            if (!$911f0faba23726a5$var$guardCheck(this)) return;
            const mouseEvent = e, pos = {
                x: mouseEvent.offsetX || mouseEvent.clientX,
                y: mouseEvent.offsetY || mouseEvent.clientY
            };
            clickOrTouchHandler(e, pos, 1);
        };
        const touchStartHandler = ()=>{
            if (!$911f0faba23726a5$var$guardCheck(this)) return;
            touched = true;
            touchMoved = false;
        };
        const touchMoveHandler = ()=>{
            if (!$911f0faba23726a5$var$guardCheck(this)) return;
            touchMoved = true;
        };
        const touchEndHandler = (e)=>{
            if (!$911f0faba23726a5$var$guardCheck(this)) return;
            if (touched && !touchMoved) {
                const touchEvent = e;
                let lastTouch = touchEvent.touches[touchEvent.touches.length - 1];
                if (!lastTouch) {
                    lastTouch = touchEvent.changedTouches[touchEvent.changedTouches.length - 1];
                    if (!lastTouch) return;
                }
                const element = this.canvas.element, canvasRect = element ? element.getBoundingClientRect() : undefined, pos = {
                    x: lastTouch.clientX - (canvasRect ? canvasRect.left : 0),
                    y: lastTouch.clientY - (canvasRect ? canvasRect.top : 0)
                };
                clickOrTouchHandler(e, pos, Math.max(lastTouch.radiusX, lastTouch.radiusY));
            }
            touched = false;
            touchMoved = false;
        };
        const touchCancelHandler = ()=>{
            if (!$911f0faba23726a5$var$guardCheck(this)) return;
            touched = false;
            touchMoved = false;
        };
        let touched = false, touchMoved = false;
        el.addEventListener("click", clickHandler);
        el.addEventListener("touchstart", touchStartHandler);
        el.addEventListener("touchmove", touchMoveHandler);
        el.addEventListener("touchend", touchEndHandler);
        el.addEventListener("touchcancel", touchCancelHandler);
    }
    addLifeTime(value) {
        this._lifeTime += value;
    }
    addPath(key, generator, override = false) {
        if (!$911f0faba23726a5$var$guardCheck(this) || !override && this.pathGenerators.has(key)) return false;
        this.pathGenerators.set(key, generator ?? $911f0faba23726a5$var$defaultPathGenerator);
        return true;
    }
    alive() {
        return !this._duration || this._lifeTime <= this._duration;
    }
    destroy() {
        if (!$911f0faba23726a5$var$guardCheck(this)) return;
        this.stop();
        this.particles.destroy();
        this.canvas.destroy();
        for (const [, drawer] of this.drawers)drawer.destroy && drawer.destroy(this);
        for (const key of this.drawers.keys())this.drawers.delete(key);
        this._engine.plugins.destroy(this);
        this.destroyed = true;
        const mainArr = this._engine.dom(), idx = mainArr.findIndex((t)=>t === this);
        if (idx >= 0) mainArr.splice(idx, 1);
        this._engine.dispatchEvent("containerDestroyed", {
            container: this
        });
    }
    draw(force) {
        if (!$911f0faba23726a5$var$guardCheck(this)) return;
        let refreshTime = force;
        this._drawAnimationFrame = requestAnimationFrame(async (timestamp)=>{
            if (refreshTime) {
                this.lastFrameTime = undefined;
                refreshTime = false;
            }
            await this._nextFrame(timestamp);
        });
    }
    async export(type, options = {}) {
        for (const [, plugin] of this.plugins){
            if (!plugin.export) continue;
            const res = await plugin.export(type, options);
            if (!res.supported) continue;
            return res.blob;
        }
        (0, $ab7d474d755ab51b$export$2b1d391cd05230fd)().error(`${(0, $9f7790cd505e6a79$export$adea4917e02d93dc)} - Export plugin with type ${type} not found`);
    }
    getAnimationStatus() {
        return !this._paused && !this.pageHidden && $911f0faba23726a5$var$guardCheck(this);
    }
    handleClickMode(mode) {
        if (!$911f0faba23726a5$var$guardCheck(this)) return;
        this.particles.handleClickMode(mode);
        for (const [, plugin] of this.plugins)plugin.handleClickMode && plugin.handleClickMode(mode);
    }
    async init() {
        if (!$911f0faba23726a5$var$guardCheck(this)) return;
        const shapes = this._engine.plugins.getSupportedShapes();
        for (const type of shapes){
            const drawer = this._engine.plugins.getShapeDrawer(type);
            if (drawer) this.drawers.set(type, drawer);
        }
        this._options = $911f0faba23726a5$var$loadContainerOptions(this._engine, this, this._initialSourceOptions, this.sourceOptions);
        this.actualOptions = $911f0faba23726a5$var$loadContainerOptions(this._engine, this, this._options);
        const availablePlugins = this._engine.plugins.getAvailablePlugins(this);
        for (const [id, plugin] of availablePlugins)this.plugins.set(id, plugin);
        this.retina.init();
        await this.canvas.init();
        this.updateActualOptions();
        this.canvas.initBackground();
        this.canvas.resize();
        this.zLayers = this.actualOptions.zLayers;
        this._duration = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(this.actualOptions.duration) * 1000;
        this._delay = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(this.actualOptions.delay) * 1000;
        this._lifeTime = 0;
        this.fpsLimit = this.actualOptions.fpsLimit > 0 ? this.actualOptions.fpsLimit : 120;
        this.smooth = this.actualOptions.smooth;
        for (const [, drawer] of this.drawers)drawer.init && await drawer.init(this);
        for (const [, plugin] of this.plugins)plugin.init && await plugin.init();
        this._engine.dispatchEvent("containerInit", {
            container: this
        });
        this.particles.init();
        this.particles.setDensity();
        for (const [, plugin] of this.plugins)plugin.particlesSetup && plugin.particlesSetup();
        this._engine.dispatchEvent("particlesSetup", {
            container: this
        });
    }
    async loadTheme(name) {
        if (!$911f0faba23726a5$var$guardCheck(this)) return;
        this._currentTheme = name;
        await this.refresh();
    }
    pause() {
        if (!$911f0faba23726a5$var$guardCheck(this)) return;
        if (this._drawAnimationFrame !== undefined) {
            cancelAnimationFrame(this._drawAnimationFrame);
            delete this._drawAnimationFrame;
        }
        if (this._paused) return;
        for (const [, plugin] of this.plugins)plugin.pause && plugin.pause();
        if (!this.pageHidden) this._paused = true;
        this._engine.dispatchEvent("containerPaused", {
            container: this
        });
    }
    play(force) {
        if (!$911f0faba23726a5$var$guardCheck(this)) return;
        const needsUpdate = this._paused || force;
        if (this._firstStart && !this.actualOptions.autoPlay) {
            this._firstStart = false;
            return;
        }
        if (this._paused) this._paused = false;
        if (needsUpdate) {
            for (const [, plugin] of this.plugins)if (plugin.play) plugin.play();
        }
        this._engine.dispatchEvent("containerPlay", {
            container: this
        });
        this.draw(needsUpdate || false);
    }
    async refresh() {
        if (!$911f0faba23726a5$var$guardCheck(this)) return;
        this.stop();
        return this.start();
    }
    async reset() {
        if (!$911f0faba23726a5$var$guardCheck(this)) return;
        this._initialSourceOptions = undefined;
        this._options = $911f0faba23726a5$var$loadContainerOptions(this._engine, this);
        this.actualOptions = $911f0faba23726a5$var$loadContainerOptions(this._engine, this, this._options);
        return this.refresh();
    }
    setNoise(noiseOrGenerator, init, update) {
        if (!$911f0faba23726a5$var$guardCheck(this)) return;
        this.setPath(noiseOrGenerator, init, update);
    }
    setPath(pathOrGenerator, init, update) {
        if (!pathOrGenerator || !$911f0faba23726a5$var$guardCheck(this)) return;
        const pathGenerator = {
            ...$911f0faba23726a5$var$defaultPathGenerator
        };
        if ((0, $ab7d474d755ab51b$export$f6e2535fb5126e54)(pathOrGenerator)) {
            pathGenerator.generate = pathOrGenerator;
            if (init) pathGenerator.init = init;
            if (update) pathGenerator.update = update;
        } else {
            const oldGenerator = pathGenerator;
            pathGenerator.generate = pathOrGenerator.generate || oldGenerator.generate;
            pathGenerator.init = pathOrGenerator.init || oldGenerator.init;
            pathGenerator.update = pathOrGenerator.update || oldGenerator.update;
        }
        this.addPath($911f0faba23726a5$var$defaultPathGeneratorKey, pathGenerator, true);
    }
    async start() {
        if (!$911f0faba23726a5$var$guardCheck(this) || this.started) return;
        await this.init();
        this.started = true;
        await new Promise((resolve)=>{
            this._delayTimeout = setTimeout(async ()=>{
                this._eventListeners.addListeners();
                if (this.interactivity.element instanceof HTMLElement && this._intersectionObserver) this._intersectionObserver.observe(this.interactivity.element);
                for (const [, plugin] of this.plugins)plugin.start && await plugin.start();
                this._engine.dispatchEvent("containerStarted", {
                    container: this
                });
                this.play();
                resolve();
            }, this._delay);
        });
    }
    stop() {
        if (!$911f0faba23726a5$var$guardCheck(this) || !this.started) return;
        if (this._delayTimeout) {
            clearTimeout(this._delayTimeout);
            delete this._delayTimeout;
        }
        this._firstStart = true;
        this.started = false;
        this._eventListeners.removeListeners();
        this.pause();
        this.particles.clear();
        this.canvas.stop();
        if (this.interactivity.element instanceof HTMLElement && this._intersectionObserver) this._intersectionObserver.unobserve(this.interactivity.element);
        for (const [, plugin] of this.plugins)plugin.stop && plugin.stop();
        for (const key of this.plugins.keys())this.plugins.delete(key);
        this._sourceOptions = this._options;
        this._engine.dispatchEvent("containerStopped", {
            container: this
        });
    }
    updateActualOptions() {
        this.actualOptions.responsive = [];
        const newMaxWidth = this.actualOptions.setResponsive(this.canvas.size.width, this.retina.pixelRatio, this._options);
        this.actualOptions.setTheme(this._currentTheme);
        if (this.responsiveMaxWidth === newMaxWidth) return false;
        this.responsiveMaxWidth = newMaxWidth;
        return true;
    }
}


class $3b9571bb2116c76f$export$ec8b666c5fe2c75a {
    constructor(){
        this._listeners = new Map();
    }
    addEventListener(type, listener) {
        this.removeEventListener(type, listener);
        let arr = this._listeners.get(type);
        if (!arr) {
            arr = [];
            this._listeners.set(type, arr);
        }
        arr.push(listener);
    }
    dispatchEvent(type, args) {
        const listeners = this._listeners.get(type);
        listeners && listeners.forEach((handler)=>handler(args));
    }
    hasEventListener(type) {
        return !!this._listeners.get(type);
    }
    removeAllEventListeners(type) {
        if (!type) this._listeners = new Map();
        else this._listeners.delete(type);
    }
    removeEventListener(type, listener) {
        const arr = this._listeners.get(type);
        if (!arr) return;
        const length = arr.length, idx = arr.indexOf(listener);
        if (idx < 0) return;
        if (length === 1) this._listeners.delete(type);
        else arr.splice(idx, 1);
    }
}



function $a87c6305922ca927$var$getItemsFromInitializer(container, map, initializers, force = false) {
    let res = map.get(container);
    if (!res || force) {
        res = [
            ...initializers.values()
        ].map((t)=>t(container));
        map.set(container, res);
    }
    return res;
}
class $a87c6305922ca927$export$c203ca0aafe4939a {
    constructor(engine){
        this._engine = engine;
        this.plugins = [];
        this._initializers = {
            interactors: new Map(),
            movers: new Map(),
            updaters: new Map()
        };
        this.interactors = new Map();
        this.movers = new Map();
        this.updaters = new Map();
        this.presets = new Map();
        this.drawers = new Map();
        this.pathGenerators = new Map();
    }
    addInteractor(name, initInteractor) {
        this._initializers.interactors.set(name, initInteractor);
    }
    addParticleMover(name, initMover) {
        this._initializers.movers.set(name, initMover);
    }
    addParticleUpdater(name, initUpdater) {
        this._initializers.updaters.set(name, initUpdater);
    }
    addPathGenerator(type, pathGenerator) {
        !this.getPathGenerator(type) && this.pathGenerators.set(type, pathGenerator);
    }
    addPlugin(plugin) {
        !this.getPlugin(plugin.id) && this.plugins.push(plugin);
    }
    addPreset(presetKey, options, override = false) {
        (override || !this.getPreset(presetKey)) && this.presets.set(presetKey, options);
    }
    addShapeDrawer(types, drawer) {
        (0, $ab7d474d755ab51b$export$8e5dc47097396754)(types, (type)=>{
            !this.getShapeDrawer(type) && this.drawers.set(type, drawer);
        });
    }
    destroy(container) {
        this.updaters.delete(container);
        this.movers.delete(container);
        this.interactors.delete(container);
    }
    getAvailablePlugins(container) {
        const res = new Map();
        for (const plugin of this.plugins)plugin.needsPlugin(container.actualOptions) && res.set(plugin.id, plugin.getPlugin(container));
        return res;
    }
    getInteractors(container, force = false) {
        return $a87c6305922ca927$var$getItemsFromInitializer(container, this.interactors, this._initializers.interactors, force);
    }
    getMovers(container, force = false) {
        return $a87c6305922ca927$var$getItemsFromInitializer(container, this.movers, this._initializers.movers, force);
    }
    getPathGenerator(type) {
        return this.pathGenerators.get(type);
    }
    getPlugin(plugin) {
        return this.plugins.find((t)=>t.id === plugin);
    }
    getPreset(preset) {
        return this.presets.get(preset);
    }
    getShapeDrawer(type) {
        return this.drawers.get(type);
    }
    getSupportedShapes() {
        return this.drawers.keys();
    }
    getUpdaters(container, force = false) {
        return $a87c6305922ca927$var$getItemsFromInitializer(container, this.updaters, this._initializers.updaters, force);
    }
    loadOptions(options, sourceOptions) {
        for (const plugin of this.plugins)plugin.loadOptions(options, sourceOptions);
    }
    loadParticlesOptions(container, options, ...sourceOptions) {
        const updaters = this.updaters.get(container);
        if (!updaters) return;
        for (const updater of updaters)updater.loadOptions && updater.loadOptions(options, ...sourceOptions);
    }
}



async function $df1db938ee3267d5$var$getDataFromUrl(data) {
    const url = (0, $ab7d474d755ab51b$export$3fbf39566d3ee62e)(data.url, data.index);
    if (!url) return data.fallback;
    const response = await fetch(url);
    if (response.ok) return response.json();
    (0, $ab7d474d755ab51b$export$2b1d391cd05230fd)().error(`${(0, $9f7790cd505e6a79$export$adea4917e02d93dc)} ${response.status} while retrieving config file`);
    return data.fallback;
}
function $df1db938ee3267d5$var$isParamsEmpty(params) {
    return !params.id && !params.element && !params.url && !params.options;
}
function $df1db938ee3267d5$var$isParams(obj) {
    return !$df1db938ee3267d5$var$isParamsEmpty(obj);
}
class $df1db938ee3267d5$export$2c3b404bf3a77a1f {
    constructor(){
        this._configs = new Map();
        this._domArray = [];
        this._eventDispatcher = new (0, $3b9571bb2116c76f$export$ec8b666c5fe2c75a)();
        this._initialized = false;
        this.plugins = new (0, $a87c6305922ca927$export$c203ca0aafe4939a)(this);
    }
    get configs() {
        const res = {};
        for (const [name, config] of this._configs)res[name] = config;
        return res;
    }
    get version() {
        return "2.12.0";
    }
    addConfig(nameOrConfig, config) {
        if ((0, $ab7d474d755ab51b$export$844ec244b1367d54)(nameOrConfig)) {
            if (config) {
                config.name = nameOrConfig;
                this._configs.set(nameOrConfig, config);
            }
        } else this._configs.set(nameOrConfig.name ?? "default", nameOrConfig);
    }
    addEventListener(type, listener) {
        this._eventDispatcher.addEventListener(type, listener);
    }
    async addInteractor(name, interactorInitializer, refresh = true) {
        this.plugins.addInteractor(name, interactorInitializer);
        await this.refresh(refresh);
    }
    async addMover(name, moverInitializer, refresh = true) {
        this.plugins.addParticleMover(name, moverInitializer);
        await this.refresh(refresh);
    }
    async addParticleUpdater(name, updaterInitializer, refresh = true) {
        this.plugins.addParticleUpdater(name, updaterInitializer);
        await this.refresh(refresh);
    }
    async addPathGenerator(name, generator, refresh = true) {
        this.plugins.addPathGenerator(name, generator);
        await this.refresh(refresh);
    }
    async addPlugin(plugin, refresh = true) {
        this.plugins.addPlugin(plugin);
        await this.refresh(refresh);
    }
    async addPreset(preset, options, override = false, refresh = true) {
        this.plugins.addPreset(preset, options, override);
        await this.refresh(refresh);
    }
    async addShape(shape, drawer, initOrRefresh, afterEffectOrRefresh, destroyOrRefresh, refresh = true) {
        let customDrawer;
        let realRefresh = refresh, realInit, realAfterEffect, realDestroy;
        if ((0, $ab7d474d755ab51b$export$f9ce7b637dfbe238)(initOrRefresh)) {
            realRefresh = initOrRefresh;
            realInit = undefined;
        } else realInit = initOrRefresh;
        if ((0, $ab7d474d755ab51b$export$f9ce7b637dfbe238)(afterEffectOrRefresh)) {
            realRefresh = afterEffectOrRefresh;
            realAfterEffect = undefined;
        } else realAfterEffect = afterEffectOrRefresh;
        if ((0, $ab7d474d755ab51b$export$f9ce7b637dfbe238)(destroyOrRefresh)) {
            realRefresh = destroyOrRefresh;
            realDestroy = undefined;
        } else realDestroy = destroyOrRefresh;
        if ((0, $ab7d474d755ab51b$export$f6e2535fb5126e54)(drawer)) customDrawer = {
            afterEffect: realAfterEffect,
            destroy: realDestroy,
            draw: drawer,
            init: realInit
        };
        else customDrawer = drawer;
        this.plugins.addShapeDrawer(shape, customDrawer);
        await this.refresh(realRefresh);
    }
    dispatchEvent(type, args) {
        this._eventDispatcher.dispatchEvent(type, args);
    }
    dom() {
        return this._domArray;
    }
    domItem(index) {
        const dom = this.dom(), item = dom[index];
        if (!item || item.destroyed) {
            dom.splice(index, 1);
            return;
        }
        return item;
    }
    init() {
        if (this._initialized) return;
        this._initialized = true;
    }
    async load(tagIdOrOptionsOrParams, options) {
        return this.loadFromArray(tagIdOrOptionsOrParams, options);
    }
    async loadFromArray(tagIdOrOptionsOrParams, optionsOrIndex, index) {
        let params;
        if (!$df1db938ee3267d5$var$isParams(tagIdOrOptionsOrParams)) {
            params = {};
            if ((0, $ab7d474d755ab51b$export$844ec244b1367d54)(tagIdOrOptionsOrParams)) params.id = tagIdOrOptionsOrParams;
            else params.options = tagIdOrOptionsOrParams;
            if ((0, $ab7d474d755ab51b$export$7e4aa119212bc614)(optionsOrIndex)) params.index = optionsOrIndex;
            else params.options = optionsOrIndex ?? params.options;
            params.index = index ?? params.index;
        } else params = tagIdOrOptionsOrParams;
        return this._loadParams(params);
    }
    async loadJSON(tagId, pathConfigJson, index) {
        let url, id;
        if ((0, $ab7d474d755ab51b$export$7e4aa119212bc614)(pathConfigJson) || pathConfigJson === undefined) url = tagId;
        else {
            id = tagId;
            url = pathConfigJson;
        }
        return this._loadParams({
            id: id,
            url: url,
            index: index
        });
    }
    async refresh(refresh = true) {
        if (!refresh) return;
        this.dom().forEach((t)=>t.refresh());
    }
    removeEventListener(type, listener) {
        this._eventDispatcher.removeEventListener(type, listener);
    }
    async set(id, element, options, index) {
        const params = {
            index: index
        };
        if ((0, $ab7d474d755ab51b$export$844ec244b1367d54)(id)) params.id = id;
        else params.element = id;
        if (element instanceof HTMLElement) params.element = element;
        else params.options = element;
        if ((0, $ab7d474d755ab51b$export$7e4aa119212bc614)(options)) params.index = options;
        else params.options = options ?? params.options;
        return this._loadParams(params);
    }
    async setJSON(id, element, pathConfigJson, index) {
        const params = {};
        if (id instanceof HTMLElement) {
            params.element = id;
            params.url = element;
            params.index = pathConfigJson;
        } else {
            params.id = id;
            params.element = element;
            params.url = pathConfigJson;
            params.index = index;
        }
        return this._loadParams(params);
    }
    setOnClickHandler(callback) {
        const dom = this.dom();
        if (!dom.length) throw new Error(`${(0, $9f7790cd505e6a79$export$adea4917e02d93dc)} can only set click handlers after calling tsParticles.load()`);
        for (const domItem of dom)domItem.addClickHandler(callback);
    }
    async _loadParams(params) {
        const id = params.id ?? `tsparticles${Math.floor((0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() * 10000)}`, { index: index, url: url } = params, options = url ? await $df1db938ee3267d5$var$getDataFromUrl({
            fallback: params.options,
            url: url,
            index: index
        }) : params.options;
        let domContainer = params.element ?? document.getElementById(id);
        if (!domContainer) {
            domContainer = document.createElement("div");
            domContainer.id = id;
            document.body.append(domContainer);
        }
        const currentOptions = (0, $ab7d474d755ab51b$export$3fbf39566d3ee62e)(options, index), dom = this.dom(), oldIndex = dom.findIndex((v)=>v.id === id);
        if (oldIndex >= 0) {
            const old = this.domItem(oldIndex);
            if (old && !old.destroyed) {
                old.destroy();
                dom.splice(oldIndex, 1);
            }
        }
        let canvasEl;
        if (domContainer.tagName.toLowerCase() === "canvas") {
            canvasEl = domContainer;
            canvasEl.dataset[0, $9f7790cd505e6a79$export$4a278486528d5cfb] = "false";
        } else {
            const existingCanvases = domContainer.getElementsByTagName("canvas");
            if (existingCanvases.length) {
                canvasEl = existingCanvases[0];
                canvasEl.dataset[0, $9f7790cd505e6a79$export$4a278486528d5cfb] = "false";
            } else {
                canvasEl = document.createElement("canvas");
                canvasEl.dataset[0, $9f7790cd505e6a79$export$4a278486528d5cfb] = "true";
                domContainer.appendChild(canvasEl);
            }
        }
        if (!canvasEl.style.width) canvasEl.style.width = "100%";
        if (!canvasEl.style.height) canvasEl.style.height = "100%";
        const newItem = new (0, $911f0faba23726a5$export$42a852a2b6b56249)(this, id, currentOptions);
        if (oldIndex >= 0) dom.splice(oldIndex, 0, newItem);
        else dom.push(newItem);
        newItem.canvas.loadCanvas(canvasEl);
        await newItem.start();
        return newItem;
    }
}




class $20bbb7e57483344c$export$a0d665b8e8138206 {
    constructor(){
        this.key = "hsl";
        this.stringPrefix = "hsl";
    }
    handleColor(color) {
        const colorValue = color.value, hslColor = colorValue.hsl ?? color.value;
        if (hslColor.h !== undefined && hslColor.s !== undefined && hslColor.l !== undefined) return (0, $3b20cd3c058d307c$export$29fb7152bd3f781a)(hslColor);
    }
    handleRangeColor(color) {
        const colorValue = color.value, hslColor = colorValue.hsl ?? color.value;
        if (hslColor.h !== undefined && hslColor.l !== undefined) return (0, $3b20cd3c058d307c$export$29fb7152bd3f781a)({
            h: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(hslColor.h),
            l: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(hslColor.l),
            s: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(hslColor.s)
        });
    }
    parseString(input) {
        if (!input.startsWith("hsl")) return;
        const regex = /hsla?\(\s*(\d+)\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(,\s*([\d.%]+)\s*)?\)/i, result = regex.exec(input);
        return result ? (0, $3b20cd3c058d307c$export$6ae64dbcd6bfc33e)({
            a: result.length > 4 ? (0, $a17cb6ec9e2ec6c9$export$988633967de92230)(result[5]) : 1,
            h: parseInt(result[1], 10),
            l: parseInt(result[3], 10),
            s: parseInt(result[2], 10)
        }) : undefined;
    }
}



class $4140e2f89be07865$export$24da4f0c4702c17e {
    constructor(){
        this.key = "rgb";
        this.stringPrefix = "rgb";
    }
    handleColor(color) {
        const colorValue = color.value, rgbColor = colorValue.rgb ?? color.value;
        if (rgbColor.r !== undefined) return rgbColor;
    }
    handleRangeColor(color) {
        const colorValue = color.value, rgbColor = colorValue.rgb ?? color.value;
        if (rgbColor.r !== undefined) return {
            r: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(rgbColor.r),
            g: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(rgbColor.g),
            b: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(rgbColor.b)
        };
    }
    parseString(input) {
        if (!input.startsWith(this.stringPrefix)) return;
        const regex = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([\d.%]+)\s*)?\)/i, result = regex.exec(input);
        return result ? {
            a: result.length > 4 ? (0, $a17cb6ec9e2ec6c9$export$988633967de92230)(result[5]) : 1,
            b: parseInt(result[3], 10),
            g: parseInt(result[2], 10),
            r: parseInt(result[1], 10)
        } : undefined;
    }
}



function $262a18781986f84e$export$2cd8252107eb640b() {
    const rgbColorManager = new (0, $4140e2f89be07865$export$24da4f0c4702c17e)(), hslColorManager = new (0, $20bbb7e57483344c$export$a0d665b8e8138206)();
    (0, $3b20cd3c058d307c$export$fac4919b23cbaf23)(rgbColorManager);
    (0, $3b20cd3c058d307c$export$fac4919b23cbaf23)(hslColorManager);
    const engine = new (0, $df1db938ee3267d5$export$2c3b404bf3a77a1f)();
    engine.init();
    return engine;
}



class $a34f6e88dd5ec1a0$export$6e252256471acc61 {
    constructor(container){
        this.container = container;
        this.type = "external";
    }
}

class $1ee59cb044552abc$export$becdaab2d9289dc4 {
    constructor(container){
        this.container = container;
        this.type = "particles";
    }
}



const $0f2f44e3fd1f51bb$export$218c38ca7c058037 = (0, $262a18781986f84e$export$2cd8252107eb640b)();
if (!(0, $ab7d474d755ab51b$export$460b6777813d3d86)()) window.tsParticles = $0f2f44e3fd1f51bb$export$218c38ca7c058037;


const $8dc7450d41836b05$var$isObject = (val)=>typeof val === "object" && val !== null;
function $8dc7450d41836b05$export$e12301e595e16ad8(obj1, obj2, excludeKeyFn = ()=>false) {
    if (!$8dc7450d41836b05$var$isObject(obj1) || !$8dc7450d41836b05$var$isObject(obj2)) return obj1 === obj2;
    const keys1 = Object.keys(obj1).filter((key)=>!excludeKeyFn(key)), keys2 = Object.keys(obj2).filter((key)=>!excludeKeyFn(key));
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const value1 = obj1[key], value2 = obj2[key];
        if ($8dc7450d41836b05$var$isObject(value1) && $8dc7450d41836b05$var$isObject(value2)) {
            if (value1 === obj2 && value2 === obj1) continue;
            if (!$8dc7450d41836b05$export$e12301e595e16ad8(value1, value2, excludeKeyFn)) return false;
        } else if (Array.isArray(value1) && Array.isArray(value2)) {
            if (!$8dc7450d41836b05$var$deepCompareArrays(value1, value2, excludeKeyFn)) return false;
        } else if (value1 !== value2) return false;
    }
    return true;
}
function $8dc7450d41836b05$var$deepCompareArrays(arr1, arr2, excludeKeyFn) {
    if (arr1.length !== arr2.length) return false;
    for(let i = 0; i < arr1.length; i++){
        const val1 = arr1[i], val2 = arr2[i];
        if (Array.isArray(val1) && Array.isArray(val2)) {
            if (!$8dc7450d41836b05$var$deepCompareArrays(val1, val2, excludeKeyFn)) return false;
        } else if ($8dc7450d41836b05$var$isObject(val1) && $8dc7450d41836b05$var$isObject(val2)) {
            if (!$8dc7450d41836b05$export$e12301e595e16ad8(val1, val2, excludeKeyFn)) return false;
        } else if (val1 !== val2) return false;
    }
    return true;
}


const $c69b3fedfaeac164$var$defaultId = "tsparticles";
class $c69b3fedfaeac164$var$Particles extends (0, $1fELX.Component) {
    constructor(props){
        super(props);
        this.state = {
            init: false,
            library: undefined
        };
    }
    destroy() {
        if (!this.state.library) return;
        this.state.library.destroy();
        this.setState({
            library: undefined
        });
    }
    shouldComponentUpdate(nextProps) {
        const nextOptions = nextProps.options ?? nextProps.params, currentOptions = this.props.options ?? this.props.params;
        return nextProps.url !== this.props.url || nextProps.id !== this.props.id || nextProps.canvasClassName !== this.props.canvasClassName || nextProps.className !== this.props.className || nextProps.height !== this.props.height || nextProps.width !== this.props.width || !(0, $8dc7450d41836b05$export$e12301e595e16ad8)(nextProps.style, this.props.style) || nextProps.init !== this.props.init || nextProps.loaded !== this.props.loaded || !(0, $8dc7450d41836b05$export$e12301e595e16ad8)(nextOptions, currentOptions, (key)=>key.startsWith("_"));
    }
    componentDidUpdate() {
        this.refresh();
    }
    forceUpdate() {
        this.refresh().then(()=>{
            super.forceUpdate();
        });
    }
    componentDidMount() {
        (async ()=>{
            if (this.props.init) await this.props.init((0, $0f2f44e3fd1f51bb$export$218c38ca7c058037));
            this.setState({
                init: true
            }, async ()=>{
                await this.loadParticles();
            });
        })();
    }
    componentWillUnmount() {
        this.destroy();
    }
    render() {
        const { width: width, height: height, className: className, canvasClassName: canvasClassName, id: id } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).createElement("div", {
            className: className,
            id: id
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).createElement("canvas", {
            className: canvasClassName,
            style: {
                ...this.props.style,
                width: width,
                height: height
            }
        }));
    }
    async refresh() {
        this.destroy();
        await this.loadParticles();
    }
    async loadParticles() {
        if (!this.state.init) return;
        const id = this.props.id ?? $c69b3fedfaeac164$var$Particles.defaultProps.id ?? $c69b3fedfaeac164$var$defaultId, container = await (0, $0f2f44e3fd1f51bb$export$218c38ca7c058037).load({
            url: this.props.url,
            id: id,
            options: this.props.options ?? this.props.params
        });
        if (this.props.container) this.props.container.current = container;
        this.setState({
            library: container
        });
        if (this.props.loaded) await this.props.loaded(container);
    }
}
$c69b3fedfaeac164$var$Particles.defaultProps = {
    width: "100%",
    height: "100%",
    options: {},
    style: {},
    url: undefined,
    id: $c69b3fedfaeac164$var$defaultId
};
var $c69b3fedfaeac164$export$2e2bcd8739ae039 = $c69b3fedfaeac164$var$Particles;


var $2b1a073f15fcb8b0$export$2e2bcd8739ae039 = (0, $c69b3fedfaeac164$export$2e2bcd8739ae039);





class $e6bf4219ef25359e$export$d9c489b7422f439 {
    constructor(){
        this.radius = 0;
        this.mass = 0;
    }
    load(data) {
        if (!data) return;
        if (data.mass !== undefined) this.mass = data.mass;
        if (data.radius !== undefined) this.radius = data.radius;
    }
}


class $76f189bead0af748$export$d8af9fbad354c15b extends (0, $7502aa7b9e2abdb4$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.density = 5;
        this.value = 50;
        this.limit = new (0, $e6bf4219ef25359e$export$d9c489b7422f439)();
    }
    load(data) {
        if (!data) return;
        super.load(data);
        if (data.density !== undefined) this.density = data.density;
        if ((0, $ab7d474d755ab51b$export$7e4aa119212bc614)(data.limit)) this.limit.radius = data.limit;
        else this.limit.load(data.limit);
    }
}


class $52b42e68240dfb45$export$d814bc42ca06f7f3 {
    constructor(){
        this.color = new (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa)();
        this.color.value = "#000000";
        this.draggable = false;
        this.opacity = 1;
        this.destroy = true;
        this.orbits = false;
        this.size = new (0, $76f189bead0af748$export$d8af9fbad354c15b)();
    }
    load(data) {
        if (data === undefined) return;
        if (data.color !== undefined) this.color = (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.draggable !== undefined) this.draggable = data.draggable;
        this.name = data.name;
        if (data.opacity !== undefined) this.opacity = data.opacity;
        if (data.position !== undefined) {
            this.position = {};
            if (data.position.x !== undefined) this.position.x = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.position.x);
            if (data.position.y !== undefined) this.position.y = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.position.y);
        }
        if (data.size !== undefined) this.size.load(data.size);
        if (data.destroy !== undefined) this.destroy = data.destroy;
        if (data.orbits !== undefined) this.orbits = data.orbits;
    }
}





class $1f1c45736dc77903$export$2b570af194d8d56d {
    constructor(absorbers, container, options, position){
        this.absorbers = absorbers;
        this.container = container;
        this._calcPosition = ()=>{
            const exactPosition = (0, $a17cb6ec9e2ec6c9$export$b6e437e0d75e3d2c)({
                size: this.container.canvas.size,
                position: this.options.position
            });
            return (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).create(exactPosition.x, exactPosition.y);
        };
        this._updateParticlePosition = (particle, v)=>{
            if (particle.destroyed) return;
            const container = this.container, canvasSize = container.canvas.size;
            if (particle.needsNewPosition) {
                const newPosition = (0, $a17cb6ec9e2ec6c9$export$b19bedb83d642783)({
                    size: canvasSize
                });
                particle.position.setTo(newPosition);
                particle.velocity.setTo(particle.initialVelocity);
                particle.absorberOrbit = undefined;
                particle.needsNewPosition = false;
            }
            if (this.options.orbits) {
                if (particle.absorberOrbit === undefined) {
                    particle.absorberOrbit = (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).create(0, 0);
                    particle.absorberOrbit.length = (0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(particle.getPosition(), this.position);
                    particle.absorberOrbit.angle = (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() * Math.PI * 2;
                }
                if (particle.absorberOrbit.length <= this.size && !this.options.destroy) {
                    const minSize = Math.min(canvasSize.width, canvasSize.height);
                    particle.absorberOrbit.length = minSize * (1 + ((0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() * 0.2 - 0.1));
                }
                if (particle.absorberOrbitDirection === undefined) particle.absorberOrbitDirection = particle.velocity.x >= 0 ? "clockwise" : "counter-clockwise";
                const orbitRadius = particle.absorberOrbit.length, orbitAngle = particle.absorberOrbit.angle, orbitDirection = particle.absorberOrbitDirection;
                particle.velocity.setTo((0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).origin);
                const updateFunc = {
                    x: orbitDirection === "clockwise" ? Math.cos : Math.sin,
                    y: orbitDirection === "clockwise" ? Math.sin : Math.cos
                };
                particle.position.x = this.position.x + orbitRadius * updateFunc.x(orbitAngle);
                particle.position.y = this.position.y + orbitRadius * updateFunc.y(orbitAngle);
                particle.absorberOrbit.length -= v.length;
                particle.absorberOrbit.angle += (particle.retina.moveSpeed ?? 0) * container.retina.pixelRatio / 100 * container.retina.reduceFactor;
            } else {
                const addV = (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).origin;
                addV.length = v.length;
                addV.angle = v.angle;
                particle.velocity.addTo(addV);
            }
        };
        this.initialPosition = position ? (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).create(position.x, position.y) : undefined;
        if (options instanceof (0, $52b42e68240dfb45$export$d814bc42ca06f7f3)) this.options = options;
        else {
            this.options = new (0, $52b42e68240dfb45$export$d814bc42ca06f7f3)();
            this.options.load(options);
        }
        this.dragging = false;
        this.name = this.options.name;
        this.opacity = this.options.opacity;
        this.size = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(this.options.size.value) * container.retina.pixelRatio;
        this.mass = this.size * this.options.size.density * container.retina.reduceFactor;
        const limit = this.options.size.limit;
        this.limit = {
            radius: limit.radius * container.retina.pixelRatio * container.retina.reduceFactor,
            mass: limit.mass
        };
        this.color = (0, $3b20cd3c058d307c$export$fbf0bf3cc1fc0cc4)(this.options.color) ?? {
            b: 0,
            g: 0,
            r: 0
        };
        this.position = this.initialPosition?.copy() ?? this._calcPosition();
    }
    attract(particle) {
        const container = this.container, options = this.options;
        if (options.draggable) {
            const mouse = container.interactivity.mouse;
            if (mouse.clicking && mouse.downPosition) {
                const mouseDist = (0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(this.position, mouse.downPosition);
                if (mouseDist <= this.size) this.dragging = true;
            } else this.dragging = false;
            if (this.dragging && mouse.position) {
                this.position.x = mouse.position.x;
                this.position.y = mouse.position.y;
            }
        }
        const pos = particle.getPosition(), { dx: dx, dy: dy, distance: distance } = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(this.position, pos), v = (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).create(dx, dy);
        v.length = this.mass / Math.pow(distance, 2) * container.retina.reduceFactor;
        if (distance < this.size + particle.getRadius()) {
            const sizeFactor = particle.getRadius() * 0.033 * container.retina.pixelRatio;
            if (this.size > particle.getRadius() && distance < this.size - particle.getRadius() || particle.absorberOrbit !== undefined && particle.absorberOrbit.length < 0) {
                if (options.destroy) particle.destroy();
                else {
                    particle.needsNewPosition = true;
                    this._updateParticlePosition(particle, v);
                }
            } else {
                if (options.destroy) particle.size.value -= sizeFactor;
                this._updateParticlePosition(particle, v);
            }
            if (this.limit.radius <= 0 || this.size < this.limit.radius) this.size += sizeFactor;
            if (this.limit.mass <= 0 || this.mass < this.limit.mass) this.mass += sizeFactor * this.options.size.density * container.retina.reduceFactor;
        } else this._updateParticlePosition(particle, v);
    }
    draw(context) {
        context.translate(this.position.x, this.position.y);
        context.beginPath();
        context.arc(0, 0, this.size, 0, Math.PI * 2, false);
        context.closePath();
        context.fillStyle = (0, $3b20cd3c058d307c$export$2476af37e47fcae2)(this.color, this.opacity);
        context.fill();
    }
    resize() {
        const initialPosition = this.initialPosition;
        this.position = initialPosition && (0, $ab7d474d755ab51b$export$2ea42ef493c7076c)(initialPosition, this.container.canvas.size, (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).origin) ? initialPosition : this._calcPosition();
    }
}


class $c078ce61efa69120$export$2f99069530c9fa2a {
    constructor(container){
        this.container = container;
        this.array = [];
        this.absorbers = [];
        this.interactivityAbsorbers = [];
        container.getAbsorber = (idxOrName)=>idxOrName === undefined || (0, $ab7d474d755ab51b$export$7e4aa119212bc614)(idxOrName) ? this.array[idxOrName || 0] : this.array.find((t)=>t.name === idxOrName);
        container.addAbsorber = (options, position)=>this.addAbsorber(options, position);
    }
    addAbsorber(options, position) {
        const absorber = new (0, $1f1c45736dc77903$export$2b570af194d8d56d)(this, this.container, options, position);
        this.array.push(absorber);
        return absorber;
    }
    draw(context) {
        for (const absorber of this.array)absorber.draw(context);
    }
    handleClickMode(mode) {
        const absorberOptions = this.absorbers, modeAbsorbers = this.interactivityAbsorbers;
        if (mode === "absorber") {
            const absorbersModeOptions = (0, $ab7d474d755ab51b$export$3fbf39566d3ee62e)(modeAbsorbers), absorbersOptions = absorbersModeOptions ?? (0, $ab7d474d755ab51b$export$3fbf39566d3ee62e)(absorberOptions), aPosition = this.container.interactivity.mouse.clickPosition;
            this.addAbsorber(absorbersOptions, aPosition);
        }
    }
    async init() {
        this.absorbers = this.container.actualOptions.absorbers;
        this.interactivityAbsorbers = this.container.actualOptions.interactivity.modes.absorbers;
        (0, $ab7d474d755ab51b$export$8e5dc47097396754)(this.absorbers, (absorber)=>{
            this.addAbsorber(absorber);
        });
    }
    particleUpdate(particle) {
        for (const absorber of this.array){
            absorber.attract(particle);
            if (particle.destroyed) break;
        }
    }
    removeAbsorber(absorber) {
        const index = this.array.indexOf(absorber);
        if (index >= 0) this.array.splice(index, 1);
    }
    resize() {
        for (const absorber of this.array)absorber.resize();
    }
    stop() {
        this.array = [];
    }
}




class $42897151d6182eb9$var$AbsorbersPlugin {
    constructor(){
        this.id = "absorbers";
    }
    getPlugin(container) {
        return new (0, $c078ce61efa69120$export$2f99069530c9fa2a)(container);
    }
    loadOptions(options, source) {
        if (!this.needsPlugin(options) && !this.needsPlugin(source)) return;
        if (source?.absorbers) options.absorbers = (0, $ab7d474d755ab51b$export$8e5dc47097396754)(source.absorbers, (absorber)=>{
            const tmp = new (0, $52b42e68240dfb45$export$d814bc42ca06f7f3)();
            tmp.load(absorber);
            return tmp;
        });
        options.interactivity.modes.absorbers = (0, $ab7d474d755ab51b$export$8e5dc47097396754)(source?.interactivity?.modes?.absorbers, (absorber)=>{
            const tmp = new (0, $52b42e68240dfb45$export$d814bc42ca06f7f3)();
            tmp.load(absorber);
            return tmp;
        });
    }
    needsPlugin(options) {
        if (!options) return false;
        const absorbers = options.absorbers;
        if ((0, $ab7d474d755ab51b$export$43bee75e5e14138e)(absorbers)) return !!absorbers.length;
        else if (absorbers) return true;
        else if (options.interactivity?.events?.onClick?.mode && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("absorber", options.interactivity.events.onClick.mode)) return true;
        return false;
    }
}
async function $42897151d6182eb9$export$c075ef8fc5389119(engine, refresh = true) {
    await engine.addPlugin(new $42897151d6182eb9$var$AbsorbersPlugin(), refresh);
}




class $f9541831c0e28675$export$42db82a3e81a236 {
    load(data) {
        if (!data) return;
        if (data.bottom !== undefined) this.bottom = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.bottom);
        if (data.left !== undefined) this.left = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.left);
        if (data.right !== undefined) this.right = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.right);
        if (data.top !== undefined) this.top = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.top);
    }
}




class $7da801a810aa1523$export$f60d70cc94b5f20b extends (0, $7502aa7b9e2abdb4$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.value = 3;
    }
}



class $34bd675c02911d87$export$fb3eed84de2555ae extends (0, $7502aa7b9e2abdb4$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.value = {
            min: 4,
            max: 9
        };
    }
}


class $0a8338344999a9ad$export$f836382419f64c98 {
    constructor(){
        this.count = 1;
        this.factor = new (0, $7da801a810aa1523$export$f60d70cc94b5f20b)();
        this.rate = new (0, $34bd675c02911d87$export$fb3eed84de2555ae)();
        this.sizeOffset = true;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.count !== undefined) this.count = data.count;
        this.factor.load(data.factor);
        this.rate.load(data.rate);
        this.particles = (0, $ab7d474d755ab51b$export$8e5dc47097396754)(data.particles, (particles)=>{
            return (0, $ab7d474d755ab51b$export$54e9fb29908872fa)({}, particles);
        });
        if (data.sizeOffset !== undefined) this.sizeOffset = data.sizeOffset;
        if (data.colorOffset) {
            this.colorOffset = this.colorOffset ?? {};
            if (data.colorOffset.h !== undefined) this.colorOffset.h = data.colorOffset.h;
            if (data.colorOffset.s !== undefined) this.colorOffset.s = data.colorOffset.s;
            if (data.colorOffset.l !== undefined) this.colorOffset.l = data.colorOffset.l;
        }
    }
}


class $a6f4273cc053842f$export$a52d062350622d8e {
    constructor(){
        this.bounds = new (0, $f9541831c0e28675$export$42db82a3e81a236)();
        this.mode = "none";
        this.split = new (0, $0a8338344999a9ad$export$f836382419f64c98)();
    }
    load(data) {
        if (!data) return;
        if (data.mode) this.mode = data.mode;
        if (data.bounds) this.bounds.load(data.bounds);
        this.split.load(data.split);
    }
}



function $72ec054534453931$var$addSplitParticle(engine, container, parent, splitParticlesOptions) {
    const destroyOptions = parent.options.destroy;
    if (!destroyOptions) return;
    const splitOptions = destroyOptions.split, options = (0, $5364e7fd152e0675$export$3e14721506027822)(engine, container, parent.options), factor = (0, $a17cb6ec9e2ec6c9$export$bf7199a9ebcb84a9)(splitOptions.factor), parentColor = parent.getFillColor();
    if (splitOptions.color) options.color.load(splitOptions.color);
    else if (splitOptions.colorOffset && parentColor) options.color.load({
        value: {
            hsl: {
                h: parentColor.h + (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(splitOptions.colorOffset.h ?? 0),
                s: parentColor.s + (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(splitOptions.colorOffset.s ?? 0),
                l: parentColor.l + (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(splitOptions.colorOffset.l ?? 0)
            }
        }
    });
    else options.color.load({
        value: {
            hsl: parent.getFillColor()
        }
    });
    options.move.load({
        center: {
            x: parent.position.x,
            y: parent.position.y,
            mode: "precise"
        }
    });
    if ((0, $ab7d474d755ab51b$export$7e4aa119212bc614)(options.size.value)) options.size.value /= factor;
    else {
        options.size.value.min /= factor;
        options.size.value.max /= factor;
    }
    options.load(splitParticlesOptions);
    const offset = splitOptions.sizeOffset ? (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(-parent.size.value, parent.size.value) : 0, position = {
        x: parent.position.x + (0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)(offset),
        y: parent.position.y + (0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)(offset)
    };
    return container.particles.addParticle(position, options, parent.group, (particle)=>{
        if (particle.size.value < 0.5) return false;
        particle.velocity.length = (0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)((0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(parent.velocity.length, particle.velocity.length));
        particle.splitCount = (parent.splitCount ?? 0) + 1;
        particle.unbreakable = true;
        setTimeout(()=>{
            particle.unbreakable = false;
        }, 500);
        return true;
    });
}
function $72ec054534453931$export$65980d18b75784e2(engine, container, particle) {
    const destroyOptions = particle.options.destroy;
    if (!destroyOptions) return;
    const splitOptions = destroyOptions.split;
    if (splitOptions.count >= 0 && (particle.splitCount === undefined || particle.splitCount++ > splitOptions.count)) return;
    const rate = (0, $a17cb6ec9e2ec6c9$export$bf7199a9ebcb84a9)(splitOptions.rate), particlesSplitOptions = (0, $ab7d474d755ab51b$export$3fbf39566d3ee62e)(splitOptions.particles);
    for(let i = 0; i < rate; i++)$72ec054534453931$var$addSplitParticle(engine, container, particle, particlesSplitOptions);
}


class $9c7dd641a5510ba7$export$fbfd6049edb6af01 {
    constructor(engine, container){
        this.engine = engine;
        this.container = container;
    }
    init(particle) {
        const container = this.container, particlesOptions = particle.options, destroyOptions = particlesOptions.destroy;
        if (!destroyOptions) return;
        particle.splitCount = 0;
        const destroyBoundsOptions = destroyOptions.bounds;
        if (!particle.destroyBounds) particle.destroyBounds = {};
        const { bottom: bottom, left: left, right: right, top: top } = destroyBoundsOptions, { destroyBounds: destroyBounds } = particle, canvasSize = container.canvas.size;
        if (bottom) destroyBounds.bottom = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(bottom) * canvasSize.height / 100;
        if (left) destroyBounds.left = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(left) * canvasSize.width / 100;
        if (right) destroyBounds.right = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(right) * canvasSize.width / 100;
        if (top) destroyBounds.top = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(top) * canvasSize.height / 100;
    }
    isEnabled(particle) {
        return !particle.destroyed;
    }
    loadOptions(options, ...sources) {
        if (!options.destroy) options.destroy = new (0, $a6f4273cc053842f$export$a52d062350622d8e)();
        for (const source of sources)options.destroy.load(source?.destroy);
    }
    particleDestroyed(particle, override) {
        if (override) return;
        const destroyOptions = particle.options.destroy;
        if (destroyOptions && destroyOptions.mode === "split") (0, $72ec054534453931$export$65980d18b75784e2)(this.engine, this.container, particle);
    }
    update(particle) {
        if (!this.isEnabled(particle)) return;
        const position = particle.getPosition(), bounds = particle.destroyBounds;
        if (!bounds) return;
        if (bounds.bottom !== undefined && position.y >= bounds.bottom || bounds.left !== undefined && position.x <= bounds.left || bounds.right !== undefined && position.x >= bounds.right || bounds.top !== undefined && position.y <= bounds.top) particle.destroy();
    }
}


async function $70fac5c29cb0a44a$export$d6d9d65fda83a7c5(engine, refresh = true) {
    await engine.addParticleUpdater("destroy", (container)=>new (0, $9c7dd641a5510ba7$export$fbfd6049edb6af01)(engine, container), refresh);
}




class $701da279b51584f8$export$2c0b65c9c7b57845 {
    randomPosition(position, size, fill) {
        const generateTheta = (x, y)=>{
            const u = (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() / 4.0, theta = Math.atan(y / x * Math.tan(2 * Math.PI * u)), v = (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)();
            if (v < 0.25) return theta;
            else if (v < 0.5) return Math.PI - theta;
            else if (v < 0.75) return Math.PI + theta;
            else return -theta;
        }, radius = (x, y, theta)=>x * y / Math.sqrt((y * Math.cos(theta)) ** 2 + (x * Math.sin(theta)) ** 2), [a, b] = [
            size.width / 2,
            size.height / 2
        ], randomTheta = generateTheta(a, b), maxRadius = radius(a, b, randomTheta), randomRadius = fill ? maxRadius * Math.sqrt((0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)()) : maxRadius;
        return {
            x: position.x + randomRadius * Math.cos(randomTheta),
            y: position.y + randomRadius * Math.sin(randomTheta)
        };
    }
}




class $24c9732b859ed86b$export$99c2b8efc08054b {
    constructor(){
        this.wait = false;
    }
    load(data) {
        if (!data) return;
        if (data.count !== undefined) this.count = data.count;
        if (data.delay !== undefined) this.delay = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.delay);
        if (data.duration !== undefined) this.duration = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.duration);
        if (data.wait !== undefined) this.wait = data.wait;
    }
}



class $d3298b89c7a40bf0$export$c3191dc230acef25 {
    constructor(){
        this.quantity = 1;
        this.delay = 0.1;
    }
    load(data) {
        if (data === undefined) return;
        if (data.quantity !== undefined) this.quantity = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.quantity);
        if (data.delay !== undefined) this.delay = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.delay);
    }
}


class $87316bce2e7b41c6$export$a8f8ab30882c6cf0 {
    constructor(){
        this.mode = "percent";
        this.height = 0;
        this.width = 0;
    }
    load(data) {
        if (data === undefined) return;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.height !== undefined) this.height = data.height;
        if (data.width !== undefined) this.width = data.width;
    }
}


class $7bd6215af5b1a31a$export$4293555f241ae35a {
    constructor(){
        this.autoPlay = true;
        this.fill = true;
        this.life = new (0, $24c9732b859ed86b$export$99c2b8efc08054b)();
        this.rate = new (0, $d3298b89c7a40bf0$export$c3191dc230acef25)();
        this.shape = "square";
        this.startCount = 0;
    }
    load(data) {
        if (!data) return;
        if (data.autoPlay !== undefined) this.autoPlay = data.autoPlay;
        if (data.size !== undefined) {
            if (!this.size) this.size = new (0, $87316bce2e7b41c6$export$a8f8ab30882c6cf0)();
            this.size.load(data.size);
        }
        if (data.direction !== undefined) this.direction = data.direction;
        this.domId = data.domId;
        if (data.fill !== undefined) this.fill = data.fill;
        this.life.load(data.life);
        this.name = data.name;
        this.particles = (0, $ab7d474d755ab51b$export$8e5dc47097396754)(data.particles, (particles)=>{
            return (0, $ab7d474d755ab51b$export$54e9fb29908872fa)({}, particles);
        });
        this.rate.load(data.rate);
        if (data.shape !== undefined) this.shape = data.shape;
        if (data.position !== undefined) {
            this.position = {};
            if (data.position.x !== undefined) this.position.x = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.position.x);
            if (data.position.y !== undefined) this.position.y = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.position.y);
        }
        if (data.spawnColor !== undefined) {
            if (this.spawnColor === undefined) this.spawnColor = new (0, $8bb543fb93ff69a6$export$6f79b6ff75533155)();
            this.spawnColor.load(data.spawnColor);
        }
        if (data.startCount !== undefined) this.startCount = data.startCount;
    }
}







class $e1ac84f4bb51ec43$export$834c246832f0a6df {
    constructor(engine, emitters, container, options, position){
        this.emitters = emitters;
        this.container = container;
        this._calcPosition = ()=>{
            return (0, $a17cb6ec9e2ec6c9$export$b6e437e0d75e3d2c)({
                size: this.container.canvas.size,
                position: this.options.position
            });
        };
        this._destroy = ()=>{
            this.emitters.removeEmitter(this);
            this._engine.dispatchEvent("emitterDestroyed", {
                container: this.container,
                data: {
                    emitter: this
                }
            });
        };
        this._emit = ()=>{
            if (this._paused) return;
            const quantity = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(this.options.rate.quantity);
            this._emitParticles(quantity);
        };
        this._emitParticles = (quantity)=>{
            const position = this.getPosition(), size = this.getSize(), singleParticlesOptions = (0, $ab7d474d755ab51b$export$3fbf39566d3ee62e)(this._particlesOptions);
            for(let i = 0; i < quantity; i++){
                const particlesOptions = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)({}, singleParticlesOptions);
                if (this.spawnColor) {
                    const hslAnimation = this.options.spawnColor?.animation;
                    if (hslAnimation) {
                        this.spawnColor.h = this._setColorAnimation(hslAnimation.h, this.spawnColor.h, 360);
                        this.spawnColor.s = this._setColorAnimation(hslAnimation.s, this.spawnColor.s, 100);
                        this.spawnColor.l = this._setColorAnimation(hslAnimation.l, this.spawnColor.l, 100);
                    }
                    if (!particlesOptions.color) particlesOptions.color = {
                        value: this.spawnColor
                    };
                    else particlesOptions.color.value = this.spawnColor;
                }
                if (!position) return;
                const pPosition = this._shape?.randomPosition(position, size, this.fill) ?? position;
                this.container.particles.addParticle(pPosition, particlesOptions);
            }
        };
        this._prepareToDie = ()=>{
            if (this._paused) return;
            const duration = this.options.life?.duration !== undefined ? (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(this.options.life.duration) : undefined;
            if (this.container.retina.reduceFactor && (this._lifeCount > 0 || this._immortal) && duration !== undefined && duration > 0) this._duration = duration * 1000;
        };
        this._setColorAnimation = (animation, initValue, maxValue)=>{
            const container = this.container;
            if (!animation.enable) return initValue;
            const colorOffset = (0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)(animation.offset), delay = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(this.options.rate.delay), emitFactor = 1000 * delay / container.retina.reduceFactor, colorSpeed = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(animation.speed ?? 0);
            return (initValue + colorSpeed * container.fpsLimit / emitFactor + colorOffset * 3.6) % maxValue;
        };
        this._engine = engine;
        this._currentDuration = 0;
        this._currentEmitDelay = 0;
        this._currentSpawnDelay = 0;
        this._initialPosition = position;
        if (options instanceof (0, $7bd6215af5b1a31a$export$4293555f241ae35a)) this.options = options;
        else {
            this.options = new (0, $7bd6215af5b1a31a$export$4293555f241ae35a)();
            this.options.load(options);
        }
        this._spawnDelay = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(this.options.life.delay ?? 0) * 1000 / this.container.retina.reduceFactor;
        this.position = this._initialPosition ?? this._calcPosition();
        this.name = this.options.name;
        this._shape = this._engine.emitterShapeManager?.getShape(this.options.shape);
        this.fill = this.options.fill;
        this._firstSpawn = !this.options.life.wait;
        this._startParticlesAdded = false;
        let particlesOptions = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)({}, this.options.particles);
        particlesOptions ??= {};
        particlesOptions.move ??= {};
        particlesOptions.move.direction ??= this.options.direction;
        if (this.options.spawnColor) this.spawnColor = (0, $3b20cd3c058d307c$export$79a89086521c0f12)(this.options.spawnColor);
        this._paused = !this.options.autoPlay;
        this._particlesOptions = particlesOptions;
        this.size = this.options.size ?? (()=>{
            const size = new (0, $87316bce2e7b41c6$export$a8f8ab30882c6cf0)();
            size.load({
                height: 0,
                mode: "percent",
                width: 0
            });
            return size;
        })();
        this._lifeCount = this.options.life.count ?? -1;
        this._immortal = this._lifeCount <= 0;
        this._engine.dispatchEvent("emitterCreated", {
            container: container,
            data: {
                emitter: this
            }
        });
        this.play();
    }
    externalPause() {
        this._paused = true;
        this.pause();
    }
    externalPlay() {
        this._paused = false;
        this.play();
    }
    getPosition() {
        if (this.options.domId) {
            const container = this.container, element = document.getElementById(this.options.domId);
            if (element) {
                const elRect = element.getBoundingClientRect();
                return {
                    x: (elRect.x + elRect.width / 2) * container.retina.pixelRatio,
                    y: (elRect.y + elRect.height / 2) * container.retina.pixelRatio
                };
            }
        }
        return this.position;
    }
    getSize() {
        const container = this.container;
        if (this.options.domId) {
            const element = document.getElementById(this.options.domId);
            if (element) {
                const elRect = element.getBoundingClientRect();
                return {
                    width: elRect.width * container.retina.pixelRatio,
                    height: elRect.height * container.retina.pixelRatio
                };
            }
        }
        return (0, $ab7d474d755ab51b$export$31b21d0167753bb4)(this.size, container.canvas.size);
    }
    pause() {
        if (this._paused) return;
        delete this._emitDelay;
    }
    play() {
        if (this._paused) return;
        if (!(this.container.retina.reduceFactor && (this._lifeCount > 0 || this._immortal || !this.options.life.count) && (this._firstSpawn || this._currentSpawnDelay >= (this._spawnDelay ?? 0)))) return;
        if (this._emitDelay === undefined) {
            const delay = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(this.options.rate.delay);
            this._emitDelay = 1000 * delay / this.container.retina.reduceFactor;
        }
        if (this._lifeCount > 0 || this._immortal) this._prepareToDie();
    }
    resize() {
        const initialPosition = this._initialPosition;
        this.position = initialPosition && (0, $ab7d474d755ab51b$export$2ea42ef493c7076c)(initialPosition, this.container.canvas.size, (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).origin) ? initialPosition : this._calcPosition();
    }
    update(delta) {
        if (this._paused) return;
        if (this._firstSpawn) {
            this._firstSpawn = false;
            this._currentSpawnDelay = this._spawnDelay ?? 0;
            this._currentEmitDelay = this._emitDelay ?? 0;
        }
        if (!this._startParticlesAdded) {
            this._startParticlesAdded = true;
            this._emitParticles(this.options.startCount);
        }
        if (this._duration !== undefined) {
            this._currentDuration += delta.value;
            if (this._currentDuration >= this._duration) {
                this.pause();
                if (this._spawnDelay !== undefined) delete this._spawnDelay;
                if (!this._immortal) this._lifeCount--;
                if (this._lifeCount > 0 || this._immortal) {
                    this.position = this._calcPosition();
                    this._spawnDelay = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(this.options.life.delay ?? 0) * 1000 / this.container.retina.reduceFactor;
                } else this._destroy();
                this._currentDuration -= this._duration;
                delete this._duration;
            }
        }
        if (this._spawnDelay !== undefined) {
            this._currentSpawnDelay += delta.value;
            if (this._currentSpawnDelay >= this._spawnDelay) {
                this._engine.dispatchEvent("emitterPlay", {
                    container: this.container
                });
                this.play();
                this._currentSpawnDelay -= this._currentSpawnDelay;
                delete this._spawnDelay;
            }
        }
        if (this._emitDelay !== undefined) {
            this._currentEmitDelay += delta.value;
            if (this._currentEmitDelay >= this._emitDelay) {
                this._emit();
                this._currentEmitDelay -= this._emitDelay;
            }
        }
    }
}


class $e30563ade1a52dd6$export$774a0fdf08f5f4fd {
    constructor(engine, container){
        this.container = container;
        this._engine = engine;
        this.array = [];
        this.emitters = [];
        this.interactivityEmitters = {
            random: {
                count: 1,
                enable: false
            },
            value: []
        };
        container.getEmitter = (idxOrName)=>idxOrName === undefined || (0, $ab7d474d755ab51b$export$7e4aa119212bc614)(idxOrName) ? this.array[idxOrName || 0] : this.array.find((t)=>t.name === idxOrName);
        container.addEmitter = (options, position)=>this.addEmitter(options, position);
        container.removeEmitter = (idxOrName)=>{
            const emitter = container.getEmitter(idxOrName);
            if (emitter) this.removeEmitter(emitter);
        };
        container.playEmitter = (idxOrName)=>{
            const emitter = container.getEmitter(idxOrName);
            if (emitter) emitter.externalPlay();
        };
        container.pauseEmitter = (idxOrName)=>{
            const emitter = container.getEmitter(idxOrName);
            if (emitter) emitter.externalPause();
        };
    }
    addEmitter(options, position) {
        const emitterOptions = new (0, $7bd6215af5b1a31a$export$4293555f241ae35a)();
        emitterOptions.load(options);
        const emitter = new (0, $e1ac84f4bb51ec43$export$834c246832f0a6df)(this._engine, this, this.container, emitterOptions, position);
        this.array.push(emitter);
        return emitter;
    }
    handleClickMode(mode) {
        const emitterOptions = this.emitters, modeEmitters = this.interactivityEmitters;
        if (mode !== "emitter") return;
        let emittersModeOptions;
        if (modeEmitters && (0, $ab7d474d755ab51b$export$43bee75e5e14138e)(modeEmitters.value)) {
            if (modeEmitters.value.length > 0 && modeEmitters.random.enable) {
                emittersModeOptions = [];
                const usedIndexes = [];
                for(let i = 0; i < modeEmitters.random.count; i++){
                    const idx = (0, $ab7d474d755ab51b$export$aab6d48e027939d7)(modeEmitters.value);
                    if (usedIndexes.includes(idx) && usedIndexes.length < modeEmitters.value.length) {
                        i--;
                        continue;
                    }
                    usedIndexes.push(idx);
                    emittersModeOptions.push((0, $ab7d474d755ab51b$export$3a5d12ca7137122f)(modeEmitters.value, idx));
                }
            } else emittersModeOptions = modeEmitters.value;
        } else emittersModeOptions = modeEmitters?.value;
        const emittersOptions = emittersModeOptions ?? emitterOptions, ePosition = this.container.interactivity.mouse.clickPosition;
        (0, $ab7d474d755ab51b$export$8e5dc47097396754)(emittersOptions, (emitter)=>{
            this.addEmitter(emitter, ePosition);
        });
    }
    async init() {
        this.emitters = this.container.actualOptions.emitters;
        this.interactivityEmitters = this.container.actualOptions.interactivity.modes.emitters;
        if (!this.emitters) return;
        if ((0, $ab7d474d755ab51b$export$43bee75e5e14138e)(this.emitters)) for (const emitterOptions of this.emitters)this.addEmitter(emitterOptions);
        else this.addEmitter(this.emitters);
    }
    pause() {
        for (const emitter of this.array)emitter.pause();
    }
    play() {
        for (const emitter of this.array)emitter.play();
    }
    removeEmitter(emitter) {
        const index = this.array.indexOf(emitter);
        if (index >= 0) this.array.splice(index, 1);
    }
    resize() {
        for (const emitter of this.array)emitter.resize();
    }
    stop() {
        this.array = [];
    }
    update(delta) {
        for (const emitter of this.array)emitter.update(delta);
    }
}


const $047889b3ba33c3a8$var$shapes = new Map();
class $047889b3ba33c3a8$export$29ab17701a3c76b1 {
    constructor(engine){
        this._engine = engine;
    }
    addShape(name, drawer) {
        if (!this.getShape(name)) $047889b3ba33c3a8$var$shapes.set(name, drawer);
    }
    getShape(name) {
        return $047889b3ba33c3a8$var$shapes.get(name);
    }
    getSupportedShapes() {
        return $047889b3ba33c3a8$var$shapes.keys();
    }
}



function $6d9636fc47a5889e$var$randomSquareCoordinate(position, offset) {
    return position + offset * ((0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() - 0.5);
}
class $6d9636fc47a5889e$export$4997d9812dc325b0 {
    randomPosition(position, size, fill) {
        if (fill) return {
            x: $6d9636fc47a5889e$var$randomSquareCoordinate(position.x, size.width),
            y: $6d9636fc47a5889e$var$randomSquareCoordinate(position.y, size.height)
        };
        else {
            const halfW = size.width / 2, halfH = size.height / 2, side = Math.floor((0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() * 4), v = ((0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() - 0.5) * 2;
            switch(side){
                case 0:
                    return {
                        x: position.x + v * halfW,
                        y: position.y - halfH
                    };
                case 1:
                    return {
                        x: position.x - halfW,
                        y: position.y + v * halfH
                    };
                case 2:
                    return {
                        x: position.x + v * halfW,
                        y: position.y + halfH
                    };
                case 3:
                default:
                    return {
                        x: position.x + halfW,
                        y: position.y + v * halfH
                    };
            }
        }
    }
}






class $1a007bc42ebfebf1$var$EmittersPlugin {
    constructor(engine){
        this._engine = engine;
        this.id = "emitters";
    }
    getPlugin(container) {
        return new (0, $e30563ade1a52dd6$export$774a0fdf08f5f4fd)(this._engine, container);
    }
    loadOptions(options, source) {
        if (!this.needsPlugin(options) && !this.needsPlugin(source)) return;
        if (source?.emitters) options.emitters = (0, $ab7d474d755ab51b$export$8e5dc47097396754)(source.emitters, (emitter)=>{
            const tmp = new (0, $7bd6215af5b1a31a$export$4293555f241ae35a)();
            tmp.load(emitter);
            return tmp;
        });
        const interactivityEmitters = source?.interactivity?.modes?.emitters;
        if (interactivityEmitters) {
            if ((0, $ab7d474d755ab51b$export$43bee75e5e14138e)(interactivityEmitters)) options.interactivity.modes.emitters = {
                random: {
                    count: 1,
                    enable: true
                },
                value: interactivityEmitters.map((s)=>{
                    const tmp = new (0, $7bd6215af5b1a31a$export$4293555f241ae35a)();
                    tmp.load(s);
                    return tmp;
                })
            };
            else {
                const emitterMode = interactivityEmitters;
                if (emitterMode.value !== undefined) {
                    if ((0, $ab7d474d755ab51b$export$43bee75e5e14138e)(emitterMode.value)) options.interactivity.modes.emitters = {
                        random: {
                            count: emitterMode.random.count ?? 1,
                            enable: emitterMode.random.enable ?? false
                        },
                        value: emitterMode.value.map((s)=>{
                            const tmp = new (0, $7bd6215af5b1a31a$export$4293555f241ae35a)();
                            tmp.load(s);
                            return tmp;
                        })
                    };
                    else {
                        const tmp = new (0, $7bd6215af5b1a31a$export$4293555f241ae35a)();
                        tmp.load(emitterMode.value);
                        options.interactivity.modes.emitters = {
                            random: {
                                count: emitterMode.random.count ?? 1,
                                enable: emitterMode.random.enable ?? false
                            },
                            value: tmp
                        };
                    }
                } else {
                    const emitterOptions = options.interactivity.modes.emitters = {
                        random: {
                            count: 1,
                            enable: false
                        },
                        value: new (0, $7bd6215af5b1a31a$export$4293555f241ae35a)()
                    };
                    emitterOptions.value.load(interactivityEmitters);
                }
            }
        }
    }
    needsPlugin(options) {
        if (!options) return false;
        const emitters = options.emitters;
        return (0, $ab7d474d755ab51b$export$43bee75e5e14138e)(emitters) && !!emitters.length || emitters !== undefined || !!options.interactivity?.events?.onClick?.mode && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("emitter", options.interactivity.events.onClick.mode);
    }
}
async function $1a007bc42ebfebf1$export$e4e45ab97167d364(engine, refresh = true) {
    if (!engine.emitterShapeManager) engine.emitterShapeManager = new (0, $047889b3ba33c3a8$export$29ab17701a3c76b1)(engine);
    if (!engine.addEmitterShape) engine.addEmitterShape = (name, shape)=>{
        engine.emitterShapeManager?.addShape(name, shape);
    };
    const plugin = new $1a007bc42ebfebf1$var$EmittersPlugin(engine);
    await engine.addPlugin(plugin, refresh);
    engine.addEmitterShape("circle", new (0, $701da279b51584f8$export$2c0b65c9c7b57845)());
    engine.addEmitterShape("square", new (0, $6d9636fc47a5889e$export$4997d9812dc325b0)());
}




class $596c91415cfcf1ce$export$3b8b9d47fbf8fd2b {
    constructor(){
        this.delay = 1;
        this.pauseOnStop = false;
        this.quantity = 1;
    }
    load(data) {
        if (!data) return;
        if (data.delay !== undefined) this.delay = data.delay;
        if (data.quantity !== undefined) this.quantity = data.quantity;
        if (data.particles !== undefined) this.particles = (0, $ab7d474d755ab51b$export$54e9fb29908872fa)({}, data.particles);
        if (data.pauseOnStop !== undefined) this.pauseOnStop = data.pauseOnStop;
    }
}


class $ce836609eace6991$export$7e8e09e16f016468 extends (0, $a34f6e88dd5ec1a0$export$6e252256471acc61) {
    constructor(container){
        super(container);
        this._delay = 0;
    }
    clear() {}
    init() {}
    async interact(delta) {
        const container = this.container, { interactivity: interactivity } = container;
        if (!container.retina.reduceFactor) return;
        const options = container.actualOptions, trailOptions = options.interactivity.modes.trail;
        if (!trailOptions) return;
        const optDelay = trailOptions.delay * 1000 / this.container.retina.reduceFactor;
        if (this._delay < optDelay) this._delay += delta.value;
        if (this._delay < optDelay) return;
        const canEmit = !(trailOptions.pauseOnStop && (interactivity.mouse.position === this._lastPosition || interactivity.mouse.position?.x === this._lastPosition?.x && interactivity.mouse.position?.y === this._lastPosition?.y));
        const mousePos = container.interactivity.mouse.position;
        if (mousePos) this._lastPosition = {
            ...mousePos
        };
        else delete this._lastPosition;
        if (canEmit) container.particles.push(trailOptions.quantity, container.interactivity.mouse, trailOptions.particles);
        this._delay -= optDelay;
    }
    isEnabled(particle) {
        const container = this.container, options = container.actualOptions, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? options.interactivity).events;
        return mouse.clicking && mouse.inside && !!mouse.position && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("trail", events.onClick.mode) || mouse.inside && !!mouse.position && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("trail", events.onHover.mode);
    }
    loadModeOptions(options, ...sources) {
        if (!options.trail) options.trail = new (0, $596c91415cfcf1ce$export$3b8b9d47fbf8fd2b)();
        for (const source of sources)options.trail.load(source?.trail);
    }
    reset() {}
}




async function $c0010aba0f836e71$export$9e84d16a6473365f(engine, refresh = true) {
    await engine.addInteractor("externalTrail", (container)=>new (0, $ce836609eace6991$export$7e8e09e16f016468)(container), refresh);
}



function $6f167b069966a770$export$5f19b033575b4930(particle) {
    const rollOpt = particle.options.roll;
    if (!rollOpt?.enable) {
        particle.roll = {
            enable: false,
            horizontal: false,
            vertical: false,
            angle: 0,
            speed: 0
        };
        return;
    }
    particle.roll = {
        enable: rollOpt.enable,
        horizontal: rollOpt.mode === "horizontal" || rollOpt.mode === "both",
        vertical: rollOpt.mode === "vertical" || rollOpt.mode === "both",
        angle: (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() * Math.PI * 2,
        speed: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(rollOpt.speed) / 360
    };
    if (rollOpt.backColor) particle.backColor = (0, $3b20cd3c058d307c$export$79a89086521c0f12)(rollOpt.backColor);
    else if (rollOpt.darken.enable && rollOpt.enlighten.enable) {
        const alterType = (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() >= 0.5 ? "darken" : "enlighten";
        particle.roll.alter = {
            type: alterType,
            value: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(alterType === "darken" ? rollOpt.darken.value : rollOpt.enlighten.value)
        };
    } else if (rollOpt.darken.enable) particle.roll.alter = {
        type: "darken",
        value: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(rollOpt.darken.value)
    };
    else if (rollOpt.enlighten.enable) particle.roll.alter = {
        type: "enlighten",
        value: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(rollOpt.enlighten.value)
    };
}
function $6f167b069966a770$export$449a3d30f609ff1a(particle, delta) {
    const roll = particle.options.roll, data = particle.roll;
    if (!data || !roll?.enable) return;
    const speed = data.speed * delta.factor, max = 2 * Math.PI;
    data.angle += speed;
    if (data.angle > max) data.angle -= max;
}




class $9adf47a26008d8f2$export$16e8cbb26bb35e82 {
    constructor(){
        this.enable = false;
        this.value = 0;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.value !== undefined) this.value = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.value);
    }
}


class $55b29b8ac74d615b$export$aa11096b70371f74 {
    constructor(){
        this.darken = new (0, $9adf47a26008d8f2$export$16e8cbb26bb35e82)();
        this.enable = false;
        this.enlighten = new (0, $9adf47a26008d8f2$export$16e8cbb26bb35e82)();
        this.mode = "vertical";
        this.speed = 25;
    }
    load(data) {
        if (!data) return;
        if (data.backColor !== undefined) this.backColor = (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa).create(this.backColor, data.backColor);
        this.darken.load(data.darken);
        if (data.enable !== undefined) this.enable = data.enable;
        this.enlighten.load(data.enlighten);
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.speed !== undefined) this.speed = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.speed);
    }
}


class $579e611608cf9600$export$b21adf6f4d6d0a6a {
    getTransformValues(particle) {
        const roll = particle.roll?.enable && particle.roll, rollHorizontal = roll && roll.horizontal, rollVertical = roll && roll.vertical;
        return {
            a: rollHorizontal ? Math.cos(roll.angle) : undefined,
            d: rollVertical ? Math.sin(roll.angle) : undefined
        };
    }
    init(particle) {
        (0, $6f167b069966a770$export$5f19b033575b4930)(particle);
    }
    isEnabled(particle) {
        const roll = particle.options.roll;
        return !particle.destroyed && !particle.spawning && !!roll?.enable;
    }
    loadOptions(options, ...sources) {
        if (!options.roll) options.roll = new (0, $55b29b8ac74d615b$export$aa11096b70371f74)();
        for (const source of sources)options.roll.load(source?.roll);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        (0, $6f167b069966a770$export$449a3d30f609ff1a)(particle, delta);
    }
}


async function $0dd796cea7ba1996$export$9a3fb111b9c845ed(engine, refresh = true) {
    await engine.addParticleUpdater("roll", ()=>new (0, $579e611608cf9600$export$b21adf6f4d6d0a6a)(), refresh);
}



class $d7b5b891432eda2b$export$ec4bceef241d2e36 {
    static init(options) {
        const particles = new $d7b5b891432eda2b$export$ec4bceef241d2e36(), selector = options.selector;
        if (!selector) throw new Error("No selector provided");
        const el = document.querySelector(selector);
        if (!el) throw new Error("No element found for selector");
        (0, $0f2f44e3fd1f51bb$export$218c38ca7c058037).set(selector.replace(".", "").replace("!", ""), el, {
            fullScreen: {
                enable: false
            },
            particles: {
                color: {
                    value: options.color ?? "!000000"
                },
                links: {
                    color: "random",
                    distance: options.minDistance ?? 120,
                    enable: options.connectParticles ?? false
                },
                move: {
                    enable: true,
                    speed: options.speed ?? 0.5
                },
                number: {
                    value: options.maxParticles ?? 100
                },
                size: {
                    value: {
                        min: 1,
                        max: options.sizeVariations ?? 3
                    }
                }
            },
            responsive: options.responsive?.map((responsive)=>({
                    maxWidth: responsive.breakpoint,
                    options: {
                        particles: {
                            color: {
                                value: responsive.options?.color
                            },
                            links: {
                                distance: responsive.options?.minDistance,
                                enable: responsive.options?.connectParticles
                            },
                            number: {
                                value: options.maxParticles
                            },
                            move: {
                                enable: true,
                                speed: responsive.options?.speed
                            },
                            size: {
                                value: responsive.options?.sizeVariations
                            }
                        }
                    }
                }))
        }).then((container)=>{
            particles._container = container;
        });
        return particles;
    }
    destroy() {
        const container = this._container;
        container && container.destroy();
    }
    pauseAnimation() {
        const container = this._container;
        container && container.pause();
    }
    resumeAnimation() {
        const container = this._container;
        container && container.play();
    }
}


const $9579253d30183de7$export$761851227521c078 = (engine)=>{
    const particlesJS = (tagId, options)=>{
        return engine.load(tagId, options);
    };
    particlesJS.load = (tagId, pathConfigJson, callback)=>{
        engine.loadJSON(tagId, pathConfigJson).then((container)=>{
            if (container) callback(container);
        }).catch(()=>{
            callback(undefined);
        });
    };
    particlesJS.setOnClickHandler = (callback)=>{
        engine.setOnClickHandler(callback);
    };
    const pJSDom = engine.dom();
    return {
        particlesJS: particlesJS,
        pJSDom: pJSDom
    };
};


const $ffd9f3ff3605eca0$export$4948e8af77cbffab = (engine)=>{
    const { particlesJS: particlesJS, pJSDom: pJSDom } = (0, $9579253d30183de7$export$761851227521c078)(engine);
    window.particlesJS = particlesJS;
    window.pJSDom = pJSDom;
    window.Particles = (0, $d7b5b891432eda2b$export$ec4bceef241d2e36);
    return {
        particlesJS: particlesJS,
        pJSDom: pJSDom,
        Particles: $d7b5b891432eda2b$export$ec4bceef241d2e36
    };
};




function $6b5c1efe8aec39c8$export$21d7e305c937fbb2(particle) {
    const initialPosition = particle.initialPosition, { dx: dx, dy: dy } = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(initialPosition, particle.position), dxFixed = Math.abs(dx), dyFixed = Math.abs(dy), { maxDistance: maxDistance } = particle.retina, hDistance = maxDistance.horizontal, vDistance = maxDistance.vertical;
    if (!hDistance && !vDistance) return;
    if ((hDistance && dxFixed >= hDistance || vDistance && dyFixed >= vDistance) && !particle.misplaced) {
        particle.misplaced = !!hDistance && dxFixed > hDistance || !!vDistance && dyFixed > vDistance;
        if (hDistance) particle.velocity.x = particle.velocity.y / 2 - particle.velocity.x;
        if (vDistance) particle.velocity.y = particle.velocity.x / 2 - particle.velocity.y;
    } else if ((!hDistance || dxFixed < hDistance) && (!vDistance || dyFixed < vDistance) && particle.misplaced) particle.misplaced = false;
    else if (particle.misplaced) {
        const pos = particle.position, vel = particle.velocity;
        if (hDistance && (pos.x < initialPosition.x && vel.x < 0 || pos.x > initialPosition.x && vel.x > 0)) vel.x *= -(0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)();
        if (vDistance && (pos.y < initialPosition.y && vel.y < 0 || pos.y > initialPosition.y && vel.y > 0)) vel.y *= -(0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)();
    }
}
function $6b5c1efe8aec39c8$export$d947e5f4f4c48d48(particle, moveOptions, moveSpeed, maxSpeed, moveDrift, delta) {
    $6b5c1efe8aec39c8$export$2d1dd1364a451835(particle, delta);
    const gravityOptions = particle.gravity, gravityFactor = gravityOptions?.enable && gravityOptions.inverse ? -1 : 1;
    if (moveDrift && moveSpeed) particle.velocity.x += moveDrift * delta.factor / (60 * moveSpeed);
    if (gravityOptions?.enable && moveSpeed) particle.velocity.y += gravityFactor * (gravityOptions.acceleration * delta.factor) / (60 * moveSpeed);
    const decay = particle.moveDecay;
    particle.velocity.multTo(decay);
    const velocity = particle.velocity.mult(moveSpeed);
    if (gravityOptions?.enable && maxSpeed > 0 && (!gravityOptions.inverse && velocity.y >= 0 && velocity.y >= maxSpeed || gravityOptions.inverse && velocity.y <= 0 && velocity.y <= -maxSpeed)) {
        velocity.y = gravityFactor * maxSpeed;
        if (moveSpeed) particle.velocity.y = velocity.y / moveSpeed;
    }
    const zIndexOptions = particle.options.zIndex, zVelocityFactor = (1 - particle.zIndexFactor) ** zIndexOptions.velocityRate;
    velocity.multTo(zVelocityFactor);
    const { position: position } = particle;
    position.addTo(velocity);
    if (moveOptions.vibrate) {
        position.x += Math.sin(position.x * Math.cos(position.y));
        position.y += Math.cos(position.y * Math.sin(position.x));
    }
}
function $6b5c1efe8aec39c8$export$c82e186cf428d56d(particle, moveSpeed) {
    const container = particle.container;
    if (!particle.spin) return;
    const updateFunc = {
        x: particle.spin.direction === "clockwise" ? Math.cos : Math.sin,
        y: particle.spin.direction === "clockwise" ? Math.sin : Math.cos
    };
    particle.position.x = particle.spin.center.x + particle.spin.radius * updateFunc.x(particle.spin.angle);
    particle.position.y = particle.spin.center.y + particle.spin.radius * updateFunc.y(particle.spin.angle);
    particle.spin.radius += particle.spin.acceleration;
    const maxCanvasSize = Math.max(container.canvas.size.width, container.canvas.size.height);
    if (particle.spin.radius > maxCanvasSize / 2) {
        particle.spin.radius = maxCanvasSize / 2;
        particle.spin.acceleration *= -1;
    } else if (particle.spin.radius < 0) {
        particle.spin.radius = 0;
        particle.spin.acceleration *= -1;
    }
    particle.spin.angle += moveSpeed / 100 * (1 - particle.spin.radius / maxCanvasSize);
}
function $6b5c1efe8aec39c8$export$2d1dd1364a451835(particle, delta) {
    const particlesOptions = particle.options, pathOptions = particlesOptions.move.path, pathEnabled = pathOptions.enable;
    if (!pathEnabled) return;
    if (particle.lastPathTime <= particle.pathDelay) {
        particle.lastPathTime += delta.value;
        return;
    }
    const path = particle.pathGenerator?.generate(particle, delta);
    if (path) particle.velocity.addTo(path);
    if (pathOptions.clamp) {
        particle.velocity.x = (0, $a17cb6ec9e2ec6c9$export$7d15b64cf5a3a4c4)(particle.velocity.x, -1, 1);
        particle.velocity.y = (0, $a17cb6ec9e2ec6c9$export$7d15b64cf5a3a4c4)(particle.velocity.y, -1, 1);
    }
    particle.lastPathTime -= particle.pathDelay;
}
function $6b5c1efe8aec39c8$export$7f3cc12c83994316(particle) {
    return particle.slow.inRange ? particle.slow.factor : 1;
}


const $8ae59505233eb302$var$diffFactor = 2;
class $8ae59505233eb302$export$c506fa331d75adff {
    constructor(){
        this._initSpin = (particle)=>{
            const container = particle.container, options = particle.options, spinOptions = options.move.spin;
            if (!spinOptions.enable) return;
            const spinPos = spinOptions.position ?? {
                x: 50,
                y: 50
            }, spinCenter = {
                x: spinPos.x / 100 * container.canvas.size.width,
                y: spinPos.y / 100 * container.canvas.size.height
            }, pos = particle.getPosition(), distance = (0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(pos, spinCenter), spinAcceleration = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(spinOptions.acceleration);
            particle.retina.spinAcceleration = spinAcceleration * container.retina.pixelRatio;
            particle.spin = {
                center: spinCenter,
                direction: particle.velocity.x >= 0 ? "clockwise" : "counter-clockwise",
                angle: particle.velocity.angle,
                radius: distance,
                acceleration: particle.retina.spinAcceleration
            };
        };
    }
    init(particle) {
        const options = particle.options, gravityOptions = options.move.gravity;
        particle.gravity = {
            enable: gravityOptions.enable,
            acceleration: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(gravityOptions.acceleration),
            inverse: gravityOptions.inverse
        };
        this._initSpin(particle);
    }
    isEnabled(particle) {
        return !particle.destroyed && particle.options.move.enable;
    }
    move(particle, delta) {
        const particleOptions = particle.options, moveOptions = particleOptions.move;
        if (!moveOptions.enable) return;
        const container = particle.container, pxRatio = container.retina.pixelRatio, slowFactor = (0, $6b5c1efe8aec39c8$export$7f3cc12c83994316)(particle), baseSpeed = (particle.retina.moveSpeed ??= (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(moveOptions.speed) * pxRatio) * container.retina.reduceFactor, moveDrift = particle.retina.moveDrift ??= (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(particle.options.move.drift) * pxRatio, maxSize = (0, $a17cb6ec9e2ec6c9$export$27d2c76f835d583d)(particleOptions.size.value) * pxRatio, sizeFactor = moveOptions.size ? particle.getRadius() / maxSize : 1, moveSpeed = baseSpeed * sizeFactor * slowFactor * (delta.factor || 1) / $8ae59505233eb302$var$diffFactor, maxSpeed = particle.retina.maxSpeed ?? container.retina.maxSpeed;
        if (moveOptions.spin.enable) (0, $6b5c1efe8aec39c8$export$c82e186cf428d56d)(particle, moveSpeed);
        else (0, $6b5c1efe8aec39c8$export$d947e5f4f4c48d48)(particle, moveOptions, moveSpeed, maxSpeed, moveDrift, delta);
        (0, $6b5c1efe8aec39c8$export$21d7e305c937fbb2)(particle);
    }
}


async function $3b0fe1d31d756722$export$8949951fd9df9397(engine, refresh = true) {
    await engine.addMover("base", ()=>new (0, $8ae59505233eb302$export$c506fa331d75adff)(), refresh);
}



class $33e6acbfdf8c4fa3$export$b29a4fa100f54972 {
    draw(context, particle, radius) {
        if (!particle.circleRange) particle.circleRange = {
            min: 0,
            max: Math.PI * 2
        };
        const circleRange = particle.circleRange;
        context.arc(0, 0, radius, circleRange.min, circleRange.max, false);
    }
    getSidesCount() {
        return 12;
    }
    particleInit(container, particle) {
        const shapeData = particle.shapeData, angle = shapeData?.angle ?? {
            max: 360,
            min: 0
        };
        particle.circleRange = !(0, $ab7d474d755ab51b$export$a6cdc56e425d0d0a)(angle) ? {
            min: 0,
            max: angle * Math.PI / 180
        } : {
            min: angle.min * Math.PI / 180,
            max: angle.max * Math.PI / 180
        };
    }
}


async function $3b2c3c5e375294b5$export$66237f65cef19277(engine, refresh = true) {
    await engine.addShape("circle", new (0, $33e6acbfdf8c4fa3$export$b29a4fa100f54972)(), refresh);
}




function $f5b3b28fa7da0ec0$var$updateColorValue(delta, colorValue, valueAnimation, max, decrease) {
    if (!colorValue || !valueAnimation.enable || (colorValue.maxLoops ?? 0) > 0 && (colorValue.loops ?? 0) > (colorValue.maxLoops ?? 0)) return;
    if (!colorValue.time) colorValue.time = 0;
    if ((colorValue.delayTime ?? 0) > 0 && colorValue.time < (colorValue.delayTime ?? 0)) colorValue.time += delta.value;
    if ((colorValue.delayTime ?? 0) > 0 && colorValue.time < (colorValue.delayTime ?? 0)) return;
    const offset = (0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)(valueAnimation.offset), velocity = (colorValue.velocity ?? 0) * delta.factor + offset * 3.6, decay = colorValue.decay ?? 1;
    if (!decrease || colorValue.status === "increasing") {
        colorValue.value += velocity;
        if (colorValue.value > max) {
            if (!colorValue.loops) colorValue.loops = 0;
            colorValue.loops++;
            if (decrease) {
                colorValue.status = "decreasing";
                colorValue.value -= colorValue.value % max;
            }
        }
    } else {
        colorValue.value -= velocity;
        if (colorValue.value < 0) {
            if (!colorValue.loops) colorValue.loops = 0;
            colorValue.loops++;
            colorValue.status = "increasing";
            colorValue.value += colorValue.value;
        }
    }
    if (colorValue.velocity && decay !== 1) colorValue.velocity *= decay;
    if (colorValue.value > max) colorValue.value %= max;
}
function $f5b3b28fa7da0ec0$export$649b44ac750da8e(particle, delta) {
    const { h: hAnimation, s: sAnimation, l: lAnimation } = particle.options.color.animation, { color: color } = particle;
    if (!color) return;
    const { h: h, s: s, l: l } = color;
    if (h) $f5b3b28fa7da0ec0$var$updateColorValue(delta, h, hAnimation, 360, false);
    if (s) $f5b3b28fa7da0ec0$var$updateColorValue(delta, s, sAnimation, 100, true);
    if (l) $f5b3b28fa7da0ec0$var$updateColorValue(delta, l, lAnimation, 100, true);
}


class $216a2e248aa88ca2$export$c36bb5e4d505f205 {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const hslColor = (0, $3b20cd3c058d307c$export$79a89086521c0f12)(particle.options.color, particle.id, particle.options.reduceDuplicates);
        if (hslColor) particle.color = (0, $3b20cd3c058d307c$export$6e8a573710bea117)(hslColor, particle.options.color.animation, this.container.retina.reduceFactor);
    }
    isEnabled(particle) {
        const { h: hAnimation, s: sAnimation, l: lAnimation } = particle.options.color.animation, { color: color } = particle;
        return !particle.destroyed && !particle.spawning && (color?.h.value !== undefined && hAnimation.enable || color?.s.value !== undefined && sAnimation.enable || color?.l.value !== undefined && lAnimation.enable);
    }
    update(particle, delta) {
        (0, $f5b3b28fa7da0ec0$export$649b44ac750da8e)(particle, delta);
    }
}


async function $9b0441ccfe27601a$export$bfdad36561fbf902(engine, refresh = true) {
    await engine.addParticleUpdater("color", (container)=>new (0, $216a2e248aa88ca2$export$c36bb5e4d505f205)(container), refresh);
}




function $920465c94e3c7f07$var$checkDestroy(particle, value, minValue, maxValue) {
    switch(particle.options.opacity.animation.destroy){
        case "max":
            if (value >= maxValue) particle.destroy();
            break;
        case "min":
            if (value <= minValue) particle.destroy();
            break;
    }
}
function $920465c94e3c7f07$export$c319af361533710c(particle, delta) {
    const data = particle.opacity;
    if (particle.destroyed || !data?.enable || (data.maxLoops ?? 0) > 0 && (data.loops ?? 0) > (data.maxLoops ?? 0)) return;
    const minValue = data.min, maxValue = data.max, decay = data.decay ?? 1;
    if (!data.time) data.time = 0;
    if ((data.delayTime ?? 0) > 0 && data.time < (data.delayTime ?? 0)) data.time += delta.value;
    if ((data.delayTime ?? 0) > 0 && data.time < (data.delayTime ?? 0)) return;
    switch(data.status){
        case "increasing":
            if (data.value >= maxValue) {
                data.status = "decreasing";
                if (!data.loops) data.loops = 0;
                data.loops++;
            } else data.value += (data.velocity ?? 0) * delta.factor;
            break;
        case "decreasing":
            if (data.value <= minValue) {
                data.status = "increasing";
                if (!data.loops) data.loops = 0;
                data.loops++;
            } else data.value -= (data.velocity ?? 0) * delta.factor;
            break;
    }
    if (data.velocity && data.decay !== 1) data.velocity *= decay;
    $920465c94e3c7f07$var$checkDestroy(particle, data.value, minValue, maxValue);
    if (!particle.destroyed) data.value = (0, $a17cb6ec9e2ec6c9$export$7d15b64cf5a3a4c4)(data.value, minValue, maxValue);
}


class $23eb2bea67ad7a45$export$99f6686a87b9ec6f {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const opacityOptions = particle.options.opacity;
        particle.opacity = (0, $ab7d474d755ab51b$export$bebd78259cce4fd)(opacityOptions, 1);
        const opacityAnimation = opacityOptions.animation;
        if (opacityAnimation.enable) {
            particle.opacity.velocity = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(opacityAnimation.speed) / 100 * this.container.retina.reduceFactor;
            if (!opacityAnimation.sync) particle.opacity.velocity *= (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)();
        }
    }
    isEnabled(particle) {
        return !particle.destroyed && !particle.spawning && !!particle.opacity && particle.opacity.enable && ((particle.opacity.maxLoops ?? 0) <= 0 || (particle.opacity.maxLoops ?? 0) > 0 && (particle.opacity.loops ?? 0) < (particle.opacity.maxLoops ?? 0));
    }
    reset(particle) {
        if (particle.opacity) {
            particle.opacity.time = 0;
            particle.opacity.loops = 0;
        }
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        (0, $920465c94e3c7f07$export$c319af361533710c)(particle, delta);
    }
}


async function $4de87b376af1d0a3$export$8322e3b69c08b6eb(engine, refresh = true) {
    await engine.addParticleUpdater("opacity", (container)=>new (0, $23eb2bea67ad7a45$export$99f6686a87b9ec6f)(container), refresh);
}




function $417e22bc5374d8d6$export$1def114a7da042cf(data) {
    if (data.outMode !== "bounce" && data.outMode !== "bounce-horizontal" && data.outMode !== "bounceHorizontal" && data.outMode !== "split" || data.direction !== "left" && data.direction !== "right") return;
    if (data.bounds.right < 0 && data.direction === "left") data.particle.position.x = data.size + data.offset.x;
    else if (data.bounds.left > data.canvasSize.width && data.direction === "right") data.particle.position.x = data.canvasSize.width - data.size - data.offset.x;
    const velocity = data.particle.velocity.x;
    let bounced = false;
    if (data.direction === "right" && data.bounds.right >= data.canvasSize.width && velocity > 0 || data.direction === "left" && data.bounds.left <= 0 && velocity < 0) {
        const newVelocity = (0, $a17cb6ec9e2ec6c9$export$bf7199a9ebcb84a9)(data.particle.options.bounce.horizontal);
        data.particle.velocity.x *= -newVelocity;
        bounced = true;
    }
    if (!bounced) return;
    const minPos = data.offset.x + data.size;
    if (data.bounds.right >= data.canvasSize.width && data.direction === "right") data.particle.position.x = data.canvasSize.width - minPos;
    else if (data.bounds.left <= 0 && data.direction === "left") data.particle.position.x = minPos;
    if (data.outMode === "split") data.particle.destroy();
}
function $417e22bc5374d8d6$export$46000c44e0211bc6(data) {
    if (data.outMode !== "bounce" && data.outMode !== "bounce-vertical" && data.outMode !== "bounceVertical" && data.outMode !== "split" || data.direction !== "bottom" && data.direction !== "top") return;
    if (data.bounds.bottom < 0 && data.direction === "top") data.particle.position.y = data.size + data.offset.y;
    else if (data.bounds.top > data.canvasSize.height && data.direction === "bottom") data.particle.position.y = data.canvasSize.height - data.size - data.offset.y;
    const velocity = data.particle.velocity.y;
    let bounced = false;
    if (data.direction === "bottom" && data.bounds.bottom >= data.canvasSize.height && velocity > 0 || data.direction === "top" && data.bounds.top <= 0 && velocity < 0) {
        const newVelocity = (0, $a17cb6ec9e2ec6c9$export$bf7199a9ebcb84a9)(data.particle.options.bounce.vertical);
        data.particle.velocity.y *= -newVelocity;
        bounced = true;
    }
    if (!bounced) return;
    const minPos = data.offset.y + data.size;
    if (data.bounds.bottom >= data.canvasSize.height && data.direction === "bottom") data.particle.position.y = data.canvasSize.height - minPos;
    else if (data.bounds.top <= 0 && data.direction === "top") data.particle.position.y = minPos;
    if (data.outMode === "split") data.particle.destroy();
}


class $3ae25e91e178c073$export$7a10ae135b551126 {
    constructor(container){
        this.container = container;
        this.modes = [
            "bounce",
            "bounce-vertical",
            "bounce-horizontal",
            "bounceVertical",
            "bounceHorizontal",
            "split"
        ];
    }
    update(particle, direction, delta, outMode) {
        if (!this.modes.includes(outMode)) return;
        const container = this.container;
        let handled = false;
        for (const [, plugin] of container.plugins){
            if (plugin.particleBounce !== undefined) handled = plugin.particleBounce(particle, delta, direction);
            if (handled) break;
        }
        if (handled) return;
        const pos = particle.getPosition(), offset = particle.offset, size = particle.getRadius(), bounds = (0, $ab7d474d755ab51b$export$b0a2169b5f9d18d8)(pos, size), canvasSize = container.canvas.size;
        (0, $417e22bc5374d8d6$export$1def114a7da042cf)({
            particle: particle,
            outMode: outMode,
            direction: direction,
            bounds: bounds,
            canvasSize: canvasSize,
            offset: offset,
            size: size
        });
        (0, $417e22bc5374d8d6$export$46000c44e0211bc6)({
            particle: particle,
            outMode: outMode,
            direction: direction,
            bounds: bounds,
            canvasSize: canvasSize,
            offset: offset,
            size: size
        });
    }
}



class $ef14f4e7252c46a4$export$4c86fe322e2200a {
    constructor(container){
        this.container = container;
        this.modes = [
            "destroy"
        ];
    }
    update(particle, direction, _delta, outMode) {
        if (!this.modes.includes(outMode)) return;
        const container = this.container;
        switch(particle.outType){
            case "normal":
            case "outside":
                if ((0, $ab7d474d755ab51b$export$2ea42ef493c7076c)(particle.position, container.canvas.size, (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).origin, particle.getRadius(), direction)) return;
                break;
            case "inside":
                {
                    const { dx: dx, dy: dy } = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(particle.position, particle.moveCenter);
                    const { x: vx, y: vy } = particle.velocity;
                    if (vx < 0 && dx > particle.moveCenter.radius || vy < 0 && dy > particle.moveCenter.radius || vx >= 0 && dx < -particle.moveCenter.radius || vy >= 0 && dy < -particle.moveCenter.radius) return;
                    break;
                }
        }
        container.particles.remove(particle, undefined, true);
    }
}



class $571cdf1f361a6816$export$a026dc73727d2f19 {
    constructor(container){
        this.container = container;
        this.modes = [
            "none"
        ];
    }
    update(particle, direction, delta, outMode) {
        if (!this.modes.includes(outMode)) return;
        if (particle.options.move.distance.horizontal && (direction === "left" || direction === "right") || particle.options.move.distance.vertical && (direction === "top" || direction === "bottom")) return;
        const gravityOptions = particle.options.move.gravity, container = this.container;
        const canvasSize = container.canvas.size;
        const pRadius = particle.getRadius();
        if (!gravityOptions.enable) {
            if (particle.velocity.y > 0 && particle.position.y <= canvasSize.height + pRadius || particle.velocity.y < 0 && particle.position.y >= -pRadius || particle.velocity.x > 0 && particle.position.x <= canvasSize.width + pRadius || particle.velocity.x < 0 && particle.position.x >= -pRadius) return;
            if (!(0, $ab7d474d755ab51b$export$2ea42ef493c7076c)(particle.position, container.canvas.size, (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).origin, pRadius, direction)) container.particles.remove(particle);
        } else {
            const position = particle.position;
            if (!gravityOptions.inverse && position.y > canvasSize.height + pRadius && direction === "bottom" || gravityOptions.inverse && position.y < -pRadius && direction === "top") container.particles.remove(particle);
        }
    }
}



class $bfb9c29365f31c76$export$7300b77892783c0e {
    constructor(container){
        this.container = container;
        this.modes = [
            "out"
        ];
    }
    update(particle, direction, delta, outMode) {
        if (!this.modes.includes(outMode)) return;
        const container = this.container;
        switch(particle.outType){
            case "inside":
                {
                    const { x: vx, y: vy } = particle.velocity;
                    const circVec = (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).origin;
                    circVec.length = particle.moveCenter.radius;
                    circVec.angle = particle.velocity.angle + Math.PI;
                    circVec.addTo((0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).create(particle.moveCenter));
                    const { dx: dx, dy: dy } = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(particle.position, circVec);
                    if (vx <= 0 && dx >= 0 || vy <= 0 && dy >= 0 || vx >= 0 && dx <= 0 || vy >= 0 && dy <= 0) return;
                    particle.position.x = Math.floor((0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)({
                        min: 0,
                        max: container.canvas.size.width
                    }));
                    particle.position.y = Math.floor((0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)({
                        min: 0,
                        max: container.canvas.size.height
                    }));
                    const { dx: newDx, dy: newDy } = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(particle.position, particle.moveCenter);
                    particle.direction = Math.atan2(-newDy, -newDx);
                    particle.velocity.angle = particle.direction;
                    break;
                }
            default:
                if ((0, $ab7d474d755ab51b$export$2ea42ef493c7076c)(particle.position, container.canvas.size, (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).origin, particle.getRadius(), direction)) return;
                switch(particle.outType){
                    case "outside":
                        {
                            particle.position.x = Math.floor((0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)({
                                min: -particle.moveCenter.radius,
                                max: particle.moveCenter.radius
                            })) + particle.moveCenter.x;
                            particle.position.y = Math.floor((0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)({
                                min: -particle.moveCenter.radius,
                                max: particle.moveCenter.radius
                            })) + particle.moveCenter.y;
                            const { dx: dx, dy: dy } = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(particle.position, particle.moveCenter);
                            if (particle.moveCenter.radius) {
                                particle.direction = Math.atan2(dy, dx);
                                particle.velocity.angle = particle.direction;
                            }
                            break;
                        }
                    case "normal":
                        {
                            const wrap = particle.options.move.warp, canvasSize = container.canvas.size, newPos = {
                                bottom: canvasSize.height + particle.getRadius() + particle.offset.y,
                                left: -particle.getRadius() - particle.offset.x,
                                right: canvasSize.width + particle.getRadius() + particle.offset.x,
                                top: -particle.getRadius() - particle.offset.y
                            }, sizeValue = particle.getRadius(), nextBounds = (0, $ab7d474d755ab51b$export$b0a2169b5f9d18d8)(particle.position, sizeValue);
                            if (direction === "right" && nextBounds.left > canvasSize.width + particle.offset.x) {
                                particle.position.x = newPos.left;
                                particle.initialPosition.x = particle.position.x;
                                if (!wrap) {
                                    particle.position.y = (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() * canvasSize.height;
                                    particle.initialPosition.y = particle.position.y;
                                }
                            } else if (direction === "left" && nextBounds.right < -particle.offset.x) {
                                particle.position.x = newPos.right;
                                particle.initialPosition.x = particle.position.x;
                                if (!wrap) {
                                    particle.position.y = (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() * canvasSize.height;
                                    particle.initialPosition.y = particle.position.y;
                                }
                            }
                            if (direction === "bottom" && nextBounds.top > canvasSize.height + particle.offset.y) {
                                if (!wrap) {
                                    particle.position.x = (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() * canvasSize.width;
                                    particle.initialPosition.x = particle.position.x;
                                }
                                particle.position.y = newPos.top;
                                particle.initialPosition.y = particle.position.y;
                            } else if (direction === "top" && nextBounds.bottom < -particle.offset.y) {
                                if (!wrap) {
                                    particle.position.x = (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() * canvasSize.width;
                                    particle.initialPosition.x = particle.position.x;
                                }
                                particle.position.y = newPos.bottom;
                                particle.initialPosition.y = particle.position.y;
                            }
                            break;
                        }
                }
                break;
        }
    }
}


class $bab3c9716e31a8e8$export$cb0990f1117a9f95 {
    constructor(container){
        this.container = container;
        this._updateOutMode = (particle, delta, outMode, direction)=>{
            for (const updater of this.updaters)updater.update(particle, direction, delta, outMode);
        };
        this.updaters = [
            new (0, $3ae25e91e178c073$export$7a10ae135b551126)(container),
            new (0, $ef14f4e7252c46a4$export$4c86fe322e2200a)(container),
            new (0, $bfb9c29365f31c76$export$7300b77892783c0e)(container),
            new (0, $571cdf1f361a6816$export$a026dc73727d2f19)(container)
        ];
    }
    init() {}
    isEnabled(particle) {
        return !particle.destroyed && !particle.spawning;
    }
    update(particle, delta) {
        const outModes = particle.options.move.outModes;
        this._updateOutMode(particle, delta, outModes.bottom ?? outModes.default, "bottom");
        this._updateOutMode(particle, delta, outModes.left ?? outModes.default, "left");
        this._updateOutMode(particle, delta, outModes.right ?? outModes.default, "right");
        this._updateOutMode(particle, delta, outModes.top ?? outModes.default, "top");
    }
}


async function $e6dd96717bacaad9$export$4cf4cb6464fcf0a1(engine, refresh = true) {
    await engine.addParticleUpdater("outModes", (container)=>new (0, $bab3c9716e31a8e8$export$cb0990f1117a9f95)(container), refresh);
}




function $6236806e9fa4f64c$var$checkDestroy(particle, value, minValue, maxValue) {
    switch(particle.options.size.animation.destroy){
        case "max":
            if (value >= maxValue) particle.destroy();
            break;
        case "min":
            if (value <= minValue) particle.destroy();
            break;
    }
}
function $6236806e9fa4f64c$export$df0d1bc998a4783b(particle, delta) {
    const data = particle.size;
    if (particle.destroyed || !data || !data.enable || (data.maxLoops ?? 0) > 0 && (data.loops ?? 0) > (data.maxLoops ?? 0)) return;
    const sizeVelocity = (data.velocity ?? 0) * delta.factor, minValue = data.min, maxValue = data.max, decay = data.decay ?? 1;
    if (!data.time) data.time = 0;
    if ((data.delayTime ?? 0) > 0 && data.time < (data.delayTime ?? 0)) data.time += delta.value;
    if ((data.delayTime ?? 0) > 0 && data.time < (data.delayTime ?? 0)) return;
    switch(data.status){
        case "increasing":
            if (data.value >= maxValue) {
                data.status = "decreasing";
                if (!data.loops) data.loops = 0;
                data.loops++;
            } else data.value += sizeVelocity;
            break;
        case "decreasing":
            if (data.value <= minValue) {
                data.status = "increasing";
                if (!data.loops) data.loops = 0;
                data.loops++;
            } else data.value -= sizeVelocity;
    }
    if (data.velocity && decay !== 1) data.velocity *= decay;
    $6236806e9fa4f64c$var$checkDestroy(particle, data.value, minValue, maxValue);
    if (!particle.destroyed) data.value = (0, $a17cb6ec9e2ec6c9$export$7d15b64cf5a3a4c4)(data.value, minValue, maxValue);
}


class $b377b15fe7e6185a$export$545f3be57f54ffb6 {
    init(particle) {
        const container = particle.container, sizeOptions = particle.options.size, sizeAnimation = sizeOptions.animation;
        if (sizeAnimation.enable) {
            particle.size.velocity = (particle.retina.sizeAnimationSpeed ?? container.retina.sizeAnimationSpeed) / 100 * container.retina.reduceFactor;
            if (!sizeAnimation.sync) particle.size.velocity *= (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)();
        }
    }
    isEnabled(particle) {
        return !particle.destroyed && !particle.spawning && particle.size.enable && ((particle.size.maxLoops ?? 0) <= 0 || (particle.size.maxLoops ?? 0) > 0 && (particle.size.loops ?? 0) < (particle.size.maxLoops ?? 0));
    }
    reset(particle) {
        particle.size.loops = 0;
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        (0, $6236806e9fa4f64c$export$df0d1bc998a4783b)(particle, delta);
    }
}


async function $025b225bbae2c0d8$export$ca8bd803ddf2ea7e(engine, refresh = true) {
    await engine.addParticleUpdater("size", ()=>new (0, $b377b15fe7e6185a$export$545f3be57f54ffb6)(), refresh);
}


async function $cfa79809f7729e19$export$244419993531723b(engine, refresh = true) {
    await (0, $3b0fe1d31d756722$export$8949951fd9df9397)(engine, false);
    await (0, $3b2c3c5e375294b5$export$66237f65cef19277)(engine, false);
    await (0, $9b0441ccfe27601a$export$bfdad36561fbf902)(engine, false);
    await (0, $4de87b376af1d0a3$export$8322e3b69c08b6eb)(engine, false);
    await (0, $e6dd96717bacaad9$export$4cf4cb6464fcf0a1)(engine, false);
    await (0, $025b225bbae2c0d8$export$ca8bd803ddf2ea7e)(engine, false);
    await engine.refresh(refresh);
}



async function $3f33526d3a73a8f4$export$869269643d4bbdcd() {
    (0, $a17cb6ec9e2ec6c9$export$e2251c95822ce867)("ease-in-quad", (value)=>value ** 2);
    (0, $a17cb6ec9e2ec6c9$export$e2251c95822ce867)("ease-out-quad", (value)=>1 - (1 - value) ** 2);
    (0, $a17cb6ec9e2ec6c9$export$e2251c95822ce867)("ease-in-out-quad", (value)=>value < 0.5 ? 2 * value ** 2 : 1 - (-2 * value + 2) ** 2 / 2);
}



class $e4454dc3cf5cf0df$export$2e6bb8ee3737fcb3 {
    constructor(){
        this.distance = 200;
        this.duration = 0.4;
        this.easing = "ease-out-quad";
        this.factor = 1;
        this.maxSpeed = 50;
        this.speed = 1;
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = data.distance;
        if (data.duration !== undefined) this.duration = data.duration;
        if (data.easing !== undefined) this.easing = data.easing;
        if (data.factor !== undefined) this.factor = data.factor;
        if (data.maxSpeed !== undefined) this.maxSpeed = data.maxSpeed;
        if (data.speed !== undefined) this.speed = data.speed;
    }
}


class $7c35b0001de7e05c$export$27a51cca6e7ea831 extends (0, $a34f6e88dd5ec1a0$export$6e252256471acc61) {
    constructor(engine, container){
        super(container);
        this._clickAttract = ()=>{
            const container = this.container;
            if (!container.attract) container.attract = {
                particles: []
            };
            const { attract: attract } = container;
            if (!attract.finish) {
                if (!attract.count) attract.count = 0;
                attract.count++;
                if (attract.count === container.particles.count) attract.finish = true;
            }
            if (attract.clicking) {
                const mousePos = container.interactivity.mouse.clickPosition, attractRadius = container.retina.attractModeDistance;
                if (!attractRadius || attractRadius < 0 || !mousePos) return;
                this._processAttract(mousePos, attractRadius, new (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa)(mousePos.x, mousePos.y, attractRadius));
            } else if (attract.clicking === false) attract.particles = [];
            return;
        };
        this._hoverAttract = ()=>{
            const container = this.container, mousePos = container.interactivity.mouse.position, attractRadius = container.retina.attractModeDistance;
            if (!attractRadius || attractRadius < 0 || !mousePos) return;
            this._processAttract(mousePos, attractRadius, new (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa)(mousePos.x, mousePos.y, attractRadius));
        };
        this._processAttract = (position, attractRadius, area)=>{
            const container = this.container, attractOptions = container.actualOptions.interactivity.modes.attract;
            if (!attractOptions) return;
            const query = container.particles.quadTree.query(area, (p)=>this.isEnabled(p));
            for (const particle of query){
                const { dx: dx, dy: dy, distance: distance } = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(particle.position, position);
                const velocity = attractOptions.speed * attractOptions.factor;
                const attractFactor = (0, $a17cb6ec9e2ec6c9$export$7d15b64cf5a3a4c4)((0, $a17cb6ec9e2ec6c9$export$2bbf531f74195405)(attractOptions.easing)(1 - distance / attractRadius) * velocity, 0, attractOptions.maxSpeed);
                const normVec = (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).create(distance === 0 ? velocity : dx / distance * attractFactor, distance === 0 ? velocity : dy / distance * attractFactor);
                particle.position.subFrom(normVec);
            }
        };
        this._engine = engine;
        if (!container.attract) container.attract = {
            particles: []
        };
        this.handleClickMode = (mode)=>{
            const options = this.container.actualOptions, attract = options.interactivity.modes.attract;
            if (!attract || mode !== "attract") return;
            if (!container.attract) container.attract = {
                particles: []
            };
            container.attract.clicking = true;
            container.attract.count = 0;
            for (const particle of container.attract.particles){
                if (!this.isEnabled(particle)) continue;
                particle.velocity.setTo(particle.initialVelocity);
            }
            container.attract.particles = [];
            container.attract.finish = false;
            setTimeout(()=>{
                if (container.destroyed) return;
                if (!container.attract) container.attract = {
                    particles: []
                };
                container.attract.clicking = false;
            }, attract.duration * 1000);
        };
    }
    clear() {}
    init() {
        const container = this.container, attract = container.actualOptions.interactivity.modes.attract;
        if (!attract) return;
        container.retina.attractModeDistance = attract.distance * container.retina.pixelRatio;
    }
    async interact() {
        const container = this.container, options = container.actualOptions, mouseMoveStatus = container.interactivity.status === (0, $9f7790cd505e6a79$export$1ffe551d7d33cd33), events = options.interactivity.events, hoverEnabled = events.onHover.enable, hoverMode = events.onHover.mode, clickEnabled = events.onClick.enable, clickMode = events.onClick.mode;
        if (mouseMoveStatus && hoverEnabled && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("attract", hoverMode)) this._hoverAttract();
        else if (clickEnabled && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("attract", clickMode)) this._clickAttract();
    }
    isEnabled(particle) {
        const container = this.container, options = container.actualOptions, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? options.interactivity).events;
        if ((!mouse.position || !events.onHover.enable) && (!mouse.clickPosition || !events.onClick.enable)) return false;
        const hoverMode = events.onHover.mode, clickMode = events.onClick.mode;
        return (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("attract", hoverMode) || (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("attract", clickMode);
    }
    loadModeOptions(options, ...sources) {
        if (!options.attract) options.attract = new (0, $e4454dc3cf5cf0df$export$2e6bb8ee3737fcb3)();
        for (const source of sources)options.attract.load(source?.attract);
    }
    reset() {}
}




async function $17bcf2679deaa951$export$802792820c064418(engine, refresh = true) {
    await engine.addInteractor("externalAttract", (container)=>new (0, $7c35b0001de7e05c$export$27a51cca6e7ea831)(engine, container), refresh);
}



class $f57f2f4cd779d770$export$d20e79fdc3899e95 {
    constructor(){
        this.distance = 200;
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = data.distance;
    }
}


class $ee856fc5df20361b$export$81812ec41a0682d1 extends (0, $a34f6e88dd5ec1a0$export$6e252256471acc61) {
    constructor(container){
        super(container);
        this._processBounce = (position, radius, area)=>{
            const query = this.container.particles.quadTree.query(area, (p)=>this.isEnabled(p));
            for (const particle of query){
                if (area instanceof (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa)) (0, $ab7d474d755ab51b$export$c6e9f28fb57ea828)((0, $ab7d474d755ab51b$export$11ae16f2acc5c3ba)(particle), {
                    position: position,
                    radius: radius,
                    mass: radius ** 2 * Math.PI / 2,
                    velocity: (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).origin,
                    factor: (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).origin
                });
                else if (area instanceof (0, $fbaf108f02b30a19$export$4617fb02663045ef)) (0, $ab7d474d755ab51b$export$e83851ba31840182)(particle, (0, $ab7d474d755ab51b$export$b0a2169b5f9d18d8)(position, radius));
            }
        };
        this._processMouseBounce = ()=>{
            const container = this.container, pxRatio = container.retina.pixelRatio, tolerance = 10 * pxRatio, mousePos = container.interactivity.mouse.position, radius = container.retina.bounceModeDistance;
            if (!radius || radius < 0 || !mousePos) return;
            this._processBounce(mousePos, radius, new (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa)(mousePos.x, mousePos.y, radius + tolerance));
        };
        this._singleSelectorBounce = (selector, div)=>{
            const container = this.container, query = document.querySelectorAll(selector);
            if (!query.length) return;
            query.forEach((item)=>{
                const elem = item, pxRatio = container.retina.pixelRatio, pos = {
                    x: (elem.offsetLeft + elem.offsetWidth / 2) * pxRatio,
                    y: (elem.offsetTop + elem.offsetHeight / 2) * pxRatio
                }, radius = elem.offsetWidth / 2 * pxRatio, tolerance = 10 * pxRatio, area = div.type === "circle" ? new (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa)(pos.x, pos.y, radius + tolerance) : new (0, $fbaf108f02b30a19$export$4617fb02663045ef)(elem.offsetLeft * pxRatio - tolerance, elem.offsetTop * pxRatio - tolerance, elem.offsetWidth * pxRatio + tolerance * 2, elem.offsetHeight * pxRatio + tolerance * 2);
                this._processBounce(pos, radius, area);
            });
        };
    }
    clear() {}
    init() {
        const container = this.container, bounce = container.actualOptions.interactivity.modes.bounce;
        if (!bounce) return;
        container.retina.bounceModeDistance = bounce.distance * container.retina.pixelRatio;
    }
    async interact() {
        const container = this.container, options = container.actualOptions, events = options.interactivity.events, mouseMoveStatus = container.interactivity.status === (0, $9f7790cd505e6a79$export$1ffe551d7d33cd33), hoverEnabled = events.onHover.enable, hoverMode = events.onHover.mode, divs = events.onDiv;
        if (mouseMoveStatus && hoverEnabled && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("bounce", hoverMode)) this._processMouseBounce();
        else (0, $ab7d474d755ab51b$export$194f9554360903fd)("bounce", divs, (selector, div)=>this._singleSelectorBounce(selector, div));
    }
    isEnabled(particle) {
        const container = this.container, options = container.actualOptions, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? options.interactivity).events, divs = events.onDiv;
        return mouse.position && events.onHover.enable && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("bounce", events.onHover.mode) || (0, $ab7d474d755ab51b$export$5d1f020956707f4)("bounce", divs);
    }
    loadModeOptions(options, ...sources) {
        if (!options.bounce) options.bounce = new (0, $f57f2f4cd779d770$export$d20e79fdc3899e95)();
        for (const source of sources)options.bounce.load(source?.bounce);
    }
    reset() {}
}




async function $4d6aef1b5ecf751d$export$ec1513be4b96e6ba(engine, refresh = true) {
    await engine.addInteractor("externalBounce", (container)=>new (0, $ee856fc5df20361b$export$81812ec41a0682d1)(container), refresh);
}





class $50f64b0cfb276749$export$e71d224ed8cf00b6 {
    constructor(){
        this.distance = 200;
        this.duration = 0.4;
        this.mix = false;
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = data.distance;
        if (data.duration !== undefined) this.duration = data.duration;
        if (data.mix !== undefined) this.mix = data.mix;
        if (data.opacity !== undefined) this.opacity = data.opacity;
        if (data.color !== undefined) {
            const sourceColor = (0, $ab7d474d755ab51b$export$43bee75e5e14138e)(this.color) ? undefined : this.color;
            this.color = (0, $ab7d474d755ab51b$export$8e5dc47097396754)(data.color, (color)=>{
                return (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa).create(sourceColor, color);
            });
        }
        if (data.size !== undefined) this.size = data.size;
    }
}




class $ba29de39f09eaf72$export$768c85074997964c extends (0, $50f64b0cfb276749$export$e71d224ed8cf00b6) {
    constructor(){
        super();
        this.selectors = [];
    }
    get ids() {
        return (0, $ab7d474d755ab51b$export$8e5dc47097396754)(this.selectors, (t)=>t.replace("#", ""));
    }
    set ids(value) {
        this.selectors = (0, $ab7d474d755ab51b$export$8e5dc47097396754)(value, (t)=>`#${t}`);
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.ids !== undefined) this.ids = data.ids;
        if (data.selectors !== undefined) this.selectors = data.selectors;
    }
}


class $e8a2ca5cf86e47c6$export$646feb54fbadbe06 extends (0, $50f64b0cfb276749$export$e71d224ed8cf00b6) {
    load(data) {
        super.load(data);
        if (!data) return;
        this.divs = (0, $ab7d474d755ab51b$export$8e5dc47097396754)(data.divs, (div)=>{
            const tmp = new (0, $ba29de39f09eaf72$export$768c85074997964c)();
            tmp.load(div);
            return tmp;
        });
    }
}



function $f47ccf366de61bcb$export$144231fdd3795a95(particleValue, modeValue, optionsValue, ratio) {
    if (modeValue >= optionsValue) {
        const value = particleValue + (modeValue - optionsValue) * ratio;
        return (0, $a17cb6ec9e2ec6c9$export$7d15b64cf5a3a4c4)(value, particleValue, modeValue);
    } else if (modeValue < optionsValue) {
        const value = particleValue - (optionsValue - modeValue) * ratio;
        return (0, $a17cb6ec9e2ec6c9$export$7d15b64cf5a3a4c4)(value, modeValue, particleValue);
    }
}


class $43b098819881552e$export$6430b7804bc9fbe5 extends (0, $a34f6e88dd5ec1a0$export$6e252256471acc61) {
    constructor(container){
        super(container);
        this._clickBubble = ()=>{
            const container = this.container, options = container.actualOptions, mouseClickPos = container.interactivity.mouse.clickPosition, bubbleOptions = options.interactivity.modes.bubble;
            if (!bubbleOptions || !mouseClickPos) return;
            if (!container.bubble) container.bubble = {};
            const distance = container.retina.bubbleModeDistance;
            if (!distance || distance < 0) return;
            const query = container.particles.quadTree.queryCircle(mouseClickPos, distance, (p)=>this.isEnabled(p)), { bubble: bubble } = container;
            for (const particle of query){
                if (!bubble.clicking) continue;
                particle.bubble.inRange = !bubble.durationEnd;
                const pos = particle.getPosition(), distMouse = (0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(pos, mouseClickPos), timeSpent = (new Date().getTime() - (container.interactivity.mouse.clickTime || 0)) / 1000;
                if (timeSpent > bubbleOptions.duration) bubble.durationEnd = true;
                if (timeSpent > bubbleOptions.duration * 2) {
                    bubble.clicking = false;
                    bubble.durationEnd = false;
                }
                const sizeData = {
                    bubbleObj: {
                        optValue: container.retina.bubbleModeSize,
                        value: particle.bubble.radius
                    },
                    particlesObj: {
                        optValue: (0, $a17cb6ec9e2ec6c9$export$27d2c76f835d583d)(particle.options.size.value) * container.retina.pixelRatio,
                        value: particle.size.value
                    },
                    type: "size"
                };
                this._process(particle, distMouse, timeSpent, sizeData);
                const opacityData = {
                    bubbleObj: {
                        optValue: bubbleOptions.opacity,
                        value: particle.bubble.opacity
                    },
                    particlesObj: {
                        optValue: (0, $a17cb6ec9e2ec6c9$export$27d2c76f835d583d)(particle.options.opacity.value),
                        value: particle.opacity?.value ?? 1
                    },
                    type: "opacity"
                };
                this._process(particle, distMouse, timeSpent, opacityData);
                if (!bubble.durationEnd && distMouse <= distance) this._hoverBubbleColor(particle, distMouse);
                else delete particle.bubble.color;
            }
        };
        this._hoverBubble = ()=>{
            const container = this.container, mousePos = container.interactivity.mouse.position, distance = container.retina.bubbleModeDistance;
            if (!distance || distance < 0 || mousePos === undefined) return;
            const query = container.particles.quadTree.queryCircle(mousePos, distance, (p)=>this.isEnabled(p));
            for (const particle of query){
                particle.bubble.inRange = true;
                const pos = particle.getPosition(), pointDistance = (0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(pos, mousePos), ratio = 1 - pointDistance / distance;
                if (pointDistance <= distance) {
                    if (ratio >= 0 && container.interactivity.status === (0, $9f7790cd505e6a79$export$1ffe551d7d33cd33)) {
                        this._hoverBubbleSize(particle, ratio);
                        this._hoverBubbleOpacity(particle, ratio);
                        this._hoverBubbleColor(particle, ratio);
                    }
                } else this.reset(particle);
                if (container.interactivity.status === (0, $9f7790cd505e6a79$export$f4b184a85a586f8a)) this.reset(particle);
            }
        };
        this._hoverBubbleColor = (particle, ratio, divBubble)=>{
            const options = this.container.actualOptions, bubbleOptions = divBubble ?? options.interactivity.modes.bubble;
            if (!bubbleOptions) return;
            if (!particle.bubble.finalColor) {
                const modeColor = bubbleOptions.color;
                if (!modeColor) return;
                const bubbleColor = (0, $ab7d474d755ab51b$export$3fbf39566d3ee62e)(modeColor);
                particle.bubble.finalColor = (0, $3b20cd3c058d307c$export$79a89086521c0f12)(bubbleColor);
            }
            if (!particle.bubble.finalColor) return;
            if (bubbleOptions.mix) {
                particle.bubble.color = undefined;
                const pColor = particle.getFillColor();
                particle.bubble.color = pColor ? (0, $3b20cd3c058d307c$export$c85ca4f4753af384)((0, $3b20cd3c058d307c$export$9b476054b78b89cd)(pColor, particle.bubble.finalColor, 1 - ratio, ratio)) : particle.bubble.finalColor;
            } else particle.bubble.color = particle.bubble.finalColor;
        };
        this._hoverBubbleOpacity = (particle, ratio, divBubble)=>{
            const container = this.container, options = container.actualOptions, modeOpacity = divBubble?.opacity ?? options.interactivity.modes.bubble?.opacity;
            if (!modeOpacity) return;
            const optOpacity = particle.options.opacity.value, pOpacity = particle.opacity?.value ?? 1, opacity = (0, $f47ccf366de61bcb$export$144231fdd3795a95)(pOpacity, modeOpacity, (0, $a17cb6ec9e2ec6c9$export$27d2c76f835d583d)(optOpacity), ratio);
            if (opacity !== undefined) particle.bubble.opacity = opacity;
        };
        this._hoverBubbleSize = (particle, ratio, divBubble)=>{
            const container = this.container, modeSize = divBubble?.size ? divBubble.size * container.retina.pixelRatio : container.retina.bubbleModeSize;
            if (modeSize === undefined) return;
            const optSize = (0, $a17cb6ec9e2ec6c9$export$27d2c76f835d583d)(particle.options.size.value) * container.retina.pixelRatio, pSize = particle.size.value, size = (0, $f47ccf366de61bcb$export$144231fdd3795a95)(pSize, modeSize, optSize, ratio);
            if (size !== undefined) particle.bubble.radius = size;
        };
        this._process = (particle, distMouse, timeSpent, data)=>{
            const container = this.container, bubbleParam = data.bubbleObj.optValue, options = container.actualOptions, bubbleOptions = options.interactivity.modes.bubble;
            if (!bubbleOptions || bubbleParam === undefined) return;
            const bubbleDuration = bubbleOptions.duration, bubbleDistance = container.retina.bubbleModeDistance, particlesParam = data.particlesObj.optValue, pObjBubble = data.bubbleObj.value, pObj = data.particlesObj.value || 0, type = data.type;
            if (!bubbleDistance || bubbleDistance < 0 || bubbleParam === particlesParam) return;
            if (!container.bubble) container.bubble = {};
            if (container.bubble.durationEnd) {
                if (pObjBubble) {
                    if (type === "size") delete particle.bubble.radius;
                    if (type === "opacity") delete particle.bubble.opacity;
                }
            } else if (distMouse <= bubbleDistance) {
                const obj = pObjBubble ?? pObj;
                if (obj !== bubbleParam) {
                    const value = pObj - timeSpent * (pObj - bubbleParam) / bubbleDuration;
                    if (type === "size") particle.bubble.radius = value;
                    if (type === "opacity") particle.bubble.opacity = value;
                }
            } else {
                if (type === "size") delete particle.bubble.radius;
                if (type === "opacity") delete particle.bubble.opacity;
            }
        };
        this._singleSelectorHover = (delta, selector, div)=>{
            const container = this.container, selectors = document.querySelectorAll(selector), bubble = container.actualOptions.interactivity.modes.bubble;
            if (!bubble || !selectors.length) return;
            selectors.forEach((item)=>{
                const elem = item, pxRatio = container.retina.pixelRatio, pos = {
                    x: (elem.offsetLeft + elem.offsetWidth / 2) * pxRatio,
                    y: (elem.offsetTop + elem.offsetHeight / 2) * pxRatio
                }, repulseRadius = elem.offsetWidth / 2 * pxRatio, area = div.type === "circle" ? new (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa)(pos.x, pos.y, repulseRadius) : new (0, $fbaf108f02b30a19$export$4617fb02663045ef)(elem.offsetLeft * pxRatio, elem.offsetTop * pxRatio, elem.offsetWidth * pxRatio, elem.offsetHeight * pxRatio), query = container.particles.quadTree.query(area, (p)=>this.isEnabled(p));
                for (const particle of query){
                    if (!area.contains(particle.getPosition())) continue;
                    particle.bubble.inRange = true;
                    const divs = bubble.divs, divBubble = (0, $ab7d474d755ab51b$export$f7c2b83aad443adb)(divs, elem);
                    if (!particle.bubble.div || particle.bubble.div !== elem) {
                        this.clear(particle, delta, true);
                        particle.bubble.div = elem;
                    }
                    this._hoverBubbleSize(particle, 1, divBubble);
                    this._hoverBubbleOpacity(particle, 1, divBubble);
                    this._hoverBubbleColor(particle, 1, divBubble);
                }
            });
        };
        if (!container.bubble) container.bubble = {};
        this.handleClickMode = (mode)=>{
            if (mode !== "bubble") return;
            if (!container.bubble) container.bubble = {};
            container.bubble.clicking = true;
        };
    }
    clear(particle, delta, force) {
        if (particle.bubble.inRange && !force) return;
        delete particle.bubble.div;
        delete particle.bubble.opacity;
        delete particle.bubble.radius;
        delete particle.bubble.color;
    }
    init() {
        const container = this.container, bubble = container.actualOptions.interactivity.modes.bubble;
        if (!bubble) return;
        container.retina.bubbleModeDistance = bubble.distance * container.retina.pixelRatio;
        if (bubble.size !== undefined) container.retina.bubbleModeSize = bubble.size * container.retina.pixelRatio;
    }
    async interact(delta) {
        const options = this.container.actualOptions, events = options.interactivity.events, onHover = events.onHover, onClick = events.onClick, hoverEnabled = onHover.enable, hoverMode = onHover.mode, clickEnabled = onClick.enable, clickMode = onClick.mode, divs = events.onDiv;
        if (hoverEnabled && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("bubble", hoverMode)) this._hoverBubble();
        else if (clickEnabled && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("bubble", clickMode)) this._clickBubble();
        else (0, $ab7d474d755ab51b$export$194f9554360903fd)("bubble", divs, (selector, div)=>this._singleSelectorHover(delta, selector, div));
    }
    isEnabled(particle) {
        const container = this.container, options = container.actualOptions, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? options.interactivity).events, { onClick: onClick, onDiv: onDiv, onHover: onHover } = events, divBubble = (0, $ab7d474d755ab51b$export$5d1f020956707f4)("bubble", onDiv);
        if (!(divBubble || onHover.enable && mouse.position || onClick.enable && mouse.clickPosition)) return false;
        return (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("bubble", onHover.mode) || (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("bubble", onClick.mode) || divBubble;
    }
    loadModeOptions(options, ...sources) {
        if (!options.bubble) options.bubble = new (0, $e8a2ca5cf86e47c6$export$646feb54fbadbe06)();
        for (const source of sources)options.bubble.load(source?.bubble);
    }
    reset(particle) {
        particle.bubble.inRange = false;
    }
}








async function $1b576938e8b0f649$export$38085c395e2c86d6(engine, refresh = true) {
    await engine.addInteractor("externalBubble", (container)=>new (0, $43b098819881552e$export$6430b7804bc9fbe5)(container), refresh);
}



class $2e6edd55a6cec9cf$export$e5eae882224f3ec7 {
    constructor(){
        this.opacity = 0.5;
    }
    load(data) {
        if (!data) return;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}


class $37d9b62554cfc318$export$59e6910693f047c2 {
    constructor(){
        this.distance = 80;
        this.links = new (0, $2e6edd55a6cec9cf$export$e5eae882224f3ec7)();
        this.radius = 60;
    }
    get lineLinked() {
        return this.links;
    }
    set lineLinked(value) {
        this.links = value;
    }
    get line_linked() {
        return this.links;
    }
    set line_linked(value) {
        this.links = value;
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = data.distance;
        this.links.load(data.links ?? data.lineLinked ?? data.line_linked);
        if (data.radius !== undefined) this.radius = data.radius;
    }
}



function $5668e308efc2852f$export$f7d09cddc76f277f(context, p1, p2, opacity) {
    const gradStop = Math.floor(p2.getRadius() / p1.getRadius()), color1 = p1.getFillColor(), color2 = p2.getFillColor();
    if (!color1 || !color2) return;
    const sourcePos = p1.getPosition(), destPos = p2.getPosition(), midRgb = (0, $3b20cd3c058d307c$export$9b476054b78b89cd)(color1, color2, p1.getRadius(), p2.getRadius()), grad = context.createLinearGradient(sourcePos.x, sourcePos.y, destPos.x, destPos.y);
    grad.addColorStop(0, (0, $3b20cd3c058d307c$export$9d057e59c7b0a82d)(color1, opacity));
    grad.addColorStop(gradStop > 1 ? 1 : gradStop, (0, $3b20cd3c058d307c$export$2476af37e47fcae2)(midRgb, opacity));
    grad.addColorStop(1, (0, $3b20cd3c058d307c$export$9d057e59c7b0a82d)(color2, opacity));
    return grad;
}
function $5668e308efc2852f$export$11e612c61d71bca9(context, width, lineStyle, begin, end) {
    (0, $b69b7cfe4b0de35f$export$819db45aec5fcbe5)(context, begin, end);
    context.lineWidth = width;
    context.strokeStyle = lineStyle;
    context.stroke();
}
function $5668e308efc2852f$export$dae7cf860e07354f(container, ctx, p1, p2) {
    const options = container.actualOptions, connectOptions = options.interactivity.modes.connect;
    if (!connectOptions) return;
    return $5668e308efc2852f$export$f7d09cddc76f277f(ctx, p1, p2, connectOptions.links.opacity);
}
function $5668e308efc2852f$export$7b1cbcf336779304(container, p1, p2) {
    container.canvas.draw((ctx)=>{
        const ls = $5668e308efc2852f$export$dae7cf860e07354f(container, ctx, p1, p2);
        if (!ls) return;
        const pos1 = p1.getPosition(), pos2 = p2.getPosition();
        $5668e308efc2852f$export$11e612c61d71bca9(ctx, p1.retina.linksWidth ?? 0, ls, pos1, pos2);
    });
}


class $8091077da75dc769$export$b2278035370d6017 extends (0, $a34f6e88dd5ec1a0$export$6e252256471acc61) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {
        const container = this.container, connect = container.actualOptions.interactivity.modes.connect;
        if (!connect) return;
        container.retina.connectModeDistance = connect.distance * container.retina.pixelRatio;
        container.retina.connectModeRadius = connect.radius * container.retina.pixelRatio;
    }
    async interact() {
        const container = this.container, options = container.actualOptions;
        if (options.interactivity.events.onHover.enable && container.interactivity.status === "pointermove") {
            const mousePos = container.interactivity.mouse.position;
            if (!container.retina.connectModeDistance || container.retina.connectModeDistance < 0 || !container.retina.connectModeRadius || container.retina.connectModeRadius < 0 || !mousePos) return;
            const distance = Math.abs(container.retina.connectModeRadius), query = container.particles.quadTree.queryCircle(mousePos, distance, (p)=>this.isEnabled(p));
            let i = 0;
            for (const p1 of query){
                const pos1 = p1.getPosition();
                for (const p2 of query.slice(i + 1)){
                    const pos2 = p2.getPosition(), distMax = Math.abs(container.retina.connectModeDistance), xDiff = Math.abs(pos1.x - pos2.x), yDiff = Math.abs(pos1.y - pos2.y);
                    if (xDiff < distMax && yDiff < distMax) (0, $5668e308efc2852f$export$7b1cbcf336779304)(container, p1, p2);
                }
                ++i;
            }
        }
    }
    isEnabled(particle) {
        const container = this.container, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? container.actualOptions.interactivity).events;
        if (!(events.onHover.enable && mouse.position)) return false;
        return (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("connect", events.onHover.mode);
    }
    loadModeOptions(options, ...sources) {
        if (!options.connect) options.connect = new (0, $37d9b62554cfc318$export$59e6910693f047c2)();
        for (const source of sources)options.connect.load(source?.connect);
    }
    reset() {}
}






async function $6a87c76d53b7dca5$export$6d77a62d34a75d00(engine, refresh = true) {
    await engine.addInteractor("externalConnect", (container)=>new (0, $8091077da75dc769$export$b2278035370d6017)(container), refresh);
}




class $7b9cb2941961d479$export$18834b4d015f5981 {
    constructor(){
        this.blink = false;
        this.consent = false;
        this.opacity = 1;
    }
    load(data) {
        if (!data) return;
        if (data.blink !== undefined) this.blink = data.blink;
        if (data.color !== undefined) this.color = (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.consent !== undefined) this.consent = data.consent;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}


class $4e99d3a1877b87fc$export$19925e45e371d8d {
    constructor(){
        this.distance = 100;
        this.links = new (0, $7b9cb2941961d479$export$18834b4d015f5981)();
    }
    get lineLinked() {
        return this.links;
    }
    set lineLinked(value) {
        this.links = value;
    }
    get line_linked() {
        return this.links;
    }
    set line_linked(value) {
        this.links = value;
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = data.distance;
        this.links.load(data.links ?? data.lineLinked ?? data.line_linked);
    }
}



function $259cd1cb78c0c51b$export$d5ea4ac1cc26adad(context, width, begin, end, colorLine, opacity) {
    (0, $b69b7cfe4b0de35f$export$819db45aec5fcbe5)(context, begin, end);
    context.strokeStyle = (0, $3b20cd3c058d307c$export$2476af37e47fcae2)(colorLine, opacity);
    context.lineWidth = width;
    context.stroke();
}
function $259cd1cb78c0c51b$export$62755b116b3b3e8(container, particle, lineColor, opacity, mousePos) {
    container.canvas.draw((ctx)=>{
        const beginPos = particle.getPosition();
        $259cd1cb78c0c51b$export$d5ea4ac1cc26adad(ctx, particle.retina.linksWidth ?? 0, beginPos, mousePos, lineColor, opacity);
    });
}


class $ceeccb05e829be96$export$b1641bf46f4bbeac extends (0, $a34f6e88dd5ec1a0$export$6e252256471acc61) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {
        const container = this.container, grab = container.actualOptions.interactivity.modes.grab;
        if (!grab) return;
        container.retina.grabModeDistance = grab.distance * container.retina.pixelRatio;
    }
    async interact() {
        const container = this.container, options = container.actualOptions, interactivity = options.interactivity;
        if (!interactivity.modes.grab || !interactivity.events.onHover.enable || container.interactivity.status !== (0, $9f7790cd505e6a79$export$1ffe551d7d33cd33)) return;
        const mousePos = container.interactivity.mouse.position;
        if (!mousePos) return;
        const distance = container.retina.grabModeDistance;
        if (!distance || distance < 0) return;
        const query = container.particles.quadTree.queryCircle(mousePos, distance, (p)=>this.isEnabled(p));
        for (const particle of query){
            const pos = particle.getPosition(), pointDistance = (0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(pos, mousePos);
            if (pointDistance > distance) continue;
            const grabLineOptions = interactivity.modes.grab.links, lineOpacity = grabLineOptions.opacity, opacityLine = lineOpacity - pointDistance * lineOpacity / distance;
            if (opacityLine <= 0) continue;
            const optColor = grabLineOptions.color ?? particle.options.links?.color;
            if (!container.particles.grabLineColor && optColor) {
                const linksOptions = interactivity.modes.grab.links;
                container.particles.grabLineColor = (0, $3b20cd3c058d307c$export$cf0e5a4ae26bdcdc)(optColor, linksOptions.blink, linksOptions.consent);
            }
            const colorLine = (0, $3b20cd3c058d307c$export$b676eb46c472d7df)(particle, undefined, container.particles.grabLineColor);
            if (!colorLine) continue;
            (0, $259cd1cb78c0c51b$export$62755b116b3b3e8)(container, particle, colorLine, opacityLine, mousePos);
        }
    }
    isEnabled(particle) {
        const container = this.container, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? container.actualOptions.interactivity).events;
        return events.onHover.enable && !!mouse.position && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("grab", events.onHover.mode);
    }
    loadModeOptions(options, ...sources) {
        if (!options.grab) options.grab = new (0, $4e99d3a1877b87fc$export$19925e45e371d8d)();
        for (const source of sources)options.grab.load(source?.grab);
    }
    reset() {}
}






async function $9094ce23a4e133f4$export$919b2e865378f034(engine, refresh = true) {
    await engine.addInteractor("externalGrab", (container)=>new (0, $ceeccb05e829be96$export$b1641bf46f4bbeac)(container), refresh);
}



class $90a39c3b0804816f$export$193ea5a420bb5c41 extends (0, $a34f6e88dd5ec1a0$export$6e252256471acc61) {
    constructor(container){
        super(container);
        this.handleClickMode = (mode)=>{
            if (mode !== "pause") return;
            const container = this.container;
            if (container.getAnimationStatus()) container.pause();
            else container.play();
        };
    }
    clear() {}
    init() {}
    async interact() {}
    isEnabled() {
        return true;
    }
    reset() {}
}


async function $867e55cfe3609187$export$bbbab73b3aee4f94(engine, refresh = true) {
    await engine.addInteractor("externalPause", (container)=>new (0, $90a39c3b0804816f$export$193ea5a420bb5c41)(container), refresh);
}




class $ee2e06393e198a16$export$fb87db22c6b0e2ba {
    constructor(){
        this.default = true;
        this.groups = [];
        this.quantity = 4;
    }
    get particles_nb() {
        return this.quantity;
    }
    set particles_nb(value) {
        this.quantity = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(value);
    }
    load(data) {
        if (!data) return;
        if (data.default !== undefined) this.default = data.default;
        if (data.groups !== undefined) this.groups = data.groups.map((t)=>t);
        if (!this.groups.length) this.default = true;
        const quantity = data.quantity ?? data.particles_nb;
        if (quantity !== undefined) this.quantity = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(quantity);
    }
}


class $f57aa06d5e4edb28$export$3f362fabca57c3b4 extends (0, $a34f6e88dd5ec1a0$export$6e252256471acc61) {
    constructor(container){
        super(container);
        this.handleClickMode = (mode)=>{
            if (mode !== "push") return;
            const container = this.container, options = container.actualOptions, pushOptions = options.interactivity.modes.push;
            if (!pushOptions) return;
            const quantity = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(pushOptions.quantity);
            if (quantity <= 0) return;
            const group = (0, $ab7d474d755ab51b$export$3a5d12ca7137122f)([
                undefined,
                ...pushOptions.groups
            ]), groupOptions = group !== undefined ? container.actualOptions.particles.groups[group] : undefined;
            container.particles.push(quantity, container.interactivity.mouse, groupOptions, group);
        };
    }
    clear() {}
    init() {}
    async interact() {}
    isEnabled() {
        return true;
    }
    loadModeOptions(options, ...sources) {
        if (!options.push) options.push = new (0, $ee2e06393e198a16$export$fb87db22c6b0e2ba)();
        for (const source of sources)options.push.load(source?.push);
    }
    reset() {}
}




async function $3a1142db207d63a5$export$38a8d49241950f5a(engine, refresh = true) {
    await engine.addInteractor("externalPush", (container)=>new (0, $f57aa06d5e4edb28$export$3f362fabca57c3b4)(container), refresh);
}




class $5dc0d42d2552049c$export$6072865765515195 {
    constructor(){
        this.quantity = 2;
    }
    get particles_nb() {
        return this.quantity;
    }
    set particles_nb(value) {
        this.quantity = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(value);
    }
    load(data) {
        if (!data) return;
        const quantity = data.quantity ?? data.particles_nb;
        if (quantity !== undefined) this.quantity = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(quantity);
    }
}


class $dcc699088e8c884f$export$8772d4256fea677e extends (0, $a34f6e88dd5ec1a0$export$6e252256471acc61) {
    constructor(container){
        super(container);
        this.handleClickMode = (mode)=>{
            const container = this.container, options = container.actualOptions;
            if (!options.interactivity.modes.remove || mode !== "remove") return;
            const removeNb = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(options.interactivity.modes.remove.quantity);
            container.particles.removeQuantity(removeNb);
        };
    }
    clear() {}
    init() {}
    async interact() {}
    isEnabled() {
        return true;
    }
    loadModeOptions(options, ...sources) {
        if (!options.remove) options.remove = new (0, $5dc0d42d2552049c$export$6072865765515195)();
        for (const source of sources)options.remove.load(source?.remove);
    }
    reset() {}
}




async function $3cd65b1242c9aaca$export$7eeb8763dff0d815(engine, refresh = true) {
    await engine.addInteractor("externalRemove", (container)=>new (0, $dcc699088e8c884f$export$8772d4256fea677e)(container), refresh);
}




class $c2e18a5173006a5e$export$45e7d1e8b677a8c1 {
    constructor(){
        this.distance = 200;
        this.duration = 0.4;
        this.factor = 100;
        this.speed = 1;
        this.maxSpeed = 50;
        this.easing = "ease-out-quad";
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = data.distance;
        if (data.duration !== undefined) this.duration = data.duration;
        if (data.easing !== undefined) this.easing = data.easing;
        if (data.factor !== undefined) this.factor = data.factor;
        if (data.speed !== undefined) this.speed = data.speed;
        if (data.maxSpeed !== undefined) this.maxSpeed = data.maxSpeed;
    }
}




class $51435ab76a498417$export$4a5cb954c5b3580d extends (0, $c2e18a5173006a5e$export$45e7d1e8b677a8c1) {
    constructor(){
        super();
        this.selectors = [];
    }
    get ids() {
        return (0, $ab7d474d755ab51b$export$8e5dc47097396754)(this.selectors, (t)=>t.replace("#", ""));
    }
    set ids(value) {
        this.selectors = (0, $ab7d474d755ab51b$export$8e5dc47097396754)(value, (t)=>`#${t}`);
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.ids !== undefined) this.ids = data.ids;
        if (data.selectors !== undefined) this.selectors = data.selectors;
    }
}


class $1ab989af38147b2c$export$12e904dcff83f5f9 extends (0, $c2e18a5173006a5e$export$45e7d1e8b677a8c1) {
    load(data) {
        super.load(data);
        if (!data) return;
        this.divs = (0, $ab7d474d755ab51b$export$8e5dc47097396754)(data.divs, (div)=>{
            const tmp = new (0, $51435ab76a498417$export$4a5cb954c5b3580d)();
            tmp.load(div);
            return tmp;
        });
    }
}


class $795bdf6500fb6e80$export$4d442f40198e66c4 extends (0, $a34f6e88dd5ec1a0$export$6e252256471acc61) {
    constructor(engine, container){
        super(container);
        this._clickRepulse = ()=>{
            const container = this.container, repulseOptions = container.actualOptions.interactivity.modes.repulse;
            if (!repulseOptions) return;
            const repulse = container.repulse || {
                particles: []
            };
            if (!repulse.finish) {
                if (!repulse.count) repulse.count = 0;
                repulse.count++;
                if (repulse.count === container.particles.count) repulse.finish = true;
            }
            if (repulse.clicking) {
                const repulseDistance = container.retina.repulseModeDistance;
                if (!repulseDistance || repulseDistance < 0) return;
                const repulseRadius = Math.pow(repulseDistance / 6, 3), mouseClickPos = container.interactivity.mouse.clickPosition;
                if (mouseClickPos === undefined) return;
                const range = new (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa)(mouseClickPos.x, mouseClickPos.y, repulseRadius), query = container.particles.quadTree.query(range, (p)=>this.isEnabled(p));
                for (const particle of query){
                    const { dx: dx, dy: dy, distance: distance } = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(mouseClickPos, particle.position), d = distance ** 2, velocity = repulseOptions.speed, force = -repulseRadius * velocity / d;
                    if (d <= repulseRadius) {
                        repulse.particles.push(particle);
                        const vect = (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).create(dx, dy);
                        vect.length = force;
                        particle.velocity.setTo(vect);
                    }
                }
            } else if (repulse.clicking === false) {
                for (const particle of repulse.particles)particle.velocity.setTo(particle.initialVelocity);
                repulse.particles = [];
            }
        };
        this._hoverRepulse = ()=>{
            const container = this.container, mousePos = container.interactivity.mouse.position, repulseRadius = container.retina.repulseModeDistance;
            if (!repulseRadius || repulseRadius < 0 || !mousePos) return;
            this._processRepulse(mousePos, repulseRadius, new (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa)(mousePos.x, mousePos.y, repulseRadius));
        };
        this._processRepulse = (position, repulseRadius, area, divRepulse)=>{
            const container = this.container, query = container.particles.quadTree.query(area, (p)=>this.isEnabled(p)), repulseOptions = container.actualOptions.interactivity.modes.repulse;
            if (!repulseOptions) return;
            for (const particle of query){
                const { dx: dx, dy: dy, distance: distance } = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(particle.position, position), velocity = (divRepulse?.speed ?? repulseOptions.speed) * repulseOptions.factor, repulseFactor = (0, $a17cb6ec9e2ec6c9$export$7d15b64cf5a3a4c4)((0, $a17cb6ec9e2ec6c9$export$2bbf531f74195405)(repulseOptions.easing)(1 - distance / repulseRadius) * velocity, 0, repulseOptions.maxSpeed), normVec = (0, $f2e8cb9a78120c28$export$9b781de7bf37bf48).create(distance === 0 ? velocity : dx / distance * repulseFactor, distance === 0 ? velocity : dy / distance * repulseFactor);
                particle.position.addTo(normVec);
            }
        };
        this._singleSelectorRepulse = (selector, div)=>{
            const container = this.container, repulse = container.actualOptions.interactivity.modes.repulse;
            if (!repulse) return;
            const query = document.querySelectorAll(selector);
            if (!query.length) return;
            query.forEach((item)=>{
                const elem = item, pxRatio = container.retina.pixelRatio, pos = {
                    x: (elem.offsetLeft + elem.offsetWidth / 2) * pxRatio,
                    y: (elem.offsetTop + elem.offsetHeight / 2) * pxRatio
                }, repulseRadius = elem.offsetWidth / 2 * pxRatio, area = div.type === "circle" ? new (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa)(pos.x, pos.y, repulseRadius) : new (0, $fbaf108f02b30a19$export$4617fb02663045ef)(elem.offsetLeft * pxRatio, elem.offsetTop * pxRatio, elem.offsetWidth * pxRatio, elem.offsetHeight * pxRatio), divs = repulse.divs, divRepulse = (0, $ab7d474d755ab51b$export$f7c2b83aad443adb)(divs, elem);
                this._processRepulse(pos, repulseRadius, area, divRepulse);
            });
        };
        this._engine = engine;
        if (!container.repulse) container.repulse = {
            particles: []
        };
        this.handleClickMode = (mode)=>{
            const options = this.container.actualOptions, repulseOpts = options.interactivity.modes.repulse;
            if (!repulseOpts || mode !== "repulse") return;
            if (!container.repulse) container.repulse = {
                particles: []
            };
            const repulse = container.repulse;
            repulse.clicking = true;
            repulse.count = 0;
            for (const particle of container.repulse.particles){
                if (!this.isEnabled(particle)) continue;
                particle.velocity.setTo(particle.initialVelocity);
            }
            repulse.particles = [];
            repulse.finish = false;
            setTimeout(()=>{
                if (container.destroyed) return;
                repulse.clicking = false;
            }, repulseOpts.duration * 1000);
        };
    }
    clear() {}
    init() {
        const container = this.container, repulse = container.actualOptions.interactivity.modes.repulse;
        if (!repulse) return;
        container.retina.repulseModeDistance = repulse.distance * container.retina.pixelRatio;
    }
    async interact() {
        const container = this.container, options = container.actualOptions, mouseMoveStatus = container.interactivity.status === (0, $9f7790cd505e6a79$export$1ffe551d7d33cd33), events = options.interactivity.events, hover = events.onHover, hoverEnabled = hover.enable, hoverMode = hover.mode, click = events.onClick, clickEnabled = click.enable, clickMode = click.mode, divs = events.onDiv;
        if (mouseMoveStatus && hoverEnabled && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("repulse", hoverMode)) this._hoverRepulse();
        else if (clickEnabled && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("repulse", clickMode)) this._clickRepulse();
        else (0, $ab7d474d755ab51b$export$194f9554360903fd)("repulse", divs, (selector, div)=>this._singleSelectorRepulse(selector, div));
    }
    isEnabled(particle) {
        const container = this.container, options = container.actualOptions, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? options.interactivity).events, divs = events.onDiv, hover = events.onHover, click = events.onClick, divRepulse = (0, $ab7d474d755ab51b$export$5d1f020956707f4)("repulse", divs);
        if (!(divRepulse || hover.enable && mouse.position || click.enable && mouse.clickPosition)) return false;
        const hoverMode = hover.mode, clickMode = click.mode;
        return (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("repulse", hoverMode) || (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("repulse", clickMode) || divRepulse;
    }
    loadModeOptions(options, ...sources) {
        if (!options.repulse) options.repulse = new (0, $1ab989af38147b2c$export$12e904dcff83f5f9)();
        for (const source of sources)options.repulse.load(source?.repulse);
    }
    reset() {}
}








async function $9f5eabca63a1d30e$export$5ff7a4cab01244f4(engine, refresh = true) {
    await engine.addInteractor("externalRepulse", (container)=>new (0, $795bdf6500fb6e80$export$4d442f40198e66c4)(engine, container), refresh);
}



class $fbe73299c6513125$export$b417a3b6f3fd58ad {
    constructor(){
        this.factor = 3;
        this.radius = 200;
    }
    load(data) {
        if (!data) return;
        if (data.factor !== undefined) this.factor = data.factor;
        if (data.radius !== undefined) this.radius = data.radius;
    }
}


class $bea054cea2626a71$export$16a733526f31d7d extends (0, $a34f6e88dd5ec1a0$export$6e252256471acc61) {
    constructor(container){
        super(container);
    }
    clear(particle, delta, force) {
        if (particle.slow.inRange && !force) return;
        particle.slow.factor = 1;
    }
    init() {
        const container = this.container, slow = container.actualOptions.interactivity.modes.slow;
        if (!slow) return;
        container.retina.slowModeRadius = slow.radius * container.retina.pixelRatio;
    }
    async interact() {}
    isEnabled(particle) {
        const container = this.container, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? container.actualOptions.interactivity).events;
        return events.onHover.enable && !!mouse.position && (0, $ab7d474d755ab51b$export$5e9bb4359042e24b)("slow", events.onHover.mode);
    }
    loadModeOptions(options, ...sources) {
        if (!options.slow) options.slow = new (0, $fbe73299c6513125$export$b417a3b6f3fd58ad)();
        for (const source of sources)options.slow.load(source?.slow);
    }
    reset(particle) {
        particle.slow.inRange = false;
        const container = this.container, options = container.actualOptions, mousePos = container.interactivity.mouse.position, radius = container.retina.slowModeRadius, slowOptions = options.interactivity.modes.slow;
        if (!slowOptions || !radius || radius < 0 || !mousePos) return;
        const particlePos = particle.getPosition(), dist = (0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(mousePos, particlePos), proximityFactor = dist / radius, slowFactor = slowOptions.factor, { slow: slow } = particle;
        if (dist > radius) return;
        slow.inRange = true;
        slow.factor = proximityFactor / slowFactor;
    }
}




async function $f7fe00e9889a9e84$export$da393a0f615758e8(engine, refresh = true) {
    await engine.addInteractor("externalSlow", (container)=>new (0, $bea054cea2626a71$export$16a733526f31d7d)(container), refresh);
}



const $79d29b4d58cd68cc$export$6e3040decbe42e1 = [
    0,
    4,
    2,
    1
];
const $79d29b4d58cd68cc$export$a6bec62d89063364 = [
    8,
    8,
    4,
    2
];


class $7e4714fb14b461b2$export$8130652b8df6235f {
    constructor(bytes){
        this.pos = 0;
        this.data = new Uint8ClampedArray(bytes);
    }
    getString(count) {
        const slice = this.data.slice(this.pos, this.pos + count);
        this.pos += slice.length;
        return slice.reduce((acc, curr)=>acc + String.fromCharCode(curr), "");
    }
    nextByte() {
        return this.data[this.pos++];
    }
    nextTwoBytes() {
        this.pos += 2;
        return this.data[this.pos - 2] + (this.data[this.pos - 1] << 8);
    }
    readSubBlocks() {
        let blockString = "", size = 0;
        do {
            size = this.data[this.pos++];
            for(let count = size; --count >= 0; blockString += String.fromCharCode(this.data[this.pos++]));
        }while (size !== 0);
        return blockString;
    }
    readSubBlocksBin() {
        let size = 0, len = 0;
        for(let offset = 0; (size = this.data[this.pos + offset]) !== 0; offset += size + 1)len += size;
        const blockData = new Uint8Array(len);
        for(let i = 0; (size = this.data[this.pos++]) !== 0;){
            for(let count = size; --count >= 0; blockData[i++] = this.data[this.pos++]);
        }
        return blockData;
    }
    skipSubBlocks() {
        for(; this.data[this.pos] !== 0; this.pos += this.data[this.pos] + 1);
        this.pos++;
    }
}


function $f9e07d4431d0e126$var$parseColorTable(byteStream, count) {
    const colors = [];
    for(let i = 0; i < count; i++){
        colors.push({
            r: byteStream.data[byteStream.pos],
            g: byteStream.data[byteStream.pos + 1],
            b: byteStream.data[byteStream.pos + 2]
        });
        byteStream.pos += 3;
    }
    return colors;
}
async function $f9e07d4431d0e126$var$parseExtensionBlock(byteStream, gif, getFrameIndex, getTransparencyIndex) {
    switch(byteStream.nextByte()){
        case 249:
            {
                const frame = gif.frames[getFrameIndex(false)];
                byteStream.pos++;
                const packedByte = byteStream.nextByte();
                frame.GCreserved = (packedByte & 0xe0) >>> 5;
                frame.disposalMethod = (packedByte & 0x1c) >>> 2;
                frame.userInputDelayFlag = (packedByte & 2) === 2;
                const transparencyFlag = (packedByte & 1) === 1;
                frame.delayTime = byteStream.nextTwoBytes() * 0xa;
                const transparencyIndex = byteStream.nextByte();
                if (transparencyFlag) getTransparencyIndex(transparencyIndex);
                byteStream.pos++;
                break;
            }
        case 255:
            {
                byteStream.pos++;
                const applicationExtension = {
                    identifier: byteStream.getString(8),
                    authenticationCode: byteStream.getString(3),
                    data: byteStream.readSubBlocksBin()
                };
                gif.applicationExtensions.push(applicationExtension);
                break;
            }
        case 254:
            gif.comments.push([
                getFrameIndex(false),
                byteStream.readSubBlocks()
            ]);
            break;
        case 1:
            if (gif.globalColorTable.length === 0) throw new EvalError("plain text extension without global color table");
            byteStream.pos++;
            gif.frames[getFrameIndex(false)].plainTextData = {
                left: byteStream.nextTwoBytes(),
                top: byteStream.nextTwoBytes(),
                width: byteStream.nextTwoBytes(),
                height: byteStream.nextTwoBytes(),
                charSize: {
                    width: byteStream.nextTwoBytes(),
                    height: byteStream.nextTwoBytes()
                },
                foregroundColor: byteStream.nextByte(),
                backgroundColor: byteStream.nextByte(),
                text: byteStream.readSubBlocks()
            };
            break;
        default:
            byteStream.skipSubBlocks();
            break;
    }
}
async function $f9e07d4431d0e126$var$parseImageBlock(byteStream, gif, avgAlpha, getFrameIndex, getTransparencyIndex, progressCallback) {
    const frame = gif.frames[getFrameIndex(true)];
    frame.left = byteStream.nextTwoBytes();
    frame.top = byteStream.nextTwoBytes();
    frame.width = byteStream.nextTwoBytes();
    frame.height = byteStream.nextTwoBytes();
    const packedByte = byteStream.nextByte(), localColorTableFlag = (packedByte & 0x80) === 0x80, interlacedFlag = (packedByte & 0x40) === 0x40;
    frame.sortFlag = (packedByte & 0x20) === 0x20;
    frame.reserved = (packedByte & 0x18) >>> 3;
    const localColorCount = 1 << (packedByte & 7) + 1;
    if (localColorTableFlag) frame.localColorTable = $f9e07d4431d0e126$var$parseColorTable(byteStream, localColorCount);
    const getColor = (index)=>{
        const { r: r, g: g, b: b } = (localColorTableFlag ? frame.localColorTable : gif.globalColorTable)[index];
        return {
            r: r,
            g: g,
            b: b,
            a: index === getTransparencyIndex(null) ? avgAlpha ? ~~((r + g + b) / 3) : 0 : 255
        };
    };
    const image = (()=>{
        try {
            return new ImageData(frame.width, frame.height, {
                colorSpace: "srgb"
            });
        } catch (error) {
            if (error instanceof DOMException && error.name === "IndexSizeError") return null;
            throw error;
        }
    })();
    if (image == null) throw new EvalError("GIF frame size is to large");
    const minCodeSize = byteStream.nextByte(), imageData = byteStream.readSubBlocksBin(), clearCode = 1 << minCodeSize;
    const readBits = (pos, len)=>{
        const bytePos = pos >>> 3, bitPos = pos & 7;
        return (imageData[bytePos] + (imageData[bytePos + 1] << 8) + (imageData[bytePos + 2] << 16) & (1 << len) - 1 << bitPos) >>> bitPos;
    };
    if (interlacedFlag) {
        for(let code = 0, size = minCodeSize + 1, pos = 0, dic = [
            [
                0
            ]
        ], pass = 0; pass < 4; pass++){
            if ((0, $79d29b4d58cd68cc$export$6e3040decbe42e1)[pass] < frame.height) for(let pixelPos = 0, lineIndex = 0;;){
                const last = code;
                code = readBits(pos, size);
                pos += size + 1;
                if (code === clearCode) {
                    size = minCodeSize + 1;
                    dic.length = clearCode + 2;
                    for(let i = 0; i < dic.length; i++)dic[i] = i < clearCode ? [
                        i
                    ] : [];
                } else {
                    if (code >= dic.length) dic.push(dic[last].concat(dic[last][0]));
                    else if (last !== clearCode) dic.push(dic[last].concat(dic[code][0]));
                    for(let i = 0; i < dic[code].length; i++){
                        const { r: r, g: g, b: b, a: a } = getColor(dic[code][i]);
                        image.data.set([
                            r,
                            g,
                            b,
                            a
                        ], (0, $79d29b4d58cd68cc$export$6e3040decbe42e1)[pass] * frame.width + (0, $79d29b4d58cd68cc$export$a6bec62d89063364)[pass] * lineIndex + pixelPos % (frame.width * 4));
                        pixelPos += 4;
                    }
                    if (dic.length === 1 << size && size < 0xc) size++;
                }
                if (pixelPos === frame.width * 4 * (lineIndex + 1)) {
                    lineIndex++;
                    if ((0, $79d29b4d58cd68cc$export$6e3040decbe42e1)[pass] + (0, $79d29b4d58cd68cc$export$a6bec62d89063364)[pass] * lineIndex >= frame.height) break;
                }
            }
            progressCallback?.(byteStream.pos / (byteStream.data.length - 1), getFrameIndex(false) + 1, image, {
                x: frame.left,
                y: frame.top
            }, {
                width: gif.width,
                height: gif.height
            });
        }
        frame.image = image;
        frame.bitmap = await createImageBitmap(image);
    } else {
        for(let code = 0, size = minCodeSize + 1, pos = 0, dic = [
            [
                0
            ]
        ], pixelPos = -4;;){
            const last = code;
            code = readBits(pos, size);
            pos += size;
            if (code === clearCode) {
                size = minCodeSize + 1;
                dic.length = clearCode + 2;
                for(let i = 0; i < dic.length; i++)dic[i] = i < clearCode ? [
                    i
                ] : [];
            } else {
                if (code === clearCode + 1) break;
                if (code >= dic.length) dic.push(dic[last].concat(dic[last][0]));
                else if (last !== clearCode) dic.push(dic[last].concat(dic[code][0]));
                for(let i = 0; i < dic[code].length; i++){
                    const { r: r, g: g, b: b, a: a } = getColor(dic[code][i]);
                    image.data.set([
                        r,
                        g,
                        b,
                        a
                    ], pixelPos += 4);
                }
                if (dic.length >= 1 << size && size < 0xc) size++;
            }
        }
        frame.image = image;
        frame.bitmap = await createImageBitmap(image);
        progressCallback?.((byteStream.pos + 1) / byteStream.data.length, getFrameIndex(false) + 1, frame.image, {
            x: frame.left,
            y: frame.top
        }, {
            width: gif.width,
            height: gif.height
        });
    }
}
async function $f9e07d4431d0e126$var$parseBlock(byteStream, gif, avgAlpha, getFrameIndex, getTransparencyIndex, progressCallback) {
    switch(byteStream.nextByte()){
        case 59:
            return true;
        case 44:
            await $f9e07d4431d0e126$var$parseImageBlock(byteStream, gif, avgAlpha, getFrameIndex, getTransparencyIndex, progressCallback);
            break;
        case 33:
            await $f9e07d4431d0e126$var$parseExtensionBlock(byteStream, gif, getFrameIndex, getTransparencyIndex);
            break;
        default:
            throw new EvalError("undefined block found");
    }
    return false;
}
function $f9e07d4431d0e126$export$67ac3d66f3062195(gif) {
    for (const extension of gif.applicationExtensions){
        if (extension.identifier + extension.authenticationCode !== "NETSCAPE2.0") continue;
        return extension.data[1] + (extension.data[2] << 8);
    }
    return NaN;
}
async function $f9e07d4431d0e126$export$242c765bf39e1a4e(gifURL, progressCallback, avgAlpha) {
    if (!avgAlpha) avgAlpha = false;
    const res = await fetch(gifURL);
    if (!res.ok && res.status === 404) throw new EvalError("file not found");
    const buffer = await res.arrayBuffer();
    const gif = {
        width: 0,
        height: 0,
        totalTime: 0,
        colorRes: 0,
        pixelAspectRatio: 0,
        frames: [],
        sortFlag: false,
        globalColorTable: [],
        backgroundImage: new ImageData(1, 1, {
            colorSpace: "srgb"
        }),
        comments: [],
        applicationExtensions: []
    }, byteStream = new (0, $7e4714fb14b461b2$export$8130652b8df6235f)(new Uint8ClampedArray(buffer));
    if (byteStream.getString(6) !== "GIF89a") throw new Error("not a supported GIF file");
    gif.width = byteStream.nextTwoBytes();
    gif.height = byteStream.nextTwoBytes();
    const packedByte = byteStream.nextByte(), globalColorTableFlag = (packedByte & 0x80) === 0x80;
    gif.colorRes = (packedByte & 0x70) >>> 4;
    gif.sortFlag = (packedByte & 8) === 8;
    const globalColorCount = 1 << (packedByte & 7) + 1, backgroundColorIndex = byteStream.nextByte();
    gif.pixelAspectRatio = byteStream.nextByte();
    if (gif.pixelAspectRatio !== 0) gif.pixelAspectRatio = (gif.pixelAspectRatio + 0xf) / 0x40;
    if (globalColorTableFlag) gif.globalColorTable = $f9e07d4431d0e126$var$parseColorTable(byteStream, globalColorCount);
    const backgroundImage = (()=>{
        try {
            return new ImageData(gif.width, gif.height, {
                colorSpace: "srgb"
            });
        } catch (error) {
            if (error instanceof DOMException && error.name === "IndexSizeError") return null;
            throw error;
        }
    })();
    if (backgroundImage == null) throw new Error("GIF frame size is to large");
    const { r: r, g: g, b: b } = gif.globalColorTable[backgroundColorIndex];
    backgroundImage.data.set(globalColorTableFlag ? [
        r,
        g,
        b,
        255
    ] : [
        0,
        0,
        0,
        0
    ]);
    for(let i = 4; i < backgroundImage.data.length; i *= 2)backgroundImage.data.copyWithin(i, 0, i);
    gif.backgroundImage = backgroundImage;
    let frameIndex = -1, incrementFrameIndex = true, transparencyIndex = -1;
    const getframeIndex = (increment)=>{
        if (increment) incrementFrameIndex = true;
        return frameIndex;
    };
    const getTransparencyIndex = (newValue)=>{
        if (newValue != null) transparencyIndex = newValue;
        return transparencyIndex;
    };
    try {
        do if (incrementFrameIndex) {
            gif.frames.push({
                left: 0,
                top: 0,
                width: 0,
                height: 0,
                disposalMethod: 0,
                image: new ImageData(1, 1, {
                    colorSpace: "srgb"
                }),
                plainTextData: null,
                userInputDelayFlag: false,
                delayTime: 0,
                sortFlag: false,
                localColorTable: [],
                reserved: 0,
                GCreserved: 0
            });
            frameIndex++;
            transparencyIndex = -1;
            incrementFrameIndex = false;
        }
        while (!await $f9e07d4431d0e126$var$parseBlock(byteStream, gif, avgAlpha, getframeIndex, getTransparencyIndex, progressCallback));
        gif.frames.length--;
        for (const frame of gif.frames){
            if (frame.userInputDelayFlag && frame.delayTime === 0) {
                gif.totalTime = Infinity;
                break;
            }
            gif.totalTime += frame.delayTime;
        }
        return gif;
    } catch (error) {
        if (error instanceof EvalError) throw new Error(`error while parsing frame ${frameIndex} "${error.message}"`);
        throw error;
    }
}


const $6bd96f509c674554$var$currentColorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d.]+%?\))|currentcolor/gi;
function $6bd96f509c674554$var$replaceColorSvg(imageShape, color, opacity) {
    const { svgData: svgData } = imageShape;
    if (!svgData) return "";
    const colorStyle = (0, $3b20cd3c058d307c$export$9d057e59c7b0a82d)(color, opacity);
    if (svgData.includes("fill")) return svgData.replace($6bd96f509c674554$var$currentColorRegex, ()=>colorStyle);
    const preFillIndex = svgData.indexOf(">");
    return `${svgData.substring(0, preFillIndex)} fill="${colorStyle}"${svgData.substring(preFillIndex)}`;
}
async function $6bd96f509c674554$export$fe58198efe02b173(image) {
    return new Promise((resolve)=>{
        image.loading = true;
        const img = new Image();
        image.element = img;
        img.addEventListener("load", ()=>{
            image.loading = false;
            resolve();
        });
        img.addEventListener("error", ()=>{
            image.element = undefined;
            image.error = true;
            image.loading = false;
            (0, $ab7d474d755ab51b$export$2b1d391cd05230fd)().error(`${(0, $9f7790cd505e6a79$export$adea4917e02d93dc)} loading image: ${image.source}`);
            resolve();
        });
        img.src = image.source;
    });
}
async function $6bd96f509c674554$export$745ee5fd99d9f9d8(image) {
    if (image.type !== "gif") {
        await $6bd96f509c674554$export$fe58198efe02b173(image);
        return;
    }
    image.loading = true;
    try {
        image.gifData = await (0, $f9e07d4431d0e126$export$242c765bf39e1a4e)(image.source);
        image.gifLoopCount = (0, $f9e07d4431d0e126$export$67ac3d66f3062195)(image.gifData) ?? 0;
        if (image.gifLoopCount === 0) image.gifLoopCount = Infinity;
    } catch  {
        image.error = true;
    }
    image.loading = false;
}
async function $6bd96f509c674554$export$4b83b5a5338ae9dc(image) {
    if (image.type !== "svg") {
        await $6bd96f509c674554$export$fe58198efe02b173(image);
        return;
    }
    image.loading = true;
    const response = await fetch(image.source);
    if (!response.ok) {
        (0, $ab7d474d755ab51b$export$2b1d391cd05230fd)().error(`${(0, $9f7790cd505e6a79$export$adea4917e02d93dc)} Image not found`);
        image.error = true;
    } else image.svgData = await response.text();
    image.loading = false;
}
function $6bd96f509c674554$export$49424b6b83198c61(image, imageData, color, particle) {
    const svgColoredData = $6bd96f509c674554$var$replaceColorSvg(image, color, particle.opacity?.value ?? 1), imageRes = {
        color: color,
        gif: imageData.gif,
        data: {
            ...image,
            svgData: svgColoredData
        },
        loaded: false,
        ratio: imageData.width / imageData.height,
        replaceColor: imageData.replaceColor ?? imageData.replace_color,
        source: imageData.src
    };
    return new Promise((resolve)=>{
        const svg = new Blob([
            svgColoredData
        ], {
            type: "image/svg+xml"
        }), domUrl = URL || window.URL || window.webkitURL || window, url = domUrl.createObjectURL(svg), img = new Image();
        img.addEventListener("load", ()=>{
            imageRes.loaded = true;
            imageRes.element = img;
            resolve(imageRes);
            domUrl.revokeObjectURL(url);
        });
        img.addEventListener("error", async ()=>{
            domUrl.revokeObjectURL(url);
            const img2 = {
                ...image,
                error: false,
                loading: true
            };
            await $6bd96f509c674554$export$fe58198efe02b173(img2);
            imageRes.loaded = true;
            imageRes.element = img2.element;
            resolve(imageRes);
        });
        img.src = url;
    });
}




class $430d540f71eac2b5$export$b1e5f9a9161ef3b1 {
    constructor(engine){
        this.loadImageShape = async (imageShape)=>{
            if (!this._engine.loadImage) throw new Error(`${(0, $9f7790cd505e6a79$export$adea4917e02d93dc)} image shape not initialized`);
            await this._engine.loadImage({
                gif: imageShape.gif,
                name: imageShape.name,
                replaceColor: imageShape.replaceColor ?? imageShape.replace_color ?? false,
                src: imageShape.src
            });
        };
        this._engine = engine;
    }
    addImage(image) {
        if (!this._engine.images) this._engine.images = [];
        this._engine.images.push(image);
    }
    draw(context, particle, radius, opacity, delta) {
        const image = particle.image, element = image?.element;
        if (!image) return;
        context.globalAlpha = opacity;
        if (image.gif && image.gifData) {
            const offscreenCanvas = new OffscreenCanvas(image.gifData.width, image.gifData.height), offscreenContext = offscreenCanvas.getContext("2d");
            if (!offscreenContext) throw new Error("could not create offscreen canvas context");
            offscreenContext.imageSmoothingQuality = "low";
            offscreenContext.imageSmoothingEnabled = false;
            offscreenContext.clearRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);
            if (particle.gifLoopCount === undefined) particle.gifLoopCount = image.gifLoopCount ?? 0;
            let frameIndex = particle.gifFrame ?? 0;
            const pos = {
                x: -image.gifData.width * 0.5,
                y: -image.gifData.height * 0.5
            }, frame = image.gifData.frames[frameIndex];
            if (particle.gifTime === undefined) particle.gifTime = 0;
            if (!frame.bitmap) return;
            context.scale(radius / image.gifData.width, radius / image.gifData.height);
            switch(frame.disposalMethod){
                case 4:
                case 5:
                case 6:
                case 7:
                case 0:
                    offscreenContext.drawImage(frame.bitmap, frame.left, frame.top);
                    context.drawImage(offscreenCanvas, pos.x, pos.y);
                    offscreenContext.clearRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);
                    break;
                case 1:
                    offscreenContext.drawImage(frame.bitmap, frame.left, frame.top);
                    context.drawImage(offscreenCanvas, pos.x, pos.y);
                    break;
                case 2:
                    offscreenContext.drawImage(frame.bitmap, frame.left, frame.top);
                    context.drawImage(offscreenCanvas, pos.x, pos.y);
                    offscreenContext.clearRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);
                    if (image.gifData.globalColorTable.length === 0) offscreenContext.putImageData(image.gifData.frames[0].image, pos.x + frame.left, pos.y + frame.top);
                    else offscreenContext.putImageData(image.gifData.backgroundImage, pos.x, pos.y);
                    break;
                case 3:
                    {
                        const previousImageData = offscreenContext.getImageData(0, 0, offscreenCanvas.width, offscreenCanvas.height);
                        offscreenContext.drawImage(frame.bitmap, frame.left, frame.top);
                        context.drawImage(offscreenCanvas, pos.x, pos.y);
                        offscreenContext.clearRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);
                        offscreenContext.putImageData(previousImageData, 0, 0);
                    }
                    break;
            }
            particle.gifTime += delta.value;
            if (particle.gifTime > frame.delayTime) {
                particle.gifTime -= frame.delayTime;
                if (++frameIndex >= image.gifData.frames.length) {
                    if (--particle.gifLoopCount <= 0) return;
                    frameIndex = 0;
                    offscreenContext.clearRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);
                }
                particle.gifFrame = frameIndex;
            }
            context.scale(image.gifData.width / radius, image.gifData.height / radius);
        } else if (element) {
            const ratio = image.ratio, pos = {
                x: -radius,
                y: -radius
            };
            context.drawImage(element, pos.x, pos.y, radius * 2, radius * 2 / ratio);
        }
        context.globalAlpha = 1;
    }
    getSidesCount() {
        return 12;
    }
    async init(container) {
        const options = container.actualOptions;
        if (!options.preload || !this._engine.loadImage) return;
        for (const imageData of options.preload)await this._engine.loadImage(imageData);
    }
    loadShape(particle) {
        if (particle.shape !== "image" && particle.shape !== "images") return;
        if (!this._engine.images) this._engine.images = [];
        const imageData = particle.shapeData, image = this._engine.images.find((t)=>t.name === imageData.name || t.source === imageData.src);
        if (!image) this.loadImageShape(imageData).then(()=>{
            this.loadShape(particle);
        });
    }
    particleInit(container, particle) {
        if (particle.shape !== "image" && particle.shape !== "images") return;
        if (!this._engine.images) this._engine.images = [];
        const images = this._engine.images, imageData = particle.shapeData, color = particle.getFillColor(), image = images.find((t)=>t.name === imageData.name || t.source === imageData.src);
        if (!image) return;
        const replaceColor = imageData.replaceColor ?? imageData.replace_color ?? image.replaceColor;
        if (image.loading) {
            setTimeout(()=>{
                this.particleInit(container, particle);
            });
            return;
        }
        (async ()=>{
            let imageRes;
            if (image.svgData && color) imageRes = await (0, $6bd96f509c674554$export$49424b6b83198c61)(image, imageData, color, particle);
            else imageRes = {
                color: color,
                data: image,
                element: image.element,
                gif: image.gif,
                gifData: image.gifData,
                gifLoopCount: image.gifLoopCount,
                loaded: true,
                ratio: imageData.width && imageData.height ? imageData.width / imageData.height : image.ratio ?? 1,
                replaceColor: replaceColor,
                source: imageData.src
            };
            if (!imageRes.ratio) imageRes.ratio = 1;
            const fill = imageData.fill ?? particle.fill, close = imageData.close ?? particle.close, imageShape = {
                image: imageRes,
                fill: fill,
                close: close
            };
            particle.image = imageShape.image;
            particle.fill = imageShape.fill;
            particle.close = imageShape.close;
        })();
    }
}


class $5a422b83a68fa8ab$export$62ec7f5fcda483d7 {
    constructor(){
        this.src = "";
        this.gif = false;
    }
    load(data) {
        if (!data) return;
        if (data.gif !== undefined) this.gif = data.gif;
        if (data.height !== undefined) this.height = data.height;
        if (data.name !== undefined) this.name = data.name;
        if (data.replaceColor !== undefined) this.replaceColor = data.replaceColor;
        if (data.src !== undefined) this.src = data.src;
        if (data.width !== undefined) this.width = data.width;
    }
}


class $0c2b1964ea8ae752$export$9ecd7cd0f869b77e {
    constructor(engine){
        this.id = "imagePreloader";
        this._engine = engine;
    }
    getPlugin() {
        return {};
    }
    loadOptions(options, source) {
        if (!source || !source.preload) return;
        if (!options.preload) options.preload = [];
        const preloadOptions = options.preload;
        for (const item of source.preload){
            const existing = preloadOptions.find((t)=>t.name === item.name || t.src === item.src);
            if (existing) existing.load(item);
            else {
                const preload = new (0, $5a422b83a68fa8ab$export$62ec7f5fcda483d7)();
                preload.load(item);
                preloadOptions.push(preload);
            }
        }
    }
    needsPlugin() {
        return true;
    }
}



function $32d973eb441648b7$var$addLoadImageToEngine(engine) {
    if (engine.loadImage) return;
    engine.loadImage = async (data)=>{
        if (!data.name && !data.src) throw new Error(`${(0, $9f7790cd505e6a79$export$adea4917e02d93dc)} no image source provided`);
        if (!engine.images) engine.images = [];
        if (engine.images.find((t)=>t.name === data.name || t.source === data.src)) return;
        try {
            const image = {
                gif: data.gif ?? false,
                name: data.name ?? data.src,
                source: data.src,
                type: data.src.substring(data.src.length - 3),
                error: false,
                loading: true,
                replaceColor: data.replaceColor,
                ratio: data.width && data.height ? data.width / data.height : undefined
            };
            engine.images.push(image);
            const imageFunc = data.gif ? (0, $6bd96f509c674554$export$745ee5fd99d9f9d8) : data.replaceColor ? (0, $6bd96f509c674554$export$4b83b5a5338ae9dc) : (0, $6bd96f509c674554$export$fe58198efe02b173);
            await imageFunc(image);
        } catch  {
            throw new Error(`${(0, $9f7790cd505e6a79$export$adea4917e02d93dc)} ${data.name ?? data.src} not found`);
        }
    };
}
async function $32d973eb441648b7$export$4be35e7676465a2d(engine, refresh = true) {
    $32d973eb441648b7$var$addLoadImageToEngine(engine);
    const preloader = new (0, $0c2b1964ea8ae752$export$9ecd7cd0f869b77e)(engine);
    await engine.addPlugin(preloader, refresh);
    await engine.addShape([
        "image",
        "images"
    ], new (0, $430d540f71eac2b5$export$b1e5f9a9161ef3b1)(engine), refresh);
}




class $5b16a71420a6e9fd$export$cfeee7551c31115e extends (0, $7502aa7b9e2abdb4$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.sync = false;
    }
    load(data) {
        if (!data) return;
        super.load(data);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}



class $22f38cc61914d1a9$export$c09f84979931ae91 extends (0, $7502aa7b9e2abdb4$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.random.minimumValue = 0.0001;
        this.sync = false;
    }
    load(data) {
        if (!data) return;
        super.load(data);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}


class $c0a9cf68522f46cb$export$305b21c541a8d65b {
    constructor(){
        this.count = 0;
        this.delay = new (0, $5b16a71420a6e9fd$export$cfeee7551c31115e)();
        this.duration = new (0, $22f38cc61914d1a9$export$c09f84979931ae91)();
    }
    load(data) {
        if (!data) return;
        if (data.count !== undefined) this.count = data.count;
        this.delay.load(data.delay);
        this.duration.load(data.duration);
    }
}


class $50cc3171f21dc073$export$ba0edc0e3650d019 {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const container = this.container, particlesOptions = particle.options, lifeOptions = particlesOptions.life;
        if (!lifeOptions) return;
        particle.life = {
            delay: container.retina.reduceFactor ? (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(lifeOptions.delay.value) * (lifeOptions.delay.sync ? 1 : (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)()) / container.retina.reduceFactor * 1000 : 0,
            delayTime: 0,
            duration: container.retina.reduceFactor ? (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(lifeOptions.duration.value) * (lifeOptions.duration.sync ? 1 : (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)()) / container.retina.reduceFactor * 1000 : 0,
            time: 0,
            count: lifeOptions.count
        };
        if (particle.life.duration <= 0) particle.life.duration = -1;
        if (particle.life.count <= 0) particle.life.count = -1;
        if (particle.life) particle.spawning = particle.life.delay > 0;
    }
    isEnabled(particle) {
        return !particle.destroyed;
    }
    loadOptions(options, ...sources) {
        if (!options.life) options.life = new (0, $c0a9cf68522f46cb$export$305b21c541a8d65b)();
        for (const source of sources)options.life.load(source?.life);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle) || !particle.life) return;
        const life = particle.life;
        let justSpawned = false;
        if (particle.spawning) {
            life.delayTime += delta.value;
            if (life.delayTime >= particle.life.delay) {
                justSpawned = true;
                particle.spawning = false;
                life.delayTime = 0;
                life.time = 0;
            } else return;
        }
        if (life.duration === -1) return;
        if (particle.spawning) return;
        if (justSpawned) life.time = 0;
        else life.time += delta.value;
        if (life.time < life.duration) return;
        life.time = 0;
        if (particle.life.count > 0) particle.life.count--;
        if (particle.life.count === 0) {
            particle.destroy();
            return;
        }
        const canvasSize = this.container.canvas.size, widthRange = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(0, canvasSize.width), heightRange = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(0, canvasSize.width);
        particle.position.x = (0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)(widthRange);
        particle.position.y = (0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)(heightRange);
        particle.spawning = true;
        life.delayTime = 0;
        life.time = 0;
        particle.reset();
        const lifeOptions = particle.options.life;
        if (lifeOptions) {
            life.delay = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(lifeOptions.delay.value) * 1000;
            life.duration = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(lifeOptions.duration.value) * 1000;
        }
    }
}


async function $0cae0ff7c9060df6$export$11010788d59cefed(engine, refresh = true) {
    await engine.addParticleUpdater("life", (container)=>new (0, $50cc3171f21dc073$export$ba0edc0e3650d019)(container), refresh);
}


class $c219a6e411c0dd82$export$360e6f46aa8bdfbf {
    draw(context, particle, radius) {
        const shapeData = particle.shapeData;
        context.moveTo(-radius / 2, 0);
        context.lineTo(radius / 2, 0);
        context.lineCap = shapeData?.cap ?? "butt";
    }
    getSidesCount() {
        return 1;
    }
}


async function $5fc8bccf5c864b1a$export$3e146d8abf762757(engine, refresh = true) {
    await engine.addShape("line", new (0, $c219a6e411c0dd82$export$360e6f46aa8bdfbf)(), refresh);
}



class $c00d3fb5948e4ec0$export$ca4210876740c02b {
    init() {}
    isEnabled(particle) {
        return !(0, $ab7d474d755ab51b$export$460b6777813d3d86)() && !particle.destroyed && particle.container.actualOptions.interactivity.events.onHover.parallax.enable;
    }
    move(particle) {
        const container = particle.container, options = container.actualOptions, parallaxOptions = options.interactivity.events.onHover.parallax;
        if ((0, $ab7d474d755ab51b$export$460b6777813d3d86)() || !parallaxOptions.enable) return;
        const parallaxForce = parallaxOptions.force, mousePos = container.interactivity.mouse.position;
        if (!mousePos) return;
        const canvasSize = container.canvas.size, canvasCenter = {
            x: canvasSize.width / 2,
            y: canvasSize.height / 2
        }, parallaxSmooth = parallaxOptions.smooth, factor = particle.getRadius() / parallaxForce, centerDistance = {
            x: (mousePos.x - canvasCenter.x) * factor,
            y: (mousePos.y - canvasCenter.y) * factor
        }, { offset: offset } = particle;
        offset.x += (centerDistance.x - offset.x) / parallaxSmooth;
        offset.y += (centerDistance.y - offset.y) / parallaxSmooth;
    }
}


async function $e8ba413cb3be9d07$export$d0a2f1e972d040a5(engine, refresh = true) {
    await engine.addMover("parallax", ()=>new (0, $c00d3fb5948e4ec0$export$ca4210876740c02b)(), refresh);
}



class $f013c2a3a70eecc3$export$27a51cca6e7ea831 extends (0, $1ee59cb044552abc$export$becdaab2d9289dc4) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {}
    async interact(p1) {
        const container = this.container, distance = p1.retina.attractDistance ?? container.retina.attractDistance, pos1 = p1.getPosition(), query = container.particles.quadTree.queryCircle(pos1, distance);
        for (const p2 of query){
            if (p1 === p2 || !p2.options.move.attract.enable || p2.destroyed || p2.spawning) continue;
            const pos2 = p2.getPosition(), { dx: dx, dy: dy } = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(pos1, pos2), rotate = p1.options.move.attract.rotate, ax = dx / (rotate.x * 1000), ay = dy / (rotate.y * 1000), p1Factor = p2.size.value / p1.size.value, p2Factor = 1 / p1Factor;
            p1.velocity.x -= ax * p1Factor;
            p1.velocity.y -= ay * p1Factor;
            p2.velocity.x += ax * p2Factor;
            p2.velocity.y += ay * p2Factor;
        }
    }
    isEnabled(particle) {
        return particle.options.move.attract.enable;
    }
    reset() {}
}


async function $1652aa6097be1290$export$c74248ecb2172f71(engine, refresh = true) {
    await engine.addInteractor("particlesAttract", (container)=>new (0, $f013c2a3a70eecc3$export$27a51cca6e7ea831)(container), refresh);
}




function $4ea07da6ee9d73cb$var$updateAbsorb(p1, r1, p2, r2, delta, pixelRatio) {
    const factor = (0, $a17cb6ec9e2ec6c9$export$7d15b64cf5a3a4c4)(p1.options.collisions.absorb.speed * delta.factor / 10, 0, r2);
    p1.size.value += factor / 2;
    p2.size.value -= factor;
    if (r2 <= pixelRatio) {
        p2.size.value = 0;
        p2.destroy();
    }
}
function $4ea07da6ee9d73cb$export$be8f954d9467d61e(p1, p2, delta, pixelRatio) {
    const r1 = p1.getRadius(), r2 = p2.getRadius();
    if (r1 === undefined && r2 !== undefined) p1.destroy();
    else if (r1 !== undefined && r2 === undefined) p2.destroy();
    else if (r1 !== undefined && r2 !== undefined) {
        if (r1 >= r2) $4ea07da6ee9d73cb$var$updateAbsorb(p1, r1, p2, r2, delta, pixelRatio);
        else $4ea07da6ee9d73cb$var$updateAbsorb(p2, r2, p1, r1, delta, pixelRatio);
    }
}



const $a9ce1a055fb33f11$var$fixBounceSpeed = (p)=>{
    if (p.collisionMaxSpeed === undefined) p.collisionMaxSpeed = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(p.options.collisions.maxSpeed);
    if (p.velocity.length > p.collisionMaxSpeed) p.velocity.length = p.collisionMaxSpeed;
};
function $a9ce1a055fb33f11$export$e3ce947fb98643bf(p1, p2) {
    (0, $ab7d474d755ab51b$export$c6e9f28fb57ea828)((0, $ab7d474d755ab51b$export$11ae16f2acc5c3ba)(p1), (0, $ab7d474d755ab51b$export$11ae16f2acc5c3ba)(p2));
    $a9ce1a055fb33f11$var$fixBounceSpeed(p1);
    $a9ce1a055fb33f11$var$fixBounceSpeed(p2);
}



function $e2df15c6ad2dc7d0$export$b1fb4cac938035f7(p1, p2) {
    if (!p1.unbreakable && !p2.unbreakable) (0, $a9ce1a055fb33f11$export$e3ce947fb98643bf)(p1, p2);
    if (p1.getRadius() === undefined && p2.getRadius() !== undefined) p1.destroy();
    else if (p1.getRadius() !== undefined && p2.getRadius() === undefined) p2.destroy();
    else if (p1.getRadius() !== undefined && p2.getRadius() !== undefined) {
        const deleteP = p1.getRadius() >= p2.getRadius() ? p2 : p1;
        deleteP.destroy();
    }
}


function $318ce5376b92e9ab$export$3ea41c4ff8214d51(p1, p2, delta, pixelRatio) {
    switch(p1.options.collisions.mode){
        case "absorb":
            (0, $4ea07da6ee9d73cb$export$be8f954d9467d61e)(p1, p2, delta, pixelRatio);
            break;
        case "bounce":
            (0, $a9ce1a055fb33f11$export$e3ce947fb98643bf)(p1, p2);
            break;
        case "destroy":
            (0, $e2df15c6ad2dc7d0$export$b1fb4cac938035f7)(p1, p2);
            break;
    }
}


class $a1b1d548be91a917$export$b7c6eef0ebb06133 extends (0, $1ee59cb044552abc$export$becdaab2d9289dc4) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {}
    async interact(p1, delta) {
        if (p1.destroyed || p1.spawning) return;
        const container = this.container, pos1 = p1.getPosition(), radius1 = p1.getRadius(), query = container.particles.quadTree.queryCircle(pos1, radius1 * 2);
        for (const p2 of query){
            if (p1 === p2 || !p2.options.collisions.enable || p1.options.collisions.mode !== p2.options.collisions.mode || p2.destroyed || p2.spawning) continue;
            const pos2 = p2.getPosition(), radius2 = p2.getRadius();
            if (Math.abs(Math.round(pos1.z) - Math.round(pos2.z)) > radius1 + radius2) continue;
            const dist = (0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(pos1, pos2), distP = radius1 + radius2;
            if (dist > distP) continue;
            (0, $318ce5376b92e9ab$export$3ea41c4ff8214d51)(p1, p2, delta, container.retina.pixelRatio);
        }
    }
    isEnabled(particle) {
        return particle.options.collisions.enable;
    }
    reset() {}
}


async function $db78217b6bf99022$export$2ac615e1c8d77bf3(engine, refresh = true) {
    await engine.addInteractor("particlesCollisions", (container)=>new (0, $a1b1d548be91a917$export$b7c6eef0ebb06133)(container), refresh);
}




class $949e6c73b24a44fe$export$63eeb78c14ab922 extends (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa) {
    constructor(x, y, radius, canvasSize){
        super(x, y, radius);
        this.canvasSize = canvasSize;
        this.canvasSize = {
            ...canvasSize
        };
    }
    contains(point) {
        const { width: width, height: height } = this.canvasSize;
        const { x: x, y: y } = point;
        return super.contains(point) || super.contains({
            x: x - width,
            y: y
        }) || super.contains({
            x: x - width,
            y: y - height
        }) || super.contains({
            x: x,
            y: y - height
        });
    }
    intersects(range) {
        if (super.intersects(range)) return true;
        const rect = range, circle = range, newPos = {
            x: range.position.x - this.canvasSize.width,
            y: range.position.y - this.canvasSize.height
        };
        if (circle.radius !== undefined) {
            const biggerCircle = new (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa)(newPos.x, newPos.y, circle.radius * 2);
            return super.intersects(biggerCircle);
        } else if (rect.size !== undefined) {
            const rectSW = new (0, $fbaf108f02b30a19$export$4617fb02663045ef)(newPos.x, newPos.y, rect.size.width * 2, rect.size.height * 2);
            return super.intersects(rectSW);
        }
        return false;
    }
}




class $a81ee04b4e87680e$export$a541b0189b16e12e {
    constructor(){
        this.blur = 5;
        this.color = new (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa)();
        this.color.value = "#000";
        this.enable = false;
    }
    load(data) {
        if (!data) return;
        if (data.blur !== undefined) this.blur = data.blur;
        this.color = (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.enable !== undefined) this.enable = data.enable;
    }
}



class $6ee4c8859541df5b$export$fcc54a02c265e2fe {
    constructor(){
        this.enable = false;
        this.frequency = 1;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.frequency !== undefined) this.frequency = data.frequency;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}


class $95eccffef5fa42bc$export$b2e089eb3692b073 {
    constructor(){
        this.blink = false;
        this.color = new (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa)();
        this.color.value = "#fff";
        this.consent = false;
        this.distance = 100;
        this.enable = false;
        this.frequency = 1;
        this.opacity = 1;
        this.shadow = new (0, $a81ee04b4e87680e$export$a541b0189b16e12e)();
        this.triangles = new (0, $6ee4c8859541df5b$export$fcc54a02c265e2fe)();
        this.width = 1;
        this.warp = false;
    }
    load(data) {
        if (!data) return;
        if (data.id !== undefined) this.id = data.id;
        if (data.blink !== undefined) this.blink = data.blink;
        this.color = (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.consent !== undefined) this.consent = data.consent;
        if (data.distance !== undefined) this.distance = data.distance;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.frequency !== undefined) this.frequency = data.frequency;
        if (data.opacity !== undefined) this.opacity = data.opacity;
        this.shadow.load(data.shadow);
        this.triangles.load(data.triangles);
        if (data.width !== undefined) this.width = data.width;
        if (data.warp !== undefined) this.warp = data.warp;
    }
}


function $0377728898b97760$var$getLinkDistance(pos1, pos2, optDistance, canvasSize, warp) {
    const { dx: dx, dy: dy, distance: distance } = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(pos1, pos2);
    if (!warp || distance <= optDistance) return distance;
    const absDiffs = {
        x: Math.abs(dx),
        y: Math.abs(dy)
    }, warpDistances = {
        x: Math.min(absDiffs.x, canvasSize.width - absDiffs.x),
        y: Math.min(absDiffs.y, canvasSize.height - absDiffs.y)
    };
    return Math.sqrt(warpDistances.x ** 2 + warpDistances.y ** 2);
}
class $0377728898b97760$export$5bd94e9ac300debe extends (0, $1ee59cb044552abc$export$becdaab2d9289dc4) {
    constructor(container){
        super(container);
        this._setColor = (p1)=>{
            if (!p1.options.links) return;
            const container = this.linkContainer, linksOptions = p1.options.links;
            let linkColor = linksOptions.id === undefined ? container.particles.linksColor : container.particles.linksColors.get(linksOptions.id);
            if (linkColor) return;
            const optColor = linksOptions.color;
            linkColor = (0, $3b20cd3c058d307c$export$cf0e5a4ae26bdcdc)(optColor, linksOptions.blink, linksOptions.consent);
            if (linksOptions.id === undefined) container.particles.linksColor = linkColor;
            else container.particles.linksColors.set(linksOptions.id, linkColor);
        };
        this.linkContainer = container;
    }
    clear() {}
    init() {
        this.linkContainer.particles.linksColor = undefined;
        this.linkContainer.particles.linksColors = new Map();
    }
    async interact(p1) {
        if (!p1.options.links) return;
        p1.links = [];
        const pos1 = p1.getPosition(), container = this.container, canvasSize = container.canvas.size;
        if (pos1.x < 0 || pos1.y < 0 || pos1.x > canvasSize.width || pos1.y > canvasSize.height) return;
        const linkOpt1 = p1.options.links, optOpacity = linkOpt1.opacity, optDistance = p1.retina.linksDistance ?? 0, warp = linkOpt1.warp, range = warp ? new (0, $949e6c73b24a44fe$export$63eeb78c14ab922)(pos1.x, pos1.y, optDistance, canvasSize) : new (0, $a41a3c6540989ea7$export$c89a927ffc67e6fa)(pos1.x, pos1.y, optDistance), query = container.particles.quadTree.query(range);
        for (const p2 of query){
            const linkOpt2 = p2.options.links;
            if (p1 === p2 || !linkOpt2?.enable || linkOpt1.id !== linkOpt2.id || p2.spawning || p2.destroyed || !p2.links || p1.links.some((t)=>t.destination === p2) || p2.links.some((t)=>t.destination === p1)) continue;
            const pos2 = p2.getPosition();
            if (pos2.x < 0 || pos2.y < 0 || pos2.x > canvasSize.width || pos2.y > canvasSize.height) continue;
            const distance = $0377728898b97760$var$getLinkDistance(pos1, pos2, optDistance, canvasSize, warp && linkOpt2.warp);
            if (distance > optDistance) continue;
            const opacityLine = (1 - distance / optDistance) * optOpacity;
            this._setColor(p1);
            p1.links.push({
                destination: p2,
                opacity: opacityLine
            });
        }
    }
    isEnabled(particle) {
        return !!particle.options.links?.enable;
    }
    loadParticlesOptions(options, ...sources) {
        if (!options.links) options.links = new (0, $95eccffef5fa42bc$export$b2e089eb3692b073)();
        for (const source of sources)options.links.load(source?.links ?? source?.lineLinked ?? source?.line_linked);
    }
    reset() {}
}


async function $d87d8231905a197b$export$ad1f96e9bde185a9(engine, refresh = true) {
    await engine.addInteractor("particlesLinks", (container)=>new (0, $0377728898b97760$export$5bd94e9ac300debe)(container), refresh);
}




function $67dd92a105fde902$export$58e0e9036805c1fd(params) {
    let drawn = false;
    const { begin: begin, end: end, maxDistance: maxDistance, context: context, canvasSize: canvasSize, width: width, backgroundMask: backgroundMask, colorLine: colorLine, opacity: opacity, links: links } = params;
    if ((0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(begin, end) <= maxDistance) {
        (0, $b69b7cfe4b0de35f$export$819db45aec5fcbe5)(context, begin, end);
        drawn = true;
    } else if (links.warp) {
        let pi1;
        let pi2;
        const endNE = {
            x: end.x - canvasSize.width,
            y: end.y
        };
        const d1 = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(begin, endNE);
        if (d1.distance <= maxDistance) {
            const yi = begin.y - d1.dy / d1.dx * begin.x;
            pi1 = {
                x: 0,
                y: yi
            };
            pi2 = {
                x: canvasSize.width,
                y: yi
            };
        } else {
            const endSW = {
                x: end.x,
                y: end.y - canvasSize.height
            };
            const d2 = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(begin, endSW);
            if (d2.distance <= maxDistance) {
                const yi = begin.y - d2.dy / d2.dx * begin.x;
                const xi = -yi / (d2.dy / d2.dx);
                pi1 = {
                    x: xi,
                    y: 0
                };
                pi2 = {
                    x: xi,
                    y: canvasSize.height
                };
            } else {
                const endSE = {
                    x: end.x - canvasSize.width,
                    y: end.y - canvasSize.height
                };
                const d3 = (0, $a17cb6ec9e2ec6c9$export$c76b58cfe053f228)(begin, endSE);
                if (d3.distance <= maxDistance) {
                    const yi = begin.y - d3.dy / d3.dx * begin.x;
                    const xi = -yi / (d3.dy / d3.dx);
                    pi1 = {
                        x: xi,
                        y: yi
                    };
                    pi2 = {
                        x: pi1.x + canvasSize.width,
                        y: pi1.y + canvasSize.height
                    };
                }
            }
        }
        if (pi1 && pi2) {
            (0, $b69b7cfe4b0de35f$export$819db45aec5fcbe5)(context, begin, pi1);
            (0, $b69b7cfe4b0de35f$export$819db45aec5fcbe5)(context, end, pi2);
            drawn = true;
        }
    }
    if (!drawn) return;
    context.lineWidth = width;
    if (backgroundMask.enable) context.globalCompositeOperation = backgroundMask.composite;
    context.strokeStyle = (0, $3b20cd3c058d307c$export$2476af37e47fcae2)(colorLine, opacity);
    const { shadow: shadow } = links;
    if (shadow.enable) {
        const shadowColor = (0, $3b20cd3c058d307c$export$fbf0bf3cc1fc0cc4)(shadow.color);
        if (shadowColor) {
            context.shadowBlur = shadow.blur;
            context.shadowColor = (0, $3b20cd3c058d307c$export$2476af37e47fcae2)(shadowColor);
        }
    }
    context.stroke();
}
function $67dd92a105fde902$export$cab2f25e574d2614(params) {
    const { context: context, pos1: pos1, pos2: pos2, pos3: pos3, backgroundMask: backgroundMask, colorTriangle: colorTriangle, opacityTriangle: opacityTriangle } = params;
    (0, $b69b7cfe4b0de35f$export$e6b70c7883316010)(context, pos1, pos2, pos3);
    if (backgroundMask.enable) context.globalCompositeOperation = backgroundMask.composite;
    context.fillStyle = (0, $3b20cd3c058d307c$export$2476af37e47fcae2)(colorTriangle, opacityTriangle);
    context.fill();
}
function $67dd92a105fde902$export$4509bfc4137b425(ids) {
    ids.sort((a, b)=>a - b);
    return ids.join("_");
}
function $67dd92a105fde902$export$1502611422f00997(particles, dictionary) {
    const key = $67dd92a105fde902$export$4509bfc4137b425(particles.map((t)=>t.id));
    let res = dictionary.get(key);
    if (res === undefined) {
        res = (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)();
        dictionary.set(key, res);
    }
    return res;
}


class $67fbbc5e38e8e50f$export$2ef513794a0916ce {
    constructor(container){
        this.container = container;
        this._drawLinkLine = (p1, link)=>{
            const p1LinksOptions = p1.options.links;
            if (!p1LinksOptions?.enable) return;
            const container = this.container, options = container.actualOptions, p2 = link.destination, pos1 = p1.getPosition(), pos2 = p2.getPosition();
            let opacity = link.opacity;
            container.canvas.draw((ctx)=>{
                let colorLine;
                const twinkle = p1.options.twinkle?.lines;
                if (twinkle?.enable) {
                    const twinkleFreq = twinkle.frequency, twinkleRgb = (0, $3b20cd3c058d307c$export$fbf0bf3cc1fc0cc4)(twinkle.color), twinkling = (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() < twinkleFreq;
                    if (twinkling && twinkleRgb) {
                        colorLine = twinkleRgb;
                        opacity = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(twinkle.opacity);
                    }
                }
                if (!colorLine) {
                    const linkColor = p1LinksOptions.id !== undefined ? container.particles.linksColors.get(p1LinksOptions.id) : container.particles.linksColor;
                    colorLine = (0, $3b20cd3c058d307c$export$b676eb46c472d7df)(p1, p2, linkColor);
                }
                if (!colorLine) return;
                const width = p1.retina.linksWidth ?? 0, maxDistance = p1.retina.linksDistance ?? 0, { backgroundMask: backgroundMask } = options;
                (0, $67dd92a105fde902$export$58e0e9036805c1fd)({
                    context: ctx,
                    width: width,
                    begin: pos1,
                    end: pos2,
                    maxDistance: maxDistance,
                    canvasSize: container.canvas.size,
                    links: p1LinksOptions,
                    backgroundMask: backgroundMask,
                    colorLine: colorLine,
                    opacity: opacity
                });
            });
        };
        this._drawLinkTriangle = (p1, link1, link2)=>{
            const linksOptions = p1.options.links;
            if (!linksOptions?.enable) return;
            const triangleOptions = linksOptions.triangles;
            if (!triangleOptions.enable) return;
            const container = this.container, options = container.actualOptions, p2 = link1.destination, p3 = link2.destination, opacityTriangle = triangleOptions.opacity ?? (link1.opacity + link2.opacity) / 2;
            if (opacityTriangle <= 0) return;
            container.canvas.draw((ctx)=>{
                const pos1 = p1.getPosition(), pos2 = p2.getPosition(), pos3 = p3.getPosition(), linksDistance = p1.retina.linksDistance ?? 0;
                if ((0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(pos1, pos2) > linksDistance || (0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(pos3, pos2) > linksDistance || (0, $a17cb6ec9e2ec6c9$export$79376507b09a66f)(pos3, pos1) > linksDistance) return;
                let colorTriangle = (0, $3b20cd3c058d307c$export$fbf0bf3cc1fc0cc4)(triangleOptions.color);
                if (!colorTriangle) {
                    const linkColor = linksOptions.id !== undefined ? container.particles.linksColors.get(linksOptions.id) : container.particles.linksColor;
                    colorTriangle = (0, $3b20cd3c058d307c$export$b676eb46c472d7df)(p1, p2, linkColor);
                }
                if (!colorTriangle) return;
                (0, $67dd92a105fde902$export$cab2f25e574d2614)({
                    context: ctx,
                    pos1: pos1,
                    pos2: pos2,
                    pos3: pos3,
                    backgroundMask: options.backgroundMask,
                    colorTriangle: colorTriangle,
                    opacityTriangle: opacityTriangle
                });
            });
        };
        this._drawTriangles = (options, p1, link, p1Links)=>{
            const p2 = link.destination;
            if (!(options.links?.triangles.enable && p2.options.links?.triangles.enable)) return;
            const vertices = p2.links?.filter((t)=>{
                const linkFreq = this._getLinkFrequency(p2, t.destination);
                return p2.options.links && linkFreq <= p2.options.links.frequency && p1Links.findIndex((l)=>l.destination === t.destination) >= 0;
            });
            if (!vertices?.length) return;
            for (const vertex of vertices){
                const p3 = vertex.destination, triangleFreq = this._getTriangleFrequency(p1, p2, p3);
                if (triangleFreq > options.links.triangles.frequency) continue;
                this._drawLinkTriangle(p1, link, vertex);
            }
        };
        this._getLinkFrequency = (p1, p2)=>{
            return (0, $67dd92a105fde902$export$1502611422f00997)([
                p1,
                p2
            ], this._freqs.links);
        };
        this._getTriangleFrequency = (p1, p2, p3)=>{
            return (0, $67dd92a105fde902$export$1502611422f00997)([
                p1,
                p2,
                p3
            ], this._freqs.triangles);
        };
        this._freqs = {
            links: new Map(),
            triangles: new Map()
        };
    }
    drawParticle(context, particle) {
        const { links: links, options: options } = particle;
        if (!links || links.length <= 0) return;
        const p1Links = links.filter((l)=>options.links && this._getLinkFrequency(particle, l.destination) <= options.links.frequency);
        for (const link of p1Links){
            this._drawTriangles(options, particle, link, p1Links);
            if (link.opacity > 0 && (particle.retina.linksWidth ?? 0) > 0) this._drawLinkLine(particle, link);
        }
    }
    async init() {
        this._freqs.links = new Map();
        this._freqs.triangles = new Map();
    }
    particleCreated(particle) {
        particle.links = [];
        if (!particle.options.links) return;
        const ratio = this.container.retina.pixelRatio, { retina: retina } = particle, { distance: distance, width: width } = particle.options.links;
        retina.linksDistance = distance * ratio;
        retina.linksWidth = width * ratio;
    }
    particleDestroyed(particle) {
        particle.links = [];
    }
}


class $eba3a440d273e792$var$LinksPlugin {
    constructor(){
        this.id = "links";
    }
    getPlugin(container) {
        return new (0, $67fbbc5e38e8e50f$export$2ef513794a0916ce)(container);
    }
    loadOptions() {}
    needsPlugin() {
        return true;
    }
}
async function $eba3a440d273e792$export$7512928df34dbc5b(engine, refresh = true) {
    const plugin = new $eba3a440d273e792$var$LinksPlugin();
    await engine.addPlugin(plugin, refresh);
}








async function $8eb0a80b51cf2dad$export$abcf1b8392d2aa58(engine, refresh = true) {
    await (0, $d87d8231905a197b$export$ad1f96e9bde185a9)(engine, refresh);
    await (0, $eba3a440d273e792$export$7512928df34dbc5b)(engine, refresh);
}



class $fd4691137ee999c2$export$f8ea5ed53fb3a92e {
    draw(context, particle, radius) {
        const start = this.getCenter(particle, radius), side = this.getSidesData(particle, radius), sideCount = side.count.numerator * side.count.denominator, decimalSides = side.count.numerator / side.count.denominator, interiorAngleDegrees = 180 * (decimalSides - 2) / decimalSides, interiorAngle = Math.PI - Math.PI * interiorAngleDegrees / 180;
        if (!context) return;
        context.beginPath();
        context.translate(start.x, start.y);
        context.moveTo(0, 0);
        for(let i = 0; i < sideCount; i++){
            context.lineTo(side.length, 0);
            context.translate(side.length, 0);
            context.rotate(interiorAngle);
        }
    }
    getSidesCount(particle) {
        const polygon = particle.shapeData;
        return Math.round((0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(polygon?.sides ?? polygon?.nb_sides ?? 5));
    }
}


class $47983ef24400d93a$export$e19799e6d95a4459 extends (0, $fd4691137ee999c2$export$f8ea5ed53fb3a92e) {
    getCenter(particle, radius) {
        return {
            x: -radius / (particle.sides / 3.5),
            y: -radius / 0.76
        };
    }
    getSidesData(particle, radius) {
        const sides = particle.sides;
        return {
            count: {
                denominator: 1,
                numerator: sides
            },
            length: radius * 2.66 / (sides / 3)
        };
    }
}



class $a805085a516571c5$export$f7d2d6c2da09994c extends (0, $fd4691137ee999c2$export$f8ea5ed53fb3a92e) {
    getCenter(particle, radius) {
        return {
            x: -radius,
            y: radius / 1.66
        };
    }
    getSidesCount() {
        return 3;
    }
    getSidesData(particle, radius) {
        return {
            count: {
                denominator: 2,
                numerator: 3
            },
            length: radius * 2
        };
    }
}


async function $b23f3a7daa8dba00$export$f8596ed9bb066678(engine, refresh = true) {
    await engine.addShape("polygon", new (0, $47983ef24400d93a$export$e19799e6d95a4459)(), refresh);
}
async function $b23f3a7daa8dba00$export$23adca4e3d46291f(engine, refresh = true) {
    await engine.addShape("triangle", new (0, $a805085a516571c5$export$f7d2d6c2da09994c)(), refresh);
}
async function $b23f3a7daa8dba00$export$2a8adcfe9fcff9a7(engine, refresh = true) {
    await $b23f3a7daa8dba00$export$f8596ed9bb066678(engine, refresh);
    await $b23f3a7daa8dba00$export$23adca4e3d46291f(engine, refresh);
}





class $6b7feefe39b130d1$export$cdf8682ab8a5e20a {
    constructor(){
        this.enable = false;
        this.speed = 0;
        this.decay = 0;
        this.sync = false;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) this.speed = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.speed);
        if (data.decay !== undefined) this.decay = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.decay);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}


class $01ed8779d6e31c08$export$152db69a76b6b79e extends (0, $7502aa7b9e2abdb4$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.animation = new (0, $6b7feefe39b130d1$export$cdf8682ab8a5e20a)();
        this.direction = "clockwise";
        this.path = false;
        this.value = 0;
    }
    load(data) {
        if (!data) return;
        super.load(data);
        if (data.direction !== undefined) this.direction = data.direction;
        this.animation.load(data.animation);
        if (data.path !== undefined) this.path = data.path;
    }
}


function $1ef57a26c9d66fc3$var$updateRotate(particle, delta) {
    const rotate = particle.rotate, rotateOptions = particle.options.rotate;
    if (!rotate || !rotateOptions) return;
    const rotateAnimation = rotateOptions.animation, speed = (rotate.velocity ?? 0) * delta.factor, max = 2 * Math.PI, decay = rotate.decay ?? 1;
    if (!rotateAnimation.enable) return;
    switch(rotate.status){
        case "increasing":
            rotate.value += speed;
            if (rotate.value > max) rotate.value -= max;
            break;
        case "decreasing":
        default:
            rotate.value -= speed;
            if (rotate.value < 0) rotate.value += max;
            break;
    }
    if (rotate.velocity && decay !== 1) rotate.velocity *= decay;
}
class $1ef57a26c9d66fc3$export$3b9356b2fa15ee9f {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const rotateOptions = particle.options.rotate;
        if (!rotateOptions) return;
        particle.rotate = {
            enable: rotateOptions.animation.enable,
            value: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(rotateOptions.value) * Math.PI / 180
        };
        particle.pathRotation = rotateOptions.path;
        let rotateDirection = rotateOptions.direction;
        if (rotateDirection === "random") {
            const index = Math.floor((0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() * 2);
            rotateDirection = index > 0 ? "counter-clockwise" : "clockwise";
        }
        switch(rotateDirection){
            case "counter-clockwise":
            case "counterClockwise":
                particle.rotate.status = "decreasing";
                break;
            case "clockwise":
                particle.rotate.status = "increasing";
                break;
        }
        const rotateAnimation = rotateOptions.animation;
        if (rotateAnimation.enable) {
            particle.rotate.decay = 1 - (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(rotateAnimation.decay);
            particle.rotate.velocity = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(rotateAnimation.speed) / 360 * this.container.retina.reduceFactor;
            if (!rotateAnimation.sync) particle.rotate.velocity *= (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)();
        }
        particle.rotation = particle.rotate.value;
    }
    isEnabled(particle) {
        const rotate = particle.options.rotate;
        if (!rotate) return false;
        return !particle.destroyed && !particle.spawning && rotate.animation.enable && !rotate.path;
    }
    loadOptions(options, ...sources) {
        if (!options.rotate) options.rotate = new (0, $01ed8779d6e31c08$export$152db69a76b6b79e)();
        for (const source of sources)options.rotate.load(source?.rotate);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        $1ef57a26c9d66fc3$var$updateRotate(particle, delta);
        particle.rotation = particle.rotate?.value ?? 0;
    }
}


async function $4996d153fc2f3e48$export$4e45f5f68451ed59(engine, refresh = true) {
    await engine.addParticleUpdater("rotate", (container)=>new (0, $1ef57a26c9d66fc3$export$3b9356b2fa15ee9f)(container), refresh);
}


const $00121fe7355fbb63$var$fixFactor = Math.sqrt(2);
class $00121fe7355fbb63$export$e0bf05a057b4a28b {
    draw(context, particle, radius) {
        const fixedRadius = radius / $00121fe7355fbb63$var$fixFactor, fixedDiameter = fixedRadius * 2;
        context.rect(-fixedRadius, -fixedRadius, fixedDiameter, fixedDiameter);
    }
    getSidesCount() {
        return 4;
    }
}


async function $129177a5ec28fe97$export$43ae275f06aaeea(engine, refresh = true) {
    await engine.addShape([
        "edge",
        "square"
    ], new (0, $00121fe7355fbb63$export$e0bf05a057b4a28b)(), refresh);
}



class $fd2aca73d77bea58$export$9353a030aedd2caa {
    draw(context, particle, radius) {
        const sides = particle.sides, inset = particle.starInset ?? 2;
        context.moveTo(0, 0 - radius);
        for(let i = 0; i < sides; i++){
            context.rotate(Math.PI / sides);
            context.lineTo(0, 0 - radius * inset);
            context.rotate(Math.PI / sides);
            context.lineTo(0, 0 - radius);
        }
    }
    getSidesCount(particle) {
        const star = particle.shapeData;
        return Math.round((0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(star?.sides ?? star?.nb_sides ?? 5));
    }
    particleInit(container, particle) {
        const star = particle.shapeData, inset = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(star?.inset ?? 2);
        particle.starInset = inset;
    }
}


async function $2601a48394d0f821$export$f283471236cef89e(engine, refresh = true) {
    await engine.addShape("star", new (0, $fd2aca73d77bea58$export$9353a030aedd2caa)(), refresh);
}




function $e124c66a15d2a7dc$var$updateColorValue(delta, colorValue, valueAnimation, max, decrease) {
    if (!colorValue || !valueAnimation.enable || (colorValue.maxLoops ?? 0) > 0 && (colorValue.loops ?? 0) > (colorValue.maxLoops ?? 0)) return;
    if (!colorValue.time) colorValue.time = 0;
    if ((colorValue.delayTime ?? 0) > 0 && colorValue.time < (colorValue.delayTime ?? 0)) colorValue.time += delta.value;
    if ((colorValue.delayTime ?? 0) > 0 && colorValue.time < (colorValue.delayTime ?? 0)) return;
    const offset = (0, $a17cb6ec9e2ec6c9$export$8b958c8ecd94a804)(valueAnimation.offset), velocity = (colorValue.velocity ?? 0) * delta.factor + offset * 3.6, decay = colorValue.decay ?? 1;
    if (!decrease || colorValue.status === "increasing") {
        colorValue.value += velocity;
        if (colorValue.value > max) {
            if (!colorValue.loops) colorValue.loops = 0;
            colorValue.loops++;
            if (decrease) {
                colorValue.status = "decreasing";
                colorValue.value -= colorValue.value % max;
            }
        }
    } else {
        colorValue.value -= velocity;
        if (colorValue.value < 0) {
            if (!colorValue.loops) colorValue.loops = 0;
            colorValue.loops++;
            colorValue.status = "increasing";
            colorValue.value += colorValue.value;
        }
    }
    if (colorValue.velocity && decay !== 1) colorValue.velocity *= decay;
    if (colorValue.value > max) colorValue.value %= max;
}
function $e124c66a15d2a7dc$export$358bd9432884eda9(particle, delta) {
    if (!particle.strokeColor || !particle.strokeAnimation) return;
    const { h: h, s: s, l: l } = particle.strokeColor, { h: hAnimation, s: sAnimation, l: lAnimation } = particle.strokeAnimation;
    if (h) $e124c66a15d2a7dc$var$updateColorValue(delta, h, hAnimation, 360, false);
    if (s) $e124c66a15d2a7dc$var$updateColorValue(delta, s, sAnimation, 100, true);
    if (l) $e124c66a15d2a7dc$var$updateColorValue(delta, l, lAnimation, 100, true);
}


class $f39ff3a996dd4e9a$export$34b1490acfca3625 {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const container = this.container, options = particle.options;
        const stroke = (0, $ab7d474d755ab51b$export$3fbf39566d3ee62e)(options.stroke, particle.id, options.reduceDuplicates);
        particle.strokeWidth = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(stroke.width) * container.retina.pixelRatio;
        particle.strokeOpacity = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(stroke.opacity ?? 1);
        particle.strokeAnimation = stroke.color?.animation;
        const strokeHslColor = (0, $3b20cd3c058d307c$export$79a89086521c0f12)(stroke.color) ?? particle.getFillColor();
        if (strokeHslColor) particle.strokeColor = (0, $3b20cd3c058d307c$export$6e8a573710bea117)(strokeHslColor, particle.strokeAnimation, container.retina.reduceFactor);
    }
    isEnabled(particle) {
        const color = particle.strokeAnimation, { strokeColor: strokeColor } = particle;
        return !particle.destroyed && !particle.spawning && !!color && (strokeColor?.h.value !== undefined && strokeColor.h.enable || strokeColor?.s.value !== undefined && strokeColor.s.enable || strokeColor?.l.value !== undefined && strokeColor.l.enable);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        (0, $e124c66a15d2a7dc$export$358bd9432884eda9)(particle, delta);
    }
}


async function $ff06ac37bb08bb34$export$3265715adf72f85b(engine, refresh = true) {
    await engine.addParticleUpdater("strokeColor", (container)=>new (0, $f39ff3a996dd4e9a$export$34b1490acfca3625)(container), refresh);
}



const $9813fcb2ed3464f7$export$7479ced0de99242c = [
    "text",
    "character",
    "char"
];
class $9813fcb2ed3464f7$export$a007af5794c15990 {
    draw(context, particle, radius, opacity) {
        const character = particle.shapeData;
        if (character === undefined) return;
        const textData = character.value;
        if (textData === undefined) return;
        if (particle.text === undefined) particle.text = (0, $ab7d474d755ab51b$export$3fbf39566d3ee62e)(textData, particle.randomIndexData);
        const text = particle.text, style = character.style ?? "", weight = character.weight ?? "400", size = Math.round(radius) * 2, font = character.font ?? "Verdana", fill = particle.fill, offsetX = text.length * radius / 2;
        context.font = `${style} ${weight} ${size}px "${font}"`;
        const pos = {
            x: -offsetX,
            y: radius / 2
        };
        context.globalAlpha = opacity;
        if (fill) context.fillText(text, pos.x, pos.y);
        else context.strokeText(text, pos.x, pos.y);
        context.globalAlpha = 1;
    }
    getSidesCount() {
        return 12;
    }
    async init(container) {
        const options = container.actualOptions;
        if ($9813fcb2ed3464f7$export$7479ced0de99242c.find((t)=>(0, $ab7d474d755ab51b$export$5e9bb4359042e24b)(t, options.particles.shape.type))) {
            const shapeOptions = $9813fcb2ed3464f7$export$7479ced0de99242c.map((t)=>options.particles.shape.options[t]).find((t)=>!!t), promises = [];
            (0, $ab7d474d755ab51b$export$8e5dc47097396754)(shapeOptions, (shape)=>{
                promises.push((0, $ab7d474d755ab51b$export$672089c3debc1182)(shape.font, shape.weight));
            });
            await Promise.all(promises);
        }
    }
    particleInit(container, particle) {
        if (!particle.shape || !$9813fcb2ed3464f7$export$7479ced0de99242c.includes(particle.shape)) return;
        const character = particle.shapeData;
        if (character === undefined) return;
        const textData = character.value;
        if (textData === undefined) return;
        particle.text = (0, $ab7d474d755ab51b$export$3fbf39566d3ee62e)(textData, particle.randomIndexData);
    }
}


async function $bf748e6a56b448a0$export$da06b6ff4c270300(engine, refresh = true) {
    await engine.addShape((0, $9813fcb2ed3464f7$export$7479ced0de99242c), new (0, $9813fcb2ed3464f7$export$a007af5794c15990)(), refresh);
}


async function $455ad9bd4323ff81$export$e11831a95a1ec8d5(engine, refresh = true) {
    (0, $ffd9f3ff3605eca0$export$4948e8af77cbffab)(engine);
    await (0, $e8ba413cb3be9d07$export$d0a2f1e972d040a5)(engine, false);
    await (0, $17bcf2679deaa951$export$802792820c064418)(engine, false);
    await (0, $4d6aef1b5ecf751d$export$ec1513be4b96e6ba)(engine, false);
    await (0, $1b576938e8b0f649$export$38085c395e2c86d6)(engine, false);
    await (0, $6a87c76d53b7dca5$export$6d77a62d34a75d00)(engine, false);
    await (0, $9094ce23a4e133f4$export$919b2e865378f034)(engine, false);
    await (0, $867e55cfe3609187$export$bbbab73b3aee4f94)(engine, false);
    await (0, $3a1142db207d63a5$export$38a8d49241950f5a)(engine, false);
    await (0, $3cd65b1242c9aaca$export$7eeb8763dff0d815)(engine, false);
    await (0, $9f5eabca63a1d30e$export$5ff7a4cab01244f4)(engine, false);
    await (0, $f7fe00e9889a9e84$export$da393a0f615758e8)(engine, false);
    await (0, $1652aa6097be1290$export$c74248ecb2172f71)(engine, false);
    await (0, $db78217b6bf99022$export$2ac615e1c8d77bf3)(engine, false);
    await (0, $8eb0a80b51cf2dad$export$abcf1b8392d2aa58)(engine, false);
    await (0, $3f33526d3a73a8f4$export$869269643d4bbdcd)();
    await (0, $32d973eb441648b7$export$4be35e7676465a2d)(engine, false);
    await (0, $5fc8bccf5c864b1a$export$3e146d8abf762757)(engine, false);
    await (0, $b23f3a7daa8dba00$export$2a8adcfe9fcff9a7)(engine, false);
    await (0, $129177a5ec28fe97$export$43ae275f06aaeea)(engine, false);
    await (0, $2601a48394d0f821$export$f283471236cef89e)(engine, false);
    await (0, $bf748e6a56b448a0$export$da06b6ff4c270300)(engine, false);
    await (0, $0cae0ff7c9060df6$export$11010788d59cefed)(engine, false);
    await (0, $4996d153fc2f3e48$export$4e45f5f68451ed59)(engine, false);
    await (0, $ff06ac37bb08bb34$export$3265715adf72f85b)(engine, false);
    await (0, $cfa79809f7729e19$export$244419993531723b)(engine, refresh);
}





class $cfd8e7baa701f0f5$export$e573f4ca73db5908 {
    constructor(){
        this.enable = false;
        this.speed = 0;
        this.decay = 0;
        this.sync = false;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) this.speed = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.speed);
        if (data.decay !== undefined) this.decay = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.decay);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}


class $257d6aa4a890e8f4$export$7f9fd97e8e8ffd03 extends (0, $7502aa7b9e2abdb4$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.animation = new (0, $cfd8e7baa701f0f5$export$e573f4ca73db5908)();
        this.direction = "clockwise";
        this.enable = false;
        this.value = 0;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        this.animation.load(data.animation);
        if (data.direction !== undefined) this.direction = data.direction;
        if (data.enable !== undefined) this.enable = data.enable;
    }
}


function $65cbede8dac0bfa8$export$a54513c02db8db(particle, delta) {
    if (!particle.tilt || !particle.options.tilt) return;
    const tilt = particle.options.tilt, tiltAnimation = tilt.animation, speed = (particle.tilt.velocity ?? 0) * delta.factor, max = 2 * Math.PI, decay = particle.tilt.decay ?? 1;
    if (!tiltAnimation.enable) return;
    switch(particle.tilt.status){
        case "increasing":
            particle.tilt.value += speed;
            if (particle.tilt.value > max) particle.tilt.value -= max;
            break;
        case "decreasing":
        default:
            particle.tilt.value -= speed;
            if (particle.tilt.value < 0) particle.tilt.value += max;
            break;
    }
    if (particle.tilt.velocity && decay !== 1) particle.tilt.velocity *= decay;
}


class $cc0cb6ab01fbe43c$export$bf10918add78aca9 {
    constructor(container){
        this.container = container;
    }
    getTransformValues(particle) {
        const tilt = particle.tilt?.enable && particle.tilt;
        return {
            b: tilt ? Math.cos(tilt.value) * tilt.cosDirection : undefined,
            c: tilt ? Math.sin(tilt.value) * tilt.sinDirection : undefined
        };
    }
    init(particle) {
        const tiltOptions = particle.options.tilt;
        if (!tiltOptions) return;
        particle.tilt = {
            enable: tiltOptions.enable,
            value: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(tiltOptions.value) * Math.PI / 180,
            sinDirection: (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() >= 0.5 ? 1 : -1,
            cosDirection: (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() >= 0.5 ? 1 : -1
        };
        let tiltDirection = tiltOptions.direction;
        if (tiltDirection === "random") {
            const index = Math.floor((0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() * 2);
            tiltDirection = index > 0 ? "counter-clockwise" : "clockwise";
        }
        switch(tiltDirection){
            case "counter-clockwise":
            case "counterClockwise":
                particle.tilt.status = "decreasing";
                break;
            case "clockwise":
                particle.tilt.status = "increasing";
                break;
        }
        const tiltAnimation = particle.options.tilt?.animation;
        if (tiltAnimation?.enable) {
            particle.tilt.decay = 1 - (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(tiltAnimation.decay);
            particle.tilt.velocity = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(tiltAnimation.speed) / 360 * this.container.retina.reduceFactor;
            if (!tiltAnimation.sync) particle.tilt.velocity *= (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)();
        }
    }
    isEnabled(particle) {
        const tiltAnimation = particle.options.tilt?.animation;
        return !particle.destroyed && !particle.spawning && !!tiltAnimation?.enable;
    }
    loadOptions(options, ...sources) {
        if (!options.tilt) options.tilt = new (0, $257d6aa4a890e8f4$export$7f9fd97e8e8ffd03)();
        for (const source of sources)options.tilt.load(source?.tilt);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        (0, $65cbede8dac0bfa8$export$a54513c02db8db)(particle, delta);
    }
}


async function $89e21f8a6092072a$export$ad7cd7f1bf42858c(engine, refresh = true) {
    await engine.addParticleUpdater("tilt", (container)=>new (0, $cc0cb6ab01fbe43c$export$bf10918add78aca9)(container), refresh);
}




class $31dbc44f41771f25$export$f548b4b237268fab {
    constructor(){
        this.enable = false;
        this.frequency = 0.05;
        this.opacity = 1;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $67b0362ed7572c6e$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.frequency !== undefined) this.frequency = data.frequency;
        if (data.opacity !== undefined) this.opacity = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.opacity);
    }
}


class $c4a64e16208722a1$export$d2019f714f998af1 {
    constructor(){
        this.lines = new (0, $31dbc44f41771f25$export$f548b4b237268fab)();
        this.particles = new (0, $31dbc44f41771f25$export$f548b4b237268fab)();
    }
    load(data) {
        if (!data) return;
        this.lines.load(data.lines);
        this.particles.load(data.particles);
    }
}


class $c0986cca66c2321b$export$ea14214ae03f2c07 {
    getColorStyles(particle, context, radius, opacity) {
        const pOptions = particle.options, twinkleOptions = pOptions.twinkle;
        if (!twinkleOptions) return {};
        const twinkle = twinkleOptions.particles, twinkling = twinkle.enable && (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() < twinkle.frequency, zIndexOptions = particle.options.zIndex, zOpacityFactor = (1 - particle.zIndexFactor) ** zIndexOptions.opacityRate, twinklingOpacity = twinkling ? (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(twinkle.opacity) * zOpacityFactor : opacity, twinkleRgb = (0, $3b20cd3c058d307c$export$79a89086521c0f12)(twinkle.color), twinkleStyle = twinkleRgb ? (0, $3b20cd3c058d307c$export$9d057e59c7b0a82d)(twinkleRgb, twinklingOpacity) : undefined, res = {}, needsTwinkle = twinkling && twinkleStyle;
        res.fill = needsTwinkle ? twinkleStyle : undefined;
        res.stroke = needsTwinkle ? twinkleStyle : undefined;
        return res;
    }
    init() {}
    isEnabled(particle) {
        const pOptions = particle.options, twinkleOptions = pOptions.twinkle;
        if (!twinkleOptions) return false;
        return twinkleOptions.particles.enable;
    }
    loadOptions(options, ...sources) {
        if (!options.twinkle) options.twinkle = new (0, $c4a64e16208722a1$export$d2019f714f998af1)();
        for (const source of sources)options.twinkle.load(source?.twinkle);
    }
    update() {}
}


async function $cfbaf154a5656984$export$b9c8280298f659a5(engine, refresh = true) {
    await engine.addParticleUpdater("twinkle", ()=>new (0, $c0986cca66c2321b$export$ea14214ae03f2c07)(), refresh);
}





class $4d21af36f30d61bc$export$9d1564e235810926 {
    constructor(){
        this.angle = 50;
        this.move = 10;
    }
    load(data) {
        if (!data) return;
        if (data.angle !== undefined) this.angle = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.angle);
        if (data.move !== undefined) this.move = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.move);
    }
}


class $2d86bbac5137454a$export$e3332f9062c9ef49 {
    constructor(){
        this.distance = 5;
        this.enable = false;
        this.speed = new (0, $4d21af36f30d61bc$export$9d1564e235810926)();
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = (0, $a17cb6ec9e2ec6c9$export$6dcd5a07b989db7)(data.distance);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) {
            if ((0, $ab7d474d755ab51b$export$7e4aa119212bc614)(data.speed)) this.speed.load({
                angle: data.speed
            });
            else {
                const rangeSpeed = data.speed;
                if (rangeSpeed.min !== undefined) this.speed.load({
                    angle: rangeSpeed
                });
                else this.speed.load(data.speed);
            }
        }
    }
}


function $bc66c0913b414989$export$c35033201341f652(particle, delta) {
    const { wobble: wobbleOptions } = particle.options, { wobble: wobble } = particle;
    if (!wobbleOptions?.enable || !wobble) return;
    const angleSpeed = wobble.angleSpeed * delta.factor, moveSpeed = wobble.moveSpeed * delta.factor, distance = moveSpeed * ((particle.retina.wobbleDistance ?? 0) * delta.factor) / (1000 / 60), max = 2 * Math.PI, { position: position } = particle;
    wobble.angle += angleSpeed;
    if (wobble.angle > max) wobble.angle -= max;
    position.x += distance * Math.cos(wobble.angle);
    position.y += distance * Math.abs(Math.sin(wobble.angle));
}


class $4ac22c4314639657$export$40b8dfc901f79b9a {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const wobbleOpt = particle.options.wobble;
        if (wobbleOpt?.enable) particle.wobble = {
            angle: (0, $a17cb6ec9e2ec6c9$export$1a76347094524b3b)() * Math.PI * 2,
            angleSpeed: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(wobbleOpt.speed.angle) / 360,
            moveSpeed: (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(wobbleOpt.speed.move) / 10
        };
        else particle.wobble = {
            angle: 0,
            angleSpeed: 0,
            moveSpeed: 0
        };
        particle.retina.wobbleDistance = (0, $a17cb6ec9e2ec6c9$export$e70c64b68236cb4e)(wobbleOpt?.distance ?? 0) * this.container.retina.pixelRatio;
    }
    isEnabled(particle) {
        return !particle.destroyed && !particle.spawning && !!particle.options.wobble?.enable;
    }
    loadOptions(options, ...sources) {
        if (!options.wobble) options.wobble = new (0, $2d86bbac5137454a$export$e3332f9062c9ef49)();
        for (const source of sources)options.wobble.load(source?.wobble);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        (0, $bc66c0913b414989$export$c35033201341f652)(particle, delta);
    }
}


async function $21aa125d8bdf7e49$export$b74f9b6304f50c00(engine, refresh = true) {
    await engine.addParticleUpdater("wobble", (container)=>new (0, $4ac22c4314639657$export$40b8dfc901f79b9a)(container), refresh);
}


async function $c7877c8cbcd285e5$export$85493d8c5e7176fb(engine, refresh = true) {
    await (0, $70fac5c29cb0a44a$export$d6d9d65fda83a7c5)(engine, false);
    await (0, $0dd796cea7ba1996$export$9a3fb111b9c845ed)(engine, false);
    await (0, $89e21f8a6092072a$export$ad7cd7f1bf42858c)(engine, false);
    await (0, $cfbaf154a5656984$export$b9c8280298f659a5)(engine, false);
    await (0, $21aa125d8bdf7e49$export$b74f9b6304f50c00)(engine, false);
    await (0, $c0010aba0f836e71$export$9e84d16a6473365f)(engine, false);
    await (0, $42897151d6182eb9$export$c075ef8fc5389119)(engine, false);
    await (0, $1a007bc42ebfebf1$export$e4e45ab97167d364)(engine, false);
    await (0, $455ad9bd4323ff81$export$e11831a95a1ec8d5)(engine, refresh);
}


const $85f96101cfd9e56a$var$init = async (engine)=>{
    await (0, $c7877c8cbcd285e5$export$85493d8c5e7176fb)(engine);
};
const $85f96101cfd9e56a$var$particleOptions = {
    fullScreen: {
        zIndex: 1
    },
    particles: {
        number: {
            value: 0
        },
        shape: {
            type: "image",
            image: [
                {
                    src: "stars/star_1.svg"
                },
                {
                    src: "stars/star_2.svg"
                },
                {
                    src: "stars/star_3.svg"
                },
                {
                    src: "stars/star_4.svg"
                }
            ]
        },
        opacity: {
            value: 1,
            animation: {
                enable: true,
                minimumValue: 0,
                speed: {
                    min: 1,
                    max: 2
                },
                startValue: "max",
                destroy: "min",
                sync: true
            }
        },
        size: {
            value: 32,
            random: {
                enable: true,
                minimumValue: 2.5
            }
        },
        links: {
            enable: false
        },
        life: {
            duration: {
                value: 1.5
            },
            count: 1
        },
        move: {
            enable: true,
            gravity: {
                enable: true,
                acceleration: 0
            },
            speed: {
                min: 10,
                max: 35
            },
            decay: 0.07,
            angle: 360,
            direction: "none",
            straight: false,
            outModes: {
                default: "destroy",
                top: "none"
            }
        },
        rotate: {
            value: {
                min: 0,
                max: 360
            },
            direction: "random",
            move: true,
            animation: {
                enable: true,
                speed: 15
            }
        }
    },
    emitters: {
        position: {
            x: 80,
            y: 40
        },
        life: {
            count: 1,
            duration: 0.1
        },
        rate: {
            quantity: 25
        },
        size: {
            width: 0,
            height: 0
        }
    }
};
const $85f96101cfd9e56a$export$9d0c55036e5f7610 = ({ score: score })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $01494118b1e6559d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b769f11e629ddf15$export$e25e478948902b8b).div, {
                className: "fixed top-[40%] left-[80%] -translate-x-1/2 -translate-y-1/2 text-neutral-50 text-display2 font-medium z-50",
                initial: {
                    opacity: 1
                },
                animate: {
                    opacity: 0,
                    transition: {
                        duration: 0.3,
                        delay: 0.7,
                        ease: "easeOut"
                    }
                },
                children: [
                    "+ ",
                    score,
                    " points"
                ]
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $c69b3fedfaeac164$export$2e2bcd8739ae039), {
                init: $85f96101cfd9e56a$var$init,
                options: $85f96101cfd9e56a$var$particleOptions
            })
        ]
    });
};




var $358a9353f8d9edbc$exports = {};


$358a9353f8d9edbc$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("ktZBX");


const $01143b28052bbc8c$export$f3f3f6c0124f08de = ({ gameSession: gameSession, setGameStatus: setGameStatus, setGameSession: setGameSession })=>{
    const [gameStartTime, setGameStartTime] = (0, $1fELX.useState)();
    const [imageStartTime, setImageStartTime] = (0, $1fELX.useState)();
    const [selectionHistory, setSelectionHistory] = (0, $1fELX.useState)([]);
    const [lastSelected, setLastSelected] = (0, $1fELX.useState)();
    const [totalScore, setTotalScore] = (0, $1fELX.useState)(0);
    const [lastScore, setLastScore] = (0, $1fELX.useState)();
    const [showTimer, setShowTimer] = (0, $1fELX.useState)(true);
    const [play] = (0, $d4d68b59540df7f6$export$a34349420ba3cec8)((0, (/*@__PURE__*/$parcel$interopDefault($358a9353f8d9edbc$exports))), {
        interrupt: true
    });
    const currentIndex = selectionHistory.length;
    const currentImage = gameSession.shownImages[currentIndex];
    const resetGameStartTime = ()=>{
        setGameStartTime(new Date());
    };
    const onSelect = (grading)=>{
        if (!currentImage || !imageStartTime) return;
        setLastSelected(grading);
        const selectedTime = new Date();
        const usedTime = selectedTime.getTime() - imageStartTime.getTime();
        const score = (0, $9fa5f9e20cc9995d$export$947363cddeff0a3d)(usedTime, grading, currentImage);
        if (score > 0) setTimeout(()=>play(), 300);
        requestAnimationFrame(()=>{
            setSelectionHistory([
                ...selectionHistory,
                {
                    dicomId: currentImage.id,
                    grading: grading,
                    usedTime: usedTime
                }
            ]);
            setLastScore(score);
            setTotalScore(totalScore + score);
            setImageStartTime(selectedTime);
        });
    };
    (0, $1fELX.useEffect)(()=>{
        resetGameStartTime();
        setImageStartTime(new Date());
    }, []);
    (0, $1fELX.useEffect)(()=>{
        if (!currentImage) {
            const timeout = setTimeout(()=>{
                setGameStatus((0, $fe11df8941c5cc1d$export$23c7328964450bd2).Finished);
            }, 1000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        currentImage,
        setGameStatus,
        setGameSession
    ]);
    (0, $1fELX.useEffect)(()=>{
        setGameSession((gameSession)=>{
            return {
                ...gameSession,
                selectionHistory: selectionHistory,
                score: totalScore,
                totalTime: selectionHistory.reduce((sum, selection)=>{
                    return sum + selection.usedTime;
                }, 0)
            };
        });
    }, [
        setGameSession,
        selectionHistory,
        totalScore
    ]);
    (0, $1fELX.useEffect)(()=>{
        if (lastScore) {
            setShowTimer(false);
            const timeout = setTimeout(()=>{
                setShowTimer(true);
            }, 1000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        lastScore
    ]);
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
        className: "h-full w-screen fixed",
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $46adf260b14651d6$export$5f95e975d3adc575), {}),
            imageStartTime && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $aed330b7874a8ed8$export$3e8d0cb7ceb1642a), {
                currentIndex: currentIndex,
                selectionHistory: selectionHistory,
                startTime: imageStartTime
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $3b721212c7786b45$export$94026ee33dbabc26), {
                image: currentImage,
                lastSelected: lastSelected
            }),
            !!gameStartTime && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $176c0debacf7111a$export$4f932205b2d915ac), {
                onSelect: onSelect,
                totalScore: totalScore,
                startTime: gameStartTime,
                isActive: !!currentImage,
                correctAnswer: currentImage?.groundTruth?.grading
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                className: "fixed top-0 bottom-[15%] left-1/2 -translate-x-1/2",
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a3e7ef04d345b07d$export$13921ac0cc260818), {
                    lastSelected: lastSelected,
                    currentIndex: currentIndex
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b19d52cfe90140b0$export$3ae376d12526dd6f), {
                children: !!imageStartTime && !!currentImage && showTimer && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $0a33ef90d6a0bed0$export$c57e9b2d8b9e4de), {
                    startTime: imageStartTime,
                    onLimitReached: ()=>onSelect(undefined)
                })
            }),
            !!lastScore && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $85f96101cfd9e56a$export$9d0c55036e5f7610), {
                score: lastScore
            }, currentIndex)
        ]
    });
};



parcelRequire("1fELX");

var $01091edf101a80f7$exports = {};


$01091edf101a80f7$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("39v1z");







const $b06252936b8ebca8$export$dcfbacf97d3ea1ac = ({ setGameStatus: setGameStatus })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$b89a827e9254211a), {
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b280a35ff744d18b$export$8868dba5c6237081), {
                children: "Game Instructions"
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b280a35ff744d18b$export$a2a14dc5e9bae153), {
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                    className: "overflow-y-auto sm:-mx-2 lg:-mx-4",
                    children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                        className: "flex flex-col min-w-full py-2 sm:px-6 lg:px-4 gap-16",
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                className: "flex flex-col overflow-hidden gap-10",
                                children: [
                                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                        className: "flex items-center text-display3",
                                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("h2", {
                                            children: "1- Select the correct TIRAD level of 10 DICOM images."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                        className: "flex gap-6 items-center px-10",
                                        children: [
                                            Array(5).fill((0, (/*@__PURE__*/$parcel$interopDefault($01091edf101a80f7$exports)))).map((s, i)=>{
                                                return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                                                    src: s
                                                }, i);
                                            }),
                                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                                className: "flex text-display3",
                                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("h2", {
                                                    children: " = "
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("svg", {
                                                width: "44",
                                                height: "44",
                                                viewBox: "0 0 25 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("g", {
                                                    id: "Frame",
                                                    children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                        id: "Vector",
                                                        d: "M12.3569 2L15.4469 8.26L22.3569 9.27L17.3569 14.14L18.5369 21.02L12.3569 17.77L6.17693 21.02L7.35693 14.14L2.35693 9.27L9.26693 8.26L12.3569 2Z",
                                                        stroke: "#00ffba",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                className: "flex flex-col overflow-hidden gap-10",
                                children: [
                                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                        className: "flex items-center text-display3",
                                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("h2", {
                                            children: "2- You’ve got 30 seconds per image. The quicker you choose, the more points you get."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                        className: "flex gap-6 items-center px-10",
                                        children: [
                                            (0, $cc00f4b137e2dc0c$export$897da0bbced5e834).map((grading)=>/*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $176c0debacf7111a$export$353f5b6fc5456de1), {
                                                    label: (0, $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)[grading].label,
                                                    className: (0, $cc00f4b137e2dc0c$export$9fba6b0d4f6e73ca)[grading].className,
                                                    onSelect: ()=>null
                                                }, grading)),
                                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                                className: "flex text-display3",
                                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("h2", {
                                                    children: " = "
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("svg", {
                                                width: "44",
                                                height: "44",
                                                viewBox: "0 0 25 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("g", {
                                                    id: "Frame",
                                                    children: [
                                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                            id: "Vector",
                                                            d: "M10.5713 2H14.5713",
                                                            stroke: "#00ffba",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                            id: "Vector_2",
                                                            d: "M12.5713 14L15.5713 11",
                                                            stroke: "#00ffba",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                            id: "Vector_3",
                                                            d: "M12.5713 22C16.9896 22 20.5713 18.4183 20.5713 14C20.5713 9.58172 16.9896 6 12.5713 6C8.15301 6 4.57129 9.58172 4.57129 14C4.57129 18.4183 8.15301 22 12.5713 22Z",
                                                            stroke: "#00ffba",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                className: "flex flex-col overflow-hidden gap-6",
                                children: [
                                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                        className: "flex items-center text-display3",
                                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("h2", {
                                            children: " 3- Highest scores will show on the leaderboard."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                                        className: "flex gap-6 items-center px-10",
                                        children: [
                                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("svg", {
                                                width: "44",
                                                height: "44",
                                                viewBox: "0 0 25 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("g", {
                                                    id: "Frame",
                                                    children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                        id: "Vector",
                                                        d: "M12.3569 2L15.4469 8.26L22.3569 9.27L17.3569 14.14L18.5369 21.02L12.3569 17.77L6.17693 21.02L7.35693 14.14L2.35693 9.27L9.26693 8.26L12.3569 2Z",
                                                        stroke: "#00ffba",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                                className: "flex text-display3",
                                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("h2", {
                                                    children: " + "
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("svg", {
                                                width: "44",
                                                height: "44",
                                                viewBox: "0 0 25 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("g", {
                                                    id: "Frame",
                                                    children: [
                                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                            id: "Vector",
                                                            d: "M10.5713 2H14.5713",
                                                            stroke: "#00ffba",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                            id: "Vector_2",
                                                            d: "M12.5713 14L15.5713 11",
                                                            stroke: "#00ffba",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                            id: "Vector_3",
                                                            d: "M12.5713 22C16.9896 22 20.5713 18.4183 20.5713 14C20.5713 9.58172 16.9896 6 12.5713 6C8.15301 6 4.57129 9.58172 4.57129 14C4.57129 18.4183 8.15301 22 12.5713 22Z",
                                                            stroke: "#00ffba",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                                                className: "flex text-display3",
                                                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("h2", {
                                                    children: " = "
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($78301b06f4fb5e5f$exports)))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$f1011c2ab959143d), {
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                        onClick: ()=>setGameStatus((0, $fe11df8941c5cc1d$export$23c7328964450bd2).Leaderboard),
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                name: "arrow-left"
                            }),
                            "Back"
                        ]
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                        variant: "primary",
                        onClick: ()=>setGameStatus((0, $fe11df8941c5cc1d$export$23c7328964450bd2).Started),
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                name: "controller"
                            }),
                            "Begin"
                        ]
                    })
                ]
            })
        ]
    });
};





var $1fELX = parcelRequire("1fELX");



var $1fELX = parcelRequire("1fELX");
var $37a6ef5f83f6d391$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $37a6ef5f83f6d391$var$isDateObject = (value1)=>value1 instanceof Date;
var $37a6ef5f83f6d391$var$isNullOrUndefined = (value1)=>value1 == null;
const $37a6ef5f83f6d391$var$isObjectType = (value1)=>typeof value1 === "object";
var $37a6ef5f83f6d391$var$isObject = (value1)=>!$37a6ef5f83f6d391$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $37a6ef5f83f6d391$var$isObjectType(value1) && !$37a6ef5f83f6d391$var$isDateObject(value1);
var $37a6ef5f83f6d391$var$getEventValue = (event)=>$37a6ef5f83f6d391$var$isObject(event) && event.target ? $37a6ef5f83f6d391$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $37a6ef5f83f6d391$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $37a6ef5f83f6d391$var$isNameInFieldArray = (names, name)=>names.has($37a6ef5f83f6d391$var$getNodeParentName(name));
var $37a6ef5f83f6d391$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $37a6ef5f83f6d391$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $37a6ef5f83f6d391$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $37a6ef5f83f6d391$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($37a6ef5f83f6d391$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $37a6ef5f83f6d391$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$37a6ef5f83f6d391$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $37a6ef5f83f6d391$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $37a6ef5f83f6d391$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $37a6ef5f83f6d391$var$isUndefined = (val)=>val === undefined;
var $37a6ef5f83f6d391$export$3988ae62b71be9a3 = (obj, path, defaultValue)=>{
    if (!path || !$37a6ef5f83f6d391$var$isObject(obj)) return defaultValue;
    const result = $37a6ef5f83f6d391$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$37a6ef5f83f6d391$var$isNullOrUndefined(result) ? result : result[key], obj);
    return $37a6ef5f83f6d391$var$isUndefined(result) || result === obj ? $37a6ef5f83f6d391$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
var $37a6ef5f83f6d391$var$isBoolean = (value1)=>typeof value1 === "boolean";
const $37a6ef5f83f6d391$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $37a6ef5f83f6d391$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $37a6ef5f83f6d391$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $37a6ef5f83f6d391$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $37a6ef5f83f6d391$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useContext($37a6ef5f83f6d391$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $37a6ef5f83f6d391$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).createElement($37a6ef5f83f6d391$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $37a6ef5f83f6d391$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $37a6ef5f83f6d391$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $37a6ef5f83f6d391$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $37a6ef5f83f6d391$var$isEmptyObject = (value1)=>$37a6ef5f83f6d391$var$isObject(value1) && !Object.keys(value1).length;
var $37a6ef5f83f6d391$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $37a6ef5f83f6d391$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $37a6ef5f83f6d391$var$VALIDATION_MODE.all));
};
var $37a6ef5f83f6d391$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $37a6ef5f83f6d391$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $37a6ef5f83f6d391$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $37a6ef5f83f6d391$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $37a6ef5f83f6d391$export$606f11b2eb45ecc6(props) {
    const methods = $37a6ef5f83f6d391$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef(name);
    _name.current = name;
    $37a6ef5f83f6d391$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $37a6ef5f83f6d391$var$shouldSubscribeByName(_name.current, value1.name, exact) && $37a6ef5f83f6d391$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $37a6ef5f83f6d391$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $37a6ef5f83f6d391$var$isString = (value1)=>typeof value1 === "string";
var $37a6ef5f83f6d391$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($37a6ef5f83f6d391$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $37a6ef5f83f6d391$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $37a6ef5f83f6d391$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $37a6ef5f83f6d391$export$3c773aa2b84f29e0(props) {
    const methods = $37a6ef5f83f6d391$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef(name);
    _name.current = name;
    $37a6ef5f83f6d391$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($37a6ef5f83f6d391$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($37a6ef5f83f6d391$var$cloneObject($37a6ef5f83f6d391$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $37a6ef5f83f6d391$var$isKey = (value1)=>/^\w*$/.test(value1);
var $37a6ef5f83f6d391$var$stringToPath = (input)=>$37a6ef5f83f6d391$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
function $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(object, path, value1) {
    let index = -1;
    const tempPath = $37a6ef5f83f6d391$var$isKey(path) ? [
        path
    ] : $37a6ef5f83f6d391$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $37a6ef5f83f6d391$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $37a6ef5f83f6d391$export$e8c786024a2b0a79(props) {
    const methods = $37a6ef5f83f6d391$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $37a6ef5f83f6d391$var$isNameInFieldArray(control._names.array, name);
    const value1 = $37a6ef5f83f6d391$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $37a6ef5f83f6d391$export$3988ae62b71be9a3(control._formValues, name, $37a6ef5f83f6d391$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $37a6ef5f83f6d391$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef(control.register(name, {
        ...props.rules,
        value: value1
    }));
    _registerProps.current = control.register(name, props.rules);
    (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $37a6ef5f83f6d391$var$cloneObject($37a6ef5f83f6d391$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($37a6ef5f83f6d391$var$isUndefined($37a6ef5f83f6d391$export$3988ae62b71be9a3(control._formValues, name))) $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useEffect(()=>{
        if ($37a6ef5f83f6d391$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$37a6ef5f83f6d391$var$isBoolean(disabled) ? {
                disabled: disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $37a6ef5f83f6d391$var$getEventValue(event),
                        name: name
                    },
                    type: $37a6ef5f83f6d391$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $37a6ef5f83f6d391$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $37a6ef5f83f6d391$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$37a6ef5f83f6d391$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$37a6ef5f83f6d391$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$37a6ef5f83f6d391$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$37a6ef5f83f6d391$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $37a6ef5f83f6d391$export$bd0bf19f25da8474 = (props)=>props.render($37a6ef5f83f6d391$export$e8c786024a2b0a79(props));
const $37a6ef5f83f6d391$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $37a6ef5f83f6d391$export$a7fed597f4b8afd8(props) {
    const methods = $37a6ef5f83f6d391$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $37a6ef5f83f6d391$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $37a6ef5f83f6d391$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $37a6ef5f83f6d391$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
const $37a6ef5f83f6d391$var$focusFieldBy = (fields, callback, fieldsNames)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus) {
                    _f.ref.focus();
                    break;
                } else if (_f.refs && _f.refs[0].focus) {
                    _f.refs[0].focus();
                    break;
                }
            } else if ($37a6ef5f83f6d391$var$isObject(currentField)) $37a6ef5f83f6d391$var$focusFieldBy(currentField, callback);
        }
    }
};
var $37a6ef5f83f6d391$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $37a6ef5f83f6d391$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $37a6ef5f83f6d391$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$37a6ef5f83f6d391$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $37a6ef5f83f6d391$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $37a6ef5f83f6d391$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $37a6ef5f83f6d391$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $37a6ef5f83f6d391$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $37a6ef5f83f6d391$var$VALIDATION_MODE.all,
        isOnTouch: mode === $37a6ef5f83f6d391$var$VALIDATION_MODE.onTouched
    });
var $37a6ef5f83f6d391$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
var $37a6ef5f83f6d391$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $37a6ef5f83f6d391$var$compact($37a6ef5f83f6d391$export$3988ae62b71be9a3(errors, name));
    $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $37a6ef5f83f6d391$var$isFileInput = (element)=>element.type === "file";
var $37a6ef5f83f6d391$var$isFunction = (value1)=>typeof value1 === "function";
var $37a6ef5f83f6d391$var$isHTMLElement = (value1)=>{
    if (!$37a6ef5f83f6d391$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $37a6ef5f83f6d391$var$isMessage = (value1)=>$37a6ef5f83f6d391$var$isString(value1);
var $37a6ef5f83f6d391$var$isRadioInput = (element)=>element.type === "radio";
var $37a6ef5f83f6d391$var$isRegex = (value1)=>value1 instanceof RegExp;
const $37a6ef5f83f6d391$var$defaultResult = {
    value: false,
    isValid: false
};
const $37a6ef5f83f6d391$var$validResult = {
    value: true,
    isValid: true
};
var $37a6ef5f83f6d391$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$37a6ef5f83f6d391$var$isUndefined(options[0].attributes.value) ? $37a6ef5f83f6d391$var$isUndefined(options[0].value) || options[0].value === "" ? $37a6ef5f83f6d391$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $37a6ef5f83f6d391$var$validResult : $37a6ef5f83f6d391$var$defaultResult;
    }
    return $37a6ef5f83f6d391$var$defaultResult;
};
const $37a6ef5f83f6d391$var$defaultReturn = {
    isValid: false,
    value: null
};
var $37a6ef5f83f6d391$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $37a6ef5f83f6d391$var$defaultReturn) : $37a6ef5f83f6d391$var$defaultReturn;
function $37a6ef5f83f6d391$var$getValidateError(result, ref, type = "validate") {
    if ($37a6ef5f83f6d391$var$isMessage(result) || Array.isArray(result) && result.every($37a6ef5f83f6d391$var$isMessage) || $37a6ef5f83f6d391$var$isBoolean(result) && !result) return {
        type: type,
        message: $37a6ef5f83f6d391$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $37a6ef5f83f6d391$var$getValueAndMessage = (validationData)=>$37a6ef5f83f6d391$var$isObject(validationData) && !$37a6ef5f83f6d391$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $37a6ef5f83f6d391$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $37a6ef5f83f6d391$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($37a6ef5f83f6d391$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $37a6ef5f83f6d391$var$isRadioInput(ref);
    const isCheckBox = $37a6ef5f83f6d391$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $37a6ef5f83f6d391$var$isFileInput(ref)) && $37a6ef5f83f6d391$var$isUndefined(ref.value) && $37a6ef5f83f6d391$var$isUndefined(inputValue) || $37a6ef5f83f6d391$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $37a6ef5f83f6d391$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $37a6ef5f83f6d391$var$INPUT_VALIDATION_RULES.maxLength, minType = $37a6ef5f83f6d391$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $37a6ef5f83f6d391$var$isNullOrUndefined(inputValue)) || $37a6ef5f83f6d391$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$37a6ef5f83f6d391$var$getCheckboxValue(refs).isValid || isRadio && !$37a6ef5f83f6d391$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $37a6ef5f83f6d391$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $37a6ef5f83f6d391$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $37a6ef5f83f6d391$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($37a6ef5f83f6d391$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$37a6ef5f83f6d391$var$isNullOrUndefined(min) || !$37a6ef5f83f6d391$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $37a6ef5f83f6d391$var$getValueAndMessage(max);
        const minOutput = $37a6ef5f83f6d391$var$getValueAndMessage(min);
        if (!$37a6ef5f83f6d391$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$37a6ef5f83f6d391$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$37a6ef5f83f6d391$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($37a6ef5f83f6d391$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($37a6ef5f83f6d391$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $37a6ef5f83f6d391$var$INPUT_VALIDATION_RULES.max, $37a6ef5f83f6d391$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($37a6ef5f83f6d391$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $37a6ef5f83f6d391$var$getValueAndMessage(maxLength);
        const minLengthOutput = $37a6ef5f83f6d391$var$getValueAndMessage(minLength);
        const exceedMax = !$37a6ef5f83f6d391$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$37a6ef5f83f6d391$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $37a6ef5f83f6d391$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $37a6ef5f83f6d391$var$getValueAndMessage(pattern);
        if ($37a6ef5f83f6d391$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $37a6ef5f83f6d391$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($37a6ef5f83f6d391$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($37a6ef5f83f6d391$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $37a6ef5f83f6d391$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($37a6ef5f83f6d391$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($37a6ef5f83f6d391$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$37a6ef5f83f6d391$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $37a6ef5f83f6d391$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$37a6ef5f83f6d391$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
function $37a6ef5f83f6d391$var$append(data, value1) {
    return [
        ...data,
        ...$37a6ef5f83f6d391$var$convertToArrayPayload(value1)
    ];
}
var $37a6ef5f83f6d391$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $37a6ef5f83f6d391$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$37a6ef5f83f6d391$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $37a6ef5f83f6d391$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($37a6ef5f83f6d391$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
function $37a6ef5f83f6d391$var$prepend(data, value1) {
    return [
        ...$37a6ef5f83f6d391$var$convertToArrayPayload(value1),
        ...$37a6ef5f83f6d391$var$convertToArrayPayload(data)
    ];
}
function $37a6ef5f83f6d391$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $37a6ef5f83f6d391$var$compact(temp).length ? temp : [];
}
var $37a6ef5f83f6d391$var$removeArrayAt = (data, index)=>$37a6ef5f83f6d391$var$isUndefined(index) ? [] : $37a6ef5f83f6d391$var$removeAtIndexes(data, $37a6ef5f83f6d391$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $37a6ef5f83f6d391$var$swapArrayAt = (data, indexA, indexB)=>{
    data[indexA] = [
        data[indexB],
        data[indexB] = data[indexA]
    ][0];
};
function $37a6ef5f83f6d391$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $37a6ef5f83f6d391$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $37a6ef5f83f6d391$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$37a6ef5f83f6d391$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $37a6ef5f83f6d391$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $37a6ef5f83f6d391$var$isKey(path) ? [
        path
    ] : $37a6ef5f83f6d391$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $37a6ef5f83f6d391$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($37a6ef5f83f6d391$var$isObject(childObject) && $37a6ef5f83f6d391$var$isEmptyObject(childObject) || Array.isArray(childObject) && $37a6ef5f83f6d391$var$isEmptyArray(childObject))) $37a6ef5f83f6d391$var$unset(object, paths.slice(0, -1));
    return object;
}
var $37a6ef5f83f6d391$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $37a6ef5f83f6d391$export$310131896651d559(props) {
    const methods = $37a6ef5f83f6d391$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef(control._getFieldArray(name).map($37a6ef5f83f6d391$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $37a6ef5f83f6d391$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $37a6ef5f83f6d391$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($37a6ef5f83f6d391$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append$1 = (value1, options)=>{
        const appendValue = $37a6ef5f83f6d391$var$convertToArrayPayload($37a6ef5f83f6d391$var$cloneObject(value1));
        const updatedFieldArrayValues = $37a6ef5f83f6d391$var$append(control._getFieldArray(name), appendValue);
        control._names.focus = $37a6ef5f83f6d391$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $37a6ef5f83f6d391$var$append(ids.current, appendValue.map($37a6ef5f83f6d391$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $37a6ef5f83f6d391$var$append, {
            argA: $37a6ef5f83f6d391$var$fillEmptyArray(value1)
        });
    };
    const prepend$1 = (value1, options)=>{
        const prependValue = $37a6ef5f83f6d391$var$convertToArrayPayload($37a6ef5f83f6d391$var$cloneObject(value1));
        const updatedFieldArrayValues = $37a6ef5f83f6d391$var$prepend(control._getFieldArray(name), prependValue);
        control._names.focus = $37a6ef5f83f6d391$var$getFocusFieldName(name, 0, options);
        ids.current = $37a6ef5f83f6d391$var$prepend(ids.current, prependValue.map($37a6ef5f83f6d391$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $37a6ef5f83f6d391$var$prepend, {
            argA: $37a6ef5f83f6d391$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $37a6ef5f83f6d391$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $37a6ef5f83f6d391$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $37a6ef5f83f6d391$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $37a6ef5f83f6d391$var$convertToArrayPayload($37a6ef5f83f6d391$var$cloneObject(value1));
        const updatedFieldArrayValues = $37a6ef5f83f6d391$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $37a6ef5f83f6d391$var$getFocusFieldName(name, index, options);
        ids.current = $37a6ef5f83f6d391$var$insert(ids.current, index, insertValue.map($37a6ef5f83f6d391$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $37a6ef5f83f6d391$var$insert, {
            argA: index,
            argB: $37a6ef5f83f6d391$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $37a6ef5f83f6d391$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $37a6ef5f83f6d391$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $37a6ef5f83f6d391$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $37a6ef5f83f6d391$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $37a6ef5f83f6d391$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $37a6ef5f83f6d391$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $37a6ef5f83f6d391$var$cloneObject(value1);
        const updatedFieldArrayValues = $37a6ef5f83f6d391$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $37a6ef5f83f6d391$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $37a6ef5f83f6d391$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $37a6ef5f83f6d391$var$convertToArrayPayload($37a6ef5f83f6d391$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($37a6ef5f83f6d391$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useEffect(()=>{
        control._state.action = false;
        $37a6ef5f83f6d391$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$37a6ef5f83f6d391$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $37a6ef5f83f6d391$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $37a6ef5f83f6d391$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $37a6ef5f83f6d391$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) $37a6ef5f83f6d391$var$validateField(field, control._formValues, control._options.criteriaMode === $37a6ef5f83f6d391$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$37a6ef5f83f6d391$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $37a6ef5f83f6d391$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $37a6ef5f83f6d391$var$focusFieldBy(control._fields, (key)=>!!key && key.startsWith(control._names.focus || ""));
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useEffect(()=>{
        !$37a6ef5f83f6d391$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback(prepend$1, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback(append$1, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $37a6ef5f83f6d391$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
function $37a6ef5f83f6d391$var$createSubject() {
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
}
var $37a6ef5f83f6d391$var$isPrimitive = (value1)=>$37a6ef5f83f6d391$var$isNullOrUndefined(value1) || !$37a6ef5f83f6d391$var$isObjectType(value1);
function $37a6ef5f83f6d391$var$deepEqual(object1, object2) {
    if ($37a6ef5f83f6d391$var$isPrimitive(object1) || $37a6ef5f83f6d391$var$isPrimitive(object2)) return object1 === object2;
    if ($37a6ef5f83f6d391$var$isDateObject(object1) && $37a6ef5f83f6d391$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($37a6ef5f83f6d391$var$isDateObject(val1) && $37a6ef5f83f6d391$var$isDateObject(val2) || $37a6ef5f83f6d391$var$isObject(val1) && $37a6ef5f83f6d391$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$37a6ef5f83f6d391$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $37a6ef5f83f6d391$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $37a6ef5f83f6d391$var$isRadioOrCheckbox = (ref)=>$37a6ef5f83f6d391$var$isRadioInput(ref) || $37a6ef5f83f6d391$var$isCheckBoxInput(ref);
var $37a6ef5f83f6d391$var$live = (ref)=>$37a6ef5f83f6d391$var$isHTMLElement(ref) && ref.isConnected;
var $37a6ef5f83f6d391$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($37a6ef5f83f6d391$var$isFunction(data[key])) return true;
    }
    return false;
};
function $37a6ef5f83f6d391$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($37a6ef5f83f6d391$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $37a6ef5f83f6d391$var$isObject(data[key]) && !$37a6ef5f83f6d391$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $37a6ef5f83f6d391$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$37a6ef5f83f6d391$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $37a6ef5f83f6d391$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($37a6ef5f83f6d391$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $37a6ef5f83f6d391$var$isObject(data[key]) && !$37a6ef5f83f6d391$var$objectHasFunction(data[key])) {
            if ($37a6ef5f83f6d391$var$isUndefined(formValues) || $37a6ef5f83f6d391$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $37a6ef5f83f6d391$var$markFieldsDirty(data[key], []) : {
                ...$37a6ef5f83f6d391$var$markFieldsDirty(data[key])
            };
            else $37a6ef5f83f6d391$var$getDirtyFieldsFromDefaultValues(data[key], $37a6ef5f83f6d391$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$37a6ef5f83f6d391$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $37a6ef5f83f6d391$var$getDirtyFields = (defaultValues, formValues)=>$37a6ef5f83f6d391$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $37a6ef5f83f6d391$var$markFieldsDirty(formValues));
var $37a6ef5f83f6d391$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$37a6ef5f83f6d391$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $37a6ef5f83f6d391$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $37a6ef5f83f6d391$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($37a6ef5f83f6d391$var$isFileInput(ref)) return ref.files;
    if ($37a6ef5f83f6d391$var$isRadioInput(ref)) return $37a6ef5f83f6d391$var$getRadioValue(_f.refs).value;
    if ($37a6ef5f83f6d391$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($37a6ef5f83f6d391$var$isCheckBoxInput(ref)) return $37a6ef5f83f6d391$var$getCheckboxValue(_f.refs).value;
    return $37a6ef5f83f6d391$var$getFieldValueAs($37a6ef5f83f6d391$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $37a6ef5f83f6d391$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name);
        field && $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $37a6ef5f83f6d391$var$getRuleValue = (rule)=>$37a6ef5f83f6d391$var$isUndefined(rule) ? rule : $37a6ef5f83f6d391$var$isRegex(rule) ? rule.source : $37a6ef5f83f6d391$var$isObject(rule) ? $37a6ef5f83f6d391$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $37a6ef5f83f6d391$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $37a6ef5f83f6d391$var$schemaErrorLookup(errors, _fields, name) {
    const error = $37a6ef5f83f6d391$export$3988ae62b71be9a3(errors, name);
    if (error || $37a6ef5f83f6d391$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $37a6ef5f83f6d391$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $37a6ef5f83f6d391$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $37a6ef5f83f6d391$var$unsetEmptyArray = (ref, name)=>!$37a6ef5f83f6d391$var$compact($37a6ef5f83f6d391$export$3988ae62b71be9a3(ref, name)).length && $37a6ef5f83f6d391$var$unset(ref, name);
const $37a6ef5f83f6d391$var$defaultOptions = {
    mode: $37a6ef5f83f6d391$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $37a6ef5f83f6d391$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $37a6ef5f83f6d391$var$createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...$37a6ef5f83f6d391$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $37a6ef5f83f6d391$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {}
    };
    let _fields = {};
    let _defaultValues = $37a6ef5f83f6d391$var$isObject(_options.defaultValues) || $37a6ef5f83f6d391$var$isObject(_options.values) ? $37a6ef5f83f6d391$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $37a6ef5f83f6d391$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $37a6ef5f83f6d391$var$createSubject(),
        array: $37a6ef5f83f6d391$var$createSubject(),
        state: $37a6ef5f83f6d391$var$createSubject()
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    const validationModeBeforeSubmit = $37a6ef5f83f6d391$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $37a6ef5f83f6d391$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $37a6ef5f83f6d391$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $37a6ef5f83f6d391$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (value1)=>_proxyFormState.isValidating && _subjects.state.next({
            isValidating: value1
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($37a6ef5f83f6d391$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($37a6ef5f83f6d391$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $37a6ef5f83f6d391$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($37a6ef5f83f6d391$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($37a6ef5f83f6d391$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $37a6ef5f83f6d391$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_formValues, name, $37a6ef5f83f6d391$var$isUndefined(value1) ? $37a6ef5f83f6d391$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $37a6ef5f83f6d391$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $37a6ef5f83f6d391$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = $37a6ef5f83f6d391$var$deepEqual($37a6ef5f83f6d391$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            isCurrentFieldPristine ? $37a6ef5f83f6d391$var$unset(_formState.dirtyFields, name) : $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $37a6ef5f83f6d391$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $37a6ef5f83f6d391$var$unset(_formState.errors, name);
        }
        if ((error ? !$37a6ef5f83f6d391$var$deepEqual(previousFieldError, error) : previousFieldError) || !$37a6ef5f83f6d391$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $37a6ef5f83f6d391$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name)=>_options.resolver(_formValues, _options.context, $37a6ef5f83f6d391$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $37a6ef5f83f6d391$export$3988ae62b71be9a3(errors, name);
            error ? $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $37a6ef5f83f6d391$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await $37a6ef5f83f6d391$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($37a6ef5f83f6d391$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $37a6ef5f83f6d391$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $37a6ef5f83f6d391$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$37a6ef5f83f6d391$var$live(ref)) : !$37a6ef5f83f6d391$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formValues, name, data), !$37a6ef5f83f6d391$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$37a6ef5f83f6d391$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $37a6ef5f83f6d391$var$isUndefined(defaultValue) ? _defaultValues : $37a6ef5f83f6d391$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$37a6ef5f83f6d391$var$compact($37a6ef5f83f6d391$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $37a6ef5f83f6d391$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formValues, name, $37a6ef5f83f6d391$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $37a6ef5f83f6d391$var$isHTMLElement(fieldReference.ref) && $37a6ef5f83f6d391$var$isNullOrUndefined(value1) ? "" : value1;
                if ($37a6ef5f83f6d391$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($37a6ef5f83f6d391$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($37a6ef5f83f6d391$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$37a6ef5f83f6d391$var$isPrimitive(fieldValue) || field && !field._f) && !$37a6ef5f83f6d391$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $37a6ef5f83f6d391$var$cloneObject(value1);
        $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $37a6ef5f83f6d391$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$37a6ef5f83f6d391$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $37a6ef5f83f6d391$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: name,
            values: {
                ..._formValues
            }
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $37a6ef5f83f6d391$var$getFieldValue(field._f) : $37a6ef5f83f6d391$var$getEventValue(event);
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $37a6ef5f83f6d391$var$EVENTS.BLUR || event.type === $37a6ef5f83f6d391$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$37a6ef5f83f6d391$var$hasValidation(field._f) && !_options.resolver && !$37a6ef5f83f6d391$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $37a6ef5f83f6d391$var$skipValidation(isBlurEvent, $37a6ef5f83f6d391$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $37a6ef5f83f6d391$var$isWatched(name, _names, isBlurEvent);
            $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$37a6ef5f83f6d391$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                const previousErrorLookupResult = $37a6ef5f83f6d391$var$schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = $37a6ef5f83f6d391$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = $37a6ef5f83f6d391$var$isEmptyObject(errors);
            } else {
                error = (await $37a6ef5f83f6d391$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === $37a6ef5f83f6d391$export$3988ae62b71be9a3(_formValues, name, fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $37a6ef5f83f6d391$var$convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($37a6ef5f83f6d391$var$isUndefined(name) ? name : fieldNames);
            isValid = $37a6ef5f83f6d391$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$37a6ef5f83f6d391$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$37a6ef5f83f6d391$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && $37a6ef5f83f6d391$var$focusFieldBy(_fields, (key)=>key && $37a6ef5f83f6d391$export$3988ae62b71be9a3(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $37a6ef5f83f6d391$var$isUndefined(fieldNames) ? values : $37a6ef5f83f6d391$var$isString(fieldNames) ? $37a6ef5f83f6d391$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$37a6ef5f83f6d391$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$37a6ef5f83f6d391$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$37a6ef5f83f6d391$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$37a6ef5f83f6d391$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $37a6ef5f83f6d391$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $37a6ef5f83f6d391$var$convertToArrayPayload(name).forEach((inputName)=>$37a6ef5f83f6d391$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$37a6ef5f83f6d391$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $37a6ef5f83f6d391$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $37a6ef5f83f6d391$var$unset(_fields, fieldName);
                $37a6ef5f83f6d391$var$unset(_formValues, fieldName);
            }
            !options.keepError && $37a6ef5f83f6d391$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $37a6ef5f83f6d391$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $37a6ef5f83f6d391$var$unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $37a6ef5f83f6d391$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields })=>{
        if ($37a6ef5f83f6d391$var$isBoolean(disabled)) {
            const value1 = disabled ? undefined : $37a6ef5f83f6d391$export$3988ae62b71be9a3(_formValues, name, $37a6ef5f83f6d391$var$getFieldValue(field ? field._f : $37a6ef5f83f6d391$export$3988ae62b71be9a3(fields, name)._f));
            $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_formValues, name, value1);
            updateTouchAndDirty(name, value1, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $37a6ef5f83f6d391$var$isBoolean(options.disabled);
        $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $37a6ef5f83f6d391$var$getRuleValue(options.min),
                max: $37a6ef5f83f6d391$var$getRuleValue(options.max),
                minLength: $37a6ef5f83f6d391$var$getRuleValue(options.minLength),
                maxLength: $37a6ef5f83f6d391$var$getRuleValue(options.maxLength),
                pattern: $37a6ef5f83f6d391$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $37a6ef5f83f6d391$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $37a6ef5f83f6d391$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($37a6ef5f83f6d391$var$live),
                                    fieldRef,
                                    ...Array.isArray($37a6ef5f83f6d391$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($37a6ef5f83f6d391$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $37a6ef5f83f6d391$var$focusFieldBy(_fields, (key)=>key && $37a6ef5f83f6d391$export$3988ae62b71be9a3(_formState.errors, key), _names.mount);
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $37a6ef5f83f6d391$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $37a6ef5f83f6d391$var$unset(_formState.errors, "root");
            if ($37a6ef5f83f6d391$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                await onValid(fieldValues, e);
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $37a6ef5f83f6d391$var$isEmptyObject(_formState.errors),
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
        };
    const resetField = (name, options = {})=>{
        if ($37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name)) {
            if ($37a6ef5f83f6d391$var$isUndefined(options.defaultValue)) setValue(name, $37a6ef5f83f6d391$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $37a6ef5f83f6d391$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $37a6ef5f83f6d391$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $37a6ef5f83f6d391$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $37a6ef5f83f6d391$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $37a6ef5f83f6d391$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $37a6ef5f83f6d391$var$cloneObject(updatedValues);
        const values = formValues && !$37a6ef5f83f6d391$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) for (const fieldName of _names.mount)$37a6ef5f83f6d391$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $37a6ef5f83f6d391$export$adaa4cf7ef1b65be(values, fieldName, $37a6ef5f83f6d391$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $37a6ef5f83f6d391$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($37a6ef5f83f6d391$var$isWeb && $37a6ef5f83f6d391$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($37a6ef5f83f6d391$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $37a6ef5f83f6d391$var$cloneObject(_defaultValues) : {} : $37a6ef5f83f6d391$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$37a6ef5f83f6d391$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $37a6ef5f83f6d391$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($37a6ef5f83f6d391$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $37a6ef5f83f6d391$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$37a6ef5f83f6d391$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $37a6ef5f83f6d391$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $37a6ef5f83f6d391$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: $37a6ef5f83f6d391$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$37a6ef5f83f6d391$var$createFormControl(props, ()=>updateFormState((formState)=>({
                    ...formState
                }))),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $37a6ef5f83f6d391$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($37a6ef5f83f6d391$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useEffect(()=>{
        if (props.values && !$37a6ef5f83f6d391$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $37a6ef5f83f6d391$var$getProxyFormState(formState, control);
    return _formControl.current;
}





var $1fELX = parcelRequire("1fELX");





var $f25e48f8ed22b305$var$_gcTimeout;
var $f25e48f8ed22b305$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $f25e48f8ed22b305$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $f57a82afd5852ebf$export$e539f754e934e270)(this.gcTime)) (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $f25e48f8ed22b305$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $f57a82afd5852ebf$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $f25e48f8ed22b305$var$_gcTimeout)) {
            clearTimeout((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $f25e48f8ed22b305$var$_gcTimeout));
            (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $f25e48f8ed22b305$var$_gcTimeout, void 0);
        }
    }
};
$f25e48f8ed22b305$var$_gcTimeout = new WeakMap();



var $a1036179644e43e7$var$_observers, $a1036179644e43e7$var$_defaultOptions, $a1036179644e43e7$var$_mutationCache, $a1036179644e43e7$var$_retryer, $a1036179644e43e7$var$_dispatch, $a1036179644e43e7$var$dispatch_fn;
var $a1036179644e43e7$export$17b8b19c814bcf56 = class extends (0, $f25e48f8ed22b305$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $a1036179644e43e7$var$_dispatch);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $a1036179644e43e7$var$_observers, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $a1036179644e43e7$var$_defaultOptions, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $a1036179644e43e7$var$_mutationCache, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $a1036179644e43e7$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $a1036179644e43e7$var$_defaultOptions, config.defaultOptions);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $a1036179644e43e7$var$_mutationCache, config.mutationCache);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $a1036179644e43e7$var$_observers, []);
        this.state = config.state || $a1036179644e43e7$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_observers).includes(observer)) {
            (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $a1036179644e43e7$var$_observers, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const executeMutation = ()=>{
            (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $a1036179644e43e7$var$_retryer, (0, $d448c6ba1da5350d$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                    return this.options.mutationFn(variables);
                },
                onFail: (failureCount, error)=>{
                    (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $a1036179644e43e7$var$_dispatch, $a1036179644e43e7$var$dispatch_fn).call(this, {
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $a1036179644e43e7$var$_dispatch, $a1036179644e43e7$var$dispatch_fn).call(this, {
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $a1036179644e43e7$var$_dispatch, $a1036179644e43e7$var$dispatch_fn).call(this, {
                        type: "continue"
                    });
                },
                retry: this.options.retry ?? 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            }));
            return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_retryer).promise;
        };
        const restored = this.state.status === "pending";
        try {
            if (!restored) {
                (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $a1036179644e43e7$var$_dispatch, $a1036179644e43e7$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables
                });
                await ((_b = (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $a1036179644e43e7$var$_dispatch, $a1036179644e43e7$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables
                });
            }
            const data = await executeMutation();
            await ((_f = (_e = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $a1036179644e43e7$var$_dispatch, $a1036179644e43e7$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $a1036179644e43e7$var$_dispatch, $a1036179644e43e7$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        }
    }
};
$a1036179644e43e7$var$_observers = new WeakMap();
$a1036179644e43e7$var$_defaultOptions = new WeakMap();
$a1036179644e43e7$var$_mutationCache = new WeakMap();
$a1036179644e43e7$var$_retryer = new WeakMap();
$a1036179644e43e7$var$_dispatch = new WeakSet();
$a1036179644e43e7$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: !(0, $d448c6ba1da5350d$export$61b92f63f30245cf)(this.options.networkMode),
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>{
        (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $a1036179644e43e7$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $a1036179644e43e7$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}





var $b797be0c4bc85458$var$_client, $b797be0c4bc85458$var$_currentResult, $b797be0c4bc85458$var$_currentMutation, $b797be0c4bc85458$var$_mutateOptions, $b797be0c4bc85458$var$_updateResult, $b797be0c4bc85458$var$updateResult_fn, $b797be0c4bc85458$var$_notify, $b797be0c4bc85458$var$notify_fn;
var $b797be0c4bc85458$export$d3c1860ee66f291a = class extends (0, $afef6c1c30b4cd1f$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $b797be0c4bc85458$var$_updateResult);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $b797be0c4bc85458$var$_notify);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $b797be0c4bc85458$var$_client, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $b797be0c4bc85458$var$_currentResult, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $b797be0c4bc85458$var$_currentMutation, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $b797be0c4bc85458$var$_mutateOptions, void 0);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $b797be0c4bc85458$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $b797be0c4bc85458$var$_updateResult, $b797be0c4bc85458$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_client).defaultMutationOptions(options);
        if (!(0, $f57a82afd5852ebf$export$3e67810a3f0e9f1c)(prevOptions, this.options)) (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentMutation),
            observer: this
        });
        (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentMutation)) == null || _a.setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $b797be0c4bc85458$var$_updateResult, $b797be0c4bc85458$var$updateResult_fn).call(this);
        (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $b797be0c4bc85458$var$_notify, $b797be0c4bc85458$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentResult);
    }
    reset() {
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $b797be0c4bc85458$var$_currentMutation, void 0);
        (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $b797be0c4bc85458$var$_updateResult, $b797be0c4bc85458$var$updateResult_fn).call(this);
        (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $b797be0c4bc85458$var$_notify, $b797be0c4bc85458$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $b797be0c4bc85458$var$_mutateOptions, options);
        (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $b797be0c4bc85458$var$_currentMutation, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_client).getMutationCache().build((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_client), this.options));
        (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentMutation).addObserver(this);
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentMutation).execute(variables);
    }
};
$b797be0c4bc85458$var$_client = new WeakMap();
$b797be0c4bc85458$var$_currentResult = new WeakMap();
$b797be0c4bc85458$var$_currentMutation = new WeakMap();
$b797be0c4bc85458$var$_mutateOptions = new WeakMap();
$b797be0c4bc85458$var$_updateResult = new WeakSet();
$b797be0c4bc85458$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $a1036179644e43e7$export$a1659b54bac3252a)();
    (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $b797be0c4bc85458$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$b797be0c4bc85458$var$_notify = new WeakSet();
$b797be0c4bc85458$var$notify_fn = function(action) {
    (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_mutateOptions) && this.hasListeners()) {
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentResult).variables, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentResult).context);
                (_d = (_c = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentResult).variables, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentResult).context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentResult).variables, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentResult).context);
                (_h = (_g = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentResult).variables, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentResult).context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $b797be0c4bc85458$var$_currentResult));
        });
    });
};




"use client";
function $cfefbe1cc1f48a09$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $b41875c28b512fff$export$22e77b9572c4fded)(queryClient);
    const [observer] = $1fELX.useState(()=>new (0, $b797be0c4bc85458$export$d3c1860ee66f291a)(client, options));
    $1fELX.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $1fELX.useSyncExternalStore($1fELX.useCallback((onStoreChange)=>observer.subscribe((0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $1fELX.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($cfefbe1cc1f48a09$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $fd2dd5d99e5425e7$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}
function $cfefbe1cc1f48a09$var$noop() {}



const $8790dd8d7218c6b4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $8790dd8d7218c6b4$export$2e2bcd8739ae039 = {
    randomUUID: $8790dd8d7218c6b4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $24ec2a4bc8d35633$var$getRandomValues;
const $24ec2a4bc8d35633$var$rnds8 = new Uint8Array(16);
function $24ec2a4bc8d35633$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$24ec2a4bc8d35633$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $24ec2a4bc8d35633$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$24ec2a4bc8d35633$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $24ec2a4bc8d35633$var$getRandomValues($24ec2a4bc8d35633$var$rnds8);
}


var $b6deaa1688c2c51b$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $8276f6ceb6937517$var$validate(uuid) {
    return typeof uuid === "string" && (0, $b6deaa1688c2c51b$export$2e2bcd8739ae039).test(uuid);
}
var $8276f6ceb6937517$export$2e2bcd8739ae039 = $8276f6ceb6937517$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $adda579331607eb2$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$adda579331607eb2$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $adda579331607eb2$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $adda579331607eb2$var$byteToHex[arr[offset + 0]] + $adda579331607eb2$var$byteToHex[arr[offset + 1]] + $adda579331607eb2$var$byteToHex[arr[offset + 2]] + $adda579331607eb2$var$byteToHex[arr[offset + 3]] + "-" + $adda579331607eb2$var$byteToHex[arr[offset + 4]] + $adda579331607eb2$var$byteToHex[arr[offset + 5]] + "-" + $adda579331607eb2$var$byteToHex[arr[offset + 6]] + $adda579331607eb2$var$byteToHex[arr[offset + 7]] + "-" + $adda579331607eb2$var$byteToHex[arr[offset + 8]] + $adda579331607eb2$var$byteToHex[arr[offset + 9]] + "-" + $adda579331607eb2$var$byteToHex[arr[offset + 10]] + $adda579331607eb2$var$byteToHex[arr[offset + 11]] + $adda579331607eb2$var$byteToHex[arr[offset + 12]] + $adda579331607eb2$var$byteToHex[arr[offset + 13]] + $adda579331607eb2$var$byteToHex[arr[offset + 14]] + $adda579331607eb2$var$byteToHex[arr[offset + 15]];
}
function $adda579331607eb2$var$stringify(arr, offset = 0) {
    const uuid = $adda579331607eb2$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $8276f6ceb6937517$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $adda579331607eb2$export$2e2bcd8739ae039 = $adda579331607eb2$var$stringify;


function $bcffca2f027c5201$var$v4(options, buf, offset) {
    if ((0, $8790dd8d7218c6b4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $8790dd8d7218c6b4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $24ec2a4bc8d35633$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $adda579331607eb2$export$8fb373d660548968)(rnds);
}
var $bcffca2f027c5201$export$2e2bcd8739ae039 = $bcffca2f027c5201$var$v4;





const $5300ffe4c7e4571c$export$b7fd644df0fac47 = ({ gameSession: gameSession, setGameStatus: setGameStatus })=>{
    const { data: playerInfo = [] } = (0, $6da3eb65dfb1e8de$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $5b61aaedfb6d7f4f$export$ff90cd3c8a8f97de)
        ],
        queryFn: (0, $5b61aaedfb6d7f4f$export$73542a68f45c89c2)
    });
    const rank = (0, $4d6ebddf7daae0bd$export$fe1fe805a87328d)(gameSession, playerInfo);
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$b89a827e9254211a), {
        children: [
            $5300ffe4c7e4571c$var$renderHeader(rank, gameSession.score),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b280a35ff744d18b$export$a2a14dc5e9bae153), {
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                    className: "py-[5vh] px-[10vh]",
                    children: [
                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                            className: "font-semibold text-display4",
                            children: [
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("p", {
                                    className: "flex items-center gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                            name: "clock",
                                            className: "h-10 w-10"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("span", {
                                            className: "text-primary ",
                                            children: [
                                                "Your time: ",
                                                (0, $a15d49ed6e92009e$export$5daf09ba04077ce8)(gameSession.totalTime)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("p", {
                                    className: "flex items-center gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                            name: "star",
                                            className: "h-10 w-10"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("span", {
                                            className: "text-primary",
                                            children: [
                                                "Your score: ",
                                                gameSession.score,
                                                " Points"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($5300ffe4c7e4571c$var$PlayerDetailsForm, {
                            gameSession: gameSession,
                            setGameStatus: setGameStatus
                        }),
                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                            className: "mt-8 font-light",
                            children: [
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("strong", {
                                    className: "font-semibold",
                                    children: "Note:"
                                }),
                                " We only display your last name and first name on the leaderboard"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$f1011c2ab959143d), {
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                        variant: "neutral",
                        onClick: ()=>setGameStatus((0, $fe11df8941c5cc1d$export$23c7328964450bd2).Finished),
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                name: "arrow-left"
                            }),
                            "Back"
                        ]
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                        variant: "neutral",
                        onClick: ()=>setGameStatus((0, $fe11df8941c5cc1d$export$23c7328964450bd2).Leaderboard),
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                        variant: "primary",
                        type: "submit",
                        form: "player-details-form",
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                name: "trophy-wire-frame"
                            }),
                            "Save"
                        ]
                    })
                ]
            })
        ]
    });
};
function $5300ffe4c7e4571c$var$renderHeader(rank, score) {
    if (rank <= 3) {
        const image = (0, $f53e2e66ab870a62$export$e51102fedf2f55a8)[rank].image;
        return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$8868dba5c6237081), {
            children: [
                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                    src: image,
                    className: "max-h-20"
                }),
                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("span", {
                    className: "mx-10 text-primary",
                    children: [
                        "Congratulations you ranked ",
                        (0, $f53e2e66ab870a62$export$e51102fedf2f55a8)[rank].label
                    ]
                }),
                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                    src: image,
                    className: "max-h-20"
                })
            ]
        });
    } else if (rank < 10) return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$8868dba5c6237081), {
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($78301b06f4fb5e5f$exports))),
                className: "max-h-20"
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("span", {
                className: "mx-10 text-primary",
                children: [
                    "Congratulations you ranked ",
                    rank,
                    "th"
                ]
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($78301b06f4fb5e5f$exports))),
                className: "max-h-20"
            })
        ]
    });
    else return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$8868dba5c6237081), {
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($78301b06f4fb5e5f$exports))),
                className: "max-h-20"
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("span", {
                className: "mx-10 flex items-center text-primary",
                children: [
                    "You collected ",
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                        name: "star",
                        className: "w-16 h-16 mx-4"
                    }),
                    " ",
                    score,
                    " ",
                    "Points"
                ]
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($78301b06f4fb5e5f$exports))),
                className: "max-h-20"
            })
        ]
    });
}
const $5300ffe4c7e4571c$var$PlayerDetailsForm = ({ gameSession: gameSession, setGameStatus: setGameStatus })=>{
    const { score: score, totalTime: totalTime, selectionHistory: selectionHistory } = gameSession;
    const { register: register, handleSubmit: handleSubmit } = (0, $37a6ef5f83f6d391$export$87c0cf8eb5a167e0)();
    const queryClient = (0, $b41875c28b512fff$export$22e77b9572c4fded)();
    const mutation = (0, $cfefbe1cc1f48a09$export$609860bf8b0084c)({
        mutationFn: (0, $5b61aaedfb6d7f4f$export$4c6503a9ef13db27),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $5b61aaedfb6d7f4f$export$ff90cd3c8a8f97de)
                ]
            });
        }
    });
    const onSubmit = async (data)=>{
        await mutation.mutateAsync({
            id: (0, $bcffca2f027c5201$export$2e2bcd8739ae039)(),
            ...data,
            score: score,
            totalTime: totalTime,
            selectionHistory: selectionHistory
        });
        setGameStatus((0, $fe11df8941c5cc1d$export$23c7328964450bd2).Leaderboard);
    };
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("form", {
        className: "flex flex-col gap-8 pt-8",
        onSubmit: handleSubmit(onSubmit),
        id: "player-details-form",
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($5300ffe4c7e4571c$var$PlayerDetailsFormInput, {
                label: "First Name *",
                ...register("firstName", {
                    required: true
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($5300ffe4c7e4571c$var$PlayerDetailsFormInput, {
                label: "Last Name",
                ...register("lastName")
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($5300ffe4c7e4571c$var$PlayerDetailsFormInput, {
                label: "Institution Name",
                ...register("institution")
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)($5300ffe4c7e4571c$var$PlayerDetailsFormInput, {
                label: "Email",
                type: "email",
                ...register("email")
            })
        ]
    });
};
const $5300ffe4c7e4571c$var$PlayerDetailsFormInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1fELX))).forwardRef(({ label: label, placeholder: _, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("input", {
        className: "p-4 bg-neutral-900 placeholder:text-neutral-100 placeholder:font-light",
        type: "text",
        placeholder: label,
        autoComplete: "off",
        ref: ref,
        ...rest
    });
});



parcelRequire("1fELX");


const $78631a54d45f6a1c$var$init = async (engine)=>{
    await (0, $c7877c8cbcd285e5$export$85493d8c5e7176fb)(engine);
};
const $78631a54d45f6a1c$var$particleOptions = {
    fullScreen: {
        zIndex: 1
    },
    emitters: [
        {
            position: {
                x: 0,
                y: 30
            },
            rate: {
                quantity: 5,
                delay: 0.15
            },
            particles: {
                move: {
                    direction: "top-right",
                    outModes: {
                        top: "none",
                        left: "none",
                        default: "destroy"
                    }
                }
            }
        },
        {
            position: {
                x: 100,
                y: 30
            },
            rate: {
                quantity: 5,
                delay: 0.15
            },
            particles: {
                move: {
                    direction: "top-left",
                    outModes: {
                        top: "none",
                        right: "none",
                        default: "destroy"
                    }
                }
            }
        }
    ],
    particles: {
        color: {
            value: [
                "#ffffff",
                "#FF0000"
            ]
        },
        move: {
            decay: 0.05,
            direction: "top",
            enable: true,
            gravity: {
                enable: true
            },
            outModes: {
                top: "none",
                default: "destroy"
            },
            speed: {
                min: 10,
                max: 50
            }
        },
        number: {
            value: 0
        },
        opacity: {
            value: 1
        },
        rotate: {
            value: {
                min: 0,
                max: 360
            },
            direction: "random",
            animation: {
                enable: true,
                speed: 30
            }
        },
        tilt: {
            direction: "random",
            enable: true,
            value: {
                min: 0,
                max: 360
            },
            animation: {
                enable: true,
                speed: 30
            }
        },
        size: {
            value: {
                min: 0,
                max: 2
            },
            animation: {
                enable: true,
                startValue: "min",
                count: 1,
                speed: 16,
                sync: true
            }
        },
        roll: {
            darken: {
                enable: true,
                value: 25
            },
            enable: true,
            speed: {
                min: 5,
                max: 15
            }
        },
        wobble: {
            distance: 30,
            enable: true,
            speed: {
                min: -7,
                max: 7
            }
        },
        shape: {
            type: [
                "circle",
                "square"
            ],
            options: {}
        }
    }
};
const $78631a54d45f6a1c$export$602134b4601945f4 = ()=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $c69b3fedfaeac164$export$2e2bcd8739ae039), {
        init: $78631a54d45f6a1c$var$init,
        options: $78631a54d45f6a1c$var$particleOptions
    });
};



parcelRequire("1fELX");




const $b800b49ca0df553f$export$7e0bc609d95231e4 = ({ setGameStatus: setGameStatus })=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                className: "fixed top-[17%] -translate-y-1/2 left-[20%] right-[20%] text-primary text-title text-center",
                children: "CAN YOU CORRECTLY IDENTIFY THE THYROID LESIONS?"
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                className: "fixed top-[46%] -translate-y-1/2 left-1/2 -translate-x-1/2 z-50 scale-75",
                children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("svg", {
                    width: "1033",
                    height: "444",
                    viewBox: "0 0 1033 444",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("g", {
                            filter: "url(#filter0_d_842_2875)",
                            children: [
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M97.1667 99.461C101.078 92.5863 108.379 88.3405 116.288 88.3405H270.382C274.191 88.3405 277.874 86.9817 280.771 84.5085L304.392 64.3404C311.453 58.3119 320.432 55 329.716 55H703.502C712.57 55 721.354 58.1596 728.344 63.9354L753.444 84.6747C756.311 87.0442 759.915 88.3405 763.635 88.3405H910.191C917.681 88.3405 924.656 92.1508 928.703 98.4529L975.548 171.402C979.637 177.77 975.065 186.139 967.498 186.139C962.214 186.139 957.931 190.423 957.931 195.707V247.042C957.931 252.542 962.389 257 967.889 257C975.526 257 980.321 265.244 976.544 271.882L935.695 343.678C931.783 350.553 924.483 354.799 916.573 354.799H762.48C758.671 354.799 754.987 356.157 752.09 358.631L728.469 378.799C721.409 384.827 712.429 388.139 703.145 388.139L329.359 388.139C320.292 388.139 311.507 384.98 304.517 379.204L279.418 358.464C276.55 356.095 272.946 354.799 269.226 354.799L122.671 354.799C115.181 354.799 108.206 350.988 104.159 344.686L57.3132 271.737C53.2243 265.369 57.7963 257 65.3634 257C70.6473 257 74.9307 252.717 74.9307 247.433V196.097C74.9307 190.598 70.4723 186.139 64.9727 186.139C57.3349 186.139 52.5405 177.895 56.3175 171.257L97.1667 99.461Z",
                                    fill: "url(#paint0_radial_842_2875)"
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                    d: "M97.1667 99.461L92.8209 96.9884H92.8209L97.1667 99.461ZM304.392 64.3404L307.639 68.1429V68.1429L304.392 64.3404ZM728.344 63.9354L731.529 60.081V60.081L728.344 63.9354ZM928.703 98.4529L932.91 95.7512V95.7512L928.703 98.4529ZM935.695 343.678L940.041 346.151L935.695 343.678ZM728.469 378.799L731.716 382.601H731.716L728.469 378.799ZM703.145 388.139V393.139V388.139ZM329.359 388.139V383.139V388.139ZM304.517 379.204L301.332 383.058H301.332L304.517 379.204ZM122.671 354.799V349.799V354.799ZM104.159 344.686L99.9516 347.388L104.159 344.686ZM56.3175 171.257L51.9717 168.784L56.3175 171.257ZM752.09 358.631L748.844 354.828L752.09 358.631ZM279.418 358.464L276.233 362.319L279.418 358.464ZM269.226 354.799V349.799V354.799ZM975.548 171.402L979.755 168.701L975.548 171.402ZM753.444 84.6747L750.259 88.5291L753.444 84.6747ZM57.3132 271.737L61.5204 269.035L57.3132 271.737ZM976.544 271.882L980.89 274.355L976.544 271.882ZM116.288 83.3405C106.581 83.3405 97.6212 88.5513 92.8209 96.9884L101.513 101.934C104.535 96.6214 110.176 93.3405 116.288 93.3405V83.3405ZM270.382 83.3405H116.288V93.3405H270.382V83.3405ZM301.145 60.5379L277.524 80.706L284.018 88.3111L307.639 68.1429L301.145 60.5379ZM329.716 50C319.242 50 309.111 53.7365 301.145 60.5379L307.639 68.1429C313.794 62.8873 321.622 60 329.716 60V50ZM703.502 50H329.716V60H703.502V50ZM731.529 60.081C723.643 53.5647 713.732 50 703.502 50V60C711.407 60 719.065 62.7545 725.159 67.7898L731.529 60.081ZM756.628 80.8203L731.529 60.081L725.159 67.7898L750.259 88.5291L756.628 80.8203ZM910.191 83.3405H763.635V93.3405H910.191V83.3405ZM932.91 95.7512C927.943 88.0168 919.383 83.3405 910.191 83.3405V93.3405C915.978 93.3405 921.368 96.2848 924.495 101.155L932.91 95.7512ZM979.755 168.701L932.91 95.7512L924.495 101.155L971.341 174.104L979.755 168.701ZM952.931 195.707V247.042H962.931V195.707H952.931ZM940.041 346.151L980.89 274.355L972.198 269.41L931.349 341.206L940.041 346.151ZM916.573 359.799C926.28 359.799 935.24 354.588 940.041 346.151L931.349 341.206C928.326 346.518 922.685 349.799 916.573 349.799V359.799ZM762.48 359.799H916.573V349.799H762.48V359.799ZM731.716 382.601L755.337 362.433L748.844 354.828L725.223 374.996L731.716 382.601ZM703.145 393.139C713.62 393.139 723.75 389.403 731.716 382.601L725.223 374.996C719.067 380.252 711.239 383.139 703.145 383.139V393.139ZM329.359 393.139L703.145 393.139V383.139L329.359 383.139V393.139ZM301.332 383.058C309.219 389.574 319.129 393.139 329.359 393.139V383.139C321.454 383.139 313.796 380.385 307.702 375.349L301.332 383.058ZM276.233 362.319L301.332 383.058L307.702 375.349L282.603 354.61L276.233 362.319ZM122.671 359.799L269.226 359.799V349.799L122.671 349.799V359.799ZM99.9516 347.388C104.918 355.122 113.479 359.799 122.671 359.799V349.799C116.883 349.799 111.493 346.854 108.366 341.984L99.9516 347.388ZM53.106 274.438L99.9516 347.388L108.366 341.984L61.5204 269.035L53.106 274.438ZM79.9307 247.433V196.097H69.9307V247.433H79.9307ZM92.8209 96.9884L51.9717 168.784L60.6633 173.729L101.513 101.934L92.8209 96.9884ZM64.9727 181.139C61.1699 181.139 58.7828 177.035 60.6633 173.729L51.9717 168.784C46.2982 178.756 53.4999 191.139 64.9727 191.139V181.139ZM79.9307 196.097C79.9307 187.836 73.2337 181.139 64.9727 181.139V191.139C67.7109 191.139 69.9307 193.359 69.9307 196.097H79.9307ZM270.382 93.3405C275.381 93.3405 280.216 91.5571 284.018 88.3111L277.524 80.706C275.533 82.4064 273 83.3405 270.382 83.3405V93.3405ZM65.3634 262C73.4087 262 79.9307 255.478 79.9307 247.433H69.9307C69.9307 249.955 67.8859 252 65.3634 252V262ZM762.48 349.799C757.481 349.799 752.646 351.582 748.844 354.828L755.337 362.433C757.328 360.733 759.861 359.799 762.48 359.799V349.799ZM967.498 181.139C959.453 181.139 952.931 187.661 952.931 195.707H962.931C962.931 193.184 964.976 191.139 967.498 191.139V181.139ZM282.603 354.61C278.839 351.5 274.109 349.799 269.226 349.799V359.799C271.784 359.799 274.261 360.69 276.233 362.319L282.603 354.61ZM971.341 174.104C973.293 177.144 971.11 181.139 967.498 181.139V191.139C979.02 191.139 985.981 178.396 979.755 168.701L971.341 174.104ZM952.931 247.042C952.931 255.303 959.628 262 967.889 262V252C965.15 252 962.931 249.78 962.931 247.042H952.931ZM750.259 88.5291C754.023 91.6392 758.753 93.3405 763.635 93.3405V83.3405C761.078 83.3405 758.6 82.4493 756.628 80.8203L750.259 88.5291ZM61.5204 269.035C59.5684 265.995 61.751 262 65.3634 262V252C53.8416 252 46.8802 264.743 53.106 274.438L61.5204 269.035ZM967.889 262C971.691 262 974.079 266.105 972.198 269.41L980.89 274.355C986.563 264.383 979.361 252 967.889 252V262Z",
                                    fill: "#4D6471"
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("g", {
                                    filter: "url(#filter1_i_842_2875)",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M324.993 327.293C321.2 324.873 322.915 319 327.414 319H380C383.314 319 386 321.686 386 325V343C386 346.314 383.314 349 380 349H360.752C359.608 349 358.488 348.673 357.523 348.058L324.993 327.293Z",
                                            fill: "#C9D4DA"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M324.993 327.293C321.2 324.873 322.915 319 327.414 319H380C383.314 319 386 321.686 386 325V343C386 346.314 383.314 349 380 349H360.752C359.608 349 358.488 348.673 357.523 348.058L324.993 327.293Z",
                                            fill: "url(#paint1_linear_842_2875)",
                                            fillOpacity: "0.2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("g", {
                                    filter: "url(#filter2_i_842_2875)",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("rect", {
                                            x: "403",
                                            y: "319",
                                            width: "64",
                                            height: "30",
                                            rx: "6",
                                            fill: "#FFD990"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("rect", {
                                            x: "403",
                                            y: "319",
                                            width: "64",
                                            height: "30",
                                            rx: "6",
                                            fill: "url(#paint2_linear_842_2875)",
                                            fillOpacity: "0.2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("g", {
                                    filter: "url(#filter3_i_842_2875)",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("rect", {
                                            x: "484",
                                            y: "319",
                                            width: "64",
                                            height: "30",
                                            rx: "6",
                                            fill: "#FFA048"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("rect", {
                                            x: "484",
                                            y: "319",
                                            width: "64",
                                            height: "30",
                                            rx: "6",
                                            fill: "url(#paint3_linear_842_2875)",
                                            fillOpacity: "0.2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("g", {
                                    filter: "url(#filter4_i_842_2875)",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("rect", {
                                            x: "565",
                                            y: "319",
                                            width: "64",
                                            height: "30",
                                            rx: "6",
                                            fill: "#F85E1D"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("rect", {
                                            x: "565",
                                            y: "319",
                                            width: "64",
                                            height: "30",
                                            rx: "6",
                                            fill: "url(#paint4_linear_842_2875)",
                                            fillOpacity: "0.2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("g", {
                                    filter: "url(#filter5_i_842_2875)",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M707.007 327.293C710.8 324.873 709.085 319 704.586 319H652C648.686 319 646 321.686 646 325V343C646 346.314 648.686 349 652 349H671.248C672.392 349 673.512 348.673 674.477 348.058L707.007 327.293Z",
                                            fill: "#E62C4C"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M707.007 327.293C710.8 324.873 709.085 319 704.586 319H652C648.686 319 646 321.686 646 325V343C646 346.314 648.686 349 652 349H671.248C672.392 349 673.512 348.673 674.477 348.058L707.007 327.293Z",
                                            fill: "url(#paint5_linear_842_2875)",
                                            fillOpacity: "0.2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("g", {
                                    filter: "url(#filter6_d_842_2875)",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("mask", {
                                            id: "path-8-outside-1_842_2875",
                                            maskUnits: "userSpaceOnUse",
                                            x: "120.327",
                                            y: "100.594",
                                            width: "787",
                                            height: "176",
                                            fill: "black",
                                            children: [
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("rect", {
                                                    fill: "white",
                                                    x: "120.327",
                                                    y: "100.594",
                                                    width: "787",
                                                    height: "176"
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                    d: "M126.327 177.925V158.909H215.922V177.925H182.523V268H159.725V177.925H126.327Z"
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                    d: "M253.741 158.909V268H230.677V158.909H253.741Z"
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                    d: "M323.268 204.452V222.457H273.517V204.452H323.268Z"
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                    d: "M343.03 268V158.909H386.07C394.309 158.909 401.34 160.383 407.164 163.33C413.023 166.242 417.48 170.379 420.534 175.741C423.623 181.068 425.168 187.336 425.168 194.545C425.168 201.789 423.606 208.021 420.481 213.241C417.356 218.426 412.828 222.403 406.898 225.173C401.003 227.943 393.865 229.328 385.484 229.328H356.667V210.791H381.755C386.159 210.791 389.817 210.187 392.728 208.98C395.64 207.773 397.807 205.961 399.227 203.547C400.683 201.132 401.411 198.131 401.411 194.545C401.411 190.922 400.683 187.868 399.227 185.383C397.807 182.897 395.623 181.015 392.675 179.736C389.763 178.422 386.088 177.765 381.649 177.765H366.095V268H343.03ZM401.944 218.355L429.057 268H403.595L377.068 218.355H401.944Z"
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                    d: "M460.271 268H435.555L473.215 158.909H502.938L540.545 268H515.829L488.503 183.838H487.65L460.271 268ZM458.726 225.12H517.107V243.124H458.726V225.12Z"
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                    d: "M592.347 268H553.675V158.909H592.666C603.639 158.909 613.085 161.093 621.004 165.461C628.923 169.793 635.014 176.025 639.275 184.157C643.572 192.29 645.72 202.02 645.72 213.348C645.72 224.711 643.572 234.477 639.275 242.645C635.014 250.812 628.888 257.08 620.898 261.448C612.943 265.816 603.426 268 592.347 268ZM576.739 248.238H591.388C598.206 248.238 603.941 247.03 608.593 244.616C613.281 242.165 616.796 238.383 619.14 233.27C621.519 228.121 622.709 221.48 622.709 213.348C622.709 205.287 621.519 198.699 619.14 193.586C616.796 188.472 613.298 184.708 608.646 182.293C603.994 179.878 598.259 178.671 591.441 178.671H576.739V248.238Z"
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                    d: "M662.38 268V186.182H685.071V268H662.38Z"
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                    d: "M740.216 269.598C731.835 269.598 724.627 267.822 718.59 264.271C712.588 260.685 707.972 255.713 704.74 249.356C701.544 243 699.946 235.685 699.946 227.41C699.946 219.03 701.562 211.679 704.793 205.358C708.06 199.001 712.695 194.047 718.696 190.496C724.698 186.91 731.835 185.116 740.109 185.116C747.247 185.116 753.497 186.412 758.859 189.005C764.222 191.597 768.465 195.237 771.59 199.925C774.715 204.612 776.438 210.116 776.757 216.437H755.344C754.74 212.354 753.142 209.069 750.55 206.583C747.993 204.062 744.637 202.801 740.482 202.801C736.967 202.801 733.895 203.76 731.267 205.677C728.675 207.559 726.651 210.312 725.195 213.934C723.739 217.556 723.011 221.942 723.011 227.091C723.011 232.311 723.721 236.75 725.141 240.408C726.597 244.065 728.639 246.853 731.267 248.77C733.895 250.688 736.967 251.647 740.482 251.647C743.075 251.647 745.401 251.114 747.46 250.049C749.556 248.984 751.278 247.439 752.627 245.415C754.012 243.355 754.918 240.887 755.344 238.011H776.757C776.402 244.261 774.698 249.765 771.644 254.523C768.625 259.246 764.453 262.94 759.126 265.603C753.799 268.266 747.496 269.598 740.216 269.598Z"
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                    d: "M814.617 269.545C809.397 269.545 804.745 268.639 800.661 266.828C796.577 264.981 793.346 262.265 790.966 258.678C788.622 255.056 787.451 250.546 787.451 245.148C787.451 240.603 788.285 236.785 789.954 233.696C791.623 230.606 793.896 228.121 796.772 226.239C799.649 224.356 802.916 222.936 806.573 221.977C810.267 221.018 814.137 220.344 818.186 219.953C822.944 219.456 826.779 218.994 829.691 218.568C832.603 218.106 834.716 217.432 836.03 216.544C837.344 215.656 838.001 214.342 838.001 212.602V212.282C838.001 208.909 836.936 206.299 834.805 204.452C832.71 202.606 829.727 201.682 825.856 201.682C821.772 201.682 818.523 202.588 816.108 204.399C813.693 206.175 812.095 208.412 811.314 211.111L790.327 209.406C791.392 204.434 793.488 200.138 796.613 196.515C799.738 192.858 803.768 190.052 808.704 188.099C813.676 186.111 819.429 185.116 825.963 185.116C830.508 185.116 834.858 185.649 839.013 186.714C843.203 187.78 846.914 189.431 850.146 191.668C853.413 193.905 855.988 196.782 857.87 200.297C859.752 203.778 860.693 207.95 860.693 212.815V268H839.173V256.654H838.534C837.22 259.211 835.462 261.466 833.26 263.419C831.059 265.337 828.413 266.846 825.323 267.947C822.234 269.012 818.665 269.545 814.617 269.545ZM821.115 253.884C824.453 253.884 827.401 253.227 829.958 251.913C832.515 250.564 834.521 248.753 835.977 246.48C837.433 244.207 838.161 241.633 838.161 238.756V230.074C837.451 230.535 836.474 230.962 835.231 231.352C834.024 231.707 832.657 232.045 831.13 232.364C829.603 232.648 828.076 232.915 826.549 233.163C825.022 233.376 823.637 233.572 822.394 233.749C819.73 234.14 817.404 234.761 815.416 235.614C813.427 236.466 811.882 237.62 810.782 239.076C809.681 240.496 809.13 242.272 809.13 244.403C809.13 247.492 810.249 249.854 812.486 251.487C814.759 253.085 817.635 253.884 821.115 253.884Z"
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                    d: "M900.989 158.909V268H878.298V158.909H900.989Z"
                                                }),
                                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M683.103 106.644C684.164 106.842 685.023 107.613 685.318 108.632L690.33 125.917L707.672 131.801C708.694 132.148 709.431 133.031 709.573 134.08C709.716 135.129 709.239 136.161 708.343 136.743L693.152 146.615L692.946 164.539C692.934 165.596 692.31 166.55 691.337 167C690.364 167.45 689.21 167.317 688.361 166.658L673.961 155.476L656.492 160.692C655.462 160.999 654.339 160.706 653.594 159.935C652.85 159.164 652.613 158.049 652.984 157.059L659.275 140.273L648.684 125.575C648.059 124.709 647.988 123.574 648.5 122.647C649.012 121.721 650.019 121.164 651.097 121.21L669.393 121.998L680.317 107.696C680.961 106.853 682.041 106.445 683.103 106.644ZM681.438 115.535L673.053 126.512C672.497 127.241 671.608 127.652 670.677 127.612L656.63 127.007L664.761 138.291C665.302 139.041 665.433 140 665.112 140.857L660.283 153.74L673.693 149.736C674.583 149.47 675.554 149.652 676.288 150.222L687.341 158.805L687.5 145.048C687.51 144.133 687.979 143.286 688.755 142.782L700.417 135.204L687.103 130.687C686.22 130.387 685.54 129.682 685.285 128.802L681.438 115.535Z"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M126.327 177.925V158.909H215.922V177.925H182.523V268H159.725V177.925H126.327Z",
                                            fill: "url(#paint6_linear_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M253.741 158.909V268H230.677V158.909H253.741Z",
                                            fill: "url(#paint7_linear_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M323.268 204.452V222.457H273.517V204.452H323.268Z",
                                            fill: "url(#paint8_linear_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M343.03 268V158.909H386.07C394.309 158.909 401.34 160.383 407.164 163.33C413.023 166.242 417.48 170.379 420.534 175.741C423.623 181.068 425.168 187.336 425.168 194.545C425.168 201.789 423.606 208.021 420.481 213.241C417.356 218.426 412.828 222.403 406.898 225.173C401.003 227.943 393.865 229.328 385.484 229.328H356.667V210.791H381.755C386.159 210.791 389.817 210.187 392.728 208.98C395.64 207.773 397.807 205.961 399.227 203.547C400.683 201.132 401.411 198.131 401.411 194.545C401.411 190.922 400.683 187.868 399.227 185.383C397.807 182.897 395.623 181.015 392.675 179.736C389.763 178.422 386.088 177.765 381.649 177.765H366.095V268H343.03ZM401.944 218.355L429.057 268H403.595L377.068 218.355H401.944Z",
                                            fill: "url(#paint9_linear_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M460.271 268H435.555L473.215 158.909H502.938L540.545 268H515.829L488.503 183.838H487.65L460.271 268ZM458.726 225.12H517.107V243.124H458.726V225.12Z",
                                            fill: "url(#paint10_linear_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M592.347 268H553.675V158.909H592.666C603.639 158.909 613.085 161.093 621.004 165.461C628.923 169.793 635.014 176.025 639.275 184.157C643.572 192.29 645.72 202.02 645.72 213.348C645.72 224.711 643.572 234.477 639.275 242.645C635.014 250.812 628.888 257.08 620.898 261.448C612.943 265.816 603.426 268 592.347 268ZM576.739 248.238H591.388C598.206 248.238 603.941 247.03 608.593 244.616C613.281 242.165 616.796 238.383 619.14 233.27C621.519 228.121 622.709 221.48 622.709 213.348C622.709 205.287 621.519 198.699 619.14 193.586C616.796 188.472 613.298 184.708 608.646 182.293C603.994 179.878 598.259 178.671 591.441 178.671H576.739V248.238Z",
                                            fill: "url(#paint11_linear_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M662.38 268V186.182H685.071V268H662.38Z",
                                            fill: "url(#paint12_linear_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M740.216 269.598C731.835 269.598 724.627 267.822 718.59 264.271C712.588 260.685 707.972 255.713 704.74 249.356C701.544 243 699.946 235.685 699.946 227.41C699.946 219.03 701.562 211.679 704.793 205.358C708.06 199.001 712.695 194.047 718.696 190.496C724.698 186.91 731.835 185.116 740.109 185.116C747.247 185.116 753.497 186.412 758.859 189.005C764.222 191.597 768.465 195.237 771.59 199.925C774.715 204.612 776.438 210.116 776.757 216.437H755.344C754.74 212.354 753.142 209.069 750.55 206.583C747.993 204.062 744.637 202.801 740.482 202.801C736.967 202.801 733.895 203.76 731.267 205.677C728.675 207.559 726.651 210.312 725.195 213.934C723.739 217.556 723.011 221.942 723.011 227.091C723.011 232.311 723.721 236.75 725.141 240.408C726.597 244.065 728.639 246.853 731.267 248.77C733.895 250.688 736.967 251.647 740.482 251.647C743.075 251.647 745.401 251.114 747.46 250.049C749.556 248.984 751.278 247.439 752.627 245.415C754.012 243.355 754.918 240.887 755.344 238.011H776.757C776.402 244.261 774.698 249.765 771.644 254.523C768.625 259.246 764.453 262.94 759.126 265.603C753.799 268.266 747.496 269.598 740.216 269.598Z",
                                            fill: "url(#paint13_linear_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M814.617 269.545C809.397 269.545 804.745 268.639 800.661 266.828C796.577 264.981 793.346 262.265 790.966 258.678C788.622 255.056 787.451 250.546 787.451 245.148C787.451 240.603 788.285 236.785 789.954 233.696C791.623 230.606 793.896 228.121 796.772 226.239C799.649 224.356 802.916 222.936 806.573 221.977C810.267 221.018 814.137 220.344 818.186 219.953C822.944 219.456 826.779 218.994 829.691 218.568C832.603 218.106 834.716 217.432 836.03 216.544C837.344 215.656 838.001 214.342 838.001 212.602V212.282C838.001 208.909 836.936 206.299 834.805 204.452C832.71 202.606 829.727 201.682 825.856 201.682C821.772 201.682 818.523 202.588 816.108 204.399C813.693 206.175 812.095 208.412 811.314 211.111L790.327 209.406C791.392 204.434 793.488 200.138 796.613 196.515C799.738 192.858 803.768 190.052 808.704 188.099C813.676 186.111 819.429 185.116 825.963 185.116C830.508 185.116 834.858 185.649 839.013 186.714C843.203 187.78 846.914 189.431 850.146 191.668C853.413 193.905 855.988 196.782 857.87 200.297C859.752 203.778 860.693 207.95 860.693 212.815V268H839.173V256.654H838.534C837.22 259.211 835.462 261.466 833.26 263.419C831.059 265.337 828.413 266.846 825.323 267.947C822.234 269.012 818.665 269.545 814.617 269.545ZM821.115 253.884C824.453 253.884 827.401 253.227 829.958 251.913C832.515 250.564 834.521 248.753 835.977 246.48C837.433 244.207 838.161 241.633 838.161 238.756V230.074C837.451 230.535 836.474 230.962 835.231 231.352C834.024 231.707 832.657 232.045 831.13 232.364C829.603 232.648 828.076 232.915 826.549 233.163C825.022 233.376 823.637 233.572 822.394 233.749C819.73 234.14 817.404 234.761 815.416 235.614C813.427 236.466 811.882 237.62 810.782 239.076C809.681 240.496 809.13 242.272 809.13 244.403C809.13 247.492 810.249 249.854 812.486 251.487C814.759 253.085 817.635 253.884 821.115 253.884Z",
                                            fill: "url(#paint14_linear_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M900.989 158.909V268H878.298V158.909H900.989Z",
                                            fill: "url(#paint15_linear_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M683.103 106.644C684.164 106.842 685.023 107.613 685.318 108.632L690.33 125.917L707.672 131.801C708.694 132.148 709.431 133.031 709.573 134.08C709.716 135.129 709.239 136.161 708.343 136.743L693.152 146.615L692.946 164.539C692.934 165.596 692.31 166.55 691.337 167C690.364 167.45 689.21 167.317 688.361 166.658L673.961 155.476L656.492 160.692C655.462 160.999 654.339 160.706 653.594 159.935C652.85 159.164 652.613 158.049 652.984 157.059L659.275 140.273L648.684 125.575C648.059 124.709 647.988 123.574 648.5 122.647C649.012 121.721 650.019 121.164 651.097 121.21L669.393 121.998L680.317 107.696C680.961 106.853 682.041 106.445 683.103 106.644ZM681.438 115.535L673.053 126.512C672.497 127.241 671.608 127.652 670.677 127.612L656.63 127.007L664.761 138.291C665.302 139.041 665.433 140 665.112 140.857L660.283 153.74L673.693 149.736C674.583 149.47 675.554 149.652 676.288 150.222L687.341 158.805L687.5 145.048C687.51 144.133 687.979 143.286 688.755 142.782L700.417 135.204L687.103 130.687C686.22 130.387 685.54 129.682 685.285 128.802L681.438 115.535Z",
                                            fill: "url(#paint16_linear_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M126.327 177.925V158.909H215.922V177.925H182.523V268H159.725V177.925H126.327Z",
                                            stroke: "#0A161D",
                                            strokeWidth: "12",
                                            strokeLinejoin: "round",
                                            mask: "url(#path-8-outside-1_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M253.741 158.909V268H230.677V158.909H253.741Z",
                                            stroke: "#0A161D",
                                            strokeWidth: "12",
                                            strokeLinejoin: "round",
                                            mask: "url(#path-8-outside-1_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M323.268 204.452V222.457H273.517V204.452H323.268Z",
                                            stroke: "#0A161D",
                                            strokeWidth: "12",
                                            strokeLinejoin: "round",
                                            mask: "url(#path-8-outside-1_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M343.03 268V158.909H386.07C394.309 158.909 401.34 160.383 407.164 163.33C413.023 166.242 417.48 170.379 420.534 175.741C423.623 181.068 425.168 187.336 425.168 194.545C425.168 201.789 423.606 208.021 420.481 213.241C417.356 218.426 412.828 222.403 406.898 225.173C401.003 227.943 393.865 229.328 385.484 229.328H356.667V210.791H381.755C386.159 210.791 389.817 210.187 392.728 208.98C395.64 207.773 397.807 205.961 399.227 203.547C400.683 201.132 401.411 198.131 401.411 194.545C401.411 190.922 400.683 187.868 399.227 185.383C397.807 182.897 395.623 181.015 392.675 179.736C389.763 178.422 386.088 177.765 381.649 177.765H366.095V268H343.03ZM401.944 218.355L429.057 268H403.595L377.068 218.355H401.944Z",
                                            stroke: "#0A161D",
                                            strokeWidth: "12",
                                            strokeLinejoin: "round",
                                            mask: "url(#path-8-outside-1_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M460.271 268H435.555L473.215 158.909H502.938L540.545 268H515.829L488.503 183.838H487.65L460.271 268ZM458.726 225.12H517.107V243.124H458.726V225.12Z",
                                            stroke: "#0A161D",
                                            strokeWidth: "12",
                                            strokeLinejoin: "round",
                                            mask: "url(#path-8-outside-1_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M592.347 268H553.675V158.909H592.666C603.639 158.909 613.085 161.093 621.004 165.461C628.923 169.793 635.014 176.025 639.275 184.157C643.572 192.29 645.72 202.02 645.72 213.348C645.72 224.711 643.572 234.477 639.275 242.645C635.014 250.812 628.888 257.08 620.898 261.448C612.943 265.816 603.426 268 592.347 268ZM576.739 248.238H591.388C598.206 248.238 603.941 247.03 608.593 244.616C613.281 242.165 616.796 238.383 619.14 233.27C621.519 228.121 622.709 221.48 622.709 213.348C622.709 205.287 621.519 198.699 619.14 193.586C616.796 188.472 613.298 184.708 608.646 182.293C603.994 179.878 598.259 178.671 591.441 178.671H576.739V248.238Z",
                                            stroke: "#0A161D",
                                            strokeWidth: "12",
                                            strokeLinejoin: "round",
                                            mask: "url(#path-8-outside-1_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M662.38 268V186.182H685.071V268H662.38Z",
                                            stroke: "#0A161D",
                                            strokeWidth: "12",
                                            strokeLinejoin: "round",
                                            mask: "url(#path-8-outside-1_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M740.216 269.598C731.835 269.598 724.627 267.822 718.59 264.271C712.588 260.685 707.972 255.713 704.74 249.356C701.544 243 699.946 235.685 699.946 227.41C699.946 219.03 701.562 211.679 704.793 205.358C708.06 199.001 712.695 194.047 718.696 190.496C724.698 186.91 731.835 185.116 740.109 185.116C747.247 185.116 753.497 186.412 758.859 189.005C764.222 191.597 768.465 195.237 771.59 199.925C774.715 204.612 776.438 210.116 776.757 216.437H755.344C754.74 212.354 753.142 209.069 750.55 206.583C747.993 204.062 744.637 202.801 740.482 202.801C736.967 202.801 733.895 203.76 731.267 205.677C728.675 207.559 726.651 210.312 725.195 213.934C723.739 217.556 723.011 221.942 723.011 227.091C723.011 232.311 723.721 236.75 725.141 240.408C726.597 244.065 728.639 246.853 731.267 248.77C733.895 250.688 736.967 251.647 740.482 251.647C743.075 251.647 745.401 251.114 747.46 250.049C749.556 248.984 751.278 247.439 752.627 245.415C754.012 243.355 754.918 240.887 755.344 238.011H776.757C776.402 244.261 774.698 249.765 771.644 254.523C768.625 259.246 764.453 262.94 759.126 265.603C753.799 268.266 747.496 269.598 740.216 269.598Z",
                                            stroke: "#0A161D",
                                            strokeWidth: "12",
                                            strokeLinejoin: "round",
                                            mask: "url(#path-8-outside-1_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M814.617 269.545C809.397 269.545 804.745 268.639 800.661 266.828C796.577 264.981 793.346 262.265 790.966 258.678C788.622 255.056 787.451 250.546 787.451 245.148C787.451 240.603 788.285 236.785 789.954 233.696C791.623 230.606 793.896 228.121 796.772 226.239C799.649 224.356 802.916 222.936 806.573 221.977C810.267 221.018 814.137 220.344 818.186 219.953C822.944 219.456 826.779 218.994 829.691 218.568C832.603 218.106 834.716 217.432 836.03 216.544C837.344 215.656 838.001 214.342 838.001 212.602V212.282C838.001 208.909 836.936 206.299 834.805 204.452C832.71 202.606 829.727 201.682 825.856 201.682C821.772 201.682 818.523 202.588 816.108 204.399C813.693 206.175 812.095 208.412 811.314 211.111L790.327 209.406C791.392 204.434 793.488 200.138 796.613 196.515C799.738 192.858 803.768 190.052 808.704 188.099C813.676 186.111 819.429 185.116 825.963 185.116C830.508 185.116 834.858 185.649 839.013 186.714C843.203 187.78 846.914 189.431 850.146 191.668C853.413 193.905 855.988 196.782 857.87 200.297C859.752 203.778 860.693 207.95 860.693 212.815V268H839.173V256.654H838.534C837.22 259.211 835.462 261.466 833.26 263.419C831.059 265.337 828.413 266.846 825.323 267.947C822.234 269.012 818.665 269.545 814.617 269.545ZM821.115 253.884C824.453 253.884 827.401 253.227 829.958 251.913C832.515 250.564 834.521 248.753 835.977 246.48C837.433 244.207 838.161 241.633 838.161 238.756V230.074C837.451 230.535 836.474 230.962 835.231 231.352C834.024 231.707 832.657 232.045 831.13 232.364C829.603 232.648 828.076 232.915 826.549 233.163C825.022 233.376 823.637 233.572 822.394 233.749C819.73 234.14 817.404 234.761 815.416 235.614C813.427 236.466 811.882 237.62 810.782 239.076C809.681 240.496 809.13 242.272 809.13 244.403C809.13 247.492 810.249 249.854 812.486 251.487C814.759 253.085 817.635 253.884 821.115 253.884Z",
                                            stroke: "#0A161D",
                                            strokeWidth: "12",
                                            strokeLinejoin: "round",
                                            mask: "url(#path-8-outside-1_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            d: "M900.989 158.909V268H878.298V158.909H900.989Z",
                                            stroke: "#0A161D",
                                            strokeWidth: "12",
                                            strokeLinejoin: "round",
                                            mask: "url(#path-8-outside-1_842_2875)"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M683.103 106.644C684.164 106.842 685.023 107.613 685.318 108.632L690.33 125.917L707.672 131.801C708.694 132.148 709.431 133.031 709.573 134.08C709.716 135.129 709.239 136.161 708.343 136.743L693.152 146.615L692.946 164.539C692.934 165.596 692.31 166.55 691.337 167C690.364 167.45 689.21 167.317 688.361 166.658L673.961 155.476L656.492 160.692C655.462 160.999 654.339 160.706 653.594 159.935C652.85 159.164 652.613 158.049 652.984 157.059L659.275 140.273L648.684 125.575C648.059 124.709 647.988 123.574 648.5 122.647C649.012 121.721 650.019 121.164 651.097 121.21L669.393 121.998L680.317 107.696C680.961 106.853 682.041 106.445 683.103 106.644ZM681.438 115.535L673.053 126.512C672.497 127.241 671.608 127.652 670.677 127.612L656.63 127.007L664.761 138.291C665.302 139.041 665.433 140 665.112 140.857L660.283 153.74L673.693 149.736C674.583 149.47 675.554 149.652 676.288 150.222L687.341 158.805L687.5 145.048C687.51 144.133 687.979 143.286 688.755 142.782L700.417 135.204L687.103 130.687C686.22 130.387 685.54 129.682 685.285 128.802L681.438 115.535Z",
                                            stroke: "#0A161D",
                                            strokeWidth: "12",
                                            strokeLinejoin: "round",
                                            mask: "url(#path-8-outside-1_842_2875)"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("defs", {
                            children: [
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("filter", {
                                    id: "filter0_d_842_2875",
                                    x: "-0.00732422",
                                    y: "0",
                                    width: "1032.88",
                                    height: "443.139",
                                    filterUnits: "userSpaceOnUse",
                                    colorInterpolationFilters: "sRGB",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feFlood", {
                                            floodOpacity: "0",
                                            result: "BackgroundImageFix"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            in: "SourceAlpha",
                                            type: "matrix",
                                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                            result: "hardAlpha"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feOffset", {}),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feGaussianBlur", {
                                            stdDeviation: "25"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feComposite", {
                                            in2: "hardAlpha",
                                            operator: "out"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            type: "matrix",
                                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in2: "BackgroundImageFix",
                                            result: "effect1_dropShadow_842_2875"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in: "SourceGraphic",
                                            in2: "effect1_dropShadow_842_2875",
                                            result: "shape"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("filter", {
                                    id: "filter1_i_842_2875",
                                    x: "322.906",
                                    y: "319",
                                    width: "63.0942",
                                    height: "32",
                                    filterUnits: "userSpaceOnUse",
                                    colorInterpolationFilters: "sRGB",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feFlood", {
                                            floodOpacity: "0",
                                            result: "BackgroundImageFix"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in: "SourceGraphic",
                                            in2: "BackgroundImageFix",
                                            result: "shape"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            in: "SourceAlpha",
                                            type: "matrix",
                                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                            result: "hardAlpha"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feOffset", {
                                            dy: "2"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feGaussianBlur", {
                                            stdDeviation: "4"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feComposite", {
                                            in2: "hardAlpha",
                                            operator: "arithmetic",
                                            k2: "-1",
                                            k3: "1"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            type: "matrix",
                                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in2: "shape",
                                            result: "effect1_innerShadow_842_2875"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("filter", {
                                    id: "filter2_i_842_2875",
                                    x: "403",
                                    y: "319",
                                    width: "64",
                                    height: "32",
                                    filterUnits: "userSpaceOnUse",
                                    colorInterpolationFilters: "sRGB",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feFlood", {
                                            floodOpacity: "0",
                                            result: "BackgroundImageFix"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in: "SourceGraphic",
                                            in2: "BackgroundImageFix",
                                            result: "shape"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            in: "SourceAlpha",
                                            type: "matrix",
                                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                            result: "hardAlpha"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feOffset", {
                                            dy: "2"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feGaussianBlur", {
                                            stdDeviation: "4"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feComposite", {
                                            in2: "hardAlpha",
                                            operator: "arithmetic",
                                            k2: "-1",
                                            k3: "1"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            type: "matrix",
                                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in2: "shape",
                                            result: "effect1_innerShadow_842_2875"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("filter", {
                                    id: "filter3_i_842_2875",
                                    x: "484",
                                    y: "319",
                                    width: "64",
                                    height: "32",
                                    filterUnits: "userSpaceOnUse",
                                    colorInterpolationFilters: "sRGB",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feFlood", {
                                            floodOpacity: "0",
                                            result: "BackgroundImageFix"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in: "SourceGraphic",
                                            in2: "BackgroundImageFix",
                                            result: "shape"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            in: "SourceAlpha",
                                            type: "matrix",
                                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                            result: "hardAlpha"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feOffset", {
                                            dy: "2"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feGaussianBlur", {
                                            stdDeviation: "4"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feComposite", {
                                            in2: "hardAlpha",
                                            operator: "arithmetic",
                                            k2: "-1",
                                            k3: "1"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            type: "matrix",
                                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in2: "shape",
                                            result: "effect1_innerShadow_842_2875"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("filter", {
                                    id: "filter4_i_842_2875",
                                    x: "565",
                                    y: "319",
                                    width: "64",
                                    height: "32",
                                    filterUnits: "userSpaceOnUse",
                                    colorInterpolationFilters: "sRGB",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feFlood", {
                                            floodOpacity: "0",
                                            result: "BackgroundImageFix"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in: "SourceGraphic",
                                            in2: "BackgroundImageFix",
                                            result: "shape"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            in: "SourceAlpha",
                                            type: "matrix",
                                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                            result: "hardAlpha"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feOffset", {
                                            dy: "2"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feGaussianBlur", {
                                            stdDeviation: "4"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feComposite", {
                                            in2: "hardAlpha",
                                            operator: "arithmetic",
                                            k2: "-1",
                                            k3: "1"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            type: "matrix",
                                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in2: "shape",
                                            result: "effect1_innerShadow_842_2875"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("filter", {
                                    id: "filter5_i_842_2875",
                                    x: "646",
                                    y: "319",
                                    width: "63.0942",
                                    height: "32",
                                    filterUnits: "userSpaceOnUse",
                                    colorInterpolationFilters: "sRGB",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feFlood", {
                                            floodOpacity: "0",
                                            result: "BackgroundImageFix"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in: "SourceGraphic",
                                            in2: "BackgroundImageFix",
                                            result: "shape"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            in: "SourceAlpha",
                                            type: "matrix",
                                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                            result: "hardAlpha"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feOffset", {
                                            dy: "2"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feGaussianBlur", {
                                            stdDeviation: "4"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feComposite", {
                                            in2: "hardAlpha",
                                            operator: "arithmetic",
                                            k2: "-1",
                                            k3: "1"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            type: "matrix",
                                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in2: "shape",
                                            result: "effect1_innerShadow_842_2875"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("filter", {
                                    id: "filter6_d_842_2875",
                                    x: "100.327",
                                    y: "80.5945",
                                    width: "826.663",
                                    height: "215.003",
                                    filterUnits: "userSpaceOnUse",
                                    colorInterpolationFilters: "sRGB",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feFlood", {
                                            floodOpacity: "0",
                                            result: "BackgroundImageFix"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            in: "SourceAlpha",
                                            type: "matrix",
                                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                            result: "hardAlpha"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feOffset", {}),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feGaussianBlur", {
                                            stdDeviation: "10"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feComposite", {
                                            in2: "hardAlpha",
                                            operator: "out"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feColorMatrix", {
                                            type: "matrix",
                                            values: "0 0 0 0 0.611765 0 0 0 0 0.690196 0 0 0 0 0.737255 0 0 0 1 0"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in2: "BackgroundImageFix",
                                            result: "effect1_dropShadow_842_2875"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("feBlend", {
                                            mode: "normal",
                                            in: "SourceGraphic",
                                            in2: "effect1_dropShadow_842_2875",
                                            result: "shape"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("radialGradient", {
                                    id: "paint0_radial_842_2875",
                                    cx: "0",
                                    cy: "0",
                                    r: "1",
                                    gradientUnits: "userSpaceOnUse",
                                    gradientTransform: "translate(516.431 221.57) rotate(90) scale(166.57 461.431)",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "0.150422",
                                            stopColor: "#3C6781"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "0.916667",
                                            stopColor: "#213846"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint1_linear_842_2875",
                                    x1: "349",
                                    y1: "319",
                                    x2: "349",
                                    y2: "349",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            stopColor: "white"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "white",
                                            stopOpacity: "0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint2_linear_842_2875",
                                    x1: "435",
                                    y1: "319",
                                    x2: "435",
                                    y2: "349",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            stopColor: "white"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "white",
                                            stopOpacity: "0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint3_linear_842_2875",
                                    x1: "516",
                                    y1: "319",
                                    x2: "516",
                                    y2: "349",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            stopColor: "white"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "white",
                                            stopOpacity: "0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint4_linear_842_2875",
                                    x1: "597",
                                    y1: "319",
                                    x2: "597",
                                    y2: "349",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            stopColor: "white"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "white",
                                            stopOpacity: "0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint5_linear_842_2875",
                                    x1: "683",
                                    y1: "319",
                                    x2: "683",
                                    y2: "349",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            stopColor: "white"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "white",
                                            stopOpacity: "0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint6_linear_842_2875",
                                    x1: "516",
                                    y1: "122",
                                    x2: "516",
                                    y2: "304",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "0.291667",
                                            stopColor: "#00FFBA"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "#006449"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint7_linear_842_2875",
                                    x1: "516",
                                    y1: "122",
                                    x2: "516",
                                    y2: "304",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "0.291667",
                                            stopColor: "#00FFBA"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "#006449"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint8_linear_842_2875",
                                    x1: "516",
                                    y1: "122",
                                    x2: "516",
                                    y2: "304",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "0.291667",
                                            stopColor: "#00FFBA"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "#006449"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint9_linear_842_2875",
                                    x1: "516",
                                    y1: "122",
                                    x2: "516",
                                    y2: "304",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "0.291667",
                                            stopColor: "#00FFBA"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "#006449"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint10_linear_842_2875",
                                    x1: "516",
                                    y1: "122",
                                    x2: "516",
                                    y2: "304",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "0.291667",
                                            stopColor: "#00FFBA"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "#006449"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint11_linear_842_2875",
                                    x1: "516",
                                    y1: "122",
                                    x2: "516",
                                    y2: "304",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "0.291667",
                                            stopColor: "#00FFBA"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "#006449"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint12_linear_842_2875",
                                    x1: "516",
                                    y1: "122",
                                    x2: "516",
                                    y2: "304",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "0.291667",
                                            stopColor: "#00FFBA"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "#006449"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint13_linear_842_2875",
                                    x1: "516",
                                    y1: "122",
                                    x2: "516",
                                    y2: "304",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "0.291667",
                                            stopColor: "#00FFBA"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "#006449"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint14_linear_842_2875",
                                    x1: "516",
                                    y1: "122",
                                    x2: "516",
                                    y2: "304",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "0.291667",
                                            stopColor: "#00FFBA"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "#006449"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint15_linear_842_2875",
                                    x1: "516",
                                    y1: "122",
                                    x2: "516",
                                    y2: "304",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "0.291667",
                                            stopColor: "#00FFBA"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "#006449"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("linearGradient", {
                                    id: "paint16_linear_842_2875",
                                    x1: "516",
                                    y1: "122",
                                    x2: "516",
                                    y2: "304",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "0.291667",
                                            stopColor: "#00FFBA"
                                        }),
                                        /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("stop", {
                                            offset: "1",
                                            stopColor: "#006449"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                className: "fixed top-[70%] -translate-y-1/2 left-[20%] right-[20%] text-neutral-50 text-display1 text-center",
                children: "Press START To Play!"
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                className: "fixed top-[80%] left-1/2 -translate-x-1/2 z-50 flex gap-10",
                children: [
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                        onClick: ()=>setGameStatus((0, $fe11df8941c5cc1d$export$23c7328964450bd2).Leaderboard),
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                name: "trophy-wire-frame"
                            }),
                            "Leaderboard"
                        ]
                    }),
                    /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                        variant: "primary",
                        onClick: ()=>setGameStatus((0, $fe11df8941c5cc1d$export$23c7328964450bd2).Ready),
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                name: "controller"
                            }),
                            "START"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $46adf260b14651d6$export$5f95e975d3adc575), {
                prewarm: true
            })
        ]
    });
};




var $d188f8dbd05611b8$exports = {};


$d188f8dbd05611b8$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("kSNJe");


var $b1c9d6c52435a9e0$exports = {};


$b1c9d6c52435a9e0$exports = (parcelRequire("3j58s")).getBundleURL("3PIvK") + (parcelRequire("fFhxl")).resolve("jwIcY");



var $1fELX = parcelRequire("1fELX");

var $a7rUz = parcelRequire("a7rUz");
function $e53093ffc88b338d$export$cc2f7653b27d7228(gameStatus, soundEnabled) {
    const [playMenuSound, { stop: stopMenuSound }] = (0, $d4d68b59540df7f6$export$a34349420ba3cec8)((0, (/*@__PURE__*/$parcel$interopDefault($d188f8dbd05611b8$exports))), {
        interrupt: true
    });
    const [playGameSound, { stop: stopGameSound }] = (0, $d4d68b59540df7f6$export$a34349420ba3cec8)((0, (/*@__PURE__*/$parcel$interopDefault($b1c9d6c52435a9e0$exports))), {
        interrupt: true
    });
    const musicType = $e53093ffc88b338d$var$getMusicType(gameStatus);
    (0, $1fELX.useEffect)(()=>{
        if (musicType === "game") {
            stopMenuSound();
            playGameSound();
        } else if (musicType === "menu") {
            stopGameSound();
            playMenuSound();
        } else {
            stopGameSound();
            stopMenuSound();
        }
    }, [
        musicType,
        playGameSound,
        playMenuSound,
        stopGameSound,
        stopMenuSound
    ]);
    (0, $1fELX.useEffect)(()=>{
        (0, $a7rUz.Howler).mute(!soundEnabled);
    }, [
        soundEnabled
    ]);
}
function $e53093ffc88b338d$var$getMusicType(gameStatus) {
    if (gameStatus === (0, $fe11df8941c5cc1d$export$23c7328964450bd2).Title) return "none";
    else if (gameStatus === (0, $fe11df8941c5cc1d$export$23c7328964450bd2).Started) return "game";
    else return "menu";
}




const $a5b3d4b023f6d7be$export$67b504a331effb70 = ()=>{
    const [gameStatus, setGameStatus] = (0, $1fELX.useState)((0, $fe11df8941c5cc1d$export$23c7328964450bd2).Title);
    const [gameSession, setGameSession] = (0, $1fELX.useState)({
        score: 0,
        shownImages: (0, $042a7e9d97463528$export$321dbc493110171c).slice(0, (0, $f53e2e66ab870a62$export$176c9ac0984acede).numberOfImages),
        totalTime: 0,
        selectionHistory: []
    });
    const [soundEnabled, setSoundEnabled] = (0, $1fELX.useState)(true);
    (0, $e53093ffc88b338d$export$cc2f7653b27d7228)(gameStatus, soundEnabled);
    const getContent = ()=>{
        switch(gameStatus){
            case (0, $fe11df8941c5cc1d$export$23c7328964450bd2).Title:
                return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b800b49ca0df553f$export$7e0bc609d95231e4), {
                    setGameStatus: setGameStatus
                });
            case (0, $fe11df8941c5cc1d$export$23c7328964450bd2).Paused:
            case (0, $fe11df8941c5cc1d$export$23c7328964450bd2).Started:
                return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $01143b28052bbc8c$export$f3f3f6c0124f08de), {
                    gameSession: gameSession,
                    setGameStatus: setGameStatus,
                    setGameSession: setGameSession
                });
            case (0, $fe11df8941c5cc1d$export$23c7328964450bd2).Finished:
                return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $d92e9fb9044b3545$export$8fdcabde73f49165), {
                    setGameStatus: setGameStatus,
                    gameSession: gameSession
                });
            case (0, $fe11df8941c5cc1d$export$23c7328964450bd2).Ready:
                return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b06252936b8ebca8$export$dcfbacf97d3ea1ac), {
                    setGameStatus: setGameStatus
                });
            case (0, $fe11df8941c5cc1d$export$23c7328964450bd2).PlayerDetails:
                return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $5300ffe4c7e4571c$export$b7fd644df0fac47), {
                    setGameStatus: setGameStatus,
                    gameSession: gameSession
                });
            case (0, $fe11df8941c5cc1d$export$23c7328964450bd2).Leaderboard:
            default:
                return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $76aa6350eb86bafa$export$e439bffd17c92e84), {
                    setGameStatus: setGameStatus
                });
        }
    };
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
        className: "bg-neutral-900 h-screen",
        children: [
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)("div", {
                className: "mx-auto content-center text-neutral-50 h-full",
                children: getContent()
            }),
            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)("div", {
                className: "fixed top-xxxl right-xxxl z-50 flex gap-6",
                children: [
                    soundEnabled && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                        onClick: ()=>setSoundEnabled(false),
                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                            name: "mute"
                        })
                    }),
                    !soundEnabled && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                        onClick: ()=>setSoundEnabled(true),
                        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                            name: "sound"
                        })
                    }),
                    gameStatus === (0, $fe11df8941c5cc1d$export$23c7328964450bd2).Started && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsxs)((0, $b280a35ff744d18b$export$59ad24bf1c8e19d9), {
                        onClick: ()=>setGameStatus((0, $fe11df8941c5cc1d$export$23c7328964450bd2).Title),
                        children: [
                            /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a1f1afff6039ad8b$export$f04a61298a47a40f), {
                                name: "controller"
                            }),
                            "Exit"
                        ]
                    })
                ]
            }),
            (gameStatus === (0, $fe11df8941c5cc1d$export$23c7328964450bd2).Finished || gameStatus === (0, $fe11df8941c5cc1d$export$23c7328964450bd2).PlayerDetails) && /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $78631a54d45f6a1c$export$602134b4601945f4), {})
        ]
    });
};











var $38c07b14c67fafef$var$_initialState, $38c07b14c67fafef$var$_revertState, $38c07b14c67fafef$var$_cache, $38c07b14c67fafef$var$_promise, $38c07b14c67fafef$var$_retryer, $38c07b14c67fafef$var$_observers, $38c07b14c67fafef$var$_defaultOptions, $38c07b14c67fafef$var$_abortSignalConsumed, $38c07b14c67fafef$var$_setOptions, $38c07b14c67fafef$var$setOptions_fn, $38c07b14c67fafef$var$_dispatch, $38c07b14c67fafef$var$dispatch_fn;
var $38c07b14c67fafef$export$62297b13309008b2 = class extends (0, $f25e48f8ed22b305$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $38c07b14c67fafef$var$_setOptions);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $38c07b14c67fafef$var$_dispatch);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $38c07b14c67fafef$var$_initialState, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $38c07b14c67fafef$var$_revertState, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $38c07b14c67fafef$var$_cache, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $38c07b14c67fafef$var$_promise, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $38c07b14c67fafef$var$_retryer, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $38c07b14c67fafef$var$_observers, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $38c07b14c67fafef$var$_defaultOptions, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $38c07b14c67fafef$var$_abortSignalConsumed, void 0);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $38c07b14c67fafef$var$_abortSignalConsumed, false);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $38c07b14c67fafef$var$_defaultOptions, config.defaultOptions);
        (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $38c07b14c67fafef$var$_setOptions, $38c07b14c67fafef$var$setOptions_fn).call(this, config.options);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $38c07b14c67fafef$var$_observers, []);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $38c07b14c67fafef$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $38c07b14c67fafef$var$_initialState, config.state || $38c07b14c67fafef$var$getDefaultState(this.options));
        this.state = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    optionalRemove() {
        if (!(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_observers).length && this.state.fetchStatus === "idle") (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $f57a82afd5852ebf$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $38c07b14c67fafef$var$_dispatch, $38c07b14c67fafef$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $38c07b14c67fafef$var$_dispatch, $38c07b14c67fafef$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a;
        const promise = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_promise);
        (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_retryer)) == null || _a.cancel(options);
        return promise ? promise.then((0, $f57a82afd5852ebf$export$8793edee2d425525)).catch((0, $f57a82afd5852ebf$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_initialState));
    }
    isActive() {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_observers).some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_observers).some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $f57a82afd5852ebf$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_observers).find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_observers).find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_observers).includes(observer)) {
            (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_observers).includes(observer)) {
            (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $38c07b14c67fafef$var$_observers, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_observers).filter((x)=>x !== observer));
            if (!(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_observers).length) {
                if ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_retryer)) {
                    if ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_abortSignalConsumed)) (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_observers).length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $38c07b14c67fafef$var$_dispatch, $38c07b14c67fafef$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c, _d;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_promise)) {
                (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_retryer)) == null || _a.continueRetry();
                return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_promise);
            }
        }
        if (options) (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $38c07b14c67fafef$var$_setOptions, $38c07b14c67fafef$var$setOptions_fn).call(this, options);
        if (!this.options.queryFn) {
            const observer = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_observers).find((x)=>x.options.queryFn);
            if (observer) (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $38c07b14c67fafef$var$_setOptions, $38c07b14c67fafef$var$setOptions_fn).call(this, observer.options);
        }
        const abortController = new AbortController();
        const queryFnContext = {
            queryKey: this.queryKey,
            meta: this.meta
        };
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $38c07b14c67fafef$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        addSignalProperty(queryFnContext);
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject(new Error(`Missing queryFn: '${this.options.queryHash}'`));
            (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $38c07b14c67fafef$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(this.options.queryFn, queryFnContext, this);
            return this.options.queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_b = this.options.behavior) == null || _b.onFetch(context, this);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $38c07b14c67fafef$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_c = context.fetchOptions) == null ? void 0 : _c.meta)) (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $38c07b14c67fafef$var$_dispatch, $38c07b14c67fafef$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_d = context.fetchOptions) == null ? void 0 : _d.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d2;
            if (!((0, $d448c6ba1da5350d$export$986cc6445c1d323)(error) && error.silent)) (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $38c07b14c67fafef$var$_dispatch, $38c07b14c67fafef$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $d448c6ba1da5350d$export$986cc6445c1d323)(error)) {
                (_b2 = (_a2 = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d2 = (_c2 = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_cache).config).onSettled) == null || _d2.call(_c2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $38c07b14c67fafef$var$_retryer, (0, $d448c6ba1da5350d$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d2;
                if (typeof data === "undefined") {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                this.setData(data);
                (_b2 = (_a2 = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d2 = (_c2 = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_cache).config).onSettled) == null || _d2.call(_c2, data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $38c07b14c67fafef$var$_dispatch, $38c07b14c67fafef$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $38c07b14c67fafef$var$_dispatch, $38c07b14c67fafef$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $e0694f4e7923cdf6$export$fa92d15b718fce20)(this, $38c07b14c67fafef$var$_dispatch, $38c07b14c67fafef$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        }));
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $38c07b14c67fafef$var$_promise, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_retryer).promise);
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_promise);
    }
};
$38c07b14c67fafef$var$_initialState = new WeakMap();
$38c07b14c67fafef$var$_revertState = new WeakMap();
$38c07b14c67fafef$var$_cache = new WeakMap();
$38c07b14c67fafef$var$_promise = new WeakMap();
$38c07b14c67fafef$var$_retryer = new WeakMap();
$38c07b14c67fafef$var$_observers = new WeakMap();
$38c07b14c67fafef$var$_defaultOptions = new WeakMap();
$38c07b14c67fafef$var$_abortSignalConsumed = new WeakMap();
$38c07b14c67fafef$var$_setOptions = new WeakSet();
$38c07b14c67fafef$var$setOptions_fn = function(options) {
    this.options = {
        ...(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_defaultOptions),
        ...options
    };
    this.updateGcTime(this.options.gcTime);
};
$38c07b14c67fafef$var$_dispatch = new WeakSet();
$38c07b14c67fafef$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    fetchFailureCount: 0,
                    fetchFailureReason: null,
                    fetchMeta: action.meta ?? null,
                    fetchStatus: (0, $d448c6ba1da5350d$export$61b92f63f30245cf)(this.options.networkMode) ? "fetching" : "paused",
                    ...!state.dataUpdatedAt && {
                        error: null,
                        status: "pending"
                    }
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $d448c6ba1da5350d$export$986cc6445c1d323)(error) && error.revert && (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_revertState)) return {
                    ...(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>{
        (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_observers).forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $38c07b14c67fafef$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $38c07b14c67fafef$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $1fae4e337054502a$var$_queries;
var $1fae4e337054502a$export$5dde0cd941da8468 = class extends (0, $afef6c1c30b4cd1f$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $1fae4e337054502a$var$_queries, void 0);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $1fae4e337054502a$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $f57a82afd5852ebf$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $38c07b14c67fafef$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $1fae4e337054502a$var$_queries).has(query.queryHash)) {
            (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $1fae4e337054502a$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $1fae4e337054502a$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $1fae4e337054502a$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $1fae4e337054502a$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $1fae4e337054502a$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $f57a82afd5852ebf$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $f57a82afd5852ebf$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$1fae4e337054502a$var$_queries = new WeakMap();







var $d1b4b2b52ac005d8$var$_mutations, $d1b4b2b52ac005d8$var$_mutationId, $d1b4b2b52ac005d8$var$_resuming;
var $d1b4b2b52ac005d8$export$1fcfd9a244434844 = class extends (0, $afef6c1c30b4cd1f$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $d1b4b2b52ac005d8$var$_mutations, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $d1b4b2b52ac005d8$var$_mutationId, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $d1b4b2b52ac005d8$var$_resuming, void 0);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $d1b4b2b52ac005d8$var$_mutations, []);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $d1b4b2b52ac005d8$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $a1036179644e43e7$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $e0694f4e7923cdf6$export$b1fe7cbb4502036b)(this, $d1b4b2b52ac005d8$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $d1b4b2b52ac005d8$var$_mutations).push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $d1b4b2b52ac005d8$var$_mutations, (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $d1b4b2b52ac005d8$var$_mutations).filter((x)=>x !== mutation));
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>{
            (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $d1b4b2b52ac005d8$var$_mutations).forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $d1b4b2b52ac005d8$var$_mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $d1b4b2b52ac005d8$var$_mutations).find((mutation)=>(0, $f57a82afd5852ebf$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $d1b4b2b52ac005d8$var$_mutations).filter((mutation)=>(0, $f57a82afd5852ebf$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $d1b4b2b52ac005d8$var$_resuming, ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $d1b4b2b52ac005d8$var$_resuming) ?? Promise.resolve()).then(()=>{
            const pausedMutations = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $d1b4b2b52ac005d8$var$_mutations).filter((x)=>x.state.isPaused);
            return (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $f57a82afd5852ebf$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $d1b4b2b52ac005d8$var$_resuming, void 0);
        }));
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $d1b4b2b52ac005d8$var$_resuming);
    }
};
$d1b4b2b52ac005d8$var$_mutations = new WeakMap();
$d1b4b2b52ac005d8$var$_mutationId = new WeakMap();
$d1b4b2b52ac005d8$var$_resuming = new WeakMap();







function $a028ad2cf4097f66$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const fetchFn = async ()=>{
                var _a, _b, _c, _d, _e;
                const options = context.options;
                const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
                const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
                const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
                const empty = {
                    pages: [],
                    pageParams: []
                };
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = context.options.queryFn || (()=>Promise.reject(new Error(`Missing queryFn: '${context.options.queryHash}'`)));
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $f57a82afd5852ebf$export$8c6246b73dd61f4a) : (0, $f57a82afd5852ebf$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                let result;
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $a028ad2cf4097f66$var$getPreviousPageParam : $a028ad2cf4097f66$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    result = await fetchPage(empty, oldPageParams[0] ?? options.initialPageParam);
                    const remainingPages = pages ?? oldPages.length;
                    for(let i = 1; i < remainingPages; i++){
                        const param = $a028ad2cf4097f66$var$getNextPageParam(options, result);
                        result = await fetchPage(result, param);
                    }
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a, _b;
                return (_b = (_a = context.options).persister) == null ? void 0 : _b.call(_a, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $a028ad2cf4097f66$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams);
}
function $a028ad2cf4097f66$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams);
}
function $a028ad2cf4097f66$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $a028ad2cf4097f66$var$getNextPageParam(options, data) != null;
}
function $a028ad2cf4097f66$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $a028ad2cf4097f66$var$getPreviousPageParam(options, data) != null;
}


var $31836bee032f13d0$var$_queryCache, $31836bee032f13d0$var$_mutationCache, $31836bee032f13d0$var$_defaultOptions, $31836bee032f13d0$var$_queryDefaults, $31836bee032f13d0$var$_mutationDefaults, $31836bee032f13d0$var$_mountCount, $31836bee032f13d0$var$_unsubscribeFocus, $31836bee032f13d0$var$_unsubscribeOnline;
var $31836bee032f13d0$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $31836bee032f13d0$var$_queryCache, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $31836bee032f13d0$var$_mutationCache, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $31836bee032f13d0$var$_defaultOptions, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $31836bee032f13d0$var$_queryDefaults, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $31836bee032f13d0$var$_mutationDefaults, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $31836bee032f13d0$var$_mountCount, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $31836bee032f13d0$var$_unsubscribeFocus, void 0);
        (0, $e0694f4e7923cdf6$export$addf369becd23283)(this, $31836bee032f13d0$var$_unsubscribeOnline, void 0);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $31836bee032f13d0$var$_queryCache, config.queryCache || new (0, $1fae4e337054502a$export$5dde0cd941da8468)());
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $31836bee032f13d0$var$_mutationCache, config.mutationCache || new (0, $d1b4b2b52ac005d8$export$1fcfd9a244434844)());
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $31836bee032f13d0$var$_defaultOptions, config.defaultOptions || {});
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $31836bee032f13d0$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $31836bee032f13d0$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $31836bee032f13d0$var$_mountCount, 0);
    }
    mount() {
        (0, $e0694f4e7923cdf6$export$b1fe7cbb4502036b)(this, $31836bee032f13d0$var$_mountCount)._++;
        if ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_mountCount) !== 1) return;
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $31836bee032f13d0$var$_unsubscribeFocus, (0, $e144ef068697cf99$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $e144ef068697cf99$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache).onFocus();
            }
        }));
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $31836bee032f13d0$var$_unsubscribeOnline, (0, $7f3a5e4614e6f9f6$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $7f3a5e4614e6f9f6$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $e0694f4e7923cdf6$export$b1fe7cbb4502036b)(this, $31836bee032f13d0$var$_mountCount)._--;
        if ((0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_mountCount) !== 0) return;
        (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $31836bee032f13d0$var$_unsubscribeFocus, void 0);
        (_b = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $31836bee032f13d0$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        return (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache).find({
            queryKey: queryKey
        })) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(options);
    }
    getQueriesData(filters) {
        return this.getQueryCache().findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache).find({
            queryKey: queryKey
        });
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $f57a82afd5852ebf$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === "undefined") return void 0;
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        return (_a = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache).find({
            queryKey: queryKey
        })) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache);
        (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $f57a82afd5852ebf$export$8793edee2d425525)).catch((0, $f57a82afd5852ebf$export$8793edee2d425525));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>{
            (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: (options == null ? void 0 : options.cancelRefetch) ?? true
        };
        const promises = (0, $d2c8ece77381cd5b$export$520687f44db6e1ab).batch(()=>(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $f57a82afd5852ebf$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $f57a82afd5852ebf$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $f57a82afd5852ebf$export$8793edee2d425525)).catch((0, $f57a82afd5852ebf$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $a028ad2cf4097f66$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $f57a82afd5852ebf$export$8793edee2d425525)).catch((0, $f57a82afd5852ebf$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_mutationCache).resumePausedMutations();
    }
    getQueryCache() {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache);
    }
    getMutationCache() {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $e0694f4e7923cdf6$export$42432efe6614d3b4)(this, $31836bee032f13d0$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryDefaults).set((0, $f57a82afd5852ebf$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $f57a82afd5852ebf$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_mutationDefaults).set((0, $f57a82afd5852ebf$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $f57a82afd5852ebf$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_defaultOptions).queries,
            ...(options == null ? void 0 : options.queryKey) && this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $f57a82afd5852ebf$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.throwOnError === "undefined") defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (typeof defaultedOptions.networkMode === "undefined" && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_queryCache).clear();
        (0, $e0694f4e7923cdf6$export$18a094aefa070634)(this, $31836bee032f13d0$var$_mutationCache).clear();
    }
};
$31836bee032f13d0$var$_queryCache = new WeakMap();
$31836bee032f13d0$var$_mutationCache = new WeakMap();
$31836bee032f13d0$var$_defaultOptions = new WeakMap();
$31836bee032f13d0$var$_queryDefaults = new WeakMap();
$31836bee032f13d0$var$_mutationDefaults = new WeakMap();
$31836bee032f13d0$var$_mountCount = new WeakMap();
$31836bee032f13d0$var$_unsubscribeFocus = new WeakMap();
$31836bee032f13d0$var$_unsubscribeOnline = new WeakMap();


const $ff89b9ab2b9d6c47$var$queryClient = new (0, $31836bee032f13d0$export$405d0624ed55a03f)();
const $ff89b9ab2b9d6c47$export$86fbec116b87613f = ()=>{
    return /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $b41875c28b512fff$export$45604f0cc8ae667b), {
        client: $ff89b9ab2b9d6c47$var$queryClient,
        children: /*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $a5b3d4b023f6d7be$export$67b504a331effb70), {})
    });
};


const $012f7be1d13cf9ca$var$root = (0, $62253b9dcd75e122$export$882461b6382ed46c)(document.getElementById("app"));
$012f7be1d13cf9ca$var$root.render(/*#__PURE__*/ (0, $01494118b1e6559d$exports.jsx)((0, $ff89b9ab2b9d6c47$export$86fbec116b87613f), {}));

})();
//# sourceMappingURL=index.776de6b3.js.map
